/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/analytics/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var document = __webpack_require__(14);
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	__webpack_require__(168);
	__webpack_require__(87);
	
	__webpack_require__(130);
	
	var App = __webpack_require__(74);
	
	$(document).foundation();
	
	// application defaults
	
	var DEFAULT_QUERY = {
	    rows: ["decade"],
	    cols: ["author_1"],
	    agg: "sum_receipts",
	    order: {
	        "author_1": "desc",
	        "decade": "nat"
	    },
	    filter: {
	        "author_1": ["Corneille (Pierre)", "Molière (Jean-Baptiste Poquelin dit)", "Racine (Jean)", "Voltaire (François-Marie Arouet dit)"],
	        "decade": [1710, 1720, 1730, 1740, 1750]
	    },
	    decade_scope: {
	        start: '1710', // 1680
	        end: '1750' // 1790
	    }
	};
	
	// const DEFAULT_QUERY = {
	//   rows: [ "decade" ],
	//   cols: [ "author_1" ],
	//   agg: "sum_receipts_weighted",
	//   order: { "author_1": "desc",
	//            "decade": "nat" },
	//   filter: { "author_1":
	//             ["Corneille (Pierre)",
	//              "Molière (Jean-Baptiste Poquelin dit)",
	//              "Racine (Jean)",
	//              "Voltaire (François-Marie Arouet dit)",
	//             ] }
	// }
	
	var elem = document.getElementById("app") || document.body;
	var datapoint_url = elem.getAttribute("data-analytics");
	
	// install in web page
	
	hg.app(elem, App(datapoint_url, DEFAULT_QUERY), App.render);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var SingleEvent = __webpack_require__(45);
	var MultipleEvent = __webpack_require__(134);
	var extend = __webpack_require__(209);
	
	/*
	    Pro tip: Don't require `mercury` itself.
	      require and depend on all these modules directly!
	*/
	var mercury = module.exports = {
	    // Entry
	    main: __webpack_require__(138),
	    app: app,
	
	    // Base
	    BaseEvent: __webpack_require__(12),
	
	    // Input
	    Delegator: __webpack_require__(42),
	    // deprecated: use hg.channels instead.
	    input: input,
	    // deprecated: use hg.channels instead.
	    handles: channels,
	    channels: channels,
	    // deprecated: use hg.send instead.
	    event: __webpack_require__(57),
	    send: __webpack_require__(57),
	    // deprecated: use hg.sendValue instead.
	    valueEvent: __webpack_require__(60),
	    sendValue: __webpack_require__(60),
	    // deprecated: use hg.sendSubmit instead.
	    submitEvent: __webpack_require__(59),
	    sendSubmit: __webpack_require__(59),
	    // deprecated: use hg.sendChange instead.
	    changeEvent: __webpack_require__(55),
	    sendChange: __webpack_require__(55),
	    // deprecated: use hg.sendKey instead.
	    keyEvent: __webpack_require__(58),
	    sendKey: __webpack_require__(58),
	    // deprecated use hg.sendClick instead.
	    clickEvent: __webpack_require__(56),
	    sendClick: __webpack_require__(56),
	
	    // State
	    // remove from core: favor hg.varhash instead.
	    array: __webpack_require__(51),
	    struct: __webpack_require__(49),
	    // deprecated: use hg.struct instead.
	    hash: __webpack_require__(49),
	    varhash: __webpack_require__(151),
	    value: __webpack_require__(16),
	    state: state,
	
	    // Render
	    diff: __webpack_require__(67),
	    patch: __webpack_require__(62),
	    partial: __webpack_require__(176),
	    create: __webpack_require__(34),
	    h: __webpack_require__(22),
	
	    // Utilities
	    // remove from core: require computed directly instead.
	    computed: __webpack_require__(153),
	    // remove from core: require watch directly instead.
	    watch: __webpack_require__(154)
	};
	
	function input(names) {
	    if (!names) {
	        return SingleEvent();
	    }
	
	    return MultipleEvent(names);
	}
	
	function state(obj) {
	    var copy = extend(obj);
	    var $channels = copy.channels;
	    var $handles = copy.handles;
	
	    if ($channels) {
	        copy.channels = mercury.value(null);
	    } else if ($handles) {
	        copy.handles = mercury.value(null);
	    }
	
	    var observ = mercury.struct(copy);
	    if ($channels) {
	        observ.channels.set(mercury.channels($channels, observ));
	    } else if ($handles) {
	        observ.handles.set(mercury.channels($handles, observ));
	    }
	    return observ;
	}
	
	function channels(funcs, context) {
	    return Object.keys(funcs).reduce(createHandle, {});
	
	    function createHandle(acc, name) {
	        var handle = mercury.Delegator.allocateHandle(
	            funcs[name].bind(null, context));
	
	        acc[name] = handle;
	        return acc;
	    }
	}
	
	function app(elem, observ, render, opts) {
	    if (!elem) {
	        throw new Error(
	            'Element does not exist. ' +
	            'Mercury cannot be initialized.');
	    }
	
	    mercury.Delegator(opts);
	    var loop = mercury.main(observ(), render, extend({
	        diff: mercury.diff,
	        create: mercury.create,
	        patch: mercury.patch
	    }, opts));
	
	    elem.appendChild(loop.target);
	
	    return observ(loop.update);
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* CFRP categories and formatting
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 06/2015
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _jsUtilI18n = __webpack_require__(4);
	
	var d3 = __webpack_require__(8);
	
	var subscript = function subscript(range, items) {
	  var result = range.map(function (i) {
	    return items.map(function (item) {
	      return item + "_" + i;
	    });
	  });
	  return result.reduce(function (a, b) {
	    return a.concat(b);
	  });
	};
	
	var playbills = ['n'].concat(d3.range(1, 4));
	
	var schema = {
	
	  performance: subscript(playbills, ["title"]),
	
	  time: ["decade", "season", "month",
	  // TODO.  day yields 40,000 results -- query latency unacceptable
	  //      "day",
	  "weekday"],
	  author: subscript(playbills, ["author"]),
	  genre: subscript(playbills, ["genre"]),
	  //   seating_area:
	  //     subscript(playbills,
	  //     [ "seating_area"]),
	  seating_area: ["seating_area"],
	  acts: subscript(playbills, ["acts"])
	
	};
	
	//   prose_vers:
	//     subscript(playbills,
	//     [ "prose_vers" ]),
	
	/*performance_addl:
	  subscript(playbills,
	  [ "prologue",
	    "musique_danse_machine",
	    "free_entry",
	    "reprise",
	    "firstrun",
	    "newactor",
	    "debut" ,
	    "ex_attendance",
	    "ex_representation",
	    "ex_place"  ]) */
	var public_aggregates = ["sum_receipts",
	// "sum_receipts_weighted",
	"performances_days", "mean_receipts_day",
	// "mean_receipts_day_weighted",
	"mean_price"];
	
	function group() {
	  return schema;
	}
	
	function dimension() {
	  return d3.values(schema).reduce(function (a, b) {
	    return a.concat(b);
	  });
	}
	
	function aggregate() {
	  return public_aggregates;
	}
	
	function parse(field) {
	  // only necessary for non-text fields received via AJAX/CSV
	  switch (true) {
	    case /^decade(_.*)?/.test(field):
	      return parseInt;
	    case /^month(_.*)?/.test(field):
	      return parseInt;
	    case /^weekday(_.*)?/.test(field):
	      return parseInt;
	    case /^acts(_.*)?/.test(field):
	      return parseInt;
	    case /^prologue(_.*)?/.test(field):
	      return parseBool;
	    case /^musique_danse_machine(_.*)?/.test(field):
	      return parseBool;
	    case /^free_entry(_.*)?/.test(field):
	      return parseBool;
	    case /^reprise(_.*)?/.test(field):
	      return parseBool;
	    case /^firstrun(_.*)?/.test(field):
	      return parseBool;
	
	    // aggregates
	    case /sum_receipts/.test(field):
	      return parseFloat;
	    case /sum_receipts_weighted/.test(field):
	      return parseFloat;
	    case /performances_days/.test(field):
	      return parseInt;
	    case /mean_receipts_day/.test(field):
	      return parseFloat;
	    case /mean_receipts_day_weighted/.test(field):
	      return parseFloat;
	    case /mean_price/.test(field):
	      return parseFloat;
	    case /count_authors_(\d)/.test(field):
	      return parseInt;
	    case /count_titles_(\d)/.test(field):
	      return parseInt;
	  }
	  return function (x) {
	    return x;
	  };
	
	  function parseBool(s) {
	    switch (s) {
	      case 't':
	        return true;
	      case 'f':
	        return false;
	      default:
	        return null;
	    }
	  }
	}
	
	function format(lang, field, len) {
	  // TODO logic could be clearer... some much easier in ruby
	  //      lets us use the same logic for both languages
	
	  var spec = lang === 'en' ? _jsUtilI18n.en_spec : _jsUtilI18n.fr_spec;
	  var fmt = lang === 'en' ? _jsUtilI18n.en : _jsUtilI18n.fr;
	
	  switch (true) {
	
	    // dimensions
	    case /^decade(_.*)?/.test(field):
	      return function (i) {
	        return +i;
	      }; // [i, +i+9].join(' - ')
	    case /^month(_.*)?/.test(field):
	      // NB. months and weekdays are kept in 1-indexed format (like postgresql; unlike javascript)
	      return function (i) {
	        return i === null ? "" : spec.months[+i - 1];
	      };
	    case /^day(_.*)?/.test(field):
	      return fmt.timeFormat("%a %d %b %Y");
	    case /^weekday(_.*)?/.test(field):
	      // NB. months and weekdays are kept in 1-indexed format (like postgresql; unlike javascript)
	      return function (i) {
	        return i === null ? "" : spec.days[+i - 1];
	      };
	    case /^prologue(_.*)?/.test(field):
	      return formatBool;
	    case /^musique_danse_machine(_.*)?/.test(field):
	      return formatBool;
	    case /^free_entry(_.*)?/.test(field):
	      return formatBool;
	    case /^reprise(_.*)?/.test(field):
	      return formatBool;
	    case /^firstrun(_.*)?/.test(field):
	      return formatBool;
	
	    // aggregates
	    case /sum_receipts/.test(field):
	      return fmt.numberFormat(",.2f");
	    case /sum_receipts_weighted/.test(field):
	      return fmt.numberFormat(",f");
	    case /performances_days/.test(field):
	      return fmt.numberFormat(",f");
	    case /mean_receipts_day/.test(field):
	      return fmt.numberFormat(",.2f");
	    case /mean_receipts_day_weighted/.test(field):
	      return fmt.numberFormat(",f");
	    case /mean_price/.test(field):
	      return fmt.numberFormat(",.2f");
	    case /count_authors_(\d)/.test(field):
	      return fmt.numberFormat(",f");
	    case /count_titles_(\d)/.test(field):
	      return fmt.numberFormat(",f");
	  }
	
	  /* When len is set, returns the earlier of
	     (1) a 'hard' delimiter: parens, semicolon, comma
	     (2) the first 'soft' (space) delimiter after the len characters
	     TODO move into an editable short value in the database ? */
	  return function (x) {
	    if (!x) return "";
	    x = "" + x;
	    if (!len) return x;
	
	    var hard = x.search(/\s*[(,;]/);
	    hard = hard > -1 ? hard : Infinity;
	    var soft = x.indexOf(' ', len);
	    soft = soft > -1 ? soft : Infinity;
	
	    return x.slice(0, Math.min(hard, soft));
	  };
	
	  function formatBool(b) {
	    if (b === true) {
	      return lang === 'en' ? 'yes' : 'oui';
	    }
	    if (b === false) {
	      return lang === 'en' ? 'no' : 'non';
	    }
	    if (b === "undefined") {
	      return "";
	    }
	    return b;
	  }
	}
	
	function sort(vals) {
	  if (vals && vals.hasOwnProperty("sort") && vals.length > 0) {
	    if (typeof vals[0] === "number") {
	      vals.sort(function (a, b) {
	        return a - b;
	      });
	    } else {
	      vals.sort();
	    }
	  }
	}
	
	exports.group = group;
	exports.dimension = dimension;
	exports.aggregate = aggregate;
	exports.parse = parse;
	exports.format = format;
	exports.sort = sort;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = {
		"en": {
			"comparison_tool_title": "Comparison tool",
			"calendar_tool_title": "Calendar tool",
			"new_search_button": "New search",
			"comparison_tool_scope_title": "What are you looking for ?",
			"comparison_tool_place_title": "For what theatre ?",
			"comparison_tool_time_scope_title": "For what period ?",
			"comparison_tool_x_title": "x. In function of what ?",
			"comparison_tool_y_title": "y. In function of what ?",
			"comparison_tool_open_handle": "Search criterias",
			"filter_button_all": "Use all filters",
			"filter_button_clear_all": "Clear all filters",
			"sum_receipts": "Gross receipts",
			"sum_receipts_weighted": "Gross receipts (weighted)",
			"performances_days": "Performances (= days)",
			"mean_receipts_day": "Average receipts / day",
			"mean_receipts_day_weighted": "Average receipts / day (weighted)",
			"mean_price": "Average ticket price",
			"count_authors": "Count author",
			"count_titles": "Count title",
			"rows": "Rows",
			"cols": "Columns",
			"cells": "Cells",
			"find": "Search",
			"all": "All",
			"ok": "OK",
			"from": "From",
			"to": "To",
			"time": "Time",
			"performance": "Performance",
			"performance_addl": "Performance (additional)",
			"theater": "Theater",
			"decade": "Decade",
			"decade_hint": "for decade {decade}",
			"season": "Season",
			"season_hint": "during the season of {season}",
			"month": "Month",
			"month_hint": "for {month}",
			"day": "Day",
			"weekday": "Weekday",
			"weekday_hint": "on {weekday}",
			"author": "Author",
			"author_n": "Author",
			"author_n_hint": "for author {author_1}",
			"author_1": "Author (overture)",
			"author_1_hint": "when {author_1} is presented during overture",
			"author_2": "Author (2nd part)",
			"author_2_hint": "when {author_2} is presented in 2nd part",
			"author_3": "Author (3rd part)",
			"author_3_hint": "when {author_3} is presented in 3rd part",
			"title": "Title",
			"title_n": "Title",
			"title_n_hint": "for {title}",
			"title_1": "First title",
			"title_1_hint": "where the first title is {title_1}",
			"title_2": "Second title",
			"title_2_hint": "where the second title is {title_2}",
			"title_3": "Third title",
			"title_3_hint": "where the third title is {title_3}",
			"genre": "Genre",
			"genre_n": "Genre",
			"genre_n_hint": "for the {genre} genre",
			"genre_1": "Genre (overture)",
			"genre_1_hint": "where the first title is a {genre_1} genre",
			"genre_2": "Genre (2nd part)",
			"genre_2_hint": "where the third title is a {genre_3} genre",
			"genre_3": "Genre (3rd part)",
			"acts": "Acts",
			"acts_hint": "for act {acts}",
			"prose_vers": "Prose/Verse",
			"prologue": "Prolog",
			"musique_danse_machine": "Music/Dance/Machinery",
			"free_entry": "Free Entry",
			"firstrun": "First Run",
			"reprise": "Reprise",
			"newactor": "New Actor",
			"debut": "Debut",
			"ex_attendance": "VIP",
			"ex_representation": "Notable performance",
			"ex_place": "Notable place",
			"theater_period": "Theater + Period",
			"seating_area": "Seat"
		},
		"fr": {
			"comparison_tool_title": "Outil de comparaison",
			"calendar_tool_title": "Outil calendrier",
			"new_search_button": "Nouvelle recherche",
			"comparison_tool_scope_title": "Que cherchez-vous ?",
			"comparison_tool_place_title": "Pour quelle salle ?",
			"comparison_tool_time_scope_title": "Selon quelle période ?",
			"comparison_tool_x_title": "x. En fonction de quoi ?",
			"comparison_tool_y_title": "y. En fonction de quoi ?",
			"comparison_tool_open_handle": "Critères de recherche",
			"filter_button_all": "Utiliser tous les filtres",
			"filter_button_clear_all": "Supprimer les filtres",
			"sum_receipts": "Somme des recettes",
			"sum_receipts_weighted": "Somme recette (pondérée)",
			"performances_days": "Représentations / jour",
			"mean_receipts_day": "Moyenne des recettes / jour",
			"mean_receipts_day_weighted": "Moyenne recette/jour (pondérée)",
			"mean_price": "Moyenne du prix des places",
			"count_authors": "Nombre d'auteurs",
			"count_titles": "Nombre de pièces",
			"rows": "Lignes",
			"cols": "Colonnes",
			"cells": "Cellules",
			"find": "Rechercher",
			"all": "Tous",
			"ok": "OK",
			"from": "De",
			"to": "À",
			"time": "Période",
			"performance": "Pièce",
			"performance_addl": "Soirée (supplémentaire)",
			"theater": "Salle",
			"decade": "Décennie",
			"decade_hint": "pour la décennie {decade}",
			"season": "Saison",
			"season_hint": "durant la saison de {season}",
			"month": "Mois",
			"month_hint": "pour {month}",
			"day": "Jour",
			"weekday": "Jour de la semaine",
			"weekday_hint": "pour le {weekday}",
			"author": "Auteur",
			"author_n": "Auteur",
			"author_n_hint": "pour l'auteur {author_1}",
			"author_1": "Auteur de la première pièce",
			"author_1_hint": "lorsque {author_1} est en 1ère partie",
			"author_2": "Auteur de la seconde pièce",
			"author_2_hint": "lorsque {author_2} est en 2e partie",
			"author_3": "Auteur de la troisième pièce",
			"author_3_hint": "lorsque {author_3} est en 3e partie",
			"title": "Pièce",
			"title_n": "Pièce",
			"title_n_hint": "pour la pièce {title}",
			"title_1": "Première pièce",
			"title_1_hint": "dont la 1ère pièce est {title_1}",
			"title_2": "Seconde pièce",
			"title_2_hint": "dont la 2e pièce est {title_2}",
			"title_3": "Troisième pièce",
			"title_3_hint": "dont la 3e pièce est {title_3}",
			"genre": "Genre",
			"genre_n": "Genre",
			"genre_n_hint": "des {genre}s",
			"genre_1": "Genre de la première pièce",
			"genre_1_hint": "dont le genre de la 1ère pièce est {genre_1}",
			"genre_2": "Genre de la seconde pièce",
			"genre_2_hint": "dont le genre de la 2e pièce est {genre_2}",
			"genre_3": "Genre de la troisième pièce",
			"genre_3_hint": "dont le genre de la 3e pièce est {genre_3}",
			"acts": "Acte(s)",
			"acts_hint": "pour l'acte {acts}",
			"prose_vers": "Prose/Vers",
			"prologue": "Prologue",
			"musique_danse_machine": "Musique/Danse/Machine",
			"free_entry": "Gratuit",
			"firstrun": "First Run",
			"reprise": "Reprise",
			"newactor": "Nouvel Acteur",
			"debut": "Début",
			"ex_attendance": "Présence exceptionelle",
			"ex_representation": "Répresentation exceptionelles",
			"ex_place": "ExPlace",
			"theater_period": "Théâtre + Période",
			"seating_area": "Place",
			"seating_area_hint": "pour la place {seating_area}"
		}
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Barebones i18n
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 07/2015
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var d3 = __webpack_require__(8);
	
	var h = __webpack_require__(1).h;
	
	var fr_spec = {
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["", " €"],
	  dateTime: "%A, le %e %B %Y, %X",
	  date: "%d/%m/%Y",
	  time: "%H:%M:%S",
	  periods: ["AM", "PM"], // unused
	  days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
	  shortDays: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
	  months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
	  shortMonths: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."]
	};
	var fr = d3.locale(fr_spec);
	
	var en_spec = {
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  dateTime: "%a %b %e %X %Y",
	  date: "%m/%d/%Y",
	  time: "%H:%M:%S",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	};
	var en = d3.locale(en_spec);
	
	function format_stem_sub(msgs, s, lang, callback) {
	  if (!msgs[lang]) {
	    throw "Unknown language (" + lang + ")";
	  }
	  var stem, sub, m;
	
	  if (stem = msgs[lang][s]) {
	    sub = null;
	  } else {
	    m = /([A-Za-z0-9]+)(_[n0-9])?$/.exec(s);
	    stem = m[1];
	    stem = msgs[lang][stem] || stem;
	    sub = m[2] ? m[2].slice(1) : null;
	  }
	
	  return callback(stem, sub);
	}
	
	function htmlize(msgs, s, lang) {
	  return format_stem_sub(msgs, s, lang, function (stem, sub) {
	    return h('span', [stem, sub ? h('sub', [sub]) : null]);
	  });
	}
	
	exports.fr = fr;
	exports.fr_spec = fr_spec;
	exports.en = en;
	exports.en_spec = en_spec;
	exports.htmlize = htmlize;
	exports.format_stem_sub = format_stem_sub;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./query.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./query.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Modal Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 08/2015
	* David Talbot, Laval University, 07/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	function Modal(initial_query) {
	  return hg.state({
	    modal: hg.value(null),
	
	    // Query ui elements states
	    queryPanelOpen: hg.value(true),
	    aggregateDropdownOpen: hg.value(false),
	    xAxisDropdownOpen: hg.value(false),
	    yAxisDropdownOpen: hg.value(false),
	    axisDimensionDropdown: hg.value(null),
	    selectAll: hg.varhash({}),
	    filter_selection: hg.varhash(initial_query.filter),
	
	    channels: {
	      setModal: Modal.setModal,
	
	      // Queri ui elements channels
	      setPanelOpen: Modal.setPanelOpen,
	      setAggregateDropdownOpen: Modal.setAggregateDropdownOpen,
	      setXAxisDropdownOpen: Modal.setXAxisDropdownOpen,
	      setYAxisDropdownOpen: Modal.setYAxisDropdownOpen,
	      setAxisDimensionDropdown: Modal.setAxisDimensionDropdown,
	      toggleAllFilterValues: Modal.toggleAllFilterValues,
	      toggleFilterValue: Modal.toggleFilterValue,
	      resetSelectedFilterValue: Modal.resetSelectedFilterValue
	    }
	  });
	}
	
	Modal.setModal = function (state, new_modal) {
	  if (new_modal === state.modal()) {
	    new_modal = null;
	  }
	  state.modal.set(new_modal);
	};
	
	Modal.setPanelOpen = function (state) {
	  state.queryPanelOpen.set(!state.queryPanelOpen());
	};
	
	Modal.setAggregateDropdownOpen = function (state) {
	  state.aggregateDropdownOpen.set(!state.aggregateDropdownOpen());
	};
	
	Modal.setXAxisDropdownOpen = function (state, axis) {
	  state.xAxisDropdownOpen.set(!state.xAxisDropdownOpen());
	  state.yAxisDropdownOpen.set(false);
	};
	
	Modal.setYAxisDropdownOpen = function (state, axis) {
	  state.yAxisDropdownOpen.set(!state.yAxisDropdownOpen());
	  state.xAxisDropdownOpen.set(false);
	};
	
	Modal.setAxisDimensionDropdown = function (state, dimension_name) {
	  if (state.axisDimensionDropdown() == dimension_name) {
	    state.axisDimensionDropdown.set(null);
	  } else {
	    state.axisDimensionDropdown.set(dimension_name);
	  }
	};
	
	Modal.toggleAllFilterValues = function (modal, dim) {
	  if (!modal.selectAll[dim]) {
	    modal.selectAll.put(dim, true);
	    modal.filter_selection.put(dim, []);
	  } else {
	    modal.selectAll.put(dim, false);
	    modal.filter_selection.put(dim, null);
	  }
	};
	
	Modal.toggleFilterValue = function (modal, data) {
	  var dim = data.dim;
	  var value = data.value;
	
	  var sv = modal.filter_selection()[dim] || [];
	  var start_count = sv.length;
	
	  var j = sv.indexOf(value);
	
	  if (j > -1) {
	    sv.splice(j, 1);
	  } else {
	    sv.push(value);
	  }
	  sv.sort();
	
	  console.log('toggled selection ' + dim + '.' + value + ' (' + sv.length + ')');
	
	  if (sv.length < 5) {
	    console.log(JSON.stringify(sv));
	  }
	
	  modal.filter_selection.put(dim, sv);
	  modal.selectAll.put(dim, false);
	};
	
	Modal.resetSelectedFilterValue = function (modal, data) {
	  modal.filter_selection.put(data.dim, null);
	};
	
	Modal.render = function (state, modal_key, label, children) {
	  return h('div.dropdown', [h('button', { 'ev-click': hg.send(state.channels.setModal, modal_key) }, [label]), state.modal === modal_key ? children : null]);
	};
	
	exports['default'] = Modal;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Data analytics client ("store" in flux)
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 06/2015
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var schema = __webpack_require__(2);
	
	var d3 = __webpack_require__(8); // solely for ajax
	
	var qs = __webpack_require__(32);
	
	var dateIndexFormat = d3.time.format('%Y-%m-%d');
	
	function datapoint(datapoint_url) {
	
	  datapoint_url = datapoint_url || "/api/cfrp";
	
	  // TODO.  change these calls to Javascript promises
	
	  return {
	    domain: function domain(dim, fn) {
	      d3.csv(datapoint_url + "/aggregate/default.csv?" + qs.stringify({ 'axis[]': dim }), function (error, data) {
	        if (error) {
	          return console.error(error);
	        } else {
	          data = data.map(function (d) {
	            return schema.parse(dim)(d[dim]);
	          });
	          fn(data);
	        }
	      });
	    },
	
	    url: aggregate_url,
	
	    summarize: function summarize(dims, agg, filter, windows, fn) {
	      var url = aggregate_url(dims, agg, filter, windows);
	
	      d3.csv(url, function (error, data) {
	        if (data) {
	          data = data.map(function (d) {
	            for (var key in d) {
	              d[key] = schema.parse(key)(d[key]);
	            }
	            return d;
	          });
	        }
	        fn(error, data);
	      });
	    }
	  };
	
	  function aggregate_url(dims, agg, filter, windows) {
	    var params = Object.create({});
	    params['axis[]'] = dims;
	    for (var dim in filter) {
	      params['filter.' + dim + '[]'] = filter[dim];
	    }
	
	    for (var dim in windows) {
	      if (windows[dim][0]) {
	        params['filter.' + dim + '.gt'] = dateIndexFormat(windows[dim][0]);
	      }
	      if (windows[dim][1]) {
	        params['filter.' + dim + '.lt'] = dateIndexFormat(windows[dim][1]);
	      }
	    }
	
	    return datapoint_url + "/aggregate/" + encodeURIComponent(agg) + ".csv?" + qs.stringify(params);
	  }
	}
	
	exports['default'] = datapoint;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var Delegator = __webpack_require__(42)
	
	module.exports = BaseEvent
	
	function BaseEvent(lambda) {
	    return EventHandler;
	
	    function EventHandler(fn, data, opts) {
	        var handler = {
	            fn: fn,
	            data: data !== undefined ? data : {},
	            opts: opts || {},
	            handleEvent: handleEvent
	        }
	
	        if (fn && fn.type === 'dom-delegator-handle') {
	            return Delegator.transformHandle(fn,
	                handleLambda.bind(handler))
	        }
	
	        return handler;
	    }
	
	    function handleLambda(ev, broadcast) {
	        if (this.opts.startPropagation && ev.startPropagation) {
	            ev.startPropagation();
	        }
	
	        return lambda.call(this, ev, broadcast)
	    }
	
	    function handleEvent(ev) {
	        var self = this
	
	        if (self.opts.startPropagation && ev.startPropagation) {
	            ev.startPropagation()
	        }
	
	        lambda.call(self, ev, broadcast)
	
	        function broadcast(value) {
	            if (typeof self.fn === 'function') {
	                self.fn(value)
	            } else {
	                self.fn.write(value)
	            }
	        }
	    }
	}


/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = isWidget
	
	function isWidget(w) {
	    return w && w.type === "Widget"
	}


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(211);
	
	if (typeof document !== 'undefined') {
	    module.exports = document;
	} else {
	    var doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	
	    module.exports = doccy;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = setNonEnumerable;
	
	function setNonEnumerable(object, key, value) {
	    Object.defineProperty(object, key, {
	        value: value,
	        writable: true,
	        configurable: true,
	        enumerable: false
	    });
	}


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = Observable
	
	function Observable(value) {
	    var listeners = []
	    value = value === undefined ? null : value
	
	    observable.set = function (v) {
	        value = v
	        listeners.forEach(function (f) {
	            f(v)
	        })
	    }
	
	    return observable
	
	    function observable(listener) {
	        if (!listener) {
	            return value
	        }
	
	        listeners.push(listener)
	
	        return function remove() {
	            listeners.splice(listeners.indexOf(listener), 1)
	        }
	    }
	}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(18)
	
	module.exports = isVirtualNode
	
	function isVirtualNode(x) {
	    return x && x.type === "VirtualNode" && x.version === version
	}


/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = "2"


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var OneVersionConstraint = __webpack_require__(114);
	
	var MY_VERSION = '7';
	OneVersionConstraint('ev-store', MY_VERSION);
	
	var hashKey = '__EV_STORE_KEY@' + MY_VERSION;
	
	module.exports = EvStore;
	
	function EvStore(elem) {
	    var hash = elem[hashKey];
	
	    if (!hash) {
	        hash = elem[hashKey] = {};
	    }
	
	    return hash;
	}


/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = {
		"en": {
			"dot1": "Crosstab",
			"dot2": "Crosstab + Calendar",
			"dot3": "Calendar + Register",
			"pane_selector_button_1": "Crosstab",
			"pane_selector_button_2": "Calendar",
			"pane_selector_button_3": "Resgistry",
			"download": "Download in format"
		},
		"fr": {
			"dot1": "Tableau croisé",
			"dot2": "Tableau croisé + Calendrier",
			"dot3": "Calendrier + Registre",
			"pane_selector_button_1": "Tableau Croisé",
			"pane_selector_button_2": "Calendrier",
			"pane_selector_button_3": "Registre",
			"sum_receipts": "{agg} Livres est la somme des recettes {cols} {rows}",
			"performances_days": "{agg} est le nombre de représentations par jour {cols} {rows}",
			"mean_receipts_day": "{agg} Livres est la moyenne des recettes par jour {cols} {rows}",
			"mean_price": "{agg} Livres est la moyenne du prix des places {cols} {rows}",
			"currency": "Livres",
			"cancel": "Annuler",
			"ok": "OK",
			"calendar_tool_caption": "Changement d'outil",
			"calendar_tool_message": "Le passage de l'outil de comparaison à l'outil calendrier implique la reprise des sélections faites précédemment dans le premier outil. Tous les nouveaux choix de critères faits dans l'outil calendrier ne seront pas pris en compte.",
			"criteria_caption": "",
			"criteria_message": "Vous souhaitez générer un graphique avec une grande quantité de critères. Nous vous invitons à raffiner votre recherche pour une meilleure lisibilité.",
			"criteria_download_message": "Au besoin, vous pouvez télécharger directement le résultat de cette recherche.",
			"legend_caption": "Légende : {type}",
			"download": "Télécharger au format",
			"download-button": "Télécharger"
		}
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var setNonEnumerable = __webpack_require__(15);
	
	module.exports = addListener
	
	function addListener(observArray, observ) {
	    var list = observArray._list
	
	    return observ(function (value) {
	        var valueList =  observArray().slice()
	        var index = list.indexOf(observ)
	
	        // This code path should never hit. If this happens
	        // there's a bug in the cleanup code
	        if (index === -1) {
	            var message = "observ-array: Unremoved observ listener"
	            var err = new Error(message)
	            err.list = list
	            err.index = index
	            err.observ = observ
	            throw err
	        }
	
	        valueList.splice(index, 1, value)
	        setNonEnumerable(valueList, "_diff", [ [index, 1, value] ])
	
	        observArray._observSet(valueList)
	    })
	}


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(27);
	
	var VNode = __webpack_require__(64);
	var VText = __webpack_require__(66);
	var isVNode = __webpack_require__(17);
	var isVText = __webpack_require__(25);
	var isWidget = __webpack_require__(13);
	var isHook = __webpack_require__(24);
	var isVThunk = __webpack_require__(23);
	
	var parseTag = __webpack_require__(190);
	var softSetHook = __webpack_require__(189);
	var evHook = __webpack_require__(188);
	
	module.exports = h;
	
	function h(tagName, properties, children) {
	    var childNodes = [];
	    var tag, props, key, namespace;
	
	    if (!children && isChildren(properties)) {
	        children = properties;
	        props = {};
	    }
	
	    props = props || properties || {};
	    tag = parseTag(tagName, props);
	
	    // support keys
	    if (props.hasOwnProperty('key')) {
	        key = props.key;
	        props.key = undefined;
	    }
	
	    // support namespace
	    if (props.hasOwnProperty('namespace')) {
	        namespace = props.namespace;
	        props.namespace = undefined;
	    }
	
	    // fix cursor bug
	    if (tag === 'INPUT' &&
	        !namespace &&
	        props.hasOwnProperty('value') &&
	        props.value !== undefined &&
	        !isHook(props.value)
	    ) {
	        props.value = softSetHook(props.value);
	    }
	
	    transformProperties(props);
	
	    if (children !== undefined && children !== null) {
	        addChild(children, childNodes, tag, props);
	    }
	
	
	    return new VNode(tag, props, childNodes, key, namespace);
	}
	
	function addChild(c, childNodes, tag, props) {
	    if (typeof c === 'string') {
	        childNodes.push(new VText(c));
	    } else if (typeof c === 'number') {
	        childNodes.push(new VText(String(c)));
	    } else if (isChild(c)) {
	        childNodes.push(c);
	    } else if (isArray(c)) {
	        for (var i = 0; i < c.length; i++) {
	            addChild(c[i], childNodes, tag, props);
	        }
	    } else if (c === null || c === undefined) {
	        return;
	    } else {
	        throw UnexpectedVirtualElement({
	            foreignObject: c,
	            parentVnode: {
	                tagName: tag,
	                properties: props
	            }
	        });
	    }
	}
	
	function transformProperties(props) {
	    for (var propName in props) {
	        if (props.hasOwnProperty(propName)) {
	            var value = props[propName];
	
	            if (isHook(value)) {
	                continue;
	            }
	
	            if (propName.substr(0, 3) === 'ev-') {
	                // add ev-foo support
	                props[propName] = evHook(value);
	            }
	        }
	    }
	}
	
	function isChild(x) {
	    return isVNode(x) || isVText(x) || isWidget(x) || isVThunk(x);
	}
	
	function isChildren(x) {
	    return typeof x === 'string' || isArray(x) || isChild(x);
	}
	
	function UnexpectedVirtualElement(data) {
	    var err = new Error();
	
	    err.type = 'virtual-hyperscript.unexpected.virtual-element';
	    err.message = 'Unexpected virtual child passed to h().\n' +
	        'Expected a VNode / Vthunk / VWidget / string but:\n' +
	        'got:\n' +
	        errorString(data.foreignObject) +
	        '.\n' +
	        'The parent vnode is:\n' +
	        errorString(data.parentVnode)
	        '\n' +
	        'Suggested fix: change your `h(..., [ ... ])` callsite.';
	    err.foreignObject = data.foreignObject;
	    err.parentVnode = data.parentVnode;
	
	    return err;
	}
	
	function errorString(obj) {
	    try {
	        return JSON.stringify(obj, null, '    ');
	    } catch (e) {
	        return String(obj);
	    }
	}


/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = isThunk
	
	function isThunk(t) {
	    return t && t.type === "Thunk"
	}


/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = isHook
	
	function isHook(hook) {
	    return hook &&
	      (typeof hook.hook === "function" && !hook.hasOwnProperty("hook") ||
	       typeof hook.unhook === "function" && !hook.hasOwnProperty("unhook"))
	}


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(18)
	
	module.exports = isVirtualText
	
	function isVirtualText(x) {
	    return x && x.type === "VirtualText" && x.version === version
	}


/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = "1"


/***/ },
/* 27 */
/***/ function(module, exports) {

	var nativeIsArray = Array.isArray
	var toString = Object.prototype.toString
	
	module.exports = nativeIsArray || isArray
	
	function isArray(obj) {
	    return toString.call(obj) === "[object Array]"
	}


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var d3 = __webpack_require__(8);
	
	var vector_palette = ['#2379b4', '#f7941e', '#2ba048', '#d62930', '#f8b6c0', '#006838', '#662d91', '#d7df23', '#ec008c', '#0c0c54', '#a8e0f9', '#da1c5c', '#726658', '#603913', '#231f20', '#2b3990', '#9fc59a', '#819cd1', '#92278f', '#00a79d', '#27aae1', '#f04b44'];
	
	function colors(domain) {
	  return d3.scale.ordinal().range(vector_palette).domain(domain);
	}
	
	function lighten(color, amount) {
	  var r = "0x" + color.substring(1, 3);
	  var g = "0x" + color.substring(3, 5);
	  var b = "0x" + color.substring(5);
	  return "rgba(" + parseInt(r) + ", " + parseInt(g) + ", " + parseInt(b) + ", " + amount + ")";
	}
	
	exports.vector_palette = vector_palette;
	exports.colors = colors;
	exports.lighten = lighten;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var walk = __webpack_require__(112)
	
	var FormData = __webpack_require__(133)
	
	module.exports = getFormData
	
	function buildElems(rootElem) {
	    var hash = {}
	    if (rootElem.name) {
	    	hash[rootElem.name] = rootElem
	    }
	
	    walk(rootElem, function (child) {
	        if (child.name) {
	            hash[child.name] = child
	        }
	    })
	
	
	    return hash
	}
	
	function getFormData(rootElem) {
	    var elements = buildElems(rootElem)
	
	    return FormData(elements)
	}


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.2
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-03-17T17:51Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.2",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE11 only
		// In IE 11 fullscreen elements inside of an iframe have
		// 100x too small dimensions (gh-1764).
		if ( document.msFullscreenElement && window.top !== window ) {
	
			// Support: IE11 only
			// Running getBoundingClientRect on a disconnected node
			// in IE throws an error.
			if ( elem.getClientRects().length ) {
				val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
			}
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
	
					// Previously, `originalEvent: {}` was set here, so stopPropagation call
					// would not be triggered on donor event, since in our own
					// jQuery.event.stopPropagation function we had a check for existence of
					// originalEvent.stopPropagation method, so, consequently it would be a noop.
					//
					// But now, this "simulate" function is used only for events
					// for which stopPropagation() is noop, so there is no need for that anymore.
					//
					// For the 1.x branch though, guard for "click" and "submit"
					// events is still used, but was moved to jQuery.event.stopPropagation function
					// because `originalEvent` should point to the original event for the constancy
					// with other events and for more focused logic
				}
			);
	
			jQuery.event.trigger( e, null, elem );
	
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( self, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var addListener = __webpack_require__(21)
	
	module.exports = applyPatch
	
	function applyPatch (valueList, args) {
	    var obs = this
	    var valueArgs = args.map(unpack)
	
	    valueList.splice.apply(valueList, valueArgs)
	    obs._list.splice.apply(obs._list, args)
	
	    var extraRemoveListeners = args.slice(2).map(function (observ) {
	        return typeof observ === "function" ?
	            addListener(obs, observ) :
	            null
	    })
	
	    extraRemoveListeners.unshift(args[0], args[1])
	    var removedListeners = obs._removeListeners.splice
	        .apply(obs._removeListeners, extraRemoveListeners)
	
	    removedListeners.forEach(function (removeObservListener) {
	        if (removeObservListener) {
	            removeObservListener()
	        }
	    })
	
	    return valueArgs
	}
	
	function unpack(value, index){
	    if (index === 0 || index === 1) {
	        return value
	    }
	    return typeof value === "function" ? value() : value
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(157);
	exports.encode = exports.stringify = __webpack_require__(158);


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var hasKeys = __webpack_require__(174)
	
	module.exports = extend
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        if (!hasKeys(source)) {
	            continue
	        }
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(14)
	
	var applyProperties = __webpack_require__(61)
	
	var isVNode = __webpack_require__(17)
	var isVText = __webpack_require__(25)
	var isWidget = __webpack_require__(13)
	var handleThunk = __webpack_require__(63)
	
	module.exports = createElement
	
	function createElement(vnode, opts) {
	    var doc = opts ? opts.document || document : document
	    var warn = opts ? opts.warn : null
	
	    vnode = handleThunk(vnode).a
	
	    if (isWidget(vnode)) {
	        return vnode.init()
	    } else if (isVText(vnode)) {
	        return doc.createTextNode(vnode.text)
	    } else if (!isVNode(vnode)) {
	        if (warn) {
	            warn("Item is not a valid virtual dom node", vnode)
	        }
	        return null
	    }
	
	    var node = (vnode.namespace === null) ?
	        doc.createElement(vnode.tagName) :
	        doc.createElementNS(vnode.namespace, vnode.tagName)
	
	    var props = vnode.properties
	    applyProperties(node, props)
	
	    var children = vnode.children
	
	    for (var i = 0; i < children.length; i++) {
	        var childNode = createElement(children[i], opts)
	        if (childNode) {
	            node.appendChild(childNode)
	        }
	    }
	
	    return node
	}


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Charting Component
	*
	* Copyright (c) 2016 MIT Hyperstudio
	* Christopher York, 04/2016
	*
	*/
	
	/*
	 * TODO.
	 * [x] salle data field  SERVER SIDE
	 * [x] tilt labels
	 * [x] colors for lines
	 * [x] decades etc formatted
	 * [x] grey legend background
	 * [ ] clean up
	 * [ ] think through ordinal/linear & nesting
	 * [ ] bugs on unusual combinations of axes
	 * [x] x axis scale is wrong when # of ticks high (in decades)
	 * [ ] cartesian fisheye with labels?                           NOT TO DO
	 * [ ] rendering loop too slow
	 * [ ] fisheye jerks when scrubbing left                        NOT TO DO
	 * [x] legend entries should have ellipsis when cut             ALTERNATE
	 * [ ] barchart: groups are moving independently from axis labels
	 * [ ] barchart: don't show groups that are too small to see?
	 * [ ] "and 20 more"
	 * [ ] scrolling                                                NOT TO DO
	 * [ ] calculate distortion from distance between axis points?  DIST CANCELLED
	 * [x] adjust legend of line graph to cursor
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(54);
	
	var msgs = __webpack_require__(3);
	
	var i18n = __webpack_require__(4);
	
	var hg = __webpack_require__(1);
	var svg = __webpack_require__(50);
	
	/* TODO.  switch completely to d3 v4 - better support for non-DOM situations */
	var d3 = __webpack_require__(8);
	
	var datapoint = __webpack_require__(11);
	var rendering = __webpack_require__(28);
	var schema = __webpack_require__(2);
	
	var margins = { top: 10, right: 130, bottom: 100, left: 80 };
	var legend_margins = { top: 5, right: 0, bottom: 0, left: 5 }; /* TODO.  remove */
	
	var max_legend = 20;
	var max_group = 10;
	
	var min_spacing = 20;
	
	/* component state */
	function Chart() {
	  return hg.state({
	    focus: hg.value(null),
	    point: hg.value(null),
	    channels: {
	      focus: function focus(state, key) {
	        //        console.log('clicked ' + JSON.stringify(key) + '; state is ' + JSON.stringify(state.focus()))
	        state.focus.set(state.focus() == key ? null : key);
	      },
	      point: function point(state, key) {
	        state.point.set(state.point() == key ? null : key);
	      }
	    }
	  });
	}
	
	/* state, query: required; data, size, lang: optional */
	Chart.render = function (state, app, query, data, size, legend, lang) {
	  /* For now, queries map to graph as follows:
	   * x axis is last dimension in rows
	   * y axis is the aggregate value
	   * color is the last dimension in cols
	   *
	   * future: matrix of graphs; select one dimension for color
	   *   c.f. wilkinson, grammar of graphics, ch 11.3.2 "Multi-Way Tables"
	   *
	   * to handle visual complexity, chart shows only first 10 values in each dimension
	   *
	   * in combination with query.order, this gives
	   * - desc: top 10 values
	   * - asc: bottom 10 values
	   *
	   * in combination with query.filter, any particular series can be charted
	   */
	
	  var origdata = data;
	
	  data = data ? data["1x1"] || [] : [];
	  size = size || [800, 250];
	
	  var width = size[0] - margins.left - margins.right;
	  var height = size[1] - margins.top - margins.bottom;
	
	  var f_x = function f_x(d) {
	    return d && query.rows.length ? d[query.rows[query.rows.length - 1]] : 'tous';
	  };
	  var f_y = function f_y(d) {
	    return d[query.agg];
	  };
	  var f_color = function f_color(d) {
	    return d && query.cols.length ? d[query.cols[0]] : 'tous';
	  };
	
	  var fmt_x = schema.format(lang, query.rows[query.rows.length - 1], 10);
	  var fmt_x_long = schema.format(lang, query.rows[query.rows.length - 1]);
	  var fmt_y = schema.format(lang, query.agg);
	  var fmt_color = schema.format(lang, query.cols[0], 10);
	  var fmt_color_long = schema.format(lang, query.cols[0]);
	
	  var ordinal = ordinal_domain(data, function (v) {
	    return fmt_x(f_x(v));
	  });
	
	  /* interlude to find top 10 by color and group */
	
	  var sums = undefined;
	  sums = (origdata ? origdata["0x1"] || [] : []).slice();
	  sums.sort(function (a, b) {
	    return d3.descending(f_y(a), f_y(b));
	  });
	  var sel_vectors = sums.slice(0, max_legend).map(f_color);
	
	  sums = (origdata ? origdata["1x1"] || [] : []).slice();
	  sums = sums.filter(function (d) {
	    var c = f_color(d);
	    var b = sel_vectors.indexOf(c) > -1;
	    //    console.log(c + " : " + b)
	    return true;
	  });
	  sums = sums.sort(function (a, b) {
	    return d3.descending(f_y(a), f_y(b));
	  });
	  //  console.log(sums)
	
	  var sel_groups = sums.slice(0, max_group).map(f_x);
	
	  //  console.log('vectors: ' + JSON.stringify(sel_vectors))
	  //  console.log('groups: ' + JSON.stringify(sel_groups))
	
	  /* rearrange data */
	
	  var vectors = {};
	  data.forEach(function (d) {
	    var c = f_color(d);
	    var x = f_x(d);
	
	    if (!ordinal && sel_vectors.indexOf(c) !== -1 || ordinal && sel_groups.indexOf(x) !== -1 && sel_vectors.indexOf(c) !== -1) {
	      vectors[c] = vectors[c] || [];
	      vectors[c].push(d);
	    }
	  });
	
	  /* end of interlude */
	
	  var num_vectors = sel_vectors.length;
	
	  var y = d3.scale.linear().range([height, 0]).domain([0, d3.max(data, f_y)]);
	
	  var x = undefined,
	      plot = undefined,
	      ticks = undefined,
	      bar_width = undefined;
	  if (ordinal) {
	    x = d3.scale.ordinal().rangeRoundBands([0, width], .1).domain(sel_groups);
	    plot = bars();
	    ticks = x.domain();
	    bar_width = x.rangeBand() / num_vectors;
	  } else {
	    x = d3.scale.linear().range([0, width]).domain(d3.extent(data, f_x));
	    plot = d3.svg.line().interpolate('monotone');
	    ticks = x.ticks();
	    bar_width = 0;
	  }
	
	  plot.x(function (d) {
	    return x(f_x(d));
	  }).y(function (d) {
	    return y(f_y(d));
	  });
	
	  var fmt = function fmt(v) {
	    return '' + v;
	  };
	  var subscript = function subscript(attrs, axis) {
	    if (!(axis && axis[0])) return null;
	    return i18n.format_stem_sub(msgs, axis[0], lang, function (stem, sub) {
	      return svg('text', attrs || {}, [stem.toUpperCase(), sub ? svg('tspan', { dy: '1em' }, sub) : null]);
	    });
	  };
	  var tspan_title = function tspan_title(v1, v2) {
	    return [svg('tspan', {}, v1), v1 !== v2 ? svg('title', {}, v2) : null];
	  };
	
	  var f_focus = function f_focus(row, r_value, col, c_value) {
	    return Object.defineProperty(Object.defineProperty({}, row, { value: r_value }), col, { value: c_value });
	  };
	
	  var legend_labels = d3.keys(vectors);
	
	  //  console.log('legend_labels: ' + JSON.stringify(legend_labels.slice(0,max_legend)))
	
	  var color = rendering.colors(legend_labels);
	
	  var num_legend_labels = Math.min(max_legend + 1, legend_labels.length); /* +1 for extra labels line */
	
	  return svg('svg', { 'class': 'chart',
	    width: width + margins.left + margins.right,
	    height: height + margins.top + margins.bottom
	  }, [svg('g', { 'class': ordinal ? 'ordinal' : 'linear',
	    transform: 'translate(' + margins.left + ',' + margins.top + ')',
	    'font-family': 'Roboto Regular, Helvetica, Arial, sans-serif',
	    'font-size': '10px'
	  }, [
	
	  // marks
	
	  svg('g', { 'class': 'marks' }, d3.entries(vectors).map(function (d, i) {
	    return svg('g', {
	      'class': 'line l' + i, transform: 'translate(' + i * bar_width + ')',
	      opacity: state.focus === null || state.focus == d.key ? 1 : 0.2
	    }, d.value.map(function (dn) {
	      return !ordinal ? svg('circle', {
	        cx: x(f_x(dn)), cy: y(f_y(dn)),
	        r: state.point === f_x(dn) && state.focus == d.key ? 6 : 4, fill: color(d.key),
	        'ev-click': [hg.send(app.channels.focus_cell, { focus: f_focus(query.rows[0], f_x(dn), query.cols[0], d.key) })]
	      }) : null;
	    }).concat([svg('path', { d: plot(d.value), stroke: color(d.key), fill: ordinal ? color(d.key) : 'none' }), svg('title', d.key)]));
	  })),
	
	  // axes
	
	  svg('g', { 'class': 'x axis', transform: 'translate(0,' + height + ')' }, ticks.map(function (d) {
	    return svg('g', { 'class': 'tick',
	      transform: 'translate(' + x(d) + ')'
	    }, [svg('line', { y1: 3, y2: 8, stroke: 'gray' }), svg('text', { y: 8, dy: 8, dx: 8, transform: 'rotate(35)', 'text-anchor': 'start' }, tspan_title(fmt_x(d), fmt_x_long(d)))]);
	  }).concat([svg('path', { stroke: 'gray',
	    d: 'M0 0 H' + (width + 10) + (ordinal ? '' : 'V1.5 L' + (width + 15) + ' 0 L' + (width + 10) + ' -1.5V0') })])), svg('g', { 'class': 'y axis' }, y.ticks().map(function (d) {
	    return svg('g', { 'class': 'tick', transform: 'translate(0,' + y(d) + ')' }, [svg('line', { x1: -8, y1: 0, x2: -3, y2: 0, stroke: 'gray' }), svg('text', { x: -10, dy: '.3em', 'text-anchor': 'end' }, fmt_y(d))]);
	  }).concat([svg('path', { stroke: 'gray', d: 'M0 ' + height + ' V-10 H1.5 L0 -15 L-1.5 -10 H 0' })])),
	
	  // legend + axis labels
	  legend ? svg('g', { 'class': 'legend', transform: 'translate(' + [width + 5, 15] + ')' }, [legend_labels.length ? svg('rect', { 'class': 'background',
	    x: 0, y: legend_margins.top,
	    width: margins.right - 15, height: num_legend_labels * 15 + legend_margins.top,
	    stroke: 'none',
	    fill: 'black',
	    opacity: 0.05 }) : null, legend_labels.length > max_legend ? svg('text', { x: margins.right - 15, dy: '.3em', 'text-anchor': 'end' }, '[+ ' + (legend_labels.length - max_legend) + ' ]') : null].concat(legend_labels.slice(0, max_legend).map(function (d, i) {
	    return svg('g', { 'class': 'line', transform: 'translate(' + legend_margins.left + ',' + (15 + i * 15) + ')',
	      'ev-click': hg.send(state.channels.focus, d),
	      opacity: state.focus === null || state.focus === d ? 1 : 0.1 }, [svg('text', { x: 32, dy: '.3em' }, tspan_title(fmt_color(d), fmt_color_long(d))), svg('path', { d: ordinal ? 'M20 -5 h10 v10 h-10 z' : 'M0 0 H30', stroke: color(d), fill: color(d) }), !ordinal ? svg('circle', { cx: 15, r: 2, fill: color(d) }) : null]);
	  }))) : null, svg('g', { 'class': 'axis-labels', 'font-size': '12px' }, [legend ? subscript({ 'class': 'cols', transform: 'translate(' + [width + 5, 0] + ')', dy: '0.3em' }, query.cols) : null, subscript({ 'class': 'rows', transform: 'translate(' + [width + 25, height] + ')', dy: '0.3em' }, query.rows), svg('text', { 'class': 'agg', transform: 'translate(' + -margins.left + ')rotate(-90)', dy: '1em', 'text-anchor': 'end' }, msgs[lang][query.agg].toUpperCase())])])]);
	
	  function bars() {
	    var x = undefined,
	        y = undefined;
	
	    function f_rect(d, i) {
	      return 'M' + x(d, i) + ' ' + y(d, i) + ' h' + bar_width + ' V' + height + ' h' + -bar_width + ' Z';
	    }
	
	    function result(data) {
	      return data.map(f_rect).join(' ');
	    }
	
	    result.x = function (fn) {
	      if (!arguments.length) return x;
	      x = fn;
	      return result;
	    };
	
	    result.y = function (fn) {
	      if (!arguments.length) return y;
	      y = fn;
	      return result;
	    };
	
	    return result;
	  }
	};
	
	function ordinal_domain(data, f) {
	  return typeof f(data[0]) !== 'number';
	}
	
	exports['default'] = Chart;
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var assign = __webpack_require__(7);
	
	var Modal = __webpack_require__(10);
	
	var schema = __webpack_require__(2);
	
	var i18n = __webpack_require__(4);
	
	// see vdom bug below...
	var unique_key = 0;
	
	function DimensionSelector() {
		return null;
	}
	
	DimensionSelector.setDimensionDropdownOpen = function (state, dimension) {
		state.queryPanelOpen.set(dimension);
	};
	
	DimensionSelector.render = function (modal_state, query_state, axis, lang) {
		var lAxisChannel = axis == 'rows' ? 'setXAxisDropdownOpen' : 'setYAxisDropdownOpen';
		var lAxisDropdown = axis == 'rows' ? 'xAxisDropdownOpen' : 'yAxisDropdownOpen';
	
		var stem_lis = function stem_lis(dims, stem) {
	
			var buildDimNodeFunc = function buildDimNodeFunc(dim) {
				// vdom bug, must define radio attrs out of the return statement
				var attrs = {
					type: 'radio',
					id: 'axis_dimension',
					name: 'axis_dimension',
					key: unique_key++,
					'ev-click': [hg.send(query_state.channels.setSelectedDimension, { axis: axis, dim: dim }), hg.send(modal_state.channels[lAxisChannel])]
				};
				if (query_state.selectedDimension && dim == query_state.selectedDimension.dim && axis == query_state.selectedDimension.axis) {
					attrs.checked = true;
				}
	
				return [h('input', attrs), h('label', {
					'ev-click': [hg.send(query_state.channels.setSelectedDimension, { axis: axis, dim: dim }), hg.send(modal_state.channels[lAxisChannel])]
				}, [h('span.radio', h('span.radio')), h('span', i18n.htmlize(msgs, dim, lang))])];
			};
	
			var lis = dims.map(function (dim) {
				// TODO.  virtual-dom doesn't match changes in <input checked ... /> properly
				//        a parallel issue for Mithril: https://github.com/lhorie/mithril.js/issues/691
				//        one workaround is to cache-bust the entire list with a key:
				return h('li', { key: unique_key++ }, buildDimNodeFunc(dim));
			});
	
			if (lis.length > 1) {
				return h('ul.dropdown-list-content.dropdown-inline', lis);
			} else {
				return buildDimNodeFunc(dims[0]);
			}
	
			// return lResult;
		};
	
		var dim_lis = function dim_lis(dims) {
	
			var bins = Object.create({});
			dims.forEach(function (dim) {
				var match = /^([^_]+)/.exec(dim),
				    stem = match ? match[1] : dim;
				bins[stem] = bins[stem] || [];
				bins[stem].push(dim);
			});
	
			var stems = Object.keys(bins);
			var all_lis = stems.map(function (stem) {
				return h('li', stem_lis(bins[stem], stem));
			});
			return all_lis;
		};
	
		var group_lis = function group_lis(groups) {
			var names = Object.keys(groups);
			return names.map(function (name) {
				return h('li', [h('button.dropdown-list.dimension-selector' + (modal_state.axisDimensionDropdown == name ? '.selected' : ''), {
					'ev-click': hg.send(modal_state.channels.setAxisDimensionDropdown, name)
				}, [h('span.title', i18n.htmlize(msgs, name, lang)), h('span.fa.right' + (modal_state.axisDimensionDropdown == name ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content.dropdown-inline' + (modal_state.axisDimensionDropdown == name ? '.visible-container' : '.hidden-container'), dim_lis(groups[name]))]);
			});
		};
	
		return h('div.axis-selector.' + axis, [h('button.dropdown-list', {
			'ev-click': hg.send(modal_state.channels[lAxisChannel])
		}, [h('span.fa.right' + (modal_state[lAxisDropdown] ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content.axis-content' + (modal_state[lAxisDropdown] ? '.visible-container' : '.hidden-container'), group_lis(schema.group()))]);
	};
	
	exports['default'] = DimensionSelector;
	module.exports = exports['default'];

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var schema = __webpack_require__(2);
	
	var assign = __webpack_require__(7);
	
	var i18n = __webpack_require__(4);
	
	var Modal = __webpack_require__(10);
	
	function strMatch(s, p) {
	  s = ("" + s).toLowerCase();
	  p = ("" + p).toLowerCase();
	  return s.indexOf(p) > -1;
	}
	
	function Filter() {
	
	  //  console.log("FILTER: " + JSON.stringify(initial_query))
	
	  return hg.state({
	    search: hg.value(''),
	    channels: {
	      updateSearch: updateSearch
	    }
	  });
	}
	
	function updateSearch(state, data) {
	  state.search.set(data.search);
	}
	
	// see vdom bug below...
	var unique_key = 0;
	
	//Filter.render = function(state, channels, dim, values, query, formatter, lang) {
	Filter.render = function (modal_state, query_state, dim, axis, lang) {
	  var msgs_i18n = msgs[lang];
	  var formatter = schema.format(lang, dim);
	
	  var cbs = [];
	
	  var values = query_state.domains_data_selection[dim] || [];
	  var sel_values = modal_state.filter_selection[dim] || [];
	
	  values.forEach(function (d, i) {
	    if (strMatch(d, query_state.filter_state.search)) {
	      var attrs = { type: 'checkbox',
	        id: d,
	        name: d,
	        'ev-event': hg.sendChange(modal_state.channels.toggleFilterValue, { dim: dim, value: d }) };
	
	      if (sel_values.indexOf(d) > -1 || modal_state.selectAll[dim]) {
	        attrs.checked = true;
	      }
	      cbs.push(
	      // TODO.  virtual-dom doesn't match changes in <input checked ... /> properly
	      //        a parallel issue for Mithril: https://github.com/lhorie/mithril.js/issues/691
	      //        one workaround is to cache-bust the entire list with a key:
	      h('li.custom-checkbox', {
	        key: unique_key++,
	        'ev-click': hg.send(modal_state.channels.toggleFilterValue, { dim: dim, value: d })
	      }, [h('input', attrs), h('label' + (attrs.checked ? '.selected-filter' : ''), [h('span.custom-input', h('span.custom-input')), h('span', formatter(d))])]));
	    }
	  });
	
	  var lSelectAllButtonTitle = modal_state.selectAll[dim] ? msgs_i18n.filter_button_clear_all : msgs_i18n.filter_button_all;
	
	  return [h('div', h('button.secondary', { 'ev-click': hg.send(modal_state.channels.toggleAllFilterValues, dim) }, [lSelectAllButtonTitle])), h('div', h('h4', [msgs_i18n[dim]])), h('div', h('input', { 'ev-event': hg.sendChange(query_state.filter_state.channels.updateSearch),
	    value: query_state.filter_state.search,
	    type: 'text',
	    name: 'search',
	    placeholder: msgs_i18n.find })), h('ul.filter-list', cbs), h('div', h('button.secondary', { 'ev-click': [hg.send(query_state.channels.addDimension, { axis: axis, dim: dim, filters: modal_state.filter_selection[dim] })] }, [msgs_i18n.ok]))];
	};
	
	exports['default'] = Filter;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 08/2015
	*
	* TODO : This component is not actively used (not called in app.js) and may be removed in future if not needed. Kept for possible reintegration (dtalbot)
	* Used in axis.js
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(9);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	function Order(initial_order) {
	  return hg.varhash(initial_order);
	}
	
	Order.render = function (query_state, dim) {
	  return h('span.order.' + (query_state.order[dim] || 'nat'), {
	    'ev-click': hg.send(query_state.channels.toggleDimensionOrder, dim)
	  });
	};
	
	exports['default'] = Order;
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, $) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function Tooltip() {}
	
	Tooltip.prototype.hook = function (element) {
	  setImmediate(function () {
	    var tooltip = $(element);
	    tooltip.attr("data-tooltip", "");
	    if (tooltip.attr("data-toggle")) {
	      if (tooltip.attr("title")) {
	        $("#" + tooltip.attr("data-toggle")).text(tooltip.attr("title"));
	        tooltip.attr("title", "");
	      }
	    } else {
	      tooltip.foundation();
	    }
	  });
	};
	
	exports.Tooltip = Tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(208).setImmediate, __webpack_require__(30)))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  factory((global.time = {}));
	}(this, function (exports) { 'use strict';
	
	  var t1 = new Date;
	
	  var t0 = new Date;
	
	  function newInterval(floori, offseti, count) {
	
	    function interval(date) {
	      return floori(date = new Date(+date)), date;
	    }
	
	    interval.floor = interval;
	
	    interval.round = function(date) {
	      var d0 = new Date(+date),
	          d1 = new Date(date - 1);
	      floori(d0), floori(d1), offseti(d1, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    };
	
	    interval.ceil = function(date) {
	      return floori(date = new Date(date - 1)), offseti(date, 1), date;
	    };
	
	    interval.offset = function(date, step) {
	      return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	    };
	
	    interval.range = function(start, stop, step) {
	      var range = [];
	      start = new Date(start - 1);
	      stop = new Date(+stop);
	      step = step == null ? 1 : Math.floor(step);
	      if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	      offseti(start, 1), floori(start);
	      if (start < stop) range.push(new Date(+start));
	      while (offseti(start, step), floori(start), start < stop) range.push(new Date(+start));
	      return range;
	    };
	
	    interval.filter = function(test) {
	      return newInterval(function(date) {
	        while (floori(date), !test(date)) date.setTime(date - 1);
	      }, function(date, step) {
	        while (--step >= 0) while (offseti(date, 1), !test(date));
	      });
	    };
	
	    if (count) interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    return interval;
	  }
	
	  var second = newInterval(function(date) {
	    date.setMilliseconds(0);
	  }, function(date, step) {
	    date.setTime(+date + step * 1e3);
	  }, function(start, end) {
	    return (end - start) / 1e3;
	  });
	
	  exports.seconds = second.range;
	
	  var minute = newInterval(function(date) {
	    date.setSeconds(0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * 6e4);
	  }, function(start, end) {
	    return (end - start) / 6e4;
	  });
	
	  exports.minutes = minute.range;
	
	  var hour = newInterval(function(date) {
	    date.setMinutes(0, 0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * 36e5);
	  }, function(start, end) {
	    return (end - start) / 36e5;
	  });
	
	  exports.hours = hour.range;
	
	  var day = newInterval(function(date) {
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * 6e4) / 864e5;
	  });
	
	  exports.days = day.range;
	
	  function weekday(i) {
	    return newInterval(function(date) {
	      date.setHours(0, 0, 0, 0);
	      date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    }, function(date, step) {
	      date.setDate(date.getDate() + step * 7);
	    }, function(start, end) {
	      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * 6e4) / 6048e5;
	    });
	  }
	
	  exports.sunday = weekday(0);
	
	  exports.sundays = exports.sunday.range;
	
	  exports.monday = weekday(1);
	
	  exports.mondays = exports.monday.range;
	
	  exports.tuesday = weekday(2);
	
	  exports.tuesdays = exports.tuesday.range;
	
	  exports.wednesday = weekday(3);
	
	  exports.wednesdays = exports.wednesday.range;
	
	  exports.thursday = weekday(4);
	
	  exports.thursdays = exports.thursday.range;
	
	  exports.friday = weekday(5);
	
	  exports.fridays = exports.friday.range;
	
	  exports.saturday = weekday(6);
	
	  exports.saturdays = exports.saturday.range;
	
	  var week = exports.sunday;
	
	  exports.weeks = week.range;
	
	  var month = newInterval(function(date) {
	    date.setHours(0, 0, 0, 0);
	    date.setDate(1);
	  }, function(date, step) {
	    date.setMonth(date.getMonth() + step);
	  }, function(start, end) {
	    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	  });
	
	  exports.months = month.range;
	
	  var year = newInterval(function(date) {
	    date.setHours(0, 0, 0, 0);
	    date.setMonth(0, 1);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step);
	  }, function(start, end) {
	    return end.getFullYear() - start.getFullYear();
	  });
	
	  exports.years = year.range;
	
	  var utcSecond = newInterval(function(date) {
	    date.setUTCMilliseconds(0);
	  }, function(date, step) {
	    date.setTime(+date + step * 1e3);
	  }, function(start, end) {
	    return (end - start) / 1e3;
	  });
	
	  exports.utcSeconds = utcSecond.range;
	
	  var utcMinute = newInterval(function(date) {
	    date.setUTCSeconds(0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * 6e4);
	  }, function(start, end) {
	    return (end - start) / 6e4;
	  });
	
	  exports.utcMinutes = utcMinute.range;
	
	  var utcHour = newInterval(function(date) {
	    date.setUTCMinutes(0, 0, 0);
	  }, function(date, step) {
	    date.setTime(+date + step * 36e5);
	  }, function(start, end) {
	    return (end - start) / 36e5;
	  });
	
	  exports.utcHours = utcHour.range;
	
	  var utcDay = newInterval(function(date) {
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step);
	  }, function(start, end) {
	    return (end - start) / 864e5;
	  });
	
	  exports.utcDays = utcDay.range;
	
	  function utcWeekday(i) {
	    return newInterval(function(date) {
	      date.setUTCHours(0, 0, 0, 0);
	      date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    }, function(date, step) {
	      date.setUTCDate(date.getUTCDate() + step * 7);
	    }, function(start, end) {
	      return (end - start) / 6048e5;
	    });
	  }
	
	  exports.utcSunday = utcWeekday(0);
	
	  exports.utcSundays = exports.utcSunday.range;
	
	  exports.utcMonday = utcWeekday(1);
	
	  exports.utcMondays = exports.utcMonday.range;
	
	  exports.utcTuesday = utcWeekday(2);
	
	  exports.utcTuesdays = exports.utcTuesday.range;
	
	  exports.utcWednesday = utcWeekday(3);
	
	  exports.utcWednesdays = exports.utcWednesday.range;
	
	  exports.utcThursday = utcWeekday(4);
	
	  exports.utcThursdays = exports.utcThursday.range;
	
	  exports.utcFriday = utcWeekday(5);
	
	  exports.utcFridays = exports.utcFriday.range;
	
	  exports.utcSaturday = utcWeekday(6);
	
	  exports.utcSaturdays = exports.utcSaturday.range;
	
	  var utcWeek = exports.utcSunday;
	
	  exports.utcWeeks = utcWeek.range;
	
	  var utcMonth = newInterval(function(date) {
	    date.setUTCHours(0, 0, 0, 0);
	    date.setUTCDate(1);
	  }, function(date, step) {
	    date.setUTCMonth(date.getUTCMonth() + step);
	  }, function(start, end) {
	    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	  });
	
	  exports.utcMonths = utcMonth.range;
	
	  var utcYear = newInterval(function(date) {
	    date.setUTCHours(0, 0, 0, 0);
	    date.setUTCMonth(0, 1);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step);
	  }, function(start, end) {
	    return end.getUTCFullYear() - start.getUTCFullYear();
	  });
	
	  exports.utcYears = utcYear.range;
	
	  exports.interval = newInterval;
	  exports.second = second;
	  exports.minute = minute;
	  exports.hour = hour;
	  exports.day = day;
	  exports.week = week;
	  exports.month = month;
	  exports.year = year;
	  exports.utcSecond = utcSecond;
	  exports.utcMinute = utcMinute;
	  exports.utcHour = utcHour;
	  exports.utcDay = utcDay;
	  exports.utcWeek = utcWeek;
	  exports.utcMonth = utcMonth;
	  exports.utcYear = utcYear;
	
	}));

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var createStore = __webpack_require__(106)
	var Individual = __webpack_require__(46)
	
	var createHash = __webpack_require__(105)
	
	var hashStore = Individual("__DATA_SET_WEAKMAP@3", createStore())
	
	module.exports = DataSet
	
	function DataSet(elem) {
	    var store = hashStore(elem)
	
	    if (!store.hash) {
	        store.hash = createHash(elem)
	    }
	
	    return store.hash
	}


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var Individual = __webpack_require__(46)
	var cuid = __webpack_require__(104)
	var globalDocument = __webpack_require__(14)
	
	var DOMDelegator = __webpack_require__(109)
	
	var versionKey = "13"
	var cacheKey = "__DOM_DELEGATOR_CACHE@" + versionKey
	var cacheTokenKey = "__DOM_DELEGATOR_CACHE_TOKEN@" + versionKey
	var delegatorCache = Individual(cacheKey, {
	    delegators: {}
	})
	var commonEvents = [
	    "blur", "change", "click",  "contextmenu", "dblclick",
	    "error","focus", "focusin", "focusout", "input", "keydown",
	    "keypress", "keyup", "load", "mousedown", "mouseup",
	    "resize", "select", "submit", "touchcancel",
	    "touchend", "touchstart", "unload"
	]
	
	/*  Delegator is a thin wrapper around a singleton `DOMDelegator`
	        instance.
	
	    Only one DOMDelegator should exist because we do not want
	        duplicate event listeners bound to the DOM.
	
	    `Delegator` will also `listenTo()` all events unless
	        every caller opts out of it
	*/
	module.exports = Delegator
	
	function Delegator(opts) {
	    opts = opts || {}
	    var document = opts.document || globalDocument
	
	    var cacheKey = document[cacheTokenKey]
	
	    if (!cacheKey) {
	        cacheKey =
	            document[cacheTokenKey] = cuid()
	    }
	
	    var delegator = delegatorCache.delegators[cacheKey]
	
	    if (!delegator) {
	        delegator = delegatorCache.delegators[cacheKey] =
	            new DOMDelegator(document)
	    }
	
	    if (opts.defaultEvents !== false) {
	        for (var i = 0; i < commonEvents.length; i++) {
	            delegator.listenTo(commonEvents[i])
	        }
	    }
	
	    return delegator
	}
	
	Delegator.allocateHandle = DOMDelegator.allocateHandle;
	Delegator.transformHandle = DOMDelegator.transformHandle;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var camelize = __webpack_require__(92)
	var template = __webpack_require__(161)
	var extend = __webpack_require__(210)
	
	module.exports = TypedError
	
	function TypedError(args) {
	    if (!args) {
	        throw new Error("args is required");
	    }
	    if (!args.type) {
	        throw new Error("args.type is required");
	    }
	    if (!args.message) {
	        throw new Error("args.message is required");
	    }
	
	    var message = args.message
	
	    if (args.type && !args.name) {
	        var errorName = camelize(args.type) + "Error"
	        args.name = errorName[0].toUpperCase() + errorName.substr(1)
	    }
	
	    extend(createError, args);
	    createError._name = args.name;
	
	    return createError;
	
	    function createError(opts) {
	        var result = new Error()
	
	        Object.defineProperty(result, "type", {
	            value: result.type,
	            enumerable: true,
	            writable: true,
	            configurable: true
	        })
	
	        var options = extend({}, args, opts)
	
	        extend(result, options)
	        result.message = template(message, options)
	
	        return result
	    }
	}
	


/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = Event
	function Event() {
	    var listeners = []
	
	    return { broadcast: broadcast, listen: event }
	
	    function broadcast(value) {
	        var listenersCopy = listeners.slice()
	        for (var i = 0; i < listenersCopy.length; i++) {
	            if (!listenersCopy[i].deleted) {
	                listenersCopy[i].fn(value)
	            }
	        }
	    }
	
	    function event(listener) {
	        listeners.push(new ListItem(listener))
	
	        return removeListener
	
	        function removeListener() {
	            for (var i = 0; i < listeners.length; i++) {
	                if (listeners[i].fn === listener) {
	                    listeners[i].deleted = true
	                    listeners.splice(i, 1)
	                    break
	                }
	            }
	        }
	    }
	}
	
	function ListItem(fn) {
	    this.fn = fn
	    this.deleted = false
	}


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var Event = __webpack_require__(44)
	
	module.exports = Single
	
	function Single() {
	    var tuple = Event()
	
	    return function event(value) {
	        if (typeof value === "function") {
	            return tuple.listen(value)
	        } else {
	            return tuple.broadcast(value)
	        }
	    }
	}


/***/ },
/* 46 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var root = typeof window !== 'undefined' ?
	    window : typeof global !== 'undefined' ?
	    global : {};
	
	module.exports = Individual
	
	function Individual(key, value) {
	    if (root[key]) {
	        return root[key]
	    }
	
	    Object.defineProperty(root, key, {
	        value: value
	        , configurable: true
	    })
	
	    return value
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 47 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function isObject(x) {
		return typeof x === "object" && x !== null;
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var value = __webpack_require__(16);
	var source = __webpack_require__(135);
	var window = __webpack_require__(136);
	var document = __webpack_require__(14);
	var routeMap = __webpack_require__(53);
	
	
	var atom = router.atom = value(String(document.location.href));
	
	function router(channels_map, args) {
	    var inPopState = false;
	    var popstates = popstate();
	
	    popstates(onPopState);
	    atom(onRouteSet);
	
	    return { state: atom };
	
	    function onPopState(uri) {
	        inPopState = true;
	        atom.set(uri);
	    }
	
	    function onRouteSet(uri) {
	        if (inPopState) {
	            inPopState = false;
	            return;
	        }
	
	        if(channels_map){
	          if (args && args.base) {
	              channels_map = Object.keys(channels_map)
	                  .reduce(function applyBase(acc, str) {
	                      acc[args.base + str] = channels_map[str];
	                      return acc;
	                  }, {});
	          }
	
	          var match = routeMap(channels_map);
	
	          var res = match(uri);
	
	          if (res) {
	            res.params.url = res.url;
	            res.fn(res.params);
	          }
	        }
	
	
	        pushHistoryState(uri);
	    }
	}
	
	function pushHistoryState(uri) {
	    window.history.pushState(null, document.title, uri);
	}
	
	function popstate() {
	    return source(function broadcaster(broadcast) {
	        window.addEventListener('popstate', onPopState);
	
	        function onPopState() {
	            broadcast(String(document.location.href));
	        }
	    });
	}
	
	module.exports = router;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var Observ = __webpack_require__(16)
	var extend = __webpack_require__(143)
	
	var blackList = ["name", "_diff", "_type", "_version"]
	var blackListReasons = {
	    "name": "Clashes with `Function.prototype.name`.\n",
	    "_diff": "_diff is reserved key of observ-struct.\n",
	    "_type": "_type is reserved key of observ-struct.\n",
	    "_version": "_version is reserved key of observ-struct.\n"
	}
	var NO_TRANSACTION = {}
	
	function setNonEnumerable(object, key, value) {
	    Object.defineProperty(object, key, {
	        value: value,
	        writable: true,
	        configurable: true,
	        enumerable: false
	    })
	}
	
	/* ObservStruct := (Object<String, Observ<T>>) => 
	    Object<String, Observ<T>> &
	        Observ<Object<String, T> & {
	            _diff: Object<String, Any>
	        }>
	
	*/
	module.exports = ObservStruct
	
	function ObservStruct(struct) {
	    var keys = Object.keys(struct)
	
	    var initialState = {}
	    var currentTransaction = NO_TRANSACTION
	    var nestedTransaction = NO_TRANSACTION
	
	    keys.forEach(function (key) {
	        if (blackList.indexOf(key) !== -1) {
	            throw new Error("cannot create an observ-struct " +
	                "with a key named '" + key + "'.\n" +
	                blackListReasons[key]);
	        }
	
	        var observ = struct[key]
	        initialState[key] = typeof observ === "function" ?
	            observ() : observ
	    })
	
	    var obs = Observ(initialState)
	    keys.forEach(function (key) {
	        var observ = struct[key]
	        obs[key] = observ
	
	        if (typeof observ === "function") {
	            observ(function (value) {
	                if (nestedTransaction === value) {
	                    return
	                }
	
	                var state = extend(obs())
	                state[key] = value
	                var diff = {}
	                diff[key] = value && value._diff ?
	                    value._diff : value
	
	                setNonEnumerable(state, "_diff", diff)
	                currentTransaction = state
	                obs.set(state)
	                currentTransaction = NO_TRANSACTION
	            })
	        }
	    })
	    var _set = obs.set
	    obs.set = function trackDiff(value) {
	        if (currentTransaction === value) {
	            return _set(value)
	        }
	
	        var newState = extend(value)
	        setNonEnumerable(newState, "_diff", value)
	        _set(newState)
	    }
	
	    obs(function (newState) {
	        if (currentTransaction === newState) {
	            return
	        }
	
	        keys.forEach(function (key) {
	            var observ = struct[key]
	            var newObservValue = newState[key]
	
	            if (typeof observ === "function" &&
	                observ() !== newObservValue
	            ) {
	                nestedTransaction = newObservValue
	                observ.set(newState[key])
	                nestedTransaction = NO_TRANSACTION
	            }
	        })
	    })
	
	    obs._type = "observ-struct"
	    obs._version = "5"
	
	    return obs
	}


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(192);


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var Observ = __webpack_require__(16)
	
	// circular dep between ArrayMethods & this file
	module.exports = ObservArray
	
	var splice = __webpack_require__(149)
	var put = __webpack_require__(147)
	var set = __webpack_require__(148)
	var transaction = __webpack_require__(150)
	var ArrayMethods = __webpack_require__(144)
	var addListener = __webpack_require__(21)
	
	
	/*  ObservArray := (Array<T>) => Observ<
	        Array<T> & { _diff: Array }
	    > & {
	        splice: (index: Number, amount: Number, rest...: T) =>
	            Array<T>,
	        push: (values...: T) => Number,
	        filter: (lambda: Function, thisValue: Any) => Array<T>,
	        indexOf: (item: T, fromIndex: Number) => Number
	    }
	
	    Fix to make it more like ObservHash.
	
	    I.e. you write observables into it.
	        reading methods take plain JS objects to read
	        and the value of the array is always an array of plain
	        objsect.
	
	        The observ array instance itself would have indexed
	        properties that are the observables
	*/
	function ObservArray(initialList) {
	    // list is the internal mutable list observ instances that
	    // all methods on `obs` dispatch to.
	    var list = initialList
	    var initialState = []
	
	    // copy state out of initialList into initialState
	    list.forEach(function (observ, index) {
	        initialState[index] = typeof observ === "function" ?
	            observ() : observ
	    })
	
	    var obs = Observ(initialState)
	    obs.splice = splice
	
	    // override set and store original for later use
	    obs._observSet = obs.set
	    obs.set = set
	
	    obs.get = get
	    obs.getLength = getLength
	    obs.put = put
	    obs.transaction = transaction
	
	    // you better not mutate this list directly
	    // this is the list of observs instances
	    obs._list = list
	
	    var removeListeners = list.map(function (observ) {
	        return typeof observ === "function" ?
	            addListener(obs, observ) :
	            null
	    });
	    // this is a list of removal functions that must be called
	    // when observ instances are removed from `obs.list`
	    // not calling this means we do not GC our observ change
	    // listeners. Which causes rage bugs
	    obs._removeListeners = removeListeners
	
	    obs._type = "observ-array"
	    obs._version = "3"
	
	    return ArrayMethods(obs, list)
	}
	
	function get(index) {
	    return this._list[index]
	}
	
	function getLength() {
	    return this._list.length
	}


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('queue', factory) :
	  (global.queue = factory());
	}(this, function () { 'use strict';
	
	  var slice = [].slice;
	
	  function noop() {}
	
	  var noabort = {};
	  var success = [null];
	  function newQueue(concurrency) {
	    if (!(concurrency >= 1)) throw new Error;
	
	    var q,
	        tasks = [],
	        results = [],
	        waiting = 0,
	        active = 0,
	        ended = 0,
	        starting, // inside a synchronous task callback?
	        error,
	        callback = noop,
	        callbackAll = true;
	
	    function start() {
	      if (starting) return; // let the current task complete
	      while (starting = waiting && active < concurrency) {
	        var i = ended + active,
	            t = tasks[i],
	            j = t.length - 1,
	            c = t[j];
	        t[j] = end(i);
	        --waiting, ++active, tasks[i] = c.apply(null, t) || noabort;
	      }
	    }
	
	    function end(i) {
	      return function(e, r) {
	        if (!tasks[i]) throw new Error; // detect multiple callbacks
	        --active, ++ended, tasks[i] = null;
	        if (error != null) return; // only report the first error
	        if (e != null) {
	          abort(e);
	        } else {
	          results[i] = r;
	          if (waiting) start();
	          else if (!active) notify();
	        }
	      };
	    }
	
	    function abort(e) {
	      error = e; // ignore new tasks and squelch active callbacks
	      waiting = NaN; // stop queued tasks from starting
	      notify();
	    }
	
	    function notify() {
	      if (error != null) callback(error);
	      else if (callbackAll) callback(null, results);
	      else callback.apply(null, success.concat(results));
	    }
	
	    return q = {
	      defer: function(f) {
	        if (callback !== noop) throw new Error;
	        var t = slice.call(arguments, 1);
	        t.push(f);
	        ++waiting, tasks.push(t);
	        start();
	        return q;
	      },
	      abort: function() {
	        if (error == null) {
	          var i = ended + active, t;
	          while (--i >= 0) (t = tasks[i]) && t.abort && t.abort();
	          abort(new Error("abort"));
	        }
	        return q;
	      },
	      await: function(f) {
	        if (callback !== noop) throw new Error;
	        callback = f, callbackAll = false;
	        if (!waiting && !active) notify();
	        return q;
	      },
	      awaitAll: function(f) {
	        if (callback !== noop) throw new Error;
	        callback = f, callbackAll = true;
	        if (!waiting && !active) notify();
	        return q;
	      }
	    };
	  }
	
	  function queue(concurrency) {
	    return newQueue(arguments.length ? +concurrency : Infinity);
	  }
	
	  queue.version = "1.2.1";
	
	  return queue;
	
	}));

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var parseUrl = __webpack_require__(173).parse;
	var parseQS = __webpack_require__(32).parse;
	var pathToRegexp = __webpack_require__(155);
	
	module.exports = routeMap;
	
	function routeMap (routes) {
	  var map = {};
	
	  var pattern, keys;
	  for (pattern in routes) {
	    keys = [];
	    map[pattern] = {
	      keys: keys,
	      exp: pathToRegexp(pattern, keys)
	    };
	  }
	
	  return match;
	
	  function match (fullUrl) {
	    var url = parseUrl(fullUrl);
	    var result = {
	      url: fullUrl,
	      hash: url.hash,
	      qs: url.query,
	      params: {},
	      keys: keys
	    };
	
	    var pattern, match, i;
	    for (pattern in map) {
	      match = url.pathname.match(map[pattern].exp);
	
	      if (!match) continue;
	
	      result.pattern = pattern;
	      result.fn = routes[pattern];
	      result.keys = map[pattern].keys;
	
	      if (result.qs) {
	        result.qs = parseQS(result.qs);
	      }
	
	      i = map[pattern].keys.length;
	      while (i--) {
	        result.params[ map[pattern].keys[i].name ] = match[i+1];
	      }
	
	      return result;
	    }
	
	}
	
	}


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(98);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./chart.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./chart.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(33)
	var getFormData = __webpack_require__(29)
	
	var BaseEvent = __webpack_require__(12)
	
	var VALID_CHANGE = ['checkbox', 'file', 'select-multiple', 'select-one'];
	var VALID_INPUT = ['color', 'date', 'datetime', 'datetime-local', 'email',
	    'month', 'number', 'password', 'range', 'search', 'tel', 'text', 'time',
	    'url', 'week', 'textarea'];
	
	module.exports = BaseEvent(changeLambda);
	
	function changeLambda(ev, broadcast) {
	    var target = ev.target
	
	    var isValid =
	        (ev.type === 'input' && VALID_INPUT.indexOf(target.type) !== -1) ||
	        (ev.type === 'change' && VALID_CHANGE.indexOf(target.type) !== -1);
	
	    if (!isValid) {
	        if (ev.startPropagation) {
	            ev.startPropagation()
	        }
	        return
	    }
	
	    var value = getFormData(ev.currentTarget)
	    var data = extend(value, this.data)
	
	    broadcast(data)
	}


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var BaseEvent = __webpack_require__(12);
	
	module.exports = BaseEvent(clickLambda);
	
	function clickLambda(ev, broadcast) {
	    var opts = this.opts;
	
	    if (!opts.ctrl && ev.ctrlKey) {
	        return;
	    }
	
	    if (!opts.meta && ev.metaKey) {
	        return;
	    }
	
	    if (!opts.rightClick && ev.which === 2) {
	        return;
	    }
	
	    if (this.opts.preventDefault && ev.preventDefault) {
	        ev.preventDefault();
	    }
	
	    broadcast(this.data);
	}


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var BaseEvent = __webpack_require__(12);
	
	module.exports = BaseEvent(eventLambda);
	
	function eventLambda(ev, broadcast) {
	    broadcast(this.data);
	}


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var BaseEvent = __webpack_require__(12);
	
	module.exports = BaseEvent(keyLambda);
	
	function keyLambda(ev, broadcast) {
	    var key = this.opts.key;
	
	    if (ev.keyCode === key) {
	        if (this.opts.preventDefault && ev.preventDefault) {
	            ev.preventDefault();
	        }
	
	        broadcast(this.data);
	    }
	}


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(33)
	var getFormData = __webpack_require__(29)
	
	var BaseEvent = __webpack_require__(12);
	
	var ENTER = 13
	
	module.exports = BaseEvent(submitLambda);
	
	function submitLambda(ev, broadcast) {
	    var target = ev.target
	
	    var isValid =
	        (ev.type === 'submit' && target.tagName === 'FORM') ||
	        (ev.type === 'click' && target.tagName === 'BUTTON') ||
	        (ev.type === 'click' && target.type === 'submit') ||
	        (
	            (target.type === 'text') &&
	            (ev.keyCode === ENTER && ev.type === 'keydown')
	        )
	
	    if (!isValid) {
	        if (ev.startPropagation) {
	            ev.startPropagation()
	        }
	        return
	    }
	
	    var value = getFormData(ev.currentTarget)
	    var data = extend(value, this.data)
	
	    if (ev.preventDefault) {
	        ev.preventDefault();
	    }
	
	    broadcast(data);
	}


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(33)
	var getFormData = __webpack_require__(29)
	
	var BaseEvent = __webpack_require__(12);
	
	module.exports = BaseEvent(valueLambda);
	
	function valueLambda(ev, broadcast) {
	    var value = getFormData(ev.currentTarget)
	    var data = extend(value, this.data)
	
	    broadcast(data);
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47)
	var isHook = __webpack_require__(24)
	
	module.exports = applyProperties
	
	function applyProperties(node, props, previous) {
	    for (var propName in props) {
	        var propValue = props[propName]
	
	        if (propValue === undefined) {
	            removeProperty(node, propName, propValue, previous);
	        } else if (isHook(propValue)) {
	            removeProperty(node, propName, propValue, previous)
	            if (propValue.hook) {
	                propValue.hook(node,
	                    propName,
	                    previous ? previous[propName] : undefined)
	            }
	        } else {
	            if (isObject(propValue)) {
	                patchObject(node, props, previous, propName, propValue);
	            } else {
	                node[propName] = propValue
	            }
	        }
	    }
	}
	
	function removeProperty(node, propName, propValue, previous) {
	    if (previous) {
	        var previousValue = previous[propName]
	
	        if (!isHook(previousValue)) {
	            if (propName === "attributes") {
	                for (var attrName in previousValue) {
	                    node.removeAttribute(attrName)
	                }
	            } else if (propName === "style") {
	                for (var i in previousValue) {
	                    node.style[i] = ""
	                }
	            } else if (typeof previousValue === "string") {
	                node[propName] = ""
	            } else {
	                node[propName] = null
	            }
	        } else if (previousValue.unhook) {
	            previousValue.unhook(node, propName, propValue)
	        }
	    }
	}
	
	function patchObject(node, props, previous, propName, propValue) {
	    var previousValue = previous ? previous[propName] : undefined
	
	    // Set attributes
	    if (propName === "attributes") {
	        for (var attrName in propValue) {
	            var attrValue = propValue[attrName]
	
	            if (attrValue === undefined) {
	                node.removeAttribute(attrName)
	            } else {
	                node.setAttribute(attrName, attrValue)
	            }
	        }
	
	        return
	    }
	
	    if(previousValue && isObject(previousValue) &&
	        getPrototype(previousValue) !== getPrototype(propValue)) {
	        node[propName] = propValue
	        return
	    }
	
	    if (!isObject(node[propName])) {
	        node[propName] = {}
	    }
	
	    var replacer = propName === "style" ? "" : undefined
	
	    for (var k in propValue) {
	        var value = propValue[k]
	        node[propName][k] = (value === undefined) ? replacer : value
	    }
	}
	
	function getPrototype(value) {
	    if (Object.getPrototypeOf) {
	        return Object.getPrototypeOf(value)
	    } else if (value.__proto__) {
	        return value.__proto__
	    } else if (value.constructor) {
	        return value.constructor.prototype
	    }
	}


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(14)
	var isArray = __webpack_require__(27)
	
	var render = __webpack_require__(34)
	var domIndex = __webpack_require__(184)
	var patchOp = __webpack_require__(185)
	module.exports = patch
	
	function patch(rootNode, patches, renderOptions) {
	    renderOptions = renderOptions || {}
	    renderOptions.patch = renderOptions.patch && renderOptions.patch !== patch
	        ? renderOptions.patch
	        : patchRecursive
	    renderOptions.render = renderOptions.render || render
	
	    return renderOptions.patch(rootNode, patches, renderOptions)
	}
	
	function patchRecursive(rootNode, patches, renderOptions) {
	    var indices = patchIndices(patches)
	
	    if (indices.length === 0) {
	        return rootNode
	    }
	
	    var index = domIndex(rootNode, patches.a, indices)
	    var ownerDocument = rootNode.ownerDocument
	
	    if (!renderOptions.document && ownerDocument !== document) {
	        renderOptions.document = ownerDocument
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	        var nodeIndex = indices[i]
	        rootNode = applyPatch(rootNode,
	            index[nodeIndex],
	            patches[nodeIndex],
	            renderOptions)
	    }
	
	    return rootNode
	}
	
	function applyPatch(rootNode, domNode, patchList, renderOptions) {
	    if (!domNode) {
	        return rootNode
	    }
	
	    var newNode
	
	    if (isArray(patchList)) {
	        for (var i = 0; i < patchList.length; i++) {
	            newNode = patchOp(patchList[i], domNode, renderOptions)
	
	            if (domNode === rootNode) {
	                rootNode = newNode
	            }
	        }
	    } else {
	        newNode = patchOp(patchList, domNode, renderOptions)
	
	        if (domNode === rootNode) {
	            rootNode = newNode
	        }
	    }
	
	    return rootNode
	}
	
	function patchIndices(patches) {
	    var indices = []
	
	    for (var key in patches) {
	        if (key !== "a") {
	            indices.push(Number(key))
	        }
	    }
	
	    return indices
	}


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var isVNode = __webpack_require__(17)
	var isVText = __webpack_require__(25)
	var isWidget = __webpack_require__(13)
	var isThunk = __webpack_require__(23)
	
	module.exports = handleThunk
	
	function handleThunk(a, b) {
	    var renderedA = a
	    var renderedB = b
	
	    if (isThunk(b)) {
	        renderedB = renderThunk(b, a)
	    }
	
	    if (isThunk(a)) {
	        renderedA = renderThunk(a, null)
	    }
	
	    return {
	        a: renderedA,
	        b: renderedB
	    }
	}
	
	function renderThunk(thunk, previous) {
	    var renderedThunk = thunk.vnode
	
	    if (!renderedThunk) {
	        renderedThunk = thunk.vnode = thunk.render(previous)
	    }
	
	    if (!(isVNode(renderedThunk) ||
	            isVText(renderedThunk) ||
	            isWidget(renderedThunk))) {
	        throw new Error("thunk did not return a valid node");
	    }
	
	    return renderedThunk
	}


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(18)
	var isVNode = __webpack_require__(17)
	var isWidget = __webpack_require__(13)
	var isThunk = __webpack_require__(23)
	var isVHook = __webpack_require__(24)
	
	module.exports = VirtualNode
	
	var noProperties = {}
	var noChildren = []
	
	function VirtualNode(tagName, properties, children, key, namespace) {
	    this.tagName = tagName
	    this.properties = properties || noProperties
	    this.children = children || noChildren
	    this.key = key != null ? String(key) : undefined
	    this.namespace = (typeof namespace === "string") ? namespace : null
	
	    var count = (children && children.length) || 0
	    var descendants = 0
	    var hasWidgets = false
	    var hasThunks = false
	    var descendantHooks = false
	    var hooks
	
	    for (var propName in properties) {
	        if (properties.hasOwnProperty(propName)) {
	            var property = properties[propName]
	            if (isVHook(property) && property.unhook) {
	                if (!hooks) {
	                    hooks = {}
	                }
	
	                hooks[propName] = property
	            }
	        }
	    }
	
	    for (var i = 0; i < count; i++) {
	        var child = children[i]
	        if (isVNode(child)) {
	            descendants += child.count || 0
	
	            if (!hasWidgets && child.hasWidgets) {
	                hasWidgets = true
	            }
	
	            if (!hasThunks && child.hasThunks) {
	                hasThunks = true
	            }
	
	            if (!descendantHooks && (child.hooks || child.descendantHooks)) {
	                descendantHooks = true
	            }
	        } else if (!hasWidgets && isWidget(child)) {
	            if (typeof child.destroy === "function") {
	                hasWidgets = true
	            }
	        } else if (!hasThunks && isThunk(child)) {
	            hasThunks = true;
	        }
	    }
	
	    this.count = count + descendants
	    this.hasWidgets = hasWidgets
	    this.hasThunks = hasThunks
	    this.hooks = hooks
	    this.descendantHooks = descendantHooks
	}
	
	VirtualNode.prototype.version = version
	VirtualNode.prototype.type = "VirtualNode"


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(18)
	
	VirtualPatch.NONE = 0
	VirtualPatch.VTEXT = 1
	VirtualPatch.VNODE = 2
	VirtualPatch.WIDGET = 3
	VirtualPatch.PROPS = 4
	VirtualPatch.ORDER = 5
	VirtualPatch.INSERT = 6
	VirtualPatch.REMOVE = 7
	VirtualPatch.THUNK = 8
	
	module.exports = VirtualPatch
	
	function VirtualPatch(type, vNode, patch) {
	    this.type = Number(type)
	    this.vNode = vNode
	    this.patch = patch
	}
	
	VirtualPatch.prototype.version = version
	VirtualPatch.prototype.type = "VirtualPatch"


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(18)
	
	module.exports = VirtualText
	
	function VirtualText(text) {
	    this.text = String(text)
	}
	
	VirtualText.prototype.version = version
	VirtualText.prototype.type = "VirtualText"


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27)
	
	var VPatch = __webpack_require__(65)
	var isVNode = __webpack_require__(17)
	var isVText = __webpack_require__(25)
	var isWidget = __webpack_require__(13)
	var isThunk = __webpack_require__(23)
	var handleThunk = __webpack_require__(63)
	
	var diffProps = __webpack_require__(193)
	
	module.exports = diff
	
	function diff(a, b) {
	    var patch = { a: a }
	    walk(a, b, patch, 0)
	    return patch
	}
	
	function walk(a, b, patch, index) {
	    if (a === b) {
	        return
	    }
	
	    var apply = patch[index]
	    var applyClear = false
	
	    if (isThunk(a) || isThunk(b)) {
	        thunks(a, b, patch, index)
	    } else if (b == null) {
	
	        // If a is a widget we will add a remove patch for it
	        // Otherwise any child widgets/hooks must be destroyed.
	        // This prevents adding two remove patches for a widget.
	        if (!isWidget(a)) {
	            clearState(a, patch, index)
	            apply = patch[index]
	        }
	
	        apply = appendPatch(apply, new VPatch(VPatch.REMOVE, a, b))
	    } else if (isVNode(b)) {
	        if (isVNode(a)) {
	            if (a.tagName === b.tagName &&
	                a.namespace === b.namespace &&
	                a.key === b.key) {
	                var propsPatch = diffProps(a.properties, b.properties)
	                if (propsPatch) {
	                    apply = appendPatch(apply,
	                        new VPatch(VPatch.PROPS, a, propsPatch))
	                }
	                apply = diffChildren(a, b, patch, apply, index)
	            } else {
	                apply = appendPatch(apply, new VPatch(VPatch.VNODE, a, b))
	                applyClear = true
	            }
	        } else {
	            apply = appendPatch(apply, new VPatch(VPatch.VNODE, a, b))
	            applyClear = true
	        }
	    } else if (isVText(b)) {
	        if (!isVText(a)) {
	            apply = appendPatch(apply, new VPatch(VPatch.VTEXT, a, b))
	            applyClear = true
	        } else if (a.text !== b.text) {
	            apply = appendPatch(apply, new VPatch(VPatch.VTEXT, a, b))
	        }
	    } else if (isWidget(b)) {
	        if (!isWidget(a)) {
	            applyClear = true
	        }
	
	        apply = appendPatch(apply, new VPatch(VPatch.WIDGET, a, b))
	    }
	
	    if (apply) {
	        patch[index] = apply
	    }
	
	    if (applyClear) {
	        clearState(a, patch, index)
	    }
	}
	
	function diffChildren(a, b, patch, apply, index) {
	    var aChildren = a.children
	    var orderedSet = reorder(aChildren, b.children)
	    var bChildren = orderedSet.children
	
	    var aLen = aChildren.length
	    var bLen = bChildren.length
	    var len = aLen > bLen ? aLen : bLen
	
	    for (var i = 0; i < len; i++) {
	        var leftNode = aChildren[i]
	        var rightNode = bChildren[i]
	        index += 1
	
	        if (!leftNode) {
	            if (rightNode) {
	                // Excess nodes in b need to be added
	                apply = appendPatch(apply,
	                    new VPatch(VPatch.INSERT, null, rightNode))
	            }
	        } else {
	            walk(leftNode, rightNode, patch, index)
	        }
	
	        if (isVNode(leftNode) && leftNode.count) {
	            index += leftNode.count
	        }
	    }
	
	    if (orderedSet.moves) {
	        // Reorder nodes last
	        apply = appendPatch(apply, new VPatch(
	            VPatch.ORDER,
	            a,
	            orderedSet.moves
	        ))
	    }
	
	    return apply
	}
	
	function clearState(vNode, patch, index) {
	    // TODO: Make this a single walk, not two
	    unhook(vNode, patch, index)
	    destroyWidgets(vNode, patch, index)
	}
	
	// Patch records for all destroyed widgets must be added because we need
	// a DOM node reference for the destroy function
	function destroyWidgets(vNode, patch, index) {
	    if (isWidget(vNode)) {
	        if (typeof vNode.destroy === "function") {
	            patch[index] = appendPatch(
	                patch[index],
	                new VPatch(VPatch.REMOVE, vNode, null)
	            )
	        }
	    } else if (isVNode(vNode) && (vNode.hasWidgets || vNode.hasThunks)) {
	        var children = vNode.children
	        var len = children.length
	        for (var i = 0; i < len; i++) {
	            var child = children[i]
	            index += 1
	
	            destroyWidgets(child, patch, index)
	
	            if (isVNode(child) && child.count) {
	                index += child.count
	            }
	        }
	    } else if (isThunk(vNode)) {
	        thunks(vNode, null, patch, index)
	    }
	}
	
	// Create a sub-patch for thunks
	function thunks(a, b, patch, index) {
	    var nodes = handleThunk(a, b)
	    var thunkPatch = diff(nodes.a, nodes.b)
	    if (hasPatches(thunkPatch)) {
	        patch[index] = new VPatch(VPatch.THUNK, null, thunkPatch)
	    }
	}
	
	function hasPatches(patch) {
	    for (var index in patch) {
	        if (index !== "a") {
	            return true
	        }
	    }
	
	    return false
	}
	
	// Execute hooks when two nodes are identical
	function unhook(vNode, patch, index) {
	    if (isVNode(vNode)) {
	        if (vNode.hooks) {
	            patch[index] = appendPatch(
	                patch[index],
	                new VPatch(
	                    VPatch.PROPS,
	                    vNode,
	                    undefinedKeys(vNode.hooks)
	                )
	            )
	        }
	
	        if (vNode.descendantHooks || vNode.hasThunks) {
	            var children = vNode.children
	            var len = children.length
	            for (var i = 0; i < len; i++) {
	                var child = children[i]
	                index += 1
	
	                unhook(child, patch, index)
	
	                if (isVNode(child) && child.count) {
	                    index += child.count
	                }
	            }
	        }
	    } else if (isThunk(vNode)) {
	        thunks(vNode, null, patch, index)
	    }
	}
	
	function undefinedKeys(obj) {
	    var result = {}
	
	    for (var key in obj) {
	        result[key] = undefined
	    }
	
	    return result
	}
	
	// List diff, naive left to right reordering
	function reorder(aChildren, bChildren) {
	    // O(M) time, O(M) memory
	    var bChildIndex = keyIndex(bChildren)
	    var bKeys = bChildIndex.keys
	    var bFree = bChildIndex.free
	
	    if (bFree.length === bChildren.length) {
	        return {
	            children: bChildren,
	            moves: null
	        }
	    }
	
	    // O(N) time, O(N) memory
	    var aChildIndex = keyIndex(aChildren)
	    var aKeys = aChildIndex.keys
	    var aFree = aChildIndex.free
	
	    if (aFree.length === aChildren.length) {
	        return {
	            children: bChildren,
	            moves: null
	        }
	    }
	
	    // O(MAX(N, M)) memory
	    var newChildren = []
	
	    var freeIndex = 0
	    var freeCount = bFree.length
	    var deletedItems = 0
	
	    // Iterate through a and match a node in b
	    // O(N) time,
	    for (var i = 0 ; i < aChildren.length; i++) {
	        var aItem = aChildren[i]
	        var itemIndex
	
	        if (aItem.key) {
	            if (bKeys.hasOwnProperty(aItem.key)) {
	                // Match up the old keys
	                itemIndex = bKeys[aItem.key]
	                newChildren.push(bChildren[itemIndex])
	
	            } else {
	                // Remove old keyed items
	                itemIndex = i - deletedItems++
	                newChildren.push(null)
	            }
	        } else {
	            // Match the item in a with the next free item in b
	            if (freeIndex < freeCount) {
	                itemIndex = bFree[freeIndex++]
	                newChildren.push(bChildren[itemIndex])
	            } else {
	                // There are no free items in b to match with
	                // the free items in a, so the extra free nodes
	                // are deleted.
	                itemIndex = i - deletedItems++
	                newChildren.push(null)
	            }
	        }
	    }
	
	    var lastFreeIndex = freeIndex >= bFree.length ?
	        bChildren.length :
	        bFree[freeIndex]
	
	    // Iterate through b and append any new keys
	    // O(M) time
	    for (var j = 0; j < bChildren.length; j++) {
	        var newItem = bChildren[j]
	
	        if (newItem.key) {
	            if (!aKeys.hasOwnProperty(newItem.key)) {
	                // Add any new keyed items
	                // We are adding new items to the end and then sorting them
	                // in place. In future we should insert new items in place.
	                newChildren.push(newItem)
	            }
	        } else if (j >= lastFreeIndex) {
	            // Add any leftover non-keyed items
	            newChildren.push(newItem)
	        }
	    }
	
	    var simulate = newChildren.slice()
	    var simulateIndex = 0
	    var removes = []
	    var inserts = []
	    var simulateItem
	
	    for (var k = 0; k < bChildren.length;) {
	        var wantedItem = bChildren[k]
	        simulateItem = simulate[simulateIndex]
	
	        // remove items
	        while (simulateItem === null && simulate.length) {
	            removes.push(remove(simulate, simulateIndex, null))
	            simulateItem = simulate[simulateIndex]
	        }
	
	        if (!simulateItem || simulateItem.key !== wantedItem.key) {
	            // if we need a key in this position...
	            if (wantedItem.key) {
	                if (simulateItem && simulateItem.key) {
	                    // if an insert doesn't put this key in place, it needs to move
	                    if (bKeys[simulateItem.key] !== k + 1) {
	                        removes.push(remove(simulate, simulateIndex, simulateItem.key))
	                        simulateItem = simulate[simulateIndex]
	                        // if the remove didn't put the wanted item in place, we need to insert it
	                        if (!simulateItem || simulateItem.key !== wantedItem.key) {
	                            inserts.push({key: wantedItem.key, to: k})
	                        }
	                        // items are matching, so skip ahead
	                        else {
	                            simulateIndex++
	                        }
	                    }
	                    else {
	                        inserts.push({key: wantedItem.key, to: k})
	                    }
	                }
	                else {
	                    inserts.push({key: wantedItem.key, to: k})
	                }
	                k++
	            }
	            // a key in simulate has no matching wanted key, remove it
	            else if (simulateItem && simulateItem.key) {
	                removes.push(remove(simulate, simulateIndex, simulateItem.key))
	            }
	        }
	        else {
	            simulateIndex++
	            k++
	        }
	    }
	
	    // remove all the remaining nodes from simulate
	    while(simulateIndex < simulate.length) {
	        simulateItem = simulate[simulateIndex]
	        removes.push(remove(simulate, simulateIndex, simulateItem && simulateItem.key))
	    }
	
	    // If the only moves we have are deletes then we can just
	    // let the delete patch remove these items.
	    if (removes.length === deletedItems && !inserts.length) {
	        return {
	            children: newChildren,
	            moves: null
	        }
	    }
	
	    return {
	        children: newChildren,
	        moves: {
	            removes: removes,
	            inserts: inserts
	        }
	    }
	}
	
	function remove(arr, index, key) {
	    arr.splice(index, 1)
	
	    return {
	        from: index,
	        key: key
	    }
	}
	
	function keyIndex(children) {
	    var keys = {}
	    var free = []
	    var length = children.length
	
	    for (var i = 0; i < length; i++) {
	        var child = children[i]
	
	        if (child.key) {
	            keys[child.key] = i
	        } else {
	            free.push(i)
	        }
	    }
	
	    return {
	        keys: keys,     // A hash of key name to index
	        free: free      // An array of unkeyed item indices
	    }
	}
	
	function appendPatch(apply, patch) {
	    if (apply) {
	        if (isArray(apply)) {
	            apply.push(patch)
	        } else {
	            apply = [apply, patch]
	        }
	
	        return apply
	    } else {
	        return patch
	    }
	}


/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = isHook
	
	function isHook(hook) {
	    return hook && typeof hook.hook === "function" &&
	        !hook.hasOwnProperty("hook")
	}


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(26)
	
	module.exports = isVirtualNode
	
	function isVirtualNode(x) {
	    return x && x.type === "VirtualNode" && x.version === version
	}


/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = isWidget
	
	function isWidget(w) {
	    return w && w.type === "Widget"
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var h = __webpack_require__(197)
	
	var BLACKLISTED_KEYS = {
	    "style": true,
	    "namespace": true,
	    "key": true
	}
	var SVG_NAMESPACE = "http://www.w3.org/2000/svg"
	
	module.exports = svg
	
	function svg(tagName, properties, children) {
	    if (!children && isChildren(properties)) {
	        children = properties
	        properties = {}
	    }
	
	    properties = properties || {}
	
	    // set namespace for svg
	    properties.namespace = SVG_NAMESPACE
	
	    var attributes = properties.attributes || (properties.attributes = {})
	
	    // for each key, if attribute & string, bool or number then
	    // convert it into a setAttribute hook
	    for (var key in properties) {
	        if (!properties.hasOwnProperty(key)) {
	            continue
	        }
	
	        if (BLACKLISTED_KEYS[key]) {
	            continue
	        }
	
	        var value = properties[key]
	        if (typeof value !== "string" &&
	            typeof value !== "number" &&
	            typeof value !== "boolean"
	        ) {
	            continue
	        }
	
	        attributes[key] = value
	    }
	
	    return h(tagName, properties, children)
	}
	
	function isChildren(x) {
	    return typeof x === "string" || Array.isArray(x)
	}


/***/ },
/* 72 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 73 */
/***/ function(module, exports) {

	function head (a) {
	  return a[0]
	}
	
	function last (a) {
	  return a[a.length - 1]
	}
	
	function tail(a) {
	  return a.slice(1)
	}
	
	function retreat (e) {
	  return e.pop()
	}
	
	function hasLength (e) {
	  return e.length
	}
	
	function any(ary, test) {
	  for(var i=0;i<ary.length;i++)
	    if(test(ary[i]))
	      return true
	  return false
	}
	
	function score (a) {
	  return a.reduce(function (s, a) {
	      return s + a.length + a[1] + 1
	  }, 0)
	}
	
	function best (a, b) {
	  return score(a) <= score(b) ? a : b
	}
	
	
	var _rules // set at the bottom  
	
	// note, naive implementation. will break on circular objects.
	
	function _equal(a, b) {
	  if(a && !b) return false
	  if(Array.isArray(a))
	    if(a.length != b.length) return false
	  if(a && 'object' == typeof a) {
	    for(var i in a)
	      if(!_equal(a[i], b[i])) return false
	    for(var i in b)
	      if(!_equal(a[i], b[i])) return false
	    return true
	  }
	  return a == b
	}
	
	function getArgs(args) {
	  return args.length == 1 ? args[0] : [].slice.call(args)
	}
	
	// return the index of the element not like the others, or -1
	function oddElement(ary, cmp) {
	  var c
	  function guess(a) {
	    var odd = -1
	    c = 0
	    for (var i = a; i < ary.length; i ++) {
	      if(!cmp(ary[a], ary[i])) {
	        odd = i, c++
	      }
	    }
	    return c > 1 ? -1 : odd
	  }
	  //assume that it is the first element.
	  var g = guess(0)
	  if(-1 != g) return g
	  //0 was the odd one, then all the other elements are equal
	  //else there more than one different element
	  guess(1)
	  return c == 0 ? 0 : -1
	}
	var exports = module.exports = function (deps, exports) {
	  var equal = (deps && deps.equal) || _equal
	  exports = exports || {} 
	  exports.lcs = 
	  function lcs() {
	    var cache = {}
	    var args = getArgs(arguments)
	    var a = args[0], b = args[1]
	
	    function key (a,b){
	      return a.length + ':' + b.length
	    }
	
	    //find length that matches at the head
	
	    if(args.length > 2) {
	      //if called with multiple sequences
	      //recurse, since lcs(a, b, c, d) == lcs(lcs(a,b), lcs(c,d))
	      args.push(lcs(args.shift(), args.shift()))
	      return lcs(args)
	    }
	    
	    //this would be improved by truncating input first
	    //and not returning an lcs as an intermediate step.
	    //untill that is a performance problem.
	
	    var start = 0, end = 0
	    for(var i = 0; i < a.length && i < b.length 
	      && equal(a[i], b[i])
	      ; i ++
	    )
	      start = i + 1
	
	    if(a.length === start)
	      return a.slice()
	
	    for(var i = 0;  i < a.length - start && i < b.length - start
	      && equal(a[a.length - 1 - i], b[b.length - 1 - i])
	      ; i ++
	    )
	      end = i
	
	    function recurse (a, b) {
	      if(!a.length || !b.length) return []
	      //avoid exponential time by caching the results
	      if(cache[key(a, b)]) return cache[key(a, b)]
	
	      if(equal(a[0], b[0]))
	        return [head(a)].concat(recurse(tail(a), tail(b)))
	      else { 
	        var _a = recurse(tail(a), b)
	        var _b = recurse(a, tail(b))
	        return cache[key(a,b)] = _a.length > _b.length ? _a : _b  
	      }
	    }
	    
	    var middleA = a.slice(start, a.length - end)
	    var middleB = b.slice(start, b.length - end)
	
	    return (
	      a.slice(0, start).concat(
	        recurse(middleA, middleB)
	      ).concat(a.slice(a.length - end))
	    )
	  }
	
	  // given n sequences, calc the lcs, and then chunk strings into stable and unstable sections.
	  // unstable chunks are passed to build
	  exports.chunk =
	  function (q, build) {
	    var q = q.map(function (e) { return e.slice() })
	    var lcs = exports.lcs.apply(null, q)
	    var all = [lcs].concat(q)
	
	    function matchLcs (e) {
	      if(e.length && !lcs.length || !e.length && lcs.length)
	        return false //incase the last item is null
	      return equal(last(e), last(lcs)) || ((e.length + lcs.length) === 0)
	    }
	
	    while(any(q, hasLength)) {
	      //if each element is at the lcs then this chunk is stable.
	      while(q.every(matchLcs) && q.every(hasLength))
	        all.forEach(retreat)
	      //collect the changes in each array upto the next match with the lcs
	      var c = false
	      var unstable = q.map(function (e) {
	        var change = []
	        while(!matchLcs(e)) {
	          change.unshift(retreat(e))
	          c = true
	        }
	        return change
	      })
	      if(c) build(q[0].length, unstable)
	    }
	  }
	
	  //calculate a diff this is only updates
	  exports.optimisticDiff =
	  function (a, b) {
	    var M = Math.max(a.length, b.length)
	    var m = Math.min(a.length, b.length)
	    var patch = []
	    for(var i = 0; i < M; i++)
	      if(a[i] !== b[i]) {
	        var cur = [i,0], deletes = 0
	        while(a[i] !== b[i] && i < m) {
	          cur[1] = ++deletes
	          cur.push(b[i++])
	        }
	        //the rest are deletes or inserts
	        if(i >= m) {
	          //the rest are deletes
	          if(a.length > b.length)
	            cur[1] += a.length - b.length
	          //the rest are inserts
	          else if(a.length < b.length)
	            cur = cur.concat(b.slice(a.length))
	        }
	        patch.push(cur)
	      }
	
	    return patch
	  }
	
	  exports.diff =
	  function (a, b) {
	    var optimistic = exports.optimisticDiff(a, b)
	    var changes = []
	    exports.chunk([a, b], function (index, unstable) {
	      var del = unstable.shift().length
	      var insert = unstable.shift()
	      changes.push([index, del].concat(insert))
	    })
	    return best(optimistic, changes)
	  }
	
	  exports.patch = function (a, changes, mutate) {
	    if(mutate !== true) a = a.slice(a)//copy a
	    changes.forEach(function (change) {
	      [].splice.apply(a, change)
	    })
	    return a
	  }
	
	  // http://en.wikipedia.org/wiki/Concestor
	  // me, concestor, you...
	  exports.merge = function () {
	    var args = getArgs(arguments)
	    var patch = exports.diff3(args)
	    return exports.patch(args[0], patch)
	  }
	
	  exports.diff3 = function () {
	    var args = getArgs(arguments)
	    var r = []
	    exports.chunk(args, function (index, unstable) {
	      var mine = unstable[0]
	      var insert = resolve(unstable)
	      if(equal(mine, insert)) return 
	      r.push([index, mine.length].concat(insert)) 
	    })
	    return r
	  }
	  exports.oddOneOut =
	    function oddOneOut (changes) {
	      changes = changes.slice()
	      //put the concestor first
	      changes.unshift(changes.splice(1,1)[0])
	      var i = oddElement(changes, equal)
	      if(i == 0) // concestor was different, 'false conflict'
	        return changes[1]
	      if (~i)
	        return changes[i] 
	    }
	  exports.insertMergeOverDelete = 
	    //i've implemented this as a seperate rule,
	    //because I had second thoughts about this.
	    function insertMergeOverDelete (changes) {
	      changes = changes.slice()
	      changes.splice(1,1)// remove concestor
	      
	      //if there is only one non empty change thats okay.
	      //else full confilct
	      for (var i = 0, nonempty; i < changes.length; i++)
	        if(changes[i].length) 
	          if(!nonempty) nonempty = changes[i]
	          else return // full conflict
	      return nonempty
	    }
	
	  var rules = (deps && deps.rules) || [exports.oddOneOut, exports.insertMergeOverDelete]
	
	  function resolve (changes) {
	    var l = rules.length
	    for (var i in rules) { // first
	      
	      var c = rules[i] && rules[i](changes)
	      if(c) return c
	    }
	    changes.splice(1,1) // remove concestor
	    //returning the conflicts as an object is a really bad idea,
	    // because == will not detect they are the same. and conflicts build.
	    // better to use
	    // '<<<<<<<<<<<<<'
	    // of course, i wrote this before i started on snob, so i didn't know that then.
	    /*var conflict = ['>>>>>>>>>>>>>>>>']
	    while(changes.length)
	      conflict = conflict.concat(changes.shift()).concat('============')
	    conflict.pop()
	    conflict.push          ('<<<<<<<<<<<<<<<')
	    changes.unshift       ('>>>>>>>>>>>>>>>')
	    return conflict*/
	    //nah, better is just to use an equal can handle objects
	    return {'?': changes}
	  }
	  return exports
	}
	exports(null, exports)


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Data Analytics Tool
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 08/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(162);
	__webpack_require__(54);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var RouterComponent = __webpack_require__(140);
	var Router = RouterComponent;
	
	var Modal = __webpack_require__(10);
	var Carousel = __webpack_require__(76);
	var Query = __webpack_require__(80);
	var Crosstab = __webpack_require__(77);
	var Chart = __webpack_require__(35);
	var Calendar = __webpack_require__(75);
	var Register = __webpack_require__(86);
	var Download = __webpack_require__(78);
	var Legend = __webpack_require__(79);
	
	var datapoint = __webpack_require__(11);
	var foundation = __webpack_require__(39);
	
	var assign = __webpack_require__(7);
	var schema = __webpack_require__(2);
	
	var queue = __webpack_require__(52);
	
	var msgs = __webpack_require__(20);
	
	var DATE_NAME = 'day';
	
	var dateIndexFormat = d3.time.format('%Y-%m-%d');
	
	var filterDims = ["decade", "month", "weekday", "theater_period"];
	
	// cribbed from underscore: http://underscorejs.org/docs/underscore.html#section-69
	function debounce(func, wait, immediate) {
	  var timeout, args, context, timestamp, result;
	
	  var now = Date.now || function () {
	    return new Date().getTime();
	  };
	
	  var later = function later() {
	    var last = now() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      }
	    }
	  };
	
	  return function () {
	    context = this;
	    args = arguments;
	    timestamp = now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	}
	
	function App(url, initial_query) {
	  var api = datapoint(url);
	  var state = hg.state({
	
	    // component state
	    route: Router(),
	    modal: Modal(initial_query),
	    carousel: Carousel(1),
	    register: Register(),
	    chart: Chart(),
	    legend: Legend(),
	    tableView: hg.value('half-table'),
	    download: Download(url),
	
	    // global state
	    query: Query(initial_query, url),
	    start_date: hg.value(0),
	    end_date: hg.value(0),
	    sel_dates: hg.value([]),
	    chart_sizes: hg.value([800, 350]),
	    period_filters: hg.varhash({}),
	    month_filter_opened: hg.value(false),
	    day_filter_opened: hg.value(false),
	    theater_filter_opened: hg.value(false),
	    focus_cell: hg.value({}),
	    focus_day: hg.value(null),
	    available_decades: hg.value(),
	    available_months: hg.value(),
	    available_weekdays: hg.value(),
	    available_theater_periods: hg.value([]),
	
	    loading: hg.value(false),
	    pane_display: hg.value(1),
	    show_registry: hg.value(false),
	    show_message: hg.value(false),
	    message_caption: hg.value(''),
	    message_values: hg.value([]),
	    message_buttons: hg.value([]),
	
	    // data loaded from server
	    calendar_data: hg.value([]),
	    calendar_extent: hg.value(null),
	    cube_data: hg.value({}),
	    theater_data: hg.value([]), // should be initialized once, at load
	
	    // reference data
	    url: url,
	
	    // global state transitions
	    channels: {
	      set_start_date: App.set_start_date,
	      set_end_date: App.set_end_date,
	      sel_dates: App.sel_dates,
	      add_period_filter: App.add_period_filter,
	      remove_period_filter: App.remove_period_filter,
	      open_month_period_filter: App.open_month_period_filter,
	      open_day_period_filter: App.open_day_period_filter,
	      open_theater_period_filter: App.open_theater_period_filter,
	      reset_dates: App.reset_dates,
	      focus_col: App.focus_col,
	      focus_cell: App.focus_cell,
	      focus_day: App.focus_day,
	      focus_theater: App.focus_theater,
	      toggle_modal: App.toggle_modal,
	      set_pane: App.set_pane,
	      open_calendar: App.open_calendar,
	      confirm: App.confirm,
	      cancel: App.cancel,
	      switchTableView: App.switchTableView,
	      refresh_pane: App.refresh_pane
	    }
	  });
	
	  var debouncingLoadCube = debounce(loadCube, 500);
	  var debouncingLoadCalendar = debounce(loadCalendar, 500);
	
	  state.query(function () {
	    load();
	  });
	
	  state.sel_dates(function () {
	    load();
	  });
	
	  state.cube_data(alignFocus);
	  state.query.agg(loadCalendar);
	
	  // this might be bad form... how to send a message to a component?
	  state.focus_day(function (date) {
	    return Register.setDate(state.register, url, date);
	  });
	
	  loadCube();
	  loadTheaters();
	
	  // Loading filters to be used in query panel
	  filterDims.forEach(function (dim) {
	    return api.domain(dim, function (vals) {
	      schema.sort(vals);
	      state['available_' + dim + 's'].set(vals);
	    });
	  });
	
	  // Setting default decade scope
	  if (initial_query.decade_scope) {
	    // UI date selection
	    state.start_date.set(parseInt(initial_query.decade_scope.start));
	    state.end_date.set(parseInt(initial_query.decade_scope.end));
	    // App query date selection
	    var startDate = new Date(initial_query.decade_scope.start + '-04-01');
	    var endDate = new Date(initial_query.decade_scope.end + '-03-31');
	    state.sel_dates.set([startDate, endDate]);
	  }
	
	  return state;
	
	  function loadCube() {
	    if (state.pane_display() === 1) {
	      App.loadCube(state);
	    }
	  }
	
	  function load() {
	    if (validateFilters()) {
	      state.cube_data.set(hg.varhash({}));
	      debouncingLoadCube();
	      debouncingLoadCalendar();
	    } else {
	      var api = datapoint(state.download.url);
	      var all_dims = [].concat(state.query.rows()).concat(state.query.cols());
	      var download_url = api.url(all_dims, state.query.agg(), state.query.filter());
	      state.message_caption.set('criteria_caption');
	      state.message_values.set(['criteria_message', 'criteria_download_message']);
	      state.message_buttons.set([{
	        cls: 'center',
	        url: download_url,
	        text: 'download-button'
	      }]);
	      state.show_message.set(true);
	    }
	  }
	
	  function alignFocus() {
	    var cube_data = state.cube_data();
	    var focus_cell = state.focus_cell();
	  }
	
	  function loadCalendar() {
	    if (state.pane_display() === 2) {
	      App.loadCalendar(state);
	    }
	  }
	
	  function validateFilters() {
	    var filters = state.query().filter;
	    var dimension = Object.keys(filters).find(function (key) {
	      return filters[key] && filters[key].length > 19;
	    });
	    if (dimension) {
	      console.log(filters[dimension]);
	    }
	    return !dimension;
	  }
	
	  function loadTheaters() {
	    queue().defer(api.summarize, ['theater_period'], 'min(date)', {}, {}).defer(api.summarize, ['theater_period'], 'max(date)', {}, {}).await(function (err, theater_mins, theater_maxes) {
	      if (err) throw err;
	      var data = Object.create({});
	      theater_mins.forEach(function (d) {
	        var key = d['theater_period'];
	        var val = d['min(date)'];
	        data[key] = { start_date: dateIndexFormat.parse(val) };
	      });
	
	      theater_maxes.forEach(function (d) {
	        var key = d['theater_period'];
	        var val = d['max(date)'];
	        data[key].end_date = dateIndexFormat.parse(val);
	      });
	
	      state.theater_data.set(data);
	    });
	  }
	}
	
	App.loadCalendar = function (state) {
	  var api = datapoint(state.url);
	  // presumes access to state... seems bad
	  state.calendar_data.set([]);
	
	  state.loading.set(true);
	
	  var day_window = state.sel_dates ? { day: state.sel_dates() } : {};
	  api.summarize([DATE_NAME], state.query.agg(), state.query.filter(), day_window, function (err, raw_data) {
	    if (err) {
	      throw err;
	    }
	    var data = Object.create({});
	    raw_data.forEach(function (d) {
	      var day = d[DATE_NAME];
	      data[day] = d[state.query.agg()];
	    });
	    state.calendar_data.set(data);
	    // NB this works because the date format sorts alphanumerically
	    var min_max = d3.extent(d3.keys(data));
	    state.calendar_extent.set(min_max);
	    state.loading.set(false);
	  });
	};
	
	App.loadCube = function (state) {
	  var api = datapoint(state.url);
	  var query = state.query();
	  var first_row = query.rows.slice(0, 1);
	  var first_col = query.cols.slice(0, 1);
	  var day_window = state.sel_dates ? { day: state.sel_dates() } : {};
	
	  state.loading.set(true);
	
	  // load the 4 fundamental combinations of cube dimensions;
	  // remainder are accessible via drill-down in the UI
	  queue().defer(api.summarize, [], query.agg, query.filter, day_window).defer(api.summarize, first_row, query.agg, query.filter, day_window).defer(api.summarize, first_col, query.agg, query.filter, day_window).defer(api.summarize, [].concat(first_row).concat(first_col), query.agg, query.filter, day_window).await(function (err, d1, d2, d3, d4) {
	    if (err) {
	      throw err;
	    }
	    state.cube_data.set({
	      '0x0': d1,
	      '1x0': d2,
	      '0x1': d3,
	      '1x1': d4
	    });
	    state.loading.set(false);
	  });
	};
	// focus changes
	
	App.refresh_pane = function (state, data) {
	  if (state.pane_display === 2) {
	    App.loadCalendar(state);
	  }
	};
	
	App.sel_dates = function (state, data) {
	  var startDate = data.startDate;
	  var endDate = data.endDate;
	
	  if (startDate && endDate && startDate != '-' && endDate != '-') {
	    startDate = new Date(startDate);
	    endDate = new Date(endDate);
	    state.sel_dates.set([startDate, endDate]);
	  } else {
	    state.sel_dates.set([]);
	  }
	  App.refresh_pane(state);
	};
	
	App.open_calendar = function (state, data) {
	  if (state.pane_display() !== 2) {
	    state.message_caption.set('calendar_tool_caption');
	    state.message_values.set(['calendar_tool_message']);
	    state.message_buttons.set([{
	      cls: 'left.secondary',
	      channel: 'cancel',
	      text: 'cancel'
	    }, {
	      cls: 'right',
	      channel: 'confirm',
	      text: 'ok'
	    }]);
	    state.show_message.set(true);
	  }
	};
	
	App.confirm = function (state, data) {
	  state.show_message.set(false);
	  App.loadCalendar(state);
	  state.pane_display.set(2);
	};
	
	App.cancel = function (state, data) {
	  state.show_message.set(false);
	};
	
	App.set_start_date = function (state, data) {
	  state.start_date.set(parseInt(data.startDate, 10) || 0);
	};
	
	App.set_end_date = function (state, data) {
	  state.end_date.set(parseInt(data.endDate, 10) || 0);
	};
	
	App.add_period_filter = function (state, data) {
	  var filters = state.period_filters.get(data.dim);
	  if (!filters) {
	    filters = [];
	    state.period_filters.put(data.dim, filters);
	  }
	  if (filters.indexOf(data.value) === -1) {
	    filters.push(data.value);
	  } else {
	    filters.splice(filters.indexOf(data.value), 1);
	  }
	  App.close_period_filters(state);
	};
	
	App.remove_period_filter = function (state, data) {
	  var filters = state.period_filters.get(data.dim);
	  filters.splice(filters.indexOf(data.value), 1);
	  state.period_filters.put(data.dim, filters);
	  App.close_period_filters(state);
	};
	
	App.close_period_filters = function (state) {
	  state.month_filter_opened.set(false);
	  state.day_filter_opened.set(false);
	  state.theater_filter_opened.set(false);
	};
	
	App.open_month_period_filter = function (state) {
	  state.month_filter_opened.set(!state.month_filter_opened());
	  state.day_filter_opened.set(false);
	  state.theater_filter_opened.set(false);
	};
	
	App.open_day_period_filter = function (state) {
	  state.month_filter_opened.set(false);
	  state.day_filter_opened.set(!state.day_filter_opened());
	  state.theater_filter_opened.set(false);
	};
	
	App.open_theater_period_filter = function (state) {
	  state.month_filter_opened.set(false);
	  state.day_filter_opened.set(false);
	  state.theater_filter_opened.set(!state.theater_filter_opened());
	};
	
	App.reset_dates = function (state) {
	  state.start_date.set(1680);
	  state.end_date.set(1790);
	  state.period_filters.set({});
	  state.pane_display.set(1);
	};
	
	App.focus_col = function (state, data) {
	  var focus = state.focus_cell;
	  if (focus[data.dimension] != data.value) {
	    focus[data.dimension] = data.value;
	    state.legend.focus.set(data.value);
	    state.chart.focus.set(data.value);
	  } else {
	    delete focus[data.dimension];
	    state.legend.focus.set(null);
	    state.chart.focus.set(null);
	  }
	  state.focus_cell.set(focus);
	};
	
	App.focus_cell = function (state, data) {
	  var new_focus = data.focus;
	  var first_col = state.query.cols.slice(0, 1);
	  var first_row = state.query.rows.slice(0, 1);
	  var focus = state.focus_cell();
	  if (!focus || focus[first_col] != new_focus[first_col] || focus[first_row] != new_focus[first_row]) {
	    state.focus_cell.set(new_focus);
	    state.legend.focus.set(new_focus[first_col]);
	    state.chart.focus.set(new_focus[first_col]);
	    state.chart.point.set(new_focus[first_row]);
	  } else {
	    state.focus_cell.set({});
	    state.legend.focus.set(null);
	    state.chart.focus.set(null);
	    state.chart.point.set(null);
	  }
	  Carousel.setSlide(state.carousel, 1);
	};
	
	App.focus_day = function (state, data) {
	  var new_day = data.date;
	  state.focus_day.set(new_day);
	  Carousel.setSlide(state.carousel, 2);
	  state.show_registry.set(true);
	};
	
	App.focus_theater = function (state, new_theater) {
	  var filter = state.query.filter;
	  var new_filter = assign(filter, { theater_period: new_theater });
	  state.query.filter.set(new_filter);
	  Carousel.setSlide(state.carousel, 1);
	};
	
	App.toggle_modal = function (state, modal) {
	  var prev = state.modal();
	  var next = modal !== prev ? modal : null;
	
	  state.modal.set(next);
	};
	
	App.set_pane = function (state, data) {
	  state.pane_display.set(data);
	};
	
	App.switchTableView = function (state, tableViewState) {
	  state.tableView.set(tableViewState);
	};
	
	// rendering
	
	App.render = function (state) {
	  return RouterComponent.render(state, {
	    '/:lang/app': function langApp(params) {
	      return render_i18n(lang(params));
	    },
	    '/*': render_i18n.bind(null, 'fr')
	  });
	
	  function lang(params) {
	    switch (params['lang']) {
	      case 'fr':
	        return 'fr';
	      case 'en':
	        return 'en';
	      default:
	        return 'fr';
	    }
	  }
	
	  function chart_size() {
	    var sizes = [800, 350];
	    if (!state.modal.queryPanelOpen) {
	      sizes[0] = 1200;
	    }
	    if (state.tableView == 'full-chart') {
	      sizes[1] = 500;
	    }
	    return sizes;
	  }
	
	  function render_i18n(lang) {
	    return h('div.row.main-container', [h('div.overlay' + (state.show_message ? '.show' : '.hide'), { 'ev-click': hg.send(state.channels.cancel) }, h('div.modal-message', {
	      'ev-click': function evClick() {
	        // do nothing to prevent the dialog from closing due to
	        // the ev-click registered on the overlay
	      }
	    }, [h('h1', msgs[lang][state.message_caption]), state.message_values.map(function (value) {
	      return h('p', msgs[lang][value]);
	    }), state.message_buttons.map(function (button) {
	      return h('a.button.' + button.cls, {
	        'ev-click': button.channel ? hg.send(state.channels[button.channel]) : null,
	        'href': button.url
	      }, msgs[lang][button.text]);
	    })])), Query.render(state, state.modal, state.query, lang), h('section.columns.data-display-container', [
	    // h('div.pane_selector', h('nav', [
	    //   h('button' + (state.pane_display == 1 ? '.selected' : ''), { 'ev-click': hg.send(state.channels.set_pane, 1) }, msgs[lang]['pane_selector_button_1']),
	    //   h('button' + (state.pane_display == 2 ? '.selected' : ''), { 'ev-click': hg.send(state.channels.set_pane, 2) }, msgs[lang]['pane_selector_button_2']),
	    // ])),
	    h('div.data-container-pane' + (state.pane_display == 1 ? '.show' : '.hide'), [h('aside.crosstab-view-splitter-container', [h('div.crosstab-view-splitter', [h('button.full-table' + (state.tableView == 'full-table' ? '.selected' : ''), { 'ev-click': hg.send(state.channels.switchTableView, 'full-table') }), h('button.half-tablechart' + (state.tableView == 'half-table' ? '.selected' : ''), { 'ev-click': hg.send(state.channels.switchTableView, 'half-table') }), h('button.full-chart' + (state.tableView == 'full-chart' ? '.selected' : ''), { 'ev-click': hg.send(state.channels.switchTableView, 'full-chart') })])]), Download.render(state, lang), h('section.crosstab-container.' + state.tableView, [h('div.loading-indicator' + (state.loading ? '.show' : '.hide'), h('div.loading-icon')), Crosstab.render(state, lang)]), h('section.chart-containter.' + state.tableView, [h('div.loading-indicator' + (state.loading ? '.show' : '.hide'), h('div.loading-icon')), Chart.render(state.chart, state, state.query, state.cube_data, chart_size(), false, lang), Legend.render(state.legend, state, state.query, state.cube_data, lang)])]), h('div.data-container-pane' + (state.pane_display == 2 ? '.show' : '.hide'), [h('div.loading-indicator' + (state.loading ? '.show' : '.hide'), h('div.loading-icon')), Calendar.render(state, chart_size(), lang)])])]);
	  }
	};
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Calendar Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	*
	* TODO : This component is not actively used (not called in app.js) and may be removed in future if not needed. Kept for possible reintegration (dtalbot)
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _utilDateUtils = __webpack_require__(90);
	
	__webpack_require__(163);
	
	var schema = __webpack_require__(2);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var d3 = __webpack_require__(8);
	var colorbrewer = __webpack_require__(94);
	var d3_time = __webpack_require__(40); // until d3 core updated to use d3-time 0.0.5
	var queue = __webpack_require__(52);
	
	var i18n = __webpack_require__(4);
	
	var datapoint = __webpack_require__(11);
	
	var assign = __webpack_require__(7);
	
	var timeFormat = d3.time.format;
	var numberFormat = d3.format;
	
	var day = d3.time.format('%w');
	var month = d3.time.format('%m');
	
	var msgs = __webpack_require__(20);
	var query_msgs = __webpack_require__(3);
	
	// number of sundays since the prior March 1
	var weeksOffset = function weeksOffset(e, y) {
	  return d3_time.sunday.count(d3_time.sunday(new Date(e.getFullYear(), 3, 1)), y);
	};
	var invertWeekOffset = function invertWeekOffset(y, c) {
	  return d3_time.sunday.offset(d3_time.sunday(new Date(y.getFullYear(), 3, 1)), c);
	};
	
	var dateIndexFormat = d3.time.format('%Y-%m-%d');
	
	var month_n = function month_n(month, season) {
	  return month.getMonth() - 3 + (month.getFullYear() - season.getFullYear()) * 12;
	};
	var month_y = function month_y(month, date, cellSize) {
	  return d3_time.sunday.count(d3_time.sunday(new Date(month.getFullYear(), month.getMonth(), 1)), date) * cellSize;
	};
	var month_x = function month_x(month, season, cellSize, zoom) {
	  var mn = month_n(month, season);
	  mn = zoom ? mn % 5 : mn;
	  return mn ? mn * 5 + mn * 7 * cellSize : mn;
	};
	
	var y_global = null;
	
	var sameDate = function sameDate(d0, d1) {
	  return d0 && d1 && d1 - d0 === 0;
	};
	
	var yearRange = function yearRange(i0, i1) {
	  var yearFormat = d3.format("04d");
	  var s0 = yearFormat(i0);
	  var s1 = yearFormat(i1);
	
	  return s0 + "-" + s1;
	};
	
	function GraphWidget(calendar_data, theater_data, calendar_extent, sel_dates, focus_day, mode, scale, sizes, lang) {
	  this.calendar_data = calendar_data;
	  this.theater_data = theater_data;
	  this.calendar_extent = calendar_extent;
	  this.sel_dates = sel_dates;
	  this.focus_day = this.isInRange(sel_dates, focus_day) ? focus_day : null;
	  this.zoom = this.isZoom(sel_dates);
	  this.mode = mode;
	  this.scale = scale;
	  this.lang = lang;
	  this.sizes = sizes;
	}
	
	GraphWidget.prototype.isInRange = function (sel_dates, focus_day) {
	  return sel_dates && focus_day >= (0, _utilDateUtils.easterForYear)(sel_dates[0].getFullYear()) && focus_day < (0, _utilDateUtils.easterForYear)(sel_dates[1].getFullYear());
	};
	
	GraphWidget.prototype.isZoom = function (sel_dates) {
	  return sel_dates && sel_dates[1].getFullYear() - sel_dates[0].getFullYear() > 1 ? false : true;
	};
	
	GraphWidget.prototype.width = function () {
	  return this.sizes[0];
	};
	
	GraphWidget.prototype.cellSize = function () {
	  var cellCount = this.zoom ? 35 : 91;
	  return (this.width() - 60) / cellCount;
	};
	
	GraphWidget.prototype.margins = function () {
	  var values = { top: 30, right: 25, bottom: 10, left: 20 };
	  values.left = this.width() > 800 ? 70 : values.left;
	  return values;
	};
	
	GraphWidget.prototype.type = 'Widget';
	
	GraphWidget.prototype.init = function () {
	  var margins = this.margins();
	  var elem = document.createElement('div');
	  var graph = d3.select(elem).classed('graph', true);
	  var canvas = graph.append('canvas').attr('width', this.width());
	  var svg = graph.append('svg').attr('width', this.width());
	  var foreground = svg.append('g').classed('foreground', true).attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');
	  foreground.append('rect').attr("fill", "#E7E8EA").attr("x", "-10").attr("y", "-3em").attr("width", this.width() + 10).attr("height", "2.5em");
	  var x_axis = foreground.append('g').classed('x axis', true);
	  var y_axis = foreground.append('g').classed('y axis', true);
	
	  this.listen(elem);
	
	  return elem;
	};
	
	GraphWidget.prototype.select = function () {
	  var date = pointToDate(d3.event, this.calendar_extent);
	  this.props.handlePreview(date);
	};
	
	function pointToDate(e, extent, graph, click) {
	  var canvas = d3.select(".calendar canvas")[0][0];
	  var rect = canvas.getBoundingClientRect();
	  var x = e.clientX - rect.left;
	  var y = e.clientY - rect.top;
	  var margins = graph.margins();
	  var cellSize = graph.cellSize();
	
	  if (y < margins.top) {
	    return null;
	  }
	
	  if (graph.zoom) {
	    var season = (0, _utilDateUtils.easterForYear)(graph.sel_dates[0].getFullYear());
	    var nextSeason = (0, _utilDateUtils.easterForYear)(season.getFullYear() + 1);
	
	    var ry = y / (8 * cellSize);
	    var rx = (x - margins.left + 10) / (7 * cellSize + 5);
	
	    var mn = Math.floor(ry) * 5 + Math.floor(rx);
	    var wn = (ry % 1 * (8 * cellSize) - cellSize * 1.5) / cellSize;
	    var dn = rx % 1 * (7 * cellSize + 5) / cellSize;
	
	    if (wn < 0 || dn < 0 || dn > 7) {
	      return null;
	    }
	
	    var first = new Date(season.getFullYear(), mn + 3, 1);
	    var last = d3.time.month.offset(first, 1);
	    var date = d3.time.week.offset(first, Math.floor(wn));
	    date = d3.time.day.offset(date, Math.floor(dn) - +day(first));
	
	    if (date < first || date >= last) {
	      return null;
	    }
	
	    if (date >= nextSeason || date < season) {
	      return null;
	    }
	
	    return date;
	  } else {
	    var season_min = (0, _utilDateUtils.easterForYear)(dateIndexFormat.parse(extent[0]).getFullYear());
	
	    var seasonOffset = Math.floor((y - margins.top) / (cellSize * 9));
	    var season = (0, _utilDateUtils.easterForYear)(season_min.getFullYear() + seasonOffset);
	    var nextSeason = (0, _utilDateUtils.easterForYear)(season.getFullYear() + 1);
	
	    var rx = x - margins.left + 10;
	    var month = Math.floor(rx / (cellSize * 7 + 5));
	
	    rx = rx - month * cellSize * 7 - month * 5;
	
	    //var day = Math.floor((rx - (month * cellSize * 7)) / cellSize);
	    var first = new Date(season.getFullYear(), month + 3, 1);
	    var last = d3.time.month.offset(first, 1);
	
	    var se = graph.sel_dates;
	    var sel = se.length == 0 || se[0] < first && first < se[1];
	
	    if (!sel || !y_global) {
	      return null;
	    }
	
	    var d = Math.floor(rx / cellSize);
	    var season_y = margins.top + y_global(season);
	    var ry = Math.floor((y - season_y) / cellSize);
	    if (ry > 5) {
	      return null;
	    }
	
	    var date = d3.time.week.offset(first, ry);
	    date = d3.time.day.offset(date, d - +day(first));
	
	    if (date < first || date >= last) {
	      return null;
	    }
	
	    if (date >= nextSeason || date < season) {
	      return null;
	    }
	
	    return date;
	  }
	}
	
	GraphWidget.prototype.listen = function (elem) {
	  // TODO.  not clear why this is needed...  check virtual-dom update cycle
	  if (this.calendar_extent && this.calendar_extent[0] && this.calendar_extent[1]) {
	    var boundhover = hover.bind(this);
	    var svg = d3.select(elem).select('svg');
	    svg.on("mousemove", boundhover).on("mouseleave", boundhover);
	  }
	
	  function hover() {
	    var svg = d3.select(elem).select('svg');
	    var cellSize = this.cellSize();
	    var margins = this.margins();
	
	    var locale = i18n[this.lang];
	    var tooltipFormat = locale.timeFormat("%a %e %b %Y");
	
	    var season = function season(date) {
	      return (0, _utilDateUtils.easter)(date);
	    };
	    var date = pointToDate(d3.event, this.calendar_extent, this);
	    var data;
	    if (date) {
	      var s = dateIndexFormat(date);
	      data = this.calendar_data[s];
	    }
	
	    var rx = 0;
	    var ry = 0;
	    if (date) {
	      if (this.zoom) {
	        rx = this.width() / 2 - cellSize;
	        ry = cellSize * 22;
	      } else {
	        rx = month_x(date, season(date), cellSize) - cellSize;
	        ry = y_global(season(date)) + 7.2 * cellSize;
	      }
	    }
	
	    var tooltip = svg.select(".foreground").selectAll(".tooltip").data(date && y_global ? [date] : []);
	    tooltip.exit().remove();
	    tooltip.enter().append("text").classed("tooltip", true).attr("text-align", "left").attr("x", rx).attr("y", ry);
	
	    var dataTooltip = svg.select(".foreground").selectAll(".data-tooltip").data(data ? [data] : []);
	    dataTooltip.exit().remove();
	    dataTooltip.enter().append("text").classed("data-tooltip", true).attr("text-align", "left").attr("x", rx).attr("y", ry + cellSize);
	
	    tooltip.text(tooltipFormat);
	    dataTooltip.text(data + " " + msgs[this.lang]["currency"]);
	  }
	};
	
	GraphWidget.prototype.update = function (prev, elem) {
	  var _this = this;
	
	  this.calendar_data = this.calendar_data || prev.calendar_data;
	  this.calendar_extent = this.calendar_extent || prev.calendar_extent;
	
	  this.listen(elem);
	
	  var cellSize = this.cellSize();
	  var margins = this.margins();
	  var graph = d3.select(elem);
	  var foreground = graph.select("svg").classed({ "zoomed": this.zoom });
	  var canvas = graph.select("canvas")[0][0];
	  var locale = i18n[this.lang];
	  var day_name = function day_name(day) {
	    return locale.timeFormat('%a')(day).toUpperCase().substring(0, 1);
	  };
	  var month_name = function month_name(month) {
	    var mn = locale.timeFormat('%B')(month);
	    return mn.charAt(0).toUpperCase() + mn.slice(1);
	  };
	
	  var data = this.calendar_data;
	  var keys = d3.keys(data);
	
	  if (!this.calendar_extent || !this.calendar_extent[0]) return;
	
	  var _calendar_extent$map = this.calendar_extent.map(dateIndexFormat.parse);
	
	  var _calendar_extent$map2 = _slicedToArray(_calendar_extent$map, 2);
	
	  var lo = _calendar_extent$map2[0];
	  var hi = _calendar_extent$map2[1];
	
	  var data_extent = [(0, _utilDateUtils.easterForYear)(lo.getFullYear()), (0, _utilDateUtils.easterCeiling)(hi)];
	  var height;
	  if (this.zoom) {
	    height = 8 * cellSize * 3;
	  } else {
	    height = (data_extent[1].getFullYear() - data_extent[0].getFullYear()) * cellSize * 9;
	  }
	  var width = this.width();
	
	  canvas.height = margins.top + margins.bottom + height;
	  canvas.width = margins.left + margins.right + width;
	  var svg = d3.select(elem).select("svg").attr("height", canvas.height).attr("width", canvas.width);
	
	  var y = d3.scale.linear().domain(data_extent).range([0, height]);
	
	  // TODO.  bad, very bad -- replace with a more sustainable solution
	  y_global = y;
	
	  var ctx = canvas.getContext('2d');
	  ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	  var seasons = d3.range(data_extent[0].getFullYear(), data_extent[1].getFullYear()).map(_utilDateUtils.easterForYear);
	  if (this.zoom) {
	    seasons.forEach(function (season) {
	
	      var x = function x(date) {
	        return weeksOffset(season, date) * cellSize;
	      };
	      var nextSeason = (0, _utilDateUtils.easterForYear)(season.getFullYear() + 1);
	      var monthSeason = new Date(season.getFullYear(), season.getMonth(), 1);
	      var nextMonthSeason = new Date(nextSeason.getFullYear(), nextSeason.getMonth() + 1, 1);
	
	      var days = d3.time.days(season, nextSeason);
	
	      var months = d3.time.months(new Date(season.getFullYear(), 3, 1), new Date(nextSeason.getFullYear(), 4, 1));
	      var scale = _this.scale;
	
	      months.forEach(function (month) {
	        var sel = monthSeason <= month && month < nextMonthSeason;
	        if (sel) {
	          var days = d3.time.days(month, new Date(month.getFullYear(), month.getMonth() + 1, 1));
	          var my = Math.floor(month_n(month, season, cellSize, _this.zoom) / 5) * (8 * cellSize);
	          var mx = month_x(month, season, cellSize, _this.zoom) + margins.left - 10;
	          ctx.fillStyle = "#E7E8EA";
	          ctx.fillRect(mx, my, cellSize * 7, cellSize * 1.5);
	
	          ctx.fillStyle = "#333";
	          ctx.textAlign = "center";
	          if (_this.width() > 800) {
	            ctx.font = "16px sans-serif";
	          } else {
	            ctx.font = "12px sans-serif";
	          }
	          ctx.fillText(month_name(month), mx + cellSize * 7 / 2, my + cellSize * 0.5);
	
	          days.forEach(function (d) {
	            if (season <= d && d < nextSeason) {
	              var rx = mx + day(d) * cellSize;
	              var ry = month_y(month, d, cellSize) + my + cellSize * 1.5;
	              ctx.fillStyle = "#ccc";
	              ctx.font = "11px sans-serif";
	              ctx.fillText(day_name(d), rx + cellSize / 2, my + cellSize * 1.2);
	
	              ctx.strokeStyle = '#ccc';
	              ctx.strokeRect(rx, ry, cellSize, cellSize);
	              var s = dateIndexFormat(d);
	              var data = _this.calendar_data[s];
	
	              ctx.fillStyle = "white";
	              if (data) {
	                ctx.fillStyle = scale(data);
	              }
	              ctx.fillRect(rx, ry, cellSize - 1, cellSize - 1);
	            }
	          });
	        }
	      });
	    });
	  } else {
	    ctx.translate(0.5, 0.5);
	    seasons.forEach(function (season) {
	      ctx.save();
	      ctx.translate(margins.left - 10, margins.top + Math.round(y(season)));
	
	      ctx.strokeStyle = "black";
	      ctx.beginPath();
	      ctx.moveTo(0, -3);
	      ctx.lineTo(width, -3);
	      ctx.stroke();
	
	      var x = function x(date) {
	        return weeksOffset(season, date) * cellSize;
	      };
	
	      var nextSeason = (0, _utilDateUtils.easterForYear)(season.getFullYear() + 1);
	      var monthSeason = new Date(season.getFullYear(), season.getMonth(), 1);
	      var nextMonthSeason = new Date(nextSeason.getFullYear(), nextSeason.getMonth() + 1, 1);
	      var days = d3.time.days(season, nextSeason);
	
	      var months = d3.time.months(new Date(season.getFullYear(), 3, 1), new Date(nextSeason.getFullYear(), 4, 1));
	      var scale = _this.scale;
	
	      months.forEach(function (month) {
	        var sel = monthSeason <= month && month < nextMonthSeason;
	        if (sel) {
	          var days = d3.time.days(month, new Date(month.getFullYear(), month.getMonth() + 1, 1));
	          days.forEach(function (d) {
	            if (season <= d && d < nextSeason) {
	              var rx = month_x(month, season, cellSize) + day(d) * cellSize;
	              var ry = month_y(month, d, cellSize);
	              ctx.strokeStyle = '#ccc';
	              ctx.strokeRect(rx, ry, cellSize, cellSize);
	              var s = dateIndexFormat(d);
	              var data = _this.calendar_data[s];
	
	              ctx.fillStyle = "white";
	              if (data) {
	                ctx.fillStyle = scale(data);
	              }
	              ctx.fillRect(rx, ry, cellSize - 1, cellSize - 1);
	            }
	          });
	        }
	      });
	      ctx.restore();
	    });
	  }
	
	  // svg layer
	
	  var svg = d3.select(elem).select('svg .foreground').attr("transform", "translate(" + margins.left + "," + margins.top + ")");
	
	  // focused date
	
	  var circle = svg.selectAll("circle.focus").data(this.focus_day ? [this.focus_day] : []);
	
	  circle.exit().remove();
	  circle.enter().append('circle').classed('focus', true).attr("stroke", "red").attr("stroke-width", 1.5).attr("fill", "none");
	  circle.attr("r", cellSize / 2);
	
	  if (this.zoom) {
	    circle.attr("cx", function (d) {
	      return month_x(d, (0, _utilDateUtils.easter)(d), cellSize, _this.zoom) + day(d) * cellSize + cellSize / 2 - 10;
	    }).attr("cy", function (d) {
	      var mr = Math.floor(month_n(d, (0, _utilDateUtils.easter)(d), cellSize, _this.zoom) / 5);
	      var cy = mr * (8 * cellSize);
	      cy += cellSize * 1.5 - margins.top;
	      cy += month_y(new Date(d.getFullYear(), d.getMonth(), 1), d, cellSize);
	      cy += cellSize / 2;
	      return cy;
	    });
	  } else {
	    circle.attr("cx", function (d) {
	      return month_x(d, (0, _utilDateUtils.easter)(d), cellSize) + day(d) * cellSize + cellSize / 2 - 10;
	    }).attr("cy", function (d) {
	      return y((0, _utilDateUtils.easter)(d)) + month_y(new Date(d.getFullYear(), d.getMonth(), 1), d, cellSize) + cellSize / 2;
	    });
	  }
	  // x axis
	
	  var months_extent = d3.time.months(new Date(seasons[0].getFullYear(), 3, 1), new Date(seasons[0].getFullYear() + 1, 4, 1));
	
	  var month = svg.select('.axis.x').selectAll('.month').data(months_extent);
	
	  month.enter().append('text').classed('month', true).attr('dy', '-1em').attr('text-anchor', 'middle').text(month_name);
	
	  month.attr('x', function (d) {
	    return month_x(d, seasons[0], cellSize) - (margins.left + 10) + 6 * cellSize;
	  });
	  // y axis
	
	  var all_years = d3.range(data_extent[0].getFullYear(), data_extent[1].getFullYear());
	
	  var year = svg.select('.axis.y').selectAll('.year').data(all_years, function (x) {
	    return x;
	  });
	
	  year.exit().remove();
	  year.enter().append('g').classed('year', true).append('text').attr('transform', 'rotate(-90)').attr('text-anchor', 'middle').text(function (year) {
	    return yearRange(year, year + 1);
	  });
	  year.selectAll('text').attr('dy', width);
	  year.attr('transform', function (year) {
	    return 'translate(0,' + Math.round(y((0, _utilDateUtils.easterForYear)(year)) + cellSize * 5 / 2.0) + ')';
	  });
	};
	
	function Calendar() {
	  return hg.state({});
	}
	
	var dragging = false;
	
	Calendar.render = function (state, sizes, lang) {
	  var scale = d3.scale.quantile().domain(d3.values(state.calendar_data)).range(colorbrewer.YlGnBu[9].slice(0, 7));
	
	  var graphWidget = new GraphWidget(state.calendar_data, state.theater_data, state.calendar_extent, state.sel_dates, state.focus_day, 'focus', scale, sizes, lang);
	
	  var sendDay = hg.BaseEvent(function (ev, broadcast) {
	    var date = pointToDate(ev, state.calendar_extent, graphWidget, true);
	
	    if (date && !dragging) {
	      broadcast(assign(this.data, { date: date }));
	    }
	  });
	
	  return h('div.calendar', {
	    'ev-click': sendDay(state.channels.focus_day)
	  }, [h('div.legend', {
	    style: 'width: ' + sizes[0] + 'px'
	  }, [h('h3', msgs[lang]['legend_caption'].replace(new RegExp("\\{type}"), query_msgs[lang][state.query.agg])), h('div.items', [scale.range().slice().reverse().map(function (item, index) {
	    var lo = scale.invertExtent(item)[0];
	    return h('div.item', [h('span.block', { style: 'background-color: ' + item }), h('span', lo ? schema.format(lang, state.query.agg)(lo) : '')]);
	  })])]), graphWidget]);
	};
	
	exports['default'] = Calendar;
	module.exports = exports['default'];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Carousel Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 07/2015
	*
	* TODO : This component is not actively used (not called in app.js) and may be removed in future if not needed. Kept for possible reintegration (dtalbot)
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(164);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	function Carousel(n) {
	  return hg.state({
	    active: hg.value(n || 0),
	    channels: {
	      setSlide: Carousel.setSlide
	    }
	  });
	}
	
	Carousel.setSlide = function (state, value) {
	  state.active.set(value);
	};
	
	Carousel.render = function (state, panes, children) {
	  var cur_pane = panes[state.active];
	
	  var parent_styles = {
	    width: 100 * children.length + '%',
	    left: 100 * -cur_pane.start + '%',
	    transition: 'left 1s'
	  };
	
	  return h('div.carousel', [h('ul.navigation.dots', panes.map(dot)), h('div', arrows()), h('ul.panes', { style: parent_styles }, styled_children())]);
	
	  function dot(pane, i) {
	    return h('li.dot' + (i === state.active ? ".active" : ""), {
	      'ev-click': hg.send(state.channels.setSlide, i)
	    }, [h('a', { href: '#' }, [pane.title || String(i)])]);
	  }
	
	  function arrows() {
	    var result = [];
	    if (state.active > 0) {
	      result.push(h('div.step.previous', { 'ev-click': hg.send(state.channels.setSlide, state.active - 1) }));
	    }
	    if (state.active < panes.length - 1) {
	      result.push(h('div.step.next', { 'ev-click': hg.send(state.channels.setSlide, state.active + 1) }));
	    }
	    return result;
	  }
	
	  function styled_children() {
	    return children.map(function (c, i) {
	      var visible = cur_pane.start <= i && i < cur_pane.start + cur_pane.run;
	      var child_styles = {
	        width: 100 / children.length / (visible ? cur_pane.run : 1) + '%',
	        transition: 'width 1s'
	      };
	      return h('li.pane', { style: child_styles }, [c]);
	    });
	  }
	};
	
	exports['default'] = Carousel;
	module.exports = exports['default'];

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Crosstab Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 06/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	__webpack_require__(165);
	
	var hints = __webpack_require__(20);
	var msgs = __webpack_require__(3);
	var i18n = __webpack_require__(4);
	var rendering = __webpack_require__(28);
	var foundation = __webpack_require__(39);
	var schema = __webpack_require__(2);
	var hint_suffix = "_hint";
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	var svg = __webpack_require__(71);
	var assign = __webpack_require__(7);
	
	function Crosstab() {
			return null;
	}
	
	function getSelectionHint(app_state, query_state, cube_data, lang) {
			var rowKey = query_state.rows[0];
			var colKey = query_state.cols[0];
			var aggKey = query_state.agg;
			var hint = "";
	
			if (cube_data && cube_data['0x1'] && cube_data['1x0'] && cube_data['1x1'] && app_state.focus_cell[rowKey] && app_state.focus_cell[colKey]) {
					var aggData = cube_data['1x1'].find(function (entry) {
							return entry[colKey] === app_state.focus_cell[colKey] && entry[rowKey] === app_state.focus_cell[rowKey];
					});
					if (aggData) {
							(function () {
									hint = hints[lang][aggKey];
									hint = hint.replace(/\{agg}/, schema.format(lang, aggKey)(aggData[aggKey]));
									var cols = [],
									    rows = [];
									query_state.cols.forEach(function (key) {
											var colData = cube_data['0x1'].find(function (column) {
													return column[colKey] === app_state.focus_cell[colKey];
											});
											if (colData) {
													cols.push(msgs[lang][key + hint_suffix].replace(new RegExp("\\{" + key + "}"), schema.format(lang, colKey)(colData[colKey])));
											}
									});
									query_state.rows.forEach(function (key) {
											var rowData = cube_data['1x0'].find(function (row) {
													return row[rowKey] === app_state.focus_cell[rowKey];
											});
											if (rowData) {
													rows.push(msgs[lang][key + hint_suffix].replace(new RegExp("\\{" + key + "}"), schema.format(lang, rowKey)(rowData[rowKey])));
											}
									});
									// TODO, better phrasing when more than one filter on an axis
									// hint = hint.replace(/\{cols}/, (cols.length > 1 ? cols.join(", ") : cols[0]));
									//hint = hint.replace(/\{rows}/, (rows.length > 1 ? rows.join(", ") : rows[0]));
									hint = hint.replace(/\{cols}/, cols[0]);
									hint = hint.replace(/\{rows}/, rows[0]);
							})();
					}
			}
	
			return hint;
	}
	
	Crosstab.generateRowHeadersColumn = function (query_state, cube_data, lang) {
			var lResult = [];
	
			var lAggKey = query_state.agg;
			var lRowKey = query_state.rows[0];
	
			// Generate header row
			var lDataSet = cube_data['1x0'];
			var lRows = [h('tr', h('th.cross-cell', { 'ev-click': hg.send(query_state.channels.interchangeAxis) }, h('span', 'X')))];
			for (var i in lDataSet) {
					if (lDataSet[i][lRowKey]) {
							var lData = schema.format(lang, lRowKey)(lDataSet[i][lRowKey]);
							lRows.push(h('tr', h('th', h('span.has-tip', {
									"ev-tooltip-create": new foundation.Tooltip(),
									title: lData
							}, lData))));
					}
			}
			// Add sum row
			lRows.push(h('tr', h('th.sum-row', h('span.has-tip', {
					"ev-tooltip-create": new foundation.Tooltip(),
					title: msgs[lang][lAggKey]
			}, msgs[lang][lAggKey]))));
	
			lResult.push(lRows);
	
			return lResult;
	};
	
	Crosstab.generateTableData = function (app_state, query_state, cube_data, lang) {
			var lResult = [];
	
			var lAggKey = query_state.agg;
			var lRowKey = query_state.rows[0];
			var lColKey = query_state.cols[0];
			var formatter = schema.format(lang, lColKey);
	
			// Generate header row
			var lDataSet = cube_data['0x1'];
			var lTableCols = [];
			var lHeaderRow = [];
			var columns = [];
			for (var i in lDataSet) {
					if (lDataSet[i][lColKey]) {
							columns.push(lDataSet[i][lColKey]);
					}
			}
			var color = rendering.colors(columns);
			columns.forEach(function (lData) {
					var cellColor = undefined;
					if (app_state.focus_cell[lColKey] == lData) {
							cellColor = rendering.lighten(color(lData), 0.2);
					}
					lTableCols.push(h('col', { width: '100px' }));
					lHeaderRow.push(h('th', {
							style: { 'background-color': cellColor }
					}, h('span.has-tip', {
							"ev-tooltip-create": new foundation.Tooltip(),
							title: formatter(lData)
					}, formatter(lData))));
			});
	
			if (lHeaderRow.length <= 0) {
					// Sometimes, no header is present because no X axis dimension was set
					lTableCols.push(h('col', { width: '100px' }));
					lHeaderRow.push(h('th', h('span.has-tip', {
							"ev-tooltip-create": new foundation.Tooltip(),
							title: msgs[lang][lAggKey]
					}, msgs[lang][lAggKey])));
			}
			lResult.push(lTableCols);
			lResult.push(h('tr.heading-row', { id: 'data-heading-row' }, lHeaderRow));
	
			// Calculate row count as the .lenght attribute seems to cause obscur error
			var lRowCount = 0;
			for (var i in cube_data['1x0']) {
					lRowCount++;
			}
	
			// Generate result rows
			var lColDataSet = cube_data['0x1'];
			var lRowDataSet = cube_data['1x0'];
			var lFullDataSet = cube_data['1x1'];
	
			for (var i in cube_data['1x0']) {
					var lRowCubeData = cube_data['1x0'][i];
					var lDataRow = [];
	
					for (var j in cube_data['0x1']) {
							var lColCubeData = cube_data['0x1'][j];
	
							if (lRowCubeData[lRowKey] && lColCubeData[lColKey]) {
	
									var lFullCubeData = lFullDataSet.filter(function (fullCubeData) {
											return fullCubeData[lRowKey] == lRowCubeData[lRowKey] && fullCubeData[lColKey] == lColCubeData[lColKey];
									});
	
									var lCellData = lFullCubeData.length > 0 ? schema.format(lang, lAggKey)(lFullCubeData[0][lAggKey]) : '';
									var lCellDataTitle = lRowCubeData[lRowKey].toString() + ' / ' + lColCubeData[lColKey] + ' : ' + (lCellData ? lCellData : '-');
	
									var lClickEvntObject = { focus: {} };
									lClickEvntObject.focus[lRowKey] = lRowCubeData[lRowKey];
									lClickEvntObject.focus[lColKey] = lColCubeData[lColKey];
									lClickEvntObject.focus.agg = lCellData;
	
									var cellColor = undefined;
	
									if (app_state.focus_cell[lRowKey] == lRowCubeData[lRowKey] && app_state.focus_cell[lColKey] == lColCubeData[lColKey]) {
											cellColor = rendering.lighten(color(lColCubeData[lColKey]), 0.6);
									} else if (app_state.focus_cell[lColKey] == lColCubeData[lColKey]) {
											cellColor = rendering.lighten(color(lColCubeData[lColKey]), 0.2);
									}
	
									lDataRow.push(h('td', {
											style: { 'background-color': cellColor },
											'ev-click': hg.send(app_state.channels.focus_cell, lClickEvntObject)
									}, h('span.has-tip', {
											"ev-tooltip-create": new foundation.Tooltip(),
											title: lCellDataTitle
									}, lCellData)));
							}
					}
	
					lResult.push(h('tr', lDataRow));
			}
	
			// Add row with all sums
			var lSumRow = [];
			for (var i in lColDataSet) {
					var _lCellData = "";
					var _lCellDataTitle = "";
					if (!isNaN(lColDataSet[i][lAggKey].toFixed(0))) {
							_lCellData = schema.format(lang, lAggKey)(lColDataSet[i][lAggKey]);
							_lCellDataTitle = lColDataSet[i][lColKey] + ' : ' + _lCellData;
					}
	
					lSumRow.push(h('td.sum-row', h('span.has-tip', {
							"ev-tooltip-create": new foundation.Tooltip(),
							title: _lCellDataTitle
					}, _lCellData)));
			}
			lResult.push(h('tr', lSumRow));
	
			return lResult;
	};
	
	Crosstab.generateSumColumn = function (query_state, cube_data, lang) {
			var lResult = [];
	
			var lAggKey = query_state.agg;
			var lRowKey = query_state.rows[0];
	
			// Generate header row
			var lDataSet = cube_data['1x0'];
			var lRows = [h('tr', h('th', h('span.has-tip', {
					"ev-tooltip-create": new foundation.Tooltip(),
					title: msgs[lang][lAggKey]
			}, msgs[lang][lAggKey])))];
			for (var i in lDataSet) {
					if (lDataSet[i][lRowKey]) {
							var lData = "";
							var lDataTitle = lDataSet[i][lRowKey] + " : ";
							if (!isNaN(lDataSet[i][lAggKey])) {
									lData = schema.format(lang, lAggKey)(lDataSet[i][lAggKey]);
									lDataTitle = lDataTitle + lData;
							} else {
									lDataTitle = lDataTitle + " -";
							}
							lRows.push(h('tr', h('td', h('span.has-tip', {
									"ev-tooltip-create": new foundation.Tooltip(),
									title: lDataTitle
							}, lData))));
					}
			}
	
			// Add sum
			for (var i in cube_data['0x0']) {
					var lData = "0";
					var lDataTitle = msgs[lang][lAggKey] + " : ";
					if (!isNaN(cube_data['0x0'][i][lAggKey].toFixed(0))) {
							lData = schema.format(lang, lAggKey)(cube_data['0x0'][i][lAggKey]);
					}
					lDataTitle = lDataTitle + lData;
					lRows.push(h('tr', h('td.sum-table', h('span.has-tip', {
							"ev-tooltip-create": new foundation.Tooltip(),
							title: lDataTitle
					}, lData))));
			}
			lResult.push(lRows);
	
			return lResult;
	};
	
	Crosstab.render = function (state, lang) {
	
			var sendFocus = hg.BaseEvent(function (ev, broadcast) {
	
					// ... not if clear if this is a hack or not
					//     c.f. https://github.com/Raynos/mercury/issues/36
					var data = ev.target.__data__;
	
					var cell = Object.create({});
					for (var k in data) {
							if (k !== state.query.agg) {
									cell[k] = data[k];
							}
					}
	
					broadcast(assign(this.data, { focus: cell }));
			});
	
			var renderDimentionList = function renderDimentionList(axis) {
					var lResult = [];
	
					for (var i in state.query[axis]) {
							var lAxisName = i18n.htmlize(msgs, state.query[axis][i], lang);
							var lPrefix = (axis == 'cols' ? 'y' : 'x') + (parseInt(i) + 1) + '. ';
	
							lResult.push(h('li', h('span.selected-dimension-bullet' + (i == 0 ? '.first-axis' : ''), [lPrefix, lAxisName])));
					}
					return lResult;
			};
	
			// Check if user selected anything yet
	
			if (state.query.agg.length > 0 || state.query.rows.length > 0 || state.query.cols.length > 0) {
					// Count data items to be displayed in center column
					var lColItems = 0;
					for (var i in state.cube_data['0x1']) {
							lColItems++;
					}
					var lSizingClass = lColItems <= 1 ? '.half-column' : '';
	
					// Construct Table display
					var lTableDisplay = [];
					// Add Y Axis headers column
					lTableDisplay.push(h('div.row-headers-col' + lSizingClass, h('table', { cellSpacing: 0, cellPadding: 0 }, Crosstab.generateRowHeadersColumn(state.query, state.cube_data, lang))));
					// Add X axis and data columns
					if (lColItems > 1) {
							lTableDisplay.push(h('div.data-content', h('table', { cellSpacing: 0, cellPadding: 0 }, Crosstab.generateTableData(state, state.query, state.cube_data, lang))));
					}
					// Add results column
					lTableDisplay.push(h('div.sum-col' + lSizingClass, h('table', { cellSpacing: 0, cellPadding: 0 }, Crosstab.generateSumColumn(state.query, state.cube_data, lang))));
	
					return h('div.content-container', [
					// h('div.y-axis-dimensions-container', h('ul.axis-selected-dimensions', renderDimentionList('rows'))),
	
					h('div.x-axis-data-container', [
					// h('div.x-axis-dimensions-container', h('ul.axis-selected-dimensions', renderDimentionList('cols'))),
					h('div.data-table-container', lTableDisplay), h('div.hint', h('p', getSelectionHint(state, state.query, state.cube_data, lang)))])]);
			} else {
					return h('div.content-container');
			}
	};
	
	exports["default"] = Crosstab;
	module.exports = exports["default"];

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Download Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 08/2015
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(166);
	
	var msgs = __webpack_require__(20);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	var saveAs = __webpack_require__(89);
	var Chart = __webpack_require__(35);
	var jsPDF = __webpack_require__(88);
	var datapoint = __webpack_require__(11);
	
	var vdom = __webpack_require__(182);
	
	var svg_size = [1250, 515];
	
	function Download(url) {
	  return hg.state({
	    open: hg.value(false),
	    svg: hg.value(""),
	    jpeg: hg.value(""),
	    pdf: hg.value(""),
	    url: url,
	    channels: {
	      toggleOpen: Download.toggleOpen
	    }
	  });
	}
	
	Download.toggleOpen = function (state, data) {
	  var isOpen = state.open();
	  state.open.set(!isOpen);
	  if (!isOpen) {
	    var svg_elem = vdom.create(data);
	    var svg_xml = '<?xml version="1.0" standalone="no"?>\n' + '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n' + '<svg xmlns="http://www.w3.org/2000/svg" width="' + svg_size[0] + '" height="' + svg_size[1] + '">\n' + svg_elem.innerHTML + '</svg>';
	    state.svg.set("data:image/svg+xml;base64," + encodeURIComponent(window.btoa(svg_xml)));
	    saveAs.svgAsPngUri(svg_elem, {
	      encoderType: "image/jpeg",
	      backgroundColor: "white",
	      width: svg_size[0],
	      height: svg_size[1]
	    }, function (uri) {
	      state.jpeg.set(uri);
	      var document = new jsPDF("landscape");
	      document.addImage(uri, "JPEG", 10, 40, 280, 160);
	      state.pdf.set(document.output("datauristring"));
	    });
	  }
	};
	
	Download.render = function (state, lang) {
	  var api = datapoint(state.download.url);
	  var all_dims = [].concat(state.query.rows).concat(state.query.cols);
	  var download_url = api.url(all_dims, state.query.agg, state.query.filter);
	
	  return h('div.download-container' + (state.download.open ? '.open' : '.closed'), [h('button.openClose', { 'ev-click': hg.send(state.download.channels.toggleOpen, Chart.render(state.chart, state, state.query, state.cube_data, svg_size, true, lang)) }), h('div.message', msgs[lang]['download']), h('div.formats', [h('a.format', { download: 'cfrp-table.csv', href: download_url }, 'CSV'), h('a.format', { download: 'cfrp-chart.svg', href: state.download.svg }, 'SVG'), h('a.format', { download: 'cfrp-chart.jpg', href: state.download.jpeg }, 'JPG'), h('a.format', { download: 'cfrp-chart.pdf', href: state.download.pdf }, 'PDF')])]);
	};
	
	exports['default'] = Download;
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var schema = __webpack_require__(2);
	var d3 = __webpack_require__(8);
	var msgs = __webpack_require__(3);
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	var svg = __webpack_require__(50);
	var max_group = 10;
	var max_legend = 20;
	var rendering = __webpack_require__(28);
	
	function Legend() {
	  return hg.state({
	    focus: hg.value(null),
	    channels: {
	      focus: function focus(state, key) {
	        console.log(key);
	        state.focus.set(state.focus() == key ? null : key);
	      }
	    }
	  });
	}
	
	function ordinal_domain(data, f) {
	  return typeof f(data[0]) !== 'number';
	}
	
	Legend.render = function (state, app, query, data, lang) {
	  var origdata = data;
	  data = data ? data["1x1"] || [] : [];
	  var f_x = function f_x(d) {
	    return d && query.rows.length ? d[query.rows[query.rows.length - 1]] : 'tous';
	  };
	  var f_y = function f_y(d) {
	    return d[query.agg];
	  };
	  var f_color = function f_color(d) {
	    return d && query.cols.length ? d[query.cols[0]] : 'tous';
	  };
	  var fmt_x = schema.format(lang, query.rows[query.rows.length - 1], 10);
	  var fmt_color = schema.format(lang, query.cols[0], 10);
	  var fmt_color_long = schema.format(lang, query.cols[0]);
	  var ordinal = ordinal_domain(data, function (v) {
	    return fmt_x(f_x(v));
	  });
	
	  var sums = undefined;
	  sums = (origdata ? origdata["0x1"] || [] : []).slice();
	  sums.sort(function (a, b) {
	    return d3.descending(f_y(a), f_y(b));
	  });
	  var sel_vectors = sums.slice(0, max_legend).map(f_color);
	
	  sums = (origdata ? origdata["1x1"] || [] : []).slice();
	  sums = sums.filter(function (d) {
	    var c = f_color(d);
	    var b = sel_vectors.indexOf(c) > -1;
	    //    console.log(c + " : " + b)
	    return true;
	  });
	  sums = sums.sort(function (a, b) {
	    return d3.descending(f_y(a), f_y(b));
	  });
	  var sel_groups = sums.slice(0, max_group).map(f_x);
	
	  var vectors = {};
	  data.forEach(function (d) {
	    var c = f_color(d);
	    var x = f_x(d);
	
	    if (!ordinal && sel_vectors.indexOf(c) !== -1 || ordinal && sel_groups.indexOf(x) !== -1 && sel_vectors.indexOf(c) !== -1) {
	      vectors[c] = vectors[c] || [];
	      vectors[c].push(d);
	    }
	  });
	
	  var legend_labels = d3.keys(vectors);
	  var color = rendering.colors(legend_labels);
	
	  return h('div.legend', [h('h6', msgs[lang][query.cols]), h('div.legend-labels', [].concat(legend_labels.map(function (d, i) {
	    return h('p' + (state.focus == d ? '.highlight' : ''), {
	      'ev-click': [hg.send(app.channels.focus_col, { dimension: query.cols[0], value: d })],
	      title: fmt_color(d)
	    }, [svg('svg', { width: 40, height: 15 }, [svg('path', { d: ordinal ? 'M20 5 h10 v5 h-10 z' : 'M0 8 H30', stroke: color(d), fill: color(d) }), !ordinal ? svg('circle', { cx: 15, cy: 8, r: state.focus == d ? 4 : 2, fill: color(d) }) : null]), h('span', {}, fmt_color(d))]);
	  })))]);
	};
	
	exports['default'] = Legend;
	module.exports = exports['default'];

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query Manipulation Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(9);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var msgs = __webpack_require__(3);
	
	var Aggregate = __webpack_require__(81);
	var TimePeriod = __webpack_require__(85);
	var RangeSelector = __webpack_require__(84);
	var Axis = __webpack_require__(82);
	var Order = __webpack_require__(38);
	var Filter = __webpack_require__(37);
	var DimensionSelector = __webpack_require__(36);
	var schema = __webpack_require__(2);
	
	var datapoint = __webpack_require__(11);
	
	var filter_dims = ["decade", "month", "weekday", "theater_period"];
	
	/** Query selector as a whole **/
	
	function Query(initial_query, url) {
	    var state = hg.state({
	        selectedDimension: hg.value(null),
	
	        // query data
	        agg: Aggregate(initial_query.agg),
	        rows: Axis(initial_query.rows),
	        cols: Axis(initial_query.cols),
	        order: Order(initial_query.order),
	        filter: hg.varhash(initial_query.filter),
	        // local data & server-loaded data
	        filter_state: Filter(),
	        domains_data: hg.varhash({}),
	        domains_data_selection: hg.varhash({}),
	        url: url,
	        // actions
	        channels: {
	            resetSearch: Query.resetSearch,
	            setSelectedDimension: Query.setSelectedDimension,
	            addFilter: Query.addFilter,
	            removeFilter: Query.removeFilter,
	            addFilterRange: Query.addFilterRange,
	            setAggregate: Query.setAggregate,
	            addDimension: Query.addDimension,
	            removeDimension: Query.removeDimension,
	            interchangeAxis: Query.interchangeAxis,
	
	            clearFilter: Query.clearFilter,
	            toggleDimensionOrder: Query.toggleDimensionOrder,
	            togglePivot: Query.togglePivot
	        }
	    });
	
	    loadDomains();
	
	    state.rows(loadDomains);
	    state.cols(loadDomains);
	
	    return state;
	
	    function loadDomains() {
	        var api = datapoint(url);
	
	        var active_dims = [].concat(state.rows()).concat(state.cols());
	        active_dims.forEach(function (dim) {
	            if (!state.domains_data()[dim]) {
	                api.domain(dim, function (vals) {
	                    vals.sort();
	                    state.domains_data.put(dim, vals);
	                });
	            }
	        });
	    }
	
	    // utility function to watch a hash of arrays
	    function initialFilter(filter0) {
	        var filter1 = Object.create({});
	        for (var dim in hash) {
	            filter1.put(dim, hg.array(filter0[dim]));
	        }
	        return hg.varhash(filter1);
	    }
	}
	
	var ORDER_VALUES = ['nat', 'asc', 'desc'];
	
	Query.resetSearch = function (state) {
	    state.agg.set('sum_receipts_weighted');
	    state.rows.set([]);
	    state.cols.set([]);
	    state.filter.set({
	        "decade": [1680, 1690, 1700, 1710, 1720, 1730, 1740, 1750, 1760, 1770, 1780, 1790]
	    });
	    state.selectedDimension.set('');
	};
	
	Query.setSelectedDimension = function (state, data) {
	
	    console.log('select dim');
	    console.log(data);
	
	    // Get filter values for selected dimension
	    var api = datapoint(state.url);
	    var axis = data.axis;
	    var dim = data.dim;
	
	    // Get possible filter values for selected dimension
	    api.domain(dim, function (vals) {
	        schema.sort(vals);
	        state.domains_data_selection.put(dim, vals);
	
	        if (filter_dims.indexOf(dim) != -1) {
	            // Bypass filter selection for preselected filter dimension and just add the dimension
	            // with all filters selected and the scope will be reduced to what was selected
	            // in the time selector
	            var dims = axisByName(state, axis);
	            if (dims.indexOf(dim) === -1) {
	                dims.push(dim);
	            }
	            state.domains_data.put(dim, state.domains_data_selection[dim]);
	            // state.filter.put(dim, state.domains_data_selection[dim])
	        }
	    });
	
	    // If user didn't select a preselected filter dimension, than have him choose between possible filter values
	    if (filter_dims.indexOf(dim) == -1) {
	        // Set selected dimension
	        state.selectedDimension.set(data);
	
	        // Set previously selected filter values if applcable
	        if (state.filter[dim]) {
	            state.filter_selection.put(dim, state.filter[dim]);
	        }
	    } else {
	        // Clear dimension and filter selection
	        state.domains_data_selection.put(dim, null);
	        state.selectedDimension.set('');
	        state.filter_state.search.set('');
	    }
	};
	
	Query.addFilter = function (state, data) {
	    if (state.filter.get(data.dim)) {
	        var filters = state.filter.get(data.dim);
	        if (filters.indexOf(data.value) === -1) {
	            filters.push(data.value);
	            state.filter.put(data.dim, filters);
	        }
	    } else {
	        state.filter.put(data.dim, [data.value]);
	    }
	};
	
	Query.removeFilter = function (state, data) {
	    if (state.filter.get(data.dim)) {
	        var filters = state.filter.get(data.dim);
	        filters.splice(filters.indexOf(data.value), 1);
	        state.filter.put(data.dim, filters);
	    }
	};
	
	Query.addFilterRange = function (state, data) {
	    if (data.values) {
	        var from = data.values.indexOf(data.range.from);
	        var to = data.values.indexOf(data.range.to);
	        if (from != -1 && to != -1 && from <= to) {
	            data.values.slice(from, to + 1).forEach(function (value) {
	                Query.addFilter(state, { dim: data.dim, value: value });
	            });
	        }
	    }
	};
	
	Query.setAggregate = function (query, new_agg) {
	    query.agg.set(new_agg);
	};
	
	Query.clearFilter = function (query, dim) {
	    query.filter.put(dim, []);
	};
	
	// return a *live* version of the observ_struct axis value
	function axisByName(query, axis) {
	    switch (axis) {
	        case 'rows':
	            return query.rows;
	        case 'cols':
	            return query.cols;
	        default:
	            throw "Unknown axis " + axis;
	    }
	}
	
	Query.addDimension = function (query, data) {
	    var axis = data.axis;
	    var dim = data.dim;
	    var filters = data.filters;
	    if (filters) {
	        var dims = axisByName(query, axis);
	        var j = dims.indexOf(dim);
	
	        if (j === -1) {
	            dims.push(dim);
	        }
	
	        // Add selected dimension and filter values into
	        query.domains_data.put(dim, query.domains_data_selection[dim]);
	        query.filter.put(dim, filters);
	    }
	
	    // Clear dimension and filter selection
	    query.domains_data_selection.put(dim, null);
	    query.selectedDimension.set('');
	    query.filter_state.search.set('');
	};
	
	Query.removeDimension = function (query, data) {
	    var axis = data.axis;
	    var dim = data.dim;
	
	    var dims = axisByName(query, axis);
	    var j = dims.indexOf(dim);
	
	    if (j > -1) {
	        dims.splice(j, 1);
	    }
	
	    query.filter.put(dim, []);
	    // query.filter.delete(dim)
	};
	
	Query.interchangeAxis = function (state) {
	    var lRows = state.rows();
	    var lCols = state.cols();
	
	    state.rows.set(lCols);
	    state.cols.set(lRows);
	};
	
	Query.toggleDimensionOrder = function (query, dim) {
	    var order = query.order.get(dim);
	    var k = ORDER_VALUES.indexOf(order);
	    var new_order = ORDER_VALUES[(k + 1) % ORDER_VALUES.length];
	    query.order.put(dim, new_order);
	};
	
	Query.togglePivot = function (query) {
	    var row_splice = query.rows.splice;
	    var col_splice = query.cols.splice;
	
	    var rows = query.rows();
	    var cols = query.cols();
	
	    console.log(JSON.stringify(rows) + ' <--> ' + JSON.stringify(cols));
	
	    row_splice.apply(query.rows, [0, rows.length].concat(cols));
	    col_splice.apply(query.cols, [0, cols.length].concat(rows));
	
	    console.log(JSON.stringify(query.rows()) + ' <--> ' + JSON.stringify(query.cols()));
	};
	
	Query.render = function (app_state, modal_state, query_state, lang) {
	    var api = datapoint(query_state.url);
	    //  return h('div.query', [ String("Current query: " + JSON.stringify(state)) ])
	    var all_dims = [].concat(query_state.rows).concat(query_state.cols);
	    var download_url = api.url(all_dims, query_state.agg, query_state.filter);
	
	    return h('aside.slide-pannel-container', [h('button.fa.fa-chevron-left.slide-pannel-button', {
	        'ev-click': hg.send(modal_state.channels.setPanelOpen)
	    }), h('div.query-show-handle' + (modal_state.queryPanelOpen ? '.hidden-container' : '.visible-container'), {
	        'id': 'query_panel_open',
	        'ev-click': hg.send(modal_state.channels.setPanelOpen)
	    }, [h('div', h('p', msgs[lang]['comparison_tool_open_handle'])), h('button.fa.fa-chevron-right.slide-pannel-button', {
	        'ev-click': hg.send(modal_state.channels.setPanelOpen)
	    })]), h('section.query-container' + (modal_state.queryPanelOpen ? '.visible-container' : '.hidden-container'), { id: 'query_panel' }, [h('div.query-pane-content', [h('header.query-pane-section.header', [h('h1', msgs[lang]['comparison_tool_title']), h('button', { 'ev-click': [hg.send(query_state.channels.resetSearch), hg.send(app_state.channels.reset_dates)] }, msgs[lang]['new_search_button']), h('button', { 'ev-click': [hg.send(app_state.channels.open_calendar)] }, msgs[lang]['calendar_tool_title'])]), h('header.query-pane-section', [h('h2', msgs[lang]['comparison_tool_scope_title']), Aggregate.render(modal_state, query_state, lang)]), h('header.query-pane-section', [h('h2', msgs[lang]['comparison_tool_time_scope_title']), TimePeriod.render(app_state, modal_state, query_state, lang), RangeSelector.render(app_state, modal_state, query_state, lang)]), h('header.query-pane-section' + (modal_state.xAxisDropdownOpen || query_state.selectedDimension && query_state.selectedDimension.axis == 'rows' ? '.interacted' : ''), [h('h2.axis-title', msgs[lang]['comparison_tool_x_title']), Axis.render(modal_state, query_state, 'rows', lang), DimensionSelector.render(modal_state, query_state, 'rows', lang), h('div.arrow-indicator' + (query_state.selectedDimension && query_state.selectedDimension.axis == 'rows' ? '.visible-container' : '.hidden-container')), h('button.interchange-axis-button', { 'ev-click': hg.send(query_state.channels.interchangeAxis) })]), h('header.query-pane-section' + (modal_state.yAxisDropdownOpen || query_state.selectedDimension && query_state.selectedDimension.axis == 'cols' ? '.interacted' : ''), [h('h2.axis-title', msgs[lang]['comparison_tool_y_title']), Axis.render(modal_state, query_state, 'cols', lang), DimensionSelector.render(modal_state, query_state, 'cols', lang), h('div.arrow-indicator' + (query_state.selectedDimension && query_state.selectedDimension.axis == 'cols' ? '.visible-container' : '.hidden-container'))]),, h('section.filter-container' + (modal_state.queryPanelOpen && query_state.selectedDimension ? '.visible-flex-container' : '.hidden-container'), [query_state.selectedDimension ? Filter.render(modal_state, query_state, query_state.selectedDimension.dim, query_state.selectedDimension.axis, lang) : ''])])])]);
	};
	
	exports['default'] = Query;
	module.exports = exports['default'];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var assign = __webpack_require__(7);
	
	var Modal = __webpack_require__(10);
	
	var schema = __webpack_require__(2);
	
	var i18n = __webpack_require__(4);
	
	// see vdom bug below...
	var unique_key = 0;
	
	/** Aggregate selector **/
	
	function Aggregate(initial_agg) {
		return hg.value(initial_agg);
	}
	
	Aggregate.render = function (modal_state, query_state, lang) {
		var cur_agg = query_state.agg;
		var aggregates = schema.aggregate();
	
		var lis = aggregates.map(function (new_agg) {
			// TODO.  virtual-dom doesn't match changes in <input checked ... /> properly
			//        a parallel issue for Mithril: https://github.com/lhorie/mithril.js/issues/691
			//        one workaround is to cache-bust the entire list with a key:
			var attrs = { type: 'radio',
				id: 'aggregate',
				name: 'aggregate' };
			if (cur_agg == new_agg) {
				attrs.checked = true;
			}
	
			return h('li', {
				key: unique_key++,
				'ev-click': [hg.send(query_state.channels.setAggregate, new_agg), hg.send(modal_state.channels.setAggregateDropdownOpen)]
			}, [h('input', attrs), h('label', [h('span.radio', h('span.radio')), i18n.htmlize(msgs, new_agg, lang)])]);
		});
	
		return h('div.aggregate-selector', [h('button.dropdown-list', {
			'ev-click': hg.send(modal_state.channels.setAggregateDropdownOpen)
		}, [h('span.title', i18n.htmlize(msgs, cur_agg, lang)), h('span.fa.right' + (modal_state.aggregateDropdownOpen ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content' + (modal_state.aggregateDropdownOpen ? '.visible-container' : '.hidden-container'), lis)]);
	};
	
	exports['default'] = Aggregate;
	module.exports = exports['default'];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	* David Talbot, Laval University, 04/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var assign = __webpack_require__(7);
	
	var Order = __webpack_require__(38);
	var Filter = __webpack_require__(37);
	var DimensionSelector = __webpack_require__(36);
	
	var Modal = __webpack_require__(10);
	var i18n = __webpack_require__(4);
	
	var schema = __webpack_require__(2);
	
	/** Axis selector **/
	
	function Axis(initial_dims) {
	  return hg.array(initial_dims);
	}
	
	Axis.render = function (modal_state, query_state, axis, lang) {
	  var dims = query_state[axis] || [];
	  var lIndex = 0;
	
	  var sel_lis = dims.map(function (dim) {
	    var sel_values = query_state.filter[dim] || [];
	    lIndex++;
	    var lLabelPrefix = (axis == 'rows' ? 'x' : 'y') + lIndex + '. ';
	    return h('li', [
	    //Order.render(query_state, dim),
	    h('span.selected-dimension-bullet' + (query_state.selectedDimension && query_state.selectedDimension.axis == axis && query_state.selectedDimension.dim == dim ? '.selected' : '') + (lIndex == 1 ? '.first-axis' : ''), [h('label', { 'ev-click': hg.send(query_state.channels.setSelectedDimension, { axis: axis, dim: dim }) }, [lLabelPrefix, i18n.htmlize(msgs, dim, lang)]), h('span.fa.fa-close', { 'ev-click': [hg.send(query_state.channels.removeDimension, { axis: axis, dim: dim }), hg.send(modal_state.channels.resetSelectedFilterValue, { dim: dim })] })])]);
	  });
	
	  return h('ul.axis-selected-dimensions', sel_lis);
	};
	
	exports['default'] = Axis;
	module.exports = exports['default'];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* David Talbot, 07/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	var schema = __webpack_require__(2);
	
	var i18n = __webpack_require__(4);
	var msgs = __webpack_require__(3);
	
	function listPeriodFiltersOptions(app_state, query_state, dimension, values, lang) {
	  var options = [];
	  var format = schema.format(lang, dimension);
	  for (var i in values) {
	    var current_value = values[i];
	    var selected = isFilterSelected(app_state.period_filters[dimension], current_value);
	    options.push(h('li.custom-checkbox', {
	      'ev-click': [hg.send(app_state.channels.add_period_filter, { dim: dimension, value: current_value }), hg.send(query_state.channels.addFilter, { dim: dimension, value: current_value })],
	      value: current_value
	    }, [h('input', { type: 'checkbox' }), h('label' + (selected ? '.selected-filter' : ''), [h('span.custom-input'), h('span', format(current_value))])]));
	  }
	  return options;
	};
	
	function isFilterSelected(dimension_filters, value) {
	  var selected = false;
	  if (dimension_filters) {
	    selected = dimension_filters.indexOf(value) != -1;
	  }
	  return selected;
	}
	
	function listFilters(app_state, query_state, lang) {
	  var sel_lis = Object.keys(app_state.period_filters).map(function (dim) {
	    var format = schema.format(lang, dim);
	    var sel_values = app_state.period_filters[dim] || [];
	    return sel_values.map(function (value) {
	      return h('li', [
	      //Order.render(query_state, dim),
	      h('span.selected-dimension-bullet', [h('label', [format(value)]), h('span.fa.fa-close', { 'ev-click': [hg.send(app_state.channels.remove_period_filter, { dim: dim, value: value }), hg.send(query_state.channels.removeFilter, { dim: dim, value: value })] })])]);
	    });
	  });
	
	  return h('ul.selected-period-filters', sel_lis);
	}
	
	exports.listPeriodFiltersOptions = listPeriodFiltersOptions;
	exports.listFilters = listFilters;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * MDAT Query manipulation component
	 *
	 * Copyright (c) 2015 MIT Hyperstudio
	 * David Talbot, 07/2016
	 *
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var assign = __webpack_require__(7);
	
	var Modal = __webpack_require__(10);
	
	var datapoint = __webpack_require__(11);
	
	var schema = __webpack_require__(2);
	
	var i18n = __webpack_require__(4);
	var range = __webpack_require__(83);
	
	/** Time period selector **/
	
	function RangeSelector(query_state) {
	
	    return hg.state({});
	}
	
	RangeSelector.render = function (app_state, modal_state, query_state, lang) {
	    return h('div.selector.date-period-selector', [range.listFilters(app_state, query_state, lang), h('button.dropdown-list', {
	        'ev-click': hg.send(app_state.channels.open_month_period_filter)
	    }, [h('span.title', msgs[lang].month), h('span.fa.right' + (app_state.month_filter_opened ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content.axis-content' + (app_state.month_filter_opened ? '.visible-container' : '.hidden-container'), range.listPeriodFiltersOptions(app_state, query_state, "month", app_state.available_months, lang)), h('button.selector.dropdown-list', {
	        'ev-click': hg.send(app_state.channels.open_day_period_filter)
	    }, [h('span.title', msgs[lang].weekday), h('span.fa.right' + (app_state.day_filter_opened ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content.axis-content' + (app_state.day_filter_opened ? '.visible-container' : '.hidden-container'), range.listPeriodFiltersOptions(app_state, query_state, "weekday", app_state.available_weekdays, lang)), h('button.selector.dropdown-list', {
	        'ev-click': hg.send(app_state.channels.open_theater_period_filter)
	    }, [h('span.title', msgs[lang].theater), h('span.fa.right' + (app_state.theater_filter_opened ? '.fa-chevron-up' : '.fa-chevron-down'))]), h('ul.dropdown-list-content.axis-content' + (app_state.theater_filter_opened ? '.visible-container' : '.hidden-container'), range.listPeriodFiltersOptions(app_state, query_state, "theater_period", app_state.available_theater_periods, lang))]);
	};
	
	exports['default'] = RangeSelector;
	module.exports = exports['default'];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Query manipulation component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* David Talbot, 05/2016
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(9);
	
	var msgs = __webpack_require__(3);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var assign = __webpack_require__(7);
	
	var Modal = __webpack_require__(10);
	
	var datapoint = __webpack_require__(11);
	
	var schema = __webpack_require__(2);
	
	var i18n = __webpack_require__(4);
	
	/** Time period selector **/
	
	function TimePeriod(query_state) {
	
	  return hg.state({});
	}
	
	TimePeriod.render = function (app_state, modal_state, query_state, lang) {
	  var msgs_i18n = msgs[lang];
	
	  var buildSelectOptionsFct = function buildSelectOptionsFct(selected_decade) {
	    var lAvailableDecades = app_state.available_decades;
	    var lResult = [];
	    for (var i in lAvailableDecades) {
	      var lCurrentDecade = lAvailableDecades[i];
	      var lSelected = false;
	      if (selected_decade == lCurrentDecade) {
	        lSelected = true;
	      }
	      lResult.push(h('option', { value: lCurrentDecade, selected: lSelected }, lCurrentDecade));
	    }
	    return lResult;
	  };
	
	  var createDateSelector = function createDateSelector(name, channel, options) {
	    var selector = undefined;
	    if (app_state.pane_display === 1) {
	      selector = h('select', {
	        'name': name,
	        'ev-event': hg.sendChange(channel)
	      }, buildSelectOptionsFct(options));
	    } else {
	      selector = h('input', {
	        type: 'number',
	        min: '1680',
	        max: '1790',
	        step: 1,
	        value: options,
	        name: name,
	        'ev-blur': hg.sendValue(channel)
	      });
	    }
	    return selector;
	  };
	
	  return h('div.row.time-period-selector', [h('span', msgs_i18n.from), createDateSelector('startDate', app_state.channels.set_start_date, app_state.start_date), h('span', msgs_i18n.to), createDateSelector('endDate', app_state.channels.set_end_date, app_state.end_date), h('button.secondary', {
	    'ev-click': [hg.send(app_state.channels.sel_dates, {
	      startDate: app_state.start_date ? app_state.start_date.toString() + '-04-01' : '-',
	      endDate: app_state.end_date ? app_state.end_date.toString() + '-03-31' : '-'
	    }), hg.send(query_state.channels.addFilterRange, {
	      dim: "decade",
	      values: app_state.available_decades,
	      range: {
	        from: app_state.start_date,
	        to: app_state.end_date
	      }
	    })]
	  }, msgs_i18n.ok)]);
	};
	
	exports['default'] = TimePeriod;
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Register Image Component
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 04/2015
	*
	* TODO : This component is not actively used (not called in app.js) and may be removed in future if not needed. Kept for possible reintegration (dtalbot)
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	__webpack_require__(167);
	
	var hg = __webpack_require__(1);
	var h = __webpack_require__(1).h;
	
	var svg = __webpack_require__(71);
	
	var d3 = __webpack_require__(8);
	
	var format = d3.time.format('%Y-%m-%d');
	
	/*
	* DOM based image viewer, with zoom and pan transforms vis CSS3
	*
	* Pipes events through d3's zoom behavior for cross-browser consistency.
	*
	* I decided to break with flex+react style unidirectional flow of data
	* and store image scale & translation in a small widget because:
	*
	* (1) this gives better user experience during zoom (no jerkiness)
	* (2) from the application's point of view, zoom state is transient
	* (3) BUT scale & translate persist even when user chooses a new register page
	* (4) AND feeding d3's zoom event back through mercury's dom-delegator is doable,
	*         but complex; dom-delegator is really intended for DOM events
	*/
	
	function ImageWidget(url, start_scale) {
	  this.url = url;
	  this.start_scale = start_scale || 1.0;
	}
	
	ImageWidget.prototype.type = 'Widget';
	
	ImageWidget.prototype.init = function () {
	  // create container and image
	  var register = document.createElement('div');
	  register.className = 'register';
	
	  var img = document.createElement('img');
	  img.style['transform-origin'] = '0 0';
	  register.appendChild(img);
	
	  // prepare d3 zoom behavior
	  var zoom = d3.behavior.zoom().scale(this.start_scale).on('zoom', zoomed);
	
	  d3.select(register).call(zoom);
	
	  rescale([0, 0], this.start_scale);
	
	  return register;
	
	  function zoomed() {
	    // only now are register dimensions set correctly
	    var parentWidth = register.offsetWidth;
	    var parentHeight = register.offsetHeight;
	    var min_scale = Math.min(parentWidth / img.width, parentHeight / img.height);
	
	    // get current position
	    var s = Math.max(d3.event.scale, min_scale);
	
	    var _d3$event$translate = _slicedToArray(d3.event.translate, 2);
	
	    var tx = _d3$event$translate[0];
	    var ty = _d3$event$translate[1];
	
	    // no dragging beyond bounds
	    tx = Math.max(Math.min(tx, 0), parentWidth - img.width * s);
	    ty = Math.max(Math.min(ty, 0), parentHeight - img.height * s);
	
	    // center when possible
	    tx = Math.min(tx, Math.max(0, (parentWidth - img.width * s) / 2.0));
	    ty = Math.min(ty, Math.max(0, (parentHeight - img.height * s) / 2.0));
	
	    // update zoom behavior and dom element
	    zoom.scaleExtent([min_scale, 1.2]).scale(s).translate([tx, ty]);
	
	    rescale([tx, ty], s);
	  }
	
	  function rescale(translate, scale) {
	    img.style.transform = 'translate(' + translate.map(function (r) {
	      return r + 'px';
	    }).join(', ') + ') ' + 'scale(' + scale + ')';
	  }
	};
	
	ImageWidget.prototype.update = function (prev, register) {
	  var img = register.querySelector('img');
	  img.src = this.url;
	};
	
	// Register component proper
	
	function Register() {
	  return hg.state({
	    url: hg.value(null),
	    channels: {
	      setDate: Register.setDate
	    }
	  });
	}
	
	Register.setDate = function (state, url, date) {
	  date = format(date);
	  d3.text(url + '/image?date=' + date, function (err, data) {
	    if (err) {
	      data = null;
	      console.log(err);
	    }
	    state.url.set(data);
	  });
	};
	
	Register.render = function (state) {
	  return new ImageWidget(state.url, 0.4);
	};
	
	exports['default'] = Register;
	module.exports = exports['default'];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';!(function($){"use strict";var FOUNDATION_VERSION='6.2.4'; // Global Foundation object
	// This is attached to the window, or used as a module for AMD/Browserify
	var Foundation={version:FOUNDATION_VERSION, /**
	     * Stores initialized plugins.
	     */_plugins:{}, /**
	     * Stores generated unique ids for plugin instances
	     */_uuids:[], /**
	     * Returns a boolean for RTL support
	     */rtl:function rtl(){return $('html').attr('dir') === 'rtl';}, /**
	     * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
	     * @param {Object} plugin - The constructor of the plugin.
	     */plugin:function plugin(_plugin,name){ // Object key to use when adding to global Foundation object
	// Examples: Foundation.Reveal, Foundation.OffCanvas
	var className=name || functionName(_plugin); // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
	// Examples: data-reveal, data-off-canvas
	var attrName=hyphenate(className); // Add to the Foundation object and the plugins list (for reflowing)
	this._plugins[attrName] = this[className] = _plugin;}, /**
	     * @function
	     * Populates the _uuids array with pointers to each individual plugin instance.
	     * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
	     * Also fires the initialization event for each plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @param {String} name - the name of the plugin, passed as a camelCased string.
	     * @fires Plugin#init
	     */registerPlugin:function registerPlugin(plugin,name){var pluginName=name?hyphenate(name):functionName(plugin.constructor).toLowerCase();plugin.uuid = this.GetYoDigits(6,pluginName);if(!plugin.$element.attr('data-' + pluginName)){plugin.$element.attr('data-' + pluginName,plugin.uuid);}if(!plugin.$element.data('zfPlugin')){plugin.$element.data('zfPlugin',plugin);} /**
	       * Fires when the plugin has initialized.
	       * @event Plugin#init
	       */plugin.$element.trigger('init.zf.' + pluginName);this._uuids.push(plugin.uuid);return;}, /**
	     * @function
	     * Removes the plugins uuid from the _uuids array.
	     * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
	     * Also fires the destroyed event for the plugin, consolidating repetitive code.
	     * @param {Object} plugin - an instance of a plugin, usually `this` in context.
	     * @fires Plugin#destroyed
	     */unregisterPlugin:function unregisterPlugin(plugin){var pluginName=hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));this._uuids.splice(this._uuids.indexOf(plugin.uuid),1);plugin.$element.removeAttr('data-' + pluginName).removeData('zfPlugin') /**
	       * Fires when the plugin has been destroyed.
	       * @event Plugin#destroyed
	       */.trigger('destroyed.zf.' + pluginName);for(var prop in plugin) {plugin[prop] = null; //clean up script to prep for garbage collection.
	}return;}, /**
	     * @function
	     * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
	     * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
	     * @default If no argument is passed, reflow all currently active plugins.
	     */reInit:function reInit(plugins){var isJQ=plugins instanceof $;try{if(isJQ){plugins.each(function(){$(this).data('zfPlugin')._init();});}else {var type=typeof plugins,_this=this,fns={'object':function object(plgs){plgs.forEach(function(p){p = hyphenate(p);$('[data-' + p + ']').foundation('_init');});},'string':function string(){plugins = hyphenate(plugins);$('[data-' + plugins + ']').foundation('_init');},'undefined':function undefined(){this['object'](Object.keys(_this._plugins));}};fns[type](plugins);}}catch(err) {console.error(err);}finally {return plugins;}}, /**
	     * returns a random base-36 uid with namespacing
	     * @function
	     * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
	     * @param {String} namespace - name of plugin to be incorporated in uid, optional.
	     * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
	     * @returns {String} - unique id
	     */GetYoDigits:function GetYoDigits(length,namespace){length = length || 6;return Math.round(Math.pow(36,length + 1) - Math.random() * Math.pow(36,length)).toString(36).slice(1) + (namespace?'-' + namespace:'');}, /**
	     * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
	     * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
	     * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
	     */reflow:function reflow(elem,plugins){ // If plugins is undefined, just grab everything
	if(typeof plugins === 'undefined'){plugins = Object.keys(this._plugins);} // If plugins is a string, convert it to an array with one item
	else if(typeof plugins === 'string'){plugins = [plugins];}var _this=this; // Iterate through each plugin
	$.each(plugins,function(i,name){ // Get the current plugin
	var plugin=_this._plugins[name]; // Localize the search to all elements inside elem, as well as elem itself, unless elem === document
	var $elem=$(elem).find('[data-' + name + ']').addBack('[data-' + name + ']'); // For each plugin found, initialize it
	$elem.each(function(){var $el=$(this),opts={}; // Don't double-dip on plugins
	if($el.data('zfPlugin')){console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");return;}if($el.attr('data-options')){var thing=$el.attr('data-options').split(';').forEach(function(e,i){var opt=e.split(':').map(function(el){return el.trim();});if(opt[0])opts[opt[0]] = parseValue(opt[1]);});}try{$el.data('zfPlugin',new plugin($(this),opts));}catch(er) {console.error(er);}finally {return;}});});},getFnName:functionName,transitionend:function transitionend($elem){var transitions={'transition':'transitionend','WebkitTransition':'webkitTransitionEnd','MozTransition':'transitionend','OTransition':'otransitionend'};var elem=document.createElement('div'),end;for(var t in transitions) {if(typeof elem.style[t] !== 'undefined'){end = transitions[t];}}if(end){return end;}else {end = setTimeout(function(){$elem.triggerHandler('transitionend',[$elem]);},1);return 'transitionend';}}};Foundation.util = { /**
	     * Function for applying a debounce effect to a function call.
	     * @function
	     * @param {Function} func - Function to be called at end of timeout.
	     * @param {Number} delay - Time in ms to delay the call of `func`.
	     * @returns function
	     */throttle:function throttle(func,delay){var timer=null;return function(){var context=this,args=arguments;if(timer === null){timer = setTimeout(function(){func.apply(context,args);timer = null;},delay);}};}}; // TODO: consider not making this a jQuery function
	// TODO: need way to reflow vs. re-initialize
	/**
	   * The Foundation jQuery method.
	   * @param {String|Array} method - An action to perform on the current jQuery object.
	   */var foundation=function foundation(method){var type=typeof method,$meta=$('meta.foundation-mq'),$noJS=$('.no-js');if(!$meta.length){$('<meta class="foundation-mq">').appendTo(document.head);}if($noJS.length){$noJS.removeClass('no-js');}if(type === 'undefined'){ //needs to initialize the Foundation object, or an individual plugin.
	Foundation.MediaQuery._init();Foundation.reflow(this);}else if(type === 'string'){ //an individual method to invoke on a plugin or group of plugins
	var args=Array.prototype.slice.call(arguments,1); //collect all the arguments, if necessary
	var plugClass=this.data('zfPlugin'); //determine the class of plugin
	if(plugClass !== undefined && plugClass[method] !== undefined){ //make sure both the class and method exist
	if(this.length === 1){ //if there's only one, call it directly.
	plugClass[method].apply(plugClass,args);}else {this.each(function(i,el){ //otherwise loop through the jQuery collection and invoke the method on each
	plugClass[method].apply($(el).data('zfPlugin'),args);});}}else { //error for no class or no method
	throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass?functionName(plugClass):'this element') + '.');}}else { //error for invalid argument type
	throw new TypeError('We\'re sorry, ' + type + ' is not a valid parameter. You must use a string representing the method you wish to invoke.');}return this;};window.Foundation = Foundation;$.fn.foundation = foundation; // Polyfill for requestAnimationFrame
	(function(){if(!Date.now || !window.Date.now)window.Date.now = Date.now = function(){return new Date().getTime();};var vendors=['webkit','moz'];for(var i=0;i < vendors.length && !window.requestAnimationFrame;++i) {var vp=vendors[i];window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];}if(/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame){var lastTime=0;window.requestAnimationFrame = function(callback){var now=Date.now();var nextTime=Math.max(lastTime + 16,now);return setTimeout(function(){callback(lastTime = nextTime);},nextTime - now);};window.cancelAnimationFrame = clearTimeout;} /**
	     * Polyfill for performance.now, required by rAF
	     */if(!window.performance || !window.performance.now){window.performance = {start:Date.now(),now:function now(){return Date.now() - this.start;}};}})();if(!Function.prototype.bind){Function.prototype.bind = function(oThis){if(typeof this !== 'function'){ // closest thing possible to the ECMAScript 5
	// internal IsCallable function
	throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');}var aArgs=Array.prototype.slice.call(arguments,1),fToBind=this,fNOP=function fNOP(){},fBound=function fBound(){return fToBind.apply(this instanceof fNOP?this:oThis,aArgs.concat(Array.prototype.slice.call(arguments)));};if(this.prototype){ // native functions don't have a prototype
	fNOP.prototype = this.prototype;}fBound.prototype = new fNOP();return fBound;};} // Polyfill to get the name of a function in IE9
	function functionName(fn){if(Function.prototype.name === undefined){var funcNameRegex=/function\s([^(]{1,})\(/;var results=funcNameRegex.exec(fn.toString());return results && results.length > 1?results[1].trim():"";}else if(fn.prototype === undefined){return fn.constructor.name;}else {return fn.prototype.constructor.name;}}function parseValue(str){if(/true/.test(str))return true;else if(/false/.test(str))return false;else if(!isNaN(str * 1))return parseFloat(str);return str;} // Convert PascalCase to kebab-case
	// Thank you: http://stackoverflow.com/a/8955580
	function hyphenate(str){return str.replace(/([a-z])([A-Z])/g,'$1-$2').toLowerCase();}})(jQuery);'use strict';!(function($){ // Default set of media queries
	var defaultQueries={'default':'only screen',landscape:'only screen and (orientation: landscape)',portrait:'only screen and (orientation: portrait)',retina:'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'};var MediaQuery={queries:[],current:'', /**
	     * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
	     * @function
	     * @private
	     */_init:function _init(){var self=this;var extractedStyles=$('.foundation-mq').css('font-family');var namedQueries;namedQueries = parseStyleToObject(extractedStyles);for(var key in namedQueries) {if(namedQueries.hasOwnProperty(key)){self.queries.push({name:key,value:'only screen and (min-width: ' + namedQueries[key] + ')'});}}this.current = this._getCurrentSize();this._watcher();}, /**
	     * Checks if the screen is at least as wide as a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to check.
	     * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
	     */atLeast:function atLeast(size){var query=this.get(size);if(query){return window.matchMedia(query).matches;}return false;}, /**
	     * Gets the media query of a breakpoint.
	     * @function
	     * @param {String} size - Name of the breakpoint to get.
	     * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
	     */get:function get(size){for(var i in this.queries) {if(this.queries.hasOwnProperty(i)){var query=this.queries[i];if(size === query.name)return query.value;}}return null;}, /**
	     * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
	     * @function
	     * @private
	     * @returns {String} Name of the current breakpoint.
	     */_getCurrentSize:function _getCurrentSize(){var matched;for(var i=0;i < this.queries.length;i++) {var query=this.queries[i];if(window.matchMedia(query.value).matches){matched = query;}}if(typeof matched === 'object'){return matched.name;}else {return matched;}}, /**
	     * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
	     * @function
	     * @private
	     */_watcher:function _watcher(){var _this=this;$(window).on('resize.zf.mediaquery',function(){var newSize=_this._getCurrentSize(),currentSize=_this.current;if(newSize !== currentSize){ // Change the current media query
	_this.current = newSize; // Broadcast the media query change on the window
	$(window).trigger('changed.zf.mediaquery',[newSize,currentSize]);}});}};Foundation.MediaQuery = MediaQuery; // matchMedia() polyfill - Test a CSS media type/query in JS.
	// Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license
	window.matchMedia || (window.matchMedia = (function(){'use strict'; // For browsers that support matchMedium api such as IE 9 and webkit
	var styleMedia=window.styleMedia || window.media; // For those that don't support matchMedium
	if(!styleMedia){var style=document.createElement('style'),script=document.getElementsByTagName('script')[0],info=null;style.type = 'text/css';style.id = 'matchmediajs-test';script && script.parentNode && script.parentNode.insertBefore(style,script); // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
	info = 'getComputedStyle' in window && window.getComputedStyle(style,null) || style.currentStyle;styleMedia = {matchMedium:function matchMedium(media){var text='@media ' + media + '{ #matchmediajs-test { width: 1px; } }'; // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
	if(style.styleSheet){style.styleSheet.cssText = text;}else {style.textContent = text;} // Test if media query is true or false
	return info.width === '1px';}};}return function(media){return {matches:styleMedia.matchMedium(media || 'all'),media:media || 'all'};};})()); // Thank you: https://github.com/sindresorhus/query-string
	function parseStyleToObject(str){var styleObject={};if(typeof str !== 'string'){return styleObject;}str = str.trim().slice(1,-1); // browsers re-quote string style values
	if(!str){return styleObject;}styleObject = str.split('&').reduce(function(ret,param){var parts=param.replace(/\+/g,' ').split('=');var key=parts[0];var val=parts[1];key = decodeURIComponent(key); // missing `=` should be `null`:
	// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
	val = val === undefined?null:decodeURIComponent(val);if(!ret.hasOwnProperty(key)){ret[key] = val;}else if(Array.isArray(ret[key])){ret[key].push(val);}else {ret[key] = [ret[key],val];}return ret;},{});return styleObject;}Foundation.MediaQuery = MediaQuery;})(jQuery);'use strict';!(function($){Foundation.Box = {ImNotTouchingYou:ImNotTouchingYou,GetDimensions:GetDimensions,GetOffsets:GetOffsets}; /**
	   * Compares the dimensions of an element to a container and determines collision events with container.
	   * @function
	   * @param {jQuery} element - jQuery object to test for collisions.
	   * @param {jQuery} parent - jQuery object to use as bounding container.
	   * @param {Boolean} lrOnly - set to true to check left and right values only.
	   * @param {Boolean} tbOnly - set to true to check top and bottom values only.
	   * @default if no parent object passed, detects collisions with `window`.
	   * @returns {Boolean} - true if collision free, false if a collision in any direction.
	   */function ImNotTouchingYou(element,parent,lrOnly,tbOnly){var eleDims=GetDimensions(element),top,bottom,left,right;if(parent){var parDims=GetDimensions(parent);bottom = eleDims.offset.top + eleDims.height <= parDims.height + parDims.offset.top;top = eleDims.offset.top >= parDims.offset.top;left = eleDims.offset.left >= parDims.offset.left;right = eleDims.offset.left + eleDims.width <= parDims.width + parDims.offset.left;}else {bottom = eleDims.offset.top + eleDims.height <= eleDims.windowDims.height + eleDims.windowDims.offset.top;top = eleDims.offset.top >= eleDims.windowDims.offset.top;left = eleDims.offset.left >= eleDims.windowDims.offset.left;right = eleDims.offset.left + eleDims.width <= eleDims.windowDims.width;}var allDirs=[bottom,top,left,right];if(lrOnly){return left === right === true;}if(tbOnly){return top === bottom === true;}return allDirs.indexOf(false) === -1;}; /**
	   * Uses native methods to return an object of dimension values.
	   * @function
	   * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
	   * @returns {Object} - nested object of integer pixel values
	   * TODO - if element is window, return only those values.
	   */function GetDimensions(elem,test){elem = elem.length?elem[0]:elem;if(elem === window || elem === document){throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");}var rect=elem.getBoundingClientRect(),parRect=elem.parentNode.getBoundingClientRect(),winRect=document.body.getBoundingClientRect(),winY=window.pageYOffset,winX=window.pageXOffset;return {width:rect.width,height:rect.height,offset:{top:rect.top + winY,left:rect.left + winX},parentDims:{width:parRect.width,height:parRect.height,offset:{top:parRect.top + winY,left:parRect.left + winX}},windowDims:{width:winRect.width,height:winRect.height,offset:{top:winY,left:winX}}};} /**
	   * Returns an object of top and left integer pixel values for dynamically rendered elements,
	   * such as: Tooltip, Reveal, and Dropdown
	   * @function
	   * @param {jQuery} element - jQuery object for the element being positioned.
	   * @param {jQuery} anchor - jQuery object for the element's anchor point.
	   * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
	   * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
	   * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
	   * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
	   * TODO alter/rewrite to work with `em` values as well/instead of pixels
	   */function GetOffsets(element,anchor,position,vOffset,hOffset,isOverflow){var $eleDims=GetDimensions(element),$anchorDims=anchor?GetDimensions(anchor):null;switch(position){case 'top':return {left:Foundation.rtl()?$anchorDims.offset.left - $eleDims.width + $anchorDims.width:$anchorDims.offset.left,top:$anchorDims.offset.top - ($eleDims.height + vOffset)};break;case 'left':return {left:$anchorDims.offset.left - ($eleDims.width + hOffset),top:$anchorDims.offset.top};break;case 'right':return {left:$anchorDims.offset.left + $anchorDims.width + hOffset,top:$anchorDims.offset.top};break;case 'center top':return {left:$anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,top:$anchorDims.offset.top - ($eleDims.height + vOffset)};break;case 'center bottom':return {left:isOverflow?hOffset:$anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2,top:$anchorDims.offset.top + $anchorDims.height + vOffset};break;case 'center left':return {left:$anchorDims.offset.left - ($eleDims.width + hOffset),top:$anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2};break;case 'center right':return {left:$anchorDims.offset.left + $anchorDims.width + hOffset + 1,top:$anchorDims.offset.top + $anchorDims.height / 2 - $eleDims.height / 2};break;case 'center':return {left:$eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2,top:$eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - $eleDims.height / 2};break;case 'reveal':return {left:($eleDims.windowDims.width - $eleDims.width) / 2,top:$eleDims.windowDims.offset.top + vOffset};case 'reveal full':return {left:$eleDims.windowDims.offset.left,top:$eleDims.windowDims.offset.top};break;case 'left bottom':return {left:$anchorDims.offset.left,top:$anchorDims.offset.top + $anchorDims.height};break;case 'right bottom':return {left:$anchorDims.offset.left + $anchorDims.width + hOffset - $eleDims.width,top:$anchorDims.offset.top + $anchorDims.height};break;default:return {left:Foundation.rtl()?$anchorDims.offset.left - $eleDims.width + $anchorDims.width:$anchorDims.offset.left + hOffset,top:$anchorDims.offset.top + $anchorDims.height + vOffset};}}})(jQuery);'use strict';!(function($){ /**
	   * Motion module.
	   * @module foundation.motion
	   */var initClasses=['mui-enter','mui-leave'];var activeClasses=['mui-enter-active','mui-leave-active'];var Motion={animateIn:function animateIn(element,animation,cb){animate(true,element,animation,cb);},animateOut:function animateOut(element,animation,cb){animate(false,element,animation,cb);}};function Move(duration,elem,fn){var anim,prog,start=null; // console.log('called');
	function move(ts){if(!start)start = window.performance.now(); // console.log(start, ts);
	prog = ts - start;fn.apply(elem);if(prog < duration){anim = window.requestAnimationFrame(move,elem);}else {window.cancelAnimationFrame(anim);elem.trigger('finished.zf.animate',[elem]).triggerHandler('finished.zf.animate',[elem]);}}anim = window.requestAnimationFrame(move);} /**
	   * Animates an element in or out using a CSS transition class.
	   * @function
	   * @private
	   * @param {Boolean} isIn - Defines if the animation is in or out.
	   * @param {Object} element - jQuery or HTML object to animate.
	   * @param {String} animation - CSS class to use.
	   * @param {Function} cb - Callback to run when animation is finished.
	   */function animate(isIn,element,animation,cb){element = $(element).eq(0);if(!element.length)return;var initClass=isIn?initClasses[0]:initClasses[1];var activeClass=isIn?activeClasses[0]:activeClasses[1]; // Set up the animation
	reset();element.addClass(animation).css('transition','none');requestAnimationFrame(function(){element.addClass(initClass);if(isIn)element.show();}); // Start the animation
	requestAnimationFrame(function(){element[0].offsetWidth;element.css('transition','').addClass(activeClass);}); // Clean up the animation when it finishes
	element.one(Foundation.transitionend(element),finish); // Hides the element (for out animations), resets the element, and runs a callback
	function finish(){if(!isIn)element.hide();reset();if(cb)cb.apply(element);} // Resets transitions and removes motion-specific classes
	function reset(){element[0].style.transitionDuration = 0;element.removeClass(initClass + ' ' + activeClass + ' ' + animation);}}Foundation.Move = Move;Foundation.Motion = Motion;})(jQuery);'use strict';!(function($){var MutationObserver=(function(){var prefixes=['WebKit','Moz','O','Ms',''];for(var i=0;i < prefixes.length;i++) {if(prefixes[i] + 'MutationObserver' in window){return window[prefixes[i] + 'MutationObserver'];}}return false;})();var triggers=function triggers(el,type){el.data(type).split(' ').forEach(function(id){$('#' + id)[type === 'close'?'trigger':'triggerHandler'](type + '.zf.trigger',[el]);});}; // Elements with [data-open] will reveal a plugin that supports it when clicked.
	$(document).on('click.zf.trigger','[data-open]',function(){triggers($(this),'open');}); // Elements with [data-close] will close a plugin that supports it when clicked.
	// If used without a value on [data-close], the event will bubble, allowing it to close a parent component.
	$(document).on('click.zf.trigger','[data-close]',function(){var id=$(this).data('close');if(id){triggers($(this),'close');}else {$(this).trigger('close.zf.trigger');}}); // Elements with [data-toggle] will toggle a plugin that supports it when clicked.
	$(document).on('click.zf.trigger','[data-toggle]',function(){triggers($(this),'toggle');}); // Elements with [data-closable] will respond to close.zf.trigger events.
	$(document).on('close.zf.trigger','[data-closable]',function(e){e.stopPropagation();var animation=$(this).data('closable');if(animation !== ''){Foundation.Motion.animateOut($(this),animation,function(){$(this).trigger('closed.zf');});}else {$(this).fadeOut().trigger('closed.zf');}});$(document).on('focus.zf.trigger blur.zf.trigger','[data-toggle-focus]',function(){var id=$(this).data('toggle-focus');$('#' + id).triggerHandler('toggle.zf.trigger',[$(this)]);}); /**
	  * Fires once after all other scripts have loaded
	  * @function
	  * @private
	  */$(window).on('load',function(){checkListeners();});function checkListeners(){eventsListener();resizeListener();scrollListener();closemeListener();} //******** only fires this function once on load, if there's something to watch ********
	function closemeListener(pluginName){var yetiBoxes=$('[data-yeti-box]'),plugNames=['dropdown','tooltip','reveal'];if(pluginName){if(typeof pluginName === 'string'){plugNames.push(pluginName);}else if(typeof pluginName === 'object' && typeof pluginName[0] === 'string'){plugNames.concat(pluginName);}else {console.error('Plugin names must be strings');}}if(yetiBoxes.length){var listeners=plugNames.map(function(name){return 'closeme.zf.' + name;}).join(' ');$(window).off(listeners).on(listeners,function(e,pluginId){var plugin=e.namespace.split('.')[0];var plugins=$('[data-' + plugin + ']').not('[data-yeti-box="' + pluginId + '"]');plugins.each(function(){var _this=$(this);_this.triggerHandler('close.zf.trigger',[_this]);});});}}function resizeListener(debounce){var timer=void 0,$nodes=$('[data-resize]');if($nodes.length){$(window).off('resize.zf.trigger').on('resize.zf.trigger',function(e){if(timer){clearTimeout(timer);}timer = setTimeout(function(){if(!MutationObserver){ //fallback for IE 9
	$nodes.each(function(){$(this).triggerHandler('resizeme.zf.trigger');});} //trigger all listening elements and signal a resize event
	$nodes.attr('data-events',"resize");},debounce || 10); //default time to emit resize event
	});}}function scrollListener(debounce){var timer=void 0,$nodes=$('[data-scroll]');if($nodes.length){$(window).off('scroll.zf.trigger').on('scroll.zf.trigger',function(e){if(timer){clearTimeout(timer);}timer = setTimeout(function(){if(!MutationObserver){ //fallback for IE 9
	$nodes.each(function(){$(this).triggerHandler('scrollme.zf.trigger');});} //trigger all listening elements and signal a scroll event
	$nodes.attr('data-events',"scroll");},debounce || 10); //default time to emit scroll event
	});}}function eventsListener(){if(!MutationObserver){return false;}var nodes=document.querySelectorAll('[data-resize], [data-scroll], [data-mutate]'); //element callback
	var listeningElementsMutation=function listeningElementsMutation(mutationRecordsList){var $target=$(mutationRecordsList[0].target); //trigger the event handler for the element depending on type
	switch($target.attr("data-events")){case "resize":$target.triggerHandler('resizeme.zf.trigger',[$target]);break;case "scroll":$target.triggerHandler('scrollme.zf.trigger',[$target,window.pageYOffset]);break; // case "mutate" :
	// console.log('mutate', $target);
	// $target.triggerHandler('mutate.zf.trigger');
	//
	// //make sure we don't get stuck in an infinite loop from sloppy codeing
	// if ($target.index('[data-mutate]') == $("[data-mutate]").length-1) {
	//   domMutationObserver();
	// }
	// break;
	default:return false; //nothing
	}};if(nodes.length){ //for each element that needs to listen for resizing, scrolling, (or coming soon mutation) add a single observer
	for(var i=0;i <= nodes.length - 1;i++) {var elementObserver=new MutationObserver(listeningElementsMutation);elementObserver.observe(nodes[i],{attributes:true,childList:false,characterData:false,subtree:false,attributeFilter:["data-events"]});}}} // ------------------------------------
	// [PH]
	// Foundation.CheckWatchers = checkWatchers;
	Foundation.IHearYou = checkListeners; // Foundation.ISeeYou = scrollListener;
	// Foundation.IFeelYou = closemeListener;
	})(jQuery); // function domMutationObserver(debounce) {
	//   // !!! This is coming soon and needs more work; not active  !!! //
	//   var timer,
	//   nodes = document.querySelectorAll('[data-mutate]');
	//   //
	//   if (nodes.length) {
	//     // var MutationObserver = (function () {
	//     //   var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
	//     //   for (var i=0; i < prefixes.length; i++) {
	//     //     if (prefixes[i] + 'MutationObserver' in window) {
	//     //       return window[prefixes[i] + 'MutationObserver'];
	//     //     }
	//     //   }
	//     //   return false;
	//     // }());
	//
	//
	//     //for the body, we need to listen for all changes effecting the style and class attributes
	//     var bodyObserver = new MutationObserver(bodyMutation);
	//     bodyObserver.observe(document.body, { attributes: true, childList: true, characterData: false, subtree:true, attributeFilter:["style", "class"]});
	//
	//
	//     //body callback
	//     function bodyMutation(mutate) {
	//       //trigger all listening elements and signal a mutation event
	//       if (timer) { clearTimeout(timer); }
	//
	//       timer = setTimeout(function() {
	//         bodyObserver.disconnect();
	//         $('[data-mutate]').attr('data-events',"mutate");
	//       }, debounce || 150);
	//     }
	//   }
	// }
	/*******************************************
	 *                                         *
	 * This util was created by Marius Olbertz *
	 * Please thank Marius on GitHub /owlbertz *
	 * or the web http://www.mariusolbertz.de/ *
	 *                                         *
	 ******************************************/'use strict';!(function($){var keyCodes={9:'TAB',13:'ENTER',27:'ESCAPE',32:'SPACE',37:'ARROW_LEFT',38:'ARROW_UP',39:'ARROW_RIGHT',40:'ARROW_DOWN'};var commands={};var Keyboard={keys:getKeyCodes(keyCodes), /**
	     * Parses the (keyboard) event and returns a String that represents its key
	     * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	     * @param {Event} event - the event generated by the event handler
	     * @return String key - String that represents the key pressed
	     */parseKey:function parseKey(event){var key=keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();if(event.shiftKey)key = 'SHIFT_' + key;if(event.ctrlKey)key = 'CTRL_' + key;if(event.altKey)key = 'ALT_' + key;return key;}, /**
	     * Handles the given (keyboard) event
	     * @param {Event} event - the event generated by the event handler
	     * @param {String} component - Foundation component's name, e.g. Slider or Reveal
	     * @param {Objects} functions - collection of functions that are to be executed
	     */handleKey:function handleKey(event,component,functions){var commandList=commands[component],keyCode=this.parseKey(event),cmds,command,fn;if(!commandList)return console.warn('Component not defined!');if(typeof commandList.ltr === 'undefined'){ // this component does not differentiate between ltr and rtl
	cmds = commandList; // use plain list
	}else { // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
	if(Foundation.rtl())cmds = $.extend({},commandList.ltr,commandList.rtl);else cmds = $.extend({},commandList.rtl,commandList.ltr);}command = cmds[keyCode];fn = functions[command];if(fn && typeof fn === 'function'){ // execute function  if exists
	var returnValue=fn.apply();if(functions.handled || typeof functions.handled === 'function'){ // execute function when event was handled
	functions.handled(returnValue);}}else {if(functions.unhandled || typeof functions.unhandled === 'function'){ // execute function when event was not handled
	functions.unhandled();}}}, /**
	     * Finds all focusable elements within the given `$element`
	     * @param {jQuery} $element - jQuery object to search within
	     * @return {jQuery} $focusable - all focusable elements within `$element`
	     */findFocusable:function findFocusable($element){return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function(){if(!$(this).is(':visible') || $(this).attr('tabindex') < 0){return false;} //only have visible elements and those that have a tabindex greater or equal 0
	return true;});}, /**
	     * Returns the component name name
	     * @param {Object} component - Foundation component, e.g. Slider or Reveal
	     * @return String componentName
	     */register:function register(componentName,cmds){commands[componentName] = cmds;}}; /*
	   * Constants for easier comparing.
	   * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
	   */function getKeyCodes(kcs){var k={};for(var kc in kcs) {k[kcs[kc]] = kcs[kc];}return k;}Foundation.Keyboard = Keyboard;})(jQuery);'use strict';!(function($){var Nest={Feather:function Feather(menu){var type=arguments.length <= 1 || arguments[1] === undefined?'zf':arguments[1];menu.attr('role','menubar');var items=menu.find('li').attr({'role':'menuitem'}),subMenuClass='is-' + type + '-submenu',subItemClass=subMenuClass + '-item',hasSubClass='is-' + type + '-submenu-parent';menu.find('a:first').attr('tabindex',0);items.each(function(){var $item=$(this),$sub=$item.children('ul');if($sub.length){$item.addClass(hasSubClass).attr({'aria-haspopup':true,'aria-expanded':false,'aria-label':$item.children('a:first').text()});$sub.addClass('submenu ' + subMenuClass).attr({'data-submenu':'','aria-hidden':true,'role':'menu'});}if($item.parent('[data-submenu]').length){$item.addClass('is-submenu-item ' + subItemClass);}});return;},Burn:function Burn(menu,type){var items=menu.find('li').removeAttr('tabindex'),subMenuClass='is-' + type + '-submenu',subItemClass=subMenuClass + '-item',hasSubClass='is-' + type + '-submenu-parent';menu.find('>li, .menu, .menu > li').removeClass(subMenuClass + ' ' + subItemClass + ' ' + hasSubClass + ' is-submenu-item submenu is-active').removeAttr('data-submenu').css('display',''); // console.log(      menu.find('.' + subMenuClass + ', .' + subItemClass + ', .has-submenu, .is-submenu-item, .submenu, [data-submenu]')
	//           .removeClass(subMenuClass + ' ' + subItemClass + ' has-submenu is-submenu-item submenu')
	//           .removeAttr('data-submenu'));
	// items.each(function(){
	//   var $item = $(this),
	//       $sub = $item.children('ul');
	//   if($item.parent('[data-submenu]').length){
	//     $item.removeClass('is-submenu-item ' + subItemClass);
	//   }
	//   if($sub.length){
	//     $item.removeClass('has-submenu');
	//     $sub.removeClass('submenu ' + subMenuClass).removeAttr('data-submenu');
	//   }
	// });
	}};Foundation.Nest = Nest;})(jQuery);'use strict';!(function($){function Timer(elem,options,cb){var _this=this,duration=options.duration, //options is an object for easily adding features later.
	nameSpace=Object.keys(elem.data())[0] || 'timer',remain=-1,start,timer;this.isPaused = false;this.restart = function(){remain = -1;clearTimeout(timer);this.start();};this.start = function(){this.isPaused = false; // if(!elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
	clearTimeout(timer);remain = remain <= 0?duration:remain;elem.data('paused',false);start = Date.now();timer = setTimeout(function(){if(options.infinite){_this.restart(); //rerun the timer.
	}if(cb && typeof cb === 'function'){cb();}},remain);elem.trigger('timerstart.zf.' + nameSpace);};this.pause = function(){this.isPaused = true; //if(elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.
	clearTimeout(timer);elem.data('paused',true);var end=Date.now();remain = remain - (end - start);elem.trigger('timerpaused.zf.' + nameSpace);};} /**
	   * Runs a callback function when images are fully loaded.
	   * @param {Object} images - Image(s) to check if loaded.
	   * @param {Func} callback - Function to execute when image is fully loaded.
	   */function onImagesLoaded(images,callback){var self=this,unloaded=images.length;if(unloaded === 0){callback();}images.each(function(){if(this.complete){singleImageLoaded();}else if(typeof this.naturalWidth !== 'undefined' && this.naturalWidth > 0){singleImageLoaded();}else {$(this).one('load',function(){singleImageLoaded();});}});function singleImageLoaded(){unloaded--;if(unloaded === 0){callback();}}}Foundation.Timer = Timer;Foundation.onImagesLoaded = onImagesLoaded;})(jQuery); //**************************************************
	//**Work inspired by multiple jquery swipe plugins**
	//**Done by Yohai Ararat ***************************
	//**************************************************
	(function($){$.spotSwipe = {version:'1.0.0',enabled:'ontouchstart' in document.documentElement,preventDefault:false,moveThreshold:75,timeThreshold:200};var startPosX,startPosY,startTime,elapsedTime,isMoving=false;function onTouchEnd(){ //  alert(this);
	this.removeEventListener('touchmove',onTouchMove);this.removeEventListener('touchend',onTouchEnd);isMoving = false;}function onTouchMove(e){if($.spotSwipe.preventDefault){e.preventDefault();}if(isMoving){var x=e.touches[0].pageX;var y=e.touches[0].pageY;var dx=startPosX - x;var dy=startPosY - y;var dir;elapsedTime = new Date().getTime() - startTime;if(Math.abs(dx) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold){dir = dx > 0?'left':'right';} // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
	//   dir = dy > 0 ? 'down' : 'up';
	// }
	if(dir){e.preventDefault();onTouchEnd.call(this);$(this).trigger('swipe',dir).trigger('swipe' + dir);}}}function onTouchStart(e){if(e.touches.length == 1){startPosX = e.touches[0].pageX;startPosY = e.touches[0].pageY;isMoving = true;startTime = new Date().getTime();this.addEventListener('touchmove',onTouchMove,false);this.addEventListener('touchend',onTouchEnd,false);}}function init(){this.addEventListener && this.addEventListener('touchstart',onTouchStart,false);}function teardown(){this.removeEventListener('touchstart',onTouchStart);}$.event.special.swipe = {setup:init};$.each(['left','up','down','right'],function(){$.event.special['swipe' + this] = {setup:function setup(){$(this).on('swipe',$.noop);}};});})(jQuery); /****************************************************
	 * Method for adding psuedo drag events to elements *
	 ***************************************************/!(function($){$.fn.addTouch = function(){this.each(function(i,el){$(el).bind('touchstart touchmove touchend touchcancel',function(){ //we pass the original event object because the jQuery event
	//object is normalized to w3c specs and does not provide the TouchList
	handleTouch(event);});});var handleTouch=function handleTouch(event){var touches=event.changedTouches,first=touches[0],eventTypes={touchstart:'mousedown',touchmove:'mousemove',touchend:'mouseup'},type=eventTypes[event.type],simulatedEvent;if('MouseEvent' in window && typeof window.MouseEvent === 'function'){simulatedEvent = new window.MouseEvent(type,{'bubbles':true,'cancelable':true,'screenX':first.screenX,'screenY':first.screenY,'clientX':first.clientX,'clientY':first.clientY});}else {simulatedEvent = document.createEvent('MouseEvent');simulatedEvent.initMouseEvent(type,true,true,window,1,first.screenX,first.screenY,first.clientX,first.clientY,false,false,false,false,0, /*left*/null);}first.target.dispatchEvent(simulatedEvent);};};})(jQuery); //**********************************
	//**From the jQuery Mobile Library**
	//**need to recreate functionality**
	//**and try to improve if possible**
	//**********************************
	/* Removing the jQuery function ****
	************************************
	
	(function( $, window, undefined ) {
	
		var $document = $( document ),
			// supportTouch = $.mobile.support.touch,
			touchStartEvent = 'touchstart'//supportTouch ? "touchstart" : "mousedown",
			touchStopEvent = 'touchend'//supportTouch ? "touchend" : "mouseup",
			touchMoveEvent = 'touchmove'//supportTouch ? "touchmove" : "mousemove";
	
		// setup new event shortcuts
		$.each( ( "touchstart touchmove touchend " +
			"swipe swipeleft swiperight" ).split( " " ), function( i, name ) {
	
			$.fn[ name ] = function( fn ) {
				return fn ? this.bind( name, fn ) : this.trigger( name );
			};
	
			// jQuery < 1.8
			if ( $.attrFn ) {
				$.attrFn[ name ] = true;
			}
		});
	
		function triggerCustomEvent( obj, eventType, event, bubble ) {
			var originalType = event.type;
			event.type = eventType;
			if ( bubble ) {
				$.event.trigger( event, undefined, obj );
			} else {
				$.event.dispatch.call( obj, event );
			}
			event.type = originalType;
		}
	
		// also handles taphold
	
		// Also handles swipeleft, swiperight
		$.event.special.swipe = {
	
			// More than this horizontal displacement, and we will suppress scrolling.
			scrollSupressionThreshold: 30,
	
			// More time than this, and it isn't a swipe.
			durationThreshold: 1000,
	
			// Swipe horizontal displacement must be more than this.
			horizontalDistanceThreshold: window.devicePixelRatio >= 2 ? 15 : 30,
	
			// Swipe vertical displacement must be less than this.
			verticalDistanceThreshold: window.devicePixelRatio >= 2 ? 15 : 30,
	
			getLocation: function ( event ) {
				var winPageX = window.pageXOffset,
					winPageY = window.pageYOffset,
					x = event.clientX,
					y = event.clientY;
	
				if ( event.pageY === 0 && Math.floor( y ) > Math.floor( event.pageY ) ||
					event.pageX === 0 && Math.floor( x ) > Math.floor( event.pageX ) ) {
	
					// iOS4 clientX/clientY have the value that should have been
					// in pageX/pageY. While pageX/page/ have the value 0
					x = x - winPageX;
					y = y - winPageY;
				} else if ( y < ( event.pageY - winPageY) || x < ( event.pageX - winPageX ) ) {
	
					// Some Android browsers have totally bogus values for clientX/Y
					// when scrolling/zooming a page. Detectable since clientX/clientY
					// should never be smaller than pageX/pageY minus page scroll
					x = event.pageX - winPageX;
					y = event.pageY - winPageY;
				}
	
				return {
					x: x,
					y: y
				};
			},
	
			start: function( event ) {
				var data = event.originalEvent.touches ?
						event.originalEvent.touches[ 0 ] : event,
					location = $.event.special.swipe.getLocation( data );
				return {
							time: ( new Date() ).getTime(),
							coords: [ location.x, location.y ],
							origin: $( event.target )
						};
			},
	
			stop: function( event ) {
				var data = event.originalEvent.touches ?
						event.originalEvent.touches[ 0 ] : event,
					location = $.event.special.swipe.getLocation( data );
				return {
							time: ( new Date() ).getTime(),
							coords: [ location.x, location.y ]
						};
			},
	
			handleSwipe: function( start, stop, thisObject, origTarget ) {
				if ( stop.time - start.time < $.event.special.swipe.durationThreshold &&
					Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.horizontalDistanceThreshold &&
					Math.abs( start.coords[ 1 ] - stop.coords[ 1 ] ) < $.event.special.swipe.verticalDistanceThreshold ) {
					var direction = start.coords[0] > stop.coords[ 0 ] ? "swipeleft" : "swiperight";
	
					triggerCustomEvent( thisObject, "swipe", $.Event( "swipe", { target: origTarget, swipestart: start, swipestop: stop }), true );
					triggerCustomEvent( thisObject, direction,$.Event( direction, { target: origTarget, swipestart: start, swipestop: stop } ), true );
					return true;
				}
				return false;
	
			},
	
			// This serves as a flag to ensure that at most one swipe event event is
			// in work at any given time
			eventInProgress: false,
	
			setup: function() {
				var events,
					thisObject = this,
					$this = $( thisObject ),
					context = {};
	
				// Retrieve the events data for this element and add the swipe context
				events = $.data( this, "mobile-events" );
				if ( !events ) {
					events = { length: 0 };
					$.data( this, "mobile-events", events );
				}
				events.length++;
				events.swipe = context;
	
				context.start = function( event ) {
	
					// Bail if we're already working on a swipe event
					if ( $.event.special.swipe.eventInProgress ) {
						return;
					}
					$.event.special.swipe.eventInProgress = true;
	
					var stop,
						start = $.event.special.swipe.start( event ),
						origTarget = event.target,
						emitted = false;
	
					context.move = function( event ) {
						if ( !start || event.isDefaultPrevented() ) {
							return;
						}
	
						stop = $.event.special.swipe.stop( event );
						if ( !emitted ) {
							emitted = $.event.special.swipe.handleSwipe( start, stop, thisObject, origTarget );
							if ( emitted ) {
	
								// Reset the context to make way for the next swipe event
								$.event.special.swipe.eventInProgress = false;
							}
						}
						// prevent scrolling
						if ( Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.scrollSupressionThreshold ) {
							event.preventDefault();
						}
					};
	
					context.stop = function() {
							emitted = true;
	
							// Reset the context to make way for the next swipe event
							$.event.special.swipe.eventInProgress = false;
							$document.off( touchMoveEvent, context.move );
							context.move = null;
					};
	
					$document.on( touchMoveEvent, context.move )
						.one( touchStopEvent, context.stop );
				};
				$this.on( touchStartEvent, context.start );
			},
	
			teardown: function() {
				var events, context;
	
				events = $.data( this, "mobile-events" );
				if ( events ) {
					context = events.swipe;
					delete events.swipe;
					events.length--;
					if ( events.length === 0 ) {
						$.removeData( this, "mobile-events" );
					}
				}
	
				if ( context ) {
					if ( context.start ) {
						$( this ).off( touchStartEvent, context.start );
					}
					if ( context.move ) {
						$document.off( touchMoveEvent, context.move );
					}
					if ( context.stop ) {
						$document.off( touchStopEvent, context.stop );
					}
				}
			}
		};
		$.each({
			swipeleft: "swipe.left",
			swiperight: "swipe.right"
		}, function( event, sourceEvent ) {
	
			$.event.special[ event ] = {
				setup: function() {
					$( this ).bind( sourceEvent, $.noop );
				},
				teardown: function() {
					$( this ).unbind( sourceEvent );
				}
			};
		});
	})( jQuery, this );
	*/'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Slider module.
	   * @module foundation.slider
	   * @requires foundation.util.motion
	   * @requires foundation.util.triggers
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.touch
	   */var Slider=(function(){ /**
	     * Creates a new instance of a drilldown menu.
	     * @class
	     * @param {jQuery} element - jQuery object to make into an accordion menu.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Slider(element,options){_classCallCheck(this,Slider);this.$element = element;this.options = $.extend({},Slider.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Slider');Foundation.Keyboard.register('Slider',{'ltr':{'ARROW_RIGHT':'increase','ARROW_UP':'increase','ARROW_DOWN':'decrease','ARROW_LEFT':'decrease','SHIFT_ARROW_RIGHT':'increase_fast','SHIFT_ARROW_UP':'increase_fast','SHIFT_ARROW_DOWN':'decrease_fast','SHIFT_ARROW_LEFT':'decrease_fast'},'rtl':{'ARROW_LEFT':'increase','ARROW_RIGHT':'decrease','SHIFT_ARROW_LEFT':'increase_fast','SHIFT_ARROW_RIGHT':'decrease_fast'}});} /**
	     * Initilizes the plugin by reading/setting attributes, creating collections and setting the initial position of the handle(s).
	     * @function
	     * @private
	     */_createClass(Slider,[{key:'_init',value:function _init(){this.inputs = this.$element.find('input');this.handles = this.$element.find('[data-slider-handle]');this.$handle = this.handles.eq(0);this.$input = this.inputs.length?this.inputs.eq(0):$('#' + this.$handle.attr('aria-controls'));this.$fill = this.$element.find('[data-slider-fill]').css(this.options.vertical?'height':'width',0);var isDbl=false,_this=this;if(this.options.disabled || this.$element.hasClass(this.options.disabledClass)){this.options.disabled = true;this.$element.addClass(this.options.disabledClass);}if(!this.inputs.length){this.inputs = $().add(this.$input);this.options.binding = true;}this._setInitAttr(0);this._events(this.$handle);if(this.handles[1]){this.options.doubleSided = true;this.$handle2 = this.handles.eq(1);this.$input2 = this.inputs.length > 1?this.inputs.eq(1):$('#' + this.$handle2.attr('aria-controls'));if(!this.inputs[1]){this.inputs = this.inputs.add(this.$input2);}isDbl = true;this._setHandlePos(this.$handle,this.options.initialStart,true,function(){_this._setHandlePos(_this.$handle2,_this.options.initialEnd,true);}); // this.$handle.triggerHandler('click.zf.slider');
	this._setInitAttr(1);this._events(this.$handle2);}if(!isDbl){this._setHandlePos(this.$handle,this.options.initialStart,true);}} /**
	       * Sets the position of the selected handle and fill bar.
	       * @function
	       * @private
	       * @param {jQuery} $hndl - the selected handle to move.
	       * @param {Number} location - floating point between the start and end values of the slider bar.
	       * @param {Function} cb - callback function to fire on completion.
	       * @fires Slider#moved
	       * @fires Slider#changed
	       */},{key:'_setHandlePos',value:function _setHandlePos($hndl,location,noInvert,cb){ // don't move if the slider has been disabled since its initialization
	if(this.$element.hasClass(this.options.disabledClass)){return;} //might need to alter that slightly for bars that will have odd number selections.
	location = parseFloat(location); //on input change events, convert string to number...grumble.
	// prevent slider from running out of bounds, if value exceeds the limits set through options, override the value to min/max
	if(location < this.options.start){location = this.options.start;}else if(location > this.options.end){location = this.options.end;}var isDbl=this.options.doubleSided;if(isDbl){ //this block is to prevent 2 handles from crossing eachother. Could/should be improved.
	if(this.handles.index($hndl) === 0){var h2Val=parseFloat(this.$handle2.attr('aria-valuenow'));location = location >= h2Val?h2Val - this.options.step:location;}else {var h1Val=parseFloat(this.$handle.attr('aria-valuenow'));location = location <= h1Val?h1Val + this.options.step:location;}} //this is for single-handled vertical sliders, it adjusts the value to account for the slider being "upside-down"
	//for click and drag events, it's weird due to the scale(-1, 1) css property
	if(this.options.vertical && !noInvert){location = this.options.end - location;}var _this=this,vert=this.options.vertical,hOrW=vert?'height':'width',lOrT=vert?'top':'left',handleDim=$hndl[0].getBoundingClientRect()[hOrW],elemDim=this.$element[0].getBoundingClientRect()[hOrW], //percentage of bar min/max value based on click or drag point
	pctOfBar=percent(location - this.options.start,this.options.end - this.options.start).toFixed(2), //number of actual pixels to shift the handle, based on the percentage obtained above
	pxToMove=(elemDim - handleDim) * pctOfBar, //percentage of bar to shift the handle
	movement=(percent(pxToMove,elemDim) * 100).toFixed(this.options.decimal); //fixing the decimal value for the location number, is passed to other methods as a fixed floating-point value
	location = parseFloat(location.toFixed(this.options.decimal)); // declare empty object for css adjustments, only used with 2 handled-sliders
	var css={};this._setValues($hndl,location); // TODO update to calculate based on values set to respective inputs??
	if(isDbl){var isLeftHndl=this.handles.index($hndl) === 0, //empty variable, will be used for min-height/width for fill bar
	dim, //percentage w/h of the handle compared to the slider bar
	handlePct=~ ~(percent(handleDim,elemDim) * 100); //if left handle, the math is slightly different than if it's the right handle, and the left/top property needs to be changed for the fill bar
	if(isLeftHndl){ //left or top percentage value to apply to the fill bar.
	css[lOrT] = movement + '%'; //calculate the new min-height/width for the fill bar.
	dim = parseFloat(this.$handle2[0].style[lOrT]) - movement + handlePct; //this callback is necessary to prevent errors and allow the proper placement and initialization of a 2-handled slider
	//plus, it means we don't care if 'dim' isNaN on init, it won't be in the future.
	if(cb && typeof cb === 'function'){cb();} //this is only needed for the initialization of 2 handled sliders
	}else { //just caching the value of the left/bottom handle's left/top property
	var handlePos=parseFloat(this.$handle[0].style[lOrT]); //calculate the new min-height/width for the fill bar. Use isNaN to prevent false positives for numbers <= 0
	//based on the percentage of movement of the handle being manipulated, less the opposing handle's left/top position, plus the percentage w/h of the handle itself
	dim = movement - (isNaN(handlePos)?this.options.initialStart / ((this.options.end - this.options.start) / 100):handlePos) + handlePct;} // assign the min-height/width to our css object
	css['min-' + hOrW] = dim + '%';}this.$element.one('finished.zf.animate',function(){ /**
	           * Fires when the handle is done moving.
	           * @event Slider#moved
	           */_this.$element.trigger('moved.zf.slider',[$hndl]);}); //because we don't know exactly how the handle will be moved, check the amount of time it should take to move.
	var moveTime=this.$element.data('dragging')?1000 / 60:this.options.moveTime;Foundation.Move(moveTime,$hndl,function(){ //adjusting the left/top property of the handle, based on the percentage calculated above
	$hndl.css(lOrT,movement + '%');if(!_this.options.doubleSided){ //if single-handled, a simple method to expand the fill bar
	_this.$fill.css(hOrW,pctOfBar * 100 + '%');}else { //otherwise, use the css object we created above
	_this.$fill.css(css);}}); /**
	         * Fires when the value has not been change for a given time.
	         * @event Slider#changed
	         */clearTimeout(_this.timeout);_this.timeout = setTimeout(function(){_this.$element.trigger('changed.zf.slider',[$hndl]);},_this.options.changedDelay);} /**
	       * Sets the initial attribute for the slider element.
	       * @function
	       * @private
	       * @param {Number} idx - index of the current handle/input to use.
	       */},{key:'_setInitAttr',value:function _setInitAttr(idx){var id=this.inputs.eq(idx).attr('id') || Foundation.GetYoDigits(6,'slider');this.inputs.eq(idx).attr({'id':id,'max':this.options.end,'min':this.options.start,'step':this.options.step});this.handles.eq(idx).attr({'role':'slider','aria-controls':id,'aria-valuemax':this.options.end,'aria-valuemin':this.options.start,'aria-valuenow':idx === 0?this.options.initialStart:this.options.initialEnd,'aria-orientation':this.options.vertical?'vertical':'horizontal','tabindex':0});} /**
	       * Sets the input and `aria-valuenow` values for the slider element.
	       * @function
	       * @private
	       * @param {jQuery} $handle - the currently selected handle.
	       * @param {Number} val - floating point of the new value.
	       */},{key:'_setValues',value:function _setValues($handle,val){var idx=this.options.doubleSided?this.handles.index($handle):0;this.inputs.eq(idx).val(val);$handle.attr('aria-valuenow',val);} /**
	       * Handles events on the slider element.
	       * Calculates the new location of the current handle.
	       * If there are two handles and the bar was clicked, it determines which handle to move.
	       * @function
	       * @private
	       * @param {Object} e - the `event` object passed from the listener.
	       * @param {jQuery} $handle - the current handle to calculate for, if selected.
	       * @param {Number} val - floating point number for the new value of the slider.
	       * TODO clean this up, there's a lot of repeated code between this and the _setHandlePos fn.
	       */},{key:'_handleEvent',value:function _handleEvent(e,$handle,val){var value,hasVal;if(!val){ //click or drag events
	e.preventDefault();var _this=this,vertical=this.options.vertical,param=vertical?'height':'width',direction=vertical?'top':'left',eventOffset=vertical?e.pageY:e.pageX,halfOfHandle=this.$handle[0].getBoundingClientRect()[param] / 2,barDim=this.$element[0].getBoundingClientRect()[param],windowScroll=vertical?$(window).scrollTop():$(window).scrollLeft();var elemOffset=this.$element.offset()[direction]; // touch events emulated by the touch util give position relative to screen, add window.scroll to event coordinates...
	// best way to guess this is simulated is if clientY == pageY
	if(e.clientY === e.pageY){eventOffset = eventOffset + windowScroll;}var eventFromBar=eventOffset - elemOffset;var barXY;if(eventFromBar < 0){barXY = 0;}else if(eventFromBar > barDim){barXY = barDim;}else {barXY = eventFromBar;}var offsetPct=percent(barXY,barDim);value = (this.options.end - this.options.start) * offsetPct + this.options.start; // turn everything around for RTL, yay math!
	if(Foundation.rtl() && !this.options.vertical){value = this.options.end - value;}value = _this._adjustValue(null,value); //boolean flag for the setHandlePos fn, specifically for vertical sliders
	hasVal = false;if(!$handle){ //figure out which handle it is, pass it to the next function.
	var firstHndlPos=absPosition(this.$handle,direction,barXY,param),secndHndlPos=absPosition(this.$handle2,direction,barXY,param);$handle = firstHndlPos <= secndHndlPos?this.$handle:this.$handle2;}}else { //change event on input
	value = this._adjustValue(null,val);hasVal = true;}this._setHandlePos($handle,value,hasVal);} /**
	       * Adjustes value for handle in regard to step value. returns adjusted value
	       * @function
	       * @private
	       * @param {jQuery} $handle - the selected handle.
	       * @param {Number} value - value to adjust. used if $handle is falsy
	       */},{key:'_adjustValue',value:function _adjustValue($handle,value){var val,step=this.options.step,div=parseFloat(step / 2),left,prev_val,next_val;if(!!$handle){val = parseFloat($handle.attr('aria-valuenow'));}else {val = value;}left = val % step;prev_val = val - left;next_val = prev_val + step;if(left === 0){return val;}val = val >= prev_val + div?next_val:prev_val;return val;} /**
	       * Adds event listeners to the slider elements.
	       * @function
	       * @private
	       * @param {jQuery} $handle - the current handle to apply listeners to.
	       */},{key:'_events',value:function _events($handle){var _this=this,curHandle,timer;this.inputs.off('change.zf.slider').on('change.zf.slider',function(e){var idx=_this.inputs.index($(this));_this._handleEvent(e,_this.handles.eq(idx),$(this).val());});if(this.options.clickSelect){this.$element.off('click.zf.slider').on('click.zf.slider',function(e){if(_this.$element.data('dragging')){return false;}if(!$(e.target).is('[data-slider-handle]')){if(_this.options.doubleSided){_this._handleEvent(e);}else {_this._handleEvent(e,_this.$handle);}}});}if(this.options.draggable){this.handles.addTouch();var $body=$('body');$handle.off('mousedown.zf.slider').on('mousedown.zf.slider',function(e){$handle.addClass('is-dragging');_this.$fill.addClass('is-dragging'); //
	_this.$element.data('dragging',true);curHandle = $(e.currentTarget);$body.on('mousemove.zf.slider',function(e){e.preventDefault();_this._handleEvent(e,curHandle);}).on('mouseup.zf.slider',function(e){_this._handleEvent(e,curHandle);$handle.removeClass('is-dragging');_this.$fill.removeClass('is-dragging');_this.$element.data('dragging',false);$body.off('mousemove.zf.slider mouseup.zf.slider');});}) // prevent events triggered by touch
	.on('selectstart.zf.slider touchmove.zf.slider',function(e){e.preventDefault();});}$handle.off('keydown.zf.slider').on('keydown.zf.slider',function(e){var _$handle=$(this),idx=_this.options.doubleSided?_this.handles.index(_$handle):0,oldValue=parseFloat(_this.inputs.eq(idx).val()),newValue; // handle keyboard event with keyboard util
	Foundation.Keyboard.handleKey(e,'Slider',{decrease:function decrease(){newValue = oldValue - _this.options.step;},increase:function increase(){newValue = oldValue + _this.options.step;},decrease_fast:function decrease_fast(){newValue = oldValue - _this.options.step * 10;},increase_fast:function increase_fast(){newValue = oldValue + _this.options.step * 10;},handled:function handled(){ // only set handle pos when event was handled specially
	e.preventDefault();_this._setHandlePos(_$handle,newValue,true);}}); /*if (newValue) { // if pressed key has special function, update value
	            e.preventDefault();
	            _this._setHandlePos(_$handle, newValue);
	          }*/});} /**
	       * Destroys the slider plugin.
	       */},{key:'destroy',value:function destroy(){this.handles.off('.zf.slider');this.inputs.off('.zf.slider');this.$element.off('.zf.slider');Foundation.unregisterPlugin(this);}}]);return Slider;})();Slider.defaults = { /**
	     * Minimum value for the slider scale.
	     * @option
	     * @example 0
	     */start:0, /**
	     * Maximum value for the slider scale.
	     * @option
	     * @example 100
	     */end:100, /**
	     * Minimum value change per change event.
	     * @option
	     * @example 1
	     */step:1, /**
	     * Value at which the handle/input *(left handle/first input)* should be set to on initialization.
	     * @option
	     * @example 0
	     */initialStart:0, /**
	     * Value at which the right handle/second input should be set to on initialization.
	     * @option
	     * @example 100
	     */initialEnd:100, /**
	     * Allows the input to be located outside the container and visible. Set to by the JS
	     * @option
	     * @example false
	     */binding:false, /**
	     * Allows the user to click/tap on the slider bar to select a value.
	     * @option
	     * @example true
	     */clickSelect:true, /**
	     * Set to true and use the `vertical` class to change alignment to vertical.
	     * @option
	     * @example false
	     */vertical:false, /**
	     * Allows the user to drag the slider handle(s) to select a value.
	     * @option
	     * @example true
	     */draggable:true, /**
	     * Disables the slider and prevents event listeners from being applied. Double checked by JS with `disabledClass`.
	     * @option
	     * @example false
	     */disabled:false, /**
	     * Allows the use of two handles. Double checked by the JS. Changes some logic handling.
	     * @option
	     * @example false
	     */doubleSided:false, /**
	     * Potential future feature.
	     */ // steps: 100,
	/**
	     * Number of decimal places the plugin should go to for floating point precision.
	     * @option
	     * @example 2
	     */decimal:2, /**
	     * Time delay for dragged elements.
	     */ // dragDelay: 0,
	/**
	     * Time, in ms, to animate the movement of a slider handle if user clicks/taps on the bar. Needs to be manually set if updating the transition time in the Sass settings.
	     * @option
	     * @example 200
	     */moveTime:200, //update this if changing the transition time in the sass
	/**
	     * Class applied to disabled sliders.
	     * @option
	     * @example 'disabled'
	     */disabledClass:'disabled', /**
	     * Will invert the default layout for a vertical<span data-tooltip title="who would do this???"> </span>slider.
	     * @option
	     * @example false
	     */invertVertical:false, /**
	     * Milliseconds before the `changed.zf-slider` event is triggered after value change.
	     * @option
	     * @example 500
	     */changedDelay:500};function percent(frac,num){return frac / num;}function absPosition($handle,dir,clickPos,param){return Math.abs($handle.position()[dir] + $handle[param]() / 2 - clickPos);} // Window exports
	Foundation.plugin(Slider,'Slider');})(jQuery); //*********this is in case we go to static, absolute positions instead of dynamic positioning********
	// this.setSteps(function() {
	//   _this._events();
	//   var initStart = _this.options.positions[_this.options.initialStart - 1] || null;
	//   var initEnd = _this.options.initialEnd ? _this.options.position[_this.options.initialEnd - 1] : null;
	//   if (initStart || initEnd) {
	//     _this._handleEvent(initStart, initEnd);
	//   }
	// });
	//***********the other part of absolute positions*************
	// Slider.prototype.setSteps = function(cb) {
	//   var posChange = this.$element.outerWidth() / this.options.steps;
	//   var counter = 0
	//   while(counter < this.options.steps) {
	//     if (counter) {
	//       this.options.positions.push(this.options.positions[counter - 1] + posChange);
	//     } else {
	//       this.options.positions.push(posChange);
	//     }
	//     counter++;
	//   }
	//   cb();
	// };
	'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Drilldown module.
	   * @module foundation.drilldown
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.motion
	   * @requires foundation.util.nest
	   */var Drilldown=(function(){ /**
	     * Creates a new instance of a drilldown menu.
	     * @class
	     * @param {jQuery} element - jQuery object to make into an accordion menu.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Drilldown(element,options){_classCallCheck(this,Drilldown);this.$element = element;this.options = $.extend({},Drilldown.defaults,this.$element.data(),options);Foundation.Nest.Feather(this.$element,'drilldown');this._init();Foundation.registerPlugin(this,'Drilldown');Foundation.Keyboard.register('Drilldown',{'ENTER':'open','SPACE':'open','ARROW_RIGHT':'next','ARROW_UP':'up','ARROW_DOWN':'down','ARROW_LEFT':'previous','ESCAPE':'close','TAB':'down','SHIFT_TAB':'up'});} /**
	     * Initializes the drilldown by creating jQuery collections of elements
	     * @private
	     */_createClass(Drilldown,[{key:'_init',value:function _init(){this.$submenuAnchors = this.$element.find('li.is-drilldown-submenu-parent').children('a');this.$submenus = this.$submenuAnchors.parent('li').children('[data-submenu]');this.$menuItems = this.$element.find('li').not('.js-drilldown-back').attr('role','menuitem').find('a');this._prepareMenu();this._keyboardEvents();} /**
	       * prepares drilldown menu by setting attributes to links and elements
	       * sets a min height to prevent content jumping
	       * wraps the element if not already wrapped
	       * @private
	       * @function
	       */},{key:'_prepareMenu',value:function _prepareMenu(){var _this=this; // if(!this.options.holdOpen){
	//   this._menuLinkEvents();
	// }
	this.$submenuAnchors.each(function(){var $link=$(this);var $sub=$link.parent();if(_this.options.parentLink){$link.clone().prependTo($sub.children('[data-submenu]')).wrap('<li class="is-submenu-parent-item is-submenu-item is-drilldown-submenu-item" role="menu-item"></li>');}$link.data('savedHref',$link.attr('href')).removeAttr('href').attr('tabindex',0);$link.children('[data-submenu]').attr({'aria-hidden':true,'tabindex':0,'role':'menu'});_this._events($link);});this.$submenus.each(function(){var $menu=$(this),$back=$menu.find('.js-drilldown-back');if(!$back.length){$menu.prepend(_this.options.backButton);}_this._back($menu);});if(!this.$element.parent().hasClass('is-drilldown')){this.$wrapper = $(this.options.wrapper).addClass('is-drilldown');this.$wrapper = this.$element.wrap(this.$wrapper).parent().css(this._getMaxDims());}} /**
	       * Adds event handlers to elements in the menu.
	       * @function
	       * @private
	       * @param {jQuery} $elem - the current menu item to add handlers to.
	       */},{key:'_events',value:function _events($elem){var _this=this;$elem.off('click.zf.drilldown').on('click.zf.drilldown',function(e){if($(e.target).parentsUntil('ul','li').hasClass('is-drilldown-submenu-parent')){e.stopImmediatePropagation();e.preventDefault();} // if(e.target !== e.currentTarget.firstElementChild){
	//   return false;
	// }
	_this._show($elem.parent('li'));if(_this.options.closeOnClick){var $body=$('body');$body.off('.zf.drilldown').on('click.zf.drilldown',function(e){if(e.target === _this.$element[0] || $.contains(_this.$element[0],e.target)){return;}e.preventDefault();_this._hideAll();$body.off('.zf.drilldown');});}});} /**
	       * Adds keydown event listener to `li`'s in the menu.
	       * @private
	       */},{key:'_keyboardEvents',value:function _keyboardEvents(){var _this=this;this.$menuItems.add(this.$element.find('.js-drilldown-back > a')).on('keydown.zf.drilldown',function(e){var $element=$(this),$elements=$element.parent('li').parent('ul').children('li').children('a'),$prevElement,$nextElement;$elements.each(function(i){if($(this).is($element)){$prevElement = $elements.eq(Math.max(0,i - 1));$nextElement = $elements.eq(Math.min(i + 1,$elements.length - 1));return;}});Foundation.Keyboard.handleKey(e,'Drilldown',{next:function next(){if($element.is(_this.$submenuAnchors)){_this._show($element.parent('li'));$element.parent('li').one(Foundation.transitionend($element),function(){$element.parent('li').find('ul li a').filter(_this.$menuItems).first().focus();});return true;}},previous:function previous(){_this._hide($element.parent('li').parent('ul'));$element.parent('li').parent('ul').one(Foundation.transitionend($element),function(){setTimeout(function(){$element.parent('li').parent('ul').parent('li').children('a').first().focus();},1);});return true;},up:function up(){$prevElement.focus();return true;},down:function down(){$nextElement.focus();return true;},close:function close(){_this._back(); //_this.$menuItems.first().focus(); // focus to first element
	},open:function open(){if(!$element.is(_this.$menuItems)){ // not menu item means back button
	_this._hide($element.parent('li').parent('ul'));$element.parent('li').parent('ul').one(Foundation.transitionend($element),function(){setTimeout(function(){$element.parent('li').parent('ul').parent('li').children('a').first().focus();},1);});return true;}else if($element.is(_this.$submenuAnchors)){_this._show($element.parent('li'));$element.parent('li').one(Foundation.transitionend($element),function(){$element.parent('li').find('ul li a').filter(_this.$menuItems).first().focus();});return true;}},handled:function handled(preventDefault){if(preventDefault){e.preventDefault();}e.stopImmediatePropagation();}});}); // end keyboardAccess
	} /**
	       * Closes all open elements, and returns to root menu.
	       * @function
	       * @fires Drilldown#closed
	       */},{key:'_hideAll',value:function _hideAll(){var $elem=this.$element.find('.is-drilldown-submenu.is-active').addClass('is-closing');$elem.one(Foundation.transitionend($elem),function(e){$elem.removeClass('is-active is-closing');}); /**
	         * Fires when the menu is fully closed.
	         * @event Drilldown#closed
	         */this.$element.trigger('closed.zf.drilldown');} /**
	       * Adds event listener for each `back` button, and closes open menus.
	       * @function
	       * @fires Drilldown#back
	       * @param {jQuery} $elem - the current sub-menu to add `back` event.
	       */},{key:'_back',value:function _back($elem){var _this=this;$elem.off('click.zf.drilldown');$elem.children('.js-drilldown-back').on('click.zf.drilldown',function(e){e.stopImmediatePropagation(); // console.log('mouseup on back');
	_this._hide($elem); // If there is a parent submenu, call show
	var parentSubMenu=$elem.parent('li').parent('ul').parent('li');if(parentSubMenu.length){_this._show(parentSubMenu);}});} /**
	       * Adds event listener to menu items w/o submenus to close open menus on click.
	       * @function
	       * @private
	       */},{key:'_menuLinkEvents',value:function _menuLinkEvents(){var _this=this;this.$menuItems.not('.is-drilldown-submenu-parent').off('click.zf.drilldown').on('click.zf.drilldown',function(e){ // e.stopImmediatePropagation();
	setTimeout(function(){_this._hideAll();},0);});} /**
	       * Opens a submenu.
	       * @function
	       * @fires Drilldown#open
	       * @param {jQuery} $elem - the current element with a submenu to open, i.e. the `li` tag.
	       */},{key:'_show',value:function _show($elem){$elem.attr('aria-expanded',true);$elem.children('[data-submenu]').addClass('is-active').attr('aria-hidden',false); /**
	         * Fires when the submenu has opened.
	         * @event Drilldown#open
	         */this.$element.trigger('open.zf.drilldown',[$elem]);}},{key:'_hide', /**
	       * Hides a submenu
	       * @function
	       * @fires Drilldown#hide
	       * @param {jQuery} $elem - the current sub-menu to hide, i.e. the `ul` tag.
	       */value:function _hide($elem){var _this=this;$elem.parent('li').attr('aria-expanded',false);$elem.attr('aria-hidden',true).addClass('is-closing').one(Foundation.transitionend($elem),function(){$elem.removeClass('is-active is-closing');$elem.blur();}); /**
	         * Fires when the submenu has closed.
	         * @event Drilldown#hide
	         */$elem.trigger('hide.zf.drilldown',[$elem]);} /**
	       * Iterates through the nested menus to calculate the min-height, and max-width for the menu.
	       * Prevents content jumping.
	       * @function
	       * @private
	       */},{key:'_getMaxDims',value:function _getMaxDims(){var biggest=0;var result={};this.$submenus.add(this.$element).each(function(i,elem){var height=elem.getBoundingClientRect().height;if(height > biggest)biggest = height;});result['min-height'] = biggest + 'px';result['max-width'] = this.$element[0].getBoundingClientRect().width + 'px';return result;} /**
	       * Destroys the Drilldown Menu
	       * @function
	       */},{key:'destroy',value:function destroy(){this._hideAll();Foundation.Nest.Burn(this.$element,'drilldown');this.$element.unwrap().find('.js-drilldown-back, .is-submenu-parent-item').remove().end().find('.is-active, .is-closing, .is-drilldown-submenu').removeClass('is-active is-closing is-drilldown-submenu').end().find('[data-submenu]').removeAttr('aria-hidden tabindex role');this.$submenuAnchors.each(function(){$(this).off('.zf.drilldown');});this.$element.find('a').each(function(){var $link=$(this);$link.removeAttr('tabindex');if($link.data('savedHref')){$link.attr('href',$link.data('savedHref')).removeData('savedHref');}else {return;}});Foundation.unregisterPlugin(this);}}]);return Drilldown;})();Drilldown.defaults = { /**
	     * Markup used for JS generated back button. Prepended to submenu lists and deleted on `destroy` method, 'js-drilldown-back' class required. Remove the backslash (`\`) if copy and pasting.
	     * @option
	     * @example '<\li><\a>Back<\/a><\/li>'
	     */backButton:'<li class="js-drilldown-back"><a tabindex="0">Back</a></li>', /**
	     * Markup used to wrap drilldown menu. Use a class name for independent styling; the JS applied class: `is-drilldown` is required. Remove the backslash (`\`) if copy and pasting.
	     * @option
	     * @example '<\div class="is-drilldown"><\/div>'
	     */wrapper:'<div></div>', /**
	     * Adds the parent link to the submenu.
	     * @option
	     * @example false
	     */parentLink:false, /**
	     * Allow the menu to return to root list on body click.
	     * @option
	     * @example false
	     */closeOnClick:false // holdOpen: false
	}; // Window exports
	Foundation.plugin(Drilldown,'Drilldown');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * AccordionMenu module.
	   * @module foundation.accordionMenu
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.motion
	   * @requires foundation.util.nest
	   */var AccordionMenu=(function(){ /**
	     * Creates a new instance of an accordion menu.
	     * @class
	     * @fires AccordionMenu#init
	     * @param {jQuery} element - jQuery object to make into an accordion menu.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function AccordionMenu(element,options){_classCallCheck(this,AccordionMenu);this.$element = element;this.options = $.extend({},AccordionMenu.defaults,this.$element.data(),options);Foundation.Nest.Feather(this.$element,'accordion');this._init();Foundation.registerPlugin(this,'AccordionMenu');Foundation.Keyboard.register('AccordionMenu',{'ENTER':'toggle','SPACE':'toggle','ARROW_RIGHT':'open','ARROW_UP':'up','ARROW_DOWN':'down','ARROW_LEFT':'close','ESCAPE':'closeAll'});} /**
	     * Initializes the accordion menu by hiding all nested menus.
	     * @private
	     */_createClass(AccordionMenu,[{key:'_init',value:function _init(){this.$element.find('[data-submenu]').not('.is-active').slideUp(0); //.find('a').css('padding-left', '1rem');
	this.$element.attr({'role':'menu','aria-multiselectable':this.options.multiOpen});this.$menuLinks = this.$element.find('.is-accordion-submenu-parent');this.$menuLinks.each(function(){var linkId=this.id || Foundation.GetYoDigits(6,'acc-menu-link'),$elem=$(this),$sub=$elem.children('[data-submenu]'),subId=$sub[0].id || Foundation.GetYoDigits(6,'acc-menu'),isActive=$sub.hasClass('is-active');$elem.attr({'aria-controls':subId,'aria-expanded':isActive,'role':'menuitem','id':linkId});$sub.attr({'aria-labelledby':linkId,'aria-hidden':!isActive,'role':'menu','id':subId});});var initPanes=this.$element.find('.is-active');if(initPanes.length){var _this=this;initPanes.each(function(){_this.down($(this));});}this._events();} /**
	       * Adds event handlers for items within the menu.
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;this.$element.find('li').each(function(){var $submenu=$(this).children('[data-submenu]');if($submenu.length){$(this).children('a').off('click.zf.accordionMenu').on('click.zf.accordionMenu',function(e){e.preventDefault();_this.toggle($submenu);});}}).on('keydown.zf.accordionmenu',function(e){var $element=$(this),$elements=$element.parent('ul').children('li'),$prevElement,$nextElement,$target=$element.children('[data-submenu]');$elements.each(function(i){if($(this).is($element)){$prevElement = $elements.eq(Math.max(0,i - 1)).find('a').first();$nextElement = $elements.eq(Math.min(i + 1,$elements.length - 1)).find('a').first();if($(this).children('[data-submenu]:visible').length){ // has open sub menu
	$nextElement = $element.find('li:first-child').find('a').first();}if($(this).is(':first-child')){ // is first element of sub menu
	$prevElement = $element.parents('li').first().find('a').first();}else if($prevElement.parents('li').first().children('[data-submenu]:visible').length){ // if previous element has open sub menu
	$prevElement = $prevElement.parents('li').find('li:last-child').find('a').first();}if($(this).is(':last-child')){ // is last element of sub menu
	$nextElement = $element.parents('li').first().next('li').find('a').first();}return;}});Foundation.Keyboard.handleKey(e,'AccordionMenu',{open:function open(){if($target.is(':hidden')){_this.down($target);$target.find('li').first().find('a').first().focus();}},close:function close(){if($target.length && !$target.is(':hidden')){ // close active sub of this item
	_this.up($target);}else if($element.parent('[data-submenu]').length){ // close currently open sub
	_this.up($element.parent('[data-submenu]'));$element.parents('li').first().find('a').first().focus();}},up:function up(){$prevElement.focus();return true;},down:function down(){$nextElement.focus();return true;},toggle:function toggle(){if($element.children('[data-submenu]').length){_this.toggle($element.children('[data-submenu]'));}},closeAll:function closeAll(){_this.hideAll();},handled:function handled(preventDefault){if(preventDefault){e.preventDefault();}e.stopImmediatePropagation();}});}); //.attr('tabindex', 0);
	} /**
	       * Closes all panes of the menu.
	       * @function
	       */},{key:'hideAll',value:function hideAll(){this.$element.find('[data-submenu]').slideUp(this.options.slideSpeed);} /**
	       * Toggles the open/close state of a submenu.
	       * @function
	       * @param {jQuery} $target - the submenu to toggle
	       */},{key:'toggle',value:function toggle($target){if(!$target.is(':animated')){if(!$target.is(':hidden')){this.up($target);}else {this.down($target);}}} /**
	       * Opens the sub-menu defined by `$target`.
	       * @param {jQuery} $target - Sub-menu to open.
	       * @fires AccordionMenu#down
	       */},{key:'down',value:function down($target){var _this=this;if(!this.options.multiOpen){this.up(this.$element.find('.is-active').not($target.parentsUntil(this.$element).add($target)));}$target.addClass('is-active').attr({'aria-hidden':false}).parent('.is-accordion-submenu-parent').attr({'aria-expanded':true}); //Foundation.Move(this.options.slideSpeed, $target, function() {
	$target.slideDown(_this.options.slideSpeed,function(){ /**
	           * Fires when the menu is done opening.
	           * @event AccordionMenu#down
	           */_this.$element.trigger('down.zf.accordionMenu',[$target]);}); //});
	} /**
	       * Closes the sub-menu defined by `$target`. All sub-menus inside the target will be closed as well.
	       * @param {jQuery} $target - Sub-menu to close.
	       * @fires AccordionMenu#up
	       */},{key:'up',value:function up($target){var _this=this; //Foundation.Move(this.options.slideSpeed, $target, function(){
	$target.slideUp(_this.options.slideSpeed,function(){ /**
	           * Fires when the menu is done collapsing up.
	           * @event AccordionMenu#up
	           */_this.$element.trigger('up.zf.accordionMenu',[$target]);}); //});
	var $menus=$target.find('[data-submenu]').slideUp(0).addBack().attr('aria-hidden',true);$menus.parent('.is-accordion-submenu-parent').attr('aria-expanded',false);} /**
	       * Destroys an instance of accordion menu.
	       * @fires AccordionMenu#destroyed
	       */},{key:'destroy',value:function destroy(){this.$element.find('[data-submenu]').slideDown(0).css('display','');this.$element.find('a').off('click.zf.accordionMenu');Foundation.Nest.Burn(this.$element,'accordion');Foundation.unregisterPlugin(this);}}]);return AccordionMenu;})();AccordionMenu.defaults = { /**
	     * Amount of time to animate the opening of a submenu in ms.
	     * @option
	     * @example 250
	     */slideSpeed:250, /**
	     * Allow the menu to have multiple open panes.
	     * @option
	     * @example true
	     */multiOpen:true}; // Window exports
	Foundation.plugin(AccordionMenu,'AccordionMenu');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * DropdownMenu module.
	   * @module foundation.dropdown-menu
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.box
	   * @requires foundation.util.nest
	   */var DropdownMenu=(function(){ /**
	     * Creates a new instance of DropdownMenu.
	     * @class
	     * @fires DropdownMenu#init
	     * @param {jQuery} element - jQuery object to make into a dropdown menu.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function DropdownMenu(element,options){_classCallCheck(this,DropdownMenu);this.$element = element;this.options = $.extend({},DropdownMenu.defaults,this.$element.data(),options);Foundation.Nest.Feather(this.$element,'dropdown');this._init();Foundation.registerPlugin(this,'DropdownMenu');Foundation.Keyboard.register('DropdownMenu',{'ENTER':'open','SPACE':'open','ARROW_RIGHT':'next','ARROW_UP':'up','ARROW_DOWN':'down','ARROW_LEFT':'previous','ESCAPE':'close'});} /**
	     * Initializes the plugin, and calls _prepareMenu
	     * @private
	     * @function
	     */_createClass(DropdownMenu,[{key:'_init',value:function _init(){var subs=this.$element.find('li.is-dropdown-submenu-parent');this.$element.children('.is-dropdown-submenu-parent').children('.is-dropdown-submenu').addClass('first-sub');this.$menuItems = this.$element.find('[role="menuitem"]');this.$tabs = this.$element.children('[role="menuitem"]');this.$tabs.find('ul.is-dropdown-submenu').addClass(this.options.verticalClass);if(this.$element.hasClass(this.options.rightClass) || this.options.alignment === 'right' || Foundation.rtl() || this.$element.parents('.top-bar-right').is('*')){this.options.alignment = 'right';subs.addClass('opens-left');}else {subs.addClass('opens-right');}this.changed = false;this._events();}},{key:'_isVertical',value:function _isVertical(){return this.$tabs.css('display') === 'block';} /**
	       * Adds event listeners to elements within the menu
	       * @private
	       * @function
	       */},{key:'_events',value:function _events(){var _this=this,hasTouch='ontouchstart' in window || typeof window.ontouchstart !== 'undefined',parClass='is-dropdown-submenu-parent'; // used for onClick and in the keyboard handlers
	var handleClickFn=function handleClickFn(e){var $elem=$(e.target).parentsUntil('ul','.' + parClass),hasSub=$elem.hasClass(parClass),hasClicked=$elem.attr('data-is-click') === 'true',$sub=$elem.children('.is-dropdown-submenu');if(hasSub){if(hasClicked){if(!_this.options.closeOnClick || !_this.options.clickOpen && !hasTouch || _this.options.forceFollow && hasTouch){return;}else {e.stopImmediatePropagation();e.preventDefault();_this._hide($elem);}}else {e.preventDefault();e.stopImmediatePropagation();_this._show($sub);$elem.add($elem.parentsUntil(_this.$element,'.' + parClass)).attr('data-is-click',true);}}else {if(_this.options.closeOnClickInside){_this._hide($elem);}return;}};if(this.options.clickOpen || hasTouch){this.$menuItems.on('click.zf.dropdownmenu touchstart.zf.dropdownmenu',handleClickFn);}if(!this.options.disableHover){this.$menuItems.on('mouseenter.zf.dropdownmenu',function(e){var $elem=$(this),hasSub=$elem.hasClass(parClass);if(hasSub){clearTimeout(_this.delay);_this.delay = setTimeout(function(){_this._show($elem.children('.is-dropdown-submenu'));},_this.options.hoverDelay);}}).on('mouseleave.zf.dropdownmenu',function(e){var $elem=$(this),hasSub=$elem.hasClass(parClass);if(hasSub && _this.options.autoclose){if($elem.attr('data-is-click') === 'true' && _this.options.clickOpen){return false;}clearTimeout(_this.delay);_this.delay = setTimeout(function(){_this._hide($elem);},_this.options.closingTime);}});}this.$menuItems.on('keydown.zf.dropdownmenu',function(e){var $element=$(e.target).parentsUntil('ul','[role="menuitem"]'),isTab=_this.$tabs.index($element) > -1,$elements=isTab?_this.$tabs:$element.siblings('li').add($element),$prevElement,$nextElement;$elements.each(function(i){if($(this).is($element)){$prevElement = $elements.eq(i - 1);$nextElement = $elements.eq(i + 1);return;}});var nextSibling=function nextSibling(){if(!$element.is(':last-child')){$nextElement.children('a:first').focus();e.preventDefault();}},prevSibling=function prevSibling(){$prevElement.children('a:first').focus();e.preventDefault();},openSub=function openSub(){var $sub=$element.children('ul.is-dropdown-submenu');if($sub.length){_this._show($sub);$element.find('li > a:first').focus();e.preventDefault();}else {return;}},closeSub=function closeSub(){ //if ($element.is(':first-child')) {
	var close=$element.parent('ul').parent('li');close.children('a:first').focus();_this._hide(close);e.preventDefault(); //}
	};var functions={open:openSub,close:function close(){_this._hide(_this.$element);_this.$menuItems.find('a:first').focus(); // focus to first element
	e.preventDefault();},handled:function handled(){e.stopImmediatePropagation();}};if(isTab){if(_this._isVertical()){ // vertical menu
	if(Foundation.rtl()){ // right aligned
	$.extend(functions,{down:nextSibling,up:prevSibling,next:closeSub,previous:openSub});}else { // left aligned
	$.extend(functions,{down:nextSibling,up:prevSibling,next:openSub,previous:closeSub});}}else { // horizontal menu
	if(Foundation.rtl()){ // right aligned
	$.extend(functions,{next:prevSibling,previous:nextSibling,down:openSub,up:closeSub});}else { // left aligned
	$.extend(functions,{next:nextSibling,previous:prevSibling,down:openSub,up:closeSub});}}}else { // not tabs -> one sub
	if(Foundation.rtl()){ // right aligned
	$.extend(functions,{next:closeSub,previous:openSub,down:nextSibling,up:prevSibling});}else { // left aligned
	$.extend(functions,{next:openSub,previous:closeSub,down:nextSibling,up:prevSibling});}}Foundation.Keyboard.handleKey(e,'DropdownMenu',functions);});} /**
	       * Adds an event handler to the body to close any dropdowns on a click.
	       * @function
	       * @private
	       */},{key:'_addBodyHandler',value:function _addBodyHandler(){var $body=$(document.body),_this=this;$body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu').on('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu',function(e){var $link=_this.$element.find(e.target);if($link.length){return;}_this._hide();$body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu');});} /**
	       * Opens a dropdown pane, and checks for collisions first.
	       * @param {jQuery} $sub - ul element that is a submenu to show
	       * @function
	       * @private
	       * @fires DropdownMenu#show
	       */},{key:'_show',value:function _show($sub){var idx=this.$tabs.index(this.$tabs.filter(function(i,el){return $(el).find($sub).length > 0;}));var $sibs=$sub.parent('li.is-dropdown-submenu-parent').siblings('li.is-dropdown-submenu-parent');this._hide($sibs,idx);$sub.css('visibility','hidden').addClass('js-dropdown-active').attr({'aria-hidden':false}).parent('li.is-dropdown-submenu-parent').addClass('is-active').attr({'aria-expanded':true});var clear=Foundation.Box.ImNotTouchingYou($sub,null,true);if(!clear){var oldClass=this.options.alignment === 'left'?'-right':'-left',$parentLi=$sub.parent('.is-dropdown-submenu-parent');$parentLi.removeClass('opens' + oldClass).addClass('opens-' + this.options.alignment);clear = Foundation.Box.ImNotTouchingYou($sub,null,true);if(!clear){$parentLi.removeClass('opens-' + this.options.alignment).addClass('opens-inner');}this.changed = true;}$sub.css('visibility','');if(this.options.closeOnClick){this._addBodyHandler();} /**
	         * Fires when the new dropdown pane is visible.
	         * @event DropdownMenu#show
	         */this.$element.trigger('show.zf.dropdownmenu',[$sub]);} /**
	       * Hides a single, currently open dropdown pane, if passed a parameter, otherwise, hides everything.
	       * @function
	       * @param {jQuery} $elem - element with a submenu to hide
	       * @param {Number} idx - index of the $tabs collection to hide
	       * @private
	       */},{key:'_hide',value:function _hide($elem,idx){var $toClose;if($elem && $elem.length){$toClose = $elem;}else if(idx !== undefined){$toClose = this.$tabs.not(function(i,el){return i === idx;});}else {$toClose = this.$element;}var somethingToClose=$toClose.hasClass('is-active') || $toClose.find('.is-active').length > 0;if(somethingToClose){$toClose.find('li.is-active').add($toClose).attr({'aria-expanded':false,'data-is-click':false}).removeClass('is-active');$toClose.find('ul.js-dropdown-active').attr({'aria-hidden':true}).removeClass('js-dropdown-active');if(this.changed || $toClose.find('opens-inner').length){var oldClass=this.options.alignment === 'left'?'right':'left';$toClose.find('li.is-dropdown-submenu-parent').add($toClose).removeClass('opens-inner opens-' + this.options.alignment).addClass('opens-' + oldClass);this.changed = false;} /**
	           * Fires when the open menus are closed.
	           * @event DropdownMenu#hide
	           */this.$element.trigger('hide.zf.dropdownmenu',[$toClose]);}} /**
	       * Destroys the plugin.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$menuItems.off('.zf.dropdownmenu').removeAttr('data-is-click').removeClass('is-right-arrow is-left-arrow is-down-arrow opens-right opens-left opens-inner');$(document.body).off('.zf.dropdownmenu');Foundation.Nest.Burn(this.$element,'dropdown');Foundation.unregisterPlugin(this);}}]);return DropdownMenu;})(); /**
	   * Default settings for plugin
	   */DropdownMenu.defaults = { /**
	     * Disallows hover events from opening submenus
	     * @option
	     * @example false
	     */disableHover:false, /**
	     * Allow a submenu to automatically close on a mouseleave event, if not clicked open.
	     * @option
	     * @example true
	     */autoclose:true, /**
	     * Amount of time to delay opening a submenu on hover event.
	     * @option
	     * @example 50
	     */hoverDelay:50, /**
	     * Allow a submenu to open/remain open on parent click event. Allows cursor to move away from menu.
	     * @option
	     * @example true
	     */clickOpen:false, /**
	     * Amount of time to delay closing a submenu on a mouseleave event.
	     * @option
	     * @example 500
	     */closingTime:500, /**
	     * Position of the menu relative to what direction the submenus should open. Handled by JS.
	     * @option
	     * @example 'left'
	     */alignment:'left', /**
	     * Allow clicks on the body to close any open submenus.
	     * @option
	     * @example true
	     */closeOnClick:true, /**
	     * Allow clicks on leaf anchor links to close any open submenus.
	     * @option
	     * @example true
	     */closeOnClickInside:true, /**
	     * Class applied to vertical oriented menus, Foundation default is `vertical`. Update this if using your own class.
	     * @option
	     * @example 'vertical'
	     */verticalClass:'vertical', /**
	     * Class applied to right-side oriented menus, Foundation default is `align-right`. Update this if using your own class.
	     * @option
	     * @example 'align-right'
	     */rightClass:'align-right', /**
	     * Boolean to force overide the clicking of links to perform default action, on second touch event for mobile.
	     * @option
	     * @example false
	     */forceFollow:true}; // Window exports
	Foundation.plugin(DropdownMenu,'DropdownMenu');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Magellan module.
	   * @module foundation.magellan
	   */var Magellan=(function(){ /**
	     * Creates a new instance of Magellan.
	     * @class
	     * @fires Magellan#init
	     * @param {Object} element - jQuery object to add the trigger to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Magellan(element,options){_classCallCheck(this,Magellan);this.$element = element;this.options = $.extend({},Magellan.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Magellan');} /**
	     * Initializes the Magellan plugin and calls functions to get equalizer functioning on load.
	     * @private
	     */_createClass(Magellan,[{key:'_init',value:function _init(){var id=this.$element[0].id || Foundation.GetYoDigits(6,'magellan');var _this=this;this.$targets = $('[data-magellan-target]');this.$links = this.$element.find('a');this.$element.attr({'data-resize':id,'data-scroll':id,'id':id});this.$active = $();this.scrollPos = parseInt(window.pageYOffset,10);this._events();} /**
	       * Calculates an array of pixel values that are the demarcation lines between locations on the page.
	       * Can be invoked if new elements are added or the size of a location changes.
	       * @function
	       */},{key:'calcPoints',value:function calcPoints(){var _this=this,body=document.body,html=document.documentElement;this.points = [];this.winHeight = Math.round(Math.max(window.innerHeight,html.clientHeight));this.docHeight = Math.round(Math.max(body.scrollHeight,body.offsetHeight,html.clientHeight,html.scrollHeight,html.offsetHeight));this.$targets.each(function(){var $tar=$(this),pt=Math.round($tar.offset().top - _this.options.threshold);$tar.targetPoint = pt;_this.points.push(pt);});} /**
	       * Initializes events for Magellan.
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this,$body=$('html, body'),opts={duration:_this.options.animationDuration,easing:_this.options.animationEasing};$(window).one('load',function(){if(_this.options.deepLinking){if(location.hash){_this.scrollToLoc(location.hash);}}_this.calcPoints();_this._updateActive();});this.$element.on({'resizeme.zf.trigger':this.reflow.bind(this),'scrollme.zf.trigger':this._updateActive.bind(this)}).on('click.zf.magellan','a[href^="#"]',function(e){e.preventDefault();var arrival=this.getAttribute('href');_this.scrollToLoc(arrival);});} /**
	       * Function to scroll to a given location on the page.
	       * @param {String} loc - a properly formatted jQuery id selector. Example: '#foo'
	       * @function
	       */},{key:'scrollToLoc',value:function scrollToLoc(loc){ // Do nothing if target does not exist to prevent errors
	if(!$(loc).length){return false;}var scrollPos=Math.round($(loc).offset().top - this.options.threshold / 2 - this.options.barOffset);$('html, body').stop(true).animate({scrollTop:scrollPos},this.options.animationDuration,this.options.animationEasing);} /**
	       * Calls necessary functions to update Magellan upon DOM change
	       * @function
	       */},{key:'reflow',value:function reflow(){this.calcPoints();this._updateActive();} /**
	       * Updates the visibility of an active location link, and updates the url hash for the page, if deepLinking enabled.
	       * @private
	       * @function
	       * @fires Magellan#update
	       */},{key:'_updateActive',value:function _updateActive() /*evt, elem, scrollPos*/{var winPos= /*scrollPos ||*/parseInt(window.pageYOffset,10),curIdx;if(winPos + this.winHeight === this.docHeight){curIdx = this.points.length - 1;}else if(winPos < this.points[0]){curIdx = 0;}else {var isDown=this.scrollPos < winPos,_this=this,curVisible=this.points.filter(function(p,i){return isDown?p - _this.options.barOffset <= winPos:p - _this.options.barOffset - _this.options.threshold <= winPos;});curIdx = curVisible.length?curVisible.length - 1:0;}this.$active.removeClass(this.options.activeClass);this.$active = this.$links.filter('[href="#' + this.$targets.eq(curIdx).data('magellan-target') + '"]').addClass(this.options.activeClass);if(this.options.deepLinking){var hash=this.$active[0].getAttribute('href');if(window.history.pushState){window.history.pushState(null,null,hash);}else {window.location.hash = hash;}}this.scrollPos = winPos; /**
	         * Fires when magellan is finished updating to the new active element.
	         * @event Magellan#update
	         */this.$element.trigger('update.zf.magellan',[this.$active]);} /**
	       * Destroys an instance of Magellan and resets the url of the window.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$element.off('.zf.trigger .zf.magellan').find('.' + this.options.activeClass).removeClass(this.options.activeClass);if(this.options.deepLinking){var hash=this.$active[0].getAttribute('href');window.location.hash.replace(hash,'');}Foundation.unregisterPlugin(this);}}]);return Magellan;})(); /**
	   * Default settings for plugin
	   */Magellan.defaults = { /**
	     * Amount of time, in ms, the animated scrolling should take between locations.
	     * @option
	     * @example 500
	     */animationDuration:500, /**
	     * Animation style to use when scrolling between locations.
	     * @option
	     * @example 'ease-in-out'
	     */animationEasing:'linear', /**
	     * Number of pixels to use as a marker for location changes.
	     * @option
	     * @example 50
	     */threshold:50, /**
	     * Class applied to the active locations link on the magellan container.
	     * @option
	     * @example 'active'
	     */activeClass:'active', /**
	     * Allows the script to manipulate the url of the current page, and if supported, alter the history.
	     * @option
	     * @example true
	     */deepLinking:false, /**
	     * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
	     * @option
	     * @example 25
	     */barOffset:0}; // Window exports
	Foundation.plugin(Magellan,'Magellan');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * ResponsiveMenu module.
	   * @module foundation.responsiveMenu
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.accordionMenu
	   * @requires foundation.util.drilldown
	   * @requires foundation.util.dropdown-menu
	   */var ResponsiveMenu=(function(){ /**
	     * Creates a new instance of a responsive menu.
	     * @class
	     * @fires ResponsiveMenu#init
	     * @param {jQuery} element - jQuery object to make into a dropdown menu.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function ResponsiveMenu(element,options){_classCallCheck(this,ResponsiveMenu);this.$element = $(element);this.rules = this.$element.data('responsive-menu');this.currentMq = null;this.currentPlugin = null;this._init();this._events();Foundation.registerPlugin(this,'ResponsiveMenu');} /**
	     * Initializes the Menu by parsing the classes from the 'data-ResponsiveMenu' attribute on the element.
	     * @function
	     * @private
	     */_createClass(ResponsiveMenu,[{key:'_init',value:function _init(){ // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules
	if(typeof this.rules === 'string'){var rulesTree={}; // Parse rules from "classes" pulled from data attribute
	var rules=this.rules.split(' '); // Iterate through every rule found
	for(var i=0;i < rules.length;i++) {var rule=rules[i].split('-');var ruleSize=rule.length > 1?rule[0]:'small';var rulePlugin=rule.length > 1?rule[1]:rule[0];if(MenuPlugins[rulePlugin] !== null){rulesTree[ruleSize] = MenuPlugins[rulePlugin];}}this.rules = rulesTree;}if(!$.isEmptyObject(this.rules)){this._checkMediaQueries();}} /**
	       * Initializes events for the Menu.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;$(window).on('changed.zf.mediaquery',function(){_this._checkMediaQueries();}); // $(window).on('resize.zf.ResponsiveMenu', function() {
	//   _this._checkMediaQueries();
	// });
	} /**
	       * Checks the current screen width against available media queries. If the media query has changed, and the plugin needed has changed, the plugins will swap out.
	       * @function
	       * @private
	       */},{key:'_checkMediaQueries',value:function _checkMediaQueries(){var matchedMq,_this=this; // Iterate through each rule and find the last matching rule
	$.each(this.rules,function(key){if(Foundation.MediaQuery.atLeast(key)){matchedMq = key;}}); // No match? No dice
	if(!matchedMq)return; // Plugin already initialized? We good
	if(this.currentPlugin instanceof this.rules[matchedMq].plugin)return; // Remove existing plugin-specific CSS classes
	$.each(MenuPlugins,function(key,value){_this.$element.removeClass(value.cssClass);}); // Add the CSS class for the new plugin
	this.$element.addClass(this.rules[matchedMq].cssClass); // Create an instance of the new plugin
	if(this.currentPlugin)this.currentPlugin.destroy();this.currentPlugin = new this.rules[matchedMq].plugin(this.$element,{});} /**
	       * Destroys the instance of the current plugin on this element, as well as the window resize handler that switches the plugins out.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.currentPlugin.destroy();$(window).off('.zf.ResponsiveMenu');Foundation.unregisterPlugin(this);}}]);return ResponsiveMenu;})();ResponsiveMenu.defaults = {}; // The plugin matches the plugin classes with these plugin instances.
	var MenuPlugins={dropdown:{cssClass:'dropdown',plugin:Foundation._plugins['dropdown-menu'] || null},drilldown:{cssClass:'drilldown',plugin:Foundation._plugins['drilldown'] || null},accordion:{cssClass:'accordion-menu',plugin:Foundation._plugins['accordion-menu'] || null}}; // Window exports
	Foundation.plugin(ResponsiveMenu,'ResponsiveMenu');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Accordion module.
	   * @module foundation.accordion
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.motion
	   */var Accordion=(function(){ /**
	     * Creates a new instance of an accordion.
	     * @class
	     * @fires Accordion#init
	     * @param {jQuery} element - jQuery object to make into an accordion.
	     * @param {Object} options - a plain object with settings to override the default options.
	     */function Accordion(element,options){_classCallCheck(this,Accordion);this.$element = element;this.options = $.extend({},Accordion.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Accordion');Foundation.Keyboard.register('Accordion',{'ENTER':'toggle','SPACE':'toggle','ARROW_DOWN':'next','ARROW_UP':'previous'});} /**
	     * Initializes the accordion by animating the preset active pane(s).
	     * @private
	     */_createClass(Accordion,[{key:'_init',value:function _init(){this.$element.attr('role','tablist');this.$tabs = this.$element.children('li, [data-accordion-item]');this.$tabs.each(function(idx,el){var $el=$(el),$content=$el.children('[data-tab-content]'),id=$content[0].id || Foundation.GetYoDigits(6,'accordion'),linkId=el.id || id + '-label';$el.find('a:first').attr({'aria-controls':id,'role':'tab','id':linkId,'aria-expanded':false,'aria-selected':false});$content.attr({'role':'tabpanel','aria-labelledby':linkId,'aria-hidden':true,'id':id});});var $initActive=this.$element.find('.is-active').children('[data-tab-content]');if($initActive.length){this.down($initActive,true);}this._events();} /**
	       * Adds event handlers for items within the accordion.
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;this.$tabs.each(function(){var $elem=$(this);var $tabContent=$elem.children('[data-tab-content]');if($tabContent.length){$elem.children('a').off('click.zf.accordion keydown.zf.accordion').on('click.zf.accordion',function(e){e.preventDefault();_this.toggle($tabContent);}).on('keydown.zf.accordion',function(e){Foundation.Keyboard.handleKey(e,'Accordion',{toggle:function toggle(){_this.toggle($tabContent);},next:function next(){var $a=$elem.next().find('a').focus();if(!_this.options.multiExpand){$a.trigger('click.zf.accordion');}},previous:function previous(){var $a=$elem.prev().find('a').focus();if(!_this.options.multiExpand){$a.trigger('click.zf.accordion');}},handled:function handled(){e.preventDefault();e.stopPropagation();}});});}});} /**
	       * Toggles the selected content pane's open/close state.
	       * @param {jQuery} $target - jQuery object of the pane to toggle (`.accordion-content`).
	       * @function
	       */},{key:'toggle',value:function toggle($target){if($target.parent().hasClass('is-active')){this.up($target);}else {this.down($target);}} /**
	       * Opens the accordion tab defined by `$target`.
	       * @param {jQuery} $target - Accordion pane to open (`.accordion-content`).
	       * @param {Boolean} firstTime - flag to determine if reflow should happen.
	       * @fires Accordion#down
	       * @function
	       */},{key:'down',value:function down($target,firstTime){var _this2=this;$target.attr('aria-hidden',false).parent('[data-tab-content]').addBack().parent().addClass('is-active');if(!this.options.multiExpand && !firstTime){var $currentActive=this.$element.children('.is-active').children('[data-tab-content]');if($currentActive.length){this.up($currentActive.not($target));}}$target.slideDown(this.options.slideSpeed,function(){ /**
	           * Fires when the tab is done opening.
	           * @event Accordion#down
	           */_this2.$element.trigger('down.zf.accordion',[$target]);});$('#' + $target.attr('aria-labelledby')).attr({'aria-expanded':true,'aria-selected':true});} /**
	       * Closes the tab defined by `$target`.
	       * @param {jQuery} $target - Accordion tab to close (`.accordion-content`).
	       * @fires Accordion#up
	       * @function
	       */},{key:'up',value:function up($target){var $aunts=$target.parent().siblings(),_this=this;if(!this.options.allowAllClosed && !$aunts.hasClass('is-active') || !$target.parent().hasClass('is-active')){return;} // Foundation.Move(this.options.slideSpeed, $target, function(){
	$target.slideUp(_this.options.slideSpeed,function(){ /**
	           * Fires when the tab is done collapsing up.
	           * @event Accordion#up
	           */_this.$element.trigger('up.zf.accordion',[$target]);}); // });
	$target.attr('aria-hidden',true).parent().removeClass('is-active');$('#' + $target.attr('aria-labelledby')).attr({'aria-expanded':false,'aria-selected':false});} /**
	       * Destroys an instance of an accordion.
	       * @fires Accordion#destroyed
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$element.find('[data-tab-content]').stop(true).slideUp(0).css('display','');this.$element.find('a').off('.zf.accordion');Foundation.unregisterPlugin(this);}}]);return Accordion;})();Accordion.defaults = { /**
	     * Amount of time to animate the opening of an accordion pane.
	     * @option
	     * @example 250
	     */slideSpeed:250, /**
	     * Allow the accordion to have multiple open panes.
	     * @option
	     * @example false
	     */multiExpand:false, /**
	     * Allow the accordion to close all panes.
	     * @option
	     * @example false
	     */allowAllClosed:false}; // Window exports
	Foundation.plugin(Accordion,'Accordion');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Dropdown module.
	   * @module foundation.dropdown
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.box
	   * @requires foundation.util.triggers
	   */var Dropdown=(function(){ /**
	     * Creates a new instance of a dropdown.
	     * @class
	     * @param {jQuery} element - jQuery object to make into a dropdown.
	     *        Object should be of the dropdown panel, rather than its anchor.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Dropdown(element,options){_classCallCheck(this,Dropdown);this.$element = element;this.options = $.extend({},Dropdown.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Dropdown');Foundation.Keyboard.register('Dropdown',{'ENTER':'open','SPACE':'open','ESCAPE':'close','TAB':'tab_forward','SHIFT_TAB':'tab_backward'});} /**
	     * Initializes the plugin by setting/checking options and attributes, adding helper variables, and saving the anchor.
	     * @function
	     * @private
	     */_createClass(Dropdown,[{key:'_init',value:function _init(){var $id=this.$element.attr('id');this.$anchor = $('[data-toggle="' + $id + '"]').length?$('[data-toggle="' + $id + '"]'):$('[data-open="' + $id + '"]');this.$anchor.attr({'aria-controls':$id,'data-is-focus':false,'data-yeti-box':$id,'aria-haspopup':true,'aria-expanded':false});this.options.positionClass = this.getPositionClass();this.counter = 4;this.usedPositions = [];this.$element.attr({'aria-hidden':'true','data-yeti-box':$id,'data-resize':$id,'aria-labelledby':this.$anchor[0].id || Foundation.GetYoDigits(6,'dd-anchor')});this._events();} /**
	       * Helper function to determine current orientation of dropdown pane.
	       * @function
	       * @returns {String} position - string value of a position class.
	       */},{key:'getPositionClass',value:function getPositionClass(){var verticalPosition=this.$element[0].className.match(/(top|left|right|bottom)/g);verticalPosition = verticalPosition?verticalPosition[0]:'';var horizontalPosition=/float-(\S+)/.exec(this.$anchor[0].className);horizontalPosition = horizontalPosition?horizontalPosition[1]:'';var position=horizontalPosition?horizontalPosition + ' ' + verticalPosition:verticalPosition;return position;} /**
	       * Adjusts the dropdown panes orientation by adding/removing positioning classes.
	       * @function
	       * @private
	       * @param {String} position - position class to remove.
	       */},{key:'_reposition',value:function _reposition(position){this.usedPositions.push(position?position:'bottom'); //default, try switching to opposite side
	if(!position && this.usedPositions.indexOf('top') < 0){this.$element.addClass('top');}else if(position === 'top' && this.usedPositions.indexOf('bottom') < 0){this.$element.removeClass(position);}else if(position === 'left' && this.usedPositions.indexOf('right') < 0){this.$element.removeClass(position).addClass('right');}else if(position === 'right' && this.usedPositions.indexOf('left') < 0){this.$element.removeClass(position).addClass('left');} //if default change didn't work, try bottom or left first
	else if(!position && this.usedPositions.indexOf('top') > -1 && this.usedPositions.indexOf('left') < 0){this.$element.addClass('left');}else if(position === 'top' && this.usedPositions.indexOf('bottom') > -1 && this.usedPositions.indexOf('left') < 0){this.$element.removeClass(position).addClass('left');}else if(position === 'left' && this.usedPositions.indexOf('right') > -1 && this.usedPositions.indexOf('bottom') < 0){this.$element.removeClass(position);}else if(position === 'right' && this.usedPositions.indexOf('left') > -1 && this.usedPositions.indexOf('bottom') < 0){this.$element.removeClass(position);} //if nothing cleared, set to bottom
	else {this.$element.removeClass(position);}this.classChanged = true;this.counter--;} /**
	       * Sets the position and orientation of the dropdown pane, checks for collisions.
	       * Recursively calls itself if a collision is detected, with a new position class.
	       * @function
	       * @private
	       */},{key:'_setPosition',value:function _setPosition(){if(this.$anchor.attr('aria-expanded') === 'false'){return false;}var position=this.getPositionClass(),$eleDims=Foundation.Box.GetDimensions(this.$element),$anchorDims=Foundation.Box.GetDimensions(this.$anchor),_this=this,direction=position === 'left'?'left':position === 'right'?'left':'top',param=direction === 'top'?'height':'width',offset=param === 'height'?this.options.vOffset:this.options.hOffset;if($eleDims.width >= $eleDims.windowDims.width || !this.counter && !Foundation.Box.ImNotTouchingYou(this.$element)){this.$element.offset(Foundation.Box.GetOffsets(this.$element,this.$anchor,'center bottom',this.options.vOffset,this.options.hOffset,true)).css({'width':$eleDims.windowDims.width - this.options.hOffset * 2,'height':'auto'});this.classChanged = true;return false;}this.$element.offset(Foundation.Box.GetOffsets(this.$element,this.$anchor,position,this.options.vOffset,this.options.hOffset));while(!Foundation.Box.ImNotTouchingYou(this.$element,false,true) && this.counter) {this._reposition(position);this._setPosition();}} /**
	       * Adds event listeners to the element utilizing the triggers utility library.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;this.$element.on({'open.zf.trigger':this.open.bind(this),'close.zf.trigger':this.close.bind(this),'toggle.zf.trigger':this.toggle.bind(this),'resizeme.zf.trigger':this._setPosition.bind(this)});if(this.options.hover){this.$anchor.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown',function(){if($('body[data-whatinput="mouse"]').is('*')){clearTimeout(_this.timeout);_this.timeout = setTimeout(function(){_this.open();_this.$anchor.data('hover',true);},_this.options.hoverDelay);}}).on('mouseleave.zf.dropdown',function(){clearTimeout(_this.timeout);_this.timeout = setTimeout(function(){_this.close();_this.$anchor.data('hover',false);},_this.options.hoverDelay);});if(this.options.hoverPane){this.$element.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown',function(){clearTimeout(_this.timeout);}).on('mouseleave.zf.dropdown',function(){clearTimeout(_this.timeout);_this.timeout = setTimeout(function(){_this.close();_this.$anchor.data('hover',false);},_this.options.hoverDelay);});}}this.$anchor.add(this.$element).on('keydown.zf.dropdown',function(e){var $target=$(this),visibleFocusableElements=Foundation.Keyboard.findFocusable(_this.$element);Foundation.Keyboard.handleKey(e,'Dropdown',{tab_forward:function tab_forward(){if(_this.$element.find(':focus').is(visibleFocusableElements.eq(-1))){ // left modal downwards, setting focus to first element
	if(_this.options.trapFocus){ // if focus shall be trapped
	visibleFocusableElements.eq(0).focus();e.preventDefault();}else { // if focus is not trapped, close dropdown on focus out
	_this.close();}}},tab_backward:function tab_backward(){if(_this.$element.find(':focus').is(visibleFocusableElements.eq(0)) || _this.$element.is(':focus')){ // left modal upwards, setting focus to last element
	if(_this.options.trapFocus){ // if focus shall be trapped
	visibleFocusableElements.eq(-1).focus();e.preventDefault();}else { // if focus is not trapped, close dropdown on focus out
	_this.close();}}},open:function open(){if($target.is(_this.$anchor)){_this.open();_this.$element.attr('tabindex',-1).focus();e.preventDefault();}},close:function close(){_this.close();_this.$anchor.focus();}});});} /**
	       * Adds an event handler to the body to close any dropdowns on a click.
	       * @function
	       * @private
	       */},{key:'_addBodyHandler',value:function _addBodyHandler(){var $body=$(document.body).not(this.$element),_this=this;$body.off('click.zf.dropdown').on('click.zf.dropdown',function(e){if(_this.$anchor.is(e.target) || _this.$anchor.find(e.target).length){return;}if(_this.$element.find(e.target).length){return;}_this.close();$body.off('click.zf.dropdown');});} /**
	       * Opens the dropdown pane, and fires a bubbling event to close other dropdowns.
	       * @function
	       * @fires Dropdown#closeme
	       * @fires Dropdown#show
	       */},{key:'open',value:function open(){ // var _this = this;
	/**
	         * Fires to close other open dropdowns
	         * @event Dropdown#closeme
	         */this.$element.trigger('closeme.zf.dropdown',this.$element.attr('id'));this.$anchor.addClass('hover').attr({'aria-expanded':true}); // this.$element/*.show()*/;
	this._setPosition();this.$element.addClass('is-open').attr({'aria-hidden':false});if(this.options.autoFocus){var $focusable=Foundation.Keyboard.findFocusable(this.$element);if($focusable.length){$focusable.eq(0).focus();}}if(this.options.closeOnClick){this._addBodyHandler();} /**
	         * Fires once the dropdown is visible.
	         * @event Dropdown#show
	         */this.$element.trigger('show.zf.dropdown',[this.$element]);} /**
	       * Closes the open dropdown pane.
	       * @function
	       * @fires Dropdown#hide
	       */},{key:'close',value:function close(){if(!this.$element.hasClass('is-open')){return false;}this.$element.removeClass('is-open').attr({'aria-hidden':true});this.$anchor.removeClass('hover').attr('aria-expanded',false);if(this.classChanged){var curPositionClass=this.getPositionClass();if(curPositionClass){this.$element.removeClass(curPositionClass);}this.$element.addClass(this.options.positionClass) /*.hide()*/.css({height:'',width:''});this.classChanged = false;this.counter = 4;this.usedPositions.length = 0;}this.$element.trigger('hide.zf.dropdown',[this.$element]);} /**
	       * Toggles the dropdown pane's visibility.
	       * @function
	       */},{key:'toggle',value:function toggle(){if(this.$element.hasClass('is-open')){if(this.$anchor.data('hover'))return;this.close();}else {this.open();}} /**
	       * Destroys the dropdown.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$element.off('.zf.trigger').hide();this.$anchor.off('.zf.dropdown');Foundation.unregisterPlugin(this);}}]);return Dropdown;})();Dropdown.defaults = { /**
	     * Amount of time to delay opening a submenu on hover event.
	     * @option
	     * @example 250
	     */hoverDelay:250, /**
	     * Allow submenus to open on hover events
	     * @option
	     * @example false
	     */hover:false, /**
	     * Don't close dropdown when hovering over dropdown pane
	     * @option
	     * @example true
	     */hoverPane:false, /**
	     * Number of pixels between the dropdown pane and the triggering element on open.
	     * @option
	     * @example 1
	     */vOffset:1, /**
	     * Number of pixels between the dropdown pane and the triggering element on open.
	     * @option
	     * @example 1
	     */hOffset:1, /**
	     * Class applied to adjust open position. JS will test and fill this in.
	     * @option
	     * @example 'top'
	     */positionClass:'', /**
	     * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
	     * @option
	     * @example false
	     */trapFocus:false, /**
	     * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
	     * @option
	     * @example true
	     */autoFocus:false, /**
	     * Allows a click on the body to close the dropdown.
	     * @option
	     * @example false
	     */closeOnClick:false}; // Window exports
	Foundation.plugin(Dropdown,'Dropdown');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * OffCanvas module.
	   * @module foundation.offcanvas
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.triggers
	   * @requires foundation.util.motion
	   */var OffCanvas=(function(){ /**
	     * Creates a new instance of an off-canvas wrapper.
	     * @class
	     * @fires OffCanvas#init
	     * @param {Object} element - jQuery object to initialize.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function OffCanvas(element,options){_classCallCheck(this,OffCanvas);this.$element = element;this.options = $.extend({},OffCanvas.defaults,this.$element.data(),options);this.$lastTrigger = $();this.$triggers = $();this._init();this._events();Foundation.registerPlugin(this,'OffCanvas');Foundation.Keyboard.register('OffCanvas',{'ESCAPE':'close'});} /**
	     * Initializes the off-canvas wrapper by adding the exit overlay (if needed).
	     * @function
	     * @private
	     */_createClass(OffCanvas,[{key:'_init',value:function _init(){var id=this.$element.attr('id');this.$element.attr('aria-hidden','true'); // Find triggers that affect this element and add aria-expanded to them
	this.$triggers = $(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-expanded','false').attr('aria-controls',id); // Add a close trigger over the body if necessary
	if(this.options.closeOnClick){if($('.js-off-canvas-exit').length){this.$exiter = $('.js-off-canvas-exit');}else {var exiter=document.createElement('div');exiter.setAttribute('class','js-off-canvas-exit');$('[data-off-canvas-content]').append(exiter);this.$exiter = $(exiter);}}this.options.isRevealed = this.options.isRevealed || new RegExp(this.options.revealClass,'g').test(this.$element[0].className);if(this.options.isRevealed){this.options.revealOn = this.options.revealOn || this.$element[0].className.match(/(reveal-for-medium|reveal-for-large)/g)[0].split('-')[2];this._setMQChecker();}if(!this.options.transitionTime){this.options.transitionTime = parseFloat(window.getComputedStyle($('[data-off-canvas-wrapper]')[0]).transitionDuration) * 1000;}} /**
	       * Adds event handlers to the off-canvas wrapper and the exit overlay.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){this.$element.off('.zf.trigger .zf.offcanvas').on({'open.zf.trigger':this.open.bind(this),'close.zf.trigger':this.close.bind(this),'toggle.zf.trigger':this.toggle.bind(this),'keydown.zf.offcanvas':this._handleKeyboard.bind(this)});if(this.options.closeOnClick && this.$exiter.length){this.$exiter.on({'click.zf.offcanvas':this.close.bind(this)});}} /**
	       * Applies event listener for elements that will reveal at certain breakpoints.
	       * @private
	       */},{key:'_setMQChecker',value:function _setMQChecker(){var _this=this;$(window).on('changed.zf.mediaquery',function(){if(Foundation.MediaQuery.atLeast(_this.options.revealOn)){_this.reveal(true);}else {_this.reveal(false);}}).one('load.zf.offcanvas',function(){if(Foundation.MediaQuery.atLeast(_this.options.revealOn)){_this.reveal(true);}});} /**
	       * Handles the revealing/hiding the off-canvas at breakpoints, not the same as open.
	       * @param {Boolean} isRevealed - true if element should be revealed.
	       * @function
	       */},{key:'reveal',value:function reveal(isRevealed){var $closer=this.$element.find('[data-close]');if(isRevealed){this.close();this.isRevealed = true; // if (!this.options.forceTop) {
	//   var scrollPos = parseInt(window.pageYOffset);
	//   this.$element[0].style.transform = 'translate(0,' + scrollPos + 'px)';
	// }
	// if (this.options.isSticky) { this._stick(); }
	this.$element.off('open.zf.trigger toggle.zf.trigger');if($closer.length){$closer.hide();}}else {this.isRevealed = false; // if (this.options.isSticky || !this.options.forceTop) {
	//   this.$element[0].style.transform = '';
	//   $(window).off('scroll.zf.offcanvas');
	// }
	this.$element.on({'open.zf.trigger':this.open.bind(this),'toggle.zf.trigger':this.toggle.bind(this)});if($closer.length){$closer.show();}}} /**
	       * Opens the off-canvas menu.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       * @fires OffCanvas#opened
	       */},{key:'open',value:function open(event,trigger){if(this.$element.hasClass('is-open') || this.isRevealed){return;}var _this=this,$body=$(document.body);if(this.options.forceTop){$('body').scrollTop(0);} // window.pageYOffset = 0;
	// if (!this.options.forceTop) {
	//   var scrollPos = parseInt(window.pageYOffset);
	//   this.$element[0].style.transform = 'translate(0,' + scrollPos + 'px)';
	//   if (this.$exiter.length) {
	//     this.$exiter[0].style.transform = 'translate(0,' + scrollPos + 'px)';
	//   }
	// }
	/**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#opened
	         */var $wrapper=$('[data-off-canvas-wrapper]');$wrapper.addClass('is-off-canvas-open is-open-' + _this.options.position);_this.$element.addClass('is-open'); // if (_this.options.isSticky) {
	//   _this._stick();
	// }
	this.$triggers.attr('aria-expanded','true');this.$element.attr('aria-hidden','false').trigger('opened.zf.offcanvas');if(this.options.closeOnClick){this.$exiter.addClass('is-visible');}if(trigger){this.$lastTrigger = trigger;}if(this.options.autoFocus){$wrapper.one(Foundation.transitionend($wrapper),function(){if(_this.$element.hasClass('is-open')){ // handle double clicks
	_this.$element.attr('tabindex','-1');_this.$element.focus();}});}if(this.options.trapFocus){$wrapper.one(Foundation.transitionend($wrapper),function(){if(_this.$element.hasClass('is-open')){ // handle double clicks
	_this.$element.attr('tabindex','-1');_this.trapFocus();}});}} /**
	       * Traps focus within the offcanvas on open.
	       * @private
	       */},{key:'_trapFocus',value:function _trapFocus(){var focusable=Foundation.Keyboard.findFocusable(this.$element),first=focusable.eq(0),last=focusable.eq(-1);focusable.off('.zf.offcanvas').on('keydown.zf.offcanvas',function(e){var key=Foundation.Keyboard.parseKey(e);if(key === 'TAB' && e.target === last[0]){e.preventDefault();first.focus();}if(key === 'SHIFT_TAB' && e.target === first[0]){e.preventDefault();last.focus();}});} /**
	       * Allows the offcanvas to appear sticky utilizing translate properties.
	       * @private
	       */ // OffCanvas.prototype._stick = function() {
	//   var elStyle = this.$element[0].style;
	//
	//   if (this.options.closeOnClick) {
	//     var exitStyle = this.$exiter[0].style;
	//   }
	//
	//   $(window).on('scroll.zf.offcanvas', function(e) {
	//     console.log(e);
	//     var pageY = window.pageYOffset;
	//     elStyle.transform = 'translate(0,' + pageY + 'px)';
	//     if (exitStyle !== undefined) { exitStyle.transform = 'translate(0,' + pageY + 'px)'; }
	//   });
	//   // this.$element.trigger('stuck.zf.offcanvas');
	// };
	/**
	       * Closes the off-canvas menu.
	       * @function
	       * @param {Function} cb - optional cb to fire after closure.
	       * @fires OffCanvas#closed
	       */},{key:'close',value:function close(cb){if(!this.$element.hasClass('is-open') || this.isRevealed){return;}var _this=this; //  Foundation.Move(this.options.transitionTime, this.$element, function() {
	$('[data-off-canvas-wrapper]').removeClass('is-off-canvas-open is-open-' + _this.options.position);_this.$element.removeClass('is-open'); // Foundation._reflow();
	// });
	this.$element.attr('aria-hidden','true') /**
	         * Fires when the off-canvas menu opens.
	         * @event OffCanvas#closed
	         */.trigger('closed.zf.offcanvas'); // if (_this.options.isSticky || !_this.options.forceTop) {
	//   setTimeout(function() {
	//     _this.$element[0].style.transform = '';
	//     $(window).off('scroll.zf.offcanvas');
	//   }, this.options.transitionTime);
	// }
	if(this.options.closeOnClick){this.$exiter.removeClass('is-visible');}this.$triggers.attr('aria-expanded','false');if(this.options.trapFocus){$('[data-off-canvas-content]').removeAttr('tabindex');}} /**
	       * Toggles the off-canvas menu open or closed.
	       * @function
	       * @param {Object} event - Event object passed from listener.
	       * @param {jQuery} trigger - element that triggered the off-canvas to open.
	       */},{key:'toggle',value:function toggle(event,trigger){if(this.$element.hasClass('is-open')){this.close(event,trigger);}else {this.open(event,trigger);}} /**
	       * Handles keyboard input when detected. When the escape key is pressed, the off-canvas menu closes, and focus is restored to the element that opened the menu.
	       * @function
	       * @private
	       */},{key:'_handleKeyboard',value:function _handleKeyboard(e){var _this2=this;Foundation.Keyboard.handleKey(e,'OffCanvas',{close:function close(){_this2.close();_this2.$lastTrigger.focus();return true;},handled:function handled(){e.stopPropagation();e.preventDefault();}});} /**
	       * Destroys the offcanvas plugin.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.close();this.$element.off('.zf.trigger .zf.offcanvas');this.$exiter.off('.zf.offcanvas');Foundation.unregisterPlugin(this);}}]);return OffCanvas;})();OffCanvas.defaults = { /**
	     * Allow the user to click outside of the menu to close it.
	     * @option
	     * @example true
	     */closeOnClick:true, /**
	     * Amount of time in ms the open and close transition requires. If none selected, pulls from body style.
	     * @option
	     * @example 500
	     */transitionTime:0, /**
	     * Direction the offcanvas opens from. Determines class applied to body.
	     * @option
	     * @example left
	     */position:'left', /**
	     * Force the page to scroll to top on open.
	     * @option
	     * @example true
	     */forceTop:true, /**
	     * Allow the offcanvas to remain open for certain breakpoints.
	     * @option
	     * @example false
	     */isRevealed:false, /**
	     * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
	     * @option
	     * @example reveal-for-large
	     */revealOn:null, /**
	     * Force focus to the offcanvas on open. If true, will focus the opening trigger on close. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
	     * @option
	     * @example true
	     */autoFocus:true, /**
	     * Class used to force an offcanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
	     * @option
	     * TODO improve the regex testing for this.
	     * @example reveal-for-large
	     */revealClass:'reveal-for-', /**
	     * Triggers optional focus trapping when opening an offcanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
	     * @option
	     * @example true
	     */trapFocus:false}; // Window exports
	Foundation.plugin(OffCanvas,'OffCanvas');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Tabs module.
	   * @module foundation.tabs
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.timerAndImageLoader if tabs contain images
	   */var Tabs=(function(){ /**
	     * Creates a new instance of tabs.
	     * @class
	     * @fires Tabs#init
	     * @param {jQuery} element - jQuery object to make into tabs.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Tabs(element,options){_classCallCheck(this,Tabs);this.$element = element;this.options = $.extend({},Tabs.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Tabs');Foundation.Keyboard.register('Tabs',{'ENTER':'open','SPACE':'open','ARROW_RIGHT':'next','ARROW_UP':'previous','ARROW_DOWN':'next','ARROW_LEFT':'previous' // 'TAB': 'next',
	// 'SHIFT_TAB': 'previous'
	});} /**
	     * Initializes the tabs by showing and focusing (if autoFocus=true) the preset active tab.
	     * @private
	     */_createClass(Tabs,[{key:'_init',value:function _init(){var _this=this;this.$tabTitles = this.$element.find('.' + this.options.linkClass);this.$tabContent = $('[data-tabs-content="' + this.$element[0].id + '"]');this.$tabTitles.each(function(){var $elem=$(this),$link=$elem.find('a'),isActive=$elem.hasClass('is-active'),hash=$link[0].hash.slice(1),linkId=$link[0].id?$link[0].id:hash + '-label',$tabContent=$('#' + hash);$elem.attr({'role':'presentation'});$link.attr({'role':'tab','aria-controls':hash,'aria-selected':isActive,'id':linkId});$tabContent.attr({'role':'tabpanel','aria-hidden':!isActive,'aria-labelledby':linkId});if(isActive && _this.options.autoFocus){$link.focus();}});if(this.options.matchHeight){var $images=this.$tabContent.find('img');if($images.length){Foundation.onImagesLoaded($images,this._setHeight.bind(this));}else {this._setHeight();}}this._events();} /**
	       * Adds event handlers for items within the tabs.
	       * @private
	       */},{key:'_events',value:function _events(){this._addKeyHandler();this._addClickHandler();this._setHeightMqHandler = null;if(this.options.matchHeight){this._setHeightMqHandler = this._setHeight.bind(this);$(window).on('changed.zf.mediaquery',this._setHeightMqHandler);}} /**
	       * Adds click handlers for items within the tabs.
	       * @private
	       */},{key:'_addClickHandler',value:function _addClickHandler(){var _this=this;this.$element.off('click.zf.tabs').on('click.zf.tabs','.' + this.options.linkClass,function(e){e.preventDefault();e.stopPropagation();if($(this).hasClass('is-active')){return;}_this._handleTabChange($(this));});} /**
	       * Adds keyboard event handlers for items within the tabs.
	       * @private
	       */},{key:'_addKeyHandler',value:function _addKeyHandler(){var _this=this;var $firstTab=_this.$element.find('li:first-of-type');var $lastTab=_this.$element.find('li:last-of-type');this.$tabTitles.off('keydown.zf.tabs').on('keydown.zf.tabs',function(e){if(e.which === 9)return;var $element=$(this),$elements=$element.parent('ul').children('li'),$prevElement,$nextElement;$elements.each(function(i){if($(this).is($element)){if(_this.options.wrapOnKeys){$prevElement = i === 0?$elements.last():$elements.eq(i - 1);$nextElement = i === $elements.length - 1?$elements.first():$elements.eq(i + 1);}else {$prevElement = $elements.eq(Math.max(0,i - 1));$nextElement = $elements.eq(Math.min(i + 1,$elements.length - 1));}return;}}); // handle keyboard event with keyboard util
	Foundation.Keyboard.handleKey(e,'Tabs',{open:function open(){$element.find('[role="tab"]').focus();_this._handleTabChange($element);},previous:function previous(){$prevElement.find('[role="tab"]').focus();_this._handleTabChange($prevElement);},next:function next(){$nextElement.find('[role="tab"]').focus();_this._handleTabChange($nextElement);},handled:function handled(){e.stopPropagation();e.preventDefault();}});});} /**
	       * Opens the tab `$targetContent` defined by `$target`.
	       * @param {jQuery} $target - Tab to open.
	       * @fires Tabs#change
	       * @function
	       */},{key:'_handleTabChange',value:function _handleTabChange($target){var $tabLink=$target.find('[role="tab"]'),hash=$tabLink[0].hash,$targetContent=this.$tabContent.find(hash),$oldTab=this.$element.find('.' + this.options.linkClass + '.is-active').removeClass('is-active').find('[role="tab"]').attr({'aria-selected':'false'});$('#' + $oldTab.attr('aria-controls')).removeClass('is-active').attr({'aria-hidden':'true'});$target.addClass('is-active');$tabLink.attr({'aria-selected':'true'});$targetContent.addClass('is-active').attr({'aria-hidden':'false'}); /**
	         * Fires when the plugin has successfully changed tabs.
	         * @event Tabs#change
	         */this.$element.trigger('change.zf.tabs',[$target]);} /**
	       * Public method for selecting a content pane to display.
	       * @param {jQuery | String} elem - jQuery object or string of the id of the pane to display.
	       * @function
	       */},{key:'selectTab',value:function selectTab(elem){var idStr;if(typeof elem === 'object'){idStr = elem[0].id;}else {idStr = elem;}if(idStr.indexOf('#') < 0){idStr = '#' + idStr;}var $target=this.$tabTitles.find('[href="' + idStr + '"]').parent('.' + this.options.linkClass);this._handleTabChange($target);}},{key:'_setHeight', /**
	       * Sets the height of each panel to the height of the tallest panel.
	       * If enabled in options, gets called on media query change.
	       * If loading content via external source, can be called directly or with _reflow.
	       * @function
	       * @private
	       */value:function _setHeight(){var max=0;this.$tabContent.find('.' + this.options.panelClass).css('height','').each(function(){var panel=$(this),isActive=panel.hasClass('is-active');if(!isActive){panel.css({'visibility':'hidden','display':'block'});}var temp=this.getBoundingClientRect().height;if(!isActive){panel.css({'visibility':'','display':''});}max = temp > max?temp:max;}).css('height',max + 'px');} /**
	       * Destroys an instance of an tabs.
	       * @fires Tabs#destroyed
	       */},{key:'destroy',value:function destroy(){this.$element.find('.' + this.options.linkClass).off('.zf.tabs').hide().end().find('.' + this.options.panelClass).hide();if(this.options.matchHeight){if(this._setHeightMqHandler != null){$(window).off('changed.zf.mediaquery',this._setHeightMqHandler);}}Foundation.unregisterPlugin(this);}}]);return Tabs;})();Tabs.defaults = { /**
	     * Allows the window to scroll to content of active pane on load if set to true.
	     * @option
	     * @example false
	     */autoFocus:false, /**
	     * Allows keyboard input to 'wrap' around the tab links.
	     * @option
	     * @example true
	     */wrapOnKeys:true, /**
	     * Allows the tab content panes to match heights if set to true.
	     * @option
	     * @example false
	     */matchHeight:false, /**
	     * Class applied to `li`'s in tab link list.
	     * @option
	     * @example 'tabs-title'
	     */linkClass:'tabs-title', /**
	     * Class applied to the content containers.
	     * @option
	     * @example 'tabs-panel'
	     */panelClass:'tabs-panel'};function checkClass($elem){return $elem.hasClass('is-active');} // Window exports
	Foundation.plugin(Tabs,'Tabs');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Reveal module.
	   * @module foundation.reveal
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.box
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.motion if using animations
	   */var Reveal=(function(){ /**
	     * Creates a new instance of Reveal.
	     * @class
	     * @param {jQuery} element - jQuery object to use for the modal.
	     * @param {Object} options - optional parameters.
	     */function Reveal(element,options){_classCallCheck(this,Reveal);this.$element = element;this.options = $.extend({},Reveal.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Reveal');Foundation.Keyboard.register('Reveal',{'ENTER':'open','SPACE':'open','ESCAPE':'close','TAB':'tab_forward','SHIFT_TAB':'tab_backward'});} /**
	     * Initializes the modal by adding the overlay and close buttons, (if selected).
	     * @private
	     */_createClass(Reveal,[{key:'_init',value:function _init(){this.id = this.$element.attr('id');this.isActive = false;this.cached = {mq:Foundation.MediaQuery.current};this.isMobile = mobileSniff();this.$anchor = $('[data-open="' + this.id + '"]').length?$('[data-open="' + this.id + '"]'):$('[data-toggle="' + this.id + '"]');this.$anchor.attr({'aria-controls':this.id,'aria-haspopup':true,'tabindex':0});if(this.options.fullScreen || this.$element.hasClass('full')){this.options.fullScreen = true;this.options.overlay = false;}if(this.options.overlay && !this.$overlay){this.$overlay = this._makeOverlay(this.id);}this.$element.attr({'role':'dialog','aria-hidden':true,'data-yeti-box':this.id,'data-resize':this.id});if(this.$overlay){this.$element.detach().appendTo(this.$overlay);}else {this.$element.detach().appendTo($('body'));this.$element.addClass('without-overlay');}this._events();if(this.options.deepLink && window.location.hash === '#' + this.id){$(window).one('load.zf.reveal',this.open.bind(this));}} /**
	       * Creates an overlay div to display behind the modal.
	       * @private
	       */},{key:'_makeOverlay',value:function _makeOverlay(id){var $overlay=$('<div></div>').addClass('reveal-overlay').appendTo('body');return $overlay;} /**
	       * Updates position of modal
	       * TODO:  Figure out if we actually need to cache these values or if it doesn't matter
	       * @private
	       */},{key:'_updatePosition',value:function _updatePosition(){var width=this.$element.outerWidth();var outerWidth=$(window).width();var height=this.$element.outerHeight();var outerHeight=$(window).height();var left,top;if(this.options.hOffset === 'auto'){left = parseInt((outerWidth - width) / 2,10);}else {left = parseInt(this.options.hOffset,10);}if(this.options.vOffset === 'auto'){if(height > outerHeight){top = parseInt(Math.min(100,outerHeight / 10),10);}else {top = parseInt((outerHeight - height) / 4,10);}}else {top = parseInt(this.options.vOffset,10);}this.$element.css({top:top + 'px'}); // only worry about left if we don't have an overlay or we havea  horizontal offset,
	// otherwise we're perfectly in the middle
	if(!this.$overlay || this.options.hOffset !== 'auto'){this.$element.css({left:left + 'px'});this.$element.css({margin:'0px'});}} /**
	       * Adds event handlers for the modal.
	       * @private
	       */},{key:'_events',value:function _events(){var _this2=this;var _this=this;this.$element.on({'open.zf.trigger':this.open.bind(this),'close.zf.trigger':function closeZfTrigger(event,$element){if(event.target === _this.$element[0] || $(event.target).parents('[data-closable]')[0] === $element){ // only close reveal when it's explicitly called
	return _this2.close.apply(_this2);}},'toggle.zf.trigger':this.toggle.bind(this),'resizeme.zf.trigger':function resizemeZfTrigger(){_this._updatePosition();}});if(this.$anchor.length){this.$anchor.on('keydown.zf.reveal',function(e){if(e.which === 13 || e.which === 32){e.stopPropagation();e.preventDefault();_this.open();}});}if(this.options.closeOnClick && this.options.overlay){this.$overlay.off('.zf.reveal').on('click.zf.reveal',function(e){if(e.target === _this.$element[0] || $.contains(_this.$element[0],e.target) || !$.contains(document,e.target)){return;}_this.close();});}if(this.options.deepLink){$(window).on('popstate.zf.reveal:' + this.id,this._handleState.bind(this));}} /**
	       * Handles modal methods on back/forward button clicks or any other event that triggers popstate.
	       * @private
	       */},{key:'_handleState',value:function _handleState(e){if(window.location.hash === '#' + this.id && !this.isActive){this.open();}else {this.close();}} /**
	       * Opens the modal controlled by `this.$anchor`, and closes all others by default.
	       * @function
	       * @fires Reveal#closeme
	       * @fires Reveal#open
	       */},{key:'open',value:function open(){var _this3=this;if(this.options.deepLink){var hash='#' + this.id;if(window.history.pushState){window.history.pushState(null,null,hash);}else {window.location.hash = hash;}}this.isActive = true; // Make elements invisible, but remove display: none so we can get size and positioning
	this.$element.css({'visibility':'hidden'}).show().scrollTop(0);if(this.options.overlay){this.$overlay.css({'visibility':'hidden'}).show();}this._updatePosition();this.$element.hide().css({'visibility':''});if(this.$overlay){this.$overlay.css({'visibility':''}).hide();if(this.$element.hasClass('fast')){this.$overlay.addClass('fast');}else if(this.$element.hasClass('slow')){this.$overlay.addClass('slow');}}if(!this.options.multipleOpened){ /**
	           * Fires immediately before the modal opens.
	           * Closes any other modals that are currently open
	           * @event Reveal#closeme
	           */this.$element.trigger('closeme.zf.reveal',this.id);} // Motion UI method of reveal
	if(this.options.animationIn){var _this;(function(){var afterAnimationFocus=function afterAnimationFocus(){_this.$element.attr({'aria-hidden':false,'tabindex':-1}).focus();};_this = _this3;if(_this3.options.overlay){Foundation.Motion.animateIn(_this3.$overlay,'fade-in');}Foundation.Motion.animateIn(_this3.$element,_this3.options.animationIn,function(){_this3.focusableElements = Foundation.Keyboard.findFocusable(_this3.$element);afterAnimationFocus();});})();} // jQuery method of reveal
	else {if(this.options.overlay){this.$overlay.show(0);}this.$element.show(this.options.showDelay);} // handle accessibility
	this.$element.attr({'aria-hidden':false,'tabindex':-1}).focus(); /**
	         * Fires when the modal has successfully opened.
	         * @event Reveal#open
	         */this.$element.trigger('open.zf.reveal');if(this.isMobile){this.originalScrollPos = window.pageYOffset;$('html, body').addClass('is-reveal-open');}else {$('body').addClass('is-reveal-open');}setTimeout(function(){_this3._extraHandlers();},0);} /**
	       * Adds extra event handlers for the body and window if necessary.
	       * @private
	       */},{key:'_extraHandlers',value:function _extraHandlers(){var _this=this;this.focusableElements = Foundation.Keyboard.findFocusable(this.$element);if(!this.options.overlay && this.options.closeOnClick && !this.options.fullScreen){$('body').on('click.zf.reveal',function(e){if(e.target === _this.$element[0] || $.contains(_this.$element[0],e.target) || !$.contains(document,e.target)){return;}_this.close();});}if(this.options.closeOnEsc){$(window).on('keydown.zf.reveal',function(e){Foundation.Keyboard.handleKey(e,'Reveal',{close:function close(){if(_this.options.closeOnEsc){_this.close();_this.$anchor.focus();}}});});} // lock focus within modal while tabbing
	this.$element.on('keydown.zf.reveal',function(e){var $target=$(this); // handle keyboard event with keyboard util
	Foundation.Keyboard.handleKey(e,'Reveal',{tab_forward:function tab_forward(){_this.focusableElements = Foundation.Keyboard.findFocusable(_this.$element);if(_this.$element.find(':focus').is(_this.focusableElements.eq(-1))){ // left modal downwards, setting focus to first element
	_this.focusableElements.eq(0).focus();return true;}if(_this.focusableElements.length === 0){ // no focusable elements inside the modal at all, prevent tabbing in general
	return true;}},tab_backward:function tab_backward(){_this.focusableElements = Foundation.Keyboard.findFocusable(_this.$element);if(_this.$element.find(':focus').is(_this.focusableElements.eq(0)) || _this.$element.is(':focus')){ // left modal upwards, setting focus to last element
	_this.focusableElements.eq(-1).focus();return true;}if(_this.focusableElements.length === 0){ // no focusable elements inside the modal at all, prevent tabbing in general
	return true;}},open:function open(){if(_this.$element.find(':focus').is(_this.$element.find('[data-close]'))){setTimeout(function(){ // set focus back to anchor if close button has been activated
	_this.$anchor.focus();},1);}else if($target.is(_this.focusableElements)){ // dont't trigger if acual element has focus (i.e. inputs, links, ...)
	_this.open();}},close:function close(){if(_this.options.closeOnEsc){_this.close();_this.$anchor.focus();}},handled:function handled(preventDefault){if(preventDefault){e.preventDefault();}}});});} /**
	       * Closes the modal.
	       * @function
	       * @fires Reveal#closed
	       */},{key:'close',value:function close(){if(!this.isActive || !this.$element.is(':visible')){return false;}var _this=this; // Motion UI method of hiding
	if(this.options.animationOut){if(this.options.overlay){Foundation.Motion.animateOut(this.$overlay,'fade-out',finishUp);}else {finishUp();}Foundation.Motion.animateOut(this.$element,this.options.animationOut);} // jQuery method of hiding
	else {if(this.options.overlay){this.$overlay.hide(0,finishUp);}else {finishUp();}this.$element.hide(this.options.hideDelay);} // Conditionals to remove extra event listeners added on open
	if(this.options.closeOnEsc){$(window).off('keydown.zf.reveal');}if(!this.options.overlay && this.options.closeOnClick){$('body').off('click.zf.reveal');}this.$element.off('keydown.zf.reveal');function finishUp(){if(_this.isMobile){$('html, body').removeClass('is-reveal-open');if(_this.originalScrollPos){$('body').scrollTop(_this.originalScrollPos);_this.originalScrollPos = null;}}else {$('body').removeClass('is-reveal-open');}_this.$element.attr('aria-hidden',true); /**
	          * Fires when the modal is done closing.
	          * @event Reveal#closed
	          */_this.$element.trigger('closed.zf.reveal');} /**
	        * Resets the modal content
	        * This prevents a running video to keep going in the background
	        */if(this.options.resetOnClose){this.$element.html(this.$element.html());}this.isActive = false;if(_this.options.deepLink){if(window.history.replaceState){window.history.replaceState("",document.title,window.location.pathname);}else {window.location.hash = '';}}} /**
	       * Toggles the open/closed state of a modal.
	       * @function
	       */},{key:'toggle',value:function toggle(){if(this.isActive){this.close();}else {this.open();}}},{key:'destroy', /**
	       * Destroys an instance of a modal.
	       * @function
	       */value:function destroy(){if(this.options.overlay){this.$element.appendTo($('body')); // move $element outside of $overlay to prevent error unregisterPlugin()
	this.$overlay.hide().off().remove();}this.$element.hide().off();this.$anchor.off('.zf');$(window).off('.zf.reveal:' + this.id);Foundation.unregisterPlugin(this);}}]);return Reveal;})();Reveal.defaults = { /**
	     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
	     * @option
	     * @example 'slide-in-left'
	     */animationIn:'', /**
	     * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
	     * @option
	     * @example 'slide-out-right'
	     */animationOut:'', /**
	     * Time, in ms, to delay the opening of a modal after a click if no animation used.
	     * @option
	     * @example 10
	     */showDelay:0, /**
	     * Time, in ms, to delay the closing of a modal after a click if no animation used.
	     * @option
	     * @example 10
	     */hideDelay:0, /**
	     * Allows a click on the body/overlay to close the modal.
	     * @option
	     * @example true
	     */closeOnClick:true, /**
	     * Allows the modal to close if the user presses the `ESCAPE` key.
	     * @option
	     * @example true
	     */closeOnEsc:true, /**
	     * If true, allows multiple modals to be displayed at once.
	     * @option
	     * @example false
	     */multipleOpened:false, /**
	     * Distance, in pixels, the modal should push down from the top of the screen.
	     * @option
	     * @example auto
	     */vOffset:'auto', /**
	     * Distance, in pixels, the modal should push in from the side of the screen.
	     * @option
	     * @example auto
	     */hOffset:'auto', /**
	     * Allows the modal to be fullscreen, completely blocking out the rest of the view. JS checks for this as well.
	     * @option
	     * @example false
	     */fullScreen:false, /**
	     * Percentage of screen height the modal should push up from the bottom of the view.
	     * @option
	     * @example 10
	     */btmOffsetPct:10, /**
	     * Allows the modal to generate an overlay div, which will cover the view when modal opens.
	     * @option
	     * @example true
	     */overlay:true, /**
	     * Allows the modal to remove and reinject markup on close. Should be true if using video elements w/o using provider's api, otherwise, videos will continue to play in the background.
	     * @option
	     * @example false
	     */resetOnClose:false, /**
	     * Allows the modal to alter the url on open/close, and allows the use of the `back` button to close modals. ALSO, allows a modal to auto-maniacally open on page load IF the hash === the modal's user-set id.
	     * @option
	     * @example false
	     */deepLink:false}; // Window exports
	Foundation.plugin(Reveal,'Reveal');function iPhoneSniff(){return (/iP(ad|hone|od).*OS/.test(window.navigator.userAgent));}function androidSniff(){return (/Android/.test(window.navigator.userAgent));}function mobileSniff(){return iPhoneSniff() || androidSniff();}})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Tooltip module.
	   * @module foundation.tooltip
	   * @requires foundation.util.box
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.triggers
	   */var Tooltip=(function(){ /**
	     * Creates a new instance of a Tooltip.
	     * @class
	     * @fires Tooltip#init
	     * @param {jQuery} element - jQuery object to attach a tooltip to.
	     * @param {Object} options - object to extend the default configuration.
	     */function Tooltip(element,options){_classCallCheck(this,Tooltip);this.$element = element;this.options = $.extend({},Tooltip.defaults,this.$element.data(),options);this.isActive = false;this.isClick = false;this._init();Foundation.registerPlugin(this,'Tooltip');} /**
	     * Initializes the tooltip by setting the creating the tip element, adding it's text, setting private variables and setting attributes on the anchor.
	     * @private
	     */_createClass(Tooltip,[{key:'_init',value:function _init(){var elemId=this.$element.attr('aria-describedby') || Foundation.GetYoDigits(6,'tooltip');this.options.positionClass = this.options.positionClass || this._getPositionClass(this.$element);this.options.tipText = this.options.tipText || this.$element.attr('title');this.template = this.options.template?$(this.options.template):this._buildTemplate(elemId);this.template.appendTo(document.body).text(this.options.tipText).hide();this.$element.attr({'title':'','aria-describedby':elemId,'data-yeti-box':elemId,'data-toggle':elemId,'data-resize':elemId}).addClass(this.options.triggerClass); //helper variables to track movement on collisions
	this.usedPositions = [];this.counter = 4;this.classChanged = false;this._events();} /**
	       * Grabs the current positioning class, if present, and returns the value or an empty string.
	       * @private
	       */},{key:'_getPositionClass',value:function _getPositionClass(element){if(!element){return '';} // var position = element.attr('class').match(/top|left|right/g);
	var position=element[0].className.match(/\b(top|left|right)\b/g);position = position?position[0]:'';return position;}},{key:'_buildTemplate', /**
	       * builds the tooltip element, adds attributes, and returns the template.
	       * @private
	       */value:function _buildTemplate(id){var templateClasses=(this.options.tooltipClass + ' ' + this.options.positionClass + ' ' + this.options.templateClasses).trim();var $template=$('<div></div>').addClass(templateClasses).attr({'role':'tooltip','aria-hidden':true,'data-is-active':false,'data-is-focus':false,'id':id});return $template;} /**
	       * Function that gets called if a collision event is detected.
	       * @param {String} position - positioning class to try
	       * @private
	       */},{key:'_reposition',value:function _reposition(position){this.usedPositions.push(position?position:'bottom'); //default, try switching to opposite side
	if(!position && this.usedPositions.indexOf('top') < 0){this.template.addClass('top');}else if(position === 'top' && this.usedPositions.indexOf('bottom') < 0){this.template.removeClass(position);}else if(position === 'left' && this.usedPositions.indexOf('right') < 0){this.template.removeClass(position).addClass('right');}else if(position === 'right' && this.usedPositions.indexOf('left') < 0){this.template.removeClass(position).addClass('left');} //if default change didn't work, try bottom or left first
	else if(!position && this.usedPositions.indexOf('top') > -1 && this.usedPositions.indexOf('left') < 0){this.template.addClass('left');}else if(position === 'top' && this.usedPositions.indexOf('bottom') > -1 && this.usedPositions.indexOf('left') < 0){this.template.removeClass(position).addClass('left');}else if(position === 'left' && this.usedPositions.indexOf('right') > -1 && this.usedPositions.indexOf('bottom') < 0){this.template.removeClass(position);}else if(position === 'right' && this.usedPositions.indexOf('left') > -1 && this.usedPositions.indexOf('bottom') < 0){this.template.removeClass(position);} //if nothing cleared, set to bottom
	else {this.template.removeClass(position);}this.classChanged = true;this.counter--;} /**
	       * sets the position class of an element and recursively calls itself until there are no more possible positions to attempt, or the tooltip element is no longer colliding.
	       * if the tooltip is larger than the screen width, default to full width - any user selected margin
	       * @private
	       */},{key:'_setPosition',value:function _setPosition(){var position=this._getPositionClass(this.template),$tipDims=Foundation.Box.GetDimensions(this.template),$anchorDims=Foundation.Box.GetDimensions(this.$element),direction=position === 'left'?'left':position === 'right'?'left':'top',param=direction === 'top'?'height':'width',offset=param === 'height'?this.options.vOffset:this.options.hOffset,_this=this;if($tipDims.width >= $tipDims.windowDims.width || !this.counter && !Foundation.Box.ImNotTouchingYou(this.template)){this.template.offset(Foundation.Box.GetOffsets(this.template,this.$element,'center bottom',this.options.vOffset,this.options.hOffset,true)).css({ // this.$element.offset(Foundation.GetOffsets(this.template, this.$element, 'center bottom', this.options.vOffset, this.options.hOffset, true)).css({
	'width':$anchorDims.windowDims.width - this.options.hOffset * 2,'height':'auto'});return false;}this.template.offset(Foundation.Box.GetOffsets(this.template,this.$element,'center ' + (position || 'bottom'),this.options.vOffset,this.options.hOffset));while(!Foundation.Box.ImNotTouchingYou(this.template) && this.counter) {this._reposition(position);this._setPosition();}} /**
	       * reveals the tooltip, and fires an event to close any other open tooltips on the page
	       * @fires Tooltip#closeme
	       * @fires Tooltip#show
	       * @function
	       */},{key:'show',value:function show(){if(this.options.showOn !== 'all' && !Foundation.MediaQuery.atLeast(this.options.showOn)){ // console.error('The screen is too small to display this tooltip');
	return false;}var _this=this;this.template.css('visibility','hidden').show();this._setPosition(); /**
	         * Fires to close all other open tooltips on the page
	         * @event Closeme#tooltip
	         */this.$element.trigger('closeme.zf.tooltip',this.template.attr('id'));this.template.attr({'data-is-active':true,'aria-hidden':false});_this.isActive = true; // console.log(this.template);
	this.template.stop().hide().css('visibility','').fadeIn(this.options.fadeInDuration,function(){ //maybe do stuff?
	}); /**
	         * Fires when the tooltip is shown
	         * @event Tooltip#show
	         */this.$element.trigger('show.zf.tooltip');} /**
	       * Hides the current tooltip, and resets the positioning class if it was changed due to collision
	       * @fires Tooltip#hide
	       * @function
	       */},{key:'hide',value:function hide(){ // console.log('hiding', this.$element.data('yeti-box'));
	var _this=this;this.template.stop().attr({'aria-hidden':true,'data-is-active':false}).fadeOut(this.options.fadeOutDuration,function(){_this.isActive = false;_this.isClick = false;if(_this.classChanged){_this.template.removeClass(_this._getPositionClass(_this.template)).addClass(_this.options.positionClass);_this.usedPositions = [];_this.counter = 4;_this.classChanged = false;}}); /**
	         * fires when the tooltip is hidden
	         * @event Tooltip#hide
	         */this.$element.trigger('hide.zf.tooltip');} /**
	       * adds event listeners for the tooltip and its anchor
	       * TODO combine some of the listeners like focus and mouseenter, etc.
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;var $template=this.template;var isFocus=false;if(!this.options.disableHover){this.$element.on('mouseenter.zf.tooltip',function(e){if(!_this.isActive){_this.timeout = setTimeout(function(){_this.show();},_this.options.hoverDelay);}}).on('mouseleave.zf.tooltip',function(e){clearTimeout(_this.timeout);if(!isFocus || _this.isClick && !_this.options.clickOpen){_this.hide();}});}if(this.options.clickOpen){this.$element.on('mousedown.zf.tooltip',function(e){e.stopImmediatePropagation();if(_this.isClick){ //_this.hide();
	// _this.isClick = false;
	}else {_this.isClick = true;if((_this.options.disableHover || !_this.$element.attr('tabindex')) && !_this.isActive){_this.show();}}});}else {this.$element.on('mousedown.zf.tooltip',function(e){e.stopImmediatePropagation();_this.isClick = true;});}if(!this.options.disableForTouch){this.$element.on('tap.zf.tooltip touchend.zf.tooltip',function(e){_this.isActive?_this.hide():_this.show();});}this.$element.on({ // 'toggle.zf.trigger': this.toggle.bind(this),
	// 'close.zf.trigger': this.hide.bind(this)
	'close.zf.trigger':this.hide.bind(this)});this.$element.on('focus.zf.tooltip',function(e){isFocus = true;if(_this.isClick){ // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
	// a real focus, otherwise on hover and come back we get bad behavior
	if(!_this.options.clickOpen){isFocus = false;}return false;}else {_this.show();}}).on('focusout.zf.tooltip',function(e){isFocus = false;_this.isClick = false;_this.hide();}).on('resizeme.zf.trigger',function(){if(_this.isActive){_this._setPosition();}});} /**
	       * adds a toggle method, in addition to the static show() & hide() functions
	       * @function
	       */},{key:'toggle',value:function toggle(){if(this.isActive){this.hide();}else {this.show();}} /**
	       * Destroys an instance of tooltip, removes template element from the view.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$element.attr('title',this.template.text()).off('.zf.trigger .zf.tootip') //  .removeClass('has-tip')
	.removeAttr('aria-describedby').removeAttr('data-yeti-box').removeAttr('data-toggle').removeAttr('data-resize');this.template.remove();Foundation.unregisterPlugin(this);}}]);return Tooltip;})();Tooltip.defaults = {disableForTouch:false, /**
	     * Time, in ms, before a tooltip should open on hover.
	     * @option
	     * @example 200
	     */hoverDelay:200, /**
	     * Time, in ms, a tooltip should take to fade into view.
	     * @option
	     * @example 150
	     */fadeInDuration:150, /**
	     * Time, in ms, a tooltip should take to fade out of view.
	     * @option
	     * @example 150
	     */fadeOutDuration:150, /**
	     * Disables hover events from opening the tooltip if set to true
	     * @option
	     * @example false
	     */disableHover:false, /**
	     * Optional addtional classes to apply to the tooltip template on init.
	     * @option
	     * @example 'my-cool-tip-class'
	     */templateClasses:'', /**
	     * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
	     * @option
	     * @example 'tooltip'
	     */tooltipClass:'tooltip', /**
	     * Class applied to the tooltip anchor element.
	     * @option
	     * @example 'has-tip'
	     */triggerClass:'has-tip', /**
	     * Minimum breakpoint size at which to open the tooltip.
	     * @option
	     * @example 'small'
	     */showOn:'small', /**
	     * Custom template to be used to generate markup for tooltip.
	     * @option
	     * @example '&lt;div class="tooltip"&gt;&lt;/div&gt;'
	     */template:'', /**
	     * Text displayed in the tooltip template on open.
	     * @option
	     * @example 'Some cool space fact here.'
	     */tipText:'',touchCloseText:'Tap to close.', /**
	     * Allows the tooltip to remain open if triggered with a click or touch event.
	     * @option
	     * @example true
	     */clickOpen:true, /**
	     * Additional positioning classes, set by the JS
	     * @option
	     * @example 'top'
	     */positionClass:'', /**
	     * Distance, in pixels, the template should push away from the anchor on the Y axis.
	     * @option
	     * @example 10
	     */vOffset:10, /**
	     * Distance, in pixels, the template should push away from the anchor on the X axis, if aligned to a side.
	     * @option
	     * @example 12
	     */hOffset:12}; /**
	   * TODO utilize resize event trigger
	   */ // Window exports
	Foundation.plugin(Tooltip,'Tooltip');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Orbit module.
	   * @module foundation.orbit
	   * @requires foundation.util.keyboard
	   * @requires foundation.util.motion
	   * @requires foundation.util.timerAndImageLoader
	   * @requires foundation.util.touch
	   */var Orbit=(function(){ /**
	    * Creates a new instance of an orbit carousel.
	    * @class
	    * @param {jQuery} element - jQuery object to make into an Orbit Carousel.
	    * @param {Object} options - Overrides to the default plugin settings.
	    */function Orbit(element,options){_classCallCheck(this,Orbit);this.$element = element;this.options = $.extend({},Orbit.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Orbit');Foundation.Keyboard.register('Orbit',{'ltr':{'ARROW_RIGHT':'next','ARROW_LEFT':'previous'},'rtl':{'ARROW_LEFT':'next','ARROW_RIGHT':'previous'}});} /**
	    * Initializes the plugin by creating jQuery collections, setting attributes, and starting the animation.
	    * @function
	    * @private
	    */_createClass(Orbit,[{key:'_init',value:function _init(){this.$wrapper = this.$element.find('.' + this.options.containerClass);this.$slides = this.$element.find('.' + this.options.slideClass);var $images=this.$element.find('img'),initActive=this.$slides.filter('.is-active');if(!initActive.length){this.$slides.eq(0).addClass('is-active');}if(!this.options.useMUI){this.$slides.addClass('no-motionui');}if($images.length){Foundation.onImagesLoaded($images,this._prepareForOrbit.bind(this));}else {this._prepareForOrbit(); //hehe
	}if(this.options.bullets){this._loadBullets();}this._events();if(this.options.autoPlay && this.$slides.length > 1){this.geoSync();}if(this.options.accessible){ // allow wrapper to be focusable to enable arrow navigation
	this.$wrapper.attr('tabindex',0);}} /**
	      * Creates a jQuery collection of bullets, if they are being used.
	      * @function
	      * @private
	      */},{key:'_loadBullets',value:function _loadBullets(){this.$bullets = this.$element.find('.' + this.options.boxOfBullets).find('button');} /**
	      * Sets a `timer` object on the orbit, and starts the counter for the next slide.
	      * @function
	      */},{key:'geoSync',value:function geoSync(){var _this=this;this.timer = new Foundation.Timer(this.$element,{duration:this.options.timerDelay,infinite:false},function(){_this.changeSlide(true);});this.timer.start();} /**
	      * Sets wrapper and slide heights for the orbit.
	      * @function
	      * @private
	      */},{key:'_prepareForOrbit',value:function _prepareForOrbit(){var _this=this;this._setWrapperHeight(function(max){_this._setSlideHeight(max);});} /**
	      * Calulates the height of each slide in the collection, and uses the tallest one for the wrapper height.
	      * @function
	      * @private
	      * @param {Function} cb - a callback function to fire when complete.
	      */},{key:'_setWrapperHeight',value:function _setWrapperHeight(cb){ //rewrite this to `for` loop
	var max=0,temp,counter=0;this.$slides.each(function(){temp = this.getBoundingClientRect().height;$(this).attr('data-slide',counter);if(counter){ //if not the first slide, set css position and display property
	$(this).css({'position':'relative','display':'none'});}max = temp > max?temp:max;counter++;});if(counter === this.$slides.length){this.$wrapper.css({'height':max}); //only change the wrapper height property once.
	cb(max); //fire callback with max height dimension.
	}} /**
	      * Sets the max-height of each slide.
	      * @function
	      * @private
	      */},{key:'_setSlideHeight',value:function _setSlideHeight(height){this.$slides.each(function(){$(this).css('max-height',height);});} /**
	      * Adds event listeners to basically everything within the element.
	      * @function
	      * @private
	      */},{key:'_events',value:function _events(){var _this=this; //***************************************
	//**Now using custom event - thanks to:**
	//**      Yohai Ararat of Toronto      **
	//***************************************
	if(this.$slides.length > 1){if(this.options.swipe){this.$slides.off('swipeleft.zf.orbit swiperight.zf.orbit').on('swipeleft.zf.orbit',function(e){e.preventDefault();_this.changeSlide(true);}).on('swiperight.zf.orbit',function(e){e.preventDefault();_this.changeSlide(false);});} //***************************************
	if(this.options.autoPlay){this.$slides.on('click.zf.orbit',function(){_this.$element.data('clickedOn',_this.$element.data('clickedOn')?false:true);_this.timer[_this.$element.data('clickedOn')?'pause':'start']();});if(this.options.pauseOnHover){this.$element.on('mouseenter.zf.orbit',function(){_this.timer.pause();}).on('mouseleave.zf.orbit',function(){if(!_this.$element.data('clickedOn')){_this.timer.start();}});}}if(this.options.navButtons){var $controls=this.$element.find('.' + this.options.nextClass + ', .' + this.options.prevClass);$controls.attr('tabindex',0) //also need to handle enter/return and spacebar key presses
	.on('click.zf.orbit touchend.zf.orbit',function(e){e.preventDefault();_this.changeSlide($(this).hasClass(_this.options.nextClass));});}if(this.options.bullets){this.$bullets.on('click.zf.orbit touchend.zf.orbit',function(){if(/is-active/g.test(this.className)){return false;} //if this is active, kick out of function.
	var idx=$(this).data('slide'),ltr=idx > _this.$slides.filter('.is-active').data('slide'),$slide=_this.$slides.eq(idx);_this.changeSlide(ltr,$slide,idx);});}if(this.options.accessible){this.$wrapper.add(this.$bullets).on('keydown.zf.orbit',function(e){ // handle keyboard event with keyboard util
	Foundation.Keyboard.handleKey(e,'Orbit',{next:function next(){_this.changeSlide(true);},previous:function previous(){_this.changeSlide(false);},handled:function handled(){ // if bullet is focused, make sure focus moves
	if($(e.target).is(_this.$bullets)){_this.$bullets.filter('.is-active').focus();}}});});}}} /**
	      * Changes the current slide to a new one.
	      * @function
	      * @param {Boolean} isLTR - flag if the slide should move left to right.
	      * @param {jQuery} chosenSlide - the jQuery element of the slide to show next, if one is selected.
	      * @param {Number} idx - the index of the new slide in its collection, if one chosen.
	      * @fires Orbit#slidechange
	      */},{key:'changeSlide',value:function changeSlide(isLTR,chosenSlide,idx){var $curSlide=this.$slides.filter('.is-active').eq(0);if(/mui/g.test($curSlide[0].className)){return false;} //if the slide is currently animating, kick out of the function
	var $firstSlide=this.$slides.first(),$lastSlide=this.$slides.last(),dirIn=isLTR?'Right':'Left',dirOut=isLTR?'Left':'Right',_this=this,$newSlide;if(!chosenSlide){ //most of the time, this will be auto played or clicked from the navButtons.
	$newSlide = isLTR? //if wrapping enabled, check to see if there is a `next` or `prev` sibling, if not, select the first or last slide to fill in. if wrapping not enabled, attempt to select `next` or `prev`, if there's nothing there, the function will kick out on next step. CRAZY NESTED TERNARIES!!!!!
	this.options.infiniteWrap?$curSlide.next('.' + this.options.slideClass).length?$curSlide.next('.' + this.options.slideClass):$firstSlide:$curSlide.next('.' + this.options.slideClass): //pick next slide if moving left to right
	this.options.infiniteWrap?$curSlide.prev('.' + this.options.slideClass).length?$curSlide.prev('.' + this.options.slideClass):$lastSlide:$curSlide.prev('.' + this.options.slideClass); //pick prev slide if moving right to left
	}else {$newSlide = chosenSlide;}if($newSlide.length){ /**
	          * Triggers before the next slide starts animating in and only if a next slide has been found.
	          * @event Orbit#beforeslidechange
	          */this.$element.trigger('beforeslidechange.zf.orbit',[$curSlide,$newSlide]);if(this.options.bullets){idx = idx || this.$slides.index($newSlide); //grab index to update bullets
	this._updateBullets(idx);}if(this.options.useMUI){Foundation.Motion.animateIn($newSlide.addClass('is-active').css({'position':'absolute','top':0}),this.options['animInFrom' + dirIn],function(){$newSlide.css({'position':'relative','display':'block'}).attr('aria-live','polite');});Foundation.Motion.animateOut($curSlide.removeClass('is-active'),this.options['animOutTo' + dirOut],function(){$curSlide.removeAttr('aria-live');if(_this.options.autoPlay && !_this.timer.isPaused){_this.timer.restart();} //do stuff?
	});}else {$curSlide.removeClass('is-active is-in').removeAttr('aria-live').hide();$newSlide.addClass('is-active is-in').attr('aria-live','polite').show();if(this.options.autoPlay && !this.timer.isPaused){this.timer.restart();}} /**
	          * Triggers when the slide has finished animating in.
	          * @event Orbit#slidechange
	          */this.$element.trigger('slidechange.zf.orbit',[$newSlide]);}} /**
	      * Updates the active state of the bullets, if displayed.
	      * @function
	      * @private
	      * @param {Number} idx - the index of the current slide.
	      */},{key:'_updateBullets',value:function _updateBullets(idx){var $oldBullet=this.$element.find('.' + this.options.boxOfBullets).find('.is-active').removeClass('is-active').blur(),span=$oldBullet.find('span:last').detach(),$newBullet=this.$bullets.eq(idx).addClass('is-active').append(span);} /**
	      * Destroys the carousel and hides the element.
	      * @function
	      */},{key:'destroy',value:function destroy(){this.$element.off('.zf.orbit').find('*').off('.zf.orbit').end().hide();Foundation.unregisterPlugin(this);}}]);return Orbit;})();Orbit.defaults = { /**
	    * Tells the JS to look for and loadBullets.
	    * @option
	    * @example true
	    */bullets:true, /**
	    * Tells the JS to apply event listeners to nav buttons
	    * @option
	    * @example true
	    */navButtons:true, /**
	    * motion-ui animation class to apply
	    * @option
	    * @example 'slide-in-right'
	    */animInFromRight:'slide-in-right', /**
	    * motion-ui animation class to apply
	    * @option
	    * @example 'slide-out-right'
	    */animOutToRight:'slide-out-right', /**
	    * motion-ui animation class to apply
	    * @option
	    * @example 'slide-in-left'
	    *
	    */animInFromLeft:'slide-in-left', /**
	    * motion-ui animation class to apply
	    * @option
	    * @example 'slide-out-left'
	    */animOutToLeft:'slide-out-left', /**
	    * Allows Orbit to automatically animate on page load.
	    * @option
	    * @example true
	    */autoPlay:true, /**
	    * Amount of time, in ms, between slide transitions
	    * @option
	    * @example 5000
	    */timerDelay:5000, /**
	    * Allows Orbit to infinitely loop through the slides
	    * @option
	    * @example true
	    */infiniteWrap:true, /**
	    * Allows the Orbit slides to bind to swipe events for mobile, requires an additional util library
	    * @option
	    * @example true
	    */swipe:true, /**
	    * Allows the timing function to pause animation on hover.
	    * @option
	    * @example true
	    */pauseOnHover:true, /**
	    * Allows Orbit to bind keyboard events to the slider, to animate frames with arrow keys
	    * @option
	    * @example true
	    */accessible:true, /**
	    * Class applied to the container of Orbit
	    * @option
	    * @example 'orbit-container'
	    */containerClass:'orbit-container', /**
	    * Class applied to individual slides.
	    * @option
	    * @example 'orbit-slide'
	    */slideClass:'orbit-slide', /**
	    * Class applied to the bullet container. You're welcome.
	    * @option
	    * @example 'orbit-bullets'
	    */boxOfBullets:'orbit-bullets', /**
	    * Class applied to the `next` navigation button.
	    * @option
	    * @example 'orbit-next'
	    */nextClass:'orbit-next', /**
	    * Class applied to the `previous` navigation button.
	    * @option
	    * @example 'orbit-previous'
	    */prevClass:'orbit-previous', /**
	    * Boolean to flag the js to use motion ui classes or not. Default to true for backwards compatability.
	    * @option
	    * @example true
	    */useMUI:true}; // Window exports
	Foundation.plugin(Orbit,'Orbit');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Sticky module.
	   * @module foundation.sticky
	   * @requires foundation.util.triggers
	   * @requires foundation.util.mediaQuery
	   */var Sticky=(function(){ /**
	     * Creates a new instance of a sticky thing.
	     * @class
	     * @param {jQuery} element - jQuery object to make sticky.
	     * @param {Object} options - options object passed when creating the element programmatically.
	     */function Sticky(element,options){_classCallCheck(this,Sticky);this.$element = element;this.options = $.extend({},Sticky.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Sticky');} /**
	     * Initializes the sticky element by adding classes, getting/setting dimensions, breakpoints and attributes
	     * @function
	     * @private
	     */_createClass(Sticky,[{key:'_init',value:function _init(){var $parent=this.$element.parent('[data-sticky-container]'),id=this.$element[0].id || Foundation.GetYoDigits(6,'sticky'),_this=this;if(!$parent.length){this.wasWrapped = true;}this.$container = $parent.length?$parent:$(this.options.container).wrapInner(this.$element);this.$container.addClass(this.options.containerClass);this.$element.addClass(this.options.stickyClass).attr({'data-resize':id});this.scrollCount = this.options.checkEvery;this.isStuck = false;$(window).one('load.zf.sticky',function(){ //We calculate the container height to have correct values for anchor points offset calculation.
	_this.containerHeight = _this.$element.css("display") == "none"?0:_this.$element[0].getBoundingClientRect().height;_this.$container.css('height',_this.containerHeight);_this.elemHeight = _this.containerHeight;if(_this.options.anchor !== ''){_this.$anchor = $('#' + _this.options.anchor);}else {_this._parsePoints();}_this._setSizes(function(){_this._calc(false);});_this._events(id.split('-').reverse().join('-'));});} /**
	       * If using multiple elements as anchors, calculates the top and bottom pixel values the sticky thing should stick and unstick on.
	       * @function
	       * @private
	       */},{key:'_parsePoints',value:function _parsePoints(){var top=this.options.topAnchor == ""?1:this.options.topAnchor,btm=this.options.btmAnchor == ""?document.documentElement.scrollHeight:this.options.btmAnchor,pts=[top,btm],breaks={};for(var i=0,len=pts.length;i < len && pts[i];i++) {var pt;if(typeof pts[i] === 'number'){pt = pts[i];}else {var place=pts[i].split(':'),anchor=$('#' + place[0]);pt = anchor.offset().top;if(place[1] && place[1].toLowerCase() === 'bottom'){pt += anchor[0].getBoundingClientRect().height;}}breaks[i] = pt;}this.points = breaks;return;} /**
	       * Adds event handlers for the scrolling element.
	       * @private
	       * @param {String} id - psuedo-random id for unique scroll event listener.
	       */},{key:'_events',value:function _events(id){var _this=this,scrollListener=this.scrollListener = 'scroll.zf.' + id;if(this.isOn){return;}if(this.canStick){this.isOn = true;$(window).off(scrollListener).on(scrollListener,function(e){if(_this.scrollCount === 0){_this.scrollCount = _this.options.checkEvery;_this._setSizes(function(){_this._calc(false,window.pageYOffset);});}else {_this.scrollCount--;_this._calc(false,window.pageYOffset);}});}this.$element.off('resizeme.zf.trigger').on('resizeme.zf.trigger',function(e,el){_this._setSizes(function(){_this._calc(false);if(_this.canStick){if(!_this.isOn){_this._events(id);}}else if(_this.isOn){_this._pauseListeners(scrollListener);}});});} /**
	       * Removes event handlers for scroll and change events on anchor.
	       * @fires Sticky#pause
	       * @param {String} scrollListener - unique, namespaced scroll listener attached to `window`
	       */},{key:'_pauseListeners',value:function _pauseListeners(scrollListener){this.isOn = false;$(window).off(scrollListener); /**
	         * Fires when the plugin is paused due to resize event shrinking the view.
	         * @event Sticky#pause
	         * @private
	         */this.$element.trigger('pause.zf.sticky');} /**
	       * Called on every `scroll` event and on `_init`
	       * fires functions based on booleans and cached values
	       * @param {Boolean} checkSizes - true if plugin should recalculate sizes and breakpoints.
	       * @param {Number} scroll - current scroll position passed from scroll event cb function. If not passed, defaults to `window.pageYOffset`.
	       */},{key:'_calc',value:function _calc(checkSizes,scroll){if(checkSizes){this._setSizes();}if(!this.canStick){if(this.isStuck){this._removeSticky(true);}return false;}if(!scroll){scroll = window.pageYOffset;}if(scroll >= this.topPoint){if(scroll <= this.bottomPoint){if(!this.isStuck){this._setSticky();}}else {if(this.isStuck){this._removeSticky(false);}}}else {if(this.isStuck){this._removeSticky(true);}}} /**
	       * Causes the $element to become stuck.
	       * Adds `position: fixed;`, and helper classes.
	       * @fires Sticky#stuckto
	       * @function
	       * @private
	       */},{key:'_setSticky',value:function _setSticky(){var _this=this,stickTo=this.options.stickTo,mrgn=stickTo === 'top'?'marginTop':'marginBottom',notStuckTo=stickTo === 'top'?'bottom':'top',css={};css[mrgn] = this.options[mrgn] + 'em';css[stickTo] = 0;css[notStuckTo] = 'auto';css['left'] = this.$container.offset().left + parseInt(window.getComputedStyle(this.$container[0])["padding-left"],10);this.isStuck = true;this.$element.removeClass('is-anchored is-at-' + notStuckTo).addClass('is-stuck is-at-' + stickTo).css(css) /**
	         * Fires when the $element has become `position: fixed;`
	         * Namespaced to `top` or `bottom`, e.g. `sticky.zf.stuckto:top`
	         * @event Sticky#stuckto
	         */.trigger('sticky.zf.stuckto:' + stickTo);this.$element.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",function(){_this._setSizes();});} /**
	       * Causes the $element to become unstuck.
	       * Removes `position: fixed;`, and helper classes.
	       * Adds other helper classes.
	       * @param {Boolean} isTop - tells the function if the $element should anchor to the top or bottom of its $anchor element.
	       * @fires Sticky#unstuckfrom
	       * @private
	       */},{key:'_removeSticky',value:function _removeSticky(isTop){var stickTo=this.options.stickTo,stickToTop=stickTo === 'top',css={},anchorPt=(this.points?this.points[1] - this.points[0]:this.anchorHeight) - this.elemHeight,mrgn=stickToTop?'marginTop':'marginBottom',notStuckTo=stickToTop?'bottom':'top',topOrBottom=isTop?'top':'bottom';css[mrgn] = 0;css['bottom'] = 'auto';if(isTop){css['top'] = 0;}else {css['top'] = anchorPt;}css['left'] = '';this.isStuck = false;this.$element.removeClass('is-stuck is-at-' + stickTo).addClass('is-anchored is-at-' + topOrBottom).css(css) /**
	         * Fires when the $element has become anchored.
	         * Namespaced to `top` or `bottom`, e.g. `sticky.zf.unstuckfrom:bottom`
	         * @event Sticky#unstuckfrom
	         */.trigger('sticky.zf.unstuckfrom:' + topOrBottom);} /**
	       * Sets the $element and $container sizes for plugin.
	       * Calls `_setBreakPoints`.
	       * @param {Function} cb - optional callback function to fire on completion of `_setBreakPoints`.
	       * @private
	       */},{key:'_setSizes',value:function _setSizes(cb){this.canStick = Foundation.MediaQuery.atLeast(this.options.stickyOn);if(!this.canStick){if(cb && typeof cb === 'function'){cb();}}var _this=this,newElemWidth=this.$container[0].getBoundingClientRect().width,comp=window.getComputedStyle(this.$container[0]),pdng=parseInt(comp['padding-right'],10);if(this.$anchor && this.$anchor.length){this.anchorHeight = this.$anchor[0].getBoundingClientRect().height;}else {this._parsePoints();}this.$element.css({'max-width':newElemWidth - pdng + 'px'});var newContainerHeight=this.$element[0].getBoundingClientRect().height || this.containerHeight;if(this.$element.css("display") == "none"){newContainerHeight = 0;}this.containerHeight = newContainerHeight;this.$container.css({height:newContainerHeight});this.elemHeight = newContainerHeight;if(this.isStuck){this.$element.css({"left":this.$container.offset().left + parseInt(comp['padding-left'],10)});}else {if(this.$element.hasClass('is-at-bottom')){var anchorPt=(this.points?this.points[1] - this.$container.offset().top:this.anchorHeight) - this.elemHeight;this.$element.css('top',anchorPt);}}this._setBreakPoints(newContainerHeight,function(){if(cb && typeof cb === 'function'){cb();}});} /**
	       * Sets the upper and lower breakpoints for the element to become sticky/unsticky.
	       * @param {Number} elemHeight - px value for sticky.$element height, calculated by `_setSizes`.
	       * @param {Function} cb - optional callback function to be called on completion.
	       * @private
	       */},{key:'_setBreakPoints',value:function _setBreakPoints(elemHeight,cb){if(!this.canStick){if(cb && typeof cb === 'function'){cb();}else {return false;}}var mTop=emCalc(this.options.marginTop),mBtm=emCalc(this.options.marginBottom),topPoint=this.points?this.points[0]:this.$anchor.offset().top,bottomPoint=this.points?this.points[1]:topPoint + this.anchorHeight, // topPoint = this.$anchor.offset().top || this.points[0],
	// bottomPoint = topPoint + this.anchorHeight || this.points[1],
	winHeight=window.innerHeight;if(this.options.stickTo === 'top'){topPoint -= mTop;bottomPoint -= elemHeight + mTop;}else if(this.options.stickTo === 'bottom'){topPoint -= winHeight - (elemHeight + mBtm);bottomPoint -= winHeight - mBtm;}else { //this would be the stickTo: both option... tricky
	}this.topPoint = topPoint;this.bottomPoint = bottomPoint;if(cb && typeof cb === 'function'){cb();}} /**
	       * Destroys the current sticky element.
	       * Resets the element to the top position first.
	       * Removes event listeners, JS-added css properties and classes, and unwraps the $element if the JS added the $container.
	       * @function
	       */},{key:'destroy',value:function destroy(){this._removeSticky(true);this.$element.removeClass(this.options.stickyClass + ' is-anchored is-at-top').css({height:'',top:'',bottom:'','max-width':''}).off('resizeme.zf.trigger');if(this.$anchor && this.$anchor.length){this.$anchor.off('change.zf.sticky');}$(window).off(this.scrollListener);if(this.wasWrapped){this.$element.unwrap();}else {this.$container.removeClass(this.options.containerClass).css({height:''});}Foundation.unregisterPlugin(this);}}]);return Sticky;})();Sticky.defaults = { /**
	     * Customizable container template. Add your own classes for styling and sizing.
	     * @option
	     * @example '&lt;div data-sticky-container class="small-6 columns"&gt;&lt;/div&gt;'
	     */container:'<div data-sticky-container></div>', /**
	     * Location in the view the element sticks to.
	     * @option
	     * @example 'top'
	     */stickTo:'top', /**
	     * If anchored to a single element, the id of that element.
	     * @option
	     * @example 'exampleId'
	     */anchor:'', /**
	     * If using more than one element as anchor points, the id of the top anchor.
	     * @option
	     * @example 'exampleId:top'
	     */topAnchor:'', /**
	     * If using more than one element as anchor points, the id of the bottom anchor.
	     * @option
	     * @example 'exampleId:bottom'
	     */btmAnchor:'', /**
	     * Margin, in `em`'s to apply to the top of the element when it becomes sticky.
	     * @option
	     * @example 1
	     */marginTop:1, /**
	     * Margin, in `em`'s to apply to the bottom of the element when it becomes sticky.
	     * @option
	     * @example 1
	     */marginBottom:1, /**
	     * Breakpoint string that is the minimum screen size an element should become sticky.
	     * @option
	     * @example 'medium'
	     */stickyOn:'medium', /**
	     * Class applied to sticky element, and removed on destruction. Foundation defaults to `sticky`.
	     * @option
	     * @example 'sticky'
	     */stickyClass:'sticky', /**
	     * Class applied to sticky container. Foundation defaults to `sticky-container`.
	     * @option
	     * @example 'sticky-container'
	     */containerClass:'sticky-container', /**
	     * Number of scroll events between the plugin's recalculating sticky points. Setting it to `0` will cause it to recalc every scroll event, setting it to `-1` will prevent recalc on scroll.
	     * @option
	     * @example 50
	     */checkEvery:-1}; /**
	   * Helper function to calculate em values
	   * @param Number {em} - number of em's to calculate into pixels
	   */function emCalc(em){return parseInt(window.getComputedStyle(document.body,null).fontSize,10) * em;} // Window exports
	Foundation.plugin(Sticky,'Sticky');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Interchange module.
	   * @module foundation.interchange
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.timerAndImageLoader
	   */var Interchange=(function(){ /**
	     * Creates a new instance of Interchange.
	     * @class
	     * @fires Interchange#init
	     * @param {Object} element - jQuery object to add the trigger to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Interchange(element,options){_classCallCheck(this,Interchange);this.$element = element;this.options = $.extend({},Interchange.defaults,options);this.rules = [];this.currentPath = '';this._init();this._events();Foundation.registerPlugin(this,'Interchange');} /**
	     * Initializes the Interchange plugin and calls functions to get interchange functioning on load.
	     * @function
	     * @private
	     */_createClass(Interchange,[{key:'_init',value:function _init(){this._addBreakpoints();this._generateRules();this._reflow();} /**
	       * Initializes events for Interchange.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){$(window).on('resize.zf.interchange',Foundation.util.throttle(this._reflow.bind(this),50));} /**
	       * Calls necessary functions to update Interchange upon DOM change
	       * @function
	       * @private
	       */},{key:'_reflow',value:function _reflow(){var match; // Iterate through each rule, but only save the last match
	for(var i in this.rules) {if(this.rules.hasOwnProperty(i)){var rule=this.rules[i];if(window.matchMedia(rule.query).matches){match = rule;}}}if(match){this.replace(match.path);}} /**
	       * Gets the Foundation breakpoints and adds them to the Interchange.SPECIAL_QUERIES object.
	       * @function
	       * @private
	       */},{key:'_addBreakpoints',value:function _addBreakpoints(){for(var i in Foundation.MediaQuery.queries) {if(Foundation.MediaQuery.queries.hasOwnProperty(i)){var query=Foundation.MediaQuery.queries[i];Interchange.SPECIAL_QUERIES[query.name] = query.value;}}} /**
	       * Checks the Interchange element for the provided media query + content pairings
	       * @function
	       * @private
	       * @param {Object} element - jQuery object that is an Interchange instance
	       * @returns {Array} scenarios - Array of objects that have 'mq' and 'path' keys with corresponding keys
	       */},{key:'_generateRules',value:function _generateRules(element){var rulesList=[];var rules;if(this.options.rules){rules = this.options.rules;}else {rules = this.$element.data('interchange').match(/\[.*?\]/g);}for(var i in rules) {if(rules.hasOwnProperty(i)){var rule=rules[i].slice(1,-1).split(', ');var path=rule.slice(0,-1).join('');var query=rule[rule.length - 1];if(Interchange.SPECIAL_QUERIES[query]){query = Interchange.SPECIAL_QUERIES[query];}rulesList.push({path:path,query:query});}}this.rules = rulesList;} /**
	       * Update the `src` property of an image, or change the HTML of a container, to the specified path.
	       * @function
	       * @param {String} path - Path to the image or HTML partial.
	       * @fires Interchange#replaced
	       */},{key:'replace',value:function replace(path){if(this.currentPath === path)return;var _this=this,trigger='replaced.zf.interchange'; // Replacing images
	if(this.$element[0].nodeName === 'IMG'){this.$element.attr('src',path).on('load',function(){_this.currentPath = path;}).trigger(trigger);} // Replacing background images
	else if(path.match(/\.(gif|jpg|jpeg|png|svg|tiff)([?#].*)?/i)){this.$element.css({'background-image':'url(' + path + ')'}).trigger(trigger);} // Replacing HTML
	else {$.get(path,function(response){_this.$element.html(response).trigger(trigger);$(response).foundation();_this.currentPath = path;});} /**
	         * Fires when content in an Interchange element is done being loaded.
	         * @event Interchange#replaced
	         */ // this.$element.trigger('replaced.zf.interchange');
	} /**
	       * Destroys an instance of interchange.
	       * @function
	       */},{key:'destroy',value:function destroy(){ //TODO this.
	}}]);return Interchange;})(); /**
	   * Default settings for plugin
	   */Interchange.defaults = { /**
	     * Rules to be applied to Interchange elements. Set with the `data-interchange` array notation.
	     * @option
	     */rules:null};Interchange.SPECIAL_QUERIES = {'landscape':'screen and (orientation: landscape)','portrait':'screen and (orientation: portrait)','retina':'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)'}; // Window exports
	Foundation.plugin(Interchange,'Interchange');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * ResponsiveToggle module.
	   * @module foundation.responsiveToggle
	   * @requires foundation.util.mediaQuery
	   */var ResponsiveToggle=(function(){ /**
	     * Creates a new instance of Tab Bar.
	     * @class
	     * @fires ResponsiveToggle#init
	     * @param {jQuery} element - jQuery object to attach tab bar functionality to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function ResponsiveToggle(element,options){_classCallCheck(this,ResponsiveToggle);this.$element = $(element);this.options = $.extend({},ResponsiveToggle.defaults,this.$element.data(),options);this._init();this._events();Foundation.registerPlugin(this,'ResponsiveToggle');} /**
	     * Initializes the tab bar by finding the target element, toggling element, and running update().
	     * @function
	     * @private
	     */_createClass(ResponsiveToggle,[{key:'_init',value:function _init(){var targetID=this.$element.data('responsive-toggle');if(!targetID){console.error('Your tab bar needs an ID of a Menu as the value of data-tab-bar.');}this.$targetMenu = $('#' + targetID);this.$toggler = this.$element.find('[data-toggle]');this._update();} /**
	       * Adds necessary event handlers for the tab bar to work.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;this._updateMqHandler = this._update.bind(this);$(window).on('changed.zf.mediaquery',this._updateMqHandler);this.$toggler.on('click.zf.responsiveToggle',this.toggleMenu.bind(this));} /**
	       * Checks the current media query to determine if the tab bar should be visible or hidden.
	       * @function
	       * @private
	       */},{key:'_update',value:function _update(){ // Mobile
	if(!Foundation.MediaQuery.atLeast(this.options.hideFor)){this.$element.show();this.$targetMenu.hide();} // Desktop
	else {this.$element.hide();this.$targetMenu.show();}} /**
	       * Toggles the element attached to the tab bar. The toggle only happens if the screen is small enough to allow it.
	       * @function
	       * @fires ResponsiveToggle#toggled
	       */},{key:'toggleMenu',value:function toggleMenu(){if(!Foundation.MediaQuery.atLeast(this.options.hideFor)){this.$targetMenu.toggle(0); /**
	           * Fires when the element attached to the tab bar toggles.
	           * @event ResponsiveToggle#toggled
	           */this.$element.trigger('toggled.zf.responsiveToggle');}}},{key:'destroy',value:function destroy(){this.$element.off('.zf.responsiveToggle');this.$toggler.off('.zf.responsiveToggle');$(window).off('changed.zf.mediaquery',this._updateMqHandler);Foundation.unregisterPlugin(this);}}]);return ResponsiveToggle;})();ResponsiveToggle.defaults = { /**
	     * The breakpoint after which the menu is always shown, and the tab bar is hidden.
	     * @option
	     * @example 'medium'
	     */hideFor:'medium'}; // Window exports
	Foundation.plugin(ResponsiveToggle,'ResponsiveToggle');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Toggler module.
	   * @module foundation.toggler
	   * @requires foundation.util.motion
	   * @requires foundation.util.triggers
	   */var Toggler=(function(){ /**
	     * Creates a new instance of Toggler.
	     * @class
	     * @fires Toggler#init
	     * @param {Object} element - jQuery object to add the trigger to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Toggler(element,options){_classCallCheck(this,Toggler);this.$element = element;this.options = $.extend({},Toggler.defaults,element.data(),options);this.className = '';this._init();this._events();Foundation.registerPlugin(this,'Toggler');} /**
	     * Initializes the Toggler plugin by parsing the toggle class from data-toggler, or animation classes from data-animate.
	     * @function
	     * @private
	     */_createClass(Toggler,[{key:'_init',value:function _init(){var input; // Parse animation classes if they were set
	if(this.options.animate){input = this.options.animate.split(' ');this.animationIn = input[0];this.animationOut = input[1] || null;} // Otherwise, parse toggle class
	else {input = this.$element.data('toggler'); // Allow for a . at the beginning of the string
	this.className = input[0] === '.'?input.slice(1):input;} // Add ARIA attributes to triggers
	var id=this.$element[0].id;$('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-controls',id); // If the target is hidden, add aria-hidden
	this.$element.attr('aria-expanded',this.$element.is(':hidden')?false:true);} /**
	       * Initializes events for the toggle trigger.
	       * @function
	       * @private
	       */},{key:'_events',value:function _events(){this.$element.off('toggle.zf.trigger').on('toggle.zf.trigger',this.toggle.bind(this));} /**
	       * Toggles the target class on the target element. An event is fired from the original trigger depending on if the resultant state was "on" or "off".
	       * @function
	       * @fires Toggler#on
	       * @fires Toggler#off
	       */},{key:'toggle',value:function toggle(){this[this.options.animate?'_toggleAnimate':'_toggleClass']();}},{key:'_toggleClass',value:function _toggleClass(){this.$element.toggleClass(this.className);var isOn=this.$element.hasClass(this.className);if(isOn){ /**
	           * Fires if the target element has the class after a toggle.
	           * @event Toggler#on
	           */this.$element.trigger('on.zf.toggler');}else { /**
	           * Fires if the target element does not have the class after a toggle.
	           * @event Toggler#off
	           */this.$element.trigger('off.zf.toggler');}this._updateARIA(isOn);}},{key:'_toggleAnimate',value:function _toggleAnimate(){var _this=this;if(this.$element.is(':hidden')){Foundation.Motion.animateIn(this.$element,this.animationIn,function(){_this._updateARIA(true);this.trigger('on.zf.toggler');});}else {Foundation.Motion.animateOut(this.$element,this.animationOut,function(){_this._updateARIA(false);this.trigger('off.zf.toggler');});}}},{key:'_updateARIA',value:function _updateARIA(isOn){this.$element.attr('aria-expanded',isOn?true:false);} /**
	       * Destroys the instance of Toggler on the element.
	       * @function
	       */},{key:'destroy',value:function destroy(){this.$element.off('.zf.toggler');Foundation.unregisterPlugin(this);}}]);return Toggler;})();Toggler.defaults = { /**
	     * Tells the plugin if the element should animated when toggled.
	     * @option
	     * @example false
	     */animate:false}; // Window exports
	Foundation.plugin(Toggler,'Toggler');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Abide module.
	   * @module foundation.abide
	   */var Abide=(function(){ /**
	     * Creates a new instance of Abide.
	     * @class
	     * @fires Abide#init
	     * @param {Object} element - jQuery object to add the trigger to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Abide(element){var options=arguments.length <= 1 || arguments[1] === undefined?{}:arguments[1];_classCallCheck(this,Abide);this.$element = element;this.options = $.extend({},Abide.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Abide');} /**
	     * Initializes the Abide plugin and calls functions to get Abide functioning on load.
	     * @private
	     */_createClass(Abide,[{key:'_init',value:function _init(){this.$inputs = this.$element.find('input, textarea, select');this._events();} /**
	       * Initializes events for Abide.
	       * @private
	       */},{key:'_events',value:function _events(){var _this2=this;this.$element.off('.abide').on('reset.zf.abide',function(){_this2.resetForm();}).on('submit.zf.abide',function(){return _this2.validateForm();});if(this.options.validateOn === 'fieldChange'){this.$inputs.off('change.zf.abide').on('change.zf.abide',function(e){_this2.validateInput($(e.target));});}if(this.options.liveValidate){this.$inputs.off('input.zf.abide').on('input.zf.abide',function(e){_this2.validateInput($(e.target));});}} /**
	       * Calls necessary functions to update Abide upon DOM change
	       * @private
	       */},{key:'_reflow',value:function _reflow(){this._init();} /**
	       * Checks whether or not a form element has the required attribute and if it's checked or not
	       * @param {Object} element - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */},{key:'requiredCheck',value:function requiredCheck($el){if(!$el.attr('required'))return true;var isGood=true;switch($el[0].type){case 'checkbox':isGood = $el[0].checked;break;case 'select':case 'select-one':case 'select-multiple':var opt=$el.find('option:selected');if(!opt.length || !opt.val())isGood = false;break;default:if(!$el.val() || !$el.val().length)isGood = false;}return isGood;} /**
	       * Based on $el, get the first element with selector in this order:
	       * 1. The element's direct sibling('s).
	       * 3. The element's parent's children.
	       *
	       * This allows for multiple form errors per input, though if none are found, no form errors will be shown.
	       *
	       * @param {Object} $el - jQuery object to use as reference to find the form error selector.
	       * @returns {Object} jQuery object with the selector.
	       */},{key:'findFormError',value:function findFormError($el){var $error=$el.siblings(this.options.formErrorSelector);if(!$error.length){$error = $el.parent().find(this.options.formErrorSelector);}return $error;} /**
	       * Get the first element in this order:
	       * 2. The <label> with the attribute `[for="someInputId"]`
	       * 3. The `.closest()` <label>
	       *
	       * @param {Object} $el - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */},{key:'findLabel',value:function findLabel($el){var id=$el[0].id;var $label=this.$element.find('label[for="' + id + '"]');if(!$label.length){return $el.closest('label');}return $label;} /**
	       * Get the set of labels associated with a set of radio els in this order
	       * 2. The <label> with the attribute `[for="someInputId"]`
	       * 3. The `.closest()` <label>
	       *
	       * @param {Object} $el - jQuery object to check for required attribute
	       * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
	       */},{key:'findRadioLabels',value:function findRadioLabels($els){var _this3=this;var labels=$els.map(function(i,el){var id=el.id;var $label=_this3.$element.find('label[for="' + id + '"]');if(!$label.length){$label = $(el).closest('label');}return $label[0];});return $(labels);} /**
	       * Adds the CSS error class as specified by the Abide settings to the label, input, and the form
	       * @param {Object} $el - jQuery object to add the class to
	       */},{key:'addErrorClasses',value:function addErrorClasses($el){var $label=this.findLabel($el);var $formError=this.findFormError($el);if($label.length){$label.addClass(this.options.labelErrorClass);}if($formError.length){$formError.addClass(this.options.formErrorClass);}$el.addClass(this.options.inputErrorClass).attr('data-invalid','');} /**
	       * Remove CSS error classes etc from an entire radio button group
	       * @param {String} groupName - A string that specifies the name of a radio button group
	       *
	       */},{key:'removeRadioErrorClasses',value:function removeRadioErrorClasses(groupName){var $els=this.$element.find(':radio[name="' + groupName + '"]');var $labels=this.findRadioLabels($els);var $formErrors=this.findFormError($els);if($labels.length){$labels.removeClass(this.options.labelErrorClass);}if($formErrors.length){$formErrors.removeClass(this.options.formErrorClass);}$els.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');} /**
	       * Removes CSS error class as specified by the Abide settings from the label, input, and the form
	       * @param {Object} $el - jQuery object to remove the class from
	       */},{key:'removeErrorClasses',value:function removeErrorClasses($el){ // radios need to clear all of the els
	if($el[0].type == 'radio'){return this.removeRadioErrorClasses($el.attr('name'));}var $label=this.findLabel($el);var $formError=this.findFormError($el);if($label.length){$label.removeClass(this.options.labelErrorClass);}if($formError.length){$formError.removeClass(this.options.formErrorClass);}$el.removeClass(this.options.inputErrorClass).removeAttr('data-invalid');} /**
	       * Goes through a form to find inputs and proceeds to validate them in ways specific to their type
	       * @fires Abide#invalid
	       * @fires Abide#valid
	       * @param {Object} element - jQuery object to validate, should be an HTML input
	       * @returns {Boolean} goodToGo - If the input is valid or not.
	       */},{key:'validateInput',value:function validateInput($el){var clearRequire=this.requiredCheck($el),validated=false,customValidator=true,validator=$el.attr('data-validator'),equalTo=true; // don't validate ignored inputs or hidden inputs
	if($el.is('[data-abide-ignore]') || $el.is('[type="hidden"]')){return true;}switch($el[0].type){case 'radio':validated = this.validateRadio($el.attr('name'));break;case 'checkbox':validated = clearRequire;break;case 'select':case 'select-one':case 'select-multiple':validated = clearRequire;break;default:validated = this.validateText($el);}if(validator){customValidator = this.matchValidation($el,validator,$el.attr('required'));}if($el.attr('data-equalto')){equalTo = this.options.validators.equalTo($el);}var goodToGo=[clearRequire,validated,customValidator,equalTo].indexOf(false) === -1;var message=(goodToGo?'valid':'invalid') + '.zf.abide';this[goodToGo?'removeErrorClasses':'addErrorClasses']($el); /**
	         * Fires when the input is done checking for validation. Event trigger is either `valid.zf.abide` or `invalid.zf.abide`
	         * Trigger includes the DOM element of the input.
	         * @event Abide#valid
	         * @event Abide#invalid
	         */$el.trigger(message,[$el]);return goodToGo;} /**
	       * Goes through a form and if there are any invalid inputs, it will display the form error element
	       * @returns {Boolean} noError - true if no errors were detected...
	       * @fires Abide#formvalid
	       * @fires Abide#forminvalid
	       */},{key:'validateForm',value:function validateForm(){var acc=[];var _this=this;this.$inputs.each(function(){acc.push(_this.validateInput($(this)));});var noError=acc.indexOf(false) === -1;this.$element.find('[data-abide-error]').css('display',noError?'none':'block'); /**
	         * Fires when the form is finished validating. Event trigger is either `formvalid.zf.abide` or `forminvalid.zf.abide`.
	         * Trigger includes the element of the form.
	         * @event Abide#formvalid
	         * @event Abide#forminvalid
	         */this.$element.trigger((noError?'formvalid':'forminvalid') + '.zf.abide',[this.$element]);return noError;} /**
	       * Determines whether or a not a text input is valid based on the pattern specified in the attribute. If no matching pattern is found, returns true.
	       * @param {Object} $el - jQuery object to validate, should be a text input HTML element
	       * @param {String} pattern - string value of one of the RegEx patterns in Abide.options.patterns
	       * @returns {Boolean} Boolean value depends on whether or not the input value matches the pattern specified
	       */},{key:'validateText',value:function validateText($el,pattern){ // A pattern can be passed to this function, or it will be infered from the input's "pattern" attribute, or it's "type" attribute
	pattern = pattern || $el.attr('pattern') || $el.attr('type');var inputText=$el.val();var valid=false;if(inputText.length){ // If the pattern attribute on the element is in Abide's list of patterns, then test that regexp
	if(this.options.patterns.hasOwnProperty(pattern)){valid = this.options.patterns[pattern].test(inputText);} // If the pattern name isn't also the type attribute of the field, then test it as a regexp
	else if(pattern !== $el.attr('type')){valid = new RegExp(pattern).test(inputText);}else {valid = true;}} // An empty field is valid if it's not required
	else if(!$el.prop('required')){valid = true;}return valid;} /**
	       * Determines whether or a not a radio input is valid based on whether or not it is required and selected. Although the function targets a single `<input>`, it validates by checking the `required` and `checked` properties of all radio buttons in its group.
	       * @param {String} groupName - A string that specifies the name of a radio button group
	       * @returns {Boolean} Boolean value depends on whether or not at least one radio input has been selected (if it's required)
	       */},{key:'validateRadio',value:function validateRadio(groupName){ // If at least one radio in the group has the `required` attribute, the group is considered required
	// Per W3C spec, all radio buttons in a group should have `required`, but we're being nice
	var $group=this.$element.find(':radio[name="' + groupName + '"]');var valid=false,required=false; // For the group to be required, at least one radio needs to be required
	$group.each(function(i,e){if($(e).attr('required')){required = true;}});if(!required)valid = true;if(!valid){ // For the group to be valid, at least one radio needs to be checked
	$group.each(function(i,e){if($(e).prop('checked')){valid = true;}});};return valid;} /**
	       * Determines if a selected input passes a custom validation function. Multiple validations can be used, if passed to the element with `data-validator="foo bar baz"` in a space separated listed.
	       * @param {Object} $el - jQuery input element.
	       * @param {String} validators - a string of function names matching functions in the Abide.options.validators object.
	       * @param {Boolean} required - self explanatory?
	       * @returns {Boolean} - true if validations passed.
	       */},{key:'matchValidation',value:function matchValidation($el,validators,required){var _this4=this;required = required?true:false;var clear=validators.split(' ').map(function(v){return _this4.options.validators[v]($el,required,$el.parent());});return clear.indexOf(false) === -1;} /**
	       * Resets form inputs and styles
	       * @fires Abide#formreset
	       */},{key:'resetForm',value:function resetForm(){var $form=this.$element,opts=this.options;$('.' + opts.labelErrorClass,$form).not('small').removeClass(opts.labelErrorClass);$('.' + opts.inputErrorClass,$form).not('small').removeClass(opts.inputErrorClass);$(opts.formErrorSelector + '.' + opts.formErrorClass).removeClass(opts.formErrorClass);$form.find('[data-abide-error]').css('display','none');$(':input',$form).not(':button, :submit, :reset, :hidden, :radio, :checkbox, [data-abide-ignore]').val('').removeAttr('data-invalid');$(':input:radio',$form).not('[data-abide-ignore]').prop('checked',false).removeAttr('data-invalid');$(':input:checkbox',$form).not('[data-abide-ignore]').prop('checked',false).removeAttr('data-invalid'); /**
	         * Fires when the form has been reset.
	         * @event Abide#formreset
	         */$form.trigger('formreset.zf.abide',[$form]);} /**
	       * Destroys an instance of Abide.
	       * Removes error styles and classes from elements, without resetting their values.
	       */},{key:'destroy',value:function destroy(){var _this=this;this.$element.off('.abide').find('[data-abide-error]').css('display','none');this.$inputs.off('.abide').each(function(){_this.removeErrorClasses($(this));});Foundation.unregisterPlugin(this);}}]);return Abide;})(); /**
	   * Default settings for plugin
	   */Abide.defaults = { /**
	     * The default event to validate inputs. Checkboxes and radios validate immediately.
	     * Remove or change this value for manual validation.
	     * @option
	     * @example 'fieldChange'
	     */validateOn:'fieldChange', /**
	     * Class to be applied to input labels on failed validation.
	     * @option
	     * @example 'is-invalid-label'
	     */labelErrorClass:'is-invalid-label', /**
	     * Class to be applied to inputs on failed validation.
	     * @option
	     * @example 'is-invalid-input'
	     */inputErrorClass:'is-invalid-input', /**
	     * Class selector to use to target Form Errors for show/hide.
	     * @option
	     * @example '.form-error'
	     */formErrorSelector:'.form-error', /**
	     * Class added to Form Errors on failed validation.
	     * @option
	     * @example 'is-visible'
	     */formErrorClass:'is-visible', /**
	     * Set to true to validate text inputs on any value change.
	     * @option
	     * @example false
	     */liveValidate:false,patterns:{alpha:/^[a-zA-Z]+$/,alpha_numeric:/^[a-zA-Z0-9]+$/,integer:/^[-+]?\d+$/,number:/^[-+]?\d*(?:[\.\,]\d+)?$/, // amex, visa, diners
	card:/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,cvv:/^([0-9]){3,4}$/, // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
	email:/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,url:/^(https?|ftp|file|ssh):\/\/(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/, // abc.de
	domain:/^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,datetime:/^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/, // YYYY-MM-DD
	date:/(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/, // HH:MM:SS
	time:/^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,dateISO:/^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/, // MM/DD/YYYY
	month_day_year:/^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/, // DD/MM/YYYY
	day_month_year:/^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/, // #FFF or #FFFFFF
	color:/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/}, /**
	     * Optional validation functions to be used. `equalTo` being the only default included function.
	     * Functions should return only a boolean if the input is valid or not. Functions are given the following arguments:
	     * el : The jQuery element to validate.
	     * required : Boolean value of the required attribute be present or not.
	     * parent : The direct parent of the input.
	     * @option
	     */validators:{equalTo:function equalTo(el,required,parent){return $('#' + el.attr('data-equalto')).val() === el.val();}}}; // Window exports
	Foundation.plugin(Abide,'Abide');})(jQuery);'use strict';var _createClass=(function(){function defineProperties(target,props){for(var i=0;i < props.length;i++) {var descriptor=props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if("value" in descriptor)descriptor.writable = true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};})();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}!(function($){ /**
	   * Equalizer module.
	   * @module foundation.equalizer
	   * @requires foundation.util.mediaQuery
	   * @requires foundation.util.timerAndImageLoader if equalizer contains images
	   */var Equalizer=(function(){ /**
	     * Creates a new instance of Equalizer.
	     * @class
	     * @fires Equalizer#init
	     * @param {Object} element - jQuery object to add the trigger to.
	     * @param {Object} options - Overrides to the default plugin settings.
	     */function Equalizer(element,options){_classCallCheck(this,Equalizer);this.$element = element;this.options = $.extend({},Equalizer.defaults,this.$element.data(),options);this._init();Foundation.registerPlugin(this,'Equalizer');} /**
	     * Initializes the Equalizer plugin and calls functions to get equalizer functioning on load.
	     * @private
	     */_createClass(Equalizer,[{key:'_init',value:function _init(){var eqId=this.$element.attr('data-equalizer') || '';var $watched=this.$element.find('[data-equalizer-watch="' + eqId + '"]');this.$watched = $watched.length?$watched:this.$element.find('[data-equalizer-watch]');this.$element.attr('data-resize',eqId || Foundation.GetYoDigits(6,'eq'));this.hasNested = this.$element.find('[data-equalizer]').length > 0;this.isNested = this.$element.parentsUntil(document.body,'[data-equalizer]').length > 0;this.isOn = false;this._bindHandler = {onResizeMeBound:this._onResizeMe.bind(this),onPostEqualizedBound:this._onPostEqualized.bind(this)};var imgs=this.$element.find('img');var tooSmall;if(this.options.equalizeOn){tooSmall = this._checkMQ();$(window).on('changed.zf.mediaquery',this._checkMQ.bind(this));}else {this._events();}if(tooSmall !== undefined && tooSmall === false || tooSmall === undefined){if(imgs.length){Foundation.onImagesLoaded(imgs,this._reflow.bind(this));}else {this._reflow();}}} /**
	       * Removes event listeners if the breakpoint is too small.
	       * @private
	       */},{key:'_pauseEvents',value:function _pauseEvents(){this.isOn = false;this.$element.off({'.zf.equalizer':this._bindHandler.onPostEqualizedBound,'resizeme.zf.trigger':this._bindHandler.onResizeMeBound});} /**
	       * function to handle $elements resizeme.zf.trigger, with bound this on _bindHandler.onResizeMeBound
	       * @private
	       */},{key:'_onResizeMe',value:function _onResizeMe(e){this._reflow();} /**
	       * function to handle $elements postequalized.zf.equalizer, with bound this on _bindHandler.onPostEqualizedBound
	       * @private
	       */},{key:'_onPostEqualized',value:function _onPostEqualized(e){if(e.target !== this.$element[0]){this._reflow();}} /**
	       * Initializes events for Equalizer.
	       * @private
	       */},{key:'_events',value:function _events(){var _this=this;this._pauseEvents();if(this.hasNested){this.$element.on('postequalized.zf.equalizer',this._bindHandler.onPostEqualizedBound);}else {this.$element.on('resizeme.zf.trigger',this._bindHandler.onResizeMeBound);}this.isOn = true;} /**
	       * Checks the current breakpoint to the minimum required size.
	       * @private
	       */},{key:'_checkMQ',value:function _checkMQ(){var tooSmall=!Foundation.MediaQuery.atLeast(this.options.equalizeOn);if(tooSmall){if(this.isOn){this._pauseEvents();this.$watched.css('height','auto');}}else {if(!this.isOn){this._events();}}return tooSmall;} /**
	       * A noop version for the plugin
	       * @private
	       */},{key:'_killswitch',value:function _killswitch(){return;} /**
	       * Calls necessary functions to update Equalizer upon DOM change
	       * @private
	       */},{key:'_reflow',value:function _reflow(){if(!this.options.equalizeOnStack){if(this._isStacked()){this.$watched.css('height','auto');return false;}}if(this.options.equalizeByRow){this.getHeightsByRow(this.applyHeightByRow.bind(this));}else {this.getHeights(this.applyHeight.bind(this));}} /**
	       * Manually determines if the first 2 elements are *NOT* stacked.
	       * @private
	       */},{key:'_isStacked',value:function _isStacked(){return this.$watched[0].getBoundingClientRect().top !== this.$watched[1].getBoundingClientRect().top;} /**
	       * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
	       * @param {Function} cb - A non-optional callback to return the heights array to.
	       * @returns {Array} heights - An array of heights of children within Equalizer container
	       */},{key:'getHeights',value:function getHeights(cb){var heights=[];for(var i=0,len=this.$watched.length;i < len;i++) {this.$watched[i].style.height = 'auto';heights.push(this.$watched[i].offsetHeight);}cb(heights);} /**
	       * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
	       * @param {Function} cb - A non-optional callback to return the heights array to.
	       * @returns {Array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
	       */},{key:'getHeightsByRow',value:function getHeightsByRow(cb){var lastElTopOffset=this.$watched.length?this.$watched.first().offset().top:0,groups=[],group=0; //group by Row
	groups[group] = [];for(var i=0,len=this.$watched.length;i < len;i++) {this.$watched[i].style.height = 'auto'; //maybe could use this.$watched[i].offsetTop
	var elOffsetTop=$(this.$watched[i]).offset().top;if(elOffsetTop != lastElTopOffset){group++;groups[group] = [];lastElTopOffset = elOffsetTop;}groups[group].push([this.$watched[i],this.$watched[i].offsetHeight]);}for(var j=0,ln=groups.length;j < ln;j++) {var heights=$(groups[j]).map(function(){return this[1];}).get();var max=Math.max.apply(null,heights);groups[j].push(max);}cb(groups);} /**
	       * Changes the CSS height property of each child in an Equalizer parent to match the tallest
	       * @param {array} heights - An array of heights of children within Equalizer container
	       * @fires Equalizer#preequalized
	       * @fires Equalizer#postequalized
	       */},{key:'applyHeight',value:function applyHeight(heights){var max=Math.max.apply(null,heights); /**
	         * Fires before the heights are applied
	         * @event Equalizer#preequalized
	         */this.$element.trigger('preequalized.zf.equalizer');this.$watched.css('height',max); /**
	         * Fires when the heights have been applied
	         * @event Equalizer#postequalized
	         */this.$element.trigger('postequalized.zf.equalizer');} /**
	       * Changes the CSS height property of each child in an Equalizer parent to match the tallest by row
	       * @param {array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
	       * @fires Equalizer#preequalized
	       * @fires Equalizer#preequalizedRow
	       * @fires Equalizer#postequalizedRow
	       * @fires Equalizer#postequalized
	       */},{key:'applyHeightByRow',value:function applyHeightByRow(groups){ /**
	         * Fires before the heights are applied
	         */this.$element.trigger('preequalized.zf.equalizer');for(var i=0,len=groups.length;i < len;i++) {var groupsILength=groups[i].length,max=groups[i][groupsILength - 1];if(groupsILength <= 2){$(groups[i][0][0]).css({'height':'auto'});continue;} /**
	            * Fires before the heights per row are applied
	            * @event Equalizer#preequalizedRow
	            */this.$element.trigger('preequalizedrow.zf.equalizer');for(var j=0,lenJ=groupsILength - 1;j < lenJ;j++) {$(groups[i][j][0]).css({'height':max});} /**
	            * Fires when the heights per row have been applied
	            * @event Equalizer#postequalizedRow
	            */this.$element.trigger('postequalizedrow.zf.equalizer');} /**
	         * Fires when the heights have been applied
	         */this.$element.trigger('postequalized.zf.equalizer');} /**
	       * Destroys an instance of Equalizer.
	       * @function
	       */},{key:'destroy',value:function destroy(){this._pauseEvents();this.$watched.css('height','auto');Foundation.unregisterPlugin(this);}}]);return Equalizer;})(); /**
	   * Default settings for plugin
	   */Equalizer.defaults = { /**
	     * Enable height equalization when stacked on smaller screens.
	     * @option
	     * @example true
	     */equalizeOnStack:false, /**
	     * Enable height equalization row by row.
	     * @option
	     * @example false
	     */equalizeByRow:false, /**
	     * String representing the minimum breakpoint size the plugin should equalize heights on.
	     * @option
	     * @example 'medium'
	     */equalizeOn:''}; // Window exports
	Foundation.plugin(Equalizer,'Equalizer');})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {'use strict';(function(global,factory){ true?module.exports = factory():typeof define === 'function' && define.amd?define(factory):global.jspdf = factory();})(undefined,function(){'use strict';var _typeof=typeof Symbol === "function" && typeof Symbol.iterator === "symbol"?function(obj){return typeof obj;}:function(obj){return obj && typeof Symbol === "function" && obj.constructor === Symbol?"symbol":typeof obj;};var get$1=function get$1(_x,_x2,_x3){var _again=true;_function: while(_again) {var object=_x,property=_x2,receiver=_x3;_again = false;if(object === null)object = Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent === null){return undefined;}else {_x = parent;_x2 = property;_x3 = receiver;_again = true;desc = parent = undefined;continue _function;}}else if("value" in desc){return desc.value;}else {var getter=desc.get;if(getter === undefined){return undefined;}return getter.call(receiver);}}};var set$1=function set$1(object,property,value,receiver){var desc=Object.getOwnPropertyDescriptor(object,property);if(desc === undefined){var parent=Object.getPrototypeOf(object);if(parent !== null){set$1(parent,property,value,receiver);}}else if("value" in desc && desc.writable){desc.value = value;}else {var setter=desc.set;if(setter !== undefined){setter.call(receiver,value);}}return value;}; /** @preserve
	 * jsPDF - PDF Document creation from JavaScript
	 * Version 1.3.2 Built on 2016-10-07T02:03:54.044Z
	 *                           CommitID b0c67949b0
	 *
	 * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
	 *               2010 Aaron Spike, https://github.com/acspike
	 *               2012 Willow Systems Corporation, willow-systems.com
	 *               2012 Pablo Hess, https://github.com/pablohess
	 *               2012 Florian Jenett, https://github.com/fjenett
	 *               2013 Warren Weckesser, https://github.com/warrenweckesser
	 *               2013 Youssef Beddad, https://github.com/lifof
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2013 Stefan Slonevskiy, https://github.com/stefslon
	 *               2013 Jeremy Morel, https://github.com/jmorel
	 *               2013 Christoph Hartmann, https://github.com/chris-rock
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Makes, https://github.com/dollaruw
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Steven Spungin, https://github.com/Flamenco
	 *               2014 Kenneth Glassey, https://github.com/Gavvers
	 *
	 * Licensed under the MIT License
	 *
	 * Contributor(s):
	 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	 *    kim3er, mfo, alnorth, Flamenco
	 */ /**
	 * Creates new jsPDF document object instance.
	 *
	 * @class
	 * @param orientation One of "portrait" or "landscape" (or shortcuts "p" (Default), "l")
	 * @param unit        Measurement unit to be used when coordinates are specified.
	 *                    One of "pt" (points), "mm" (Default), "cm", "in"
	 * @param format      One of 'pageFormats' as shown below, default: a4
	 * @returns {jsPDF}
	 * @name jsPDF
	 */var jsPDF=(function(global){'use strict';var pdfVersion='1.3',pageFormats={ // Size in pt of various paper formats
	'a0':[2383.94,3370.39],'a1':[1683.78,2383.94],'a2':[1190.55,1683.78],'a3':[841.89,1190.55],'a4':[595.28,841.89],'a5':[419.53,595.28],'a6':[297.64,419.53],'a7':[209.76,297.64],'a8':[147.40,209.76],'a9':[104.88,147.40],'a10':[73.70,104.88],'b0':[2834.65,4008.19],'b1':[2004.09,2834.65],'b2':[1417.32,2004.09],'b3':[1000.63,1417.32],'b4':[708.66,1000.63],'b5':[498.90,708.66],'b6':[354.33,498.90],'b7':[249.45,354.33],'b8':[175.75,249.45],'b9':[124.72,175.75],'b10':[87.87,124.72],'c0':[2599.37,3676.54],'c1':[1836.85,2599.37],'c2':[1298.27,1836.85],'c3':[918.43,1298.27],'c4':[649.13,918.43],'c5':[459.21,649.13],'c6':[323.15,459.21],'c7':[229.61,323.15],'c8':[161.57,229.61],'c9':[113.39,161.57],'c10':[79.37,113.39],'dl':[311.81,623.62],'letter':[612,792],'government-letter':[576,756],'legal':[612,1008],'junior-legal':[576,360],'ledger':[1224,792],'tabloid':[792,1224],'credit-card':[153,243]}; /**
	   * jsPDF's Internal PubSub Implementation.
	   * See mrrio.github.io/jsPDF/doc/symbols/PubSub.html
	   * Backward compatible rewritten on 2014 by
	   * Diego Casorran, https://github.com/diegocr
	   *
	   * @class
	   * @name PubSub
	   */function PubSub(context){var topics={};this.subscribe = function(topic,callback,once){if(typeof callback !== 'function'){return false;}if(!topics.hasOwnProperty(topic)){topics[topic] = {};}var id=Math.random().toString(35);topics[topic][id] = [callback,!!once];return id;};this.unsubscribe = function(token){for(var topic in topics) {if(topics[topic][token]){delete topics[topic][token];return true;}}return false;};this.publish = function(topic){if(topics.hasOwnProperty(topic)){var args=Array.prototype.slice.call(arguments,1),idr=[];for(var id in topics[topic]) {var sub=topics[topic][id];try{sub[0].apply(context,args);}catch(ex) {if(global.console){console.error('jsPDF PubSub Error',ex.message,ex);}}if(sub[1])idr.push(id);}if(idr.length)idr.forEach(this.unsubscribe);}};} /**
	   * @constructor
	   * @private
	   */function jsPDF(orientation,unit,format,compressPdf){var options={};if((typeof orientation === 'undefined'?'undefined':_typeof(orientation)) === 'object'){options = orientation;orientation = options.orientation;unit = options.unit || unit;format = options.format || format;compressPdf = options.compress || options.compressPdf || compressPdf;} // Default options
	unit = unit || 'mm';format = format || 'a4';orientation = ('' + (orientation || 'P')).toLowerCase();var format_as_string=('' + format).toLowerCase(),compress=!!compressPdf && typeof Uint8Array === 'function',textColor=options.textColor || '0 g',drawColor=options.drawColor || '0 G',activeFontSize=options.fontSize || 16,lineHeightProportion=options.lineHeight || 1.15,lineWidth=options.lineWidth || 0.200025, // 2mm
	objectNumber=2, // 'n' Current object number
	outToPages=!1, // switches where out() prints. outToPages true = push to pages obj. outToPages false = doc builder content
	offsets=[], // List of offsets. Activated and reset by buildDocument(). Pupulated by various calls buildDocument makes.
	fonts={}, // collection of font objects, where key is fontKey - a dynamically created label for a given font.
	fontmap={}, // mapping structure fontName > fontStyle > font key - performance layer. See addFont()
	activeFontKey, // will be string representing the KEY of the font as combination of fontName + fontStyle
	k, // Scale factor
	tmp,page=0,currentPage,pages=[],pagesContext=[], // same index as pages and pagedim
	pagedim=[],content=[],additionalObjects=[],lineCapID=0,lineJoinID=0,content_length=0,pageWidth,pageHeight,pageMode,zoomMode,layoutMode,documentProperties={'title':'','subject':'','author':'','keywords':'','creator':''},API={},events=new PubSub(API), /////////////////////
	// Private functions
	/////////////////////
	f2=function f2(number){return number.toFixed(2); // Ie, %.2f
	},f3=function f3(number){return number.toFixed(3); // Ie, %.3f
	},padd2=function padd2(number){return ('0' + parseInt(number)).slice(-2);},out=function out(string){if(outToPages){ /* set by beginPage */pages[currentPage].push(string);}else { // +1 for '\n' that will be used to join 'content'
	content_length += string.length + 1;content.push(string);}},newObject=function newObject(){ // Begin a new object
	objectNumber++;offsets[objectNumber] = content_length;out(objectNumber + ' 0 obj');return objectNumber;}, // Does not output the object until after the pages have been output.
	// Returns an object containing the objectId and content.
	// All pages have been added so the object ID can be estimated to start right after.
	// This does not modify the current objectNumber;  It must be updated after the newObjects are output.
	newAdditionalObject=function newAdditionalObject(){var objId=pages.length * 2 + 1;objId += additionalObjects.length;var obj={objId:objId,content:''};additionalObjects.push(obj);return obj;}, // Does not output the object.  The caller must call newObjectDeferredBegin(oid) before outputing any data
	newObjectDeferred=function newObjectDeferred(){objectNumber++;offsets[objectNumber] = function(){return content_length;};return objectNumber;},newObjectDeferredBegin=function newObjectDeferredBegin(oid){offsets[oid] = content_length;},putStream=function putStream(str){out('stream');out(str);out('endstream');},putPages=function putPages(){var n,p,arr,i,deflater,adler32,adler32cs,wPt,hPt,pageObjectNumbers=[];adler32cs = global.adler32cs || jsPDF.adler32cs;if(compress && typeof adler32cs === 'undefined'){compress = false;} // outToPages = false as set in endDocument(). out() writes to content.
	for(n = 1;n <= page;n++) {pageObjectNumbers.push(newObject());wPt = (pageWidth = pagedim[n].width) * k;hPt = (pageHeight = pagedim[n].height) * k;out('<</Type /Page');out('/Parent 1 0 R');out('/Resources 2 0 R');out('/MediaBox [0 0 ' + f2(wPt) + ' ' + f2(hPt) + ']'); // Added for annotation plugin
	events.publish('putPage',{pageNumber:n,page:pages[n]});out('/Contents ' + (objectNumber + 1) + ' 0 R');out('>>');out('endobj'); // Page content
	p = pages[n].join('\n');newObject();if(compress){arr = [];i = p.length;while(i--) {arr[i] = p.charCodeAt(i);}adler32 = adler32cs.from(p);deflater = new Deflater(6);deflater.append(new Uint8Array(arr));p = deflater.flush();arr = new Uint8Array(p.length + 6);arr.set(new Uint8Array([120,156])),arr.set(p,2);arr.set(new Uint8Array([adler32 & 0xFF,adler32 >> 8 & 0xFF,adler32 >> 16 & 0xFF,adler32 >> 24 & 0xFF]),p.length + 2);p = String.fromCharCode.apply(null,arr);out('<</Length ' + p.length + ' /Filter [/FlateDecode]>>');}else {out('<</Length ' + p.length + '>>');}putStream(p);out('endobj');}offsets[1] = content_length;out('1 0 obj');out('<</Type /Pages');var kids='/Kids [';for(i = 0;i < page;i++) {kids += pageObjectNumbers[i] + ' 0 R ';}out(kids + ']');out('/Count ' + page);out('>>');out('endobj');events.publish('postPutPages');},putFont=function putFont(font){font.objectNumber = newObject();out('<</BaseFont/' + font.PostScriptName + '/Type/Font');if(typeof font.encoding === 'string'){out('/Encoding/' + font.encoding);}out('/Subtype/Type1>>');out('endobj');},putFonts=function putFonts(){for(var fontKey in fonts) {if(fonts.hasOwnProperty(fontKey)){putFont(fonts[fontKey]);}}},putXobjectDict=function putXobjectDict(){ // Loop through images, or other data objects
	events.publish('putXobjectDict');},putResourceDictionary=function putResourceDictionary(){out('/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]');out('/Font <<'); // Do this for each font, the '1' bit is the index of the font
	for(var fontKey in fonts) {if(fonts.hasOwnProperty(fontKey)){out('/' + fontKey + ' ' + fonts[fontKey].objectNumber + ' 0 R');}}out('>>');out('/XObject <<');putXobjectDict();out('>>');},putResources=function putResources(){putFonts();events.publish('putResources'); // Resource dictionary
	offsets[2] = content_length;out('2 0 obj');out('<<');putResourceDictionary();out('>>');out('endobj');events.publish('postPutResources');},putAdditionalObjects=function putAdditionalObjects(){events.publish('putAdditionalObjects');for(var i=0;i < additionalObjects.length;i++) {var obj=additionalObjects[i];offsets[obj.objId] = content_length;out(obj.objId + ' 0 obj');out(obj.content);out('endobj');}objectNumber += additionalObjects.length;events.publish('postPutAdditionalObjects');},addToFontDictionary=function addToFontDictionary(fontKey,fontName,fontStyle){ // this is mapping structure for quick font key lookup.
	// returns the KEY of the font (ex: "F1") for a given
	// pair of font name and type (ex: "Arial". "Italic")
	if(!fontmap.hasOwnProperty(fontName)){fontmap[fontName] = {};}fontmap[fontName][fontStyle] = fontKey;}, /**
	     * FontObject describes a particular font as member of an instnace of jsPDF
	     *
	     * It's a collection of properties like 'id' (to be used in PDF stream),
	     * 'fontName' (font's family name), 'fontStyle' (font's style variant label)
	     *
	     * @class
	     * @public
	     * @property id {String} PDF-document-instance-specific label assinged to the font.
	     * @property PostScriptName {String} PDF specification full name for the font
	     * @property encoding {Object} Encoding_name-to-Font_metrics_object mapping.
	     * @name FontObject
	     */addFont=function addFont(PostScriptName,fontName,fontStyle,encoding){var fontKey='F' + (Object.keys(fonts).length + 1).toString(10), // This is FontObject
	font=fonts[fontKey] = {'id':fontKey,'PostScriptName':PostScriptName,'fontName':fontName,'fontStyle':fontStyle,'encoding':encoding,'metadata':{}};addToFontDictionary(fontKey,fontName,fontStyle);events.publish('addFont',font);return fontKey;},addFonts=function addFonts(){var HELVETICA="helvetica",TIMES="times",COURIER="courier",NORMAL="normal",BOLD="bold",ITALIC="italic",BOLD_ITALIC="bolditalic",encoding='StandardEncoding',ZAPF="zapfdingbats",standardFonts=[['Helvetica',HELVETICA,NORMAL],['Helvetica-Bold',HELVETICA,BOLD],['Helvetica-Oblique',HELVETICA,ITALIC],['Helvetica-BoldOblique',HELVETICA,BOLD_ITALIC],['Courier',COURIER,NORMAL],['Courier-Bold',COURIER,BOLD],['Courier-Oblique',COURIER,ITALIC],['Courier-BoldOblique',COURIER,BOLD_ITALIC],['Times-Roman',TIMES,NORMAL],['Times-Bold',TIMES,BOLD],['Times-Italic',TIMES,ITALIC],['Times-BoldItalic',TIMES,BOLD_ITALIC],['ZapfDingbats',ZAPF]];for(var i=0,l=standardFonts.length;i < l;i++) {var fontKey=addFont(standardFonts[i][0],standardFonts[i][1],standardFonts[i][2],encoding); // adding aliases for standard fonts, this time matching the capitalization
	var parts=standardFonts[i][0].split('-');addToFontDictionary(fontKey,parts[0],parts[1] || '');}events.publish('addFonts',{fonts:fonts,dictionary:fontmap});},SAFE=function __safeCall(fn){fn.foo = function __safeCallWrapper(){try{return fn.apply(this,arguments);}catch(e) {var stack=e.stack || '';if(~stack.indexOf(' at '))stack = stack.split(" at ")[1];var m="Error in function " + stack.split("\n")[0].split('<')[0] + ": " + e.message;if(global.console){global.console.error(m,e);if(global.alert)alert(m);}else {throw new Error(m);}}};fn.foo.bar = fn;return fn.foo;},to8bitStream=function to8bitStream(text,flags){ /**
	       * PDF 1.3 spec:
	       * "For text strings encoded in Unicode, the first two bytes must be 254 followed by
	       * 255, representing the Unicode byte order marker, U+FEFF. (This sequence conflicts
	       * with the PDFDocEncoding character sequence thorn ydieresis, which is unlikely
	       * to be a meaningful beginning of a word or phrase.) The remainder of the
	       * string consists of Unicode character codes, according to the UTF-16 encoding
	       * specified in the Unicode standard, version 2.0. Commonly used Unicode values
	       * are represented as 2 bytes per character, with the high-order byte appearing first
	       * in the string."
	       *
	       * In other words, if there are chars in a string with char code above 255, we
	       * recode the string to UCS2 BE - string doubles in length and BOM is prepended.
	       *
	       * HOWEVER!
	       * Actual *content* (body) text (as opposed to strings used in document properties etc)
	       * does NOT expect BOM. There, it is treated as a literal GID (Glyph ID)
	       *
	       * Because of Adobe's focus on "you subset your fonts!" you are not supposed to have
	       * a font that maps directly Unicode (UCS2 / UTF16BE) code to font GID, but you could
	       * fudge it with "Identity-H" encoding and custom CIDtoGID map that mimics Unicode
	       * code page. There, however, all characters in the stream are treated as GIDs,
	       * including BOM, which is the reason we need to skip BOM in content text (i.e. that
	       * that is tied to a font).
	       *
	       * To signal this "special" PDFEscape / to8bitStream handling mode,
	       * API.text() function sets (unless you overwrite it with manual values
	       * given to API.text(.., flags) )
	       * flags.autoencode = true
	       * flags.noBOM = true
	       *
	       * ===================================================================================
	       * `flags` properties relied upon:
	       *   .sourceEncoding = string with encoding label.
	       *                     "Unicode" by default. = encoding of the incoming text.
	       *                     pass some non-existing encoding name
	       *                     (ex: 'Do not touch my strings! I know what I am doing.')
	       *                     to make encoding code skip the encoding step.
	       *   .outputEncoding = Either valid PDF encoding name
	       *                     (must be supported by jsPDF font metrics, otherwise no encoding)
	       *                     or a JS object, where key = sourceCharCode, value = outputCharCode
	       *                     missing keys will be treated as: sourceCharCode === outputCharCode
	       *   .noBOM
	       *       See comment higher above for explanation for why this is important
	       *   .autoencode
	       *       See comment higher above for explanation for why this is important
	       */var i,l,sourceEncoding,encodingBlock,outputEncoding,newtext,isUnicode,ch,bch;flags = flags || {};sourceEncoding = flags.sourceEncoding || 'Unicode';outputEncoding = flags.outputEncoding; // This 'encoding' section relies on font metrics format
	// attached to font objects by, among others,
	// "Willow Systems' standard_font_metrics plugin"
	// see jspdf.plugin.standard_font_metrics.js for format
	// of the font.metadata.encoding Object.
	// It should be something like
	//   .encoding = {'codePages':['WinANSI....'], 'WinANSI...':{code:code, ...}}
	//   .widths = {0:width, code:width, ..., 'fof':divisor}
	//   .kerning = {code:{previous_char_code:shift, ..., 'fof':-divisor},...}
	if((flags.autoencode || outputEncoding) && fonts[activeFontKey].metadata && fonts[activeFontKey].metadata[sourceEncoding] && fonts[activeFontKey].metadata[sourceEncoding].encoding){encodingBlock = fonts[activeFontKey].metadata[sourceEncoding].encoding; // each font has default encoding. Some have it clearly defined.
	if(!outputEncoding && fonts[activeFontKey].encoding){outputEncoding = fonts[activeFontKey].encoding;} // Hmmm, the above did not work? Let's try again, in different place.
	if(!outputEncoding && encodingBlock.codePages){outputEncoding = encodingBlock.codePages[0]; // let's say, first one is the default
	}if(typeof outputEncoding === 'string'){outputEncoding = encodingBlock[outputEncoding];} // we want output encoding to be a JS Object, where
	// key = sourceEncoding's character code and
	// value = outputEncoding's character code.
	if(outputEncoding){isUnicode = false;newtext = [];for(i = 0,l = text.length;i < l;i++) {ch = outputEncoding[text.charCodeAt(i)];if(ch){newtext.push(String.fromCharCode(ch));}else {newtext.push(text[i]);} // since we are looping over chars anyway, might as well
	// check for residual unicodeness
	if(newtext[i].charCodeAt(0) >> 8){ /* more than 255 */isUnicode = true;}}text = newtext.join('');}}i = text.length; // isUnicode may be set to false above. Hence the triple-equal to undefined
	while(isUnicode === undefined && i !== 0) {if(text.charCodeAt(i - 1) >> 8){ /* more than 255 */isUnicode = true;}i--;}if(!isUnicode){return text;}newtext = flags.noBOM?[]:[254,255];for(i = 0,l = text.length;i < l;i++) {ch = text.charCodeAt(i);bch = ch >> 8; // divide by 256
	if(bch >> 8){ /* something left after dividing by 256 second time */throw new Error("Character at position " + i + " of string '" + text + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");}newtext.push(bch);newtext.push(ch - (bch << 8));}return String.fromCharCode.apply(undefined,newtext);},pdfEscape=function pdfEscape(text,flags){ /**
	       * Replace '/', '(', and ')' with pdf-safe versions
	       *
	       * Doing to8bitStream does NOT make this PDF display unicode text. For that
	       * we also need to reference a unicode font and embed it - royal pain in the rear.
	       *
	       * There is still a benefit to to8bitStream - PDF simply cannot handle 16bit chars,
	       * which JavaScript Strings are happy to provide. So, while we still cannot display
	       * 2-byte characters property, at least CONDITIONALLY converting (entire string containing)
	       * 16bit chars to (USC-2-BE) 2-bytes per char + BOM streams we ensure that entire PDF
	       * is still parseable.
	       * This will allow immediate support for unicode in document properties strings.
	       */return to8bitStream(text,flags).replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)');},putInfo=function putInfo(){out('/Producer (jsPDF ' + jsPDF.version + ')');for(var key in documentProperties) {if(documentProperties.hasOwnProperty(key) && documentProperties[key]){out('/' + key.substr(0,1).toUpperCase() + key.substr(1) + ' (' + pdfEscape(documentProperties[key]) + ')');}}var created=new Date(),tzoffset=created.getTimezoneOffset(),tzsign=tzoffset < 0?'+':'-',tzhour=Math.floor(Math.abs(tzoffset / 60)),tzmin=Math.abs(tzoffset % 60),tzstr=[tzsign,padd2(tzhour),"'",padd2(tzmin),"'"].join('');out(['/CreationDate (D:',created.getFullYear(),padd2(created.getMonth() + 1),padd2(created.getDate()),padd2(created.getHours()),padd2(created.getMinutes()),padd2(created.getSeconds()),tzstr,')'].join(''));},putCatalog=function putCatalog(){out('/Type /Catalog');out('/Pages 1 0 R'); // PDF13ref Section 7.2.1
	if(!zoomMode)zoomMode = 'fullwidth';switch(zoomMode){case 'fullwidth':out('/OpenAction [3 0 R /FitH null]');break;case 'fullheight':out('/OpenAction [3 0 R /FitV null]');break;case 'fullpage':out('/OpenAction [3 0 R /Fit]');break;case 'original':out('/OpenAction [3 0 R /XYZ null null 1]');break;default:var pcn='' + zoomMode;if(pcn.substr(pcn.length - 1) === '%')zoomMode = parseInt(zoomMode) / 100;if(typeof zoomMode === 'number'){out('/OpenAction [3 0 R /XYZ null null ' + f2(zoomMode) + ']');}}if(!layoutMode)layoutMode = 'continuous';switch(layoutMode){case 'continuous':out('/PageLayout /OneColumn');break;case 'single':out('/PageLayout /SinglePage');break;case 'two':case 'twoleft':out('/PageLayout /TwoColumnLeft');break;case 'tworight':out('/PageLayout /TwoColumnRight');break;}if(pageMode){ /**
	         * A name object specifying how the document should be displayed when opened:
	         * UseNone      : Neither document outline nor thumbnail images visible -- DEFAULT
	         * UseOutlines  : Document outline visible
	         * UseThumbs    : Thumbnail images visible
	         * FullScreen   : Full-screen mode, with no menu bar, window controls, or any other window visible
	         */out('/PageMode /' + pageMode);}events.publish('putCatalog');},putTrailer=function putTrailer(){out('/Size ' + (objectNumber + 1));out('/Root ' + objectNumber + ' 0 R');out('/Info ' + (objectNumber - 1) + ' 0 R');},beginPage=function beginPage(width,height){ // Dimensions are stored as user units and converted to points on output
	var orientation=typeof height === 'string' && height.toLowerCase();if(typeof width === 'string'){var format=width.toLowerCase();if(pageFormats.hasOwnProperty(format)){width = pageFormats[format][0] / k;height = pageFormats[format][1] / k;}}if(Array.isArray(width)){height = width[1];width = width[0];}if(orientation){switch(orientation.substr(0,1)){case 'l':if(height > width)orientation = 's';break;case 'p':if(width > height)orientation = 's';break;}if(orientation === 's'){tmp = width;width = height;height = tmp;}}outToPages = true;pages[++page] = [];pagedim[page] = {width:Number(width) || pageWidth,height:Number(height) || pageHeight};pagesContext[page] = {};_setPage(page);},_addPage=function _addPage(){beginPage.apply(this,arguments); // Set line width
	out(f2(lineWidth * k) + ' w'); // Set draw color
	out(drawColor); // resurrecting non-default line caps, joins
	if(lineCapID !== 0){out(lineCapID + ' J');}if(lineJoinID !== 0){out(lineJoinID + ' j');}events.publish('addPage',{pageNumber:page});},_deletePage=function _deletePage(n){if(n > 0 && n <= page){pages.splice(n,1);pagedim.splice(n,1);page--;if(currentPage > page){currentPage = page;}this.setPage(currentPage);}},_setPage=function _setPage(n){if(n > 0 && n <= page){currentPage = n;pageWidth = pagedim[n].width;pageHeight = pagedim[n].height;}}, /**
	     * Returns a document-specific font key - a label assigned to a
	     * font name + font type combination at the time the font was added
	     * to the font inventory.
	     *
	     * Font key is used as label for the desired font for a block of text
	     * to be added to the PDF document stream.
	     * @private
	     * @function
	     * @param fontName {String} can be undefined on "falthy" to indicate "use current"
	     * @param fontStyle {String} can be undefined on "falthy" to indicate "use current"
	     * @returns {String} Font key.
	     */_getFont=function _getFont(fontName,fontStyle){var key;fontName = fontName !== undefined?fontName:fonts[activeFontKey].fontName;fontStyle = fontStyle !== undefined?fontStyle:fonts[activeFontKey].fontStyle;if(fontName !== undefined){fontName = fontName.toLowerCase();}switch(fontName){case 'sans-serif':case 'verdana':case 'arial':case 'helvetica':fontName = 'helvetica';break;case 'fixed':case 'monospace':case 'terminal':case 'courier':fontName = 'courier';break;case 'serif':case 'cursive':case 'fantasy':default:fontName = 'times';break;}try{ // get a string like 'F3' - the KEY corresponding tot he font + type combination.
	key = fontmap[fontName][fontStyle];}catch(e) {}if(!key){ //throw new Error("Unable to look up font label for font '" + fontName + "', '"
	//+ fontStyle + "'. Refer to getFontList() for available fonts.");
	key = fontmap['times'][fontStyle];if(key == null){key = fontmap['times']['normal'];}}return key;},buildDocument=function buildDocument(){outToPages = false; // switches out() to content
	objectNumber = 2;content_length = 0;content = [];offsets = [];additionalObjects = []; // Added for AcroForm
	events.publish('buildDocument'); // putHeader()
	out('%PDF-' + pdfVersion);putPages(); // Must happen after putPages
	// Modifies current object Id
	putAdditionalObjects();putResources(); // Info
	newObject();out('<<');putInfo();out('>>');out('endobj'); // Catalog
	newObject();out('<<');putCatalog();out('>>');out('endobj'); // Cross-ref
	var o=content_length,i,p="0000000000";out('xref');out('0 ' + (objectNumber + 1));out(p + ' 65535 f ');for(i = 1;i <= objectNumber;i++) {var offset=offsets[i];if(typeof offset === 'function'){out((p + offsets[i]()).slice(-10) + ' 00000 n ');}else {out((p + offsets[i]).slice(-10) + ' 00000 n ');}} // Trailer
	out('trailer');out('<<');putTrailer();out('>>');out('startxref');out('' + o);out('%%EOF');outToPages = true;return content.join('\n');},getStyle=function getStyle(style){ // see path-painting operators in PDF spec
	var op='S'; // stroke
	if(style === 'F'){op = 'f'; // fill
	}else if(style === 'FD' || style === 'DF'){op = 'B'; // both
	}else if(style === 'f' || style === 'f*' || style === 'B' || style === 'B*'){ /*
	         Allow direct use of these PDF path-painting operators:
	         - f	fill using nonzero winding number rule
	         - f*	fill using even-odd rule
	         - B	fill then stroke with fill using non-zero winding number rule
	         - B*	fill then stroke with fill using even-odd rule
	         */op = style;}return op;},getArrayBuffer=function getArrayBuffer(){var data=buildDocument(),len=data.length,ab=new ArrayBuffer(len),u8=new Uint8Array(ab);while(len--) {u8[len] = data.charCodeAt(len);}return ab;},getBlob=function getBlob(){return new Blob([getArrayBuffer()],{type:"application/pdf"});}, /**
	     * Generates the PDF document.
	     *
	     * If `type` argument is undefined, output is raw body of resulting PDF returned as a string.
	     *
	     * @param {String} type A string identifying one of the possible output types.
	     * @param {Object} options An object providing some additional signalling to PDF generator.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name output
	     */_output=SAFE(function(type,options){var datauri=('' + type).substr(0,6) === 'dataur'?'data:application/pdf;base64,' + btoa(buildDocument()):0;switch(type){case undefined:return buildDocument();case 'save':if(navigator.getUserMedia){if(global.URL === undefined || global.URL.createObjectURL === undefined){return API.output('dataurlnewwindow');}}saveAs(getBlob(),options);if(typeof saveAs.unload === 'function'){if(global.setTimeout){setTimeout(saveAs.unload,911);}}break;case 'arraybuffer':return getArrayBuffer();case 'blob':return getBlob();case 'bloburi':case 'bloburl': // User is responsible of calling revokeObjectURL
	return global.URL && global.URL.createObjectURL(getBlob()) || void 0;case 'datauristring':case 'dataurlstring':return datauri;case 'dataurlnewwindow':var nW=global.open(datauri);if(nW || typeof safari === "undefined")return nW; /* pass through */case 'datauri':case 'dataurl':return global.document.location.href = datauri;default:throw new Error('Output type "' + type + '" is not supported.');} // @TODO: Add different output options
	});switch(unit){case 'pt':k = 1;break;case 'mm':k = 72 / 25.4000508;break;case 'cm':k = 72 / 2.54000508;break;case 'in':k = 72;break;case 'px':k = 96 / 72;break;case 'pc':k = 12;break;case 'em':k = 12;break;case 'ex':k = 6;break;default:throw 'Invalid unit: ' + unit;} //---------------------------------------
	// Public API
	/**
	     * Object exposing internal API to plugins
	     * @public
	     */API.internal = {'pdfEscape':pdfEscape,'getStyle':getStyle, /**
	       * Returns {FontObject} describing a particular font.
	       * @public
	       * @function
	       * @param fontName {String} (Optional) Font's family name
	       * @param fontStyle {String} (Optional) Font's style variation name (Example:"Italic")
	       * @returns {FontObject}
	       */'getFont':function getFont(){return fonts[_getFont.apply(API,arguments)];},'getFontSize':function getFontSize(){return activeFontSize;},'getLineHeight':function getLineHeight(){return activeFontSize * lineHeightProportion;},'write':function write(string1 /*, string2, string3, etc */){out(arguments.length === 1?string1:Array.prototype.join.call(arguments,' '));},'getCoordinateString':function getCoordinateString(value){return f2(value * k);},'getVerticalCoordinateString':function getVerticalCoordinateString(value){return f2((pageHeight - value) * k);},'collections':{},'newObject':newObject,'newAdditionalObject':newAdditionalObject,'newObjectDeferred':newObjectDeferred,'newObjectDeferredBegin':newObjectDeferredBegin,'putStream':putStream,'events':events, // ratio that you use in multiplication of a given "size" number to arrive to 'point'
	// units of measurement.
	// scaleFactor is set at initialization of the document and calculated against the stated
	// default measurement units for the document.
	// If default is "mm", k is the number that will turn number in 'mm' into 'points' number.
	// through multiplication.
	'scaleFactor':k,'pageSize':Object.defineProperties({},{width:{get:function get(){return pageWidth;},configurable:true,enumerable:true},height:{get:function get(){return pageHeight;},configurable:true,enumerable:true}}),'output':function output(type,options){return _output(type,options);},'getNumberOfPages':function getNumberOfPages(){return pages.length - 1;},'pages':pages,'out':out,'f2':f2,'getPageInfo':function getPageInfo(pageNumberOneBased){var objId=(pageNumberOneBased - 1) * 2 + 3;return {objId:objId,pageNumber:pageNumberOneBased,pageContext:pagesContext[pageNumberOneBased]};},'getCurrentPageInfo':function getCurrentPageInfo(){var objId=(currentPage - 1) * 2 + 3;return {objId:objId,pageNumber:currentPage,pageContext:pagesContext[currentPage]};},'getPDFVersion':function getPDFVersion(){return pdfVersion;}}; /**
	     * Adds (and transfers the focus to) new page to the PDF document.
	     * @function
	     * @returns {jsPDF}
	     *
	     * @methodOf jsPDF#
	     * @name addPage
	     */API.addPage = function(){_addPage.apply(this,arguments);return this;}; /**
	     * Adds (and transfers the focus to) new page to the PDF document.
	     * @function
	     * @returns {jsPDF}
	     *
	     * @methodOf jsPDF#
	     * @name setPage
	     * @param {Number} page Switch the active page to the page number specified
	     * @example
	     * doc = jsPDF()
	     * doc.addPage()
	     * doc.addPage()
	     * doc.text('I am on page 3')
	     * doc.setPage(1)
	     * doc.text('I am on page 1')
	     */API.setPage = function(){_setPage.apply(this,arguments);return this;};API.insertPage = function(beforePage){this.addPage();this.movePage(currentPage,beforePage);return this;};API.movePage = function(targetPage,beforePage){if(targetPage > beforePage){var tmpPages=pages[targetPage];var tmpPagedim=pagedim[targetPage];var tmpPagesContext=pagesContext[targetPage];for(var i=targetPage;i > beforePage;i--) {pages[i] = pages[i - 1];pagedim[i] = pagedim[i - 1];pagesContext[i] = pagesContext[i - 1];}pages[beforePage] = tmpPages;pagedim[beforePage] = tmpPagedim;pagesContext[beforePage] = tmpPagesContext;this.setPage(beforePage);}else if(targetPage < beforePage){var tmpPages=pages[targetPage];var tmpPagedim=pagedim[targetPage];var tmpPagesContext=pagesContext[targetPage];for(var i=targetPage;i < beforePage;i++) {pages[i] = pages[i + 1];pagedim[i] = pagedim[i + 1];pagesContext[i] = pagesContext[i + 1];}pages[beforePage] = tmpPages;pagedim[beforePage] = tmpPagedim;pagesContext[beforePage] = tmpPagesContext;this.setPage(beforePage);}return this;};API.deletePage = function(){_deletePage.apply(this,arguments);return this;};API.setDisplayMode = function(zoom,layout,pmode){zoomMode = zoom;layoutMode = layout;pageMode = pmode;return this;}, /**
	     * Adds text to page. Supports adding multiline text when 'text' argument is an Array of Strings.
	     *
	     * @function
	     * @param {String|Array} text String or array of strings to be added to the page. Each line is shifted one line down per font, spacing settings declared before this call.
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Object} flags Collection of settings signalling how the text must be encoded. Defaults are sane. If you think you want to pass some flags, you likely can read the source.
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name text
	     */API.text = function(text,x,y,flags,angle,align){ /**
	       * Inserts something like this into PDF
	       *   BT
	       *    /F1 16 Tf  % Font name + size
	       *    16 TL % How many units down for next line in multiline text
	       *    0 g % color
	       *    28.35 813.54 Td % position
	       *    (line one) Tj
	       *    T* (line two) Tj
	       *    T* (line three) Tj
	       *   ET
	       */function ESC(s){s = s.split("\t").join(Array(options.TabLen || 9).join(" "));return pdfEscape(s,flags);} // Pre-August-2012 the order of arguments was function(x, y, text, flags)
	// in effort to make all calls have similar signature like
	//   function(data, coordinates... , miscellaneous)
	// this method had its args flipped.
	// code below allows backward compatibility with old arg order.
	if(typeof text === 'number'){tmp = y;y = x;x = text;text = tmp;} // If there are any newlines in text, we assume
	// the user wanted to print multiple lines, so break the
	// text up into an array.  If the text is already an array,
	// we assume the user knows what they are doing.
	// Convert text into an array anyway to simplify
	// later code.
	if(typeof text === 'string'){if(text.match(/[\n\r]/)){text = text.split(/\r\n|\r|\n/g);}else {text = [text];}}if(typeof angle === 'string'){align = angle;angle = null;}if(typeof flags === 'string'){align = flags;flags = null;}if(typeof flags === 'number'){angle = flags;flags = null;}var xtra='',mode='Td',todo;if(angle){angle *= Math.PI / 180;var c=Math.cos(angle),s=Math.sin(angle);xtra = [f2(c),f2(s),f2(s * -1),f2(c),''].join(" ");mode = 'Tm';}flags = flags || {};if(!('noBOM' in flags))flags.noBOM = true;if(!('autoencode' in flags))flags.autoencode = true;var strokeOption='';var pageContext=this.internal.getCurrentPageInfo().pageContext;if(true === flags.stroke){if(pageContext.lastTextWasStroke !== true){strokeOption = '1 Tr\n';pageContext.lastTextWasStroke = true;}}else {if(pageContext.lastTextWasStroke){strokeOption = '0 Tr\n';}pageContext.lastTextWasStroke = false;}if(typeof this._runningPageHeight === 'undefined'){this._runningPageHeight = 0;}if(typeof text === 'string'){text = ESC(text);}else if(Object.prototype.toString.call(text) === '[object Array]'){ // we don't want to destroy  original text array, so cloning it
	var sa=text.concat(),da=[],len=sa.length; // we do array.join('text that must not be PDFescaped")
	// thus, pdfEscape each component separately
	while(len--) {da.push(ESC(sa.shift()));}var linesLeft=Math.ceil((pageHeight - y - this._runningPageHeight) * k / (activeFontSize * lineHeightProportion));if(0 <= linesLeft && linesLeft < da.length + 1){ //todo = da.splice(linesLeft-1);
	}if(align){var left,prevX,maxLineLength,leading=activeFontSize * lineHeightProportion,lineWidths=text.map(function(v){return this.getStringUnitWidth(v) * activeFontSize / k;},this);maxLineLength = Math.max.apply(Math,lineWidths); // The first line uses the "main" Td setting,
	// and the subsequent lines are offset by the
	// previous line's x coordinate.
	if(align === "center"){ // The passed in x coordinate defines
	// the center point.
	left = x - maxLineLength / 2;x -= lineWidths[0] / 2;}else if(align === "right"){ // The passed in x coordinate defines the
	// rightmost point of the text.
	left = x - maxLineLength;x -= lineWidths[0];}else {throw new Error('Unrecognized alignment option, use "center" or "right".');}prevX = x;text = da[0];for(var i=1,len=da.length;i < len;i++) {var delta=maxLineLength - lineWidths[i];if(align === "center")delta /= 2; // T* = x-offset leading Td ( text )
	text += ") Tj\n" + (left - prevX + delta) + " -" + leading + " Td (" + da[i];prevX = left + delta;}}else {text = da.join(") Tj\nT* (");}}else {throw new Error('Type of text must be string or Array. "' + text + '" is not recognized.');} // Using "'" ("go next line and render text" mark) would save space but would complicate our rendering code, templates
	// BT .. ET does NOT have default settings for Tf. You must state that explicitely every time for BT .. ET
	// if you want text transformation matrix (+ multiline) to work reliably (which reads sizes of things from font declarations)
	// Thus, there is NO useful, *reliable* concept of "default" font for a page.
	// The fact that "default" (reuse font used before) font worked before in basic cases is an accident
	// - readers dealing smartly with brokenness of jsPDF's markup.
	var curY;if(todo){ //this.addPage();
	//this._runningPageHeight += y -  (activeFontSize * 1.7 / k);
	//curY = f2(pageHeight - activeFontSize * 1.7 /k);
	}else {curY = f2((pageHeight - y) * k);} //curY = f2((pageHeight - (y - this._runningPageHeight)) * k);
	//			if (curY < 0){
	//				console.log('auto page break');
	//				this.addPage();
	//				this._runningPageHeight = y -  (activeFontSize * 1.7 / k);
	//				curY = f2(pageHeight - activeFontSize * 1.7 /k);
	//			}
	out('BT\n/' + activeFontKey + ' ' + activeFontSize + ' Tf\n' +  // font face, style, size
	activeFontSize * lineHeightProportion + ' TL\n' +  // line spacing
	strokeOption +  // stroke option
	textColor + '\n' + xtra + f2(x * k) + ' ' + curY + ' ' + mode + '\n(' + text + ') Tj\nET');if(todo){ //this.text( todo, x, activeFontSize * 1.7 / k);
	//this.text( todo, x, this._runningPageHeight + (activeFontSize * 1.7 / k));
	this.text(todo,x,y); // + (activeFontSize * 1.7 / k));
	}return this;};API.lstext = function(text,x,y,spacing){for(var i=0,len=text.length;i < len;i++,x += spacing) {this.text(text[i],x,y);}};API.line = function(x1,y1,x2,y2){return this.lines([[x2 - x1,y2 - y1]],x1,y1);};API.clip = function(){ // By patrick-roberts, github.com/MrRio/jsPDF/issues/328
	// Call .clip() after calling .rect() with a style argument of null
	out('W'); // clip
	out('S'); // stroke path; necessary for clip to work
	}; /**
	     * This fixes the previous function clip(). Perhaps the 'stroke path' hack was due to the missing 'n' instruction?
	     * We introduce the fixed version so as to not break API.
	     * @param fillRule
	     */API.clip_fixed = function(fillRule){ // Call .clip() after calling drawing ops with a style argument of null
	// W is the PDF clipping op
	if('evenodd' === fillRule){out('W*');}else {out('W');} // End the path object without filling or stroking it.
	// This operator is a path-painting no-op, used primarily for the side effect of changing the current clipping path
	// (see Section 4.4.3, “Clipping Path Operators”)
	out('n');}; /**
	     * Adds series of curves (straight lines or cubic bezier curves) to canvas, starting at `x`, `y` coordinates.
	     * All data points in `lines` are relative to last line origin.
	     * `x`, `y` become x1,y1 for first line / curve in the set.
	     * For lines you only need to specify [x2, y2] - (ending point) vector against x1, y1 starting point.
	     * For bezier curves you need to specify [x2,y2,x3,y3,x4,y4] - vectors to control points 1, 2, ending point. All vectors are against the start of the curve - x1,y1.
	     *
	     * @example .lines([[2,2],[-2,2],[1,1,2,2,3,3],[2,1]], 212,110, 10) // line, line, bezier curve, line
	     * @param {Array} lines Array of *vector* shifts as pairs (lines) or sextets (cubic bezier curves).
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} scale (Defaults to [1.0,1.0]) x,y Scaling factor for all vectors. Elements can be any floating number Sub-one makes drawing smaller. Over-one grows the drawing. Negative flips the direction.
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @param {Boolean} closed If true, the path is closed with a straight line from the end of the last curve to the starting point.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name lines
	     */API.lines = function(lines,x,y,scale,style,closed){var scalex,scaley,i,l,leg,x2,y2,x3,y3,x4,y4; // Pre-August-2012 the order of arguments was function(x, y, lines, scale, style)
	// in effort to make all calls have similar signature like
	//   function(content, coordinateX, coordinateY , miscellaneous)
	// this method had its args flipped.
	// code below allows backward compatibility with old arg order.
	if(typeof lines === 'number'){tmp = y;y = x;x = lines;lines = tmp;}scale = scale || [1,1]; // starting point
	out(f3(x * k) + ' ' + f3((pageHeight - y) * k) + ' m ');scalex = scale[0];scaley = scale[1];l = lines.length; //, x2, y2 // bezier only. In page default measurement "units", *after* scaling
	//, x3, y3 // bezier only. In page default measurement "units", *after* scaling
	// ending point for all, lines and bezier. . In page default measurement "units", *after* scaling
	x4 = x; // last / ending point = starting point for first item.
	y4 = y; // last / ending point = starting point for first item.
	for(i = 0;i < l;i++) {leg = lines[i];if(leg.length === 2){ // simple line
	x4 = leg[0] * scalex + x4; // here last x4 was prior ending point
	y4 = leg[1] * scaley + y4; // here last y4 was prior ending point
	out(f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' l');}else { // bezier curve
	x2 = leg[0] * scalex + x4; // here last x4 is prior ending point
	y2 = leg[1] * scaley + y4; // here last y4 is prior ending point
	x3 = leg[2] * scalex + x4; // here last x4 is prior ending point
	y3 = leg[3] * scaley + y4; // here last y4 is prior ending point
	x4 = leg[4] * scalex + x4; // here last x4 was prior ending point
	y4 = leg[5] * scaley + y4; // here last y4 was prior ending point
	out(f3(x2 * k) + ' ' + f3((pageHeight - y2) * k) + ' ' + f3(x3 * k) + ' ' + f3((pageHeight - y3) * k) + ' ' + f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' c');}}if(closed){out(' h');} // stroking / filling / both the path
	if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds a rectangle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name rect
	     */API.rect = function(x,y,w,h,style){var op=getStyle(style);out([f2(x * k),f2((pageHeight - y) * k),f2(w * k),f2(-h * k),'re'].join(' '));if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds a triangle to PDF
	     *
	     * @param {Number} x1 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y1 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x2 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y2 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x3 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y3 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name triangle
	     */API.triangle = function(x1,y1,x2,y2,x3,y3,style){this.lines([[x2 - x1,y2 - y1], // vector to point 2
	[x3 - x2,y3 - y2], // vector to point 3
	[x1 - x3,y1 - y3] // closing vector back to point 1
	],x1,y1, // start of path
	[1,1],style,true);return this;}; /**
	     * Adds a rectangle with rounded corners to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name roundedRect
	     */API.roundedRect = function(x,y,w,h,rx,ry,style){var MyArc=4 / 3 * (Math.SQRT2 - 1);this.lines([[w - 2 * rx,0],[rx * MyArc,0,rx,ry - ry * MyArc,rx,ry],[0,h - 2 * ry],[0,ry * MyArc,-(rx * MyArc),ry,-rx,ry],[-w + 2 * rx,0],[-(rx * MyArc),0,-rx,-(ry * MyArc),-rx,-ry],[0,-h + 2 * ry],[0,-(ry * MyArc),rx * MyArc,-ry,rx,-ry]],x + rx,y, // start of path
	[1,1],style);return this;}; /**
	     * Adds an ellipse to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name ellipse
	     */API.ellipse = function(x,y,rx,ry,style){var lx=4 / 3 * (Math.SQRT2 - 1) * rx,ly=4 / 3 * (Math.SQRT2 - 1) * ry;out([f2((x + rx) * k),f2((pageHeight - y) * k),'m',f2((x + rx) * k),f2((pageHeight - (y - ly)) * k),f2((x + lx) * k),f2((pageHeight - (y - ry)) * k),f2(x * k),f2((pageHeight - (y - ry)) * k),'c'].join(' '));out([f2((x - lx) * k),f2((pageHeight - (y - ry)) * k),f2((x - rx) * k),f2((pageHeight - (y - ly)) * k),f2((x - rx) * k),f2((pageHeight - y) * k),'c'].join(' '));out([f2((x - rx) * k),f2((pageHeight - (y + ly)) * k),f2((x - lx) * k),f2((pageHeight - (y + ry)) * k),f2(x * k),f2((pageHeight - (y + ry)) * k),'c'].join(' '));out([f2((x + lx) * k),f2((pageHeight - (y + ry)) * k),f2((x + rx) * k),f2((pageHeight - (y + ly)) * k),f2((x + rx) * k),f2((pageHeight - y) * k),'c'].join(' '));if(style !== null){out(getStyle(style));}return this;}; /**
	     * Adds an circle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} r Radius (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name circle
	     */API.circle = function(x,y,r,style){return this.ellipse(x,y,r,r,style);}; /**
	     * Adds a properties to the PDF document
	     *
	     * @param {Object} A property_name-to-property_value object structure.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setProperties
	     */API.setProperties = function(properties){ // copying only those properties we can render.
	for(var property in documentProperties) {if(documentProperties.hasOwnProperty(property) && properties[property]){documentProperties[property] = properties[property];}}return this;}; /**
	     * Sets font size for upcoming text elements.
	     *
	     * @param {Number} size Font size in points.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontSize
	     */API.setFontSize = function(size){activeFontSize = size;return this;}; /**
	     * Sets text font face, variant for upcoming text elements.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} fontName Font name or family. Example: "times"
	     * @param {String} fontStyle Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFont
	     */API.setFont = function(fontName,fontStyle){activeFontKey = _getFont(fontName,fontStyle); // if font is not found, the above line blows up and we never go further
	return this;}; /**
	     * Switches font style or variant for upcoming text elements,
	     * while keeping the font face or family same.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} style Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontStyle
	     */API.setFontStyle = API.setFontType = function(style){activeFontKey = _getFont(undefined,style); // if font is not found, the above line blows up and we never go further
	return this;}; /**
	     * Returns an object - a tree of fontName to fontStyle relationships available to
	     * active PDF document.
	     *
	     * @public
	     * @function
	     * @returns {Object} Like {'times':['normal', 'italic', ... ], 'arial':['normal', 'bold', ... ], ... }
	     * @methodOf jsPDF#
	     * @name getFontList
	     */API.getFontList = function(){ // TODO: iterate over fonts array or return copy of fontmap instead in case more are ever added.
	var list={},fontName,fontStyle,tmp;for(fontName in fontmap) {if(fontmap.hasOwnProperty(fontName)){list[fontName] = tmp = [];for(fontStyle in fontmap[fontName]) {if(fontmap[fontName].hasOwnProperty(fontStyle)){tmp.push(fontStyle);}}}}return list;}; /**
	     * Add a custom font.
	     *
	     * @param {String} Postscript name of the Font.  Example: "Menlo-Regular"
	     * @param {String} Name of font-family from @font-face definition.  Example: "Menlo Regular"
	     * @param {String} Font style.  Example: "normal"
	     * @function
	     * @returns the {fontKey} (same as the internal method)
	     * @methodOf jsPDF#
	     * @name addFont
	     */API.addFont = function(postScriptName,fontName,fontStyle){addFont(postScriptName,fontName,fontStyle,'StandardEncoding');}; /**
	     * Sets line width for upcoming lines.
	     *
	     * @param {Number} width Line width (in units declared at inception of PDF document)
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineWidth
	     */API.setLineWidth = function(width){out((width * k).toFixed(2) + ' w');return this;}; /**
	     * Sets the stroke color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setDrawColor
	     */API.setDrawColor = function(ch1,ch2,ch3,ch4){var color;if(ch2 === undefined || ch4 === undefined && ch1 === ch2 === ch3){ // Gray color space.
	if(typeof ch1 === 'string'){color = ch1 + ' G';}else {color = f2(ch1 / 255) + ' G';}}else if(ch4 === undefined){ // RGB
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,'RG'].join(' ');}else {color = [f2(ch1 / 255),f2(ch2 / 255),f2(ch3 / 255),'RG'].join(' ');}}else { // CMYK
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,ch4,'K'].join(' ');}else {color = [f2(ch1),f2(ch2),f2(ch3),f2(ch4),'K'].join(' ');}}out(color);return this;}; /**
	     * Sets the fill color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFillColor
	     */API.setFillColor = function(ch1,ch2,ch3,ch4){var color;if(ch2 === undefined || ch4 === undefined && ch1 === ch2 === ch3){ // Gray color space.
	if(typeof ch1 === 'string'){color = ch1 + ' g';}else {color = f2(ch1 / 255) + ' g';}}else if(ch4 === undefined || (typeof ch4 === 'undefined'?'undefined':_typeof(ch4)) === 'object'){ // RGB
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,'rg'].join(' ');}else {color = [f2(ch1 / 255),f2(ch2 / 255),f2(ch3 / 255),'rg'].join(' ');}if(ch4 && ch4.a === 0){ //TODO Implement transparency.
	//WORKAROUND use white for now
	color = ['255','255','255','rg'].join(' ');}}else { // CMYK
	if(typeof ch1 === 'string'){color = [ch1,ch2,ch3,ch4,'k'].join(' ');}else {color = [f2(ch1),f2(ch2),f2(ch3),f2(ch4),'k'].join(' ');}}out(color);return this;}; /**
	     * Sets the text color for upcoming elements.
	     * If only one, first argument is given,
	     * treats the value as gray-scale color value.
	     *
	     * @param {Number} r Red channel color value in range 0-255 or {String} r color value in hexadecimal, example: '#FFFFFF'
	     * @param {Number} g Green channel color value in range 0-255
	     * @param {Number} b Blue channel color value in range 0-255
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setTextColor
	     */API.setTextColor = function(r,g,b){if(typeof r === 'string' && /^#[0-9A-Fa-f]{6}$/.test(r)){var hex=parseInt(r.substr(1),16);r = hex >> 16 & 255;g = hex >> 8 & 255;b = hex & 255;}if(r === 0 && g === 0 && b === 0 || typeof g === 'undefined'){textColor = f3(r / 255) + ' g';}else {textColor = [f3(r / 255),f3(g / 255),f3(b / 255),'rg'].join(' ');}return this;}; /**
	     * Is an Object providing a mapping from human-readable to
	     * integer flag values designating the varieties of line cap
	     * and join styles.
	     *
	     * @returns {Object}
	     * @fieldOf jsPDF#
	     * @name CapJoinStyles
	     */API.CapJoinStyles = {0:0,'butt':0,'but':0,'miter':0,1:1,'round':1,'rounded':1,'circle':1,2:2,'projecting':2,'project':2,'square':2,'bevel':2}; /**
	     * Sets the line cap styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line cap
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineCap
	     */API.setLineCap = function(style){var id=this.CapJoinStyles[style];if(id === undefined){throw new Error("Line cap style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");}lineCapID = id;out(id + ' J');return this;}; /**
	     * Sets the line join styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line join
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineJoin
	     */API.setLineJoin = function(style){var id=this.CapJoinStyles[style];if(id === undefined){throw new Error("Line join style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");}lineJoinID = id;out(id + ' j');return this;}; // Output is both an internal (for plugins) and external function
	API.output = _output; /**
	     * Saves as PDF document. An alias of jsPDF.output('save', 'filename.pdf')
	     * @param  {String} filename The filename including extension.
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name save
	     */API.save = function(filename){API.output('save',filename);}; // applying plugins (more methods) ON TOP of built-in API.
	// this is intentional as we allow plugins to override
	// built-ins
	for(var plugin in jsPDF.API) {if(jsPDF.API.hasOwnProperty(plugin)){if(plugin === 'events' && jsPDF.API.events.length){(function(events,newEvents){ // jsPDF.API.events is a JS Array of Arrays
	// where each Array is a pair of event name, handler
	// Events were added by plugins to the jsPDF instantiator.
	// These are always added to the new instance and some ran
	// during instantiation.
	var eventname,handler_and_args,i;for(i = newEvents.length - 1;i !== -1;i--) { // subscribe takes 3 args: 'topic', function, runonce_flag
	// if undefined, runonce is false.
	// users can attach callback directly,
	// or they can attach an array with [callback, runonce_flag]
	// that's what the "apply" magic is for below.
	eventname = newEvents[i][0];handler_and_args = newEvents[i][1];events.subscribe.apply(events,[eventname].concat(typeof handler_and_args === 'function'?[handler_and_args]:handler_and_args));}})(events,jsPDF.API.events);}else {API[plugin] = jsPDF.API[plugin];}}} //////////////////////////////////////////////////////
	// continuing initialization of jsPDF Document object
	//////////////////////////////////////////////////////
	// Add the first page automatically
	addFonts();activeFontKey = 'F1';_addPage(format,orientation);events.publish('initialized');return API;} /**
	   * jsPDF.API is a STATIC property of jsPDF class.
	   * jsPDF.API is an object you can add methods and properties to.
	   * The methods / properties you add will show up in new jsPDF objects.
	   *
	   * One property is prepopulated. It is the 'events' Object. Plugin authors can add topics,
	   * callbacks to this object. These will be reassigned to all new instances of jsPDF.
	   * Examples:
	   * jsPDF.API.events['initialized'] = function(){ 'this' is API object }
	   * jsPDF.API.events['addFont'] = function(added_font_object){ 'this' is API object }
	   *
	   * @static
	   * @public
	   * @memberOf jsPDF
	   * @name API
	   *
	   * @example
	   * jsPDF.API.mymethod = function(){
	   *   // 'this' will be ref to internal API object. see jsPDF source
	   *   // , so you can refer to built-in methods like so:
	   *   //     this.line(....)
	   *   //     this.text(....)
	   * }
	   * var pdfdoc = new jsPDF()
	   * pdfdoc.mymethod() // <- !!!!!!
	   */jsPDF.API = {events:[]};jsPDF.version = "1.x-master";if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return jsPDF;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else if(typeof module !== 'undefined' && module.exports){module.exports = jsPDF;}else {global.jsPDF = jsPDF;}return jsPDF;})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined); /**
	 * jsPDF AcroForm Plugin
	 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(window.AcroForm = function(jsPDFAPI){'use strict';var AcroForm=window.AcroForm;AcroForm.scale = function(x){return x * (acroformPlugin.internal.scaleFactor / 1); // 1 = (96 / 72)
	};AcroForm.antiScale = function(x){return 1 / acroformPlugin.internal.scaleFactor * x;};var acroformPlugin={fields:[],xForms:[], /**
	         * acroFormDictionaryRoot contains information about the AcroForm Dictionary
	         * 0: The Event-Token, the AcroFormDictionaryCallback has
	         * 1: The Object ID of the Root
	         */acroFormDictionaryRoot:null, /**
	         * After the PDF gets evaluated, the reference to the root has to be reset,
	         * this indicates, whether the root has already been printed out
	         */printedOut:false,internal:null};jsPDF.API.acroformPlugin = acroformPlugin;var annotReferenceCallback=function annotReferenceCallback(){for(var i in this.acroformPlugin.acroFormDictionaryRoot.Fields) {var formObject=this.acroformPlugin.acroFormDictionaryRoot.Fields[i]; // add Annot Reference!
	if(formObject.hasAnnotation){ // If theres an Annotation Widget in the Form Object, put the Reference in the /Annot array
	createAnnotationReference.call(this,formObject);}}};var createAcroForm=function createAcroForm(){if(this.acroformPlugin.acroFormDictionaryRoot){ //return;
	throw new Error("Exception while creating AcroformDictionary");} // The Object Number of the AcroForm Dictionary
	this.acroformPlugin.acroFormDictionaryRoot = new AcroForm.AcroFormDictionary();this.acroformPlugin.internal = this.internal; // add Callback for creating the AcroForm Dictionary
	this.acroformPlugin.acroFormDictionaryRoot._eventID = this.internal.events.subscribe('postPutResources',AcroFormDictionaryCallback);this.internal.events.subscribe('buildDocument',annotReferenceCallback); //buildDocument
	// Register event, that is triggered when the DocumentCatalog is written, in order to add /AcroForm
	this.internal.events.subscribe('putCatalog',putCatalogCallback); // Register event, that creates all Fields
	this.internal.events.subscribe('postPutPages',createFieldCallback);}; /**
	     * Create the Reference to the widgetAnnotation, so that it gets referenced in the Annot[] int the+
	     * (Requires the Annotation Plugin)
	     */var createAnnotationReference=function createAnnotationReference(object){var options={type:'reference',object:object};jsPDF.API.annotationPlugin.annotations[this.internal.getPageInfo(object.page).pageNumber].push(options);};var putForm=function putForm(formObject){if(this.acroformPlugin.printedOut){this.acroformPlugin.printedOut = false;this.acroformPlugin.acroFormDictionaryRoot = null;}if(!this.acroformPlugin.acroFormDictionaryRoot){createAcroForm.call(this);}this.acroformPlugin.acroFormDictionaryRoot.Fields.push(formObject);}; // Callbacks
	var putCatalogCallback=function putCatalogCallback(){ //Put reference to AcroForm to DocumentCatalog
	if(typeof this.acroformPlugin.acroFormDictionaryRoot != 'undefined'){ // for safety, shouldn't normally be the case
	this.internal.write('/AcroForm ' + this.acroformPlugin.acroFormDictionaryRoot.objId + ' ' + 0 + ' R');}else {console.log('Root missing...');}}; /**
	     * Adds /Acroform X 0 R to Document Catalog,
	     * and creates the AcroForm Dictionary
	     */var AcroFormDictionaryCallback=function AcroFormDictionaryCallback(){ // Remove event
	this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID);delete this.acroformPlugin.acroFormDictionaryRoot._eventID;this.acroformPlugin.printedOut = true;}; /**
	     * Creates the single Fields and writes them into the Document
	     *
	     * If fieldArray is set, use the fields that are inside it instead of the fields from the AcroRoot
	     * (for the FormXObjects...)
	     */var createFieldCallback=function createFieldCallback(fieldArray){var standardFields=!fieldArray;if(!fieldArray){ // in case there is no fieldArray specified, we want to print out the Fields of the AcroForm
	// Print out Root
	this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId);this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString());}var fieldArray=fieldArray || this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var i in fieldArray) {var key=i;var form=fieldArray[i];var oldRect=form.Rect;if(form.Rect){form.Rect = AcroForm.internal.calculateCoordinates.call(this,form.Rect);} // Start Writing the Object
	this.internal.newObjectDeferredBegin(form.objId);var content="";content += form.objId + " 0 obj\n";content += "<<\n" + form.getContent();form.Rect = oldRect;if(form.hasAppearanceStream && !form.appearanceStreamContent){ // Calculate Appearance
	var appearance=AcroForm.internal.calculateAppearanceStream.call(this,form);content += "/AP << /N " + appearance + " >>\n";this.acroformPlugin.xForms.push(appearance);} // Assume AppearanceStreamContent is a Array with N,R,D (at least one of them!)
	if(form.appearanceStreamContent){content += "/AP << "; // Iterate over N,R and D
	for(var k in form.appearanceStreamContent) {var value=form.appearanceStreamContent[k];content += "/" + k + " ";content += "<< ";if(Object.keys(value).length >= 1 || Array.isArray(value)){ // appearanceStream is an Array or Object!
	for(var i in value) {var obj=value[i];if(typeof obj === 'function'){ // if Function is referenced, call it in order to get the FormXObject
	obj = obj.call(this,form);}content += "/" + i + " " + obj + " "; // In case the XForm is already used, e.g. OffState of CheckBoxes, don't add it
	if(!(this.acroformPlugin.xForms.indexOf(obj) >= 0))this.acroformPlugin.xForms.push(obj);}}else {var obj=value;if(typeof obj === 'function'){ // if Function is referenced, call it in order to get the FormXObject
	obj = obj.call(this,form);}content += "/" + i + " " + obj + " \n";if(!(this.acroformPlugin.xForms.indexOf(obj) >= 0))this.acroformPlugin.xForms.push(obj);}content += " >>\n";} // appearance stream is a normal Object..
	content += ">>\n";}content += ">>\nendobj\n";this.internal.out(content);}if(standardFields){createXFormObjectCallback.call(this,this.acroformPlugin.xForms);}};var createXFormObjectCallback=function createXFormObjectCallback(fieldArray){for(var i in fieldArray) {var key=i;var form=fieldArray[i]; // Start Writing the Object
	this.internal.newObjectDeferredBegin(form && form.objId);var content="";content += form?form.getString():'';this.internal.out(content);delete fieldArray[key];}}; // Public:
	jsPDFAPI.addField = function(fieldObject){ //var opt = parseOptions(fieldObject);
	if(fieldObject instanceof AcroForm.TextField){addTextField.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.ChoiceField){addChoiceField.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.Button){addButton.call(this,fieldObject);}else if(fieldObject instanceof AcroForm.ChildClass){putForm.call(this,fieldObject);}else if(fieldObject){ // try to put..
	putForm.call(this,fieldObject);}fieldObject.page = this.acroformPlugin.internal.getCurrentPageInfo().pageNumber;return this;}; // ############### sort in:
	/**
	     * Button
	     * FT = Btn
	     */var addButton=function addButton(options){var options=options || new AcroForm.Field();options.FT = '/Btn'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 17, Pushbutton
	if(options.pushbutton){ // Options.pushbutton should be 1 or 0
	flags = AcroForm.internal.setBitPosition(flags,17);delete options.pushbutton;} //16, Radio
	if(options.radio){ //flags = options.Ff | options.radio << 15;
	flags = AcroForm.internal.setBitPosition(flags,16);delete options.radio;} // 15, NoToggleToOff (Radio buttons only
	if(options.noToggleToOff){ //flags = options.Ff | options.noToggleToOff << 14;
	flags = AcroForm.internal.setBitPosition(flags,15); //delete options.noToggleToOff;
	} // In case, there is no Flag set, it is a check-box
	options.Ff = flags;putForm.call(this,options);};var addTextField=function addTextField(options){var options=options || new AcroForm.Field();options.FT = '/Tx'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 13, multiline
	if(options.multiline){ // Set Flag
	flags = flags | 1 << 12; // Remove multiline from FieldObject
	//delete options.multiline;
	} // 14, Password
	if(options.password){flags = flags | 1 << 13; //delete options.password;
	} // 21, FileSelect, PDF 1.4...
	if(options.fileSelect){flags = flags | 1 << 20; //delete options.fileSelect;
	} // 23, DoNotSpellCheck, PDF 1.4...
	if(options.doNotSpellCheck){flags = flags | 1 << 22; //delete options.doNotSpellCheck;
	} // 24, DoNotScroll, PDF 1.4...
	if(options.doNotScroll){flags = flags | 1 << 23; //delete options.doNotScroll;
	}options.Ff = options.Ff || flags; // Add field
	putForm.call(this,options);};var addChoiceField=function addChoiceField(opt){var options=opt || new AcroForm.Field();options.FT = '/Ch'; /**
	         * Calculating the Ff entry:
	         *
	         * The Ff entry contains flags, that have to be set bitwise
	         * In the Following the number in the Comment is the BitPosition
	         */var flags=options.Ff || 0; // 18, Combo (If not set, the choiceField is a listBox!!)
	if(options.combo){ // Set Flag
	flags = AcroForm.internal.setBitPosition(flags,18); // Remove combo from FieldObject
	delete options.combo;} // 19, Edit
	if(options.edit){flags = AcroForm.internal.setBitPosition(flags,19);delete options.edit;} // 20, Sort
	if(options.sort){flags = AcroForm.internal.setBitPosition(flags,20);delete options.sort;} // 22, MultiSelect (PDF 1.4)
	if(options.multiSelect && this.internal.getPDFVersion() >= 1.4){flags = AcroForm.internal.setBitPosition(flags,22);delete options.multiSelect;} // 23, DoNotSpellCheck (PDF 1.4)
	if(options.doNotSpellCheck && this.internal.getPDFVersion() >= 1.4){flags = AcroForm.internal.setBitPosition(flags,23);delete options.doNotSpellCheck;}options.Ff = flags; //options.hasAnnotation = true;
	// Add field
	putForm.call(this,options);};})(jsPDF.API);var AcroForm=window.AcroForm;AcroForm.internal = {};AcroForm.createFormXObject = function(formObject){var xobj=new AcroForm.FormXObject();var height=AcroForm.Appearance.internal.getHeight(formObject) || 0;var width=AcroForm.Appearance.internal.getWidth(formObject) || 0;xobj.BBox = [0,0,width,height];return xobj;}; // Contains Methods for creating standard appearances
	AcroForm.Appearance = {CheckBox:{createAppearanceStream:function createAppearanceStream(){var appearance={N:{On:AcroForm.Appearance.CheckBox.YesNormal},D:{On:AcroForm.Appearance.CheckBox.YesPushDown,Off:AcroForm.Appearance.CheckBox.OffPushDown}};return appearance;}, /**
	         * If any other icons are needed, the number between the brackets can be changed
	         * @returns {string}
	         */createMK:function createMK(){ // 3-> Hook
	return "<< /CA (3)>>";}, /**
	         * Returns the standard On Appearance for a CheckBox
	         * @returns {AcroForm.FormXObject}
	         */YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream=""; // F13 is ZapfDingbats (Symbolic)
	formObject.Q = 1; // set text-alignment as centered
	var calcRes=AcroForm.internal.calculateX(formObject,"3","ZapfDingbats",50);stream += "0.749023 g\n\
	             0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	             f\n\
	             BMC\n\
	             q\n\
	             0 0 1 rg\n\
	             /F13 " + calcRes.fontSize + " Tf 0 g\n\
	             BT\n";stream += calcRes.text;stream += "ET\n\
	             Q\n\
	             EMC\n";xobj.stream = stream;return xobj;},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";formObject.Q = 1; // set text-alignment as centered
	var calcRes=AcroForm.internal.calculateX(formObject,"3","ZapfDingbats",AcroForm.Appearance.internal.getHeight(formObject) * 0.9);stream += "1 g\n\
	0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	f\n\
	q\n\
	0 0 1 rg\n\
	0 0 " + (AcroForm.Appearance.internal.getWidth(formObject) - 1) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 1) + " re\n\
	W\n\
	n\n\
	0 g\n\
	BT\n\
	/F13 " + calcRes.fontSize + " Tf 0 g\n";stream += calcRes.text;stream += "ET\n\
	             Q\n";xobj.stream = stream;return xobj;}, /**
	         * Returns the standard Off Appearance for a CheckBox
	         * @returns {AcroForm.FormXObject}
	         */OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n";xobj.stream = stream;return xobj;}},RadioButton:{Circle:{createAppearanceStream:function createAppearanceStream(name){var appearanceStreamContent={D:{'Off':AcroForm.Appearance.RadioButton.Circle.OffPushDown},N:{}};appearanceStreamContent.N[name] = AcroForm.Appearance.RadioButton.Circle.YesNormal;appearanceStreamContent.D[name] = AcroForm.Appearance.RadioButton.Circle.YesPushDown;return appearanceStreamContent;},createMK:function createMK(){return "<< /CA (l)>>";},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream=""; // Make the Radius of the Circle relative to min(height, width) of formObject
	var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9;var c=AcroForm.Appearance.internal.Bezier_C; /*
	                 The Following is a Circle created with Bezier-Curves.
	                 */stream += "q\n\
	1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + DotRadius + " 0 m\n\
	" + DotRadius + " " + DotRadius * c + " " + DotRadius * c + " " + DotRadius + " 0 " + DotRadius + " c\n\
	-" + DotRadius * c + " " + DotRadius + " -" + DotRadius + " " + DotRadius * c + " -" + DotRadius + " 0 c\n\
	-" + DotRadius + " -" + DotRadius * c + " -" + DotRadius * c + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	" + DotRadius * c + " -" + DotRadius + " " + DotRadius + " -" + DotRadius * c + " " + DotRadius + " 0 c\n\
	f\n\
	Q\n";xobj.stream = stream;return xobj;},YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9; // Save results for later use; no need to waste processor ticks on doing math
	var k=DotRadius * 2; // var c = AcroForm.Appearance.internal.Bezier_C;
	var kc=k * AcroForm.Appearance.internal.Bezier_C;var dc=DotRadius * AcroForm.Appearance.internal.Bezier_C; //                 stream += "0.749023 g\n\
	//             q\n\
	//           1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius * 2 + " 0 m\n\
	// " + DotRadius * 2 + " " + DotRadius * 2 * c + " " + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 " + DotRadius * 2 + " c\n\
	// -" + DotRadius * 2 * c + " " + DotRadius * 2 + " -" + DotRadius * 2 + " " + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 c\n\
	// -" + DotRadius * 2 + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 -" + DotRadius * 2 + " c\n\
	// " + DotRadius * 2 * c + " -" + DotRadius * 2 + " " + DotRadius * 2 + " -" + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 c\n\
	//             f\n\
	//             Q\n\
	//             0 g\n\
	//             q\n\
	//             1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius + " 0 m\n\
	// " + DotRadius + " " + DotRadius * c + " " + DotRadius * c + " " + DotRadius + " 0 " + DotRadius + " c\n\
	// -" + DotRadius * c + " " + DotRadius + " -" + DotRadius + " " + DotRadius * c + " -" + DotRadius + " 0 c\n\
	// -" + DotRadius + " -" + DotRadius * c + " -" + DotRadius * c + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	// " + DotRadius * c + " -" + DotRadius + " " + DotRadius + " -" + DotRadius * c + " " + DotRadius + " 0 c\n\
	//             f\n\
	//             Q\n";
	//  FASTER VERSION with less processor ticks spent on math operations
	stream += "0.749023 g\n\
	            q\n\
	           1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + k + " 0 m\n\
	" + k + " " + kc + " " + kc + " " + k + " 0 " + k + " c\n\
	-" + kc + " " + k + " -" + k + " " + kc + " -" + k + " 0 c\n\
	-" + k + " -" + kc + " -" + kc + " -" + k + " 0 -" + k + " c\n\
	" + kc + " -" + k + " " + k + " -" + kc + " " + k + " 0 c\n\
	            f\n\
	            Q\n\
	            0 g\n\
	            q\n\
	            1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + DotRadius + " 0 m\n\
	" + DotRadius + " " + dc + " " + dc + " " + DotRadius + " 0 " + DotRadius + " c\n\
	-" + dc + " " + DotRadius + " -" + DotRadius + " " + dc + " -" + DotRadius + " 0 c\n\
	-" + DotRadius + " -" + dc + " -" + dc + " -" + DotRadius + " 0 -" + DotRadius + " c\n\
	" + dc + " -" + DotRadius + " " + DotRadius + " -" + dc + " " + DotRadius + " 0 c\n\
	            f\n\
	            Q\n";xobj.stream = stream;return xobj;},OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var DotRadius=AcroForm.Appearance.internal.getWidth(formObject) <= AcroForm.Appearance.internal.getHeight(formObject)?AcroForm.Appearance.internal.getWidth(formObject) / 4:AcroForm.Appearance.internal.getHeight(formObject) / 4; // The Borderpadding...
	DotRadius *= 0.9; // Save results for later use; no need to waste processor ticks on doing math
	var k=DotRadius * 2; // var c = AcroForm.Appearance.internal.Bezier_C;
	var kc=k * AcroForm.Appearance.internal.Bezier_C; //                 stream += "0.749023 g\n\
	//             q\n\
	//  1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	// " + DotRadius * 2 + " 0 m\n\
	// " + DotRadius * 2 + " " + DotRadius * 2 * c + " " + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 " + DotRadius * 2 + " c\n\
	// -" + DotRadius * 2 * c + " " + DotRadius * 2 + " -" + DotRadius * 2 + " " + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 c\n\
	// -" + DotRadius * 2 + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 * c + " -" + DotRadius * 2 + " 0 -" + DotRadius * 2 + " c\n\
	// " + DotRadius * 2 * c + " -" + DotRadius * 2 + " " + DotRadius * 2 + " -" + DotRadius * 2 * c + " " + DotRadius * 2 + " 0 c\n\
	//             f\n\
	//             Q\n";
	//  FASTER VERSION with less processor ticks spent on math operations
	stream += "0.749023 g\n\
	            q\n\
	 1 0 0 1 " + AcroForm.Appearance.internal.getWidth(formObject) / 2 + " " + AcroForm.Appearance.internal.getHeight(formObject) / 2 + " cm\n\
	" + k + " 0 m\n\
	" + k + " " + kc + " " + kc + " " + k + " 0 " + k + " c\n\
	-" + kc + " " + k + " -" + k + " " + kc + " -" + k + " 0 c\n\
	-" + k + " -" + kc + " -" + kc + " -" + k + " 0 -" + k + " c\n\
	" + kc + " -" + k + " " + k + " -" + kc + " " + k + " 0 c\n\
	            f\n\
	            Q\n";xobj.stream = stream;return xobj;}},Cross:{ /**
	             * Creates the Actual AppearanceDictionary-References
	             * @param name
	             * @returns
	             */createAppearanceStream:function createAppearanceStream(name){var appearanceStreamContent={D:{'Off':AcroForm.Appearance.RadioButton.Cross.OffPushDown},N:{}};appearanceStreamContent.N[name] = AcroForm.Appearance.RadioButton.Cross.YesNormal;appearanceStreamContent.D[name] = AcroForm.Appearance.RadioButton.Cross.YesPushDown;return appearanceStreamContent;},createMK:function createMK(){return "<< /CA (8)>>";},YesNormal:function YesNormal(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";var cross=AcroForm.Appearance.internal.calculateCross(formObject);stream += "q\n\
	            1 1 " + (AcroForm.Appearance.internal.getWidth(formObject) - 2) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 2) + " re\n\
	            W\n\
	            n\n\
	            " + cross.x1.x + " " + cross.x1.y + " m\n\
	            " + cross.x2.x + " " + cross.x2.y + " l\n\
	            " + cross.x4.x + " " + cross.x4.y + " m\n\
	            " + cross.x3.x + " " + cross.x3.y + " l\n\
	            s\n\
	            Q\n";xobj.stream = stream;return xobj;},YesPushDown:function YesPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var cross=AcroForm.Appearance.internal.calculateCross(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n\
	            q\n\
	            1 1 " + (AcroForm.Appearance.internal.getWidth(formObject) - 2) + " " + (AcroForm.Appearance.internal.getHeight(formObject) - 2) + " re\n\
	            W\n\
	            n\n\
	            " + cross.x1.x + " " + cross.x1.y + " m\n\
	            " + cross.x2.x + " " + cross.x2.y + " l\n\
	            " + cross.x4.x + " " + cross.x4.y + " m\n\
	            " + cross.x3.x + " " + cross.x3.y + " l\n\
	            s\n\
	            Q\n";xobj.stream = stream;return xobj;},OffPushDown:function OffPushDown(formObject){var xobj=AcroForm.createFormXObject(formObject);var stream="";stream += "0.749023 g\n\
	            0 0 " + AcroForm.Appearance.internal.getWidth(formObject) + " " + AcroForm.Appearance.internal.getHeight(formObject) + " re\n\
	            f\n";xobj.stream = stream;return xobj;}}}, /**
	     * Returns the standard Appearance
	     * @returns {AcroForm.FormXObject}
	     */createDefaultAppearanceStream:function createDefaultAppearanceStream(formObject){var stream=""; // Set Helvetica to Standard Font (size: auto)
	// Color: Black
	stream += "/Helv 0 Tf 0 g";return stream;}};AcroForm.Appearance.internal = {Bezier_C:0.551915024494,calculateCross:function calculateCross(formObject){var min=function min(x,y){return x > y?y:x;};var width=AcroForm.Appearance.internal.getWidth(formObject);var height=AcroForm.Appearance.internal.getHeight(formObject);var a=min(width,height);var crossSize=a;var borderPadding=2; // The Padding in px
	var cross={x1:{ // upperLeft
	x:(width - a) / 2,y:(height - a) / 2 + a},x2:{ // lowerRight
	x:(width - a) / 2 + a,y:(height - a) / 2 //borderPadding
	},x3:{ // lowerLeft
	x:(width - a) / 2,y:(height - a) / 2 //borderPadding
	},x4:{ // upperRight
	x:(width - a) / 2 + a,y:(height - a) / 2 + a}};return cross;}};AcroForm.Appearance.internal.getWidth = function(formObject){return formObject.Rect[2]; //(formObject.Rect[2] - formObject.Rect[0]) || 0;
	};AcroForm.Appearance.internal.getHeight = function(formObject){return formObject.Rect[3]; //(formObject.Rect[1] - formObject.Rect[3]) || 0;
	}; // ##########################
	//### For inheritance:
	AcroForm.internal.inherit = function(child,parent){var ObjectCreate=Object.create || function(o){var F=function F(){};F.prototype = o;return new F();};child.prototype = Object.create(parent.prototype);child.prototype.constructor = child;}; // ### Handy Functions:
	AcroForm.internal.arrayToPdfArray = function(array){if(Array.isArray(array)){var content=' [';for(var i in array) {var element=array[i].toString();content += element;content += i < array.length - 1?' ':'';}content += ']';return content;}};AcroForm.internal.toPdfString = function(string){string = string || ""; // put Bracket at the Beginning of the String
	if(string.indexOf('(') !== 0){string = '(' + string;}if(string.substring(string.length - 1) != ')'){string += '(';}return string;}; // ##########################
	//          Classes
	// ##########################
	AcroForm.PDFObject = function(){ // The Object ID in the PDF Object Model
	// todo
	var _objId;Object.defineProperty(this,'objId',{get:function get(){if(!_objId){if(this.internal){_objId = this.internal.newObjectDeferred();}else if(jsPDF.API.acroformPlugin.internal){ // todo - find better option, that doesn't rely on a Global Static var
	_objId = jsPDF.API.acroformPlugin.internal.newObjectDeferred();}}if(!_objId){console.log("Couldn't create Object ID");}return _objId;},configurable:false});};AcroForm.PDFObject.prototype.toString = function(){return this.objId + " 0 R";};AcroForm.PDFObject.prototype.getString = function(){var res=this.objId + " 0 obj\n<<";var content=this.getContent();res += content + ">>\n";if(this.stream){res += "stream\n";res += this.stream;res += "endstream\n";}res += "endobj\n";return res;};AcroForm.PDFObject.prototype.getContent = function(){ /**
	     * Prints out all enumerable Variables from the Object
	     * @param fieldObject
	     * @returns {string}
	     */var createContentFromFieldObject=function createContentFromFieldObject(fieldObject){var content='';var keys=Object.keys(fieldObject).filter(function(key){return key != 'content' && key != 'appearanceStreamContent' && key.substring(0,1) != "_";});for(var i in keys) {var key=keys[i];var value=fieldObject[key]; /*if (key == 'Rect' && value) {
	             value = AcroForm.internal.calculateCoordinates.call(jsPDF.API.acroformPlugin.internal, value);
	             }*/if(value){if(Array.isArray(value)){content += '/' + key + ' ' + AcroForm.internal.arrayToPdfArray(value) + "\n";}else if(value instanceof AcroForm.PDFObject){ // In case it is a reference to another PDFObject, take the referennce number
	content += '/' + key + ' ' + value.objId + " 0 R" + "\n";}else {content += '/' + key + ' ' + value + '\n';}}}return content;};var object="";object += createContentFromFieldObject(this);return object;};AcroForm.FormXObject = function(){AcroForm.PDFObject.call(this);this.Type = "/XObject";this.Subtype = "/Form";this.FormType = 1;this.BBox;this.Matrix;this.Resources = "2 0 R";this.PieceInfo;var _stream;Object.defineProperty(this,'Length',{enumerable:true,get:function get(){return _stream !== undefined?_stream.length:0;}});Object.defineProperty(this,'stream',{enumerable:false,set:function set(val){_stream = val;},get:function get(){if(_stream){return _stream;}else {return null;}}});};AcroForm.internal.inherit(AcroForm.FormXObject,AcroForm.PDFObject);AcroForm.AcroFormDictionary = function(){AcroForm.PDFObject.call(this);var _Kids=[];Object.defineProperty(this,'Kids',{enumerable:false,configurable:true,get:function get(){if(_Kids.length > 0){return _Kids;}else {return;}}});Object.defineProperty(this,'Fields',{enumerable:true,configurable:true,get:function get(){return _Kids;}}); // Default Appearance
	this.DA;};AcroForm.internal.inherit(AcroForm.AcroFormDictionary,AcroForm.PDFObject); // ##### The Objects, the User can Create:
	// The Field Object contains the Variables, that every Field needs
	// Rectangle for Appearance: lower_left_X, lower_left_Y, width, height
	AcroForm.Field = function(){'use strict';AcroForm.PDFObject.call(this);var _Rect;Object.defineProperty(this,'Rect',{enumerable:true,configurable:false,get:function get(){if(!_Rect){return;}var tmp=_Rect; //var calculatedRes = AcroForm.internal.calculateCoordinates(_Rect); // do later!
	return tmp;},set:function set(val){_Rect = val;}});var _FT="";Object.defineProperty(this,'FT',{enumerable:true,set:function set(val){_FT = val;},get:function get(){return _FT;}}); /**
	     * The Partial name of the Field Object.
	     * It has to be unique.
	     */var _T;Object.defineProperty(this,'T',{enumerable:true,configurable:false,set:function set(val){_T = val;},get:function get(){if(!_T || _T.length < 1){if(this instanceof AcroForm.ChildClass){ // In case of a Child from a Radio´Group, you don't need a FieldName!!!
	return;}return "(FieldObject" + AcroForm.Field.FieldNum++ + ")";}if(_T.substring(0,1) == "(" && _T.substring(_T.length - 1)){return _T;}return "(" + _T + ")";}});var _DA; // Defines the default appearance (Needed for variable Text)
	Object.defineProperty(this,'DA',{enumerable:true,get:function get(){if(!_DA){return;}return '(' + _DA + ')';},set:function set(val){_DA = val;}});var _DV; // Defines the default value
	Object.defineProperty(this,'DV',{enumerable:true,configurable:true,get:function get(){if(!_DV){return;}return _DV;},set:function set(val){_DV = val;}}); //this.Type = "/Annot";
	//this.Subtype = "/Widget";
	Object.defineProperty(this,'Type',{enumerable:true,get:function get(){return this.hasAnnotation?"/Annot":null;}});Object.defineProperty(this,'Subtype',{enumerable:true,get:function get(){return this.hasAnnotation?"/Widget":null;}}); /**
	     *
	     * @type {Array}
	     */this.BG;Object.defineProperty(this,'hasAnnotation',{enumerable:false,get:function get(){if(this.Rect || this.BC || this.BG){return true;}return false;}});Object.defineProperty(this,'hasAppearanceStream',{enumerable:false,configurable:true,writable:true});Object.defineProperty(this,'page',{enumerable:false,configurable:true,writable:true});};AcroForm.Field.FieldNum = 0;AcroForm.internal.inherit(AcroForm.Field,AcroForm.PDFObject);AcroForm.ChoiceField = function(){AcroForm.Field.call(this); // Field Type = Choice Field
	this.FT = "/Ch"; // options
	this.Opt = [];this.V = '()'; // Top Index
	this.TI = 0; /**
	     * Defines, whether the
	     * @type {boolean}
	     */this.combo = false; /**
	     * Defines, whether the Choice Field is an Edit Field.
	     * An Edit Field is automatically an Combo Field.
	     */Object.defineProperty(this,'edit',{enumerable:true,set:function set(val){if(val == true){this._edit = true; // ComboBox has to be true
	this.combo = true;}else {this._edit = false;}},get:function get(){if(!this._edit){return false;}return this._edit;},configurable:false});this.hasAppearanceStream = true;Object.defineProperty(this,'V',{get:function get(){AcroForm.internal.toPdfString();}});};AcroForm.internal.inherit(AcroForm.ChoiceField,AcroForm.Field);window["ChoiceField"] = AcroForm.ChoiceField;AcroForm.ListBox = function(){AcroForm.ChoiceField.call(this); //var combo = true;
	};AcroForm.internal.inherit(AcroForm.ListBox,AcroForm.ChoiceField);window["ListBox"] = AcroForm.ListBox;AcroForm.ComboBox = function(){AcroForm.ListBox.call(this);this.combo = true;};AcroForm.internal.inherit(AcroForm.ComboBox,AcroForm.ListBox);window["ComboBox"] = AcroForm.ComboBox;AcroForm.EditBox = function(){AcroForm.ComboBox.call(this);this.edit = true;};AcroForm.internal.inherit(AcroForm.EditBox,AcroForm.ComboBox);window["EditBox"] = AcroForm.EditBox;AcroForm.Button = function(){AcroForm.Field.call(this);this.FT = "/Btn"; //this.hasAnnotation = true;
	};AcroForm.internal.inherit(AcroForm.Button,AcroForm.Field);window["Button"] = AcroForm.Button;AcroForm.PushButton = function(){AcroForm.Button.call(this);this.pushbutton = true;};AcroForm.internal.inherit(AcroForm.PushButton,AcroForm.Button);window["PushButton"] = AcroForm.PushButton;AcroForm.RadioButton = function(){AcroForm.Button.call(this);this.radio = true;var _Kids=[];Object.defineProperty(this,'Kids',{enumerable:true,get:function get(){if(_Kids.length > 0){return _Kids;}}});Object.defineProperty(this,'__Kids',{get:function get(){return _Kids;}});var _noToggleToOff;Object.defineProperty(this,'noToggleToOff',{enumerable:false,get:function get(){return _noToggleToOff;},set:function set(val){_noToggleToOff = val;}}); //this.hasAnnotation = false;
	};AcroForm.internal.inherit(AcroForm.RadioButton,AcroForm.Button);window["RadioButton"] = AcroForm.RadioButton; /*
	 * The Child classs of a RadioButton (the radioGroup)
	 * -> The single Buttons
	 */AcroForm.ChildClass = function(parent,name){AcroForm.Field.call(this);this.Parent = parent; // todo: set AppearanceType as variable that can be set from the outside...
	this._AppearanceType = AcroForm.Appearance.RadioButton.Circle; // The Default appearanceType is the Circle
	this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(name); // Set Print in the Annot Flag
	this.F = AcroForm.internal.setBitPosition(this.F,3,1); // Set AppearanceCharacteristicsDictionary with default appearance if field is not interacting with user
	this.MK = this._AppearanceType.createMK(); // (8) -> Cross, (1)-> Circle, ()-> nothing
	// Default Appearance is Off
	this.AS = "/Off"; // + name;
	this._Name = name;};AcroForm.internal.inherit(AcroForm.ChildClass,AcroForm.Field);AcroForm.RadioButton.prototype.setAppearance = function(appearance){if(!('createAppearanceStream' in appearance && 'createMK' in appearance)){console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");return;}for(var i in this.__Kids) {var child=this.__Kids[i];child.appearanceStreamContent = appearance.createAppearanceStream(child._Name);child.MK = appearance.createMK();}};AcroForm.RadioButton.prototype.createOption = function(name){var parent=this;var kidCount=this.__Kids.length; // Create new Child for RadioGroup
	var child=new AcroForm.ChildClass(parent,name); // Add to Parent
	this.__Kids.push(child);jsPDF.API.addField(child);return child;};AcroForm.CheckBox = function(){Button.call(this);this.appearanceStreamContent = AcroForm.Appearance.CheckBox.createAppearanceStream();this.MK = AcroForm.Appearance.CheckBox.createMK();this.AS = "/On";this.V = "/On";};AcroForm.internal.inherit(AcroForm.CheckBox,AcroForm.Button);window["CheckBox"] = AcroForm.CheckBox;AcroForm.TextField = function(){AcroForm.Field.call(this);this.DA = AcroForm.Appearance.createDefaultAppearanceStream();this.F = 4;var _V;Object.defineProperty(this,'V',{get:function get(){if(_V){return "(" + _V + ")";}else {return _V;}},enumerable:true,set:function set(val){_V = val;}});var _DV;Object.defineProperty(this,'DV',{get:function get(){if(_DV){return "(" + _DV + ")";}else {return _DV;}},enumerable:true,set:function set(val){_DV = val;}});var _multiline=false;Object.defineProperty(this,'multiline',{enumerable:false,get:function get(){return _multiline;},set:function set(val){_multiline = val;}}); //this.multiline = false;
	//this.password = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.fileSelect = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.doNotSpellCheck = false;
	/**
	     * For PDF 1.4
	     * @type {boolean}
	     */ //this.doNotScroll = false;
	var _MaxLen=false;Object.defineProperty(this,'MaxLen',{enumerable:true,get:function get(){return _MaxLen;},set:function set(val){_MaxLen = val;}});Object.defineProperty(this,'hasAppearanceStream',{enumerable:false,get:function get(){return this.V || this.DV;}});};AcroForm.internal.inherit(AcroForm.TextField,AcroForm.Field);window["TextField"] = AcroForm.TextField;AcroForm.PasswordField = function(){TextField.call(this);Object.defineProperty(this,'password',{value:true,enumerable:false,configurable:false,writable:false});};AcroForm.internal.inherit(AcroForm.PasswordField,AcroForm.TextField);window["PasswordField"] = AcroForm.PasswordField; // ############ internal functions
	/*
	 * small workaround for calculating the TextMetric approximately
	 * @param text
	 * @param fontsize
	 * @returns {TextMetrics} (Has Height and Width)
	 */AcroForm.internal.calculateFontSpace = function(text,fontsize,fonttype){var fonttype=fonttype || "helvetica"; //re-use canvas object for speed improvements
	var canvas=AcroForm.internal.calculateFontSpace.canvas || (AcroForm.internal.calculateFontSpace.canvas = document.createElement('canvas'));var context=canvas.getContext('2d');context.save();var newFont=fontsize + " " + fonttype;context.font = newFont;var res=context.measureText(text);context.fontcolor = 'black'; // Calculate height:
	var context=canvas.getContext('2d');res.height = context.measureText("3").width * 1.5; // 3 because in ZapfDingbats its a Hook and a 3 in normal fonts
	context.restore();var width=res.width;return res;};AcroForm.internal.calculateX = function(formObject,text,font,maxFontSize){var maxFontSize=maxFontSize || 12;var font=font || "helvetica";var returnValue={text:"",fontSize:""}; // Remove Brackets
	text = text.substr(0,1) == '('?text.substr(1):text;text = text.substr(text.length - 1) == ')'?text.substr(0,text.length - 1):text; // split into array of words
	var textSplit=text.split(' '); /**
	     * the color could be ((alpha)||(r,g,b)||(c,m,y,k))
	     * @type {string}
	     */var color="0 g\n";var fontSize=maxFontSize; // The Starting fontSize (The Maximum)
	var lineSpacing=2;var borderPadding=2;var height=AcroForm.Appearance.internal.getHeight(formObject) || 0;height = height < 0?-height:height;var width=AcroForm.Appearance.internal.getWidth(formObject) || 0;width = width < 0?-width:width;var isSmallerThanWidth=function isSmallerThanWidth(i,lastLine,fontSize){if(i + 1 < textSplit.length){var tmp=lastLine + " " + textSplit[i + 1];var TextWidth=AcroForm.internal.calculateFontSpace(tmp,fontSize + "px",font).width;var FieldWidth=width - 2 * borderPadding;return TextWidth <= FieldWidth;}else {return false;}};fontSize++;FontSize: while(true) {var text="";fontSize--;var textHeight=AcroForm.internal.calculateFontSpace("3",fontSize + "px",font).height;var startY=formObject.multiline?height - fontSize:(height - textHeight) / 2;startY += lineSpacing;var startX=-borderPadding;var lastX=startX,lastY=startY;var firstWordInLine=0,lastWordInLine=0;var lastLength=0;var y=0;if(fontSize == 0){ // In case, the Text doesn't fit at all
	fontSize = 12;text = "(...) Tj\n";text += "% Width of Text: " + AcroForm.internal.calculateFontSpace(text,"1px").width + ", FieldWidth:" + width + "\n";break;}lastLength = AcroForm.internal.calculateFontSpace(textSplit[0] + " ",fontSize + "px",font).width;var lastLine="";var lineCount=0;Line: for(var i in textSplit) {lastLine += textSplit[i] + " "; // Remove last blank
	lastLine = lastLine.substr(lastLine.length - 1) == " "?lastLine.substr(0,lastLine.length - 1):lastLine;var key=parseInt(i);lastLength = AcroForm.internal.calculateFontSpace(lastLine + " ",fontSize + "px",font).width;var nextLineIsSmaller=isSmallerThanWidth(key,lastLine,fontSize);var isLastWord=i >= textSplit.length - 1;if(nextLineIsSmaller && !isLastWord){lastLine += " ";continue; // Line
	}else if(!nextLineIsSmaller && !isLastWord){if(!formObject.multiline){continue FontSize;}else {if((textHeight + lineSpacing) * (lineCount + 2) + lineSpacing > height){ // If the Text is higher than the FieldObject
	continue FontSize;}lastWordInLine = key; // go on
	}}else if(isLastWord){lastWordInLine = key;}else {if(formObject.multiline && (textHeight + lineSpacing) * (lineCount + 2) + lineSpacing > height){ // If the Text is higher than the FieldObject
	continue FontSize;}}var line='';for(var x=firstWordInLine;x <= lastWordInLine;x++) {line += textSplit[x] + ' ';} // Remove last blank
	line = line.substr(line.length - 1) == " "?line.substr(0,line.length - 1):line; //lastLength -= blankSpace.width;
	lastLength = AcroForm.internal.calculateFontSpace(line,fontSize + "px",font).width; // Calculate startX
	switch(formObject.Q){case 2: // Right justified
	startX = width - lastLength - borderPadding;break;case 1: // Q = 1 := Text-Alignment: Center
	startX = (width - lastLength) / 2;break;case 0:default:startX = borderPadding;break;}text += startX + ' ' + lastY + ' Td\n';text += '(' + line + ') Tj\n'; // reset X in PDF
	text += -startX + ' 0 Td\n'; // After a Line, adjust y position
	lastY = -(fontSize + lineSpacing);lastX = startX; // Reset for next iteration step
	lastLength = 0;firstWordInLine = lastWordInLine + 1;lineCount++;lastLine = "";continue Line;}break;}returnValue.text = text;returnValue.fontSize = fontSize;return returnValue;};AcroForm.internal.calculateAppearanceStream = function(formObject){if(formObject.appearanceStreamContent){ // If appearanceStream is already set, use it
	return formObject.appearanceStreamContent;}if(!formObject.V && !formObject.DV){return;} // else calculate it
	var stream='';var text=formObject.V || formObject.DV;var calcRes=AcroForm.internal.calculateX(formObject,text);stream += '/Tx BMC\n' + 'q\n' +  //color + '\n' +
	'/F1 ' + calcRes.fontSize + ' Tf\n' +  // Text Matrix
	'1 0 0 1 0 0 Tm\n'; // Begin Text
	stream += 'BT\n';stream += calcRes.text; // End Text
	stream += 'ET\n';stream += 'Q\n' + 'EMC\n';var appearanceStreamContent=new AcroForm.createFormXObject(formObject);appearanceStreamContent.stream = stream;var appearance={N:{'Normal':appearanceStreamContent}};return appearanceStreamContent;}; /*
	 * Converts the Parameters from x,y,w,h to lowerLeftX, lowerLeftY, upperRightX, upperRightY
	 * @param x
	 * @param y
	 * @param w
	 * @param h
	 * @returns {*[]}
	 */AcroForm.internal.calculateCoordinates = function(x,y,w,h){var coordinates={};if(this.internal){var mmtopx=function mmtopx(x){return x * this.internal.scaleFactor;};if(Array.isArray(x)){x[0] = AcroForm.scale(x[0]);x[1] = AcroForm.scale(x[1]);x[2] = AcroForm.scale(x[2]);x[3] = AcroForm.scale(x[3]);coordinates.lowerLeft_X = x[0] || 0;coordinates.lowerLeft_Y = mmtopx.call(this,this.internal.pageSize.height) - x[3] - x[1] || 0;coordinates.upperRight_X = x[0] + x[2] || 0;coordinates.upperRight_Y = mmtopx.call(this,this.internal.pageSize.height) - x[1] || 0;}else {x = AcroForm.scale(x);y = AcroForm.scale(y);w = AcroForm.scale(w);h = AcroForm.scale(h);coordinates.lowerLeft_X = x || 0;coordinates.lowerLeft_Y = this.internal.pageSize.height - y || 0;coordinates.upperRight_X = x + w || 0;coordinates.upperRight_Y = this.internal.pageSize.height - y + h || 0;}}else { // old method, that is fallback, if we can't get the pageheight, the coordinate-system starts from lower left
	if(Array.isArray(x)){coordinates.lowerLeft_X = x[0] || 0;coordinates.lowerLeft_Y = x[1] || 0;coordinates.upperRight_X = x[0] + x[2] || 0;coordinates.upperRight_Y = x[1] + x[3] || 0;}else {coordinates.lowerLeft_X = x || 0;coordinates.lowerLeft_Y = y || 0;coordinates.upperRight_X = x + w || 0;coordinates.upperRight_Y = y + h || 0;}}return [coordinates.lowerLeft_X,coordinates.lowerLeft_Y,coordinates.upperRight_X,coordinates.upperRight_Y];};AcroForm.internal.calculateColor = function(r,g,b){var color=new Array(3);color.r = r | 0;color.g = g | 0;color.b = b | 0;return color;};AcroForm.internal.getBitPosition = function(variable,position){variable = variable || 0;var bitMask=1;bitMask = bitMask << position - 1;return variable | bitMask;};AcroForm.internal.setBitPosition = function(variable,position,value){variable = variable || 0;value = value || 1;var bitMask=1;bitMask = bitMask << position - 1;if(value == 1){ // Set the Bit to 1
	var variable=variable | bitMask;}else { // Set the Bit to 0
	var variable=variable & ~bitMask;}return variable;}; /**
	 * jsPDF addHTML PlugIn
	 * Copyright (c) 2014 Diego Casorran
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(function(jsPDFAPI){'use strict'; /**
	  * Renders an HTML element to canvas object which added to the PDF
	  *
	  * This PlugIn requires html2canvas: https://github.com/niklasvh/html2canvas
	  *            OR rasterizeHTML: https://github.com/cburgmer/rasterizeHTML.js
	  *
	  * @public
	  * @function
	  * @param element {Mixed} HTML Element, or anything supported by html2canvas.
	  * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	  * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	  * @param options {Object} Additional options, check the code below.
	  * @param callback {Function} to call when the rendering has finished.
	  *
	  * NOTE: Every parameter is optional except 'element' and 'callback', in such
	  *       case the image is positioned at 0x0 covering the whole PDF document
	  *       size. Ie, to easily take screenshots of webpages saving them to PDF.
	  */jsPDFAPI.addHTML = function(element,x,y,options,callback){'use strict';if(typeof html2canvas === 'undefined' && typeof rasterizeHTML === 'undefined')throw new Error('You need either ' + 'https://github.com/niklasvh/html2canvas' + ' or https://github.com/cburgmer/rasterizeHTML.js');if(typeof x !== 'number'){options = x;callback = y;}if(typeof options === 'function'){callback = options;options = null;}var I=this.internal,K=I.scaleFactor,W=I.pageSize.width,H=I.pageSize.height;options = options || {};options.onrendered = (function(obj){x = parseInt(x) || 0;y = parseInt(y) || 0;var dim=options.dim || {};var h=dim.h || 0;var w=dim.w || Math.min(W,obj.width / K) - x;var format='JPEG';if(options.format)format = options.format;if(obj.height > H && options.pagesplit){var crop=(function(){var cy=0;while(1) {var canvas=document.createElement('canvas');canvas.width = Math.min(W * K,obj.width);canvas.height = Math.min(H * K,obj.height - cy);var ctx=canvas.getContext('2d');ctx.drawImage(obj,0,cy,obj.width,canvas.height,0,0,canvas.width,canvas.height);var args=[canvas,x,cy?0:y,canvas.width / K,canvas.height / K,format,null,'SLOW'];this.addImage.apply(this,args);cy += canvas.height;if(cy >= obj.height)break;this.addPage();}callback(w,cy,null,args);}).bind(this);if(obj.nodeName === 'CANVAS'){var img=new Image();img.onload = crop;img.src = obj.toDataURL("image/png");obj = img;}else {crop();}}else {var alias=Math.random().toString(35);var args=[obj,x,y,w,h,format,alias,'SLOW'];this.addImage.apply(this,args);callback(w,h,alias,args);}}).bind(this);if(typeof html2canvas !== 'undefined' && !options.rstz){return html2canvas(element,options);}if(typeof rasterizeHTML !== 'undefined'){var meth='drawDocument';if(typeof element === 'string'){meth = /^http/.test(element)?'drawURL':'drawHTML';}options.width = options.width || W * K;return rasterizeHTML[meth](element,void 0,options).then(function(r){options.onrendered(r.image);},function(e){callback(null,e);});}return null;};})(jsPDF.API); /** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 */(function(jsPDFAPI){'use strict';var namespace='addImage_',supported_image_types=['jpeg','jpg','png']; // Image functionality ported from pdf.js
	var putImage=function putImage(img){var objectNumber=this.internal.newObject(),out=this.internal.write,putStream=this.internal.putStream;img['n'] = objectNumber;out('<</Type /XObject');out('/Subtype /Image');out('/Width ' + img['w']);out('/Height ' + img['h']);if(img['cs'] === this.color_spaces.INDEXED){out('/ColorSpace [/Indexed /DeviceRGB ' // if an indexed png defines more than one colour with transparency, we've created a smask
	 + (img['pal'].length / 3 - 1) + ' ' + ('smask' in img?objectNumber + 2:objectNumber + 1) + ' 0 R]');}else {out('/ColorSpace /' + img['cs']);if(img['cs'] === this.color_spaces.DEVICE_CMYK){out('/Decode [1 0 1 0 1 0 1 0]');}}out('/BitsPerComponent ' + img['bpc']);if('f' in img){out('/Filter /' + img['f']);}if('dp' in img){out('/DecodeParms <<' + img['dp'] + '>>');}if('trns' in img && img['trns'].constructor == Array){var trns='',i=0,len=img['trns'].length;for(;i < len;i++) {trns += img['trns'][i] + ' ' + img['trns'][i] + ' ';}out('/Mask [' + trns + ']');}if('smask' in img){out('/SMask ' + (objectNumber + 1) + ' 0 R');}out('/Length ' + img['data'].length + '>>');putStream(img['data']);out('endobj'); // Soft mask
	if('smask' in img){var dp='/Predictor ' + img['p'] + ' /Colors 1 /BitsPerComponent ' + img['bpc'] + ' /Columns ' + img['w'];var smask={'w':img['w'],'h':img['h'],'cs':'DeviceGray','bpc':img['bpc'],'dp':dp,'data':img['smask']};if('f' in img)smask.f = img['f'];putImage.call(this,smask);} //Palette
	if(img['cs'] === this.color_spaces.INDEXED){this.internal.newObject(); //out('<< /Filter / ' + img['f'] +' /Length ' + img['pal'].length + '>>');
	//putStream(zlib.compress(img['pal']));
	out('<< /Length ' + img['pal'].length + '>>');putStream(this.arrayBufferToBinaryString(new Uint8Array(img['pal'])));out('endobj');}},putResourcesCallback=function putResourcesCallback(){var images=this.internal.collections[namespace + 'images'];for(var i in images) {putImage.call(this,images[i]);}},putXObjectsDictCallback=function putXObjectsDictCallback(){var images=this.internal.collections[namespace + 'images'],out=this.internal.write,image;for(var i in images) {image = images[i];out('/I' + image['i'],image['n'],'0','R');}},checkCompressValue=function checkCompressValue(value){if(value && typeof value === 'string')value = value.toUpperCase();return value in jsPDFAPI.image_compression?value:jsPDFAPI.image_compression.NONE;},getImages=function getImages(){var images=this.internal.collections[namespace + 'images']; //first run, so initialise stuff
	if(!images){this.internal.collections[namespace + 'images'] = images = {};this.internal.events.subscribe('putResources',putResourcesCallback);this.internal.events.subscribe('putXobjectDict',putXObjectsDictCallback);}return images;},getImageIndex=function getImageIndex(images){var imageIndex=0;if(images){ // this is NOT the first time this method is ran on this instance of jsPDF object.
	imageIndex = Object.keys?Object.keys(images).length:(function(o){var i=0;for(var e in o) {if(o.hasOwnProperty(e)){i++;}}return i;})(images);}return imageIndex;},notDefined=function notDefined(value){return typeof value === 'undefined' || value === null;},generateAliasFromData=function generateAliasFromData(data){return typeof data === 'string' && jsPDFAPI.sHashCode(data);},doesNotSupportImageType=function doesNotSupportImageType(type){return supported_image_types.indexOf(type) === -1;},processMethodNotEnabled=function processMethodNotEnabled(type){return typeof jsPDFAPI['process' + type.toUpperCase()] !== 'function';},isDOMElement=function isDOMElement(object){return (typeof object === 'undefined'?'undefined':_typeof(object)) === 'object' && object.nodeType === 1;},createDataURIFromElement=function createDataURIFromElement(element,format,angle){ //if element is an image which uses data url definition, just return the dataurl
	if(element.nodeName === 'IMG' && element.hasAttribute('src')){var src='' + element.getAttribute('src');if(!angle && src.indexOf('data:image/') === 0)return src; // only if the user doesn't care about a format
	if(!format && /\.png(?:[?#].*)?$/i.test(src))format = 'png';}if(element.nodeName === 'CANVAS'){var canvas=element;}else {var canvas=document.createElement('canvas');canvas.width = element.clientWidth || element.width;canvas.height = element.clientHeight || element.height;var ctx=canvas.getContext('2d');if(!ctx){throw 'addImage requires canvas to be supported by browser.';}if(angle){var x,y,b,c,s,w,h,to_radians=Math.PI / 180,angleInRadians;if((typeof angle === 'undefined'?'undefined':_typeof(angle)) === 'object'){x = angle.x;y = angle.y;b = angle.bg;angle = angle.angle;}angleInRadians = angle * to_radians;c = Math.abs(Math.cos(angleInRadians));s = Math.abs(Math.sin(angleInRadians));w = canvas.width;h = canvas.height;canvas.width = h * s + w * c;canvas.height = h * c + w * s;if(isNaN(x))x = canvas.width / 2;if(isNaN(y))y = canvas.height / 2;ctx.clearRect(0,0,canvas.width,canvas.height);ctx.fillStyle = b || 'white';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.save();ctx.translate(x,y);ctx.rotate(angleInRadians);ctx.drawImage(element,-(w / 2),-(h / 2));ctx.rotate(-angleInRadians);ctx.translate(-x,-y);ctx.restore();}else {ctx.drawImage(element,0,0,canvas.width,canvas.height);}}return canvas.toDataURL(('' + format).toLowerCase() == 'png'?'image/png':'image/jpeg');},checkImagesForAlias=function checkImagesForAlias(alias,images){var cached_info;if(images){for(var e in images) {if(alias === images[e].alias){cached_info = images[e];break;}}}return cached_info;},determineWidthAndHeight=function determineWidthAndHeight(w,h,info){if(!w && !h){w = -96;h = -96;}if(w < 0){w = -1 * info['w'] * 72 / w / this.internal.scaleFactor;}if(h < 0){h = -1 * info['h'] * 72 / h / this.internal.scaleFactor;}if(w === 0){w = h * info['w'] / info['h'];}if(h === 0){h = w * info['h'] / info['w'];}return [w,h];},writeImageToPDF=function writeImageToPDF(x,y,w,h,info,index,images){var dims=determineWidthAndHeight.call(this,w,h,info),coord=this.internal.getCoordinateString,vcoord=this.internal.getVerticalCoordinateString;w = dims[0];h = dims[1];images[index] = info;this.internal.write('q',coord(w),'0 0',coord(h), // TODO: check if this should be shifted by vcoord
	coord(x),vcoord(y + h),'cm /I' + info['i'],'Do Q');}; /**
	  * COLOR SPACES
	  */jsPDFAPI.color_spaces = {DEVICE_RGB:'DeviceRGB',DEVICE_GRAY:'DeviceGray',DEVICE_CMYK:'DeviceCMYK',CAL_GREY:'CalGray',CAL_RGB:'CalRGB',LAB:'Lab',ICC_BASED:'ICCBased',INDEXED:'Indexed',PATTERN:'Pattern',SEPARATION:'Separation',DEVICE_N:'DeviceN'}; /**
	  * DECODE METHODS
	  */jsPDFAPI.decode = {DCT_DECODE:'DCTDecode',FLATE_DECODE:'FlateDecode',LZW_DECODE:'LZWDecode',JPX_DECODE:'JPXDecode',JBIG2_DECODE:'JBIG2Decode',ASCII85_DECODE:'ASCII85Decode',ASCII_HEX_DECODE:'ASCIIHexDecode',RUN_LENGTH_DECODE:'RunLengthDecode',CCITT_FAX_DECODE:'CCITTFaxDecode'}; /**
	  * IMAGE COMPRESSION TYPES
	  */jsPDFAPI.image_compression = {NONE:'NONE',FAST:'FAST',MEDIUM:'MEDIUM',SLOW:'SLOW'};jsPDFAPI.sHashCode = function(str){return Array.prototype.reduce && str.split("").reduce(function(a,b){a = (a << 5) - a + b.charCodeAt(0);return a & a;},0);};jsPDFAPI.isString = function(object){return typeof object === 'string';}; /**
	  * Strips out and returns info from a valid base64 data URI
	  * @param {String[dataURI]} a valid data URI of format 'data:[<MIME-type>][;base64],<data>'
	  * @returns an Array containing the following
	  * [0] the complete data URI
	  * [1] <MIME-type>
	  * [2] format - the second part of the mime-type i.e 'png' in 'image/png'
	  * [4] <data>
	  */jsPDFAPI.extractInfoFromBase64DataURI = function(dataURI){return (/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(dataURI));}; /**
	  * Check to see if ArrayBuffer is supported
	  */jsPDFAPI.supportsArrayBuffer = function(){return typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';}; /**
	  * Tests supplied object to determine if ArrayBuffer
	  * @param {Object[object]}
	  */jsPDFAPI.isArrayBuffer = function(object){if(!this.supportsArrayBuffer())return false;return object instanceof ArrayBuffer;}; /**
	  * Tests supplied object to determine if it implements the ArrayBufferView (TypedArray) interface
	  * @param {Object[object]}
	  */jsPDFAPI.isArrayBufferView = function(object){if(!this.supportsArrayBuffer())return false;if(typeof Uint32Array === 'undefined')return false;return object instanceof Int8Array || object instanceof Uint8Array || typeof Uint8ClampedArray !== 'undefined' && object instanceof Uint8ClampedArray || object instanceof Int16Array || object instanceof Uint16Array || object instanceof Int32Array || object instanceof Uint32Array || object instanceof Float32Array || object instanceof Float64Array;}; /**
	  * Exactly what it says on the tin
	  */jsPDFAPI.binaryStringToUint8Array = function(binary_string){ /*
	   * not sure how efficient this will be will bigger files. Is there a native method?
	   */var len=binary_string.length;var bytes=new Uint8Array(len);for(var i=0;i < len;i++) {bytes[i] = binary_string.charCodeAt(i);}return bytes;}; /**
	  * @see this discussion
	  * http://stackoverflow.com/questions/6965107/converting-between-strings-and-arraybuffers
	  *
	  * As stated, i imagine the method below is highly inefficent for large files.
	  *
	  * Also of note from Mozilla,
	  *
	  * "However, this is slow and error-prone, due to the need for multiple conversions (especially if the binary data is not actually byte-format data, but, for example, 32-bit integers or floats)."
	  *
	  * https://developer.mozilla.org/en-US/Add-ons/Code_snippets/StringView
	  *
	  * Although i'm strugglig to see how StringView solves this issue? Doesn't appear to be a direct method for conversion?
	  *
	  * Async method using Blob and FileReader could be best, but i'm not sure how to fit it into the flow?
	  */jsPDFAPI.arrayBufferToBinaryString = function(buffer){ /*if('TextDecoder' in window){
	  	var decoder = new TextDecoder('ascii');
	  	return decoder.decode(buffer);
	  }*/if(this.isArrayBuffer(buffer))buffer = new Uint8Array(buffer);var binary_string='';var len=buffer.byteLength;for(var i=0;i < len;i++) {binary_string += String.fromCharCode(buffer[i]);}return binary_string; /*
	   * Another solution is the method below - convert array buffer straight to base64 and then use atob
	   */ //return atob(this.arrayBufferToBase64(buffer));
	}; /**
	  * Converts an ArrayBuffer directly to base64
	  *
	  * Taken from here
	  *
	  * http://jsperf.com/encoding-xhr-image-data/31
	  *
	  * Need to test if this is a better solution for larger files
	  *
	  */jsPDFAPI.arrayBufferToBase64 = function(arrayBuffer){var base64='';var encodings='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';var bytes=new Uint8Array(arrayBuffer);var byteLength=bytes.byteLength;var byteRemainder=byteLength % 3;var mainLength=byteLength - byteRemainder;var a,b,c,d;var chunk; // Main loop deals with bytes in chunks of 3
	for(var i=0;i < mainLength;i = i + 3) { // Combine the three bytes into a single integer
	chunk = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2]; // Use bitmasks to extract 6-bit segments from the triplet
	a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
	b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
	c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
	d = chunk & 63; // 63       = 2^6 - 1
	// Convert the raw binary segments to the appropriate ASCII encoding
	base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];} // Deal with the remaining bytes and padding
	if(byteRemainder == 1){chunk = bytes[mainLength];a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
	// Set the 4 least significant bits to zero
	b = (chunk & 3) << 4; // 3   = 2^2 - 1
	base64 += encodings[a] + encodings[b] + '==';}else if(byteRemainder == 2){chunk = bytes[mainLength] << 8 | bytes[mainLength + 1];a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
	b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
	// Set the 2 least significant bits to zero
	c = (chunk & 15) << 2; // 15    = 2^4 - 1
	base64 += encodings[a] + encodings[b] + encodings[c] + '=';}return base64;};jsPDFAPI.createImageInfo = function(data,wd,ht,cs,bpc,f,imageIndex,alias,dp,trns,pal,smask,p){var info={alias:alias,w:wd,h:ht,cs:cs,bpc:bpc,i:imageIndex,data:data // n: objectNumber will be added by putImage code
	};if(f)info.f = f;if(dp)info.dp = dp;if(trns)info.trns = trns;if(pal)info.pal = pal;if(smask)info.smask = smask;if(p)info.p = p; // predictor parameter for PNG compression
	return info;};jsPDFAPI.addImage = function(imageData,format,x,y,w,h,alias,compression,rotation){'use strict';if(typeof format !== 'string'){var tmp=h;h = w;w = y;y = x;x = format;format = tmp;}if((typeof imageData === 'undefined'?'undefined':_typeof(imageData)) === 'object' && !isDOMElement(imageData) && "imageData" in imageData){var options=imageData;imageData = options.imageData;format = options.format || format;x = options.x || x || 0;y = options.y || y || 0;w = options.w || w;h = options.h || h;alias = options.alias || alias;compression = options.compression || compression;rotation = options.rotation || options.angle || rotation;}if(isNaN(x) || isNaN(y)){console.error('jsPDF.addImage: Invalid coordinates',arguments);throw new Error('Invalid coordinates passed to jsPDF.addImage');}var images=getImages.call(this),info;if(!(info = checkImagesForAlias(imageData,images))){var dataAsBinaryString;if(isDOMElement(imageData))imageData = createDataURIFromElement(imageData,format,rotation);if(notDefined(alias))alias = generateAliasFromData(imageData);if(!(info = checkImagesForAlias(alias,images))){if(this.isString(imageData)){var base64Info=this.extractInfoFromBase64DataURI(imageData);if(base64Info){format = base64Info[2];imageData = atob(base64Info[3]); //convert to binary string
	}else {if(imageData.charCodeAt(0) === 0x89 && imageData.charCodeAt(1) === 0x50 && imageData.charCodeAt(2) === 0x4e && imageData.charCodeAt(3) === 0x47)format = 'png';}}format = (format || 'JPEG').toLowerCase();if(doesNotSupportImageType(format))throw new Error('addImage currently only supports formats ' + supported_image_types + ', not \'' + format + '\'');if(processMethodNotEnabled(format))throw new Error('please ensure that the plugin for \'' + format + '\' support is added'); /**
	     * need to test if it's more efficient to convert all binary strings
	     * to TypedArray - or should we just leave and process as string?
	     */if(this.supportsArrayBuffer()){ // no need to convert if imageData is already uint8array
	if(!(imageData instanceof Uint8Array)){dataAsBinaryString = imageData;imageData = this.binaryStringToUint8Array(imageData);}}info = this['process' + format.toUpperCase()](imageData,getImageIndex(images),alias,checkCompressValue(compression),dataAsBinaryString);if(!info)throw new Error('An unkwown error occurred whilst processing the image');}}writeImageToPDF.call(this,x,y,w,h,info,info.i,images);return this;}; /**
	  * JPEG SUPPORT
	  **/ //takes a string imgData containing the raw bytes of
	//a jpeg image and returns [width, height]
	//Algorithm from: http://www.64lines.com/jpeg-width-height
	var getJpegSize=function getJpegSize(imgData){'use strict';var width,height,numcomponents; // Verify we have a valid jpeg header 0xff,0xd8,0xff,0xe0,?,?,'J','F','I','F',0x00
	if(!imgData.charCodeAt(0) === 0xff || !imgData.charCodeAt(1) === 0xd8 || !imgData.charCodeAt(2) === 0xff || !imgData.charCodeAt(3) === 0xe0 || !imgData.charCodeAt(6) === 'J'.charCodeAt(0) || !imgData.charCodeAt(7) === 'F'.charCodeAt(0) || !imgData.charCodeAt(8) === 'I'.charCodeAt(0) || !imgData.charCodeAt(9) === 'F'.charCodeAt(0) || !imgData.charCodeAt(10) === 0x00){throw new Error('getJpegSize requires a binary string jpeg file');}var blockLength=imgData.charCodeAt(4) * 256 + imgData.charCodeAt(5);var i=4,len=imgData.length;while(i < len) {i += blockLength;if(imgData.charCodeAt(i) !== 0xff){throw new Error('getJpegSize could not find the size of the image');}if(imgData.charCodeAt(i + 1) === 0xc0 ||  //(SOF) Huffman  - Baseline DCT
	imgData.charCodeAt(i + 1) === 0xc1 ||  //(SOF) Huffman  - Extended sequential DCT
	imgData.charCodeAt(i + 1) === 0xc2 ||  // Progressive DCT (SOF2)
	imgData.charCodeAt(i + 1) === 0xc3 ||  // Spatial (sequential) lossless (SOF3)
	imgData.charCodeAt(i + 1) === 0xc4 ||  // Differential sequential DCT (SOF5)
	imgData.charCodeAt(i + 1) === 0xc5 ||  // Differential progressive DCT (SOF6)
	imgData.charCodeAt(i + 1) === 0xc6 ||  // Differential spatial (SOF7)
	imgData.charCodeAt(i + 1) === 0xc7){height = imgData.charCodeAt(i + 5) * 256 + imgData.charCodeAt(i + 6);width = imgData.charCodeAt(i + 7) * 256 + imgData.charCodeAt(i + 8);numcomponents = imgData.charCodeAt(i + 9);return [width,height,numcomponents];}else {i += 2;blockLength = imgData.charCodeAt(i) * 256 + imgData.charCodeAt(i + 1);}}},getJpegSizeFromBytes=function getJpegSizeFromBytes(data){var hdr=data[0] << 8 | data[1];if(hdr !== 0xFFD8)throw new Error('Supplied data is not a JPEG');var len=data.length,block=(data[4] << 8) + data[5],pos=4,bytes,width,height,numcomponents;while(pos < len) {pos += block;bytes = readBytes(data,pos);block = (bytes[2] << 8) + bytes[3];if((bytes[1] === 0xC0 || bytes[1] === 0xC2) && bytes[0] === 0xFF && block > 7){bytes = readBytes(data,pos + 5);width = (bytes[2] << 8) + bytes[3];height = (bytes[0] << 8) + bytes[1];numcomponents = bytes[4];return {width:width,height:height,numcomponents:numcomponents};}pos += 2;}throw new Error('getJpegSizeFromBytes could not find the size of the image');},readBytes=function readBytes(data,offset){return data.subarray(offset,offset + 5);};jsPDFAPI.processJPEG = function(data,index,alias,compression,dataAsBinaryString){'use strict';var colorSpace=this.color_spaces.DEVICE_RGB,filter=this.decode.DCT_DECODE,bpc=8,dims;if(this.isString(data)){dims = getJpegSize(data);return this.createImageInfo(data,dims[0],dims[1],dims[3] == 1?this.color_spaces.DEVICE_GRAY:colorSpace,bpc,filter,index,alias);}if(this.isArrayBuffer(data))data = new Uint8Array(data);if(this.isArrayBufferView(data)){dims = getJpegSizeFromBytes(data); // if we already have a stored binary string rep use that
	data = dataAsBinaryString || this.arrayBufferToBinaryString(data);return this.createImageInfo(data,dims.width,dims.height,dims.numcomponents == 1?this.color_spaces.DEVICE_GRAY:colorSpace,bpc,filter,index,alias);}return null;};jsPDFAPI.processJPG = function() /*data, index, alias, compression, dataAsBinaryString*/{return this.processJPEG.apply(this,arguments);};})(jsPDF.API); /**
	 * jsPDF Annotations PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * There are many types of annotations in a PDF document. Annotations are placed
	 * on a page at a particular location. They are not 'attached' to an object.
	 * <br />
	 * This plugin current supports <br />
	 * <li> Goto Page (set pageNumber and top in options)
	 * <li> Goto Name (set name and top in options)
	 * <li> Goto URL (set url in options)
	 * <p>
	 * 	The destination magnification factor can also be specified when goto is a page number or a named destination. (see documentation below)
	 *  (set magFactor in options).  XYZ is the default.
	 * </p>
	 * <p>
	 *  Links, Text, Popup, and FreeText are supported.
	 * </p>
	 * <p>
	 * Options In PDF spec Not Implemented Yet
	 * <li> link border
	 * <li> named target
	 * <li> page coordinates
	 * <li> destination page scaling and layout
	 * <li> actions other than URL and GotoPage
	 * <li> background / hover actions
	 * </p>
	 */ /*
	    Destination Magnification Factors
	    See PDF 1.3 Page 386 for meanings and options
	
	    [supported]
		XYZ (options; left top zoom)
		Fit (no options)
		FitH (options: top)
		FitV (options: left)
	
		[not supported]
		FitR
		FitB
		FitBH
		FitBV
	 */(function(jsPDFAPI){'use strict';var annotationPlugin={ /**
	   * An array of arrays, indexed by <em>pageNumber</em>.
	   */annotations:[],f2:function f2(number){return number.toFixed(2);},notEmpty:function notEmpty(obj){if(typeof obj != 'undefined'){if(obj != ''){return true;}}}};jsPDF.API.annotationPlugin = annotationPlugin;jsPDF.API.events.push(['addPage',function(info){this.annotationPlugin.annotations[info.pageNumber] = [];}]);jsPDFAPI.events.push(['putPage',function(info){ //TODO store annotations in pageContext so reorder/remove will not affect them.
	var pageAnnos=this.annotationPlugin.annotations[info.pageNumber];var found=false;for(var a=0;a < pageAnnos.length && !found;a++) {var anno=pageAnnos[a];switch(anno.type){case 'link':if(annotationPlugin.notEmpty(anno.options.url) || annotationPlugin.notEmpty(anno.options.pageNumber)){found = true;break;}case 'reference':case 'text':case 'freetext':found = true;break;}}if(found == false){return;}this.internal.write("/Annots [");var f2=this.annotationPlugin.f2;var k=this.internal.scaleFactor;var pageHeight=this.internal.pageSize.height;var pageInfo=this.internal.getPageInfo(info.pageNumber);for(var a=0;a < pageAnnos.length;a++) {var anno=pageAnnos[a];switch(anno.type){case 'reference': // References to Widget Anotations (for AcroForm Fields)
	this.internal.write(' ' + anno.object.objId + ' 0 R ');break;case 'text': // Create a an object for both the text and the popup
	var objText=this.internal.newAdditionalObject();var objPopup=this.internal.newAdditionalObject();var title=anno.title || 'Note';var rect="/Rect [" + f2(anno.bounds.x * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + " " + f2((anno.bounds.x + anno.bounds.w) * k) + " " + f2((pageHeight - anno.bounds.y) * k) + "] ";line = '<</Type /Annot /Subtype /' + 'Text' + ' ' + rect + '/Contents (' + anno.contents + ')';line += ' /Popup ' + objPopup.objId + " 0 R";line += ' /P ' + pageInfo.objId + " 0 R";line += ' /T (' + title + ') >>';objText.content = line;var parent=objText.objId + ' 0 R';var popoff=30;var rect="/Rect [" + f2((anno.bounds.x + popoff) * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + " " + f2((anno.bounds.x + anno.bounds.w + popoff) * k) + " " + f2((pageHeight - anno.bounds.y) * k) + "] "; //var rect2 = "/Rect [" + f2(anno.bounds.x * k) + " " + f2((pageHeight - anno.bounds.y) * k) + " " + f2(anno.bounds.x + anno.bounds.w * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + "] ";
	line = '<</Type /Annot /Subtype /' + 'Popup' + ' ' + rect + ' /Parent ' + parent;if(anno.open){line += ' /Open true';}line += ' >>';objPopup.content = line;this.internal.write(objText.objId,'0 R',objPopup.objId,'0 R');break;case 'freetext':var rect="/Rect [" + f2(anno.bounds.x * k) + " " + f2((pageHeight - anno.bounds.y) * k) + " " + f2(anno.bounds.x + anno.bounds.w * k) + " " + f2(pageHeight - (anno.bounds.y + anno.bounds.h) * k) + "] ";var color=anno.color || '#000000';line = '<</Type /Annot /Subtype /' + 'FreeText' + ' ' + rect + '/Contents (' + anno.contents + ')';line += ' /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#' + color + ')';line += ' /Border [0 0 0]';line += ' >>';this.internal.write(line);break;case 'link':if(anno.options.name){var loc=this.annotations._nameMap[anno.options.name];anno.options.pageNumber = loc.page;anno.options.top = loc.y;}else {if(!anno.options.top){anno.options.top = 0;}} //var pageHeight = this.internal.pageSize.height * this.internal.scaleFactor;
	var rect="/Rect [" + f2(anno.x * k) + " " + f2((pageHeight - anno.y) * k) + " " + f2(anno.x + anno.w * k) + " " + f2(pageHeight - (anno.y + anno.h) * k) + "] ";var line='';if(anno.options.url){line = '<</Type /Annot /Subtype /Link ' + rect + '/Border [0 0 0] /A <</S /URI /URI (' + anno.options.url + ') >>';}else if(anno.options.pageNumber){ // first page is 0
	var info=this.internal.getPageInfo(anno.options.pageNumber);line = '<</Type /Annot /Subtype /Link ' + rect + '/Border [0 0 0] /Dest [' + info.objId + " 0 R";anno.options.magFactor = anno.options.magFactor || "XYZ";switch(anno.options.magFactor){case 'Fit':line += ' /Fit]';break;case 'FitH': //anno.options.top = anno.options.top || f2(pageHeight * k);
	line += ' /FitH ' + anno.options.top + ']';break;case 'FitV':anno.options.left = anno.options.left || 0;line += ' /FitV ' + anno.options.left + ']';break;case 'XYZ':default:var top=f2((pageHeight - anno.options.top) * k); // || f2(pageHeight * k);
	anno.options.left = anno.options.left || 0; // 0 or null zoom will not change zoom factor
	if(typeof anno.options.zoom === 'undefined'){anno.options.zoom = 0;}line += ' /XYZ ' + anno.options.left + ' ' + top + ' ' + anno.options.zoom + ']';break;}}else { // TODO error - should not be here
	}if(line != ''){line += " >>";this.internal.write(line);}break;}}this.internal.write("]");}]);jsPDFAPI.createAnnotation = function(options){switch(options.type){case 'link':this.link(options.bounds.x,options.bounds.y,options.bounds.w,options.bounds.h,options);break;case 'text':case 'freetext':this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(options);break;}}; /**
	  * valid options
	  * <li> pageNumber or url [required]
	  * <p>If pageNumber is specified, top and zoom may also be specified</p>
	  */jsPDFAPI.link = function(x,y,w,h,options){'use strict';this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:x,y:y,w:w,h:h,options:options,type:'link'});}; /**
	  * valid options
	  * <li> pageNumber or url [required]
	  * <p>If pageNumber is specified, top and zoom may also be specified</p>
	  */jsPDFAPI.link = function(x,y,w,h,options){'use strict';this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:x,y:y,w:w,h:h,options:options,type:'link'});}; /**
	  * Currently only supports single line text.
	  * Returns the width of the text/link
	  */jsPDFAPI.textWithLink = function(text,x,y,options){'use strict';var width=this.getTextWidth(text);var height=this.internal.getLineHeight();this.text(text,x,y); //TODO We really need the text baseline height to do this correctly.
	// Or ability to draw text on top, bottom, center, or baseline.
	y += height * .2;this.link(x,y - height,width,height,options);return width;}; //TODO move into external library
	jsPDFAPI.getTextWidth = function(text){'use strict';var fontSize=this.internal.getFontSize();var txtWidth=this.getStringUnitWidth(text) * fontSize / this.internal.scaleFactor;return txtWidth;}; //TODO move into external library
	jsPDFAPI.getLineHeight = function(){return this.internal.getLineHeight();};return this;})(jsPDF.API); /**
	 * jsPDF Autoprint Plugin
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.autoPrint = function(){'use strict';var refAutoPrintTag;this.internal.events.subscribe('postPutResources',function(){refAutoPrintTag = this.internal.newObject();this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj");});this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");});return this;};})(jsPDF.API); /**
	 * jsPDF Canvas PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * This plugin mimics the HTML5 Canvas
	 * 
	 * The goal is to provide a way for current canvas users to print directly to a PDF.
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['initialized',function(){this.canvas.pdf = this;}]);jsPDFAPI.canvas = {getContext:function getContext(name){this.pdf.context2d._canvas = this;return this.pdf.context2d;},style:{}};Object.defineProperty(jsPDFAPI.canvas,'width',{get:function get(){return this._width;},set:function set(value){this._width = value;this.getContext('2d').pageWrapX = value + 1;}});Object.defineProperty(jsPDFAPI.canvas,'height',{get:function get(){return this._height;},set:function set(value){this._height = value;this.getContext('2d').pageWrapY = value + 1;}});return this;})(jsPDF.API); /** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /*jslint browser:true */ /*global document: false, jsPDF */var fontName,fontSize,fontStyle,padding=3,margin=13,headerFunction,lastCellPos={x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined},pages=1,setLastCellPosition=function setLastCellPosition(x,y,w,h,ln){lastCellPos = {'x':x,'y':y,'w':w,'h':h,'ln':ln};},getLastCellPosition=function getLastCellPosition(){return lastCellPos;},NO_MARGINS={left:0,top:0,bottom:0};jsPDFAPI.setHeaderFunction = function(func){headerFunction = func;};jsPDFAPI.getTextDimensions = function(txt){fontName = this.internal.getFont().fontName;fontSize = this.table_font_size || this.internal.getFontSize();fontStyle = this.internal.getFont().fontStyle; // 1 pixel = 0.264583 mm and 1 mm = 72/25.4 point
	var px2pt=0.264583 * 72 / 25.4,dimensions,text;text = document.createElement('font');text.id = "jsPDFCell";try{text.style.fontStyle = fontStyle;}catch(e) {text.style.fontWeight = fontStyle;}text.style.fontName = fontName;text.style.fontSize = fontSize + 'pt';try{text.textContent = txt;}catch(e) {text.innerText = txt;}document.body.appendChild(text);dimensions = {w:(text.offsetWidth + 1) * px2pt,h:(text.offsetHeight + 1) * px2pt};document.body.removeChild(text);return dimensions;};jsPDFAPI.cellAddPage = function(){var margins=this.margins || NO_MARGINS;this.addPage();setLastCellPosition(margins.left,margins.top,undefined,undefined); //setLastCellPosition(undefined, undefined, undefined, undefined, undefined);
	pages += 1;};jsPDFAPI.cellInitialize = function(){lastCellPos = {x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined};pages = 1;};jsPDFAPI.cell = function(x,y,w,h,txt,ln,align){var curCell=getLastCellPosition();var pgAdded=false; // If this is not the first cell, we must change its position
	if(curCell.ln !== undefined){if(curCell.ln === ln){ //Same line
	x = curCell.x + curCell.w;y = curCell.y;}else { //New line
	var margins=this.margins || NO_MARGINS;if(curCell.y + curCell.h + h + margin >= this.internal.pageSize.height - margins.bottom){this.cellAddPage();pgAdded = true;if(this.printHeaders && this.tableHeaderRow){this.printHeaderRow(ln,true);}} //We ignore the passed y: the lines may have different heights
	y = getLastCellPosition().y + getLastCellPosition().h;if(pgAdded)y = margin + 10;}}if(txt[0] !== undefined){if(this.printingHeaderRow){this.rect(x,y,w,h,'FD');}else {this.rect(x,y,w,h);}if(align === 'right'){if(!(txt instanceof Array)){txt = [txt];}for(var i=0;i < txt.length;i++) {var currentLine=txt[i];var textSize=this.getStringUnitWidth(currentLine) * this.internal.getFontSize();this.text(currentLine,x + w - textSize - padding,y + this.internal.getLineHeight() * (i + 1));}}else {this.text(txt,x + padding,y + this.internal.getLineHeight());}}setLastCellPosition(x,y,w,h,ln);return this;}; /**
	     * Return the maximum value from an array
	     * @param array
	     * @param comparisonFn
	     * @returns {*}
	     */jsPDFAPI.arrayMax = function(array,comparisonFn){var max=array[0],i,ln,item;for(i = 0,ln = array.length;i < ln;i += 1) {item = array[i];if(comparisonFn){if(comparisonFn(max,item) === -1){max = item;}}else {if(item > max){max = item;}}}return max;}; /**
	     * Create a table from a set of data.
	     * @param {Integer} [x] : left-position for top-left corner of table
	     * @param {Integer} [y] top-position for top-left corner of table
	     * @param {Object[]} [data] As array of objects containing key-value pairs corresponding to a row of data.
	     * @param {String[]} [headers] Omit or null to auto-generate headers at a performance cost
	      * @param {Object} [config.printHeaders] True to print column headers at the top of every page
	     * @param {Object} [config.autoSize] True to dynamically set the column widths to match the widest cell value
	     * @param {Object} [config.margins] margin values for left, top, bottom, and width
	     * @param {Object} [config.fontSize] Integer fontSize to use (optional)
	     */jsPDFAPI.table = function(x,y,data,headers,config){if(!data){throw 'No data for PDF table';}var headerNames=[],headerPrompts=[],header,i,ln,cln,columnMatrix={},columnWidths={},columnData,column,columnMinWidths=[],j,tableHeaderConfigs=[],model,jln,func, //set up defaults. If a value is provided in config, defaults will be overwritten:
	autoSize=false,printHeaders=true,fontSize=12,margins=NO_MARGINS;margins.width = this.internal.pageSize.width;if(config){ //override config defaults if the user has specified non-default behavior:
	if(config.autoSize === true){autoSize = true;}if(config.printHeaders === false){printHeaders = false;}if(config.fontSize){fontSize = config.fontSize;}if(config.css && typeof config.css['font-size'] !== "undefined"){fontSize = config.css['font-size'] * 16;}if(config.margins){margins = config.margins;}} /**
	         * @property {Number} lnMod
	         * Keep track of the current line number modifier used when creating cells
	         */this.lnMod = 0;lastCellPos = {x:undefined,y:undefined,w:undefined,h:undefined,ln:undefined},pages = 1;this.printHeaders = printHeaders;this.margins = margins;this.setFontSize(fontSize);this.table_font_size = fontSize; // Set header values
	if(headers === undefined || headers === null){ // No headers defined so we derive from data
	headerNames = Object.keys(data[0]);}else if(headers[0] && typeof headers[0] !== 'string'){var px2pt=0.264583 * 72 / 25.4; // Split header configs into names and prompts
	for(i = 0,ln = headers.length;i < ln;i += 1) {header = headers[i];headerNames.push(header.name);headerPrompts.push(header.prompt);columnWidths[header.name] = header.width * px2pt;}}else {headerNames = headers;}if(autoSize){ // Create a matrix of columns e.g., {column_title: [row1_Record, row2_Record]}
	func = function func(rec){return rec[header];};for(i = 0,ln = headerNames.length;i < ln;i += 1) {header = headerNames[i];columnMatrix[header] = data.map(func); // get header width
	columnMinWidths.push(this.getTextDimensions(headerPrompts[i] || header).w);column = columnMatrix[header]; // get cell widths
	for(j = 0,cln = column.length;j < cln;j += 1) {columnData = column[j];columnMinWidths.push(this.getTextDimensions(columnData).w);} // get final column width
	columnWidths[header] = jsPDFAPI.arrayMax(columnMinWidths); //have to reset
	columnMinWidths = [];}} // -- Construct the table
	if(printHeaders){var lineHeight=this.calculateLineHeight(headerNames,columnWidths,headerPrompts.length?headerPrompts:headerNames); // Construct the header row
	for(i = 0,ln = headerNames.length;i < ln;i += 1) {header = headerNames[i];tableHeaderConfigs.push([x,y,columnWidths[header],lineHeight,String(headerPrompts.length?headerPrompts[i]:header)]);} // Store the table header config
	this.setTableHeaderRow(tableHeaderConfigs); // Print the header for the start of the table
	this.printHeaderRow(1,false);} // Construct the data rows
	for(i = 0,ln = data.length;i < ln;i += 1) {var lineHeight;model = data[i];lineHeight = this.calculateLineHeight(headerNames,columnWidths,model);for(j = 0,jln = headerNames.length;j < jln;j += 1) {header = headerNames[j];this.cell(x,y,columnWidths[header],lineHeight,model[header],i + 2,header.align);}}this.lastCellPos = lastCellPos;this.table_x = x;this.table_y = y;return this;}; /**
	     * Calculate the height for containing the highest column
	     * @param {String[]} headerNames is the header, used as keys to the data
	     * @param {Integer[]} columnWidths is size of each column
	     * @param {Object[]} model is the line of data we want to calculate the height of
	     */jsPDFAPI.calculateLineHeight = function(headerNames,columnWidths,model){var header,lineHeight=0;for(var j=0;j < headerNames.length;j++) {header = headerNames[j];model[header] = this.splitTextToSize(String(model[header]),columnWidths[header] - padding);var h=this.internal.getLineHeight() * model[header].length + padding;if(h > lineHeight)lineHeight = h;}return lineHeight;}; /**
	     * Store the config for outputting a table header
	     * @param {Object[]} config
	     * An array of cell configs that would define a header row: Each config matches the config used by jsPDFAPI.cell
	     * except the ln parameter is excluded
	     */jsPDFAPI.setTableHeaderRow = function(config){this.tableHeaderRow = config;}; /**
	     * Output the store header row
	     * @param lineNumber The line number to output the header at
	     */jsPDFAPI.printHeaderRow = function(lineNumber,new_page){if(!this.tableHeaderRow){throw 'Property tableHeaderRow does not exist.';}var tableHeaderCell,tmpArray,i,ln;this.printingHeaderRow = true;if(headerFunction !== undefined){var position=headerFunction(this,pages);setLastCellPosition(position[0],position[1],position[2],position[3],-1);}this.setFontStyle('bold');var tempHeaderConf=[];for(i = 0,ln = this.tableHeaderRow.length;i < ln;i += 1) {this.setFillColor(200,200,200);tableHeaderCell = this.tableHeaderRow[i];if(new_page){this.margins.top = margin;tableHeaderCell[1] = this.margins && this.margins.top || 0;tempHeaderConf.push(tableHeaderCell);}tmpArray = [].concat(tableHeaderCell);this.cell.apply(this,tmpArray.concat(lineNumber));}if(tempHeaderConf.length > 0){this.setTableHeaderRow(tempHeaderConf);}this.setFontStyle('normal');this.printingHeaderRow = false;};})(jsPDF.API); /**
	 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	 *
	 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	 */ /**
	 * This plugin mimics the HTML5 Canvas's context2d.
	 *
	 * The goal is to provide a way for current canvas implementations to print directly to a PDF.
	 */ /**
	 * TODO implement stroke opacity (refactor from fill() method )
	 * TODO transform angle and radii parameters
	 */ /**
	 * require('jspdf.js'); require('lib/css_colors.js');
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['initialized',function(){this.context2d.pdf = this;this.context2d.internal.pdf = this;this.context2d.ctx = new context();this.context2d.ctxStack = [];this.context2d.path = [];}]);jsPDFAPI.context2d = {pageWrapXEnabled:false,pageWrapYEnabled:false,pageWrapX:9999999,pageWrapY:9999999,ctx:new context(),f2:function f2(number){return number.toFixed(2);},fillRect:function fillRect(x,y,w,h){if(this._isFillTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"f");},strokeRect:function strokeRect(x,y,w,h){if(this._isStrokeTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"s");}, /**
	         * We cannot clear PDF commands that were already written to PDF, so we use white instead. <br />
	         * As a special case, read a special flag (ignoreClearRect) and do nothing if it is set.
	         * This results in all calls to clearRect() to do nothing, and keep the canvas transparent.
	         * This flag is stored in the save/restore context and is managed the same way as other drawing states.
	         * @param x
	         * @param y
	         * @param w
	         * @param h
	         */clearRect:function clearRect(x,y,w,h){if(this.ctx.ignoreClearRect){return;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});this.save();this.setFillStyle('#ffffff'); //TODO This is hack to fill with white.
	this.pdf.rect(xRect.x,xRect.y,xRect.w,xRect.h,"f");this.restore();},save:function save(){this.ctx._fontSize = this.pdf.internal.getFontSize();var ctx=new context();ctx.copy(this.ctx);this.ctxStack.push(this.ctx);this.ctx = ctx;},restore:function restore(){this.ctx = this.ctxStack.pop();this.setFillStyle(this.ctx.fillStyle);this.setStrokeStyle(this.ctx.strokeStyle);this.setFont(this.ctx.font);this.pdf.setFontSize(this.ctx._fontSize);this.setLineCap(this.ctx.lineCap);this.setLineWidth(this.ctx.lineWidth);this.setLineJoin(this.ctx.lineJoin);},rect:function rect(x,y,w,h){this.moveTo(x,y);this.lineTo(x + w,y);this.lineTo(x + w,y + h);this.lineTo(x,y + h);this.lineTo(x,y); //TODO not needed
	this.closePath();},beginPath:function beginPath(){this.path = [];},closePath:function closePath(){this.path.push({type:'close'});},_getRgba:function _getRgba(style){ // get the decimal values of r, g, and b;
	var rgba={};if(this.internal.rxTransparent.test(style)){rgba.r = 0;rgba.g = 0;rgba.b = 0;rgba.a = 0;}else {var m=this.internal.rxRgb.exec(style);if(m != null){rgba.r = parseInt(m[1]);rgba.g = parseInt(m[2]);rgba.b = parseInt(m[3]);rgba.a = 1;}else {m = this.internal.rxRgba.exec(style);if(m != null){rgba.r = parseInt(m[1]);rgba.g = parseInt(m[2]);rgba.b = parseInt(m[3]);rgba.a = parseFloat(m[4]);}else {rgba.a = 1;if(style.charAt(0) != '#'){style = CssColors.colorNameToHex(style);if(!style){style = '#000000';}}else {}if(style.length === 4){rgba.r = style.substring(1,2);rgba.r += r;rgba.g = style.substring(2,3);rgba.g += g;rgba.b = style.substring(3,4);rgba.b += b;}else {rgba.r = style.substring(1,3);rgba.g = style.substring(3,5);rgba.b = style.substring(5,7);}rgba.r = parseInt(rgba.r,16);rgba.g = parseInt(rgba.g,16);rgba.b = parseInt(rgba.b,16);}}}rgba.style = style;return rgba;},setFillStyle:function setFillStyle(style){ // get the decimal values of r, g, and b;
	var r,g,b,a;if(this.internal.rxTransparent.test(style)){r = 0;g = 0;b = 0;a = 0;}else {var m=this.internal.rxRgb.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);a = 1;}else {m = this.internal.rxRgba.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);a = parseFloat(m[4]);}else {a = 1;if(style.charAt(0) != '#'){style = CssColors.colorNameToHex(style);if(!style){style = '#000000';}}else {}if(style.length === 4){r = style.substring(1,2);r += r;g = style.substring(2,3);g += g;b = style.substring(3,4);b += b;}else {r = style.substring(1,3);g = style.substring(3,5);b = style.substring(5,7);}r = parseInt(r,16);g = parseInt(g,16);b = parseInt(b,16);}}}this.ctx.fillStyle = style;this.ctx._isFillTransparent = a == 0;this.ctx._fillOpacity = a;this.pdf.setFillColor(r,g,b,{a:a});this.pdf.setTextColor(r,g,b,{a:a});},setStrokeStyle:function setStrokeStyle(style){var rgba=this._getRgba(style);this.ctx.strokeStyle = rgba.style;this.ctx._isStrokeTransparent = rgba.a == 0;this.ctx._strokeOpacity = rgba.a; //TODO jsPDF to handle rgba
	if(rgba.a === 0){this.pdf.setDrawColor(255,255,255);}else if(rgba.a === 1){this.pdf.setDrawColor(rgba.r,rgba.g,rgba.b);}else { //this.pdf.setDrawColor(rgba.r, rgba.g, rgba.b, {a: rgba.a});
	this.pdf.setDrawColor(rgba.r,rgba.g,rgba.b);}},fillText:function fillText(text,x,y,maxWidth){if(this._isFillTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var rads=this._matrix_rotation(this.ctx._transform);var degs=rads * 57.2958; //TODO only push the clip if it has not been applied to the current PDF context
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.pdf.internal.pages[1];}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(null,true);this.ctx._clip_path = this.path;this.path = origPath;}this.pdf.text(text,x,this._getBaseline(y),null,degs);if(this.ctx._clip_path.length > 0){lines.push('Q');}},strokeText:function strokeText(text,x,y,maxWidth){if(this._isStrokeTransparent()){return;}x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var rads=this._matrix_rotation(this.ctx._transform);var degs=rads * 57.2958; //TODO only push the clip if it has not been applied to the current PDF context
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.pdf.internal.pages[1];}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(null,true);this.ctx._clip_path = this.path;this.path = origPath;}this.pdf.text(text,x,this._getBaseline(y),{stroke:true},degs);if(this.ctx._clip_path.length > 0){lines.push('Q');}},setFont:function setFont(font){this.ctx.font = font; //var rx = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+["']?(\w+)['"]?/;
	var rx=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;m = rx.exec(font);if(m != null){var fontStyle=m[1];var fontVariant=m[2];var fontWeight=m[3];var fontSize=m[4];var fontSizeUnit=m[5];var fontFamily=m[6];if('px' === fontSizeUnit){fontSize = Math.floor(parseFloat(fontSize)); // fontSize = fontSize * 1.25;
	}else if('em' === fontSizeUnit){fontSize = Math.floor(parseFloat(fontSize) * this.pdf.getFontSize());}else {fontSize = Math.floor(parseFloat(fontSize));}this.pdf.setFontSize(fontSize);if(fontWeight === 'bold' || fontWeight === '700'){this.pdf.setFontStyle('bold');}else {if(fontStyle === 'italic'){this.pdf.setFontStyle('italic');}else {this.pdf.setFontStyle('normal');}}var name=fontFamily;var parts=name.toLowerCase().split(/\s*,\s*/);var jsPdfFontName;if(parts.indexOf('arial') != -1){jsPdfFontName = 'Arial';}else if(parts.indexOf('verdana') != -1){jsPdfFontName = 'Verdana';}else if(parts.indexOf('helvetica') != -1){jsPdfFontName = 'Helvetica';}else if(parts.indexOf('sans-serif') != -1){jsPdfFontName = 'sans-serif';}else if(parts.indexOf('fixed') != -1){jsPdfFontName = 'Fixed';}else if(parts.indexOf('monospace') != -1){jsPdfFontName = 'Monospace';}else if(parts.indexOf('terminal') != -1){jsPdfFontName = 'Terminal';}else if(parts.indexOf('courier') != -1){jsPdfFontName = 'Courier';}else if(parts.indexOf('times') != -1){jsPdfFontName = 'Times';}else if(parts.indexOf('cursive') != -1){jsPdfFontName = 'Cursive';}else if(parts.indexOf('fantasy') != -1){jsPdfFontName = 'Fantasy';}else if(parts.indexOf('serif') != -1){jsPdfFontName = 'Serif';}else {jsPdfFontName = 'Serif';} //TODO check more cases
	var style;if('bold' === fontWeight){style = 'bold';}else {style = 'normal';}this.pdf.setFont(jsPdfFontName,style);}else {var rx=/(\d+)(pt|px|em)\s+(\w+)\s*(\w+)?/;var m=rx.exec(font);if(m != null){var size=m[1];var unit=m[2];var name=m[3];var style=m[4];if(!style){style = 'normal';}if('em' === fontSizeUnit){size = Math.floor(parseFloat(fontSize) * this.pdf.getFontSize());}else {size = Math.floor(parseFloat(size));}this.pdf.setFontSize(size);this.pdf.setFont(name,style);}}},setTextBaseline:function setTextBaseline(baseline){this.ctx.textBaseline = baseline;},getTextBaseline:function getTextBaseline(){return this.ctx.textBaseline;}, //TODO implement textAlign
	setTextAlign:function setTextAlign(align){this.ctx.textAlign = align;},getTextAlign:function getTextAlign(){return this.ctx.textAlign;},setLineWidth:function setLineWidth(width){this.ctx.lineWidth = width;this.pdf.setLineWidth(width);},setLineCap:function setLineCap(style){this.ctx.lineCap = style;this.pdf.setLineCap(style);},setLineJoin:function setLineJoin(style){this.ctx.lineJoin = style;this.pdf.setLineJoin(style);},moveTo:function moveTo(x,y){x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var obj={type:'mt',x:x,y:y};this.path.push(obj);},_wrapX:function _wrapX(x){if(this.pageWrapXEnabled){return x % this.pageWrapX;}else {return x;}},_wrapY:function _wrapY(y){if(this.pageWrapYEnabled){this._gotoPage(this._page(y));return (y - this.lastBreak) % this.pageWrapY;}else {return y;}},transform:function transform(a,b,c,d,e,f){ //TODO apply to current transformation instead of replacing
	this.ctx._transform = [a,b,c,d,e,f];},setTransform:function setTransform(a,b,c,d,e,f){this.ctx._transform = [a,b,c,d,e,f];},_getTransform:function _getTransform(){return this.ctx._transform;},lastBreak:0, // Y Position of page breaks.
	pageBreaks:[], // returns: One-based Page Number
	// Should only be used if pageWrapYEnabled is true
	_page:function _page(y){if(this.pageWrapYEnabled){this.lastBreak = 0;var manualBreaks=0;var autoBreaks=0;for(var i=0;i < this.pageBreaks.length;i++) {if(y >= this.pageBreaks[i]){manualBreaks++;if(this.lastBreak === 0){autoBreaks++;}var spaceBetweenLastBreak=this.pageBreaks[i] - this.lastBreak;this.lastBreak = this.pageBreaks[i];var pagesSinceLastBreak=Math.floor(spaceBetweenLastBreak / this.pageWrapY);autoBreaks += pagesSinceLastBreak;}}if(this.lastBreak === 0){var pagesSinceLastBreak=Math.floor(y / this.pageWrapY) + 1;autoBreaks += pagesSinceLastBreak;}return autoBreaks + manualBreaks;}else {return this.pdf.internal.getCurrentPageInfo().pageNumber;}},_gotoPage:function _gotoPage(pageOneBased){ // This is a stub to be overriden if needed
	},lineTo:function lineTo(x,y){x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var obj={type:'lt',x:x,y:y};this.path.push(obj);},bezierCurveTo:function bezierCurveTo(x1,y1,x2,y2,x,y){x1 = this._wrapX(x1);y1 = this._wrapY(y1);x2 = this._wrapX(x2);y2 = this._wrapY(y2);x = this._wrapX(x);y = this._wrapY(y);var xpt;xpt = this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x1,y1]);x1 = xpt[0];y1 = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x2,y2]);x2 = xpt[0];y2 = xpt[1];var obj={type:'bct',x1:x1,y1:y1,x2:x2,y2:y2,x:x,y:y};this.path.push(obj);},quadraticCurveTo:function quadraticCurveTo(x1,y1,x,y){x1 = this._wrapX(x1);y1 = this._wrapY(y1);x = this._wrapX(x);y = this._wrapY(y);var xpt;xpt = this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];xpt = this._matrix_map_point(this.ctx._transform,[x1,y1]);x1 = xpt[0];y1 = xpt[1];var obj={type:'qct',x1:x1,y1:y1,x:x,y:y};this.path.push(obj);},arc:function arc(x,y,radius,startAngle,endAngle,anticlockwise){x = this._wrapX(x);y = this._wrapY(y);var xpt=this._matrix_map_point(this.ctx._transform,[x,y]);x = xpt[0];y = xpt[1];var obj={type:'arc',x:x,y:y,radius:radius,startAngle:startAngle,endAngle:endAngle,anticlockwise:anticlockwise};this.path.push(obj);},drawImage:function drawImage(img,x,y,w,h,x2,y2,w2,h2){if(x2 !== undefined){x = x2;y = y2;w = w2;h = h2;}x = this._wrapX(x);y = this._wrapY(y);var xRect=this._matrix_map_rect(this.ctx._transform,{x:x,y:y,w:w,h:h});var xRect2=this._matrix_map_rect(this.ctx._transform,{x:x2,y:y2,w:w2,h:h2}); // TODO implement source clipping and image scaling
	var format;var rx=/data:image\/(\w+).*/i;var m=rx.exec(img);if(m != null){format = m[1];}else { // format = "jpeg";
	format = "png";}this.pdf.addImage(img,format,xRect.x,xRect.y,xRect.w,xRect.h);}, /**
	         * Multiply the first matrix by the second
	         * @param m1
	         * @param m2
	         * @returns {*[]}
	         * @private
	         */_matrix_multiply:function _matrix_multiply(m2,m1){var sx=m1[0];var shy=m1[1];var shx=m1[2];var sy=m1[3];var tx=m1[4];var ty=m1[5];var t0=sx * m2[0] + shy * m2[2];var t2=shx * m2[0] + sy * m2[2];var t4=tx * m2[0] + ty * m2[2] + m2[4];shy = sx * m2[1] + shy * m2[3];sy = shx * m2[1] + sy * m2[3];ty = tx * m2[1] + ty * m2[3] + m2[5];sx = t0;shx = t2;tx = t4;return [sx,shy,shx,sy,tx,ty];},_matrix_rotation:function _matrix_rotation(m){return Math.atan2(m[2],m[0]);},_matrix_decompose:function _matrix_decompose(matrix){var a=matrix[0];var b=matrix[1];var c=matrix[2];var d=matrix[3];var scaleX=Math.sqrt(a * a + b * b);a /= scaleX;b /= scaleX;var shear=a * c + b * d;c -= a * shear;d -= b * shear;var scaleY=Math.sqrt(c * c + d * d);c /= scaleY;d /= scaleY;shear /= scaleY;if(a * d < b * c){a = -a;b = -b;shear = -shear;scaleX = -scaleX;}return {scale:[scaleX,0,0,scaleY,0,0],translate:[1,0,0,1,matrix[4],matrix[5]],rotate:[a,b,-b,a,0,0],skew:[1,0,shear,1,0,0]};},_matrix_map_point:function _matrix_map_point(m1,pt){var sx=m1[0];var shy=m1[1];var shx=m1[2];var sy=m1[3];var tx=m1[4];var ty=m1[5];var px=pt[0];var py=pt[1];var x=px * sx + py * shx + tx;var y=px * shy + py * sy + ty;return [x,y];},_matrix_map_point_obj:function _matrix_map_point_obj(m1,pt){var xpt=this._matrix_map_point(m1,[pt.x,pt.y]);return {x:xpt[0],y:xpt[1]};},_matrix_map_rect:function _matrix_map_rect(m1,rect){var p1=this._matrix_map_point(m1,[rect.x,rect.y]);var p2=this._matrix_map_point(m1,[rect.x + rect.w,rect.y + rect.h]);return {x:p1[0],y:p1[1],w:p2[0] - p1[0],h:p2[1] - p1[1]};},_matrix_is_identity:function _matrix_is_identity(m1){if(m1[0] != 1){return false;}if(m1[1] != 0){return false;}if(m1[2] != 0){return false;}if(m1[3] != 1){return false;}if(m1[4] != 0){return false;}if(m1[5] != 0){return false;}return true;},rotate:function rotate(angle){var matrix=[Math.cos(angle),Math.sin(angle),-Math.sin(angle),Math.cos(angle),0.0,0.0];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},scale:function scale(sx,sy){var matrix=[sx,0.0,0.0,sy,0.0,0.0];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},translate:function translate(x,y){var matrix=[1.0,0.0,0.0,1.0,x,y];this.ctx._transform = this._matrix_multiply(this.ctx._transform,matrix);},stroke:function stroke(){if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.pdf.internal.pages[1];}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._stroke(true);this.ctx._clip_path = this.path;this.path = origPath;this._stroke(false);lines.push("Q");}else {this._stroke(false);}},_stroke:function _stroke(isClip){if(!isClip && this._isStrokeTransparent()){return;} //TODO opacity
	var moves=[];var closed=false;var xPath=this.path;for(var i=0;i < xPath.length;i++) {var pt=xPath[i];switch(pt.type){case 'mt':moves.push({start:pt,deltas:[],abs:[]});break;case 'lt':var delta=[pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);moves[moves.length - 1].abs.push(pt);break;case 'bct':var delta=[pt.x1 - xPath[i - 1].x,pt.y1 - xPath[i - 1].y,pt.x2 - xPath[i - 1].x,pt.y2 - xPath[i - 1].y,pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'qct': // convert to bezier
	var x1=xPath[i - 1].x + 2.0 / 3.0 * (pt.x1 - xPath[i - 1].x);var y1=xPath[i - 1].y + 2.0 / 3.0 * (pt.y1 - xPath[i - 1].y);var x2=pt.x + 2.0 / 3.0 * (pt.x1 - pt.x);var y2=pt.y + 2.0 / 3.0 * (pt.y1 - pt.y);var x3=pt.x;var y3=pt.y;var delta=[x1 - xPath[i - 1].x,y1 - xPath[i - 1].y,x2 - xPath[i - 1].x,y2 - xPath[i - 1].y,x3 - xPath[i - 1].x,y3 - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'arc':moves[moves.length - 1].arc = true;moves[moves.length - 1].abs.push(pt);break;case 'close':closed = true;break;}}for(var i=0;i < moves.length;i++) {var style;if(i == moves.length - 1){style = 's';}else {style = null;}if(moves[i].arc){var arcs=moves[i].abs;for(var ii=0;ii < arcs.length;ii++) {var arc=arcs[ii];var start=arc.startAngle * 360 / (2 * Math.PI);var end=arc.endAngle * 360 / (2 * Math.PI);var x=arc.x;var y=arc.y;this.internal.arc2(this,x,y,arc.radius,start,end,arc.anticlockwise,style,isClip);}}else {var x=moves[i].start.x;var y=moves[i].start.y;if(!isClip){this.pdf.lines(moves[i].deltas,x,y,null,style);}else {this.pdf.lines(moves[i].deltas,x,y,null,null);this.pdf.clip_fixed();}}}},_isFillTransparent:function _isFillTransparent(){return this.ctx._isFillTransparent || this.globalAlpha == 0;},_isStrokeTransparent:function _isStrokeTransparent(){return this.ctx._isStrokeTransparent || this.globalAlpha == 0;},fill:function fill(fillRule){ //evenodd or nonzero (default)
	if(this.ctx._clip_path.length > 0){var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.pdf.internal.pages[1];}lines.push("q");var origPath=this.path;this.path = this.ctx._clip_path;this.ctx._clip_path = [];this._fill(fillRule,true);this.ctx._clip_path = this.path;this.path = origPath;this._fill(fillRule,false);lines.push('Q');}else {this._fill(fillRule,false);}},_fill:function _fill(fillRule,isClip){if(this._isFillTransparent()){return;}var v2Support=typeof this.pdf.internal.newObject2 === 'function';var lines;if(window.outIntercept){lines = window.outIntercept.type === 'group'?window.outIntercept.stream:window.outIntercept;}else {lines = this.pdf.internal.pages[1];} // if (this.ctx._clip_path.length > 0) {
	//     lines.push('q');
	//     var oldPath = this.path;
	//     this.path = this.ctx._clip_path;
	//     this.ctx._clip_path = [];
	//     this._fill(fillRule, true);
	//     this.ctx._clip_path = this.path;
	//     this.path = oldPath;
	// }
	var moves=[];var outInterceptOld=window.outIntercept;if(v2Support){ // Blend and Mask
	switch(this.ctx.globalCompositeOperation){case 'normal':case 'source-over':break;case 'destination-in':case 'destination-out': //TODO this need to be added to the current group or page
	// define a mask stream
	var obj=this.pdf.internal.newStreamObject(); // define a mask state
	var obj2=this.pdf.internal.newObject2();obj2.push('<</Type /ExtGState');obj2.push('/SMask <</S /Alpha /G ' + obj.objId + ' 0 R>>'); // /S /Luminosity will need to define color space
	obj2.push('>>'); // add mask to page resources
	var gsName='MASK' + obj2.objId;this.pdf.internal.addGraphicsState(gsName,obj2.objId);var instruction='/' + gsName + ' gs'; // add mask to page, group, or stream
	lines.splice(0,0,'q');lines.splice(1,0,instruction);lines.push('Q');window.outIntercept = obj;break;default:var dictionaryEntry='/' + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];if(dictionaryEntry){this.pdf.internal.out(dictionaryEntry + ' gs');}break;}}var alpha=this.ctx.globalAlpha;if(this.ctx._fillOpacity < 1){ // TODO combine this with global opacity
	alpha = this.ctx._fillOpacity;} //TODO check for an opacity graphics state that was already created
	//TODO do not set opacity if current value is already active
	if(v2Support){var objOpac=this.pdf.internal.newObject2();objOpac.push('<</Type /ExtGState'); //objOpac.push(this.ctx.globalAlpha + " CA"); // Stroke
	//objOpac.push(this.ctx.globalAlpha + " ca"); // Not Stroke
	objOpac.push('/CA ' + alpha); // Stroke
	objOpac.push('/ca ' + alpha); // Not Stroke
	objOpac.push('>>');var gsName='GS_O_' + objOpac.objId;this.pdf.internal.addGraphicsState(gsName,objOpac.objId);this.pdf.internal.out('/' + gsName + ' gs');}var xPath=this.path;for(var i=0;i < xPath.length;i++) {var pt=xPath[i];switch(pt.type){case 'mt':moves.push({start:pt,deltas:[],abs:[]});break;case 'lt':var delta=[pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);moves[moves.length - 1].abs.push(pt);break;case 'bct':var delta=[pt.x1 - xPath[i - 1].x,pt.y1 - xPath[i - 1].y,pt.x2 - xPath[i - 1].x,pt.y2 - xPath[i - 1].y,pt.x - xPath[i - 1].x,pt.y - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'qct': // convert to bezier
	var x1=xPath[i - 1].x + 2.0 / 3.0 * (pt.x1 - xPath[i - 1].x);var y1=xPath[i - 1].y + 2.0 / 3.0 * (pt.y1 - xPath[i - 1].y);var x2=pt.x + 2.0 / 3.0 * (pt.x1 - pt.x);var y2=pt.y + 2.0 / 3.0 * (pt.y1 - pt.y);var x3=pt.x;var y3=pt.y;var delta=[x1 - xPath[i - 1].x,y1 - xPath[i - 1].y,x2 - xPath[i - 1].x,y2 - xPath[i - 1].y,x3 - xPath[i - 1].x,y3 - xPath[i - 1].y];moves[moves.length - 1].deltas.push(delta);break;case 'arc': //TODO this was hack to avoid out of bounds issue
	if(moves.length == 0){moves.push({start:{x:0,y:0},deltas:[],abs:[]});}moves[moves.length - 1].arc = true;moves[moves.length - 1].abs.push(pt);break;case 'close': //moves[moves.length - 1].deltas.push('close');
	break;}}for(var i=0;i < moves.length;i++) {var style;if(i == moves.length - 1){style = 'f';if(fillRule === 'evenodd'){style += '*';}}else {style = null;}if(moves[i].arc){var arcs=moves[i].abs;for(var ii=0;ii < arcs.length;ii++) {var arc=arcs[ii]; //TODO lines deltas were getting in here
	if(typeof arc.startAngle !== 'undefined'){var start=arc.startAngle * 360 / (2 * Math.PI);var end=arc.endAngle * 360 / (2 * Math.PI); // Add the current position (last move to)
	//var x = moves[i].start.x + arc.x;
	//var y = moves[i].start.y + arc.y;
	var x=arc.x;var y=arc.y;if(ii == 0){this.internal.move2(this,x,y);}this.internal.arc2(this,x,y,arc.radius,start,end,arc.anticlockwise,null,isClip);}else {this.internal.line2(c2d,arc.x,arc.y);}} // extra move bug causing close to resolve to wrong point
	var x=moves[i].start.x;var y=moves[i].start.y;this.internal.line2(c2d,x,y);this.pdf.internal.out('h');this.pdf.internal.out('f');}else {var x=moves[i].start.x;var y=moves[i].start.y;if(!isClip){this.pdf.lines(moves[i].deltas,x,y,null,style);}else {this.pdf.lines(moves[i].deltas,x,y,null,null);this.pdf.clip_fixed();}}}window.outIntercept = outInterceptOld; // if (this.ctx._clip_path.length > 0) {
	//     lines.push('Q');
	// }
	},pushMask:function pushMask(){var v2Support=typeof this.pdf.internal.newObject2 === 'function';if(!v2Support){console.log('jsPDF v2 not enabled');return;} // define a mask stream
	var obj=this.pdf.internal.newStreamObject(); // define a mask state
	var obj2=this.pdf.internal.newObject2();obj2.push('<</Type /ExtGState');obj2.push('/SMask <</S /Alpha /G ' + obj.objId + ' 0 R>>'); // /S /Luminosity will need to define color space
	obj2.push('>>'); // add mask to page resources
	var gsName='MASK' + obj2.objId;this.pdf.internal.addGraphicsState(gsName,obj2.objId);var instruction='/' + gsName + ' gs';this.pdf.internal.out(instruction);},clip:function clip(){ //TODO do we reset the path, or just copy it?
	if(this.ctx._clip_path.length > 0){for(var i=0;i < this.path.length;i++) {this.ctx._clip_path.push(this.path[i]);}}else {this.ctx._clip_path = this.path;}this.path = [];},measureText:function measureText(text){var pdf=this.pdf;return Object.defineProperties({getWidth:function getWidth(){var fontSize=pdf.internal.getFontSize();var txtWidth=pdf.getStringUnitWidth(text) * fontSize / pdf.internal.scaleFactor;return txtWidth;}},{width:{get:function get(){return this.getWidth(text);},configurable:true,enumerable:true}});},_getBaseline:function _getBaseline(y){var height=parseInt(this.pdf.internal.getFontSize()); // TODO Get descent from font descriptor
	var descent=height * .25;switch(this.ctx.textBaseline){case 'bottom':return y - descent;case 'top':return y + height;case 'hanging':return y + height - descent;case 'middle':return y + height / 2 - descent;case 'ideographic': // TODO not implemented
	return y;case 'alphabetic':default:return y;}}};var c2d=jsPDFAPI.context2d; // accessor methods
	Object.defineProperty(c2d,'fillStyle',{set:function set(value){this.setFillStyle(value);},get:function get(){return this.ctx.fillStyle;}});Object.defineProperty(c2d,'strokeStyle',{set:function set(value){this.setStrokeStyle(value);},get:function get(){return this.ctx.strokeStyle;}});Object.defineProperty(c2d,'lineWidth',{set:function set(value){this.setLineWidth(value);},get:function get(){return this.ctx.lineWidth;}});Object.defineProperty(c2d,'lineCap',{set:function set(val){this.setLineCap(val);},get:function get(){return this.ctx.lineCap;}});Object.defineProperty(c2d,'lineJoin',{set:function set(val){this.setLineJoin(val);},get:function get(){return this.ctx.lineJoin;}});Object.defineProperty(c2d,'miterLimit',{set:function set(val){this.ctx.miterLimit = val;},get:function get(){return this.ctx.miterLimit;}});Object.defineProperty(c2d,'textBaseline',{set:function set(value){this.setTextBaseline(value);},get:function get(){return this.getTextBaseline();}});Object.defineProperty(c2d,'textAlign',{set:function set(value){this.setTextAlign(value);},get:function get(){return this.getTextAlign();}});Object.defineProperty(c2d,'font',{set:function set(value){this.setFont(value);},get:function get(){return this.ctx.font;}});Object.defineProperty(c2d,'globalCompositeOperation',{set:function set(value){this.ctx.globalCompositeOperation = value;},get:function get(){return this.ctx.globalCompositeOperation;}});Object.defineProperty(c2d,'globalAlpha',{set:function set(value){this.ctx.globalAlpha = value;},get:function get(){return this.ctx.globalAlpha;}}); // Not HTML API
	Object.defineProperty(c2d,'ignoreClearRect',{set:function set(value){this.ctx.ignoreClearRect = value;},get:function get(){return this.ctx.ignoreClearRect;}}); // End Not HTML API
	c2d.internal = {};c2d.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/;c2d.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/;c2d.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/; // http://hansmuller-flex.blogspot.com/2011/10/more-about-approximating-circular-arcs.html
	c2d.internal.arc = function(c2d,xc,yc,r,a1,a2,anticlockwise,style){var includeMove=true;var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2;var a1r=a1 * (Math.PI / 180);var a2r=a2 * (Math.PI / 180);var curves=this.createArc(r,a1r,a2r,anticlockwise);var pathData=null;for(var i=0;i < curves.length;i++) {var curve=curves[i];if(includeMove && i == 0){this.pdf.internal.out([f2((curve.x1 + xc) * k),f2((pageHeight - (curve.y1 + yc)) * k),'m',f2((curve.x2 + xc) * k),f2((pageHeight - (curve.y2 + yc)) * k),f2((curve.x3 + xc) * k),f2((pageHeight - (curve.y3 + yc)) * k),f2((curve.x4 + xc) * k),f2((pageHeight - (curve.y4 + yc)) * k),'c'].join(' '));}else {this.pdf.internal.out([f2((curve.x2 + xc) * k),f2((pageHeight - (curve.y2 + yc)) * k),f2((curve.x3 + xc) * k),f2((pageHeight - (curve.y3 + yc)) * k),f2((curve.x4 + xc) * k),f2((pageHeight - (curve.y4 + yc)) * k),'c'].join(' '));} //c2d._lastPoint = {x: curve.x1 + xc, y: curve.y1 + yc};
	c2d._lastPoint = {x:xc,y:yc}; // f2((curve.x1 + xc) * k), f2((pageHeight - (curve.y1 + yc)) * k), 'm', f2((curve.x2 + xc) * k), f2((pageHeight - (curve.y2 + yc)) * k), f2((curve.x3 + xc) * k), f2((pageHeight - (curve.y3 + yc)) * k), f2((curve.x4 + xc) * k), f2((pageHeight - (curve.y4 + yc)) * k), 'c'
	}if(style !== null){this.pdf.internal.out(this.pdf.internal.getStyle(style));}}; /**
	     *
	     * @param x Edge point X
	     * @param y Edge point Y
	     * @param r Radius
	     * @param a1 start angle
	     * @param a2 end angle
	     * @param anticlockwise
	     * @param style
	     * @param isClip
	     */c2d.internal.arc2 = function(c2d,x,y,r,a1,a2,anticlockwise,style,isClip){ // we need to convert from cartesian to polar here methinks.
	var centerX=x; // + r;
	var centerY=y;if(!isClip){this.arc(c2d,centerX,centerY,r,a1,a2,anticlockwise,style);}else {this.arc(c2d,centerX,centerY,r,a1,a2,anticlockwise,null);this.pdf.clip_fixed();}};c2d.internal.move2 = function(c2d,x,y){var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2;this.pdf.internal.out([f2(x * k),f2((pageHeight - y) * k),'m'].join(' '));c2d._lastPoint = {x:x,y:y};};c2d.internal.line2 = function(c2d,dx,dy){var k=this.pdf.internal.scaleFactor;var pageHeight=this.pdf.internal.pageSize.height;var f2=this.pdf.internal.f2; //var pt = {x: c2d._lastPoint.x + dx, y: c2d._lastPoint.y + dy};
	var pt={x:dx,y:dy};this.pdf.internal.out([f2(pt.x * k),f2((pageHeight - pt.y) * k),'l'].join(' ')); //this.pdf.internal.out('f');
	c2d._lastPoint = pt;}; /**
	     * Return a array of objects that represent bezier curves which approximate the circular arc centered at the origin, from startAngle to endAngle (radians) with the specified radius.
	     *
	     * Each bezier curve is an object with four points, where x1,y1 and x4,y4 are the arc's end points and x2,y2 and x3,y3 are the cubic bezier's control points.
	     */c2d.internal.createArc = function(radius,startAngle,endAngle,anticlockwise){var EPSILON=0.00001; // Roughly 1/1000th of a degree, see below
	// normalize startAngle, endAngle to [-2PI, 2PI]
	var twoPI=Math.PI * 2;var startAngleN=startAngle;if(startAngleN < twoPI || startAngleN > twoPI){startAngleN = startAngleN % twoPI;}var endAngleN=endAngle;if(endAngleN < twoPI || endAngleN > twoPI){endAngleN = endAngleN % twoPI;} // Compute the sequence of arc curves, up to PI/2 at a time.
	// Total arc angle is less than 2PI.
	var curves=[];var piOverTwo=Math.PI / 2.0; // var sgn = (startAngle < endAngle) ? +1 : -1; // clockwise or counterclockwise
	var sgn=anticlockwise?-1:+1;var a1=startAngle;for(var totalAngle=Math.min(twoPI,Math.abs(endAngleN - startAngleN));totalAngle > EPSILON;) {var a2=a1 + sgn * Math.min(totalAngle,piOverTwo);curves.push(this.createSmallArc(radius,a1,a2));totalAngle -= Math.abs(a2 - a1);a1 = a2;}return curves;}; /**
	     * Cubic bezier approximation of a circular arc centered at the origin, from (radians) a1 to a2, where a2-a1 < pi/2. The arc's radius is r.
	     *
	     * Returns an object with four points, where x1,y1 and x4,y4 are the arc's end points and x2,y2 and x3,y3 are the cubic bezier's control points.
	     *
	     * This algorithm is based on the approach described in: A. Riškus, "Approximation of a Cubic Bezier Curve by Circular Arcs and Vice Versa," Information Technology and Control, 35(4), 2006 pp. 371-378.
	     */c2d.internal.createSmallArc = function(r,a1,a2){ // Compute all four points for an arc that subtends the same total angle
	// but is centered on the X-axis
	var a=(a2 - a1) / 2.0;var x4=r * Math.cos(a);var y4=r * Math.sin(a);var x1=x4;var y1=-y4;var q1=x1 * x1 + y1 * y1;var q2=q1 + x1 * x4 + y1 * y4;var k2=4 / 3 * (Math.sqrt(2 * q1 * q2) - q2) / (x1 * y4 - y1 * x4);var x2=x1 - k2 * y1;var y2=y1 + k2 * x1;var x3=x2;var y3=-y2; // Find the arc points' actual locations by computing x1,y1 and x4,y4
	// and rotating the control points by a + a1
	var ar=a + a1;var cos_ar=Math.cos(ar);var sin_ar=Math.sin(ar);return {x1:r * Math.cos(a1),y1:r * Math.sin(a1),x2:x2 * cos_ar - y2 * sin_ar,y2:x2 * sin_ar + y2 * cos_ar,x3:x3 * cos_ar - y3 * sin_ar,y3:x3 * sin_ar + y3 * cos_ar,x4:r * Math.cos(a2),y4:r * Math.sin(a2)};};function context(){this._isStrokeTransparent = false;this._strokeOpacity = 1;this.strokeStyle = '#000000';this.fillStyle = '#000000';this._isFillTransparent = false;this._fillOpacity = 1;this.font = "12pt times";this.textBaseline = 'alphabetic'; // top,bottom,middle,ideographic,alphabetic,hanging
	this.textAlign = 'start';this.lineWidth = 1;this.lineJoin = 'miter'; // round, bevel, miter
	this.lineCap = 'butt'; // butt, round, square
	this._transform = [1,0,0,1,0,0]; // sx, shy, shx, sy, tx, ty
	this.globalCompositeOperation = 'normal';this.globalAlpha = 1.0;this._clip_path = []; // TODO miter limit //default 10
	// Not HTML API
	this.ignoreClearRect = false;this.copy = function(ctx){this._isStrokeTransparent = ctx._isStrokeTransparent;this._strokeOpacity = ctx._strokeOpacity;this.strokeStyle = ctx.strokeStyle;this._isFillTransparent = ctx._isFillTransparent;this._fillOpacity = ctx._fillOpacity;this.fillStyle = ctx.fillStyle;this.font = ctx.font;this.lineWidth = ctx.lineWidth;this.lineJoin = ctx.lineJoin;this.lineCap = ctx.lineCap;this.textBaseline = ctx.textBaseline;this.textAlign = ctx.textAlign;this._fontSize = ctx._fontSize;this._transform = ctx._transform.slice(0);this.globalCompositeOperation = ctx.globalCompositeOperation;this.globalAlpha = ctx.globalAlpha;this._clip_path = ctx._clip_path.slice(0); //TODO deep copy?
	// Not HTML API
	this.ignoreClearRect = ctx.ignoreClearRect;};}return this;})(jsPDF.API); /** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *               2014 Steven Spungin, https://github.com/flamenco
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){var clone,_DrillForContent,FontNameDB,FontStyleMap,TextAlignMap,FontWeightMap,FloatMap,ClearMap,GetCSS,PurgeWhiteSpace,Renderer,ResolveFont,ResolveUnitedNumber,UnitedNumberMap,elementHandledElsewhere,images,loadImgs,checkForFooter,process,tableToJson;clone = (function(){return function(obj){Clone.prototype = obj;return new Clone();};function Clone(){}})();PurgeWhiteSpace = function PurgeWhiteSpace(array){var fragment,i,l,lTrimmed,r,rTrimmed,trailingSpace;i = 0;l = array.length;fragment = void 0;lTrimmed = false;rTrimmed = false;while(!lTrimmed && i !== l) {fragment = array[i] = array[i].trimLeft();if(fragment){lTrimmed = true;}i++;}i = l - 1;while(l && !rTrimmed && i !== -1) {fragment = array[i] = array[i].trimRight();if(fragment){rTrimmed = true;}i--;}r = /\s+$/g;trailingSpace = true;i = 0;while(i !== l) { // Leave the line breaks intact
	if(array[i] != '\u2028'){fragment = array[i].replace(/\s+/g," ");if(trailingSpace){fragment = fragment.trimLeft();}if(fragment){trailingSpace = r.test(fragment);}array[i] = fragment;}i++;}return array;};Renderer = function Renderer(pdf,x,y,settings){this.pdf = pdf;this.x = x;this.y = y;this.settings = settings; //list of functions which are called after each element-rendering process
	this.watchFunctions = [];this.init();return this;};ResolveFont = function ResolveFont(css_font_family_string){var name,part,parts;name = void 0;parts = css_font_family_string.split(",");part = parts.shift();while(!name && part) {name = FontNameDB[part.trim().toLowerCase()];part = parts.shift();}return name;};ResolveUnitedNumber = function ResolveUnitedNumber(css_line_height_string){ //IE8 issues
	css_line_height_string = css_line_height_string === "auto"?"0px":css_line_height_string;if(css_line_height_string.indexOf("em") > -1 && !isNaN(Number(css_line_height_string.replace("em","")))){css_line_height_string = Number(css_line_height_string.replace("em","")) * 18.719 + "px";}if(css_line_height_string.indexOf("pt") > -1 && !isNaN(Number(css_line_height_string.replace("pt","")))){css_line_height_string = Number(css_line_height_string.replace("pt","")) * 1.333 + "px";}var normal,undef,value;undef = void 0;normal = 16.00;value = UnitedNumberMap[css_line_height_string];if(value){return value;}value = ({"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0})[{css_line_height_string:css_line_height_string}];if(value !== undef){return UnitedNumberMap[css_line_height_string] = value / normal;}if(value = parseFloat(css_line_height_string)){return UnitedNumberMap[css_line_height_string] = value / normal;}value = css_line_height_string.match(/([\d\.]+)(px)/);if(value.length === 3){return UnitedNumberMap[css_line_height_string] = parseFloat(value[1]) / normal;}return UnitedNumberMap[css_line_height_string] = 1;};GetCSS = function GetCSS(element){var css,tmp,computedCSSElement;computedCSSElement = (function(el){var compCSS;compCSS = (function(el){if(document.defaultView && document.defaultView.getComputedStyle){return document.defaultView.getComputedStyle(el,null);}else if(el.currentStyle){return el.currentStyle;}else {return el.style;}})(el);return function(prop){prop = prop.replace(/-\D/g,function(match){return match.charAt(1).toUpperCase();});return compCSS[prop];};})(element);css = {};tmp = void 0;css["font-family"] = ResolveFont(computedCSSElement("font-family")) || "times";css["font-style"] = FontStyleMap[computedCSSElement("font-style")] || "normal";css["text-align"] = TextAlignMap[computedCSSElement("text-align")] || "left";tmp = FontWeightMap[computedCSSElement("font-weight")] || "normal";if(tmp === "bold"){if(css["font-style"] === "normal"){css["font-style"] = tmp;}else {css["font-style"] = tmp + css["font-style"];}}css["font-size"] = ResolveUnitedNumber(computedCSSElement("font-size")) || 1;css["line-height"] = ResolveUnitedNumber(computedCSSElement("line-height")) || 1;css["display"] = computedCSSElement("display") === "inline"?"inline":"block";tmp = css["display"] === "block";css["margin-top"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-top")) || 0;css["margin-bottom"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-bottom")) || 0;css["padding-top"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-top")) || 0;css["padding-bottom"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-bottom")) || 0;css["margin-left"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-left")) || 0;css["margin-right"] = tmp && ResolveUnitedNumber(computedCSSElement("margin-right")) || 0;css["padding-left"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-left")) || 0;css["padding-right"] = tmp && ResolveUnitedNumber(computedCSSElement("padding-right")) || 0;css["page-break-before"] = computedCSSElement("page-break-before") || "auto"; //float and clearing of floats
	css["float"] = FloatMap[computedCSSElement("cssFloat")] || "none";css["clear"] = ClearMap[computedCSSElement("clear")] || "none";css["color"] = computedCSSElement("color");return css;};elementHandledElsewhere = function elementHandledElsewhere(element,renderer,elementHandlers){var handlers,i,isHandledElsewhere,l,t;isHandledElsewhere = false;i = void 0;l = void 0;t = void 0;handlers = elementHandlers["#" + element.id];if(handlers){if(typeof handlers === "function"){isHandledElsewhere = handlers(element,renderer);}else {i = 0;l = handlers.length;while(!isHandledElsewhere && i !== l) {isHandledElsewhere = handlers[i](element,renderer);i++;}}}handlers = elementHandlers[element.nodeName];if(!isHandledElsewhere && handlers){if(typeof handlers === "function"){isHandledElsewhere = handlers(element,renderer);}else {i = 0;l = handlers.length;while(!isHandledElsewhere && i !== l) {isHandledElsewhere = handlers[i](element,renderer);i++;}}}return isHandledElsewhere;};tableToJson = function tableToJson(table,renderer){var data,headers,i,j,rowData,tableRow,table_obj,table_with,cell,l;data = [];headers = [];i = 0;l = table.rows[0].cells.length;table_with = table.clientWidth;while(i < l) {cell = table.rows[0].cells[i];headers[i] = {name:cell.textContent.toLowerCase().replace(/\s+/g,''),prompt:cell.textContent.replace(/\r?\n/g,''),width:cell.clientWidth / table_with * renderer.pdf.internal.pageSize.width};i++;}i = 1;while(i < table.rows.length) {tableRow = table.rows[i];rowData = {};j = 0;while(j < tableRow.cells.length) {rowData[headers[j].name] = tableRow.cells[j].textContent.replace(/\r?\n/g,'');j++;}data.push(rowData);i++;}return table_obj = {rows:data,headers:headers};};var SkipNode={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1};var listCount=1;_DrillForContent = function DrillForContent(element,renderer,elementHandlers){var cn,cns,fragmentCSS,i,isBlock,l,px2pt,table2json,cb;cns = element.childNodes;cn = void 0;fragmentCSS = GetCSS(element);isBlock = fragmentCSS.display === "block";if(isBlock){renderer.setBlockBoundary();renderer.setBlockStyle(fragmentCSS);}px2pt = 0.264583 * 72 / 25.4;i = 0;l = cns.length;while(i < l) {cn = cns[i];if((typeof cn === "undefined"?"undefined":_typeof(cn)) === "object"){ //execute all watcher functions to e.g. reset floating
	renderer.executeWatchFunctions(cn); /*** HEADER rendering **/if(cn.nodeType === 1 && cn.nodeName === 'HEADER'){var header=cn; //store old top margin
	var oldMarginTop=renderer.pdf.margins_doc.top; //subscribe for new page event and render header first on every page
	renderer.pdf.internal.events.subscribe('addPage',function(pageInfo){ //set current y position to old margin
	renderer.y = oldMarginTop; //render all child nodes of the header element
	_DrillForContent(header,renderer,elementHandlers); //set margin to old margin + rendered header + 10 space to prevent overlapping
	//important for other plugins (e.g. table) to start rendering at correct position after header
	renderer.pdf.margins_doc.top = renderer.y + 10;renderer.y += 10;},false);}if(cn.nodeType === 8 && cn.nodeName === "#comment"){if(~cn.textContent.indexOf("ADD_PAGE")){renderer.pdf.addPage();renderer.y = renderer.pdf.margins_doc.top;}}else if(cn.nodeType === 1 && !SkipNode[cn.nodeName]){ /*** IMAGE RENDERING ***/var cached_image;if(cn.nodeName === "IMG"){var url=cn.getAttribute("src");cached_image = images[renderer.pdf.sHashCode(url) || url];}if(cached_image){if(renderer.pdf.internal.pageSize.height - renderer.pdf.margins_doc.bottom < renderer.y + cn.height && renderer.y > renderer.pdf.margins_doc.top){renderer.pdf.addPage();renderer.y = renderer.pdf.margins_doc.top; //check if we have to set back some values due to e.g. header rendering for new page
	renderer.executeWatchFunctions(cn);}var imagesCSS=GetCSS(cn);var imageX=renderer.x;var fontToUnitRatio=12 / renderer.pdf.internal.scaleFactor; //define additional paddings, margins which have to be taken into account for margin calculations
	var additionalSpaceLeft=(imagesCSS["margin-left"] + imagesCSS["padding-left"]) * fontToUnitRatio;var additionalSpaceRight=(imagesCSS["margin-right"] + imagesCSS["padding-right"]) * fontToUnitRatio;var additionalSpaceTop=(imagesCSS["margin-top"] + imagesCSS["padding-top"]) * fontToUnitRatio;var additionalSpaceBottom=(imagesCSS["margin-bottom"] + imagesCSS["padding-bottom"]) * fontToUnitRatio; //if float is set to right, move the image to the right border
	//add space if margin is set
	if(imagesCSS['float'] !== undefined && imagesCSS['float'] === 'right'){imageX += renderer.settings.width - cn.width - additionalSpaceRight;}else {imageX += additionalSpaceLeft;}renderer.pdf.addImage(cached_image,imageX,renderer.y + additionalSpaceTop,cn.width,cn.height);cached_image = undefined; //if the float prop is specified we have to float the text around the image
	if(imagesCSS['float'] === 'right' || imagesCSS['float'] === 'left'){ //add functiont to set back coordinates after image rendering
	renderer.watchFunctions.push((function(diffX,thresholdY,diffWidth,el){ //undo drawing box adaptions which were set by floating
	if(renderer.y >= thresholdY){renderer.x += diffX;renderer.settings.width += diffWidth;return true;}else if(el && el.nodeType === 1 && !SkipNode[el.nodeName] && renderer.x + el.width > renderer.pdf.margins_doc.left + renderer.pdf.margins_doc.width){renderer.x += diffX;renderer.y = thresholdY;renderer.settings.width += diffWidth;return true;}else {return false;}}).bind(this,imagesCSS['float'] === 'left'?-cn.width - additionalSpaceLeft - additionalSpaceRight:0,renderer.y + cn.height + additionalSpaceTop + additionalSpaceBottom,cn.width)); //reset floating by clear:both divs
	//just set cursorY after the floating element
	renderer.watchFunctions.push((function(yPositionAfterFloating,pages,el){if(renderer.y < yPositionAfterFloating && pages === renderer.pdf.internal.getNumberOfPages()){if(el.nodeType === 1 && GetCSS(el).clear === 'both'){renderer.y = yPositionAfterFloating;return true;}else {return false;}}else {return true;}}).bind(this,renderer.y + cn.height,renderer.pdf.internal.getNumberOfPages())); //if floating is set we decrease the available width by the image width
	renderer.settings.width -= cn.width + additionalSpaceLeft + additionalSpaceRight; //if left just add the image width to the X coordinate
	if(imagesCSS['float'] === 'left'){renderer.x += cn.width + additionalSpaceLeft + additionalSpaceRight;}}else { //if no floating is set, move the rendering cursor after the image height
	renderer.y += cn.height + additionalSpaceTop + additionalSpaceBottom;} /*** TABLE RENDERING ***/}else if(cn.nodeName === "TABLE"){table2json = tableToJson(cn,renderer);renderer.y += 10;renderer.pdf.table(renderer.x,renderer.y,table2json.rows,table2json.headers,{autoSize:false,printHeaders:elementHandlers.printHeaders,margins:renderer.pdf.margins_doc,css:GetCSS(cn)});renderer.y = renderer.pdf.lastCellPos.y + renderer.pdf.lastCellPos.h + 20;}else if(cn.nodeName === "OL" || cn.nodeName === "UL"){listCount = 1;if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}renderer.y += 10;}else if(cn.nodeName === "LI"){var temp=renderer.x;renderer.x += 20 / renderer.pdf.internal.scaleFactor;renderer.y += 3;if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}renderer.x = temp;}else if(cn.nodeName === "BR"){renderer.y += fragmentCSS["font-size"] * renderer.pdf.internal.scaleFactor;renderer.addText('\u2028',clone(fragmentCSS));}else {if(!elementHandledElsewhere(cn,renderer,elementHandlers)){_DrillForContent(cn,renderer,elementHandlers);}}}else if(cn.nodeType === 3){var value=cn.nodeValue;if(cn.nodeValue && cn.parentNode.nodeName === "LI"){if(cn.parentNode.parentNode.nodeName === "OL"){value = listCount++ + '. ' + value;}else {var fontSize=fragmentCSS["font-size"];var offsetX=(3 - fontSize * 0.75) * renderer.pdf.internal.scaleFactor;var offsetY=fontSize * 0.75 * renderer.pdf.internal.scaleFactor;var radius=fontSize * 1.74 / renderer.pdf.internal.scaleFactor;cb = function cb(x,y){this.pdf.circle(x + offsetX,y + offsetY,radius,'FD');};}} // Only add the text if the text node is in the body element
	// Add compatibility with IE11
	if(!!(cn.ownerDocument.body.compareDocumentPosition(cn) & 16)){renderer.addText(value,fragmentCSS);}}else if(typeof cn === "string"){renderer.addText(cn,fragmentCSS);}}i++;}elementHandlers.outY = renderer.y;if(isBlock){return renderer.setBlockBoundary(cb);}};images = {};loadImgs = function loadImgs(element,renderer,elementHandlers,cb){var imgs=element.getElementsByTagName('img'),l=imgs.length,found_images,x=0;function done(){renderer.pdf.internal.events.publish('imagesLoaded');cb(found_images);}function loadImage(url,width,height){if(!url)return;var img=new Image();found_images = ++x;img.crossOrigin = '';img.onerror = img.onload = function(){if(img.complete){ //to support data urls in images, set width and height
	//as those values are not recognized automatically
	if(img.src.indexOf('data:image/') === 0){img.width = width || img.width || 0;img.height = height || img.height || 0;} //if valid image add to known images array
	if(img.width + img.height){var hash=renderer.pdf.sHashCode(url) || url;images[hash] = images[hash] || img;}}if(! --x){done();}};img.src = url;}while(l--) {loadImage(imgs[l].getAttribute("src"),imgs[l].width,imgs[l].height);}return x || done();};checkForFooter = function checkForFooter(elem,renderer,elementHandlers){ //check if we can found a <footer> element
	var footer=elem.getElementsByTagName("footer");if(footer.length > 0){footer = footer[0]; //bad hack to get height of footer
	//creat dummy out and check new y after fake rendering
	var oldOut=renderer.pdf.internal.write;var oldY=renderer.y;renderer.pdf.internal.write = function(){};_DrillForContent(footer,renderer,elementHandlers);var footerHeight=Math.ceil(renderer.y - oldY) + 5;renderer.y = oldY;renderer.pdf.internal.write = oldOut; //add 20% to prevent overlapping
	renderer.pdf.margins_doc.bottom += footerHeight; //Create function render header on every page
	var renderFooter=function renderFooter(pageInfo){var pageNumber=pageInfo !== undefined?pageInfo.pageNumber:1; //set current y position to old margin
	var oldPosition=renderer.y; //render all child nodes of the header element
	renderer.y = renderer.pdf.internal.pageSize.height - renderer.pdf.margins_doc.bottom;renderer.pdf.margins_doc.bottom -= footerHeight; //check if we have to add page numbers
	var spans=footer.getElementsByTagName('span');for(var i=0;i < spans.length;++i) { //if we find some span element with class pageCounter, set the page
	if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" pageCounter ") > -1){spans[i].innerHTML = pageNumber;} //if we find some span element with class totalPages, set a variable which is replaced after rendering of all pages
	if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" totalPages ") > -1){spans[i].innerHTML = '###jsPDFVarTotalPages###';}} //render footer content
	_DrillForContent(footer,renderer,elementHandlers); //set bottom margin to previous height including the footer height
	renderer.pdf.margins_doc.bottom += footerHeight; //important for other plugins (e.g. table) to start rendering at correct position after header
	renderer.y = oldPosition;}; //check if footer contains totalPages which should be replace at the disoposal of the document
	var spans=footer.getElementsByTagName('span');for(var i=0;i < spans.length;++i) {if((" " + spans[i].className + " ").replace(/[\n\t]/g," ").indexOf(" totalPages ") > -1){renderer.pdf.internal.events.subscribe('htmlRenderingFinished',renderer.pdf.putTotalPages.bind(renderer.pdf,'###jsPDFVarTotalPages###'),true);}} //register event to render footer on every new page
	renderer.pdf.internal.events.subscribe('addPage',renderFooter,false); //render footer on first page
	renderFooter(); //prevent footer rendering
	SkipNode['FOOTER'] = 1;}};process = function process(pdf,element,x,y,settings,callback){if(!element)return false;if(typeof element !== "string" && !element.parentNode)element = '' + element.innerHTML;if(typeof element === "string"){element = (function(element){var $frame,$hiddendiv,framename,visuallyhidden;framename = "jsPDFhtmlText" + Date.now().toString() + (Math.random() * 1000).toFixed(0);visuallyhidden = "position: absolute !important;" + "clip: rect(1px 1px 1px 1px); /* IE6, IE7 */" + "clip: rect(1px, 1px, 1px, 1px);" + "padding:0 !important;" + "border:0 !important;" + "height: 1px !important;" + "width: 1px !important; " + "top:auto;" + "left:-100px;" + "overflow: hidden;";$hiddendiv = document.createElement('div');$hiddendiv.style.cssText = visuallyhidden;$hiddendiv.innerHTML = "<iframe style=\"height:1px;width:1px\" name=\"" + framename + "\" />";document.body.appendChild($hiddendiv);$frame = window.frames[framename];$frame.document.open();$frame.document.writeln(element);$frame.document.close();return $frame.document.body;})(element.replace(/<\/?script[^>]*?>/gi,''));}var r=new Renderer(pdf,x,y,settings),out; // 1. load images
	// 2. prepare optional footer elements
	// 3. render content
	loadImgs.call(this,element,r,settings.elementHandlers,function(found_images){checkForFooter(element,r,settings.elementHandlers);_DrillForContent(element,r,settings.elementHandlers); //send event dispose for final taks (e.g. footer totalpage replacement)
	r.pdf.internal.events.publish('htmlRenderingFinished');out = r.dispose();if(typeof callback === 'function')callback(out);else if(found_images)console.error('jsPDF Warning: rendering issues? provide a callback to fromHTML!');});return out || {x:r.x,y:r.y};};Renderer.prototype.init = function(){this.paragraph = {text:[],style:[]};return this.pdf.internal.write("q");};Renderer.prototype.dispose = function(){this.pdf.internal.write("Q");return {x:this.x,y:this.y,ready:true};}; //Checks if we have to execute some watcher functions
	//e.g. to end text floating around an image
	Renderer.prototype.executeWatchFunctions = function(el){var ret=false;var narray=[];if(this.watchFunctions.length > 0){for(var i=0;i < this.watchFunctions.length;++i) {if(this.watchFunctions[i](el) === true){ret = true;}else {narray.push(this.watchFunctions[i]);}}this.watchFunctions = narray;}return ret;};Renderer.prototype.splitFragmentsIntoLines = function(fragments,styles){var currentLineLength,defaultFontSize,ff,fontMetrics,fontMetricsCache,fragment,fragmentChopped,fragmentLength,fragmentSpecificMetrics,fs,k,line,lines,maxLineLength,style;defaultFontSize = 12;k = this.pdf.internal.scaleFactor;fontMetricsCache = {};ff = void 0;fs = void 0;fontMetrics = void 0;fragment = void 0;style = void 0;fragmentSpecificMetrics = void 0;fragmentLength = void 0;fragmentChopped = void 0;line = [];lines = [line];currentLineLength = 0;maxLineLength = this.settings.width;while(fragments.length) {fragment = fragments.shift();style = styles.shift();if(fragment){ff = style["font-family"];fs = style["font-style"];fontMetrics = fontMetricsCache[ff + fs];if(!fontMetrics){fontMetrics = this.pdf.internal.getFont(ff,fs).metadata.Unicode;fontMetricsCache[ff + fs] = fontMetrics;}fragmentSpecificMetrics = {widths:fontMetrics.widths,kerning:fontMetrics.kerning,fontSize:style["font-size"] * defaultFontSize,textIndent:currentLineLength};fragmentLength = this.pdf.getStringUnitWidth(fragment,fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;if(fragment == '\u2028'){line = [];lines.push(line);}else if(currentLineLength + fragmentLength > maxLineLength){fragmentChopped = this.pdf.splitTextToSize(fragment,maxLineLength,fragmentSpecificMetrics);line.push([fragmentChopped.shift(),style]);while(fragmentChopped.length) {line = [[fragmentChopped.shift(),style]];lines.push(line);}currentLineLength = this.pdf.getStringUnitWidth(line[0][0],fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;}else {line.push([fragment,style]);currentLineLength += fragmentLength;}}} //if text alignment was set, set margin/indent of each line
	if(style['text-align'] !== undefined && (style['text-align'] === 'center' || style['text-align'] === 'right' || style['text-align'] === 'justify')){for(var i=0;i < lines.length;++i) {var length=this.pdf.getStringUnitWidth(lines[i][0][0],fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k; //if there is more than on line we have to clone the style object as all lines hold a reference on this object
	if(i > 0){lines[i][0][1] = clone(lines[i][0][1]);}var space=maxLineLength - length;if(style['text-align'] === 'right'){lines[i][0][1]['margin-left'] = space; //if alignment is not right, it has to be center so split the space to the left and the right
	}else if(style['text-align'] === 'center'){lines[i][0][1]['margin-left'] = space / 2; //if justify was set, calculate the word spacing and define in by using the css property
	}else if(style['text-align'] === 'justify'){var countSpaces=lines[i][0][0].split(' ').length - 1;lines[i][0][1]['word-spacing'] = space / countSpaces; //ignore the last line in justify mode
	if(i === lines.length - 1){lines[i][0][1]['word-spacing'] = 0;}}}}return lines;};Renderer.prototype.RenderTextFragment = function(text,style){var defaultFontSize,font,maxLineHeight;maxLineHeight = 0;defaultFontSize = 12;if(this.pdf.internal.pageSize.height - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize()){this.pdf.internal.write("ET","Q");this.pdf.addPage();this.y = this.pdf.margins_doc.top;this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),style.color,"Td"); //move cursor by one line on new page
	maxLineHeight = Math.max(maxLineHeight,style["line-height"],style["font-size"]);this.pdf.internal.write(0,(-1 * defaultFontSize * maxLineHeight).toFixed(2),"Td");}font = this.pdf.internal.getFont(style["font-family"],style["font-style"]); // text color
	var pdfTextColor=this.getPdfColor(style["color"]);if(pdfTextColor !== this.lastTextColor){this.pdf.internal.write(pdfTextColor);this.lastTextColor = pdfTextColor;} //set the word spacing for e.g. justify style
	if(style['word-spacing'] !== undefined && style['word-spacing'] > 0){this.pdf.internal.write(style['word-spacing'].toFixed(2),"Tw");}this.pdf.internal.write("/" + font.id,(defaultFontSize * style["font-size"]).toFixed(2),"Tf","(" + this.pdf.internal.pdfEscape(text) + ") Tj"); //set the word spacing back to neutral => 0
	if(style['word-spacing'] !== undefined){this.pdf.internal.write(0,"Tw");}}; // Accepts #FFFFFF, rgb(int,int,int), or CSS Color Name
	Renderer.prototype.getPdfColor = function(style){var textColor;var r,g,b;var rx=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/;var m=rx.exec(style);if(m != null){r = parseInt(m[1]);g = parseInt(m[2]);b = parseInt(m[3]);}else {if(style.charAt(0) != '#'){style = CssColors.colorNameToHex(style);if(!style){style = '#000000';}}r = style.substring(1,3);r = parseInt(r,16);g = style.substring(3,5);g = parseInt(g,16);b = style.substring(5,7);b = parseInt(b,16);}if(typeof r === 'string' && /^#[0-9A-Fa-f]{6}$/.test(r)){var hex=parseInt(r.substr(1),16);r = hex >> 16 & 255;g = hex >> 8 & 255;b = hex & 255;}var f3=this.f3;if(r === 0 && g === 0 && b === 0 || typeof g === 'undefined'){textColor = f3(r / 255) + ' g';}else {textColor = [f3(r / 255),f3(g / 255),f3(b / 255),'rg'].join(' ');}return textColor;};Renderer.prototype.f3 = function(number){return number.toFixed(3); // Ie, %.3f
	},Renderer.prototype.renderParagraph = function(cb){var blockstyle,defaultFontSize,fontToUnitRatio,fragments,i,l,line,lines,maxLineHeight,out,paragraphspacing_after,paragraphspacing_before,priorblockstyle,styles,fontSize;fragments = PurgeWhiteSpace(this.paragraph.text);styles = this.paragraph.style;blockstyle = this.paragraph.blockstyle;priorblockstyle = this.paragraph.priorblockstyle || {};this.paragraph = {text:[],style:[],blockstyle:{},priorblockstyle:blockstyle};if(!fragments.join("").trim()){return;}lines = this.splitFragmentsIntoLines(fragments,styles);line = void 0;maxLineHeight = void 0;defaultFontSize = 12;fontToUnitRatio = defaultFontSize / this.pdf.internal.scaleFactor;this.priorMarginBottom = this.priorMarginBottom || 0;paragraphspacing_before = (Math.max((blockstyle["margin-top"] || 0) - this.priorMarginBottom,0) + (blockstyle["padding-top"] || 0)) * fontToUnitRatio;paragraphspacing_after = ((blockstyle["margin-bottom"] || 0) + (blockstyle["padding-bottom"] || 0)) * fontToUnitRatio;this.priorMarginBottom = blockstyle["margin-bottom"] || 0;if(blockstyle['page-break-before'] === 'always'){this.pdf.addPage();this.y = 0;paragraphspacing_before = ((blockstyle["margin-top"] || 0) + (blockstyle["padding-top"] || 0)) * fontToUnitRatio;}out = this.pdf.internal.write;i = void 0;l = void 0;this.y += paragraphspacing_before;out("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"); //stores the current indent of cursor position
	var currentIndent=0;while(lines.length) {line = lines.shift();maxLineHeight = 0;i = 0;l = line.length;while(i !== l) {if(line[i][0].trim()){maxLineHeight = Math.max(maxLineHeight,line[i][1]["line-height"],line[i][1]["font-size"]);fontSize = line[i][1]["font-size"] * 7;}i++;} //if we have to move the cursor to adapt the indent
	var indentMove=0;var wantedIndent=0; //if a margin was added (by e.g. a text-alignment), move the cursor
	if(line[0][1]["margin-left"] !== undefined && line[0][1]["margin-left"] > 0){wantedIndent = this.pdf.internal.getCoordinateString(line[0][1]["margin-left"]);indentMove = wantedIndent - currentIndent;currentIndent = wantedIndent;}var indentMore=Math.max(blockstyle["margin-left"] || 0,0) * fontToUnitRatio; //move the cursor
	out(indentMove + indentMore,(-1 * defaultFontSize * maxLineHeight).toFixed(2),"Td");i = 0;l = line.length;while(i !== l) {if(line[i][0]){this.RenderTextFragment(line[i][0],line[i][1]);}i++;}this.y += maxLineHeight * fontToUnitRatio; //if some watcher function was executed successful, so e.g. margin and widths were changed,
	//reset line drawing and calculate position and lines again
	//e.g. to stop text floating around an image
	if(this.executeWatchFunctions(line[0][1]) && lines.length > 0){var localFragments=[];var localStyles=[]; //create fragment array of
	lines.forEach(function(localLine){var i=0;var l=localLine.length;while(i !== l) {if(localLine[i][0]){localFragments.push(localLine[i][0] + ' ');localStyles.push(localLine[i][1]);}++i;}}); //split lines again due to possible coordinate changes
	lines = this.splitFragmentsIntoLines(PurgeWhiteSpace(localFragments),localStyles); //reposition the current cursor
	out("ET","Q");out("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");}}if(cb && typeof cb === "function"){cb.call(this,this.x - 9,this.y - fontSize / 2);}out("ET","Q");return this.y += paragraphspacing_after;};Renderer.prototype.setBlockBoundary = function(cb){return this.renderParagraph(cb);};Renderer.prototype.setBlockStyle = function(css){return this.paragraph.blockstyle = css;};Renderer.prototype.addText = function(text,css){this.paragraph.text.push(text);return this.paragraph.style.push(css);};FontNameDB = {helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"};FontWeightMap = {100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"};FontStyleMap = {normal:"normal",italic:"italic",oblique:"italic"};TextAlignMap = {left:"left",right:"right",center:"center",justify:"justify"};FloatMap = {none:'none',right:'right',left:'left'};ClearMap = {none:'none',both:'both'};UnitedNumberMap = {normal:1}; /**
	  * Converts HTML-formatted text into formatted PDF text.
	  *
	  * Notes:
	  * 2012-07-18
	  * Plugin relies on having browser, DOM around. The HTML is pushed into dom and traversed.
	  * Plugin relies on jQuery for CSS extraction.
	  * Targeting HTML output from Markdown templating, which is a very simple
	  * markup - div, span, em, strong, p. No br-based paragraph separation supported explicitly (but still may work.)
	  * Images, tables are NOT supported.
	  *
	  * @public
	  * @function
	  * @param HTML {String or DOM Element} HTML-formatted text, or pointer to DOM element that is to be rendered into PDF.
	  * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	  * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	  * @param settings {Object} Additional / optional variables controlling parsing, rendering.
	  * @returns {Object} jsPDF instance
	  */jsPDFAPI.fromHTML = function(HTML,x,y,settings,callback,margins){"use strict";this.margins_doc = margins || {top:0,bottom:0};if(!settings)settings = {};if(!settings.elementHandlers)settings.elementHandlers = {};return process(this,HTML,isNaN(x)?4:x,isNaN(y)?4:y,settings,callback);};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * 
	 * ====================================================================
	 */ /*global jsPDF */(function(jsPDFAPI){'use strict';var jsNamesObj,jsJsObj,text;jsPDFAPI.addJS = function(txt){text = txt;this.internal.events.subscribe('postPutResources',function(txt){jsNamesObj = this.internal.newObject();this.internal.write('<< /Names [(EmbeddedJS) ' + (jsNamesObj + 1) + ' 0 R] >>','endobj');jsJsObj = this.internal.newObject();this.internal.write('<< /S /JavaScript /JS (',text,') >>','endobj');});this.internal.events.subscribe('putCatalog',function(){if(jsNamesObj !== undefined && jsJsObj !== undefined){this.internal.write('/Names <</JavaScript ' + jsNamesObj + ' 0 R>>');}});return this;};})(jsPDF.API); /**
	 * jsPDF Outline PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * Generates a PDF Outline
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.events.push(['postPutResources',function(){var pdf=this;var rx=/^(\d+) 0 obj$/; // Write action goto objects for each page
	// this.outline.destsGoto = [];
	// for (var i = 0; i < totalPages; i++) {
	// var id = pdf.internal.newObject();
	// this.outline.destsGoto.push(id);
	// pdf.internal.write("<</D[" + (i * 2 + 3) + " 0 R /XYZ null
	// null null]/S/GoTo>> endobj");
	// }
	//
	// for (var i = 0; i < dests.length; i++) {
	// pdf.internal.write("(page_" + (i + 1) + ")" + dests[i] + " 0
	// R");
	// }
	//				
	if(this.outline.root.children.length > 0){var lines=pdf.outline.render().split(/\r\n/);for(var i=0;i < lines.length;i++) {var line=lines[i];var m=rx.exec(line);if(m != null){var oid=m[1];pdf.internal.newObjectDeferredBegin(oid);}pdf.internal.write(line);}} // This code will write named destination for each page reference
	// (page_1, etc)
	if(this.outline.createNamedDestinations){var totalPages=this.internal.pages.length; // WARNING: this assumes jsPDF starts on page 3 and pageIDs
	// follow 5, 7, 9, etc
	// Write destination objects for each page
	var dests=[];for(var i=0;i < totalPages;i++) {var id=pdf.internal.newObject();dests.push(id);var info=pdf.internal.getPageInfo(i + 1);pdf.internal.write("<< /D[" + info.objId + " 0 R /XYZ null null null]>> endobj");} // assign a name for each destination
	var names2Oid=pdf.internal.newObject();pdf.internal.write('<< /Names [ ');for(var i=0;i < dests.length;i++) {pdf.internal.write("(page_" + (i + 1) + ")" + dests[i] + " 0 R");}pdf.internal.write(' ] >>','endobj'); // var kids = pdf.internal.newObject();
	// pdf.internal.write('<< /Kids [ ' + names2Oid + ' 0 R');
	// pdf.internal.write(' ] >>', 'endobj');
	var namesOid=pdf.internal.newObject();pdf.internal.write('<< /Dests ' + names2Oid + " 0 R");pdf.internal.write('>>','endobj');}}]);jsPDFAPI.events.push(['putCatalog',function(){var pdf=this;if(pdf.outline.root.children.length > 0){pdf.internal.write("/Outlines",this.outline.makeRef(this.outline.root));if(this.outline.createNamedDestinations){pdf.internal.write("/Names " + namesOid + " 0 R");} // Open with Bookmarks showing
	// pdf.internal.write("/PageMode /UseOutlines");
	}}]);jsPDFAPI.events.push(['initialized',function(){var pdf=this;pdf.outline = {createNamedDestinations:false,root:{children:[]}};var namesOid;var destsGoto=[]; /**
	   * Options: pageNumber
	   */pdf.outline.add = function(parent,title,options){var item={title:title,options:options,children:[]};if(parent == null){parent = this.root;}parent.children.push(item);return item;};pdf.outline.render = function(){this.ctx = {};this.ctx.val = '';this.ctx.pdf = pdf;this.genIds_r(this.root);this.renderRoot(this.root);this.renderItems(this.root);return this.ctx.val;};pdf.outline.genIds_r = function(node){node.id = pdf.internal.newObjectDeferred();for(var i=0;i < node.children.length;i++) {this.genIds_r(node.children[i]);}};pdf.outline.renderRoot = function(node){this.objStart(node);this.line('/Type /Outlines');if(node.children.length > 0){this.line('/First ' + this.makeRef(node.children[0]));this.line('/Last ' + this.makeRef(node.children[node.children.length - 1]));}this.line('/Count ' + this.count_r({count:0},node));this.objEnd();};pdf.outline.renderItems = function(node){for(var i=0;i < node.children.length;i++) {var item=node.children[i];this.objStart(item);this.line('/Title ' + this.makeString(item.title));this.line('/Parent ' + this.makeRef(node));if(i > 0){this.line('/Prev ' + this.makeRef(node.children[i - 1]));}if(i < node.children.length - 1){this.line('/Next ' + this.makeRef(node.children[i + 1]));}if(item.children.length > 0){this.line('/First ' + this.makeRef(item.children[0]));this.line('/Last ' + this.makeRef(item.children[item.children.length - 1]));}var count=this.count = this.count_r({count:0},item);if(count > 0){this.line('/Count ' + count);}if(item.options){if(item.options.pageNumber){ // Explicit Destination
	//WARNING this assumes page ids are 3,5,7, etc.
	var info=pdf.internal.getPageInfo(item.options.pageNumber);this.line('/Dest ' + '[' + info.objId + ' 0 R /XYZ 0 ' + this.ctx.pdf.internal.pageSize.height + ' 0]'); // this line does not work on all clients (pageNumber instead of page ref)
	//this.line('/Dest ' + '[' + (item.options.pageNumber - 1) + ' /XYZ 0 ' + this.ctx.pdf.internal.pageSize.height + ' 0]');
	// Named Destination
	// this.line('/Dest (page_' + (item.options.pageNumber) + ')');
	// Action Destination
	// var id = pdf.internal.newObject();
	// pdf.internal.write('<</D[' + (item.options.pageNumber - 1) + ' /XYZ null null null]/S/GoTo>> endobj');
	// this.line('/A ' + id + ' 0 R' );
	}}this.objEnd();}for(var i=0;i < node.children.length;i++) {var item=node.children[i];this.renderItems(item);}};pdf.outline.line = function(text){this.ctx.val += text + '\r\n';};pdf.outline.makeRef = function(node){return node.id + ' 0 R';};pdf.outline.makeString = function(val){return '(' + pdf.internal.pdfEscape(val) + ')';};pdf.outline.objStart = function(node){this.ctx.val += '\r\n' + node.id + ' 0 obj' + '\r\n<<\r\n';};pdf.outline.objEnd = function(node){this.ctx.val += '>> \r\n' + 'endobj' + '\r\n';};pdf.outline.count_r = function(ctx,node){for(var i=0;i < node.children.length;i++) {ctx.count++;this.count_r(ctx,node.children[i]);}return ctx.count;};}]);return this;})(jsPDF.API); /**@preserve
	 *  ====================================================================
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /*
	  * @see http://www.w3.org/TR/PNG-Chunks.html
	  *
	  Color    Allowed      Interpretation
	  Type     Bit Depths
	 	   0       1,2,4,8,16  Each pixel is a grayscale sample.
	 	   2       8,16        Each pixel is an R,G,B triple.
	 	   3       1,2,4,8     Each pixel is a palette index;
	                        a PLTE chunk must appear.
	 	   4       8,16        Each pixel is a grayscale sample,
	                        followed by an alpha sample.
	 	   6       8,16        Each pixel is an R,G,B triple,
	                        followed by an alpha sample.
	 */ /*
	  * PNG filter method types
	  *
	  * @see http://www.w3.org/TR/PNG-Filters.html
	  * @see http://www.libpng.org/pub/png/book/chapter09.html
	  *
	  * This is what the value 'Predictor' in decode params relates to
	  *
	  * 15 is "optimal prediction", which means the prediction algorithm can change from line to line.
	  * In that case, you actually have to read the first byte off each line for the prediction algorthim (which should be 0-4, corresponding to PDF 10-14) and select the appropriate unprediction algorithm based on that byte.
	  *
	    0       None
	    1       Sub
	    2       Up
	    3       Average
	    4       Paeth
	  */var doesNotHavePngJS=function doesNotHavePngJS(){return typeof PNG !== 'function' || typeof FlateStream !== 'function';},canCompress=function canCompress(value){return value !== jsPDFAPI.image_compression.NONE && hasCompressionJS();},hasCompressionJS=function hasCompressionJS(){var inst=typeof Deflater === 'function';if(!inst)throw new Error("requires deflate.js for compression");return inst;},compressBytes=function compressBytes(bytes,lineLength,colorsPerPixel,compression){var level=5,filter_method=filterUp;switch(compression){case jsPDFAPI.image_compression.FAST:level = 3;filter_method = filterSub;break;case jsPDFAPI.image_compression.MEDIUM:level = 6;filter_method = filterAverage;break;case jsPDFAPI.image_compression.SLOW:level = 9;filter_method = filterPaeth; //uses to sum to choose best filter for each line
	break;}bytes = applyPngFilterMethod(bytes,lineLength,colorsPerPixel,filter_method);var header=new Uint8Array(createZlibHeader(level));var checksum=adler32(bytes);var deflate=new Deflater(level);var a=deflate.append(bytes);var cBytes=deflate.flush();var len=header.length + a.length + cBytes.length;var cmpd=new Uint8Array(len + 4);cmpd.set(header);cmpd.set(a,header.length);cmpd.set(cBytes,header.length + a.length);cmpd[len++] = checksum >>> 24 & 0xff;cmpd[len++] = checksum >>> 16 & 0xff;cmpd[len++] = checksum >>> 8 & 0xff;cmpd[len++] = checksum & 0xff;return jsPDFAPI.arrayBufferToBinaryString(cmpd);},createZlibHeader=function createZlibHeader(bytes,level){ /*
	   * @see http://www.ietf.org/rfc/rfc1950.txt for zlib header
	   */var cm=8;var cinfo=Math.LOG2E * Math.log(0x8000) - 8;var cmf=cinfo << 4 | cm;var hdr=cmf << 8;var flevel=Math.min(3,(level - 1 & 0xff) >> 1);hdr |= flevel << 6;hdr |= 0; //FDICT
	hdr += 31 - hdr % 31;return [cmf,hdr & 0xff & 0xff];},adler32=function adler32(array,param){var adler=1;var s1=adler & 0xffff,s2=adler >>> 16 & 0xffff;var len=array.length;var tlen;var i=0;while(len > 0) {tlen = len > param?param:len;len -= tlen;do {s1 += array[i++];s2 += s1;}while(--tlen);s1 %= 65521;s2 %= 65521;}return (s2 << 16 | s1) >>> 0;},applyPngFilterMethod=function applyPngFilterMethod(bytes,lineLength,colorsPerPixel,filter_method){var lines=bytes.length / lineLength,result=new Uint8Array(bytes.length + lines),filter_methods=getFilterMethods(),i=0,line,prevLine,offset;for(;i < lines;i++) {offset = i * lineLength;line = bytes.subarray(offset,offset + lineLength);if(filter_method){result.set(filter_method(line,colorsPerPixel,prevLine),offset + i);}else {var j=0,len=filter_methods.length,results=[];for(;j < len;j++) {results[j] = filter_methods[j](line,colorsPerPixel,prevLine);}var ind=getIndexOfSmallestSum(results.concat());result.set(results[ind],offset + i);}prevLine = line;}return result;},filterNone=function filterNone(line,colorsPerPixel,prevLine){ /*var result = new Uint8Array(line.length + 1);
	  result[0] = 0;
	  result.set(line, 1);*/var result=Array.apply([],line);result.unshift(0);return result;},filterSub=function filterSub(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left;result[0] = 1;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;result[i + 1] = line[i] - left + 0x0100 & 0xff;}return result;},filterUp=function filterUp(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,up;result[0] = 2;for(;i < len;i++) {up = prevLine && prevLine[i] || 0;result[i + 1] = line[i] - up + 0x0100 & 0xff;}return result;},filterAverage=function filterAverage(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left,up;result[0] = 3;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;up = prevLine && prevLine[i] || 0;result[i + 1] = line[i] + 0x0100 - (left + up >>> 1) & 0xff;}return result;},filterPaeth=function filterPaeth(line,colorsPerPixel,prevLine){var result=[],i=0,len=line.length,left,up,upLeft,paeth;result[0] = 4;for(;i < len;i++) {left = line[i - colorsPerPixel] || 0;up = prevLine && prevLine[i] || 0;upLeft = prevLine && prevLine[i - colorsPerPixel] || 0;paeth = paethPredictor(left,up,upLeft);result[i + 1] = line[i] - paeth + 0x0100 & 0xff;}return result;},paethPredictor=function paethPredictor(left,up,upLeft){var p=left + up - upLeft,pLeft=Math.abs(p - left),pUp=Math.abs(p - up),pUpLeft=Math.abs(p - upLeft);return pLeft <= pUp && pLeft <= pUpLeft?left:pUp <= pUpLeft?up:upLeft;},getFilterMethods=function getFilterMethods(){return [filterNone,filterSub,filterUp,filterAverage,filterPaeth];},getIndexOfSmallestSum=function getIndexOfSmallestSum(arrays){var i=0,len=arrays.length,sum,min,ind;while(i < len) {sum = absSum(arrays[i].slice(1));if(sum < min || !min){min = sum;ind = i;}i++;}return ind;},absSum=function absSum(array){var i=0,len=array.length,sum=0;while(i < len) {sum += Math.abs(array[i++]);}return sum;},getPredictorFromCompression=function getPredictorFromCompression(compression){var predictor;switch(compression){case jsPDFAPI.image_compression.FAST:predictor = 11;break;case jsPDFAPI.image_compression.MEDIUM:predictor = 13;break;case jsPDFAPI.image_compression.SLOW:predictor = 14;break;default:predictor = 12;break;}return predictor;},logImg=function logImg(img){console.log("width: " + img.width);console.log("height: " + img.height);console.log("bits: " + img.bits);console.log("colorType: " + img.colorType);console.log("transparency:");console.log(img.transparency);console.log("text:");console.log(img.text);console.log("compressionMethod: " + img.compressionMethod);console.log("filterMethod: " + img.filterMethod);console.log("interlaceMethod: " + img.interlaceMethod);console.log("imgData:");console.log(img.imgData);console.log("palette:");console.log(img.palette);console.log("colors: " + img.colors);console.log("colorSpace: " + img.colorSpace);console.log("pixelBitlength: " + img.pixelBitlength);console.log("hasAlphaChannel: " + img.hasAlphaChannel);};jsPDFAPI.processPNG = function(imageData,imageIndex,alias,compression,dataAsBinaryString){'use strict';var colorSpace=this.color_spaces.DEVICE_RGB,decode=this.decode.FLATE_DECODE,bpc=8,img,dp,trns,colors,pal,smask; /*	if(this.isString(imageData)) {
	  		}*/if(this.isArrayBuffer(imageData))imageData = new Uint8Array(imageData);if(this.isArrayBufferView(imageData)){if(doesNotHavePngJS())throw new Error("PNG support requires png.js and zlib.js");img = new PNG(imageData);imageData = img.imgData;bpc = img.bits;colorSpace = img.colorSpace;colors = img.colors; //logImg(img);
	/*
	    * colorType 6 - Each pixel is an R,G,B triple, followed by an alpha sample.
	    *
	    * colorType 4 - Each pixel is a grayscale sample, followed by an alpha sample.
	    *
	    * Extract alpha to create two separate images, using the alpha as a sMask
	    */if([4,6].indexOf(img.colorType) !== -1){ /*
	     * processes 8 bit RGBA and grayscale + alpha images
	     */if(img.bits === 8){var pixels=img.pixelBitlength == 32?new Uint32Array(img.decodePixels().buffer):img.pixelBitlength == 16?new Uint16Array(img.decodePixels().buffer):new Uint8Array(img.decodePixels().buffer),len=pixels.length,imgData=new Uint8Array(len * img.colors),alphaData=new Uint8Array(len),pDiff=img.pixelBitlength - img.bits,i=0,n=0,pixel,pbl;for(;i < len;i++) {pixel = pixels[i];pbl = 0;while(pbl < pDiff) {imgData[n++] = pixel >>> pbl & 0xff;pbl = pbl + img.bits;}alphaData[i] = pixel >>> pbl & 0xff;}} /*
	     * processes 16 bit RGBA and grayscale + alpha images
	     */if(img.bits === 16){var pixels=new Uint32Array(img.decodePixels().buffer),len=pixels.length,imgData=new Uint8Array(len * (32 / img.pixelBitlength) * img.colors),alphaData=new Uint8Array(len * (32 / img.pixelBitlength)),hasColors=img.colors > 1,i=0,n=0,a=0,pixel;while(i < len) {pixel = pixels[i++];imgData[n++] = pixel >>> 0 & 0xFF;if(hasColors){imgData[n++] = pixel >>> 16 & 0xFF;pixel = pixels[i++];imgData[n++] = pixel >>> 0 & 0xFF;}alphaData[a++] = pixel >>> 16 & 0xFF;}bpc = 8;}if(canCompress(compression)){imageData = compressBytes(imgData,img.width * img.colors,img.colors,compression);smask = compressBytes(alphaData,img.width,1,compression);}else {imageData = imgData;smask = alphaData;decode = null;}} /*
	    * Indexed png. Each pixel is a palette index.
	    */if(img.colorType === 3){colorSpace = this.color_spaces.INDEXED;pal = img.palette;if(img.transparency.indexed){var trans=img.transparency.indexed;var total=0,i=0,len=trans.length;for(;i < len;++i) {total += trans[i];}total = total / 255; /*
	      * a single color is specified as 100% transparent (0),
	      * so we set trns to use a /Mask with that index
	      */if(total === len - 1 && trans.indexOf(0) !== -1){trns = [trans.indexOf(0)]; /*
	       * there's more than one colour within the palette that specifies
	       * a transparency value less than 255, so we unroll the pixels to create an image sMask
	       */}else if(total !== len){var pixels=img.decodePixels(),alphaData=new Uint8Array(pixels.length),i=0,len=pixels.length;for(;i < len;i++) {alphaData[i] = trans[pixels[i]];}smask = compressBytes(alphaData,img.width,1);}}}var predictor=getPredictorFromCompression(compression);if(decode === this.decode.FLATE_DECODE)dp = '/Predictor ' + predictor + ' /Colors ' + colors + ' /BitsPerComponent ' + bpc + ' /Columns ' + img.width;else  //remove 'Predictor' as it applies to the type of png filter applied to its IDAT - we only apply with compression
	dp = '/Colors ' + colors + ' /BitsPerComponent ' + bpc + ' /Columns ' + img.width;if(this.isArrayBuffer(imageData) || this.isArrayBufferView(imageData))imageData = this.arrayBufferToBinaryString(imageData);if(smask && this.isArrayBuffer(smask) || this.isArrayBufferView(smask))smask = this.arrayBufferToBinaryString(smask);return this.createImageInfo(imageData,img.width,img.height,colorSpace,bpc,decode,imageIndex,alias,dp,trns,pal,smask,predictor);}throw new Error("Unsupported PNG image data, try using JPEG instead.");};})(jsPDF.API); /**
	 * jsPDF Autoprint Plugin
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.autoPrint = function(){'use strict';var refAutoPrintTag;this.internal.events.subscribe('postPutResources',function(){refAutoPrintTag = this.internal.newObject();this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj");});this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");});return this;};})(jsPDF.API); /** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */ /**
	 * 
	 * ====================================================================
	 */(function(API){'use strict'; /**
	 Returns an array of length matching length of the 'word' string, with each
	 cell ocupied by the width of the char in that position.
	 
	 @function
	 @param word {String}
	 @param widths {Object}
	 @param kerning {Object}
	 @returns {Array}
	 */var getCharWidthsArray=API.getCharWidthsArray = function(text,options){if(!options){options = {};}var widths=options.widths?options.widths:this.internal.getFont().metadata.Unicode.widths,widthsFractionOf=widths.fof?widths.fof:1,kerning=options.kerning?options.kerning:this.internal.getFont().metadata.Unicode.kerning,kerningFractionOf=kerning.fof?kerning.fof:1; // console.log("widths, kergnings", widths, kerning)
	var i,l,char_code,prior_char_code=0, // for kerning
	default_char_width=widths[0] || widthsFractionOf,output=[];for(i = 0,l = text.length;i < l;i++) {char_code = text.charCodeAt(i);output.push((widths[char_code] || default_char_width) / widthsFractionOf + (kerning[char_code] && kerning[char_code][prior_char_code] || 0) / kerningFractionOf);prior_char_code = char_code;}return output;};var getArraySum=function getArraySum(array){var i=array.length,output=0;while(i) {i--;output += array[i];}return output;}; /**
	 Returns a widths of string in a given font, if the font size is set as 1 point.
	 
	 In other words, this is "proportional" value. For 1 unit of font size, the length
	 of the string will be that much.
	 
	 Multiply by font size to get actual width in *points*
	 Then divide by 72 to get inches or divide by (72/25.6) to get 'mm' etc.
	 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */var getStringUnitWidth=API.getStringUnitWidth = function(text,options){return getArraySum(getCharWidthsArray.call(this,text,options));}; /**
	 returns array of lines
	 */var splitLongWord=function splitLongWord(word,widths_array,firstLineMaxLen,maxLen){var answer=[]; // 1st, chop off the piece that can fit on the hanging line.
	var i=0,l=word.length,workingLen=0;while(i !== l && workingLen + widths_array[i] < firstLineMaxLen) {workingLen += widths_array[i];i++;} // this is first line.
	answer.push(word.slice(0,i)); // 2nd. Split the rest into maxLen pieces.
	var startOfLine=i;workingLen = 0;while(i !== l) {if(workingLen + widths_array[i] > maxLen){answer.push(word.slice(startOfLine,i));workingLen = 0;startOfLine = i;}workingLen += widths_array[i];i++;}if(startOfLine !== i){answer.push(word.slice(startOfLine,i));}return answer;}; // Note, all sizing inputs for this function must be in "font measurement units"
	// By default, for PDF, it's "point".
	var splitParagraphIntoLines=function splitParagraphIntoLines(text,maxlen,options){ // at this time works only on Western scripts, ones with space char
	// separating the words. Feel free to expand.
	if(!options){options = {};}var line=[],lines=[line],line_length=options.textIndent || 0,separator_length=0,current_word_length=0,word,widths_array,words=text.split(' '),spaceCharWidth=getCharWidthsArray(' ',options)[0],i,l,tmp,lineIndent;if(options.lineIndent === -1){lineIndent = words[0].length + 2;}else {lineIndent = options.lineIndent || 0;}if(lineIndent){var pad=Array(lineIndent).join(" "),wrds=[];words.map(function(wrd){wrd = wrd.split(/\s*\n/);if(wrd.length > 1){wrds = wrds.concat(wrd.map(function(wrd,idx){return (idx && wrd.length?"\n":"") + wrd;}));}else {wrds.push(wrd[0]);}});words = wrds;lineIndent = getStringUnitWidth(pad,options);}for(i = 0,l = words.length;i < l;i++) {var force=0;word = words[i];if(lineIndent && word[0] == "\n"){word = word.substr(1);force = 1;}widths_array = getCharWidthsArray(word,options);current_word_length = getArraySum(widths_array);if(line_length + separator_length + current_word_length > maxlen || force){if(current_word_length > maxlen){ // this happens when you have space-less long URLs for example.
	// we just chop these to size. We do NOT insert hiphens
	tmp = splitLongWord(word,widths_array,maxlen - (line_length + separator_length),maxlen); // first line we add to existing line object
	line.push(tmp.shift()); // it's ok to have extra space indicator there
	// last line we make into new line object
	line = [tmp.pop()]; // lines in the middle we apped to lines object as whole lines
	while(tmp.length) {lines.push([tmp.shift()]); // single fragment occupies whole line
	}current_word_length = getArraySum(widths_array.slice(word.length - line[0].length));}else { // just put it on a new line
	line = [word];} // now we attach new line to lines
	lines.push(line);line_length = current_word_length + lineIndent;separator_length = spaceCharWidth;}else {line.push(word);line_length += separator_length + current_word_length;separator_length = spaceCharWidth;}}if(lineIndent){var postProcess=function postProcess(ln,idx){return (idx?pad:'') + ln.join(" ");};}else {var postProcess=function postProcess(ln){return ln.join(" ");};}return lines.map(postProcess);}; /**
	 Splits a given string into an array of strings. Uses 'size' value
	 (in measurement units declared as default for the jsPDF instance)
	 and the font's "widths" and "Kerning" tables, where available, to
	 determine display length of a given string for a given font.
	 
	 We use character's 100% of unit size (height) as width when Width
	 table or other default width is not available.
	 
	 @public
	 @function
	 @param text {String} Unencoded, regular JavaScript (Unicode, UTF-16 / UCS-2) string.
	 @param size {Number} Nominal number, measured in units default to this instance of jsPDF.
	 @param options {Object} Optional flags needed for chopper to do the right thing.
	 @returns {Array} with strings chopped to size.
	 */API.splitTextToSize = function(text,maxlen,options){'use strict';if(!options){options = {};}var fsize=options.fontSize || this.internal.getFontSize(),newOptions=(function(options){var widths={0:1},kerning={};if(!options.widths || !options.kerning){var f=this.internal.getFont(options.fontName,options.fontStyle),encoding='Unicode'; // NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE
	// Actual JavaScript-native String's 16bit char codes used.
	// no multi-byte logic here
	if(f.metadata[encoding]){return {widths:f.metadata[encoding].widths || widths,kerning:f.metadata[encoding].kerning || kerning};}}else {return {widths:options.widths,kerning:options.kerning};} // then use default values
	return {widths:widths,kerning:kerning};}).call(this,options); // first we split on end-of-line chars
	var paragraphs;if(Array.isArray(text)){paragraphs = text;}else {paragraphs = text.split(/\r?\n/);} // now we convert size (max length of line) into "font size units"
	// at present time, the "font size unit" is always 'point'
	// 'proportional' means, "in proportion to font size"
	var fontUnit_maxLen=1.0 * this.internal.scaleFactor * maxlen / fsize; // at this time, fsize is always in "points" regardless of the default measurement unit of the doc.
	// this may change in the future?
	// until then, proportional_maxlen is likely to be in 'points'
	// If first line is to be indented (shorter or longer) than maxLen
	// we indicate that by using CSS-style "text-indent" option.
	// here it's in font units too (which is likely 'points')
	// it can be negative (which makes the first line longer than maxLen)
	newOptions.textIndent = options.textIndent?options.textIndent * 1.0 * this.internal.scaleFactor / fsize:0;newOptions.lineIndent = options.lineIndent;var i,l,output=[];for(i = 0,l = paragraphs.length;i < l;i++) {output = output.concat(splitParagraphIntoLines(paragraphs[i],fontUnit_maxLen,newOptions));}return output;};})(jsPDF.API); /** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/ /**
	 * 
	 * ====================================================================
	 */(function(API){'use strict'; /*
	 # reference (Python) versions of 'compress' and 'uncompress'
	 # only 'uncompress' function is featured lower as JavaScript
	 # if you want to unit test "roundtrip", just transcribe the reference
	 # 'compress' function from Python into JavaScript
	 
	 def compress(data):
	 
	 	keys =   '0123456789abcdef'
	 	values = 'klmnopqrstuvwxyz'
	 	mapping = dict(zip(keys, values))
	 	vals = []
	 	for key in data.keys():
	 		value = data[key]
	 		try:
	 			keystring = hex(key)[2:]
	 			keystring = keystring[:-1] + mapping[keystring[-1:]]
	 		except:
	 			keystring = key.join(["'","'"])
	 			#print('Keystring is %s' % keystring)
	 
	 		try:
	 			if value < 0:
	 				valuestring = hex(value)[3:]
	 				numberprefix = '-'
	 			else:
	 				valuestring = hex(value)[2:]
	 				numberprefix = ''
	 			valuestring = numberprefix + valuestring[:-1] + mapping[valuestring[-1:]]
	 		except:
	 			if type(value) == dict:
	 				valuestring = compress(value)
	 			else:
	 				raise Exception("Don't know what to do with value type %s" % type(value))
	 
	 		vals.append(keystring+valuestring)
	 	
	 	return '{' + ''.join(vals) + '}'
	 
	 def uncompress(data):
	 
	 	decoded = '0123456789abcdef'
	 	encoded = 'klmnopqrstuvwxyz'
	 	mapping = dict(zip(encoded, decoded))
	 
	 	sign = +1
	 	stringmode = False
	 	stringparts = []
	 
	 	output = {}
	 
	 	activeobject = output
	 	parentchain = []
	 
	 	keyparts = ''
	 	valueparts = ''
	 
	 	key = None
	 
	 	ending = set(encoded)
	 
	 	i = 1
	 	l = len(data) - 1 # stripping starting, ending {}
	 	while i != l: # stripping {}
	 		# -, {, }, ' are special.
	 
	 		ch = data[i]
	 		i += 1
	 
	 		if ch == "'":
	 			if stringmode:
	 				# end of string mode
	 				stringmode = False
	 				key = ''.join(stringparts)
	 			else:
	 				# start of string mode
	 				stringmode = True
	 				stringparts = []
	 		elif stringmode == True:
	 			#print("Adding %s to stringpart" % ch)
	 			stringparts.append(ch)
	 
	 		elif ch == '{':
	 			# start of object
	 			parentchain.append( [activeobject, key] )
	 			activeobject = {}
	 			key = None
	 			#DEBUG = True
	 		elif ch == '}':
	 			# end of object
	 			parent, key = parentchain.pop()
	 			parent[key] = activeobject
	 			key = None
	 			activeobject = parent
	 			#DEBUG = False
	 
	 		elif ch == '-':
	 			sign = -1
	 		else:
	 			# must be number
	 			if key == None:
	 				#debug("In Key. It is '%s', ch is '%s'" % (keyparts, ch))
	 				if ch in ending:
	 					#debug("End of key")
	 					keyparts += mapping[ch]
	 					key = int(keyparts, 16) * sign
	 					sign = +1
	 					keyparts = ''
	 				else:
	 					keyparts += ch
	 			else:
	 				#debug("In value. It is '%s', ch is '%s'" % (valueparts, ch))
	 				if ch in ending:
	 					#debug("End of value")
	 					valueparts += mapping[ch]
	 					activeobject[key] = int(valueparts, 16) * sign
	 					sign = +1
	 					key = None
	 					valueparts = ''
	 				else:
	 					valueparts += ch
	 
	 			#debug(activeobject)
	 
	 	return output
	 
	 */ /**
	 Uncompresses data compressed into custom, base16-like format. 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */var uncompress=function uncompress(data){var decoded='0123456789abcdef',encoded='klmnopqrstuvwxyz',mapping={};for(var i=0;i < encoded.length;i++) {mapping[encoded[i]] = decoded[i];}var undef,output={},sign=1,stringparts, // undef. will be [] in string mode
	activeobject=output,parentchain=[],parent_key_pair,keyparts='',valueparts='',key, // undef. will be Truthy when Key is resolved.
	datalen=data.length - 1, // stripping ending }
	ch;i = 1; // stripping starting {
	while(i != datalen) { // - { } ' are special.
	ch = data[i];i += 1;if(ch == "'"){if(stringparts){ // end of string mode
	key = stringparts.join('');stringparts = undef;}else { // start of string mode
	stringparts = [];}}else if(stringparts){stringparts.push(ch);}else if(ch == '{'){ // start of object
	parentchain.push([activeobject,key]);activeobject = {};key = undef;}else if(ch == '}'){ // end of object
	parent_key_pair = parentchain.pop();parent_key_pair[0][parent_key_pair[1]] = activeobject;key = undef;activeobject = parent_key_pair[0];}else if(ch == '-'){sign = -1;}else { // must be number
	if(key === undef){if(mapping.hasOwnProperty(ch)){keyparts += mapping[ch];key = parseInt(keyparts,16) * sign;sign = +1;keyparts = '';}else {keyparts += ch;}}else {if(mapping.hasOwnProperty(ch)){valueparts += mapping[ch];activeobject[key] = parseInt(valueparts,16) * sign;sign = +1;key = undef;valueparts = '';}else {valueparts += ch;}}}} // end while
	return output;}; // encoding = 'Unicode' 
	// NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE. NO clever BOM behavior
	// Actual 16bit char codes used.
	// no multi-byte logic here
	// Unicode characters to WinAnsiEncoding:
	// {402: 131, 8211: 150, 8212: 151, 8216: 145, 8217: 146, 8218: 130, 8220: 147, 8221: 148, 8222: 132, 8224: 134, 8225: 135, 8226: 149, 8230: 133, 8364: 128, 8240:137, 8249: 139, 8250: 155, 710: 136, 8482: 153, 338: 140, 339: 156, 732: 152, 352: 138, 353: 154, 376: 159, 381: 142, 382: 158}
	// as you can see, all Unicode chars are outside of 0-255 range. No char code conflicts.
	// this means that you can give Win cp1252 encoded strings to jsPDF for rendering directly
	// as well as give strings with some (supported by these fonts) Unicode characters and 
	// these will be mapped to win cp1252 
	// for example, you can send char code (cp1252) 0x80 or (unicode) 0x20AC, getting "Euro" glyph displayed in both cases.
	var encodingBlock={'codePages':['WinAnsiEncoding'],'WinAnsiEncoding':uncompress("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},encodings={'Unicode':{'Courier':encodingBlock,'Courier-Bold':encodingBlock,'Courier-BoldOblique':encodingBlock,'Courier-Oblique':encodingBlock,'Helvetica':encodingBlock,'Helvetica-Bold':encodingBlock,'Helvetica-BoldOblique':encodingBlock,'Helvetica-Oblique':encodingBlock,'Times-Roman':encodingBlock,'Times-Bold':encodingBlock,'Times-BoldItalic':encodingBlock,'Times-Italic':encodingBlock //	, 'Symbol'
	//	, 'ZapfDingbats'
	}}, /** 
	 Resources:
	 Font metrics data is reprocessed derivative of contents of
	 "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
	 
	 Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
	 
	 This file and the 14 PostScript(R) AFM files it accompanies may be used,
	 copied, and distributed for any purpose and without charge, with or without
	 modification, provided that all copyright notices are retained; that the AFM
	 files are not distributed without this file; that all modifications to this
	 file or any of the AFM files are prominently noted in the modified file(s);
	 and that this paragraph is not modified. Adobe Systems has no responsibility
	 or obligation to support the use of the AFM files.
	 
	 */fontMetrics={'Unicode':{ // all sizing numbers are n/fontMetricsFractionOf = one font size unit
	// this means that if fontMetricsFractionOf = 1000, and letter A's width is 476, it's
	// width is 476/1000 or 47.6% of its height (regardless of font size)
	// At this time this value applies to "widths" and "kerning" numbers.
	// char code 0 represents "default" (average) width - use it for chars missing in this table.
	// key 'fof' represents the "fontMetricsFractionOf" value
	'Courier-Oblique':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-BoldItalic':uncompress("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),'Helvetica-Bold':uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),'Courier':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Courier-BoldOblique':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-Bold':uncompress("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), //, 'Symbol': uncompress("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}")
	'Helvetica':uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),'Helvetica-BoldOblique':uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), //, 'ZapfDingbats': uncompress("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}")
	'Courier-Bold':uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),'Times-Italic':uncompress("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),'Times-Roman':uncompress("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),'Helvetica-Oblique':uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}}; /*
	 This event handler is fired when a new jsPDF object is initialized
	 This event handler appends metrics data to standard fonts within
	 that jsPDF instance. The metrics are mapped over Unicode character
	 codes, NOT CIDs or other codes matching the StandardEncoding table of the
	 standard PDF fonts.
	 Future:
	 Also included is the encoding maping table, converting Unicode (UCS-2, UTF-16)
	 char codes to StandardEncoding character codes. The encoding table is to be used
	 somewhere around "pdfEscape" call.
	 */API.events.push(['addFont',function(font){var metrics,unicode_section,encoding='Unicode',encodingBlock;metrics = fontMetrics[encoding][font.PostScriptName];if(metrics){if(font.metadata[encoding]){unicode_section = font.metadata[encoding];}else {unicode_section = font.metadata[encoding] = {};}unicode_section.widths = metrics.widths;unicode_section.kerning = metrics.kerning;}encodingBlock = encodings[encoding][font.PostScriptName];if(encodingBlock){if(font.metadata[encoding]){unicode_section = font.metadata[encoding];}else {unicode_section = font.metadata[encoding] = {};}unicode_section.encoding = encodingBlock;if(encodingBlock.codePages && encodingBlock.codePages.length){font.encoding = encodingBlock.codePages[0];}}}]); // end of adding event handler
	})(jsPDF.API); /** @preserve
	jsPDF SVG plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	*/ /**
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict'; /**
	 Parses SVG XML and converts only some of the SVG elements into
	 PDF elements.
	 
	 Supports:
	  paths
	 
	 @public
	 @function
	 @param
	 @returns {Type}
	 */jsPDFAPI.addSVG = function(svgtext,x,y,w,h){ // 'this' is _jsPDF object returned when jsPDF is inited (new jsPDF())
	var undef;if(x === undef || y === undef){throw new Error("addSVG needs values for 'x' and 'y'");}function InjectCSS(cssbody,document){var styletag=document.createElement('style');styletag.type = 'text/css';if(styletag.styleSheet){ // ie
	styletag.styleSheet.cssText = cssbody;}else { // others
	styletag.appendChild(document.createTextNode(cssbody));}document.getElementsByTagName("head")[0].appendChild(styletag);}function createWorkerNode(document){var frameID='childframe', // Date.now().toString() + '_' + (Math.random() * 100).toString()
	frame=document.createElement('iframe');InjectCSS('.jsPDF_sillysvg_iframe {display:none;position:absolute;}',document);frame.name = frameID;frame.setAttribute("width",0);frame.setAttribute("height",0);frame.setAttribute("frameborder","0");frame.setAttribute("scrolling","no");frame.setAttribute("seamless","seamless");frame.setAttribute("class","jsPDF_sillysvg_iframe");document.body.appendChild(frame);return frame;}function attachSVGToWorkerNode(svgtext,frame){var framedoc=(frame.contentWindow || frame.contentDocument).document;framedoc.write(svgtext);framedoc.close();return framedoc.getElementsByTagName('svg')[0];}function convertPathToPDFLinesArgs(path){'use strict'; // we will use 'lines' method call. it needs:
	// - starting coordinate pair
	// - array of arrays of vector shifts (2-len for line, 6 len for bezier)
	// - scale array [horizontal, vertical] ratios
	// - style (stroke, fill, both)
	var x=parseFloat(path[1]),y=parseFloat(path[2]),vectors=[],position=3,len=path.length;while(position < len) {if(path[position] === 'c'){vectors.push([parseFloat(path[position + 1]),parseFloat(path[position + 2]),parseFloat(path[position + 3]),parseFloat(path[position + 4]),parseFloat(path[position + 5]),parseFloat(path[position + 6])]);position += 7;}else if(path[position] === 'l'){vectors.push([parseFloat(path[position + 1]),parseFloat(path[position + 2])]);position += 3;}else {position += 1;}}return [x,y,vectors];}var workernode=createWorkerNode(document),svgnode=attachSVGToWorkerNode(svgtext,workernode),scale=[1,1],svgw=parseFloat(svgnode.getAttribute('width')),svgh=parseFloat(svgnode.getAttribute('height'));if(svgw && svgh){ // setting both w and h makes image stretch to size.
	// this may distort the image, but fits your demanded size
	if(w && h){scale = [w / svgw,h / svgh];} // if only one is set, that value is set as max and SVG
	// is scaled proportionately.
	else if(w){scale = [w / svgw,w / svgw];}else if(h){scale = [h / svgh,h / svgh];}}var i,l,tmp,linesargs,items=svgnode.childNodes;for(i = 0,l = items.length;i < l;i++) {tmp = items[i];if(tmp.tagName && tmp.tagName.toUpperCase() === 'PATH'){linesargs = convertPathToPDFLinesArgs(tmp.getAttribute("d").split(' ')); // path start x coordinate
	linesargs[0] = linesargs[0] * scale[0] + x; // where x is upper left X of image
	// path start y coordinate
	linesargs[1] = linesargs[1] * scale[1] + y; // where y is upper left Y of image
	// the rest of lines are vectors. these will adjust with scale value auto.
	this.lines.call(this,linesargs[2], // lines
	linesargs[0], // starting x
	linesargs[1], // starting y
	scale);}} // clean up
	// workernode.parentNode.removeChild(workernode)
	return this;};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF total_pages plugin
	 * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 * 
	 * 
	 * ====================================================================
	 */(function(jsPDFAPI){'use strict';jsPDFAPI.putTotalPages = function(pageExpression){'use strict';var replaceExpression=new RegExp(pageExpression,'g');for(var n=1;n <= this.internal.getNumberOfPages();n++) {for(var i=0;i < this.internal.pages[n].length;i++) {this.internal.pages[n][i] = this.internal.pages[n][i].replace(replaceExpression,this.internal.getNumberOfPages());}}return this;};})(jsPDF.API); /** ==================================================================== 
	 * jsPDF XMP metadata plugin
	 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	 * 
	 * 
	 * ====================================================================
	 */ /*global jsPDF */ /**
	* Adds XMP formatted metadata to PDF
	*
	* @param {String} metadata The actual metadata to be added. The metadata shall be stored as XMP simple value. Note that if the metadata string contains XML markup characters "<", ">" or "&", those characters should be written using XML entities.
	* @param {String} namespaceuri Sets the namespace URI for the metadata. Last character should be slash or hash.
	* @function
	* @returns {jsPDF}
	* @methodOf jsPDF#
	* @name addMetadata
	*/(function(jsPDFAPI){'use strict';var xmpmetadata="";var xmpnamespaceuri="";var metadata_object_number="";jsPDFAPI.addMetadata = function(metadata,namespaceuri){xmpnamespaceuri = namespaceuri || "http://jspdf.default.namespaceuri/"; //The namespace URI for an XMP name shall not be empty
	xmpmetadata = metadata;this.internal.events.subscribe('postPutResources',function(){if(!xmpmetadata){metadata_object_number = "";}else {var xmpmeta_beginning='<x:xmpmeta xmlns:x="adobe:ns:meta/">';var rdf_beginning='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + xmpnamespaceuri + '"><jspdf:metadata>';var rdf_ending='</jspdf:metadata></rdf:Description></rdf:RDF>';var xmpmeta_ending='</x:xmpmeta>';var utf8_xmpmeta_beginning=unescape(encodeURIComponent(xmpmeta_beginning));var utf8_rdf_beginning=unescape(encodeURIComponent(rdf_beginning));var utf8_metadata=unescape(encodeURIComponent(xmpmetadata));var utf8_rdf_ending=unescape(encodeURIComponent(rdf_ending));var utf8_xmpmeta_ending=unescape(encodeURIComponent(xmpmeta_ending));var total_len=utf8_rdf_beginning.length + utf8_metadata.length + utf8_rdf_ending.length + utf8_xmpmeta_beginning.length + utf8_xmpmeta_ending.length;metadata_object_number = this.internal.newObject();this.internal.write('<< /Type /Metadata /Subtype /XML /Length ' + total_len + ' >>');this.internal.write('stream');this.internal.write(utf8_xmpmeta_beginning + utf8_rdf_beginning + utf8_metadata + utf8_rdf_ending + utf8_xmpmeta_ending);this.internal.write('endstream');this.internal.write('endobj');}});this.internal.events.subscribe('putCatalog',function(){if(metadata_object_number){this.internal.write('/Metadata ' + metadata_object_number + ' 0 R');}});return this;};})(jsPDF.API); /* Blob.js
	 * A Blob implementation.
	 * 2014-07-24
	 *
	 * By Eli Grey, http://eligrey.com
	 * By Devin Samarin, https://github.com/dsamarin
	 * License: X11/MIT
	 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
	 */ /*global self, unescape */ /*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
	  plusplus: true */ /*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */(function(view){"use strict";view.URL = view.URL || view.webkitURL;if(view.Blob && view.URL){try{new Blob();return;}catch(e) {}} // Internally we use a BlobBuilder implementation to base Blob off of
	// in order to support older browsers that only have BlobBuilder
	var BlobBuilder=view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view){var get_class=function get_class(object){return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];},FakeBlobBuilder=function BlobBuilder(){this.data = [];},FakeBlob=function Blob(data,type,encoding){this.data = data;this.size = data.length;this.type = type;this.encoding = encoding;},FBB_proto=FakeBlobBuilder.prototype,FB_proto=FakeBlob.prototype,FileReaderSync=view.FileReaderSync,FileException=function FileException(type){this.code = this[this.name = type];},file_ex_codes=("NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR " + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR").split(" "),file_ex_code=file_ex_codes.length,real_URL=view.URL || view.webkitURL || view,real_create_object_URL=real_URL.createObjectURL,real_revoke_object_URL=real_URL.revokeObjectURL,URL=real_URL,btoa=view.btoa,atob=view.atob,ArrayBuffer=view.ArrayBuffer,Uint8Array=view.Uint8Array,origin=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;FakeBlob.fake = FB_proto.fake = true;while(file_ex_code--) {FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;} // Polyfill URL
	if(!real_URL.createObjectURL){URL = view.URL = function(uri){var uri_info=document.createElementNS("http://www.w3.org/1999/xhtml","a"),uri_origin;uri_info.href = uri;if(!("origin" in uri_info)){if(uri_info.protocol.toLowerCase() === "data:"){uri_info.origin = null;}else {uri_origin = uri.match(origin);uri_info.origin = uri_origin && uri_origin[1];}}return uri_info;};}URL.createObjectURL = function(blob){var type=blob.type,data_URI_header;if(type === null){type = "application/octet-stream";}if(blob instanceof FakeBlob){data_URI_header = "data:" + type;if(blob.encoding === "base64"){return data_URI_header + ";base64," + blob.data;}else if(blob.encoding === "URI"){return data_URI_header + "," + decodeURIComponent(blob.data);}if(btoa){return data_URI_header + ";base64," + btoa(blob.data);}else {return data_URI_header + "," + encodeURIComponent(blob.data);}}else if(real_create_object_URL){return real_create_object_URL.call(real_URL,blob);}};URL.revokeObjectURL = function(object_URL){if(object_URL.substring(0,5) !== "data:" && real_revoke_object_URL){real_revoke_object_URL.call(real_URL,object_URL);}};FBB_proto.append = function(data /*, endings*/){var bb=this.data; // decode data to a binary string
	if(Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)){var str="",buf=new Uint8Array(data),i=0,buf_len=buf.length;for(;i < buf_len;i++) {str += String.fromCharCode(buf[i]);}bb.push(str);}else if(get_class(data) === "Blob" || get_class(data) === "File"){if(FileReaderSync){var fr=new FileReaderSync();bb.push(fr.readAsBinaryString(data));}else { // async FileReader won't work as BlobBuilder is sync
	throw new FileException("NOT_READABLE_ERR");}}else if(data instanceof FakeBlob){if(data.encoding === "base64" && atob){bb.push(atob(data.data));}else if(data.encoding === "URI"){bb.push(decodeURIComponent(data.data));}else if(data.encoding === "raw"){bb.push(data.data);}}else {if(typeof data !== "string"){data += ""; // convert unsupported types to strings
	} // decode UTF-16 to binary string
	bb.push(unescape(encodeURIComponent(data)));}};FBB_proto.getBlob = function(type){if(!arguments.length){type = null;}return new FakeBlob(this.data.join(""),type,"raw");};FBB_proto.toString = function(){return "[object BlobBuilder]";};FB_proto.slice = function(start,end,type){var args=arguments.length;if(args < 3){type = null;}return new FakeBlob(this.data.slice(start,args > 1?end:this.data.length),type,this.encoding);};FB_proto.toString = function(){return "[object Blob]";};FB_proto.close = function(){this.size = 0;delete this.data;};return FakeBlobBuilder;})(view);view.Blob = function(blobParts,options){var type=options?options.type || "":"";var builder=new BlobBuilder();if(blobParts){for(var i=0,len=blobParts.length;i < len;i++) {if(Uint8Array && blobParts[i] instanceof Uint8Array){builder.append(blobParts[i].buffer);}else {builder.append(blobParts[i]);}}}var blob=builder.getBlob(type);if(!blob.slice && blob.webkitSlice){blob.slice = blob.webkitSlice;}return blob;};var getPrototypeOf=Object.getPrototypeOf || function(object){return object.__proto__;};view.Blob.prototype = getPrototypeOf(new view.Blob());})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content || undefined); /* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.1.20151003
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */var saveAs=saveAs || (function(view){"use strict"; // IE <10 is explicitly unsupported
	if(typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)){return;}var doc=view.document, // only get URL when necessary in case Blob.js hasn't overridden it yet
	get_URL=function get_URL(){return view.URL || view.webkitURL || view;},save_link=doc.createElementNS("http://www.w3.org/1999/xhtml","a"),can_use_save_link=("download" in save_link),click=function click(node){var event=new MouseEvent("click");node.dispatchEvent(event);},is_safari=/Version\/[\d\.]+.*Safari/.test(navigator.userAgent),webkit_req_fs=view.webkitRequestFileSystem,req_fs=view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem,throw_outside=function throw_outside(ex){(view.setImmediate || view.setTimeout)(function(){throw ex;},0);},force_saveable_type="application/octet-stream",fs_min_size=0, // See https://code.google.com/p/chromium/issues/detail?id=375297#c7 and
	// https://github.com/eligrey/FileSaver.js/commit/485930a#commitcomment-8768047
	// for the reasoning behind the timeout and revocation flow
	arbitrary_revoke_timeout=500, // in ms
	revoke=function revoke(file){var revoker=function revoker(){if(typeof file === "string"){ // file is an object URL
	get_URL().revokeObjectURL(file);}else { // file is a File
	file.remove();}};if(view.chrome){revoker();}else {setTimeout(revoker,arbitrary_revoke_timeout);}},dispatch=function dispatch(filesaver,event_types,event){event_types = [].concat(event_types);var i=event_types.length;while(i--) {var listener=filesaver["on" + event_types[i]];if(typeof listener === "function"){try{listener.call(filesaver,event || filesaver);}catch(ex) {throw_outside(ex);}}}},auto_bom=function auto_bom(blob){ // prepend BOM for UTF-8 XML and text/* types (including HTML)
	if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)){return new Blob(['﻿',blob],{type:blob.type});}return blob;},FileSaver=function FileSaver(blob,name,no_auto_bom){if(!no_auto_bom){blob = auto_bom(blob);} // First try a.download, then web filesystem, then object URLs
	var filesaver=this,type=blob.type,blob_changed=false,object_url,target_view,dispatch_all=function dispatch_all(){dispatch(filesaver,"writestart progress write writeend".split(" "));}, // on any filesys errors revert to saving with object URLs
	fs_error=function fs_error(){if(target_view && is_safari && typeof FileReader !== "undefined"){ // Safari doesn't allow downloading of blob urls
	var reader=new FileReader();reader.onloadend = function(){var base64Data=reader.result;target_view.location.href = "data:attachment/file" + base64Data.slice(base64Data.search(/[,;]/));filesaver.readyState = filesaver.DONE;dispatch_all();};reader.readAsDataURL(blob);filesaver.readyState = filesaver.INIT;return;} // don't create more object URLs than needed
	if(blob_changed || !object_url){object_url = get_URL().createObjectURL(blob);}if(target_view){target_view.location.href = object_url;}else {var new_tab=view.open(object_url,"_blank");if(new_tab == undefined && is_safari){ //Apple do not allow window.open, see http://bit.ly/1kZffRI
	view.location.href = object_url;}}filesaver.readyState = filesaver.DONE;dispatch_all();revoke(object_url);},abortable=function abortable(func){return function(){if(filesaver.readyState !== filesaver.DONE){return func.apply(this,arguments);}};},create_if_not_found={create:true,exclusive:false},slice;filesaver.readyState = filesaver.INIT;if(!name){name = "download";}if(can_use_save_link){object_url = get_URL().createObjectURL(blob);setTimeout(function(){save_link.href = object_url;save_link.download = name;click(save_link);dispatch_all();revoke(object_url);filesaver.readyState = filesaver.DONE;});return;} // Object and web filesystem URLs have a problem saving in Google Chrome when
	// viewed in a tab, so I force save with application/octet-stream
	// http://code.google.com/p/chromium/issues/detail?id=91158
	// Update: Google errantly closed 91158, I submitted it again:
	// https://code.google.com/p/chromium/issues/detail?id=389642
	if(view.chrome && type && type !== force_saveable_type){slice = blob.slice || blob.webkitSlice;blob = slice.call(blob,0,blob.size,force_saveable_type);blob_changed = true;} // Since I can't be sure that the guessed media type will trigger a download
	// in WebKit, I append .download to the filename.
	// https://bugs.webkit.org/show_bug.cgi?id=65440
	if(webkit_req_fs && name !== "download"){name += ".download";}if(type === force_saveable_type || webkit_req_fs){target_view = view;}if(!req_fs){fs_error();return;}fs_min_size += blob.size;req_fs(view.TEMPORARY,fs_min_size,abortable(function(fs){fs.root.getDirectory("saved",create_if_not_found,abortable(function(dir){var save=function save(){dir.getFile(name,create_if_not_found,abortable(function(file){file.createWriter(abortable(function(writer){writer.onwriteend = function(event){target_view.location.href = file.toURL();filesaver.readyState = filesaver.DONE;dispatch(filesaver,"writeend",event);revoke(file);};writer.onerror = function(){var error=writer.error;if(error.code !== error.ABORT_ERR){fs_error();}};"writestart progress write abort".split(" ").forEach(function(event){writer["on" + event] = filesaver["on" + event];});writer.write(blob);filesaver.abort = function(){writer.abort();filesaver.readyState = filesaver.DONE;};filesaver.readyState = filesaver.WRITING;}),fs_error);}),fs_error);};dir.getFile(name,{create:false},abortable(function(file){ // delete file if it already exists
	file.remove();save();}),abortable(function(ex){if(ex.code === ex.NOT_FOUND_ERR){save();}else {fs_error();}}));}),fs_error);}),fs_error);},FS_proto=FileSaver.prototype,saveAs=function saveAs(blob,name,no_auto_bom){return new FileSaver(blob,name,no_auto_bom);}; // IE 10+ (native saveAs)
	if(typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob){return function(blob,name,no_auto_bom){if(!no_auto_bom){blob = auto_bom(blob);}return navigator.msSaveOrOpenBlob(blob,name || "download");};}FS_proto.abort = function(){var filesaver=this;filesaver.readyState = filesaver.DONE;dispatch(filesaver,"abort");};FS_proto.readyState = FS_proto.INIT = 0;FS_proto.WRITING = 1;FS_proto.DONE = 2;FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;return saveAs;})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content); // `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	if(typeof module !== "undefined" && module.exports){module.exports.saveAs = saveAs;}else if("function" !== "undefined" && __webpack_require__(205) !== null && __webpack_require__(206) != null){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return saveAs;}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));} /*
	 * Copyright (c) 2012 chick307 <chick307@gmail.com>
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */void (function(global,callback){if(true){module.exports = callback();}else if(typeof define === 'function'){define(callback);}else {global.adler32cs = callback();}})(jsPDF,function(){var _hasArrayBuffer=typeof ArrayBuffer === 'function' && typeof Uint8Array === 'function';var _Buffer=null,_isBuffer=(function(){if(!_hasArrayBuffer)return function _isBuffer(){return false;};try{var buffer={};if(typeof buffer.Buffer === 'function')_Buffer = buffer.Buffer;}catch(error) {}return function _isBuffer(value){return value instanceof ArrayBuffer || _Buffer !== null && value instanceof _Buffer;};})();var _utf8ToBinary=(function(){if(_Buffer !== null){return function _utf8ToBinary(utf8String){return new _Buffer(utf8String,'utf8').toString('binary');};}else {return function _utf8ToBinary(utf8String){return unescape(encodeURIComponent(utf8String));};}})();var MOD=65521;var _update=function _update(checksum,binaryString){var a=checksum & 0xFFFF,b=checksum >>> 16;for(var i=0,length=binaryString.length;i < length;i++) {a = (a + (binaryString.charCodeAt(i) & 0xFF)) % MOD;b = (b + a) % MOD;}return (b << 16 | a) >>> 0;};var _updateUint8Array=function _updateUint8Array(checksum,uint8Array){var a=checksum & 0xFFFF,b=checksum >>> 16;for(var i=0,length=uint8Array.length,x;i < length;i++) {a = (a + uint8Array[i]) % MOD;b = (b + a) % MOD;}return (b << 16 | a) >>> 0;};var exports={};var Adler32=exports.Adler32 = (function(){var ctor=function Adler32(checksum){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(!isFinite(checksum = checksum == null?1:+checksum)){throw new Error('First arguments needs to be a finite number.');}this.checksum = checksum >>> 0;};var proto=ctor.prototype = {};proto.constructor = ctor;ctor.from = (function(from){from.prototype = proto;return from;})(function from(binaryString){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(binaryString == null)throw new Error('First argument needs to be a string.');this.checksum = _update(1,binaryString.toString());});ctor.fromUtf8 = (function(fromUtf8){fromUtf8.prototype = proto;return fromUtf8;})(function fromUtf8(utf8String){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());this.checksum = _update(1,binaryString);});if(_hasArrayBuffer){ctor.fromBuffer = (function(fromBuffer){fromBuffer.prototype = proto;return fromBuffer;})(function fromBuffer(buffer){if(!(this instanceof ctor)){throw new TypeError('Constructor cannot called be as a function.');}if(!_isBuffer(buffer))throw new Error('First argument needs to be ArrayBuffer.');var array=new Uint8Array(buffer);return this.checksum = _updateUint8Array(1,array);});}proto.update = function update(binaryString){if(binaryString == null)throw new Error('First argument needs to be a string.');binaryString = binaryString.toString();return this.checksum = _update(this.checksum,binaryString);};proto.updateUtf8 = function updateUtf8(utf8String){if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());return this.checksum = _update(this.checksum,binaryString);};if(_hasArrayBuffer){proto.updateBuffer = function updateBuffer(buffer){if(!_isBuffer(buffer))throw new Error('First argument needs to be ArrayBuffer.');var array=new Uint8Array(buffer);return this.checksum = _updateUint8Array(this.checksum,array);};}proto.clone = function clone(){return new Adler32(this.checksum);};return ctor;})();exports.from = function from(binaryString){if(binaryString == null)throw new Error('First argument needs to be a string.');return _update(1,binaryString.toString());};exports.fromUtf8 = function fromUtf8(utf8String){if(utf8String == null)throw new Error('First argument needs to be a string.');var binaryString=_utf8ToBinary(utf8String.toString());return _update(1,binaryString);};if(_hasArrayBuffer){exports.fromBuffer = function fromBuffer(buffer){if(!_isBuffer(buffer))throw new Error('First argument need to be ArrayBuffer.');var array=new Uint8Array(buffer);return _updateUint8Array(1,array);};}return exports;}); /**
	 * CssColors
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */ /**
	 * Usage CssColors('red');
	 * Returns RGB hex color with '#' prefix
	 */var CssColors={};CssColors._colorsTable = {"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred ":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgrey":"#d3d3d3","lightgreen":"#90ee90","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370d8","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#d87093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"};CssColors.colorNameToHex = function(color){color = color.toLowerCase();if(typeof this._colorsTable[color] != 'undefined')return this._colorsTable[color];return false;}; /*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.
	
	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:
	
	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.
	
	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.
	
	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.
	
	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */ /*
	 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
	 * JZlib is based on zlib-1.1.3, so all credit should go authors
	 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
	 * and contributors of zlib.
	 */var Deflater=(function(obj){ // Global
	var MAX_BITS=15;var D_CODES=30;var BL_CODES=19;var LENGTH_CODES=29;var LITERALS=256;var L_CODES=LITERALS + 1 + LENGTH_CODES;var HEAP_SIZE=2 * L_CODES + 1;var END_BLOCK=256; // Bit length codes must not exceed MAX_BL_BITS bits
	var MAX_BL_BITS=7; // repeat previous bit length 3-6 times (2 bits of repeat count)
	var REP_3_6=16; // repeat a zero length 3-10 times (3 bits of repeat count)
	var REPZ_3_10=17; // repeat a zero length 11-138 times (7 bits of repeat count)
	var REPZ_11_138=18; // The lengths of the bit length codes are sent in order of decreasing
	// probability, to avoid transmitting the lengths for unused bit
	// length codes.
	var Buf_size=8 * 2; // JZlib version : "1.0.2"
	var Z_DEFAULT_COMPRESSION=-1; // compression strategy
	var Z_FILTERED=1;var Z_HUFFMAN_ONLY=2;var Z_DEFAULT_STRATEGY=0;var Z_NO_FLUSH=0;var Z_PARTIAL_FLUSH=1;var Z_FULL_FLUSH=3;var Z_FINISH=4;var Z_OK=0;var Z_STREAM_END=1;var Z_NEED_DICT=2;var Z_STREAM_ERROR=-2;var Z_DATA_ERROR=-3;var Z_BUF_ERROR=-5; // Tree
	// see definition of array dist_code below
	var _dist_code=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function Tree(){var that=this; // dyn_tree; // the dynamic tree
	// max_code; // largest code with non zero frequency
	// stat_desc; // the corresponding static tree
	// Compute the optimal bit lengths for a tree and update the total bit
	// length
	// for the current block.
	// IN assertion: the fields freq and dad are set, heap[heap_max] and
	// above are the tree nodes sorted by increasing frequency.
	// OUT assertions: the field len is set to the optimal bit length, the
	// array bl_count contains the frequencies for each bit length.
	// The length opt_len is updated; static_len is also updated if stree is
	// not null.
	function gen_bitlen(s){var tree=that.dyn_tree;var stree=that.stat_desc.static_tree;var extra=that.stat_desc.extra_bits;var base=that.stat_desc.extra_base;var max_length=that.stat_desc.max_length;var h; // heap index
	var n,m; // iterate over the tree elements
	var bits; // bit length
	var xbits; // extra bits
	var f; // frequency
	var overflow=0; // number of elements with bit length too large
	for(bits = 0;bits <= MAX_BITS;bits++) s.bl_count[bits] = 0; // In a first pass, compute the optimal bit lengths (which may
	// overflow in the case of the bit length tree).
	tree[s.heap[s.heap_max] * 2 + 1] = 0; // root of the heap
	for(h = s.heap_max + 1;h < HEAP_SIZE;h++) {n = s.heap[h];bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;if(bits > max_length){bits = max_length;overflow++;}tree[n * 2 + 1] = bits; // We overwrite tree[n*2+1] which is no longer needed
	if(n > that.max_code)continue; // not a leaf node
	s.bl_count[bits]++;xbits = 0;if(n >= base)xbits = extra[n - base];f = tree[n * 2];s.opt_len += f * (bits + xbits);if(stree)s.static_len += f * (stree[n * 2 + 1] + xbits);}if(overflow === 0)return; // This happens for example on obj2 and pic of the Calgary corpus
	// Find the first bit length which could increase:
	do {bits = max_length - 1;while(s.bl_count[bits] === 0) bits--;s.bl_count[bits]--; // move one leaf down the tree
	s.bl_count[bits + 1] += 2; // move one overflow item as its brother
	s.bl_count[max_length]--; // The brother of the overflow item also moves one step up,
	// but this does not affect bl_count[max_length]
	overflow -= 2;}while(overflow > 0);for(bits = max_length;bits !== 0;bits--) {n = s.bl_count[bits];while(n !== 0) {m = s.heap[--h];if(m > that.max_code)continue;if(tree[m * 2 + 1] != bits){s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];tree[m * 2 + 1] = bits;}n--;}}} // Reverse the first len bits of a code, using straightforward code (a
	// faster
	// method would use a table)
	// IN assertion: 1 <= len <= 15
	function bi_reverse(code, // the value to invert
	len // its bit length
	){var res=0;do {res |= code & 1;code >>>= 1;res <<= 1;}while(--len > 0);return res >>> 1;} // Generate the codes for a given tree and bit counts (which need not be
	// optimal).
	// IN assertion: the array bl_count contains the bit length statistics for
	// the given tree and the field len is set for all tree elements.
	// OUT assertion: the field code is set for all tree elements of non
	// zero code length.
	function gen_codes(tree, // the tree to decorate
	max_code, // largest code with non zero frequency
	bl_count // number of codes at each bit length
	){var next_code=[]; // next code value for each
	// bit length
	var code=0; // running code value
	var bits; // bit index
	var n; // code index
	var len; // The distribution counts are first used to generate the code values
	// without bit reversal.
	for(bits = 1;bits <= MAX_BITS;bits++) {next_code[bits] = code = code + bl_count[bits - 1] << 1;} // Check that the bit counts in bl_count are consistent. The last code
	// must be all ones.
	// Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	// "inconsistent bit counts");
	// Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	for(n = 0;n <= max_code;n++) {len = tree[n * 2 + 1];if(len === 0)continue; // Now reverse the bits
	tree[n * 2] = bi_reverse(next_code[len]++,len);}} // Construct one Huffman tree and assigns the code bit strings and lengths.
	// Update the total bit length for the current block.
	// IN assertion: the field freq is set for all tree elements.
	// OUT assertions: the fields len and code are set to the optimal bit length
	// and corresponding code. The length opt_len is updated; static_len is
	// also updated if stree is not null. The field max_code is set.
	that.build_tree = function(s){var tree=that.dyn_tree;var stree=that.stat_desc.static_tree;var elems=that.stat_desc.elems;var n,m; // iterate over heap elements
	var max_code=-1; // largest code with non zero frequency
	var node; // new node being created
	// Construct the initial heap, with least frequent element in
	// heap[1]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	// heap[0] is not used.
	s.heap_len = 0;s.heap_max = HEAP_SIZE;for(n = 0;n < elems;n++) {if(tree[n * 2] !== 0){s.heap[++s.heap_len] = max_code = n;s.depth[n] = 0;}else {tree[n * 2 + 1] = 0;}} // The pkzip format requires that at least one distance code exists,
	// and that at least one bit should be sent even if there is only one
	// possible code. So to avoid special checks later on we force at least
	// two codes of non zero frequency.
	while(s.heap_len < 2) {node = s.heap[++s.heap_len] = max_code < 2?++max_code:0;tree[node * 2] = 1;s.depth[node] = 0;s.opt_len--;if(stree)s.static_len -= stree[node * 2 + 1]; // node is 0 or 1 so it does not have extra bits
	}that.max_code = max_code; // The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	// establish sub-heaps of increasing lengths:
	for(n = Math.floor(s.heap_len / 2);n >= 1;n--) s.pqdownheap(tree,n); // Construct the Huffman tree by repeatedly combining the least two
	// frequent nodes.
	node = elems; // next internal node of the tree
	do { // n = node of least frequency
	n = s.heap[1];s.heap[1] = s.heap[s.heap_len--];s.pqdownheap(tree,1);m = s.heap[1]; // m = node of next least frequency
	s.heap[--s.heap_max] = n; // keep the nodes sorted by frequency
	s.heap[--s.heap_max] = m; // Create a new node father of n and m
	tree[node * 2] = tree[n * 2] + tree[m * 2];s.depth[node] = Math.max(s.depth[n],s.depth[m]) + 1;tree[n * 2 + 1] = tree[m * 2 + 1] = node; // and insert the new node in the heap
	s.heap[1] = node++;s.pqdownheap(tree,1);}while(s.heap_len >= 2);s.heap[--s.heap_max] = s.heap[1]; // At this point, the fields freq and dad are set. We can now
	// generate the bit lengths.
	gen_bitlen(s); // The field len is now set, we can generate the bit codes
	gen_codes(tree,that.max_code,s.bl_count);};}Tree._length_code = [0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28];Tree.base_length = [0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0];Tree.base_dist = [0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576]; // Mapping from a distance to a distance code. dist is the distance - 1 and
	// must not have side effects. _dist_code[256] and _dist_code[257] are never
	// used.
	Tree.d_code = function(dist){return dist < 256?_dist_code[dist]:_dist_code[256 + (dist >>> 7)];}; // extra bits for each length code
	Tree.extra_lbits = [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]; // extra bits for each distance code
	Tree.extra_dbits = [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]; // extra bits for each bit length code
	Tree.extra_blbits = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];Tree.bl_order = [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]; // StaticTree
	function StaticTree(static_tree,extra_bits,extra_base,elems,max_length){var that=this;that.static_tree = static_tree;that.extra_bits = extra_bits;that.extra_base = extra_base;that.elems = elems;that.max_length = max_length;}StaticTree.static_ltree = [12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8];StaticTree.static_dtree = [0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5];StaticTree.static_l_desc = new StaticTree(StaticTree.static_ltree,Tree.extra_lbits,LITERALS + 1,L_CODES,MAX_BITS);StaticTree.static_d_desc = new StaticTree(StaticTree.static_dtree,Tree.extra_dbits,0,D_CODES,MAX_BITS);StaticTree.static_bl_desc = new StaticTree(null,Tree.extra_blbits,0,BL_CODES,MAX_BL_BITS); // Deflate
	var MAX_MEM_LEVEL=9;var DEF_MEM_LEVEL=8;function Config(good_length,max_lazy,nice_length,max_chain,func){var that=this;that.good_length = good_length;that.max_lazy = max_lazy;that.nice_length = nice_length;that.max_chain = max_chain;that.func = func;}var STORED=0;var FAST=1;var SLOW=2;var config_table=[new Config(0,0,0,0,STORED),new Config(4,4,8,4,FAST),new Config(4,5,16,8,FAST),new Config(4,6,32,32,FAST),new Config(4,4,16,16,SLOW),new Config(8,16,32,32,SLOW),new Config(8,16,128,128,SLOW),new Config(8,32,128,256,SLOW),new Config(32,128,258,1024,SLOW),new Config(32,258,258,4096,SLOW)];var z_errmsg=["need dictionary", // Z_NEED_DICT
	// 2
	"stream end", // Z_STREAM_END 1
	"", // Z_OK 0
	"", // Z_ERRNO (-1)
	"stream error", // Z_STREAM_ERROR (-2)
	"data error", // Z_DATA_ERROR (-3)
	"", // Z_MEM_ERROR (-4)
	"buffer error", // Z_BUF_ERROR (-5)
	"", // Z_VERSION_ERROR (-6)
	""]; // block not completed, need more input or more output
	var NeedMore=0; // block flush performed
	var BlockDone=1; // finish started, need only more output at next deflate
	var FinishStarted=2; // finish done, accept no more input or output
	var FinishDone=3; // preset dictionary flag in zlib header
	var PRESET_DICT=0x20;var INIT_STATE=42;var BUSY_STATE=113;var FINISH_STATE=666; // The deflate compression method
	var Z_DEFLATED=8;var STORED_BLOCK=0;var STATIC_TREES=1;var DYN_TREES=2;var MIN_MATCH=3;var MAX_MATCH=258;var MIN_LOOKAHEAD=MAX_MATCH + MIN_MATCH + 1;function smaller(tree,n,m,depth){var tn2=tree[n * 2];var tm2=tree[m * 2];return tn2 < tm2 || tn2 == tm2 && depth[n] <= depth[m];}function Deflate(){var that=this;var strm; // pointer back to this zlib stream
	var status; // as the name implies
	// pending_buf; // output still pending
	var pending_buf_size; // size of pending_buf
	// pending_out; // next pending byte to output to the stream
	// pending; // nb of bytes in the pending buffer
	var method; // STORED (for zip only) or DEFLATED
	var last_flush; // value of flush param for previous deflate call
	var w_size; // LZ77 window size (32K by default)
	var w_bits; // log2(w_size) (8..16)
	var w_mask; // w_size - 1
	var window; // Sliding window. Input bytes are read into the second half of the window,
	// and move to the first half later to keep a dictionary of at least wSize
	// bytes. With this organization, matches are limited to a distance of
	// wSize-MAX_MATCH bytes, but this ensures that IO is always
	// performed with a length multiple of the block size. Also, it limits
	// the window size to 64K, which is quite useful on MSDOS.
	// To do: use the user input buffer as sliding window.
	var window_size; // Actual size of window: 2*wSize, except when the user input buffer
	// is directly used as sliding window.
	var prev; // Link to older string with same hash index. To limit the size of this
	// array to 64K, this link is maintained only for the last 32K strings.
	// An index in this array is thus a window index modulo 32K.
	var head; // Heads of the hash chains or NIL.
	var ins_h; // hash index of string to be inserted
	var hash_size; // number of elements in hash table
	var hash_bits; // log2(hash_size)
	var hash_mask; // hash_size-1
	// Number of bits by which ins_h must be shifted at each input
	// step. It must be such that after MIN_MATCH steps, the oldest
	// byte no longer takes part in the hash key, that is:
	// hash_shift * MIN_MATCH >= hash_bits
	var hash_shift; // Window position at the beginning of the current output block. Gets
	// negative when the window is moved backwards.
	var block_start;var match_length; // length of best match
	var prev_match; // previous match
	var match_available; // set if previous match exists
	var strstart; // start of string to insert
	var match_start; // start of matching string
	var lookahead; // number of valid bytes ahead in window
	// Length of the best match at previous step. Matches not greater than this
	// are discarded. This is used in the lazy match evaluation.
	var prev_length; // To speed up deflation, hash chains are never searched beyond this
	// length. A higher limit improves compression ratio but degrades the speed.
	var max_chain_length; // Attempt to find a better match only when the current match is strictly
	// smaller than this value. This mechanism is used only for compression
	// levels >= 4.
	var max_lazy_match; // Insert new strings in the hash table only if the match length is not
	// greater than this length. This saves time but degrades compression.
	// max_insert_length is used only for compression levels <= 3.
	var level; // compression level (1..9)
	var strategy; // favor or force Huffman coding
	// Use a faster search when the previous match is longer than this
	var good_match; // Stop searching when current match exceeds this
	var nice_match;var dyn_ltree; // literal and length tree
	var dyn_dtree; // distance tree
	var bl_tree; // Huffman tree for bit lengths
	var l_desc=new Tree(); // desc for literal tree
	var d_desc=new Tree(); // desc for distance tree
	var bl_desc=new Tree(); // desc for bit length tree
	// that.heap_len; // number of elements in the heap
	// that.heap_max; // element of largest frequency
	// The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	// The same heap array is used to build all trees.
	// Depth of each subtree used as tie breaker for trees of equal frequency
	that.depth = [];var l_buf; // index for literals or lengths */
	// Size of match buffer for literals/lengths. There are 4 reasons for
	// limiting lit_bufsize to 64K:
	// - frequencies can be kept in 16 bit counters
	// - if compression is not successful for the first block, all input
	// data is still in the window so we can still emit a stored block even
	// when input comes from standard input. (This can also be done for
	// all blocks if lit_bufsize is not greater than 32K.)
	// - if compression is not successful for a file smaller than 64K, we can
	// even emit a stored file instead of a stored block (saving 5 bytes).
	// This is applicable only for zip (not gzip or zlib).
	// - creating new Huffman trees less frequently may not provide fast
	// adaptation to changes in the input data statistics. (Take for
	// example a binary file with poorly compressible code followed by
	// a highly compressible string table.) Smaller buffer sizes give
	// fast adaptation but have of course the overhead of transmitting
	// trees more frequently.
	// - I can't count above 4
	var lit_bufsize;var last_lit; // running index in l_buf
	// Buffer for distances. To simplify the code, d_buf and l_buf have
	// the same number of elements. To use different lengths, an extra flag
	// array would be necessary.
	var d_buf; // index of pendig_buf
	// that.opt_len; // bit length of current block with optimal trees
	// that.static_len; // bit length of current block with static trees
	var matches; // number of string matches in current block
	var last_eob_len; // bit length of EOB code for last block
	// Output buffer. bits are inserted starting at the bottom (least
	// significant bits).
	var bi_buf; // Number of valid bits in bi_buf. All bits above the last valid bit
	// are always zero.
	var bi_valid; // number of codes at each bit length for an optimal tree
	that.bl_count = []; // heap used to build the Huffman trees
	that.heap = [];dyn_ltree = [];dyn_dtree = [];bl_tree = [];function lm_init(){var i;window_size = 2 * w_size;head[hash_size - 1] = 0;for(i = 0;i < hash_size - 1;i++) {head[i] = 0;} // Set the default configuration parameters:
	max_lazy_match = config_table[level].max_lazy;good_match = config_table[level].good_length;nice_match = config_table[level].nice_length;max_chain_length = config_table[level].max_chain;strstart = 0;block_start = 0;lookahead = 0;match_length = prev_length = MIN_MATCH - 1;match_available = 0;ins_h = 0;}function init_block(){var i; // Initialize the trees.
	for(i = 0;i < L_CODES;i++) dyn_ltree[i * 2] = 0;for(i = 0;i < D_CODES;i++) dyn_dtree[i * 2] = 0;for(i = 0;i < BL_CODES;i++) bl_tree[i * 2] = 0;dyn_ltree[END_BLOCK * 2] = 1;that.opt_len = that.static_len = 0;last_lit = matches = 0;} // Initialize the tree data structures for a new zlib stream.
	function tr_init(){l_desc.dyn_tree = dyn_ltree;l_desc.stat_desc = StaticTree.static_l_desc;d_desc.dyn_tree = dyn_dtree;d_desc.stat_desc = StaticTree.static_d_desc;bl_desc.dyn_tree = bl_tree;bl_desc.stat_desc = StaticTree.static_bl_desc;bi_buf = 0;bi_valid = 0;last_eob_len = 8; // enough lookahead for inflate
	// Initialize the first block of the first file:
	init_block();} // Restore the heap property by moving down the tree starting at node k,
	// exchanging a node with the smallest of its two sons if necessary,
	// stopping
	// when the heap property is re-established (each father smaller than its
	// two sons).
	that.pqdownheap = function(tree, // the tree to restore
	k // node to move down
	){var heap=that.heap;var v=heap[k];var j=k << 1; // left son of k
	while(j <= that.heap_len) { // Set j to the smallest of the two sons:
	if(j < that.heap_len && smaller(tree,heap[j + 1],heap[j],that.depth)){j++;} // Exit if v is smaller than both sons
	if(smaller(tree,v,heap[j],that.depth))break; // Exchange v with the smallest son
	heap[k] = heap[j];k = j; // And continue down the tree, setting j to the left son of k
	j <<= 1;}heap[k] = v;}; // Scan a literal or distance tree to determine the frequencies of the codes
	// in the bit length tree.
	function scan_tree(tree, // the tree to be scanned
	max_code // and its largest code of non zero frequency
	){var n; // iterates over all tree elements
	var prevlen=-1; // last emitted length
	var curlen; // length of current code
	var nextlen=tree[0 * 2 + 1]; // length of next code
	var count=0; // repeat count of the current code
	var max_count=7; // max repeat count
	var min_count=4; // min repeat count
	if(nextlen === 0){max_count = 138;min_count = 3;}tree[(max_code + 1) * 2 + 1] = 0xffff; // guard
	for(n = 0;n <= max_code;n++) {curlen = nextlen;nextlen = tree[(n + 1) * 2 + 1];if(++count < max_count && curlen == nextlen){continue;}else if(count < min_count){bl_tree[curlen * 2] += count;}else if(curlen !== 0){if(curlen != prevlen)bl_tree[curlen * 2]++;bl_tree[REP_3_6 * 2]++;}else if(count <= 10){bl_tree[REPZ_3_10 * 2]++;}else {bl_tree[REPZ_11_138 * 2]++;}count = 0;prevlen = curlen;if(nextlen === 0){max_count = 138;min_count = 3;}else if(curlen == nextlen){max_count = 6;min_count = 3;}else {max_count = 7;min_count = 4;}}} // Construct the Huffman tree for the bit lengths and return the index in
	// bl_order of the last bit length code to send.
	function build_bl_tree(){var max_blindex; // index of last bit length code of non zero freq
	// Determine the bit length frequencies for literal and distance trees
	scan_tree(dyn_ltree,l_desc.max_code);scan_tree(dyn_dtree,d_desc.max_code); // Build the bit length tree:
	bl_desc.build_tree(that); // opt_len now includes the length of the tree representations, except
	// the lengths of the bit lengths codes and the 5+5+4 bits for the
	// counts.
	// Determine the number of bit length codes to send. The pkzip format
	// requires that at least 4 bit length codes be sent. (appnote.txt says
	// 3 but the actual value used is 4.)
	for(max_blindex = BL_CODES - 1;max_blindex >= 3;max_blindex--) {if(bl_tree[Tree.bl_order[max_blindex] * 2 + 1] !== 0)break;} // Update opt_len to include the bit length tree and counts
	that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;return max_blindex;} // Output a byte on the stream.
	// IN assertion: there is enough room in pending_buf.
	function put_byte(p){that.pending_buf[that.pending++] = p;}function put_short(w){put_byte(w & 0xff);put_byte(w >>> 8 & 0xff);}function putShortMSB(b){put_byte(b >> 8 & 0xff);put_byte(b & 0xff & 0xff);}function send_bits(value,length){var val,len=length;if(bi_valid > Buf_size - len){val = value; // bi_buf |= (val << bi_valid);
	bi_buf |= val << bi_valid & 0xffff;put_short(bi_buf);bi_buf = val >>> Buf_size - bi_valid;bi_valid += len - Buf_size;}else { // bi_buf |= (value) << bi_valid;
	bi_buf |= value << bi_valid & 0xffff;bi_valid += len;}}function send_code(c,tree){var c2=c * 2;send_bits(tree[c2] & 0xffff,tree[c2 + 1] & 0xffff);} // Send a literal or distance tree in compressed form, using the codes in
	// bl_tree.
	function send_tree(tree, // the tree to be sent
	max_code // and its largest code of non zero frequency
	){var n; // iterates over all tree elements
	var prevlen=-1; // last emitted length
	var curlen; // length of current code
	var nextlen=tree[0 * 2 + 1]; // length of next code
	var count=0; // repeat count of the current code
	var max_count=7; // max repeat count
	var min_count=4; // min repeat count
	if(nextlen === 0){max_count = 138;min_count = 3;}for(n = 0;n <= max_code;n++) {curlen = nextlen;nextlen = tree[(n + 1) * 2 + 1];if(++count < max_count && curlen == nextlen){continue;}else if(count < min_count){do {send_code(curlen,bl_tree);}while(--count !== 0);}else if(curlen !== 0){if(curlen != prevlen){send_code(curlen,bl_tree);count--;}send_code(REP_3_6,bl_tree);send_bits(count - 3,2);}else if(count <= 10){send_code(REPZ_3_10,bl_tree);send_bits(count - 3,3);}else {send_code(REPZ_11_138,bl_tree);send_bits(count - 11,7);}count = 0;prevlen = curlen;if(nextlen === 0){max_count = 138;min_count = 3;}else if(curlen == nextlen){max_count = 6;min_count = 3;}else {max_count = 7;min_count = 4;}}} // Send the header for a block using dynamic Huffman trees: the counts, the
	// lengths of the bit length codes, the literal tree and the distance tree.
	// IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	function send_all_trees(lcodes,dcodes,blcodes){var rank; // index in bl_order
	send_bits(lcodes - 257,5); // not +255 as stated in appnote.txt
	send_bits(dcodes - 1,5);send_bits(blcodes - 4,4); // not -3 as stated in appnote.txt
	for(rank = 0;rank < blcodes;rank++) {send_bits(bl_tree[Tree.bl_order[rank] * 2 + 1],3);}send_tree(dyn_ltree,lcodes - 1); // literal tree
	send_tree(dyn_dtree,dcodes - 1); // distance tree
	} // Flush the bit buffer, keeping at most 7 bits in it.
	function bi_flush(){if(bi_valid == 16){put_short(bi_buf);bi_buf = 0;bi_valid = 0;}else if(bi_valid >= 8){put_byte(bi_buf & 0xff);bi_buf >>>= 8;bi_valid -= 8;}} // Send one empty static block to give enough lookahead for inflate.
	// This takes 10 bits, of which 7 may remain in the bit buffer.
	// The current inflate code requires 9 bits of lookahead. If the
	// last two codes for the previous block (real code plus EOB) were coded
	// on 5 bits or less, inflate may have only 5+3 bits of lookahead to decode
	// the last real code. In this case we send two empty static blocks instead
	// of one. (There are no problems if the previous block is stored or fixed.)
	// To simplify the code, we assume the worst case of last real code encoded
	// on one bit only.
	function _tr_align(){send_bits(STATIC_TREES << 1,3);send_code(END_BLOCK,StaticTree.static_ltree);bi_flush(); // Of the 10 bits for the empty block, we have already sent
	// (10 - bi_valid) bits. The lookahead for the last real code (before
	// the EOB of the previous block) was thus at least one plus the length
	// of the EOB plus what we have just sent of the empty static block.
	if(1 + last_eob_len + 10 - bi_valid < 9){send_bits(STATIC_TREES << 1,3);send_code(END_BLOCK,StaticTree.static_ltree);bi_flush();}last_eob_len = 7;} // Save the match info and tally the frequency counts. Return true if
	// the current block must be flushed.
	function _tr_tally(dist, // distance of matched string
	lc // match length-MIN_MATCH or unmatched char (if dist==0)
	){var out_length,in_length,dcode;that.pending_buf[d_buf + last_lit * 2] = dist >>> 8 & 0xff;that.pending_buf[d_buf + last_lit * 2 + 1] = dist & 0xff;that.pending_buf[l_buf + last_lit] = lc & 0xff;last_lit++;if(dist === 0){ // lc is the unmatched char
	dyn_ltree[lc * 2]++;}else {matches++; // Here, lc is the match length - MIN_MATCH
	dist--; // dist = match distance - 1
	dyn_ltree[(Tree._length_code[lc] + LITERALS + 1) * 2]++;dyn_dtree[Tree.d_code(dist) * 2]++;}if((last_lit & 0x1fff) === 0 && level > 2){ // Compute an upper bound for the compressed length
	out_length = last_lit * 8;in_length = strstart - block_start;for(dcode = 0;dcode < D_CODES;dcode++) {out_length += dyn_dtree[dcode * 2] * (5 + Tree.extra_dbits[dcode]);}out_length >>>= 3;if(matches < Math.floor(last_lit / 2) && out_length < Math.floor(in_length / 2))return true;}return last_lit == lit_bufsize - 1; // We avoid equality with lit_bufsize because of wraparound at 64K
	// on 16 bit machines and because stored blocks are restricted to
	// 64K-1 bytes.
	} // Send the block data compressed using the given Huffman trees
	function compress_block(ltree,dtree){var dist; // distance of matched string
	var lc; // match length or unmatched char (if dist === 0)
	var lx=0; // running index in l_buf
	var code; // the code to send
	var extra; // number of extra bits to send
	if(last_lit !== 0){do {dist = that.pending_buf[d_buf + lx * 2] << 8 & 0xff00 | that.pending_buf[d_buf + lx * 2 + 1] & 0xff;lc = that.pending_buf[l_buf + lx] & 0xff;lx++;if(dist === 0){send_code(lc,ltree); // send a literal byte
	}else { // Here, lc is the match length - MIN_MATCH
	code = Tree._length_code[lc];send_code(code + LITERALS + 1,ltree); // send the length
	// code
	extra = Tree.extra_lbits[code];if(extra !== 0){lc -= Tree.base_length[code];send_bits(lc,extra); // send the extra length bits
	}dist--; // dist is now the match distance - 1
	code = Tree.d_code(dist);send_code(code,dtree); // send the distance code
	extra = Tree.extra_dbits[code];if(extra !== 0){dist -= Tree.base_dist[code];send_bits(dist,extra); // send the extra distance bits
	}} // literal or match pair ?
	// Check that the overlay between pending_buf and d_buf+l_buf is
	// ok:
	}while(lx < last_lit);}send_code(END_BLOCK,ltree);last_eob_len = ltree[END_BLOCK * 2 + 1];} // Flush the bit buffer and align the output on a byte boundary
	function bi_windup(){if(bi_valid > 8){put_short(bi_buf);}else if(bi_valid > 0){put_byte(bi_buf & 0xff);}bi_buf = 0;bi_valid = 0;} // Copy a stored block, storing first the length and its
	// one's complement if requested.
	function copy_block(buf, // the input data
	len, // its length
	header // true if block header must be written
	){bi_windup(); // align on byte boundary
	last_eob_len = 8; // enough lookahead for inflate
	if(header){put_short(len);put_short(~len);}that.pending_buf.set(window.subarray(buf,buf + len),that.pending);that.pending += len;} // Send a stored block
	function _tr_stored_block(buf, // input block
	stored_len, // length of input block
	eof // true if this is the last block for a file
	){send_bits((STORED_BLOCK << 1) + (eof?1:0),3); // send block type
	copy_block(buf,stored_len,true); // with header
	} // Determine the best encoding for the current block: dynamic trees, static
	// trees or store, and output the encoded block to the zip file.
	function _tr_flush_block(buf, // input block, or NULL if too old
	stored_len, // length of input block
	eof // true if this is the last block for a file
	){var opt_lenb,static_lenb; // opt_len and static_len in bytes
	var max_blindex=0; // index of last bit length code of non zero freq
	// Build the Huffman trees unless a stored block is forced
	if(level > 0){ // Construct the literal and distance trees
	l_desc.build_tree(that);d_desc.build_tree(that); // At this point, opt_len and static_len are the total bit lengths
	// of
	// the compressed block data, excluding the tree representations.
	// Build the bit length tree for the above two trees, and get the
	// index
	// in bl_order of the last bit length code to send.
	max_blindex = build_bl_tree(); // Determine the best encoding. Compute first the block length in
	// bytes
	opt_lenb = that.opt_len + 3 + 7 >>> 3;static_lenb = that.static_len + 3 + 7 >>> 3;if(static_lenb <= opt_lenb)opt_lenb = static_lenb;}else {opt_lenb = static_lenb = stored_len + 5; // force a stored block
	}if(stored_len + 4 <= opt_lenb && buf != -1){ // 4: two words for the lengths
	// The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	// Otherwise we can't have processed more than WSIZE input bytes
	// since
	// the last block flush, because compression would have been
	// successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	// transform a block into a stored block.
	_tr_stored_block(buf,stored_len,eof);}else if(static_lenb == opt_lenb){send_bits((STATIC_TREES << 1) + (eof?1:0),3);compress_block(StaticTree.static_ltree,StaticTree.static_dtree);}else {send_bits((DYN_TREES << 1) + (eof?1:0),3);send_all_trees(l_desc.max_code + 1,d_desc.max_code + 1,max_blindex + 1);compress_block(dyn_ltree,dyn_dtree);} // The above check is made mod 2^32, for files larger than 512 MB
	// and uLong implemented on 32 bits.
	init_block();if(eof){bi_windup();}}function flush_block_only(eof){_tr_flush_block(block_start >= 0?block_start:-1,strstart - block_start,eof);block_start = strstart;strm.flush_pending();} // Fill the window when the lookahead becomes insufficient.
	// Updates strstart and lookahead.
	//
	// IN assertion: lookahead < MIN_LOOKAHEAD
	// OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	// At least one byte has been read, or avail_in === 0; reads are
	// performed for at least two bytes (required for the zip translate_eol
	// option -- not supported here).
	function fill_window(){var n,m;var p;var more; // Amount of free space at the end of the window.
	do {more = window_size - lookahead - strstart; // Deal with !@#$% 64K limit:
	if(more === 0 && strstart === 0 && lookahead === 0){more = w_size;}else if(more == -1){ // Very unlikely, but possible on 16 bit machine if strstart ==
	// 0
	// and lookahead == 1 (input done one byte at time)
	more--; // If the window is almost full and there is insufficient
	// lookahead,
	// move the upper half to the lower one to make room in the
	// upper half.
	}else if(strstart >= w_size + w_size - MIN_LOOKAHEAD){window.set(window.subarray(w_size,w_size + w_size),0);match_start -= w_size;strstart -= w_size; // we now have strstart >= MAX_DIST
	block_start -= w_size; // Slide the hash table (could be avoided with 32 bit values
	// at the expense of memory usage). We slide even when level ==
	// 0
	// to keep the hash table consistent if we switch back to level
	// > 0
	// later. (Using level 0 permanently is not an optimal usage of
	// zlib, so we don't care about this pathological case.)
	n = hash_size;p = n;do {m = head[--p] & 0xffff;head[p] = m >= w_size?m - w_size:0;}while(--n !== 0);n = w_size;p = n;do {m = prev[--p] & 0xffff;prev[p] = m >= w_size?m - w_size:0; // If n is not on any hash chain, prev[n] is garbage but
	// its value will never be used.
	}while(--n !== 0);more += w_size;}if(strm.avail_in === 0)return; // If there was no sliding:
	// strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	// more == window_size - lookahead - strstart
	// => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	// => more >= window_size - 2*WSIZE + 2
	// In the BIG_MEM or MMAP case (not yet supported),
	// window_size == input_size + MIN_LOOKAHEAD &&
	// strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	// Otherwise, window_size == 2*WSIZE so more >= 2.
	// If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	n = strm.read_buf(window,strstart + lookahead,more);lookahead += n; // Initialize the hash value now that we have some input:
	if(lookahead >= MIN_MATCH){ins_h = window[strstart] & 0xff;ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask;} // If the whole input has less than MIN_MATCH bytes, ins_h is
	// garbage,
	// but this is not important since only literal bytes will be
	// emitted.
	}while(lookahead < MIN_LOOKAHEAD && strm.avail_in !== 0);} // Copy without compression as much as possible from the input stream,
	// return
	// the current block state.
	// This function does not insert new strings in the dictionary since
	// uncompressible data is probably not useful. This function is used
	// only for the level=0 compression option.
	// NOTE: this function should be optimized to avoid extra copying from
	// window to pending_buf.
	function deflate_stored(flush){ // Stored blocks are limited to 0xffff bytes, pending_buf is limited
	// to pending_buf_size, and each stored block has a 5 byte header:
	var max_block_size=0xffff;var max_start;if(max_block_size > pending_buf_size - 5){max_block_size = pending_buf_size - 5;} // Copy as much as possible from input to output:
	while(true) { // Fill the window as much as possible:
	if(lookahead <= 1){fill_window();if(lookahead === 0 && flush == Z_NO_FLUSH)return NeedMore;if(lookahead === 0)break; // flush the current block
	}strstart += lookahead;lookahead = 0; // Emit a stored block if pending_buf will be full:
	max_start = block_start + max_block_size;if(strstart === 0 || strstart >= max_start){ // strstart === 0 is possible when wraparound on 16-bit machine
	lookahead = strstart - max_start;strstart = max_start;flush_block_only(false);if(strm.avail_out === 0)return NeedMore;} // Flush if we may have to slide, otherwise block_start may become
	// negative and the data will be gone:
	if(strstart - block_start >= w_size - MIN_LOOKAHEAD){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0)return flush == Z_FINISH?FinishStarted:NeedMore;return flush == Z_FINISH?FinishDone:BlockDone;}function longest_match(cur_match){var chain_length=max_chain_length; // max hash chain length
	var scan=strstart; // current string
	var match; // matched string
	var len; // length of current match
	var best_len=prev_length; // best match length so far
	var limit=strstart > w_size - MIN_LOOKAHEAD?strstart - (w_size - MIN_LOOKAHEAD):0;var _nice_match=nice_match; // Stop when cur_match becomes <= limit. To simplify the code,
	// we prevent matches with the string of window index 0.
	var wmask=w_mask;var strend=strstart + MAX_MATCH;var scan_end1=window[scan + best_len - 1];var scan_end=window[scan + best_len]; // The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of
	// 16.
	// It is easy to get rid of this optimization if necessary.
	// Do not waste too much time if we already have a good match:
	if(prev_length >= good_match){chain_length >>= 2;} // Do not look for matches beyond the end of the input. This is
	// necessary
	// to make deflate deterministic.
	if(_nice_match > lookahead)_nice_match = lookahead;do {match = cur_match; // Skip to next match if the match length cannot increase
	// or if the match length is less than 2:
	if(window[match + best_len] != scan_end || window[match + best_len - 1] != scan_end1 || window[match] != window[scan] || window[++match] != window[scan + 1])continue; // The check at best_len-1 can be removed because it will be made
	// again later. (This heuristic is not always a win.)
	// It is not necessary to compare scan[2] and match[2] since they
	// are always equal when the other bytes match, given that
	// the hash keys are equal and that HASH_BITS >= 8.
	scan += 2;match++; // We check for insufficient lookahead only every 8th comparison;
	// the 256th check will be made at strstart+258.
	do {}while(window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && scan < strend);len = MAX_MATCH - (strend - scan);scan = strend - MAX_MATCH;if(len > best_len){match_start = cur_match;best_len = len;if(len >= _nice_match)break;scan_end1 = window[scan + best_len - 1];scan_end = window[scan + best_len];}}while((cur_match = prev[cur_match & wmask] & 0xffff) > limit && --chain_length !== 0);if(best_len <= lookahead)return best_len;return lookahead;} // Compress as much as possible from the input stream, return the current
	// block state.
	// This function does not perform lazy evaluation of matches and inserts
	// new strings in the dictionary only for unmatched strings or for short
	// matches. It is used only for the fast compression options.
	function deflate_fast(flush){ // short hash_head = 0; // head of the hash chain
	var hash_head=0; // head of the hash chain
	var bflush; // set if current block must be flushed
	while(true) { // Make sure that we always have enough lookahead, except
	// at the end of the input file. We need MAX_MATCH bytes
	// for the next match, plus MIN_MATCH bytes to insert the
	// string following the next match.
	if(lookahead < MIN_LOOKAHEAD){fill_window();if(lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH){return NeedMore;}if(lookahead === 0)break; // flush the current block
	} // Insert the string window[strstart .. strstart+2] in the
	// dictionary, and set hash_head to the head of the hash chain:
	if(lookahead >= MIN_MATCH){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;} // Find the longest match, discarding those <= prev_length.
	// At this point we have always match_length < MIN_MATCH
	if(hash_head !== 0 && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD){ // To simplify the code, we prevent matches with the string
	// of window index 0 (in particular we have to avoid a match
	// of the string with itself at the start of the input file).
	if(strategy != Z_HUFFMAN_ONLY){match_length = longest_match(hash_head);} // longest_match() sets match_start
	}if(match_length >= MIN_MATCH){ // check_match(strstart, match_start, match_length);
	bflush = _tr_tally(strstart - match_start,match_length - MIN_MATCH);lookahead -= match_length; // Insert new strings in the hash table only if the match length
	// is not too large. This saves time but degrades compression.
	if(match_length <= max_lazy_match && lookahead >= MIN_MATCH){match_length--; // string at strstart already in hash table
	do {strstart++;ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart; // strstart never exceeds WSIZE-MAX_MATCH, so there are
	// always MIN_MATCH bytes ahead.
	}while(--match_length !== 0);strstart++;}else {strstart += match_length;match_length = 0;ins_h = window[strstart] & 0xff;ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask; // If lookahead < MIN_MATCH, ins_h is garbage, but it does
	// not
	// matter since it will be recomputed at next deflate call.
	}}else { // No match, output a literal byte
	bflush = _tr_tally(0,window[strstart] & 0xff);lookahead--;strstart++;}if(bflush){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0){if(flush == Z_FINISH)return FinishStarted;else return NeedMore;}return flush == Z_FINISH?FinishDone:BlockDone;} // Same as above, but achieves better compression. We use a lazy
	// evaluation for matches: a match is finally adopted only if there is
	// no better match at the next window position.
	function deflate_slow(flush){ // short hash_head = 0; // head of hash chain
	var hash_head=0; // head of hash chain
	var bflush; // set if current block must be flushed
	var max_insert; // Process the input block.
	while(true) { // Make sure that we always have enough lookahead, except
	// at the end of the input file. We need MAX_MATCH bytes
	// for the next match, plus MIN_MATCH bytes to insert the
	// string following the next match.
	if(lookahead < MIN_LOOKAHEAD){fill_window();if(lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH){return NeedMore;}if(lookahead === 0)break; // flush the current block
	} // Insert the string window[strstart .. strstart+2] in the
	// dictionary, and set hash_head to the head of the hash chain:
	if(lookahead >= MIN_MATCH){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;} // Find the longest match, discarding those <= prev_length.
	prev_length = match_length;prev_match = match_start;match_length = MIN_MATCH - 1;if(hash_head !== 0 && prev_length < max_lazy_match && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD){ // To simplify the code, we prevent matches with the string
	// of window index 0 (in particular we have to avoid a match
	// of the string with itself at the start of the input file).
	if(strategy != Z_HUFFMAN_ONLY){match_length = longest_match(hash_head);} // longest_match() sets match_start
	if(match_length <= 5 && (strategy == Z_FILTERED || match_length == MIN_MATCH && strstart - match_start > 4096)){ // If prev_match is also MIN_MATCH, match_start is garbage
	// but we will ignore the current match anyway.
	match_length = MIN_MATCH - 1;}} // If there was a match at the previous step and the current
	// match is not better, output the previous match:
	if(prev_length >= MIN_MATCH && match_length <= prev_length){max_insert = strstart + lookahead - MIN_MATCH; // Do not insert strings in hash table beyond this.
	// check_match(strstart-1, prev_match, prev_length);
	bflush = _tr_tally(strstart - 1 - prev_match,prev_length - MIN_MATCH); // Insert in hash table all strings up to the end of the match.
	// strstart-1 and strstart are already inserted. If there is not
	// enough lookahead, the last two strings are not inserted in
	// the hash table.
	lookahead -= prev_length - 1;prev_length -= 2;do {if(++strstart <= max_insert){ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask; // prev[strstart&w_mask]=hash_head=head[ins_h];
	hash_head = head[ins_h] & 0xffff;prev[strstart & w_mask] = head[ins_h];head[ins_h] = strstart;}}while(--prev_length !== 0);match_available = 0;match_length = MIN_MATCH - 1;strstart++;if(bflush){flush_block_only(false);if(strm.avail_out === 0)return NeedMore;}}else if(match_available !== 0){ // If there was no match at the previous position, output a
	// single literal. If there was a match but the current match
	// is longer, truncate the previous match to a single literal.
	bflush = _tr_tally(0,window[strstart - 1] & 0xff);if(bflush){flush_block_only(false);}strstart++;lookahead--;if(strm.avail_out === 0)return NeedMore;}else { // There is no previous match to compare with, wait for
	// the next step to decide.
	match_available = 1;strstart++;lookahead--;}}if(match_available !== 0){bflush = _tr_tally(0,window[strstart - 1] & 0xff);match_available = 0;}flush_block_only(flush == Z_FINISH);if(strm.avail_out === 0){if(flush == Z_FINISH)return FinishStarted;else return NeedMore;}return flush == Z_FINISH?FinishDone:BlockDone;}function deflateReset(strm){strm.total_in = strm.total_out = 0;strm.msg = null; //
	that.pending = 0;that.pending_out = 0;status = BUSY_STATE;last_flush = Z_NO_FLUSH;tr_init();lm_init();return Z_OK;}that.deflateInit = function(strm,_level,bits,_method,memLevel,_strategy){if(!_method)_method = Z_DEFLATED;if(!memLevel)memLevel = DEF_MEM_LEVEL;if(!_strategy)_strategy = Z_DEFAULT_STRATEGY; // byte[] my_version=ZLIB_VERSION;
	//
	// if (!version || version[0] != my_version[0]
	// || stream_size != sizeof(z_stream)) {
	// return Z_VERSION_ERROR;
	// }
	strm.msg = null;if(_level == Z_DEFAULT_COMPRESSION)_level = 6;if(memLevel < 1 || memLevel > MAX_MEM_LEVEL || _method != Z_DEFLATED || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY){return Z_STREAM_ERROR;}strm.dstate = that;w_bits = bits;w_size = 1 << w_bits;w_mask = w_size - 1;hash_bits = memLevel + 7;hash_size = 1 << hash_bits;hash_mask = hash_size - 1;hash_shift = Math.floor((hash_bits + MIN_MATCH - 1) / MIN_MATCH);window = new Uint8Array(w_size * 2);prev = [];head = [];lit_bufsize = 1 << memLevel + 6; // 16K elements by default
	// We overlay pending_buf and d_buf+l_buf. This works since the average
	// output size for (length,distance) codes is <= 24 bits.
	that.pending_buf = new Uint8Array(lit_bufsize * 4);pending_buf_size = lit_bufsize * 4;d_buf = Math.floor(lit_bufsize / 2);l_buf = (1 + 2) * lit_bufsize;level = _level;strategy = _strategy;method = _method & 0xff;return deflateReset(strm);};that.deflateEnd = function(){if(status != INIT_STATE && status != BUSY_STATE && status != FINISH_STATE){return Z_STREAM_ERROR;} // Deallocate in reverse order of allocations:
	that.pending_buf = null;head = null;prev = null;window = null; // free
	that.dstate = null;return status == BUSY_STATE?Z_DATA_ERROR:Z_OK;};that.deflateParams = function(strm,_level,_strategy){var err=Z_OK;if(_level == Z_DEFAULT_COMPRESSION){_level = 6;}if(_level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY){return Z_STREAM_ERROR;}if(config_table[level].func != config_table[_level].func && strm.total_in !== 0){ // Flush the last buffer:
	err = strm.deflate(Z_PARTIAL_FLUSH);}if(level != _level){level = _level;max_lazy_match = config_table[level].max_lazy;good_match = config_table[level].good_length;nice_match = config_table[level].nice_length;max_chain_length = config_table[level].max_chain;}strategy = _strategy;return err;};that.deflateSetDictionary = function(strm,dictionary,dictLength){var length=dictLength;var n,index=0;if(!dictionary || status != INIT_STATE)return Z_STREAM_ERROR;if(length < MIN_MATCH)return Z_OK;if(length > w_size - MIN_LOOKAHEAD){length = w_size - MIN_LOOKAHEAD;index = dictLength - length; // use the tail of the dictionary
	}window.set(dictionary.subarray(index,index + length),0);strstart = length;block_start = length; // Insert all strings in the hash table (except for the last two bytes).
	// s->lookahead stays null, so s->ins_h will be recomputed at the next
	// call of fill_window.
	ins_h = window[0] & 0xff;ins_h = (ins_h << hash_shift ^ window[1] & 0xff) & hash_mask;for(n = 0;n <= length - MIN_MATCH;n++) {ins_h = (ins_h << hash_shift ^ window[n + (MIN_MATCH - 1)] & 0xff) & hash_mask;prev[n & w_mask] = head[ins_h];head[ins_h] = n;}return Z_OK;};that.deflate = function(_strm,flush){var i,header,level_flags,old_flush,bstate;if(flush > Z_FINISH || flush < 0){return Z_STREAM_ERROR;}if(!_strm.next_out || !_strm.next_in && _strm.avail_in !== 0 || status == FINISH_STATE && flush != Z_FINISH){_strm.msg = z_errmsg[Z_NEED_DICT - Z_STREAM_ERROR];return Z_STREAM_ERROR;}if(_strm.avail_out === 0){_strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;}strm = _strm; // just in case
	old_flush = last_flush;last_flush = flush; // Write the zlib header
	if(status == INIT_STATE){header = Z_DEFLATED + (w_bits - 8 << 4) << 8;level_flags = (level - 1 & 0xff) >> 1;if(level_flags > 3)level_flags = 3;header |= level_flags << 6;if(strstart !== 0)header |= PRESET_DICT;header += 31 - header % 31;status = BUSY_STATE;putShortMSB(header);} // Flush as much pending output as possible
	if(that.pending !== 0){strm.flush_pending();if(strm.avail_out === 0){ // console.log(" avail_out==0");
	// Since avail_out is 0, deflate will be called again with
	// more output space, but possibly with both pending and
	// avail_in equal to zero. There won't be anything to do,
	// but this is not an error situation so make sure we
	// return OK instead of BUF_ERROR at next call of deflate:
	last_flush = -1;return Z_OK;} // Make sure there is something to do and avoid duplicate
	// consecutive
	// flushes. For repeated and useless calls with Z_FINISH, we keep
	// returning Z_STREAM_END instead of Z_BUFF_ERROR.
	}else if(strm.avail_in === 0 && flush <= old_flush && flush != Z_FINISH){strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;} // User must not provide more input after the first FINISH:
	if(status == FINISH_STATE && strm.avail_in !== 0){_strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];return Z_BUF_ERROR;} // Start a new block or continue the current one.
	if(strm.avail_in !== 0 || lookahead !== 0 || flush != Z_NO_FLUSH && status != FINISH_STATE){bstate = -1;switch(config_table[level].func){case STORED:bstate = deflate_stored(flush);break;case FAST:bstate = deflate_fast(flush);break;case SLOW:bstate = deflate_slow(flush);break;default:}if(bstate == FinishStarted || bstate == FinishDone){status = FINISH_STATE;}if(bstate == NeedMore || bstate == FinishStarted){if(strm.avail_out === 0){last_flush = -1; // avoid BUF_ERROR next call, see above
	}return Z_OK; // If flush != Z_NO_FLUSH && avail_out === 0, the next call
	// of deflate should use the same flush parameter to make sure
	// that the flush is complete. So we don't have to output an
	// empty block here, this will be done at next call. This also
	// ensures that for a very small output buffer, we emit at most
	// one empty block.
	}if(bstate == BlockDone){if(flush == Z_PARTIAL_FLUSH){_tr_align();}else { // FULL_FLUSH or SYNC_FLUSH
	_tr_stored_block(0,0,false); // For a full flush, this empty block will be recognized
	// as a special marker by inflate_sync().
	if(flush == Z_FULL_FLUSH){ // state.head[s.hash_size-1]=0;
	for(i = 0;i < hash_size /*-1*/;i++)  // forget history
	head[i] = 0;}}strm.flush_pending();if(strm.avail_out === 0){last_flush = -1; // avoid BUF_ERROR at next call, see above
	return Z_OK;}}}if(flush != Z_FINISH)return Z_OK;return Z_STREAM_END;};} // ZStream
	function ZStream(){var that=this;that.next_in_index = 0;that.next_out_index = 0; // that.next_in; // next input byte
	that.avail_in = 0; // number of bytes available at next_in
	that.total_in = 0; // total nb of input bytes read so far
	// that.next_out; // next output byte should be put there
	that.avail_out = 0; // remaining free space at next_out
	that.total_out = 0; // total nb of bytes output so far
	// that.msg;
	// that.dstate;
	}ZStream.prototype = {deflateInit:function deflateInit(level,bits){var that=this;that.dstate = new Deflate();if(!bits)bits = MAX_BITS;return that.dstate.deflateInit(that,level,bits);},deflate:function deflate(flush){var that=this;if(!that.dstate){return Z_STREAM_ERROR;}return that.dstate.deflate(that,flush);},deflateEnd:function deflateEnd(){var that=this;if(!that.dstate)return Z_STREAM_ERROR;var ret=that.dstate.deflateEnd();that.dstate = null;return ret;},deflateParams:function deflateParams(level,strategy){var that=this;if(!that.dstate)return Z_STREAM_ERROR;return that.dstate.deflateParams(that,level,strategy);},deflateSetDictionary:function deflateSetDictionary(dictionary,dictLength){var that=this;if(!that.dstate)return Z_STREAM_ERROR;return that.dstate.deflateSetDictionary(that,dictionary,dictLength);}, // Read a new buffer from the current input stream, update the
	// total number of bytes read. All deflate() input goes through
	// this function so some applications may wish to modify it to avoid
	// allocating a large strm->next_in buffer and copying from it.
	// (See also flush_pending()).
	read_buf:function read_buf(buf,start,size){var that=this;var len=that.avail_in;if(len > size)len = size;if(len === 0)return 0;that.avail_in -= len;buf.set(that.next_in.subarray(that.next_in_index,that.next_in_index + len),start);that.next_in_index += len;that.total_in += len;return len;}, // Flush as much pending output as possible. All deflate() output goes
	// through this function so some applications may wish to modify it
	// to avoid allocating a large strm->next_out buffer and copying into it.
	// (See also read_buf()).
	flush_pending:function flush_pending(){var that=this;var len=that.dstate.pending;if(len > that.avail_out)len = that.avail_out;if(len === 0)return; // if (that.dstate.pending_buf.length <= that.dstate.pending_out || that.next_out.length <= that.next_out_index
	// || that.dstate.pending_buf.length < (that.dstate.pending_out + len) || that.next_out.length < (that.next_out_index +
	// len)) {
	// console.log(that.dstate.pending_buf.length + ", " + that.dstate.pending_out + ", " + that.next_out.length + ", " +
	// that.next_out_index + ", " + len);
	// console.log("avail_out=" + that.avail_out);
	// }
	that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out,that.dstate.pending_out + len),that.next_out_index);that.next_out_index += len;that.dstate.pending_out += len;that.total_out += len;that.avail_out -= len;that.dstate.pending -= len;if(that.dstate.pending === 0){that.dstate.pending_out = 0;}}}; // Deflater
	return function Deflater(level){var that=this;var z=new ZStream();var bufsize=512;var flush=Z_NO_FLUSH;var buf=new Uint8Array(bufsize);if(typeof level == "undefined")level = Z_DEFAULT_COMPRESSION;z.deflateInit(level);z.next_out = buf;that.append = function(data,onprogress){var err,buffers=[],lastIndex=0,bufferIndex=0,bufferSize=0,array;if(!data.length)return;z.next_in_index = 0;z.next_in = data;z.avail_in = data.length;do {z.next_out_index = 0;z.avail_out = bufsize;err = z.deflate(flush);if(err != Z_OK)throw "deflating: " + z.msg;if(z.next_out_index)if(z.next_out_index == bufsize)buffers.push(new Uint8Array(buf));else buffers.push(new Uint8Array(buf.subarray(0,z.next_out_index)));bufferSize += z.next_out_index;if(onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex){onprogress(z.next_in_index);lastIndex = z.next_in_index;}}while(z.avail_in > 0 || z.avail_out === 0);array = new Uint8Array(bufferSize);buffers.forEach(function(chunk){array.set(chunk,bufferIndex);bufferIndex += chunk.length;});return array;};that.flush = function(){var err,buffers=[],bufferIndex=0,bufferSize=0,array;do {z.next_out_index = 0;z.avail_out = bufsize;err = z.deflate(Z_FINISH);if(err != Z_STREAM_END && err != Z_OK)throw "deflating: " + z.msg;if(bufsize - z.avail_out > 0)buffers.push(new Uint8Array(buf.subarray(0,z.next_out_index)));bufferSize += z.next_out_index;}while(z.avail_in > 0 || z.avail_out === 0);z.deflateEnd();array = new Uint8Array(bufferSize);buffers.forEach(function(chunk){array.set(chunk,bufferIndex);bufferIndex += chunk.length;});return array;};};})(undefined); /*
	  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
	  Copyright (c) 2016 Niklas von Hertzen
	
	  Released under  License
	*/!(function(e){if(true)module.exports = e();else if("function" == typeof define && define.amd)define([],e);else {var f;"undefined" != typeof window?f = window:"undefined" != typeof global?f = global:"undefined" != typeof self && (f = self),f.html2canvas = e();}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require == "function" && require;if(!u && a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '" + o + "'");throw (f.code = "MODULE_NOT_FOUND",f);}var l=n[o] = {exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e);},l,l.exports,e,t,n,r);}return n[o].exports;}var i=typeof require == "function" && require;for(var o=0;o < r.length;o++) s(r[o]);return s;})({1:[function(_dereq_,module,exports){(function(global){ /*! http://mths.be/punycode v1.2.4 by @mathias */(function(root){ /** Detect free variables */var freeExports=typeof exports == 'object' && exports;var freeModule=typeof module == 'object' && module && module.exports == freeExports && module;var freeGlobal=typeof global == 'object' && global;if(freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal){root = freeGlobal;} /**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */var punycode, /** Highest positive signed 32-bit float value */maxInt=2147483647, // aka. 0x7FFFFFFF or 2^31-1
	/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128, // 0x80
	delimiter='-', // '\x2D'
	/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^ -~]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators=/\x2E|\u3002|\uFF0E|\uFF61/g, // RFC 3490 separators
	/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'}, /** Convenience shortcuts */baseMinusTMin=base - tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode, /** Temporary variable */key; /*--------------------------------------------------------------------------*/ /**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */function error(type){throw RangeError(errors[type]);} /**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */function map(array,fn){var length=array.length;while(length--) {array[length] = fn(array[length]);}return array;} /**
		 * A simple `Array#map`-like wrapper to work with domain name strings.
		 * @private
		 * @param {String} domain The domain name.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */function mapDomain(string,fn){return map(string.split(regexSeparators),fn).join('.');} /**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <http://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter < length) {value = string.charCodeAt(counter++);if(value >= 0xD800 && value <= 0xDBFF && counter < length){ // high surrogate, and there is a next character
	extra = string.charCodeAt(counter++);if((extra & 0xFC00) == 0xDC00){ // low surrogate
	output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);}else { // unmatched surrogate; only append this code unit, in case the next
	// code unit is the high surrogate of a surrogate pair
	output.push(value);counter--;}}else {output.push(value);}}return output;} /**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */function ucs2encode(array){return map(array,function(value){var output='';if(value > 0xFFFF){value -= 0x10000;output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);value = 0xDC00 | value & 0x3FF;}output += stringFromCharCode(value);return output;}).join('');} /**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */function basicToDigit(codePoint){if(codePoint - 48 < 10){return codePoint - 22;}if(codePoint - 65 < 26){return codePoint - 65;}if(codePoint - 97 < 26){return codePoint - 97;}return base;} /**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */function digitToBasic(digit,flag){ //  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);} /**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */function adapt(delta,numPoints,firstTime){var k=0;delta = firstTime?floor(delta / damp):delta >> 1;delta += floor(delta / numPoints);for(; /* no initialization */delta > baseMinusTMin * tMax >> 1;k += base) {delta = floor(delta / baseMinusTMin);}return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));} /**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */function decode(input){ // Don't use UCS-2
	var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t, /** Cached calculation results */baseMinusT; // Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.
	basic = input.lastIndexOf(delimiter);if(basic < 0){basic = 0;}for(j = 0;j < basic;++j) { // if it's not a basic code point
	if(input.charCodeAt(j) >= 0x80){error('not-basic');}output.push(input.charCodeAt(j));} // Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.
	for(index = basic > 0?basic + 1:0;index < inputLength;)  /* no final expression */{ // `index` is the index of the next character to be consumed.
	// Decode a generalized variable-length integer into `delta`,
	// which gets added to `i`. The overflow checking is easier
	// if we increase `i` as we go, then subtract off its starting
	// value at the end to obtain `delta`.
	for(oldi = i,w = 1,k = base;; /* no condition */k += base) {if(index >= inputLength){error('invalid-input');}digit = basicToDigit(input.charCodeAt(index++));if(digit >= base || digit > floor((maxInt - i) / w)){error('overflow');}i += digit * w;t = k <= bias?tMin:k >= bias + tMax?tMax:k - bias;if(digit < t){break;}baseMinusT = base - t;if(w > floor(maxInt / baseMinusT)){error('overflow');}w *= baseMinusT;}out = output.length + 1;bias = adapt(i - oldi,out,oldi == 0); // `i` was supposed to wrap around from `out` to `0`,
	// incrementing `n` each time, so we'll fix that now:
	if(floor(i / out) > maxInt - n){error('overflow');}n += floor(i / out);i %= out; // Insert `n` at position `i` of the output
	output.splice(i++,0,n);}return ucs2encode(output);} /**
		 * Converts a string of Unicode symbols to a Punycode string of ASCII-only
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[], /** `inputLength` will hold the number of code points in `input`. */inputLength, /** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT; // Convert the input in UCS-2 to Unicode
	input = ucs2decode(input); // Cache the length
	inputLength = input.length; // Initialize the state
	n = initialN;delta = 0;bias = initialBias; // Handle the basic code points
	for(j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue < 0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount = basicLength = output.length; // `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.
	// Finish the basic string - if it is not empty - with a delimiter
	if(basicLength){output.push(delimiter);} // Main encoding loop:
	while(handledCPCount < inputLength) { // All non-basic code points < n have been handled already. Find the next
	// larger one:
	for(m = maxInt,j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue >= n && currentValue < m){m = currentValue;}} // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	// but guard against overflow
	handledCPCountPlusOne = handledCPCount + 1;if(m - n > floor((maxInt - delta) / handledCPCountPlusOne)){error('overflow');}delta += (m - n) * handledCPCountPlusOne;n = m;for(j = 0;j < inputLength;++j) {currentValue = input[j];if(currentValue < n && ++delta > maxInt){error('overflow');}if(currentValue == n){ // Represent delta as a generalized variable-length integer
	for(q = delta,k = base;; /* no condition */k += base) {t = k <= bias?tMin:k >= bias + tMax?tMax:k - bias;if(q < t){break;}qMinusT = q - t;baseMinusT = base - t;output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT,0)));q = floor(qMinusT / baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias = adapt(delta,handledCPCountPlusOne,handledCPCount == basicLength);delta = 0;++handledCPCount;}}++delta;++n;}return output.join('');} /**
		 * Converts a Punycode string representing a domain name to Unicode. Only the
		 * Punycoded parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it on a string that has already been converted to
		 * Unicode.
		 * @memberOf punycode
		 * @param {String} domain The Punycode domain name to convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */function toUnicode(domain){return mapDomain(domain,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});} /**
		 * Converts a Unicode string representing a domain name to Punycode. Only the
		 * non-ASCII parts of the domain name will be converted, i.e. it doesn't
		 * matter if you call it with a domain that's already in ASCII.
		 * @memberOf punycode
		 * @param {String} domain The domain name to convert, as a Unicode string.
		 * @returns {String} The Punycode representation of the given domain name.
		 */function toASCII(domain){return mapDomain(domain,function(string){return regexNonASCII.test(string)?'xn--' + encode(string):string;});} /*--------------------------------------------------------------------------*/ /** Define the public API */punycode = { /**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */'version':'1.2.4', /**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <http://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */'ucs2':{'decode':ucs2decode,'encode':ucs2encode},'decode':decode,'encode':encode,'toASCII':toASCII,'toUnicode':toUnicode}; /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if(typeof define == 'function' && typeof define.amd == 'object' && define.amd){define('punycode',function(){return punycode;});}else if(freeExports && !freeExports.nodeType){if(freeModule){ // in Node.js or RingoJS v0.8.0+
	freeModule.exports = punycode;}else { // in Narwhal or RingoJS v0.7.0-
	for(key in punycode) {punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);}}}else { // in Rhino or a web browser
	root.punycode = punycode;}})(this);}).call(this,typeof global !== "undefined"?global:typeof self !== "undefined"?self:typeof window !== "undefined"?window:{});},{}],2:[function(_dereq_,module,exports){var log=_dereq_('./log');function restoreOwnerScroll(ownerDocument,x,y){if(ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)){ownerDocument.defaultView.scrollTo(x,y);}}function cloneCanvasContents(canvas,clonedCanvas){try{if(clonedCanvas){clonedCanvas.width = canvas.width;clonedCanvas.height = canvas.height;clonedCanvas.getContext("2d").putImageData(canvas.getContext("2d").getImageData(0,0,canvas.width,canvas.height),0,0);}}catch(e) {log("Unable to copy canvas content from",canvas,e);}}function cloneNode(node,javascriptEnabled){var clone=node.nodeType === 3?document.createTextNode(node.nodeValue):node.cloneNode(false);var child=node.firstChild;while(child) {if(javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT'){clone.appendChild(cloneNode(child,javascriptEnabled));}child = child.nextSibling;}if(node.nodeType === 1){clone._scrollTop = node.scrollTop;clone._scrollLeft = node.scrollLeft;if(node.nodeName === "CANVAS"){cloneCanvasContents(node,clone);}else if(node.nodeName === "TEXTAREA" || node.nodeName === "SELECT"){clone.value = node.value;}}return clone;}function initNode(node){if(node.nodeType === 1){node.scrollTop = node._scrollTop;node.scrollLeft = node._scrollLeft;var child=node.firstChild;while(child) {initNode(child);child = child.nextSibling;}}}module.exports = function(ownerDocument,containerDocument,width,height,options,x,y){var documentElement=cloneNode(ownerDocument.documentElement,options.javascriptEnabled);var container=containerDocument.createElement("iframe");container.className = "html2canvas-container";container.style.visibility = "hidden";container.style.position = "fixed";container.style.left = "-10000px";container.style.top = "0px";container.style.border = "0";container.width = width;container.height = height;container.scrolling = "no"; // ios won't scroll without it
	containerDocument.body.appendChild(container);return new Promise(function(resolve){var documentClone=container.contentWindow.document; /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
	         if window url is about:blank, we can assign the url to current by writing onto the document
	         */container.contentWindow.onload = container.onload = function(){var interval=setInterval(function(){if(documentClone.body.childNodes.length > 0){initNode(documentClone.documentElement);clearInterval(interval);if(options.type === "view"){container.contentWindow.scrollTo(x,y);if(/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (container.contentWindow.scrollY !== y || container.contentWindow.scrollX !== x)){documentClone.documentElement.style.top = -y + "px";documentClone.documentElement.style.left = -x + "px";documentClone.documentElement.style.position = 'absolute';}}resolve(container);}},50);};documentClone.open();documentClone.write("<!DOCTYPE html><html></html>"); // Chrome scrolls the parent document for some reason after the write to the cloned window???
	restoreOwnerScroll(ownerDocument,x,y);documentClone.replaceChild(documentClone.adoptNode(documentElement),documentClone.documentElement);documentClone.close();});};},{"./log":13}],3:[function(_dereq_,module,exports){ // http://dev.w3.org/csswg/css-color/
	function Color(value){this.r = 0;this.g = 0;this.b = 0;this.a = null;var result=this.fromArray(value) || this.namedColor(value) || this.rgb(value) || this.rgba(value) || this.hex6(value) || this.hex3(value);}Color.prototype.darken = function(amount){var a=1 - amount;return new Color([Math.round(this.r * a),Math.round(this.g * a),Math.round(this.b * a),this.a]);};Color.prototype.isTransparent = function(){return this.a === 0;};Color.prototype.isBlack = function(){return this.r === 0 && this.g === 0 && this.b === 0;};Color.prototype.fromArray = function(array){if(Array.isArray(array)){this.r = Math.min(array[0],255);this.g = Math.min(array[1],255);this.b = Math.min(array[2],255);if(array.length > 3){this.a = array[3];}}return Array.isArray(array);};var _hex3=/^#([a-f0-9]{3})$/i;Color.prototype.hex3 = function(value){var match=null;if((match = value.match(_hex3)) !== null){this.r = parseInt(match[1][0] + match[1][0],16);this.g = parseInt(match[1][1] + match[1][1],16);this.b = parseInt(match[1][2] + match[1][2],16);}return match !== null;};var _hex6=/^#([a-f0-9]{6})$/i;Color.prototype.hex6 = function(value){var match=null;if((match = value.match(_hex6)) !== null){this.r = parseInt(match[1].substring(0,2),16);this.g = parseInt(match[1].substring(2,4),16);this.b = parseInt(match[1].substring(4,6),16);}return match !== null;};var _rgb=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;Color.prototype.rgb = function(value){var match=null;if((match = value.match(_rgb)) !== null){this.r = Number(match[1]);this.g = Number(match[2]);this.b = Number(match[3]);}return match !== null;};var _rgba=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;Color.prototype.rgba = function(value){var match=null;if((match = value.match(_rgba)) !== null){this.r = Number(match[1]);this.g = Number(match[2]);this.b = Number(match[3]);this.a = Number(match[4]);}return match !== null;};Color.prototype.toString = function(){return this.a !== null && this.a !== 1?"rgba(" + [this.r,this.g,this.b,this.a].join(",") + ")":"rgb(" + [this.r,this.g,this.b].join(",") + ")";};Color.prototype.namedColor = function(value){value = value.toLowerCase();var color=colors[value];if(color){this.r = color[0];this.g = color[1];this.b = color[2];}else if(value === "transparent"){this.r = this.g = this.b = this.a = 0;return true;}return !!color;};Color.prototype.isColor = true; // JSON.stringify([].slice.call($$('.named-color-table tr'), 1).map(function(row) { return [row.childNodes[3].textContent, row.childNodes[5].textContent.trim().split(",").map(Number)] }).reduce(function(data, row) {data[row[0]] = row[1]; return data}, {}))
	var colors={"aliceblue":[240,248,255],"antiquewhite":[250,235,215],"aqua":[0,255,255],"aquamarine":[127,255,212],"azure":[240,255,255],"beige":[245,245,220],"bisque":[255,228,196],"black":[0,0,0],"blanchedalmond":[255,235,205],"blue":[0,0,255],"blueviolet":[138,43,226],"brown":[165,42,42],"burlywood":[222,184,135],"cadetblue":[95,158,160],"chartreuse":[127,255,0],"chocolate":[210,105,30],"coral":[255,127,80],"cornflowerblue":[100,149,237],"cornsilk":[255,248,220],"crimson":[220,20,60],"cyan":[0,255,255],"darkblue":[0,0,139],"darkcyan":[0,139,139],"darkgoldenrod":[184,134,11],"darkgray":[169,169,169],"darkgreen":[0,100,0],"darkgrey":[169,169,169],"darkkhaki":[189,183,107],"darkmagenta":[139,0,139],"darkolivegreen":[85,107,47],"darkorange":[255,140,0],"darkorchid":[153,50,204],"darkred":[139,0,0],"darksalmon":[233,150,122],"darkseagreen":[143,188,143],"darkslateblue":[72,61,139],"darkslategray":[47,79,79],"darkslategrey":[47,79,79],"darkturquoise":[0,206,209],"darkviolet":[148,0,211],"deeppink":[255,20,147],"deepskyblue":[0,191,255],"dimgray":[105,105,105],"dimgrey":[105,105,105],"dodgerblue":[30,144,255],"firebrick":[178,34,34],"floralwhite":[255,250,240],"forestgreen":[34,139,34],"fuchsia":[255,0,255],"gainsboro":[220,220,220],"ghostwhite":[248,248,255],"gold":[255,215,0],"goldenrod":[218,165,32],"gray":[128,128,128],"green":[0,128,0],"greenyellow":[173,255,47],"grey":[128,128,128],"honeydew":[240,255,240],"hotpink":[255,105,180],"indianred":[205,92,92],"indigo":[75,0,130],"ivory":[255,255,240],"khaki":[240,230,140],"lavender":[230,230,250],"lavenderblush":[255,240,245],"lawngreen":[124,252,0],"lemonchiffon":[255,250,205],"lightblue":[173,216,230],"lightcoral":[240,128,128],"lightcyan":[224,255,255],"lightgoldenrodyellow":[250,250,210],"lightgray":[211,211,211],"lightgreen":[144,238,144],"lightgrey":[211,211,211],"lightpink":[255,182,193],"lightsalmon":[255,160,122],"lightseagreen":[32,178,170],"lightskyblue":[135,206,250],"lightslategray":[119,136,153],"lightslategrey":[119,136,153],"lightsteelblue":[176,196,222],"lightyellow":[255,255,224],"lime":[0,255,0],"limegreen":[50,205,50],"linen":[250,240,230],"magenta":[255,0,255],"maroon":[128,0,0],"mediumaquamarine":[102,205,170],"mediumblue":[0,0,205],"mediumorchid":[186,85,211],"mediumpurple":[147,112,219],"mediumseagreen":[60,179,113],"mediumslateblue":[123,104,238],"mediumspringgreen":[0,250,154],"mediumturquoise":[72,209,204],"mediumvioletred":[199,21,133],"midnightblue":[25,25,112],"mintcream":[245,255,250],"mistyrose":[255,228,225],"moccasin":[255,228,181],"navajowhite":[255,222,173],"navy":[0,0,128],"oldlace":[253,245,230],"olive":[128,128,0],"olivedrab":[107,142,35],"orange":[255,165,0],"orangered":[255,69,0],"orchid":[218,112,214],"palegoldenrod":[238,232,170],"palegreen":[152,251,152],"paleturquoise":[175,238,238],"palevioletred":[219,112,147],"papayawhip":[255,239,213],"peachpuff":[255,218,185],"peru":[205,133,63],"pink":[255,192,203],"plum":[221,160,221],"powderblue":[176,224,230],"purple":[128,0,128],"rebeccapurple":[102,51,153],"red":[255,0,0],"rosybrown":[188,143,143],"royalblue":[65,105,225],"saddlebrown":[139,69,19],"salmon":[250,128,114],"sandybrown":[244,164,96],"seagreen":[46,139,87],"seashell":[255,245,238],"sienna":[160,82,45],"silver":[192,192,192],"skyblue":[135,206,235],"slateblue":[106,90,205],"slategray":[112,128,144],"slategrey":[112,128,144],"snow":[255,250,250],"springgreen":[0,255,127],"steelblue":[70,130,180],"tan":[210,180,140],"teal":[0,128,128],"thistle":[216,191,216],"tomato":[255,99,71],"turquoise":[64,224,208],"violet":[238,130,238],"wheat":[245,222,179],"white":[255,255,255],"whitesmoke":[245,245,245],"yellow":[255,255,0],"yellowgreen":[154,205,50]};module.exports = Color;},{}],4:[function(_dereq_,module,exports){var Support=_dereq_('./support');var CanvasRenderer=_dereq_('./renderers/canvas');var ImageLoader=_dereq_('./imageloader');var NodeParser=_dereq_('./nodeparser');var NodeContainer=_dereq_('./nodecontainer');var log=_dereq_('./log');var utils=_dereq_('./utils');var createWindowClone=_dereq_('./clone');var loadUrlDocument=_dereq_('./proxy').loadUrlDocument;var getBounds=utils.getBounds;var html2canvasNodeAttribute="data-html2canvas-node";var html2canvasCloneIndex=0;function html2canvas(nodeList,options){var index=html2canvasCloneIndex++;options = options || {};if(options.logging){log.options.logging = true;log.options.start = Date.now();}options.async = typeof options.async === "undefined"?true:options.async;options.allowTaint = typeof options.allowTaint === "undefined"?false:options.allowTaint;options.removeContainer = typeof options.removeContainer === "undefined"?true:options.removeContainer;options.javascriptEnabled = typeof options.javascriptEnabled === "undefined"?false:options.javascriptEnabled;options.imageTimeout = typeof options.imageTimeout === "undefined"?10000:options.imageTimeout;options.renderer = typeof options.renderer === "function"?options.renderer:CanvasRenderer;options.strict = !!options.strict;if(typeof nodeList === "string"){if(typeof options.proxy !== "string"){return Promise.reject("Proxy must be used when rendering url");}var width=options.width != null?options.width:window.innerWidth;var height=options.height != null?options.height:window.innerHeight;return loadUrlDocument(absoluteUrl(nodeList),options.proxy,document,width,height,options).then(function(container){return renderWindow(container.contentWindow.document.documentElement,container,options,width,height);});}var node=(nodeList === undefined?[document.documentElement]:nodeList.length?nodeList:[nodeList])[0];node.setAttribute(html2canvasNodeAttribute + index,index);return renderDocument(node.ownerDocument,options,node.ownerDocument.defaultView.innerWidth,node.ownerDocument.defaultView.innerHeight,index).then(function(canvas){if(typeof options.onrendered === "function"){log("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas");options.onrendered(canvas);}return canvas;});}html2canvas.CanvasRenderer = CanvasRenderer;html2canvas.NodeContainer = NodeContainer;html2canvas.log = log;html2canvas.utils = utils;var html2canvasExport=typeof document === "undefined" || typeof Object.create !== "function" || typeof document.createElement("canvas").getContext !== "function"?function(){return Promise.reject("No canvas support");}:html2canvas;module.exports = html2canvasExport;if(typeof define === 'function' && define.amd){define('html2canvas',[],function(){return html2canvasExport;});}function renderDocument(document,options,windowWidth,windowHeight,html2canvasIndex){return createWindowClone(document,document,windowWidth,windowHeight,options,document.defaultView.pageXOffset,document.defaultView.pageYOffset).then(function(container){log("Document cloned");var attributeName=html2canvasNodeAttribute + html2canvasIndex;var selector="[" + attributeName + "='" + html2canvasIndex + "']";document.querySelector(selector).removeAttribute(attributeName);var clonedWindow=container.contentWindow;var node=clonedWindow.document.querySelector(selector);var oncloneHandler=typeof options.onclone === "function"?Promise.resolve(options.onclone(clonedWindow.document)):Promise.resolve(true);return oncloneHandler.then(function(){return renderWindow(node,container,options,windowWidth,windowHeight);});});}function renderWindow(node,container,options,windowWidth,windowHeight){var clonedWindow=container.contentWindow;var support=new Support(clonedWindow.document);var imageLoader=new ImageLoader(options,support);var bounds=getBounds(node);var width=options.type === "view"?windowWidth:documentWidth(clonedWindow.document);var height=options.type === "view"?windowHeight:documentHeight(clonedWindow.document);var renderer=new options.renderer(width,height,imageLoader,options,document);var parser=new NodeParser(node,renderer,support,imageLoader,options);return parser.ready.then(function(){log("Finished rendering");var canvas;if(options.type === "view"){canvas = crop(renderer.canvas,{width:renderer.canvas.width,height:renderer.canvas.height,top:0,left:0,x:0,y:0});}else if(node === clonedWindow.document.body || node === clonedWindow.document.documentElement || options.canvas != null){canvas = renderer.canvas;}else {canvas = crop(renderer.canvas,{width:options.width != null?options.width:bounds.width,height:options.height != null?options.height:bounds.height,top:bounds.top,left:bounds.left,x:0,y:0});}cleanupContainer(container,options);return canvas;});}function cleanupContainer(container,options){if(options.removeContainer){container.parentNode.removeChild(container);log("Cleaned up container");}}function crop(canvas,bounds){var croppedCanvas=document.createElement("canvas");var x1=Math.min(canvas.width - 1,Math.max(0,bounds.left));var x2=Math.min(canvas.width,Math.max(1,bounds.left + bounds.width));var y1=Math.min(canvas.height - 1,Math.max(0,bounds.top));var y2=Math.min(canvas.height,Math.max(1,bounds.top + bounds.height));croppedCanvas.width = bounds.width;croppedCanvas.height = bounds.height;var width=x2 - x1;var height=y2 - y1;log("Cropping canvas at:","left:",bounds.left,"top:",bounds.top,"width:",width,"height:",height);log("Resulting crop with width",bounds.width,"and height",bounds.height,"with x",x1,"and y",y1);croppedCanvas.getContext("2d").drawImage(canvas,x1,y1,width,height,bounds.x,bounds.y,width,height);return croppedCanvas;}function documentWidth(doc){return Math.max(Math.max(doc.body.scrollWidth,doc.documentElement.scrollWidth),Math.max(doc.body.offsetWidth,doc.documentElement.offsetWidth),Math.max(doc.body.clientWidth,doc.documentElement.clientWidth));}function documentHeight(doc){return Math.max(Math.max(doc.body.scrollHeight,doc.documentElement.scrollHeight),Math.max(doc.body.offsetHeight,doc.documentElement.offsetHeight),Math.max(doc.body.clientHeight,doc.documentElement.clientHeight));}function absoluteUrl(url){var link=document.createElement("a");link.href = url;link.href = link.href;return link;}},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(_dereq_,module,exports){var log=_dereq_('./log');var smallImage=_dereq_('./utils').smallImage;function DummyImageContainer(src){this.src = src;log("DummyImageContainer for",src);if(!this.promise || !this.image){log("Initiating DummyImageContainer");DummyImageContainer.prototype.image = new Image();var image=this.image;DummyImageContainer.prototype.promise = new Promise(function(resolve,reject){image.onload = resolve;image.onerror = reject;image.src = smallImage();if(image.complete === true){resolve(image);}});}}module.exports = DummyImageContainer;},{"./log":13,"./utils":26}],6:[function(_dereq_,module,exports){var smallImage=_dereq_('./utils').smallImage;function Font(family,size){var container=document.createElement('div'),img=document.createElement('img'),span=document.createElement('span'),sampleText='Hidden Text',baseline,middle;container.style.visibility = "hidden";container.style.fontFamily = family;container.style.fontSize = size;container.style.margin = 0;container.style.padding = 0;document.body.appendChild(container);img.src = smallImage();img.width = 1;img.height = 1;img.style.margin = 0;img.style.padding = 0;img.style.verticalAlign = "baseline";span.style.fontFamily = family;span.style.fontSize = size;span.style.margin = 0;span.style.padding = 0;span.appendChild(document.createTextNode(sampleText));container.appendChild(span);container.appendChild(img);baseline = img.offsetTop - span.offsetTop + 1;container.removeChild(span);container.appendChild(document.createTextNode(sampleText));container.style.lineHeight = "normal";img.style.verticalAlign = "super";middle = img.offsetTop - container.offsetTop + 1;document.body.removeChild(container);this.baseline = baseline;this.lineWidth = 1;this.middle = middle;}module.exports = Font;},{"./utils":26}],7:[function(_dereq_,module,exports){var Font=_dereq_('./font');function FontMetrics(){this.data = {};}FontMetrics.prototype.getMetrics = function(family,size){if(this.data[family + "-" + size] === undefined){this.data[family + "-" + size] = new Font(family,size);}return this.data[family + "-" + size];};module.exports = FontMetrics;},{"./font":6}],8:[function(_dereq_,module,exports){var utils=_dereq_('./utils');var getBounds=utils.getBounds;var loadUrlDocument=_dereq_('./proxy').loadUrlDocument;function FrameContainer(container,sameOrigin,options){this.image = null;this.src = container;var self=this;var bounds=getBounds(container);this.promise = (!sameOrigin?this.proxyLoad(options.proxy,bounds,options):new Promise(function(resolve){if(container.contentWindow.document.URL === "about:blank" || container.contentWindow.document.documentElement == null){container.contentWindow.onload = container.onload = function(){resolve(container);};}else {resolve(container);}})).then(function(container){var html2canvas=_dereq_('./core');return html2canvas(container.contentWindow.document.documentElement,{type:'view',width:container.width,height:container.height,proxy:options.proxy,javascriptEnabled:options.javascriptEnabled,removeContainer:options.removeContainer,allowTaint:options.allowTaint,imageTimeout:options.imageTimeout / 2});}).then(function(canvas){return self.image = canvas;});}FrameContainer.prototype.proxyLoad = function(proxy,bounds,options){var container=this.src;return loadUrlDocument(container.src,proxy,container.ownerDocument,bounds.width,bounds.height,options);};module.exports = FrameContainer;},{"./core":4,"./proxy":16,"./utils":26}],9:[function(_dereq_,module,exports){function GradientContainer(imageData){this.src = imageData.value;this.colorStops = [];this.type = null;this.x0 = 0.5;this.y0 = 0.5;this.x1 = 0.5;this.y1 = 0.5;this.promise = Promise.resolve(true);}GradientContainer.TYPES = {LINEAR:1,RADIAL:2}; // TODO: support hsl[a], negative %/length values
	// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
	GradientContainer.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i;module.exports = GradientContainer;},{}],10:[function(_dereq_,module,exports){function ImageContainer(src,cors){this.src = src;this.image = new Image();var self=this;this.tainted = null;this.promise = new Promise(function(resolve,reject){self.image.onload = resolve;self.image.onerror = reject;if(cors){self.image.crossOrigin = "anonymous";}self.image.src = src;if(self.image.complete === true){resolve(self.image);}});}module.exports = ImageContainer;},{}],11:[function(_dereq_,module,exports){var log=_dereq_('./log');var ImageContainer=_dereq_('./imagecontainer');var DummyImageContainer=_dereq_('./dummyimagecontainer');var ProxyImageContainer=_dereq_('./proxyimagecontainer');var FrameContainer=_dereq_('./framecontainer');var SVGContainer=_dereq_('./svgcontainer');var SVGNodeContainer=_dereq_('./svgnodecontainer');var LinearGradientContainer=_dereq_('./lineargradientcontainer');var WebkitGradientContainer=_dereq_('./webkitgradientcontainer');var bind=_dereq_('./utils').bind;function ImageLoader(options,support){this.link = null;this.options = options;this.support = support;this.origin = this.getOrigin(window.location.href);}ImageLoader.prototype.findImages = function(nodes){var images=[];nodes.reduce(function(imageNodes,container){switch(container.node.nodeName){case "IMG":return imageNodes.concat([{args:[container.node.src],method:"url"}]);case "svg":case "IFRAME":return imageNodes.concat([{args:[container.node],method:container.node.nodeName}]);}return imageNodes;},[]).forEach(this.addImage(images,this.loadImage),this);return images;};ImageLoader.prototype.findBackgroundImage = function(images,container){container.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(images,this.loadImage),this);return images;};ImageLoader.prototype.addImage = function(images,callback){return function(newImage){newImage.args.forEach(function(image){if(!this.imageExists(images,image)){images.splice(0,0,callback.call(this,newImage));log('Added image #' + images.length,typeof image === "string"?image.substring(0,100):image);}},this);};};ImageLoader.prototype.hasImageBackground = function(imageData){return imageData.method !== "none";};ImageLoader.prototype.loadImage = function(imageData){if(imageData.method === "url"){var src=imageData.args[0];if(this.isSVG(src) && !this.support.svg && !this.options.allowTaint){return new SVGContainer(src);}else if(src.match(/data:image\/.*;base64,/i)){return new ImageContainer(src.replace(/url\(['"]{0,}|['"]{0,}\)$/ig,''),false);}else if(this.isSameOrigin(src) || this.options.allowTaint === true || this.isSVG(src)){return new ImageContainer(src,false);}else if(this.support.cors && !this.options.allowTaint && this.options.useCORS){return new ImageContainer(src,true);}else if(this.options.proxy){return new ProxyImageContainer(src,this.options.proxy);}else {return new DummyImageContainer(src);}}else if(imageData.method === "linear-gradient"){return new LinearGradientContainer(imageData);}else if(imageData.method === "gradient"){return new WebkitGradientContainer(imageData);}else if(imageData.method === "svg"){return new SVGNodeContainer(imageData.args[0],this.support.svg);}else if(imageData.method === "IFRAME"){return new FrameContainer(imageData.args[0],this.isSameOrigin(imageData.args[0].src),this.options);}else {return new DummyImageContainer(imageData);}};ImageLoader.prototype.isSVG = function(src){return src.substring(src.length - 3).toLowerCase() === "svg" || SVGContainer.prototype.isInline(src);};ImageLoader.prototype.imageExists = function(images,src){return images.some(function(image){return image.src === src;});};ImageLoader.prototype.isSameOrigin = function(url){return this.getOrigin(url) === this.origin;};ImageLoader.prototype.getOrigin = function(url){var link=this.link || (this.link = document.createElement("a"));link.href = url;link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
	return link.protocol + link.hostname + link.port;};ImageLoader.prototype.getPromise = function(container){return this.timeout(container,this.options.imageTimeout)['catch'](function(){var dummy=new DummyImageContainer(container.src);return dummy.promise.then(function(image){container.image = image;});});};ImageLoader.prototype.get = function(src){var found=null;return this.images.some(function(img){return (found = img).src === src;})?found:null;};ImageLoader.prototype.fetch = function(nodes){this.images = nodes.reduce(bind(this.findBackgroundImage,this),this.findImages(nodes));this.images.forEach(function(image,index){image.promise.then(function(){log("Succesfully loaded image #" + (index + 1),image);},function(e){log("Failed loading image #" + (index + 1),image,e);});});this.ready = Promise.all(this.images.map(this.getPromise,this));log("Finished searching images");return this;};ImageLoader.prototype.timeout = function(container,timeout){var timer;var promise=Promise.race([container.promise,new Promise(function(res,reject){timer = setTimeout(function(){log("Timed out loading image",container);reject(container);},timeout);})]).then(function(container){clearTimeout(timer);return container;});promise['catch'](function(){clearTimeout(timer);});return promise;};module.exports = ImageLoader;},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(_dereq_,module,exports){var GradientContainer=_dereq_('./gradientcontainer');var Color=_dereq_('./color');function LinearGradientContainer(imageData){GradientContainer.apply(this,arguments);this.type = GradientContainer.TYPES.LINEAR;var hasDirection=LinearGradientContainer.REGEXP_DIRECTION.test(imageData.args[0]) || !GradientContainer.REGEXP_COLORSTOP.test(imageData.args[0]);if(hasDirection){imageData.args[0].split(/\s+/).reverse().forEach(function(position,index){switch(position){case "left":this.x0 = 0;this.x1 = 1;break;case "top":this.y0 = 0;this.y1 = 1;break;case "right":this.x0 = 1;this.x1 = 0;break;case "bottom":this.y0 = 1;this.y1 = 0;break;case "to":var y0=this.y0;var x0=this.x0;this.y0 = this.y1;this.x0 = this.x1;this.x1 = x0;this.y1 = y0;break;case "center":break; // centered by default
	// Firefox internally converts position keywords to percentages:
	// http://www.w3.org/TR/2010/WD-CSS2-20101207/colors.html#propdef-background-position
	default: // percentage or absolute length
	// TODO: support absolute start point positions (e.g., use bounds to convert px to a ratio)
	var ratio=parseFloat(position,10) * 1e-2;if(isNaN(ratio)){ // invalid or unhandled value
	break;}if(index === 0){this.y0 = ratio;this.y1 = 1 - this.y0;}else {this.x0 = ratio;this.x1 = 1 - this.x0;}break;}},this);}else {this.y0 = 0;this.y1 = 1;}this.colorStops = imageData.args.slice(hasDirection?1:0).map(function(colorStop){var colorStopMatch=colorStop.match(GradientContainer.REGEXP_COLORSTOP);var value=+colorStopMatch[2];var unit=value === 0?"%":colorStopMatch[3]; // treat "0" as "0%"
	return {color:new Color(colorStopMatch[1]), // TODO: support absolute stop positions (e.g., compute gradient line length & convert px to ratio)
	stop:unit === "%"?value / 100:null};});if(this.colorStops[0].stop === null){this.colorStops[0].stop = 0;}if(this.colorStops[this.colorStops.length - 1].stop === null){this.colorStops[this.colorStops.length - 1].stop = 1;} // calculates and fills-in explicit stop positions when omitted from rule
	this.colorStops.forEach(function(colorStop,index){if(colorStop.stop === null){this.colorStops.slice(index).some(function(find,count){if(find.stop !== null){colorStop.stop = (find.stop - this.colorStops[index - 1].stop) / (count + 1) + this.colorStops[index - 1].stop;return true;}else {return false;}},this);}},this);}LinearGradientContainer.prototype = Object.create(GradientContainer.prototype); // TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
	LinearGradientContainer.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i;module.exports = LinearGradientContainer;},{"./color":3,"./gradientcontainer":9}],13:[function(_dereq_,module,exports){var logger=function logger(){if(logger.options.logging && window.console && window.console.log){Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now() - logger.options.start + "ms","html2canvas:"].concat([].slice.call(arguments,0)));}};logger.options = {logging:false};module.exports = logger;},{}],14:[function(_dereq_,module,exports){var Color=_dereq_('./color');var utils=_dereq_('./utils');var getBounds=utils.getBounds;var parseBackgrounds=utils.parseBackgrounds;var offsetBounds=utils.offsetBounds;function NodeContainer(node,parent){this.node = node;this.parent = parent;this.stack = null;this.bounds = null;this.borders = null;this.clip = [];this.backgroundClip = [];this.offsetBounds = null;this.visible = null;this.computedStyles = null;this.colors = {};this.styles = {};this.backgroundImages = null;this.transformData = null;this.transformMatrix = null;this.isPseudoElement = false;this.opacity = null;}NodeContainer.prototype.cloneTo = function(stack){stack.visible = this.visible;stack.borders = this.borders;stack.bounds = this.bounds;stack.clip = this.clip;stack.backgroundClip = this.backgroundClip;stack.computedStyles = this.computedStyles;stack.styles = this.styles;stack.backgroundImages = this.backgroundImages;stack.opacity = this.opacity;};NodeContainer.prototype.getOpacity = function(){return this.opacity === null?this.opacity = this.cssFloat('opacity'):this.opacity;};NodeContainer.prototype.assignStack = function(stack){this.stack = stack;stack.children.push(this);};NodeContainer.prototype.isElementVisible = function(){return this.node.nodeType === Node.TEXT_NODE?this.parent.visible:this.css('display') !== "none" && this.css('visibility') !== "hidden" && !this.node.hasAttribute("data-html2canvas-ignore") && (this.node.nodeName !== "INPUT" || this.node.getAttribute("type") !== "hidden");};NodeContainer.prototype.css = function(attribute){if(!this.computedStyles){this.computedStyles = this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null);}return this.styles[attribute] || (this.styles[attribute] = this.computedStyles[attribute]);};NodeContainer.prototype.prefixedCss = function(attribute){var prefixes=["webkit","moz","ms","o"];var value=this.css(attribute);if(value === undefined){prefixes.some(function(prefix){value = this.css(prefix + attribute.substr(0,1).toUpperCase() + attribute.substr(1));return value !== undefined;},this);}return value === undefined?null:value;};NodeContainer.prototype.computedStyle = function(type){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,type);};NodeContainer.prototype.cssInt = function(attribute){var value=parseInt(this.css(attribute),10);return isNaN(value)?0:value; // borders in old IE are throwing 'medium' for demo.html
	};NodeContainer.prototype.color = function(attribute){return this.colors[attribute] || (this.colors[attribute] = new Color(this.css(attribute)));};NodeContainer.prototype.cssFloat = function(attribute){var value=parseFloat(this.css(attribute));return isNaN(value)?0:value;};NodeContainer.prototype.fontWeight = function(){var weight=this.css("fontWeight");switch(parseInt(weight,10)){case 401:weight = "bold";break;case 400:weight = "normal";break;}return weight;};NodeContainer.prototype.parseClip = function(){var matches=this.css('clip').match(this.CLIP);if(matches){return {top:parseInt(matches[1],10),right:parseInt(matches[2],10),bottom:parseInt(matches[3],10),left:parseInt(matches[4],10)};}return null;};NodeContainer.prototype.parseBackgroundImages = function(){return this.backgroundImages || (this.backgroundImages = parseBackgrounds(this.css("backgroundImage")));};NodeContainer.prototype.cssList = function(property,index){var value=(this.css(property) || '').split(',');value = value[index || 0] || value[0] || 'auto';value = value.trim().split(' ');if(value.length === 1){value = [value[0],isPercentage(value[0])?'auto':value[0]];}return value;};NodeContainer.prototype.parseBackgroundSize = function(bounds,image,index){var size=this.cssList("backgroundSize",index);var width,height;if(isPercentage(size[0])){width = bounds.width * parseFloat(size[0]) / 100;}else if(/contain|cover/.test(size[0])){var targetRatio=bounds.width / bounds.height,currentRatio=image.width / image.height;return targetRatio < currentRatio ^ size[0] === 'contain'?{width:bounds.height * currentRatio,height:bounds.height}:{width:bounds.width,height:bounds.width / currentRatio};}else {width = parseInt(size[0],10);}if(size[0] === 'auto' && size[1] === 'auto'){height = image.height;}else if(size[1] === 'auto'){height = width / image.width * image.height;}else if(isPercentage(size[1])){height = bounds.height * parseFloat(size[1]) / 100;}else {height = parseInt(size[1],10);}if(size[0] === 'auto'){width = height / image.height * image.width;}return {width:width,height:height};};NodeContainer.prototype.parseBackgroundPosition = function(bounds,image,index,backgroundSize){var position=this.cssList('backgroundPosition',index);var left,top;if(isPercentage(position[0])){left = (bounds.width - (backgroundSize || image).width) * (parseFloat(position[0]) / 100);}else {left = parseInt(position[0],10);}if(position[1] === 'auto'){top = left / image.width * image.height;}else if(isPercentage(position[1])){top = (bounds.height - (backgroundSize || image).height) * parseFloat(position[1]) / 100;}else {top = parseInt(position[1],10);}if(position[0] === 'auto'){left = top / image.height * image.width;}return {left:left,top:top};};NodeContainer.prototype.parseBackgroundRepeat = function(index){return this.cssList("backgroundRepeat",index)[0];};NodeContainer.prototype.parseTextShadows = function(){var textShadow=this.css("textShadow");var results=[];if(textShadow && textShadow !== 'none'){var shadows=textShadow.match(this.TEXT_SHADOW_PROPERTY);for(var i=0;shadows && i < shadows.length;i++) {var s=shadows[i].match(this.TEXT_SHADOW_VALUES);results.push({color:new Color(s[0]),offsetX:s[1]?parseFloat(s[1].replace('px','')):0,offsetY:s[2]?parseFloat(s[2].replace('px','')):0,blur:s[3]?s[3].replace('px',''):0});}}return results;};NodeContainer.prototype.parseTransform = function(){if(!this.transformData){if(this.hasTransform()){var offset=this.parseBounds();var origin=this.prefixedCss("transformOrigin").split(" ").map(removePx).map(asFloat);origin[0] += offset.left;origin[1] += offset.top;this.transformData = {origin:origin,matrix:this.parseTransformMatrix()};}else {this.transformData = {origin:[0,0],matrix:[1,0,0,1,0,0]};}}return this.transformData;};NodeContainer.prototype.parseTransformMatrix = function(){if(!this.transformMatrix){var transform=this.prefixedCss("transform");var matrix=transform?parseMatrix(transform.match(this.MATRIX_PROPERTY)):null;this.transformMatrix = matrix?matrix:[1,0,0,1,0,0];}return this.transformMatrix;};NodeContainer.prototype.parseBounds = function(){return this.bounds || (this.bounds = this.hasTransform()?offsetBounds(this.node):getBounds(this.node));};NodeContainer.prototype.hasTransform = function(){return this.parseTransformMatrix().join(",") !== "1,0,0,1,0,0" || this.parent && this.parent.hasTransform();};NodeContainer.prototype.getValue = function(){var value=this.node.value || "";if(this.node.tagName === "SELECT"){value = selectionValue(this.node);}else if(this.node.type === "password"){value = Array(value.length + 1).join('•'); // jshint ignore:line
	}return value.length === 0?this.node.placeholder || "":value;};NodeContainer.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/;NodeContainer.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g;NodeContainer.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g;NodeContainer.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/;function selectionValue(node){var option=node.options[node.selectedIndex || 0];return option?option.text || "":"";}function parseMatrix(match){if(match && match[1] === "matrix"){return match[2].split(",").map(function(s){return parseFloat(s.trim());});}else if(match && match[1] === "matrix3d"){var matrix3d=match[2].split(",").map(function(s){return parseFloat(s.trim());});return [matrix3d[0],matrix3d[1],matrix3d[4],matrix3d[5],matrix3d[12],matrix3d[13]];}}function isPercentage(value){return value.toString().indexOf("%") !== -1;}function removePx(str){return str.replace("px","");}function asFloat(str){return parseFloat(str);}module.exports = NodeContainer;},{"./color":3,"./utils":26}],15:[function(_dereq_,module,exports){var log=_dereq_('./log');var punycode=_dereq_('punycode');var NodeContainer=_dereq_('./nodecontainer');var TextContainer=_dereq_('./textcontainer');var PseudoElementContainer=_dereq_('./pseudoelementcontainer');var FontMetrics=_dereq_('./fontmetrics');var Color=_dereq_('./color');var StackingContext=_dereq_('./stackingcontext');var utils=_dereq_('./utils');var bind=utils.bind;var getBounds=utils.getBounds;var parseBackgrounds=utils.parseBackgrounds;var offsetBounds=utils.offsetBounds;function NodeParser(element,renderer,support,imageLoader,options){log("Starting NodeParser");this.renderer = renderer;this.options = options;this.range = null;this.support = support;this.renderQueue = [];this.stack = new StackingContext(true,1,element.ownerDocument,null);var parent=new NodeContainer(element,null);if(options.background){renderer.rectangle(0,0,renderer.width,renderer.height,new Color(options.background));}if(element === element.ownerDocument.documentElement){ // http://www.w3.org/TR/css3-background/#special-backgrounds
	var canvasBackground=new NodeContainer(parent.color('backgroundColor').isTransparent()?element.ownerDocument.body:element.ownerDocument.documentElement,null);renderer.rectangle(0,0,renderer.width,renderer.height,canvasBackground.color('backgroundColor'));}parent.visibile = parent.isElementVisible();this.createPseudoHideStyles(element.ownerDocument);this.disableAnimations(element.ownerDocument);this.nodes = flatten([parent].concat(this.getChildren(parent)).filter(function(container){return container.visible = container.isElementVisible();}).map(this.getPseudoElements,this));this.fontMetrics = new FontMetrics();log("Fetched nodes, total:",this.nodes.length);log("Calculate overflow clips");this.calculateOverflowClips();log("Start fetching images");this.images = imageLoader.fetch(this.nodes.filter(isElement));this.ready = this.images.ready.then(bind(function(){log("Images loaded, starting parsing");log("Creating stacking contexts");this.createStackingContexts();log("Sorting stacking contexts");this.sortStackingContexts(this.stack);this.parse(this.stack);log("Render queue created with " + this.renderQueue.length + " items");return new Promise(bind(function(resolve){if(!options.async){this.renderQueue.forEach(this.paint,this);resolve();}else if(typeof options.async === "function"){options.async.call(this,this.renderQueue,resolve);}else if(this.renderQueue.length > 0){this.renderIndex = 0;this.asyncRenderer(this.renderQueue,resolve);}else {resolve();}},this));},this));}NodeParser.prototype.calculateOverflowClips = function(){this.nodes.forEach(function(container){if(isElement(container)){if(isPseudoElement(container)){container.appendToDOM();}container.borders = this.parseBorders(container);var clip=container.css('overflow') === "hidden"?[container.borders.clip]:[];var cssClip=container.parseClip();if(cssClip && ["absolute","fixed"].indexOf(container.css('position')) !== -1){clip.push([["rect",container.bounds.left + cssClip.left,container.bounds.top + cssClip.top,cssClip.right - cssClip.left,cssClip.bottom - cssClip.top]]);}container.clip = hasParentClip(container)?container.parent.clip.concat(clip):clip;container.backgroundClip = container.css('overflow') !== "hidden"?container.clip.concat([container.borders.clip]):container.clip;if(isPseudoElement(container)){container.cleanDOM();}}else if(isTextNode(container)){container.clip = hasParentClip(container)?container.parent.clip:[];}if(!isPseudoElement(container)){container.bounds = null;}},this);};function hasParentClip(container){return container.parent && container.parent.clip.length;}NodeParser.prototype.asyncRenderer = function(queue,resolve,asyncTimer){asyncTimer = asyncTimer || Date.now();this.paint(queue[this.renderIndex++]);if(queue.length === this.renderIndex){resolve();}else if(asyncTimer + 20 > Date.now()){this.asyncRenderer(queue,resolve,asyncTimer);}else {setTimeout(bind(function(){this.asyncRenderer(queue,resolve);},this),0);}};NodeParser.prototype.createPseudoHideStyles = function(document){this.createStyles(document,'.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }' + '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');};NodeParser.prototype.disableAnimations = function(document){this.createStyles(document,'* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; ' + '-webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}');};NodeParser.prototype.createStyles = function(document,styles){var hidePseudoElements=document.createElement('style');hidePseudoElements.innerHTML = styles;document.body.appendChild(hidePseudoElements);};NodeParser.prototype.getPseudoElements = function(container){var nodes=[[container]];if(container.node.nodeType === Node.ELEMENT_NODE){var before=this.getPseudoElement(container,":before");var after=this.getPseudoElement(container,":after");if(before){nodes.push(before);}if(after){nodes.push(after);}}return flatten(nodes);};function toCamelCase(str){return str.replace(/(\-[a-z])/g,function(match){return match.toUpperCase().replace('-','');});}NodeParser.prototype.getPseudoElement = function(container,type){var style=container.computedStyle(type);if(!style || !style.content || style.content === "none" || style.content === "-moz-alt-content" || style.display === "none"){return null;}var content=stripQuotes(style.content);var isImage=content.substr(0,3) === 'url';var pseudoNode=document.createElement(isImage?'img':'html2canvaspseudoelement');var pseudoContainer=new PseudoElementContainer(pseudoNode,container,type);for(var i=style.length - 1;i >= 0;i--) {var property=toCamelCase(style.item(i));pseudoNode.style[property] = style[property];}pseudoNode.className = PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER;if(isImage){pseudoNode.src = parseBackgrounds(content)[0].args[0];return [pseudoContainer];}else {var text=document.createTextNode(content);pseudoNode.appendChild(text);return [pseudoContainer,new TextContainer(text,pseudoContainer)];}};NodeParser.prototype.getChildren = function(parentContainer){return flatten([].filter.call(parentContainer.node.childNodes,renderableNode).map(function(node){var container=[node.nodeType === Node.TEXT_NODE?new TextContainer(node,parentContainer):new NodeContainer(node,parentContainer)].filter(nonIgnoredElement);return node.nodeType === Node.ELEMENT_NODE && container.length && node.tagName !== "TEXTAREA"?container[0].isElementVisible()?container.concat(this.getChildren(container[0])):[]:container;},this));};NodeParser.prototype.newStackingContext = function(container,hasOwnStacking){var stack=new StackingContext(hasOwnStacking,container.getOpacity(),container.node,container.parent);container.cloneTo(stack);var parentStack=hasOwnStacking?stack.getParentStack(this):stack.parent.stack;parentStack.contexts.push(stack);container.stack = stack;};NodeParser.prototype.createStackingContexts = function(){this.nodes.forEach(function(container){if(isElement(container) && (this.isRootElement(container) || hasOpacity(container) || isPositionedForStacking(container) || this.isBodyWithTransparentRoot(container) || container.hasTransform())){this.newStackingContext(container,true);}else if(isElement(container) && (isPositioned(container) && zIndex0(container) || isInlineBlock(container) || isFloating(container))){this.newStackingContext(container,false);}else {container.assignStack(container.parent.stack);}},this);};NodeParser.prototype.isBodyWithTransparentRoot = function(container){return container.node.nodeName === "BODY" && container.parent.color('backgroundColor').isTransparent();};NodeParser.prototype.isRootElement = function(container){return container.parent === null;};NodeParser.prototype.sortStackingContexts = function(stack){stack.contexts.sort(zIndexSort(stack.contexts.slice(0)));stack.contexts.forEach(this.sortStackingContexts,this);};NodeParser.prototype.parseTextBounds = function(container){return function(text,index,textList){if(container.parent.css("textDecoration").substr(0,4) !== "none" || text.trim().length !== 0){if(this.support.rangeBounds && !container.parent.hasTransform()){var offset=textList.slice(0,index).join("").length;return this.getRangeBounds(container.node,offset,text.length);}else if(container.node && typeof container.node.data === "string"){var replacementNode=container.node.splitText(text.length);var bounds=this.getWrapperBounds(container.node,container.parent.hasTransform());container.node = replacementNode;return bounds;}}else if(!this.support.rangeBounds || container.parent.hasTransform()){container.node = container.node.splitText(text.length);}return {};};};NodeParser.prototype.getWrapperBounds = function(node,transform){var wrapper=node.ownerDocument.createElement('html2canvaswrapper');var parent=node.parentNode,backupText=node.cloneNode(true);wrapper.appendChild(node.cloneNode(true));parent.replaceChild(wrapper,node);var bounds=transform?offsetBounds(wrapper):getBounds(wrapper);parent.replaceChild(backupText,wrapper);return bounds;};NodeParser.prototype.getRangeBounds = function(node,offset,length){var range=this.range || (this.range = node.ownerDocument.createRange());range.setStart(node,offset);range.setEnd(node,offset + length);return range.getBoundingClientRect();};function ClearTransform(){}NodeParser.prototype.parse = function(stack){ // http://www.w3.org/TR/CSS21/visuren.html#z-index
	var negativeZindex=stack.contexts.filter(negativeZIndex); // 2. the child stacking contexts with negative stack levels (most negative first).
	var descendantElements=stack.children.filter(isElement);var descendantNonFloats=descendantElements.filter(not(isFloating));var nonInlineNonPositionedDescendants=descendantNonFloats.filter(not(isPositioned)).filter(not(inlineLevel)); // 3 the in-flow, non-inline-level, non-positioned descendants.
	var nonPositionedFloats=descendantElements.filter(not(isPositioned)).filter(isFloating); // 4. the non-positioned floats.
	var inFlow=descendantNonFloats.filter(not(isPositioned)).filter(inlineLevel); // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
	var stackLevel0=stack.contexts.concat(descendantNonFloats.filter(isPositioned)).filter(zIndex0); // 6. the child stacking contexts with stack level 0 and the positioned descendants with stack level 0.
	var text=stack.children.filter(isTextNode).filter(hasText);var positiveZindex=stack.contexts.filter(positiveZIndex); // 7. the child stacking contexts with positive stack levels (least positive first).
	negativeZindex.concat(nonInlineNonPositionedDescendants).concat(nonPositionedFloats).concat(inFlow).concat(stackLevel0).concat(text).concat(positiveZindex).forEach(function(container){this.renderQueue.push(container);if(isStackingContext(container)){this.parse(container);this.renderQueue.push(new ClearTransform());}},this);};NodeParser.prototype.paint = function(container){try{if(container instanceof ClearTransform){this.renderer.ctx.restore();}else if(isTextNode(container)){if(isPseudoElement(container.parent)){container.parent.appendToDOM();}this.paintText(container);if(isPseudoElement(container.parent)){container.parent.cleanDOM();}}else {this.paintNode(container);}}catch(e) {log(e);if(this.options.strict){throw e;}}};NodeParser.prototype.paintNode = function(container){if(isStackingContext(container)){this.renderer.setOpacity(container.opacity);this.renderer.ctx.save();if(container.hasTransform()){this.renderer.setTransform(container.parseTransform());}}if(container.node.nodeName === "INPUT" && container.node.type === "checkbox"){this.paintCheckbox(container);}else if(container.node.nodeName === "INPUT" && container.node.type === "radio"){this.paintRadio(container);}else {this.paintElement(container);}};NodeParser.prototype.paintElement = function(container){var bounds=container.parseBounds();this.renderer.clip(container.backgroundClip,function(){this.renderer.renderBackground(container,bounds,container.borders.borders.map(getWidth));},this);this.renderer.clip(container.clip,function(){this.renderer.renderBorders(container.borders.borders);},this);this.renderer.clip(container.backgroundClip,function(){switch(container.node.nodeName){case "svg":case "IFRAME":var imgContainer=this.images.get(container.node);if(imgContainer){this.renderer.renderImage(container,bounds,container.borders,imgContainer);}else {log("Error loading <" + container.node.nodeName + ">",container.node);}break;case "IMG":var imageContainer=this.images.get(container.node.src);if(imageContainer){this.renderer.renderImage(container,bounds,container.borders,imageContainer);}else {log("Error loading <img>",container.node.src);}break;case "CANVAS":this.renderer.renderImage(container,bounds,container.borders,{image:container.node});break;case "SELECT":case "INPUT":case "TEXTAREA":this.paintFormValue(container);break;}},this);};NodeParser.prototype.paintCheckbox = function(container){var b=container.parseBounds();var size=Math.min(b.width,b.height);var bounds={width:size - 1,height:size - 1,top:b.top,left:b.left};var r=[3,3];var radius=[r,r,r,r];var borders=[1,1,1,1].map(function(w){return {color:new Color('#A5A5A5'),width:w};});var borderPoints=calculateCurvePoints(bounds,radius,borders);this.renderer.clip(container.backgroundClip,function(){this.renderer.rectangle(bounds.left + 1,bounds.top + 1,bounds.width - 2,bounds.height - 2,new Color("#DEDEDE"));this.renderer.renderBorders(calculateBorders(borders,bounds,borderPoints,radius));if(container.node.checked){this.renderer.font(new Color('#424242'),'normal','normal','bold',size - 3 + "px",'arial');this.renderer.text('✔',bounds.left + size / 6,bounds.top + size - 1);}},this);};NodeParser.prototype.paintRadio = function(container){var bounds=container.parseBounds();var size=Math.min(bounds.width,bounds.height) - 2;this.renderer.clip(container.backgroundClip,function(){this.renderer.circleStroke(bounds.left + 1,bounds.top + 1,size,new Color('#DEDEDE'),1,new Color('#A5A5A5'));if(container.node.checked){this.renderer.circle(Math.ceil(bounds.left + size / 4) + 1,Math.ceil(bounds.top + size / 4) + 1,Math.floor(size / 2),new Color('#424242'));}},this);};NodeParser.prototype.paintFormValue = function(container){var value=container.getValue();if(value.length > 0){var document=container.node.ownerDocument;var wrapper=document.createElement('html2canvaswrapper');var properties=['lineHeight','textAlign','fontFamily','fontWeight','fontSize','color','paddingLeft','paddingTop','paddingRight','paddingBottom','width','height','borderLeftStyle','borderTopStyle','borderLeftWidth','borderTopWidth','boxSizing','whiteSpace','wordWrap'];properties.forEach(function(property){try{wrapper.style[property] = container.css(property);}catch(e) { // Older IE has issues with "border"
	log("html2canvas: Parse: Exception caught in renderFormValue: " + e.message);}});var bounds=container.parseBounds();wrapper.style.position = "fixed";wrapper.style.left = bounds.left + "px";wrapper.style.top = bounds.top + "px";wrapper.textContent = value;document.body.appendChild(wrapper);this.paintText(new TextContainer(wrapper.firstChild,container));document.body.removeChild(wrapper);}};NodeParser.prototype.paintText = function(container){container.applyTextTransform();var characters=punycode.ucs2.decode(container.node.data);var textList=(!this.options.letterRendering || noLetterSpacing(container)) && !hasUnicode(container.node.data)?getWords(characters):characters.map(function(character){return punycode.ucs2.encode([character]);});var weight=container.parent.fontWeight();var size=container.parent.css('fontSize');var family=container.parent.css('fontFamily');var shadows=container.parent.parseTextShadows();this.renderer.font(container.parent.color('color'),container.parent.css('fontStyle'),container.parent.css('fontVariant'),weight,size,family);if(shadows.length){ // TODO: support multiple text shadows
	this.renderer.fontShadow(shadows[0].color,shadows[0].offsetX,shadows[0].offsetY,shadows[0].blur);}else {this.renderer.clearShadow();}this.renderer.clip(container.parent.clip,function(){textList.map(this.parseTextBounds(container),this).forEach(function(bounds,index){if(bounds){this.renderer.text(textList[index],bounds.left,bounds.bottom);this.renderTextDecoration(container.parent,bounds,this.fontMetrics.getMetrics(family,size));}},this);},this);};NodeParser.prototype.renderTextDecoration = function(container,bounds,metrics){switch(container.css("textDecoration").split(" ")[0]){case "underline": // Draws a line at the baseline of the font
	// TODO As some browsers display the line as more than 1px if the font-size is big, need to take that into account both in position and size
	this.renderer.rectangle(bounds.left,Math.round(bounds.top + metrics.baseline + metrics.lineWidth),bounds.width,1,container.color("color"));break;case "overline":this.renderer.rectangle(bounds.left,Math.round(bounds.top),bounds.width,1,container.color("color"));break;case "line-through": // TODO try and find exact position for line-through
	this.renderer.rectangle(bounds.left,Math.ceil(bounds.top + metrics.middle + metrics.lineWidth),bounds.width,1,container.color("color"));break;}};var borderColorTransforms={inset:[["darken",0.60],["darken",0.10],["darken",0.10],["darken",0.60]]};NodeParser.prototype.parseBorders = function(container){var nodeBounds=container.parseBounds();var radius=getBorderRadiusData(container);var borders=["Top","Right","Bottom","Left"].map(function(side,index){var style=container.css('border' + side + 'Style');var color=container.color('border' + side + 'Color');if(style === "inset" && color.isBlack()){color = new Color([255,255,255,color.a]); // this is wrong, but
	}var colorTransform=borderColorTransforms[style]?borderColorTransforms[style][index]:null;return {width:container.cssInt('border' + side + 'Width'),color:colorTransform?color[colorTransform[0]](colorTransform[1]):color,args:null};});var borderPoints=calculateCurvePoints(nodeBounds,radius,borders);return {clip:this.parseBackgroundClip(container,borderPoints,borders,radius,nodeBounds),borders:calculateBorders(borders,nodeBounds,borderPoints,radius)};};function calculateBorders(borders,nodeBounds,borderPoints,radius){return borders.map(function(border,borderSide){if(border.width > 0){var bx=nodeBounds.left;var by=nodeBounds.top;var bw=nodeBounds.width;var bh=nodeBounds.height - borders[2].width;switch(borderSide){case 0: // top border
	bh = borders[0].width;border.args = drawSide({c1:[bx,by],c2:[bx + bw,by],c3:[bx + bw - borders[1].width,by + bh],c4:[bx + borders[3].width,by + bh]},radius[0],radius[1],borderPoints.topLeftOuter,borderPoints.topLeftInner,borderPoints.topRightOuter,borderPoints.topRightInner);break;case 1: // right border
	bx = nodeBounds.left + nodeBounds.width - borders[1].width;bw = borders[1].width;border.args = drawSide({c1:[bx + bw,by],c2:[bx + bw,by + bh + borders[2].width],c3:[bx,by + bh],c4:[bx,by + borders[0].width]},radius[1],radius[2],borderPoints.topRightOuter,borderPoints.topRightInner,borderPoints.bottomRightOuter,borderPoints.bottomRightInner);break;case 2: // bottom border
	by = by + nodeBounds.height - borders[2].width;bh = borders[2].width;border.args = drawSide({c1:[bx + bw,by + bh],c2:[bx,by + bh],c3:[bx + borders[3].width,by],c4:[bx + bw - borders[3].width,by]},radius[2],radius[3],borderPoints.bottomRightOuter,borderPoints.bottomRightInner,borderPoints.bottomLeftOuter,borderPoints.bottomLeftInner);break;case 3: // left border
	bw = borders[3].width;border.args = drawSide({c1:[bx,by + bh + borders[2].width],c2:[bx,by],c3:[bx + bw,by + borders[0].width],c4:[bx + bw,by + bh]},radius[3],radius[0],borderPoints.bottomLeftOuter,borderPoints.bottomLeftInner,borderPoints.topLeftOuter,borderPoints.topLeftInner);break;}}return border;});}NodeParser.prototype.parseBackgroundClip = function(container,borderPoints,borders,radius,bounds){var backgroundClip=container.css('backgroundClip'),borderArgs=[];switch(backgroundClip){case "content-box":case "padding-box":parseCorner(borderArgs,radius[0],radius[1],borderPoints.topLeftInner,borderPoints.topRightInner,bounds.left + borders[3].width,bounds.top + borders[0].width);parseCorner(borderArgs,radius[1],radius[2],borderPoints.topRightInner,borderPoints.bottomRightInner,bounds.left + bounds.width - borders[1].width,bounds.top + borders[0].width);parseCorner(borderArgs,radius[2],radius[3],borderPoints.bottomRightInner,borderPoints.bottomLeftInner,bounds.left + bounds.width - borders[1].width,bounds.top + bounds.height - borders[2].width);parseCorner(borderArgs,radius[3],radius[0],borderPoints.bottomLeftInner,borderPoints.topLeftInner,bounds.left + borders[3].width,bounds.top + bounds.height - borders[2].width);break;default:parseCorner(borderArgs,radius[0],radius[1],borderPoints.topLeftOuter,borderPoints.topRightOuter,bounds.left,bounds.top);parseCorner(borderArgs,radius[1],radius[2],borderPoints.topRightOuter,borderPoints.bottomRightOuter,bounds.left + bounds.width,bounds.top);parseCorner(borderArgs,radius[2],radius[3],borderPoints.bottomRightOuter,borderPoints.bottomLeftOuter,bounds.left + bounds.width,bounds.top + bounds.height);parseCorner(borderArgs,radius[3],radius[0],borderPoints.bottomLeftOuter,borderPoints.topLeftOuter,bounds.left,bounds.top + bounds.height);break;}return borderArgs;};function getCurvePoints(x,y,r1,r2){var kappa=4 * ((Math.sqrt(2) - 1) / 3);var ox=r1 * kappa, // control point offset horizontal
	oy=r2 * kappa, // control point offset vertical
	xm=x + r1, // x-middle
	ym=y + r2; // y-middle
	return {topLeft:bezierCurve({x:x,y:ym},{x:x,y:ym - oy},{x:xm - ox,y:y},{x:xm,y:y}),topRight:bezierCurve({x:x,y:y},{x:x + ox,y:y},{x:xm,y:ym - oy},{x:xm,y:ym}),bottomRight:bezierCurve({x:xm,y:y},{x:xm,y:y + oy},{x:x + ox,y:ym},{x:x,y:ym}),bottomLeft:bezierCurve({x:xm,y:ym},{x:xm - ox,y:ym},{x:x,y:y + oy},{x:x,y:y})};}function calculateCurvePoints(bounds,borderRadius,borders){var x=bounds.left,y=bounds.top,width=bounds.width,height=bounds.height,tlh=borderRadius[0][0] < width / 2?borderRadius[0][0]:width / 2,tlv=borderRadius[0][1] < height / 2?borderRadius[0][1]:height / 2,trh=borderRadius[1][0] < width / 2?borderRadius[1][0]:width / 2,trv=borderRadius[1][1] < height / 2?borderRadius[1][1]:height / 2,brh=borderRadius[2][0] < width / 2?borderRadius[2][0]:width / 2,brv=borderRadius[2][1] < height / 2?borderRadius[2][1]:height / 2,blh=borderRadius[3][0] < width / 2?borderRadius[3][0]:width / 2,blv=borderRadius[3][1] < height / 2?borderRadius[3][1]:height / 2;var topWidth=width - trh,rightHeight=height - brv,bottomWidth=width - brh,leftHeight=height - blv;return {topLeftOuter:getCurvePoints(x,y,tlh,tlv).topLeft.subdivide(0.5),topLeftInner:getCurvePoints(x + borders[3].width,y + borders[0].width,Math.max(0,tlh - borders[3].width),Math.max(0,tlv - borders[0].width)).topLeft.subdivide(0.5),topRightOuter:getCurvePoints(x + topWidth,y,trh,trv).topRight.subdivide(0.5),topRightInner:getCurvePoints(x + Math.min(topWidth,width + borders[3].width),y + borders[0].width,topWidth > width + borders[3].width?0:trh - borders[3].width,trv - borders[0].width).topRight.subdivide(0.5),bottomRightOuter:getCurvePoints(x + bottomWidth,y + rightHeight,brh,brv).bottomRight.subdivide(0.5),bottomRightInner:getCurvePoints(x + Math.min(bottomWidth,width - borders[3].width),y + Math.min(rightHeight,height + borders[0].width),Math.max(0,brh - borders[1].width),brv - borders[2].width).bottomRight.subdivide(0.5),bottomLeftOuter:getCurvePoints(x,y + leftHeight,blh,blv).bottomLeft.subdivide(0.5),bottomLeftInner:getCurvePoints(x + borders[3].width,y + leftHeight,Math.max(0,blh - borders[3].width),blv - borders[2].width).bottomLeft.subdivide(0.5)};}function bezierCurve(start,startControl,endControl,end){var lerp=function lerp(a,b,t){return {x:a.x + (b.x - a.x) * t,y:a.y + (b.y - a.y) * t};};return {start:start,startControl:startControl,endControl:endControl,end:end,subdivide:function subdivide(t){var ab=lerp(start,startControl,t),bc=lerp(startControl,endControl,t),cd=lerp(endControl,end,t),abbc=lerp(ab,bc,t),bccd=lerp(bc,cd,t),dest=lerp(abbc,bccd,t);return [bezierCurve(start,ab,abbc,dest),bezierCurve(dest,bccd,cd,end)];},curveTo:function curveTo(borderArgs){borderArgs.push(["bezierCurve",startControl.x,startControl.y,endControl.x,endControl.y,end.x,end.y]);},curveToReversed:function curveToReversed(borderArgs){borderArgs.push(["bezierCurve",endControl.x,endControl.y,startControl.x,startControl.y,start.x,start.y]);}};}function drawSide(borderData,radius1,radius2,outer1,inner1,outer2,inner2){var borderArgs=[];if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",outer1[1].start.x,outer1[1].start.y]);outer1[1].curveTo(borderArgs);}else {borderArgs.push(["line",borderData.c1[0],borderData.c1[1]]);}if(radius2[0] > 0 || radius2[1] > 0){borderArgs.push(["line",outer2[0].start.x,outer2[0].start.y]);outer2[0].curveTo(borderArgs);borderArgs.push(["line",inner2[0].end.x,inner2[0].end.y]);inner2[0].curveToReversed(borderArgs);}else {borderArgs.push(["line",borderData.c2[0],borderData.c2[1]]);borderArgs.push(["line",borderData.c3[0],borderData.c3[1]]);}if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",inner1[1].end.x,inner1[1].end.y]);inner1[1].curveToReversed(borderArgs);}else {borderArgs.push(["line",borderData.c4[0],borderData.c4[1]]);}return borderArgs;}function parseCorner(borderArgs,radius1,radius2,corner1,corner2,x,y){if(radius1[0] > 0 || radius1[1] > 0){borderArgs.push(["line",corner1[0].start.x,corner1[0].start.y]);corner1[0].curveTo(borderArgs);corner1[1].curveTo(borderArgs);}else {borderArgs.push(["line",x,y]);}if(radius2[0] > 0 || radius2[1] > 0){borderArgs.push(["line",corner2[0].start.x,corner2[0].start.y]);}}function negativeZIndex(container){return container.cssInt("zIndex") < 0;}function positiveZIndex(container){return container.cssInt("zIndex") > 0;}function zIndex0(container){return container.cssInt("zIndex") === 0;}function inlineLevel(container){return ["inline","inline-block","inline-table"].indexOf(container.css("display")) !== -1;}function isStackingContext(container){return container instanceof StackingContext;}function hasText(container){return container.node.data.trim().length > 0;}function noLetterSpacing(container){return (/^(normal|none|0px)$/.test(container.parent.css("letterSpacing")));}function getBorderRadiusData(container){return ["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(side){var value=container.css('border' + side + 'Radius');var arr=value.split(" ");if(arr.length <= 1){arr[1] = arr[0];}return arr.map(asInt);});}function renderableNode(node){return node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE;}function isPositionedForStacking(container){var position=container.css("position");var zIndex=["absolute","relative","fixed"].indexOf(position) !== -1?container.css("zIndex"):"auto";return zIndex !== "auto";}function isPositioned(container){return container.css("position") !== "static";}function isFloating(container){return container.css("float") !== "none";}function isInlineBlock(container){return ["inline-block","inline-table"].indexOf(container.css("display")) !== -1;}function not(callback){var context=this;return function(){return !callback.apply(context,arguments);};}function isElement(container){return container.node.nodeType === Node.ELEMENT_NODE;}function isPseudoElement(container){return container.isPseudoElement === true;}function isTextNode(container){return container.node.nodeType === Node.TEXT_NODE;}function zIndexSort(contexts){return function(a,b){return a.cssInt("zIndex") + contexts.indexOf(a) / contexts.length - (b.cssInt("zIndex") + contexts.indexOf(b) / contexts.length);};}function hasOpacity(container){return container.getOpacity() < 1;}function asInt(value){return parseInt(value,10);}function getWidth(border){return border.width;}function nonIgnoredElement(nodeContainer){return nodeContainer.node.nodeType !== Node.ELEMENT_NODE || ["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(nodeContainer.node.nodeName) === -1;}function flatten(arrays){return [].concat.apply([],arrays);}function stripQuotes(content){var first=content.substr(0,1);return first === content.substr(content.length - 1) && first.match(/'|"/)?content.substr(1,content.length - 2):content;}function getWords(characters){var words=[],i=0,onWordBoundary=false,word;while(characters.length) {if(isWordBoundary(characters[i]) === onWordBoundary){word = characters.splice(0,i);if(word.length){words.push(punycode.ucs2.encode(word));}onWordBoundary = !onWordBoundary;i = 0;}else {i++;}if(i >= characters.length){word = characters.splice(0,i);if(word.length){words.push(punycode.ucs2.encode(word));}}}return words;}function isWordBoundary(characterCode){return [32, // <space>
	13, // \r
	10, // \n
	9, // \t
	45 // -
	].indexOf(characterCode) !== -1;}function hasUnicode(string){return (/[^\u0000-\u00ff]/.test(string));}module.exports = NodeParser;},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,"punycode":1}],16:[function(_dereq_,module,exports){var XHR=_dereq_('./xhr');var utils=_dereq_('./utils');var log=_dereq_('./log');var createWindowClone=_dereq_('./clone');var decode64=utils.decode64;function Proxy(src,proxyUrl,document){var supportsCORS=('withCredentials' in new XMLHttpRequest());if(!proxyUrl){return Promise.reject("No proxy configured");}var callback=createCallback(supportsCORS);var url=createProxyUrl(proxyUrl,src,callback);return supportsCORS?XHR(url):jsonp(document,url,callback).then(function(response){return decode64(response.content);});}var proxyCount=0;function ProxyURL(src,proxyUrl,document){var supportsCORSImage=('crossOrigin' in new Image());var callback=createCallback(supportsCORSImage);var url=createProxyUrl(proxyUrl,src,callback);return supportsCORSImage?Promise.resolve(url):jsonp(document,url,callback).then(function(response){return "data:" + response.type + ";base64," + response.content;});}function jsonp(document,url,callback){return new Promise(function(resolve,reject){var s=document.createElement("script");var cleanup=function cleanup(){delete window.html2canvas.proxy[callback];document.body.removeChild(s);};window.html2canvas.proxy[callback] = function(response){cleanup();resolve(response);};s.src = url;s.onerror = function(e){cleanup();reject(e);};document.body.appendChild(s);});}function createCallback(useCORS){return !useCORS?"html2canvas_" + Date.now() + "_" + ++proxyCount + "_" + Math.round(Math.random() * 100000):"";}function createProxyUrl(proxyUrl,src,callback){return proxyUrl + "?url=" + encodeURIComponent(src) + (callback.length?"&callback=html2canvas.proxy." + callback:"");}function documentFromHTML(src){return function(html){var parser=new DOMParser(),doc;try{doc = parser.parseFromString(html,"text/html");}catch(e) {log("DOMParser not supported, falling back to createHTMLDocument");doc = document.implementation.createHTMLDocument("");try{doc.open();doc.write(html);doc.close();}catch(ee) {log("createHTMLDocument write not supported, falling back to document.body.innerHTML");doc.body.innerHTML = html; // ie9 doesnt support writing to documentElement
	}}var b=doc.querySelector("base");if(!b || !b.href.host){var base=doc.createElement("base");base.href = src;doc.head.insertBefore(base,doc.head.firstChild);}return doc;};}function loadUrlDocument(src,proxy,document,width,height,options){return new Proxy(src,proxy,window.document).then(documentFromHTML(src)).then(function(doc){return createWindowClone(doc,document,width,height,options,0,0);});}exports.Proxy = Proxy;exports.ProxyURL = ProxyURL;exports.loadUrlDocument = loadUrlDocument;},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(_dereq_,module,exports){var ProxyURL=_dereq_('./proxy').ProxyURL;function ProxyImageContainer(src,proxy){var link=document.createElement("a");link.href = src;src = link.href;this.src = src;this.image = new Image();var self=this;this.promise = new Promise(function(resolve,reject){self.image.crossOrigin = "Anonymous";self.image.onload = resolve;self.image.onerror = reject;new ProxyURL(src,proxy,document).then(function(url){self.image.src = url;})['catch'](reject);});}module.exports = ProxyImageContainer;},{"./proxy":16}],18:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function PseudoElementContainer(node,parent,type){NodeContainer.call(this,node,parent);this.isPseudoElement = true;this.before = type === ":before";}PseudoElementContainer.prototype.cloneTo = function(stack){PseudoElementContainer.prototype.cloneTo.call(this,stack);stack.isPseudoElement = true;stack.before = this.before;};PseudoElementContainer.prototype = Object.create(NodeContainer.prototype);PseudoElementContainer.prototype.appendToDOM = function(){if(this.before){this.parent.node.insertBefore(this.node,this.parent.node.firstChild);}else {this.parent.node.appendChild(this.node);}this.parent.node.className += " " + this.getHideClass();};PseudoElementContainer.prototype.cleanDOM = function(){this.node.parentNode.removeChild(this.node);this.parent.node.className = this.parent.node.className.replace(this.getHideClass(),"");};PseudoElementContainer.prototype.getHideClass = function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before?"BEFORE":"AFTER")];};PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";module.exports = PseudoElementContainer;},{"./nodecontainer":14}],19:[function(_dereq_,module,exports){var log=_dereq_('./log');function Renderer(width,height,images,options,document){this.width = width;this.height = height;this.images = images;this.options = options;this.document = document;}Renderer.prototype.renderImage = function(container,bounds,borderData,imageContainer){var paddingLeft=container.cssInt('paddingLeft'),paddingTop=container.cssInt('paddingTop'),paddingRight=container.cssInt('paddingRight'),paddingBottom=container.cssInt('paddingBottom'),borders=borderData.borders;var width=bounds.width - (borders[1].width + borders[3].width + paddingLeft + paddingRight);var height=bounds.height - (borders[0].width + borders[2].width + paddingTop + paddingBottom);this.drawImage(imageContainer,0,0,imageContainer.image.width || width,imageContainer.image.height || height,bounds.left + paddingLeft + borders[3].width,bounds.top + paddingTop + borders[0].width,width,height);};Renderer.prototype.renderBackground = function(container,bounds,borderData){if(bounds.height > 0 && bounds.width > 0){this.renderBackgroundColor(container,bounds);this.renderBackgroundImage(container,bounds,borderData);}};Renderer.prototype.renderBackgroundColor = function(container,bounds){var color=container.color("backgroundColor");if(!color.isTransparent()){this.rectangle(bounds.left,bounds.top,bounds.width,bounds.height,color);}};Renderer.prototype.renderBorders = function(borders){borders.forEach(this.renderBorder,this);};Renderer.prototype.renderBorder = function(data){if(!data.color.isTransparent() && data.args !== null){this.drawShape(data.args,data.color);}};Renderer.prototype.renderBackgroundImage = function(container,bounds,borderData){var backgroundImages=container.parseBackgroundImages();backgroundImages.reverse().forEach(function(backgroundImage,index,arr){switch(backgroundImage.method){case "url":var image=this.images.get(backgroundImage.args[0]);if(image){this.renderBackgroundRepeating(container,bounds,image,arr.length - (index + 1),borderData);}else {log("Error loading background-image",backgroundImage.args[0]);}break;case "linear-gradient":case "gradient":var gradientImage=this.images.get(backgroundImage.value);if(gradientImage){this.renderBackgroundGradient(gradientImage,bounds,borderData);}else {log("Error loading background-image",backgroundImage.args[0]);}break;case "none":break;default:log("Unknown background-image type",backgroundImage.args[0]);}},this);};Renderer.prototype.renderBackgroundRepeating = function(container,bounds,imageContainer,index,borderData){var size=container.parseBackgroundSize(bounds,imageContainer.image,index);var position=container.parseBackgroundPosition(bounds,imageContainer.image,index,size);var repeat=container.parseBackgroundRepeat(index);switch(repeat){case "repeat-x":case "repeat no-repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + borderData[3],bounds.top + position.top + borderData[0],99999,size.height,borderData);break;case "repeat-y":case "no-repeat repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + position.left + borderData[3],bounds.top + borderData[0],size.width,99999,borderData);break;case "no-repeat":this.backgroundRepeatShape(imageContainer,position,size,bounds,bounds.left + position.left + borderData[3],bounds.top + position.top + borderData[0],size.width,size.height,borderData);break;default:this.renderBackgroundRepeat(imageContainer,position,size,{top:bounds.top,left:bounds.left},borderData[3],borderData[0]);break;}};module.exports = Renderer;},{"./log":13}],20:[function(_dereq_,module,exports){var Renderer=_dereq_('../renderer');var LinearGradientContainer=_dereq_('../lineargradientcontainer');var log=_dereq_('../log');function CanvasRenderer(width,height){Renderer.apply(this,arguments);this.canvas = this.options.canvas || this.document.createElement("canvas");if(!this.options.canvas){this.canvas.width = width;this.canvas.height = height;}this.ctx = this.canvas.getContext("2d");this.taintCtx = this.document.createElement("canvas").getContext("2d");this.ctx.textBaseline = "bottom";this.variables = {};log("Initialized CanvasRenderer with size",width,"x",height);}CanvasRenderer.prototype = Object.create(Renderer.prototype);CanvasRenderer.prototype.setFillStyle = function(fillStyle){this.ctx.fillStyle = typeof fillStyle === "object" && !!fillStyle.isColor?fillStyle.toString():fillStyle;return this.ctx;};CanvasRenderer.prototype.rectangle = function(left,top,width,height,color){this.setFillStyle(color).fillRect(left,top,width,height);};CanvasRenderer.prototype.circle = function(left,top,size,color){this.setFillStyle(color);this.ctx.beginPath();this.ctx.arc(left + size / 2,top + size / 2,size / 2,0,Math.PI * 2,true);this.ctx.closePath();this.ctx.fill();};CanvasRenderer.prototype.circleStroke = function(left,top,size,color,stroke,strokeColor){this.circle(left,top,size,color);this.ctx.strokeStyle = strokeColor.toString();this.ctx.stroke();};CanvasRenderer.prototype.drawShape = function(shape,color){this.shape(shape);this.setFillStyle(color).fill();};CanvasRenderer.prototype.taints = function(imageContainer){if(imageContainer.tainted === null){this.taintCtx.drawImage(imageContainer.image,0,0);try{this.taintCtx.getImageData(0,0,1,1);imageContainer.tainted = false;}catch(e) {this.taintCtx = document.createElement("canvas").getContext("2d");imageContainer.tainted = true;}}return imageContainer.tainted;};CanvasRenderer.prototype.drawImage = function(imageContainer,sx,sy,sw,sh,dx,dy,dw,dh){if(!this.taints(imageContainer) || this.options.allowTaint){this.ctx.drawImage(imageContainer.image,sx,sy,sw,sh,dx,dy,dw,dh);}};CanvasRenderer.prototype.clip = function(shapes,callback,context){this.ctx.save();shapes.filter(hasEntries).forEach(function(shape){this.shape(shape).clip();},this);callback.call(context);this.ctx.restore();};CanvasRenderer.prototype.shape = function(shape){this.ctx.beginPath();shape.forEach(function(point,index){if(point[0] === "rect"){this.ctx.rect.apply(this.ctx,point.slice(1));}else {this.ctx[index === 0?"moveTo":point[0] + "To"].apply(this.ctx,point.slice(1));}},this);this.ctx.closePath();return this.ctx;};CanvasRenderer.prototype.font = function(color,style,variant,weight,size,family){this.setFillStyle(color).font = [style,variant,weight,size,family].join(" ").split(",")[0];};CanvasRenderer.prototype.fontShadow = function(color,offsetX,offsetY,blur){this.setVariable("shadowColor",color.toString()).setVariable("shadowOffsetY",offsetX).setVariable("shadowOffsetX",offsetY).setVariable("shadowBlur",blur);};CanvasRenderer.prototype.clearShadow = function(){this.setVariable("shadowColor","rgba(0,0,0,0)");};CanvasRenderer.prototype.setOpacity = function(opacity){this.ctx.globalAlpha = opacity;};CanvasRenderer.prototype.setTransform = function(transform){this.ctx.translate(transform.origin[0],transform.origin[1]);this.ctx.transform.apply(this.ctx,transform.matrix);this.ctx.translate(-transform.origin[0],-transform.origin[1]);};CanvasRenderer.prototype.setVariable = function(property,value){if(this.variables[property] !== value){this.variables[property] = this.ctx[property] = value;}return this;};CanvasRenderer.prototype.text = function(text,left,bottom){this.ctx.fillText(text,left,bottom);};CanvasRenderer.prototype.backgroundRepeatShape = function(imageContainer,backgroundPosition,size,bounds,left,top,width,height,borderData){var shape=[["line",Math.round(left),Math.round(top)],["line",Math.round(left + width),Math.round(top)],["line",Math.round(left + width),Math.round(height + top)],["line",Math.round(left),Math.round(height + top)]];this.clip([shape],function(){this.renderBackgroundRepeat(imageContainer,backgroundPosition,size,bounds,borderData[3],borderData[0]);},this);};CanvasRenderer.prototype.renderBackgroundRepeat = function(imageContainer,backgroundPosition,size,bounds,borderLeft,borderTop){var offsetX=Math.round(bounds.left + backgroundPosition.left + borderLeft),offsetY=Math.round(bounds.top + backgroundPosition.top + borderTop);this.setFillStyle(this.ctx.createPattern(this.resizeImage(imageContainer,size),"repeat"));this.ctx.translate(offsetX,offsetY);this.ctx.fill();this.ctx.translate(-offsetX,-offsetY);};CanvasRenderer.prototype.renderBackgroundGradient = function(gradientImage,bounds){if(gradientImage instanceof LinearGradientContainer){var gradient=this.ctx.createLinearGradient(bounds.left + bounds.width * gradientImage.x0,bounds.top + bounds.height * gradientImage.y0,bounds.left + bounds.width * gradientImage.x1,bounds.top + bounds.height * gradientImage.y1);gradientImage.colorStops.forEach(function(colorStop){gradient.addColorStop(colorStop.stop,colorStop.color.toString());});this.rectangle(bounds.left,bounds.top,bounds.width,bounds.height,gradient);}};CanvasRenderer.prototype.resizeImage = function(imageContainer,size){var image=imageContainer.image;if(image.width === size.width && image.height === size.height){return image;}var ctx,canvas=document.createElement('canvas');canvas.width = size.width;canvas.height = size.height;ctx = canvas.getContext("2d");ctx.drawImage(image,0,0,image.width,image.height,0,0,size.width,size.height);return canvas;};function hasEntries(array){return array.length > 0;}module.exports = CanvasRenderer;},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function StackingContext(hasOwnStacking,opacity,element,parent){NodeContainer.call(this,element,parent);this.ownStacking = hasOwnStacking;this.contexts = [];this.children = [];this.opacity = (this.parent?this.parent.stack.opacity:1) * opacity;}StackingContext.prototype = Object.create(NodeContainer.prototype);StackingContext.prototype.getParentStack = function(context){var parentStack=this.parent?this.parent.stack:null;return parentStack?parentStack.ownStacking?parentStack:parentStack.getParentStack(context):context.stack;};module.exports = StackingContext;},{"./nodecontainer":14}],22:[function(_dereq_,module,exports){function Support(document){this.rangeBounds = this.testRangeBounds(document);this.cors = this.testCORS();this.svg = this.testSVG();}Support.prototype.testRangeBounds = function(document){var range,testElement,rangeBounds,rangeHeight,support=false;if(document.createRange){range = document.createRange();if(range.getBoundingClientRect){testElement = document.createElement('boundtest');testElement.style.height = "123px";testElement.style.display = "block";document.body.appendChild(testElement);range.selectNode(testElement);rangeBounds = range.getBoundingClientRect();rangeHeight = rangeBounds.height;if(rangeHeight === 123){support = true;}document.body.removeChild(testElement);}}return support;};Support.prototype.testCORS = function(){return typeof new Image().crossOrigin !== "undefined";};Support.prototype.testSVG = function(){var img=new Image();var canvas=document.createElement("canvas");var ctx=canvas.getContext("2d");img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{ctx.drawImage(img,0,0);canvas.toDataURL();}catch(e) {return false;}return true;};module.exports = Support;},{}],23:[function(_dereq_,module,exports){var XHR=_dereq_('./xhr');var decode64=_dereq_('./utils').decode64;function SVGContainer(src){this.src = src;this.image = null;var self=this;this.promise = this.hasFabric().then(function(){return self.isInline(src)?Promise.resolve(self.inlineFormatting(src)):XHR(src);}).then(function(svg){return new Promise(function(resolve){window.html2canvas.svg.fabric.loadSVGFromString(svg,self.createCanvas.call(self,resolve));});});}SVGContainer.prototype.hasFabric = function(){return !window.html2canvas.svg || !window.html2canvas.svg.fabric?Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg")):Promise.resolve();};SVGContainer.prototype.inlineFormatting = function(src){return (/^data:image\/svg\+xml;base64,/.test(src)?this.decode64(this.removeContentType(src)):this.removeContentType(src));};SVGContainer.prototype.removeContentType = function(src){return src.replace(/^data:image\/svg\+xml(;base64)?,/,'');};SVGContainer.prototype.isInline = function(src){return (/^data:image\/svg\+xml/i.test(src));};SVGContainer.prototype.createCanvas = function(resolve){var self=this;return function(objects,options){var canvas=new window.html2canvas.svg.fabric.StaticCanvas('c');self.image = canvas.lowerCanvasEl;canvas.setWidth(options.width).setHeight(options.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(objects,options)).renderAll();resolve(canvas.lowerCanvasEl);};};SVGContainer.prototype.decode64 = function(str){return typeof window.atob === "function"?window.atob(str):decode64(str);};module.exports = SVGContainer;},{"./utils":26,"./xhr":28}],24:[function(_dereq_,module,exports){var SVGContainer=_dereq_('./svgcontainer');function SVGNodeContainer(node,_native){this.src = node;this.image = null;var self=this;this.promise = _native?new Promise(function(resolve,reject){self.image = new Image();self.image.onload = resolve;self.image.onerror = reject;self.image.src = "data:image/svg+xml," + new XMLSerializer().serializeToString(node);if(self.image.complete === true){resolve(self.image);}}):this.hasFabric().then(function(){return new Promise(function(resolve){window.html2canvas.svg.fabric.parseSVGDocument(node,self.createCanvas.call(self,resolve));});});}SVGNodeContainer.prototype = Object.create(SVGContainer.prototype);module.exports = SVGNodeContainer;},{"./svgcontainer":23}],25:[function(_dereq_,module,exports){var NodeContainer=_dereq_('./nodecontainer');function TextContainer(node,parent){NodeContainer.call(this,node,parent);}TextContainer.prototype = Object.create(NodeContainer.prototype);TextContainer.prototype.applyTextTransform = function(){this.node.data = this.transform(this.parent.css("textTransform"));};TextContainer.prototype.transform = function(transform){var text=this.node.data;switch(transform){case "lowercase":return text.toLowerCase();case "capitalize":return text.replace(/(^|\s|:|-|\(|\))([a-z])/g,capitalize);case "uppercase":return text.toUpperCase();default:return text;}};function capitalize(m,p1,p2){if(m.length > 0){return p1 + p2.toUpperCase();}}module.exports = TextContainer;},{"./nodecontainer":14}],26:[function(_dereq_,module,exports){exports.smallImage = function smallImage(){return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";};exports.bind = function(callback,context){return function(){return callback.apply(context,arguments);};}; /*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */exports.decode64 = function(base64){var chars="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var len=base64.length,i,encoded1,encoded2,encoded3,encoded4,byte1,byte2,byte3;var output="";for(i = 0;i < len;i += 4) {encoded1 = chars.indexOf(base64[i]);encoded2 = chars.indexOf(base64[i + 1]);encoded3 = chars.indexOf(base64[i + 2]);encoded4 = chars.indexOf(base64[i + 3]);byte1 = encoded1 << 2 | encoded2 >> 4;byte2 = (encoded2 & 15) << 4 | encoded3 >> 2;byte3 = (encoded3 & 3) << 6 | encoded4;if(encoded3 === 64){output += String.fromCharCode(byte1);}else if(encoded4 === 64 || encoded4 === -1){output += String.fromCharCode(byte1,byte2);}else {output += String.fromCharCode(byte1,byte2,byte3);}}return output;};exports.getBounds = function(node){if(node.getBoundingClientRect){var clientRect=node.getBoundingClientRect();var width=node.offsetWidth == null?clientRect.width:node.offsetWidth;return {top:clientRect.top,bottom:clientRect.bottom || clientRect.top + clientRect.height,right:clientRect.left + width,left:clientRect.left,width:width,height:node.offsetHeight == null?clientRect.height:node.offsetHeight};}return {};};exports.offsetBounds = function(node){var parent=node.offsetParent?exports.offsetBounds(node.offsetParent):{top:0,left:0};return {top:node.offsetTop + parent.top,bottom:node.offsetTop + node.offsetHeight + parent.top,right:node.offsetLeft + parent.left + node.offsetWidth,left:node.offsetLeft + parent.left,width:node.offsetWidth,height:node.offsetHeight};};exports.parseBackgrounds = function(backgroundImage){var whitespace=' \r\n\t',method,definition,prefix,prefix_i,block,results=[],mode=0,numParen=0,quote,args;var appendResult=function appendResult(){if(method){if(definition.substr(0,1) === '"'){definition = definition.substr(1,definition.length - 2);}if(definition){args.push(definition);}if(method.substr(0,1) === '-' && (prefix_i = method.indexOf('-',1) + 1) > 0){prefix = method.substr(0,prefix_i);method = method.substr(prefix_i);}results.push({prefix:prefix,method:method.toLowerCase(),value:block,args:args,image:null});}args = [];method = prefix = definition = block = '';};args = [];method = prefix = definition = block = '';backgroundImage.split("").forEach(function(c){if(mode === 0 && whitespace.indexOf(c) > -1){return;}switch(c){case '"':if(!quote){quote = c;}else if(quote === c){quote = null;}break;case '(':if(quote){break;}else if(mode === 0){mode = 1;block += c;return;}else {numParen++;}break;case ')':if(quote){break;}else if(mode === 1){if(numParen === 0){mode = 0;block += c;appendResult();return;}else {numParen--;}}break;case ',':if(quote){break;}else if(mode === 0){appendResult();return;}else if(mode === 1){if(numParen === 0 && !method.match(/^url$/i)){args.push(definition);definition = '';block += c;return;}}break;}block += c;if(mode === 0){method += c;}else {definition += c;}});appendResult();return results;};},{}],27:[function(_dereq_,module,exports){var GradientContainer=_dereq_('./gradientcontainer');function WebkitGradientContainer(imageData){GradientContainer.apply(this,arguments);this.type = imageData.args[0] === "linear"?GradientContainer.TYPES.LINEAR:GradientContainer.TYPES.RADIAL;}WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);module.exports = WebkitGradientContainer;},{"./gradientcontainer":9}],28:[function(_dereq_,module,exports){function XHR(url){return new Promise(function(resolve,reject){var xhr=new XMLHttpRequest();xhr.open('GET',url);xhr.onload = function(){if(xhr.status === 200){resolve(xhr.responseText);}else {reject(new Error(xhr.statusText));}};xhr.onerror = function(){reject(new Error("Network Error"));};xhr.send();});}module.exports = XHR;},{}]},{},[4])(4);}); // Generated by CoffeeScript 1.4.0
	/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# 
	*/(function(global){var PNG;PNG = (function(){var APNG_BLEND_OP_OVER,APNG_BLEND_OP_SOURCE,APNG_DISPOSE_OP_BACKGROUND,APNG_DISPOSE_OP_NONE,APNG_DISPOSE_OP_PREVIOUS,makeImage,scratchCanvas,scratchCtx;PNG.load = function(url,canvas,callback){var xhr,_this=this;if(typeof canvas === 'function'){callback = canvas;}xhr = new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType = "arraybuffer";xhr.onload = function(){var data,png;data = new Uint8Array(xhr.response || xhr.mozResponseArrayBuffer);png = new PNG(data);if(typeof (canvas != null?canvas.getContext:void 0) === 'function'){png.render(canvas);}return typeof callback === "function"?callback(png):void 0;};return xhr.send(null);};APNG_DISPOSE_OP_NONE = 0;APNG_DISPOSE_OP_BACKGROUND = 1;APNG_DISPOSE_OP_PREVIOUS = 2;APNG_BLEND_OP_SOURCE = 0;APNG_BLEND_OP_OVER = 1;function PNG(data){var chunkSize,colors,palLen,delayDen,delayNum,frame,i,index,key,section,palShort,text,_i,_j,_ref;this.data = data;this.pos = 8;this.palette = [];this.imgData = [];this.transparency = {};this.animation = null;this.text = {};frame = null;while(true) {chunkSize = this.readUInt32();section = (function(){var _i,_results;_results = [];for(i = _i = 0;_i < 4;i = ++_i) {_results.push(String.fromCharCode(this.data[this.pos++]));}return _results;}).call(this).join('');switch(section){case 'IHDR':this.width = this.readUInt32();this.height = this.readUInt32();this.bits = this.data[this.pos++];this.colorType = this.data[this.pos++];this.compressionMethod = this.data[this.pos++];this.filterMethod = this.data[this.pos++];this.interlaceMethod = this.data[this.pos++];break;case 'acTL':this.animation = {numFrames:this.readUInt32(),numPlays:this.readUInt32() || Infinity,frames:[]};break;case 'PLTE':this.palette = this.read(chunkSize);break;case 'fcTL':if(frame){this.animation.frames.push(frame);}this.pos += 4;frame = {width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()};delayNum = this.readUInt16();delayDen = this.readUInt16() || 100;frame.delay = 1000 * delayNum / delayDen;frame.disposeOp = this.data[this.pos++];frame.blendOp = this.data[this.pos++];frame.data = [];break;case 'IDAT':case 'fdAT':if(section === 'fdAT'){this.pos += 4;chunkSize -= 4;}data = (frame != null?frame.data:void 0) || this.imgData;for(i = _i = 0;0 <= chunkSize?_i < chunkSize:_i > chunkSize;i = 0 <= chunkSize?++_i:--_i) {data.push(this.data[this.pos++]);}break;case 'tRNS':this.transparency = {};switch(this.colorType){case 3:palLen = this.palette.length / 3;this.transparency.indexed = this.read(chunkSize);if(this.transparency.indexed.length > palLen)throw new Error('More transparent colors than palette size'); /*
	                 * According to the PNG spec trns should be increased to the same size as palette if shorter
	                 */ //palShort = 255 - this.transparency.indexed.length;
	palShort = palLen - this.transparency.indexed.length;if(palShort > 0){for(i = _j = 0;0 <= palShort?_j < palShort:_j > palShort;i = 0 <= palShort?++_j:--_j) {this.transparency.indexed.push(255);}}break;case 0:this.transparency.grayscale = this.read(chunkSize)[0];break;case 2:this.transparency.rgb = this.read(chunkSize);}break;case 'tEXt':text = this.read(chunkSize);index = text.indexOf(0);key = String.fromCharCode.apply(String,text.slice(0,index));this.text[key] = String.fromCharCode.apply(String,text.slice(index + 1));break;case 'IEND':if(frame){this.animation.frames.push(frame);}this.colors = (function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3;}}).call(this);this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;colors = this.colors + (this.hasAlphaChannel?1:0);this.pixelBitlength = this.bits * colors;this.colorSpace = (function(){switch(this.colors){case 1:return 'DeviceGray';case 3:return 'DeviceRGB';}}).call(this);this.imgData = new Uint8Array(this.imgData);return;default:this.pos += chunkSize;}this.pos += 4;if(this.pos > this.data.length){throw new Error("Incomplete or corrupt PNG file");}}return;}PNG.prototype.read = function(bytes){var i,_i,_results;_results = [];for(i = _i = 0;0 <= bytes?_i < bytes:_i > bytes;i = 0 <= bytes?++_i:--_i) {_results.push(this.data[this.pos++]);}return _results;};PNG.prototype.readUInt32 = function(){var b1,b2,b3,b4;b1 = this.data[this.pos++] << 24;b2 = this.data[this.pos++] << 16;b3 = this.data[this.pos++] << 8;b4 = this.data[this.pos++];return b1 | b2 | b3 | b4;};PNG.prototype.readUInt16 = function(){var b1,b2;b1 = this.data[this.pos++] << 8;b2 = this.data[this.pos++];return b1 | b2;};PNG.prototype.decodePixels = function(data){var abyte,c,col,i,left,length,p,pa,paeth,pb,pc,pixelBytes,pixels,pos,row,scanlineLength,upper,upperLeft,_i,_j,_k,_l,_m;if(data == null){data = this.imgData;}if(data.length === 0){return new Uint8Array(0);}data = new FlateStream(data);data = data.getBytes();pixelBytes = this.pixelBitlength / 8;scanlineLength = pixelBytes * this.width;pixels = new Uint8Array(scanlineLength * this.height);length = data.length;row = 0;pos = 0;c = 0;while(pos < length) {switch(data[pos++]){case 0:for(i = _i = 0;_i < scanlineLength;i = _i += 1) {pixels[c++] = data[pos++];}break;case 1:for(i = _j = 0;_j < scanlineLength;i = _j += 1) {abyte = data[pos++];left = i < pixelBytes?0:pixels[c - pixelBytes];pixels[c++] = (abyte + left) % 256;}break;case 2:for(i = _k = 0;_k < scanlineLength;i = _k += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];pixels[c++] = (upper + abyte) % 256;}break;case 3:for(i = _l = 0;_l < scanlineLength;i = _l += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;left = i < pixelBytes?0:pixels[c - pixelBytes];upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];pixels[c++] = (abyte + Math.floor((left + upper) / 2)) % 256;}break;case 4:for(i = _m = 0;_m < scanlineLength;i = _m += 1) {abyte = data[pos++];col = (i - i % pixelBytes) / pixelBytes;left = i < pixelBytes?0:pixels[c - pixelBytes];if(row === 0){upper = upperLeft = 0;}else {upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];}p = left + upper - upperLeft;pa = Math.abs(p - left);pb = Math.abs(p - upper);pc = Math.abs(p - upperLeft);if(pa <= pb && pa <= pc){paeth = left;}else if(pb <= pc){paeth = upper;}else {paeth = upperLeft;}pixels[c++] = (abyte + paeth) % 256;}break;default:throw new Error("Invalid filter algorithm: " + data[pos - 1]);}row++;}return pixels;};PNG.prototype.decodePalette = function(){var c,i,length,palette,pos,ret,transparency,_i,_ref,_ref1;palette = this.palette;transparency = this.transparency.indexed || [];ret = new Uint8Array((transparency.length || 0) + palette.length);pos = 0;length = palette.length;c = 0;for(i = _i = 0,_ref = palette.length;_i < _ref;i = _i += 3) {ret[pos++] = palette[i];ret[pos++] = palette[i + 1];ret[pos++] = palette[i + 2];ret[pos++] = (_ref1 = transparency[c++]) != null?_ref1:255;}return ret;};PNG.prototype.copyToImageData = function(imageData,pixels){var alpha,colors,data,i,input,j,k,length,palette,v,_ref;colors = this.colors;palette = null;alpha = this.hasAlphaChannel;if(this.palette.length){palette = (_ref = this._decodedPalette) != null?_ref:this._decodedPalette = this.decodePalette();colors = 4;alpha = true;}data = imageData.data || imageData;length = data.length;input = palette || pixels;i = j = 0;if(colors === 1){while(i < length) {k = palette?pixels[i / 4] * 4:j;v = input[k++];data[i++] = v;data[i++] = v;data[i++] = v;data[i++] = alpha?input[k++]:255;j = k;}}else {while(i < length) {k = palette?pixels[i / 4] * 4:j;data[i++] = input[k++];data[i++] = input[k++];data[i++] = input[k++];data[i++] = alpha?input[k++]:255;j = k;}}};PNG.prototype.decode = function(){var ret;ret = new Uint8Array(this.width * this.height * 4);this.copyToImageData(ret,this.decodePixels());return ret;};try{scratchCanvas = global.document.createElement('canvas');scratchCtx = scratchCanvas.getContext('2d');}catch(e) {return -1;}makeImage = function(imageData){var img;scratchCtx.width = imageData.width;scratchCtx.height = imageData.height;scratchCtx.clearRect(0,0,imageData.width,imageData.height);scratchCtx.putImageData(imageData,0,0);img = new Image();img.src = scratchCanvas.toDataURL();return img;};PNG.prototype.decodeFrames = function(ctx){var frame,i,imageData,pixels,_i,_len,_ref,_results;if(!this.animation){return;}_ref = this.animation.frames;_results = [];for(i = _i = 0,_len = _ref.length;_i < _len;i = ++_i) {frame = _ref[i];imageData = ctx.createImageData(frame.width,frame.height);pixels = this.decodePixels(new Uint8Array(frame.data));this.copyToImageData(imageData,pixels);frame.imageData = imageData;_results.push(frame.image = makeImage(imageData));}return _results;};PNG.prototype.renderFrame = function(ctx,number){var frame,frames,prev;frames = this.animation.frames;frame = frames[number];prev = frames[number - 1];if(number === 0){ctx.clearRect(0,0,this.width,this.height);}if((prev != null?prev.disposeOp:void 0) === APNG_DISPOSE_OP_BACKGROUND){ctx.clearRect(prev.xOffset,prev.yOffset,prev.width,prev.height);}else if((prev != null?prev.disposeOp:void 0) === APNG_DISPOSE_OP_PREVIOUS){ctx.putImageData(prev.imageData,prev.xOffset,prev.yOffset);}if(frame.blendOp === APNG_BLEND_OP_SOURCE){ctx.clearRect(frame.xOffset,frame.yOffset,frame.width,frame.height);}return ctx.drawImage(frame.image,frame.xOffset,frame.yOffset);};PNG.prototype.animate = function(ctx){var doFrame,frameNumber,frames,numFrames,numPlays,_ref,_this=this;frameNumber = 0;_ref = this.animation,numFrames = _ref.numFrames,frames = _ref.frames,numPlays = _ref.numPlays;return (doFrame = function(){var f,frame;f = frameNumber++ % numFrames;frame = frames[f];_this.renderFrame(ctx,f);if(numFrames > 1 && frameNumber / numFrames < numPlays){return _this.animation._timeout = setTimeout(doFrame,frame.delay);}})();};PNG.prototype.stopAnimation = function(){var _ref;return clearTimeout((_ref = this.animation) != null?_ref._timeout:void 0);};PNG.prototype.render = function(canvas){var ctx,data;if(canvas._png){canvas._png.stopAnimation();}canvas._png = this;canvas.width = this.width;canvas.height = this.height;ctx = canvas.getContext("2d");if(this.animation){this.decodeFrames(ctx);return this.animate(ctx);}else {data = ctx.createImageData(this.width,this.height);this.copyToImageData(data,this.decodePixels());return ctx.putImageData(data,0,0);}};return PNG;})();global.PNG = PNG;})(typeof window !== "undefined" && window || undefined); /*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * 
	 */var DecodeStream=(function(){function constructor(){this.pos = 0;this.bufferLength = 0;this.eof = false;this.buffer = null;}constructor.prototype = {ensureBuffer:function decodestream_ensureBuffer(requested){var buffer=this.buffer;var current=buffer?buffer.byteLength:0;if(requested < current)return buffer;var size=512;while(size < requested) size <<= 1;var buffer2=new Uint8Array(size);for(var i=0;i < current;++i) buffer2[i] = buffer[i];return this.buffer = buffer2;},getByte:function decodestream_getByte(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return this.buffer[this.pos++];},getBytes:function decodestream_getBytes(length){var pos=this.pos;if(length){this.ensureBuffer(pos + length);var end=pos + length;while(!this.eof && this.bufferLength < end) this.readBlock();var bufEnd=this.bufferLength;if(end > bufEnd)end = bufEnd;}else {while(!this.eof) this.readBlock();var end=this.bufferLength;}this.pos = end;return this.buffer.subarray(pos,end);},lookChar:function decodestream_lookChar(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return String.fromCharCode(this.buffer[this.pos]);},getChar:function decodestream_getChar(){var pos=this.pos;while(this.bufferLength <= pos) {if(this.eof)return null;this.readBlock();}return String.fromCharCode(this.buffer[this.pos++]);},makeSubStream:function decodestream_makeSubstream(start,length,dict){var end=start + length;while(this.bufferLength <= end && !this.eof) this.readBlock();return new Stream(this.buffer,start,length,dict);},skip:function decodestream_skip(n){if(!n)n = 1;this.pos += n;},reset:function decodestream_reset(){this.pos = 0;}};return constructor;})();var FlateStream=(function(){if(typeof Uint32Array === 'undefined'){return undefined;}var codeLenCodeMap=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);var lengthDecode=new Uint32Array([0x00003,0x00004,0x00005,0x00006,0x00007,0x00008,0x00009,0x0000a,0x1000b,0x1000d,0x1000f,0x10011,0x20013,0x20017,0x2001b,0x2001f,0x30023,0x3002b,0x30033,0x3003b,0x40043,0x40053,0x40063,0x40073,0x50083,0x500a3,0x500c3,0x500e3,0x00102,0x00102,0x00102]);var distDecode=new Uint32Array([0x00001,0x00002,0x00003,0x00004,0x10005,0x10007,0x20009,0x2000d,0x30011,0x30019,0x40021,0x40031,0x50041,0x50061,0x60081,0x600c1,0x70101,0x70181,0x80201,0x80301,0x90401,0x90601,0xa0801,0xa0c01,0xb1001,0xb1801,0xc2001,0xc3001,0xd4001,0xd6001]);var fixedLitCodeTab=[new Uint32Array([0x70100,0x80050,0x80010,0x80118,0x70110,0x80070,0x80030,0x900c0,0x70108,0x80060,0x80020,0x900a0,0x80000,0x80080,0x80040,0x900e0,0x70104,0x80058,0x80018,0x90090,0x70114,0x80078,0x80038,0x900d0,0x7010c,0x80068,0x80028,0x900b0,0x80008,0x80088,0x80048,0x900f0,0x70102,0x80054,0x80014,0x8011c,0x70112,0x80074,0x80034,0x900c8,0x7010a,0x80064,0x80024,0x900a8,0x80004,0x80084,0x80044,0x900e8,0x70106,0x8005c,0x8001c,0x90098,0x70116,0x8007c,0x8003c,0x900d8,0x7010e,0x8006c,0x8002c,0x900b8,0x8000c,0x8008c,0x8004c,0x900f8,0x70101,0x80052,0x80012,0x8011a,0x70111,0x80072,0x80032,0x900c4,0x70109,0x80062,0x80022,0x900a4,0x80002,0x80082,0x80042,0x900e4,0x70105,0x8005a,0x8001a,0x90094,0x70115,0x8007a,0x8003a,0x900d4,0x7010d,0x8006a,0x8002a,0x900b4,0x8000a,0x8008a,0x8004a,0x900f4,0x70103,0x80056,0x80016,0x8011e,0x70113,0x80076,0x80036,0x900cc,0x7010b,0x80066,0x80026,0x900ac,0x80006,0x80086,0x80046,0x900ec,0x70107,0x8005e,0x8001e,0x9009c,0x70117,0x8007e,0x8003e,0x900dc,0x7010f,0x8006e,0x8002e,0x900bc,0x8000e,0x8008e,0x8004e,0x900fc,0x70100,0x80051,0x80011,0x80119,0x70110,0x80071,0x80031,0x900c2,0x70108,0x80061,0x80021,0x900a2,0x80001,0x80081,0x80041,0x900e2,0x70104,0x80059,0x80019,0x90092,0x70114,0x80079,0x80039,0x900d2,0x7010c,0x80069,0x80029,0x900b2,0x80009,0x80089,0x80049,0x900f2,0x70102,0x80055,0x80015,0x8011d,0x70112,0x80075,0x80035,0x900ca,0x7010a,0x80065,0x80025,0x900aa,0x80005,0x80085,0x80045,0x900ea,0x70106,0x8005d,0x8001d,0x9009a,0x70116,0x8007d,0x8003d,0x900da,0x7010e,0x8006d,0x8002d,0x900ba,0x8000d,0x8008d,0x8004d,0x900fa,0x70101,0x80053,0x80013,0x8011b,0x70111,0x80073,0x80033,0x900c6,0x70109,0x80063,0x80023,0x900a6,0x80003,0x80083,0x80043,0x900e6,0x70105,0x8005b,0x8001b,0x90096,0x70115,0x8007b,0x8003b,0x900d6,0x7010d,0x8006b,0x8002b,0x900b6,0x8000b,0x8008b,0x8004b,0x900f6,0x70103,0x80057,0x80017,0x8011f,0x70113,0x80077,0x80037,0x900ce,0x7010b,0x80067,0x80027,0x900ae,0x80007,0x80087,0x80047,0x900ee,0x70107,0x8005f,0x8001f,0x9009e,0x70117,0x8007f,0x8003f,0x900de,0x7010f,0x8006f,0x8002f,0x900be,0x8000f,0x8008f,0x8004f,0x900fe,0x70100,0x80050,0x80010,0x80118,0x70110,0x80070,0x80030,0x900c1,0x70108,0x80060,0x80020,0x900a1,0x80000,0x80080,0x80040,0x900e1,0x70104,0x80058,0x80018,0x90091,0x70114,0x80078,0x80038,0x900d1,0x7010c,0x80068,0x80028,0x900b1,0x80008,0x80088,0x80048,0x900f1,0x70102,0x80054,0x80014,0x8011c,0x70112,0x80074,0x80034,0x900c9,0x7010a,0x80064,0x80024,0x900a9,0x80004,0x80084,0x80044,0x900e9,0x70106,0x8005c,0x8001c,0x90099,0x70116,0x8007c,0x8003c,0x900d9,0x7010e,0x8006c,0x8002c,0x900b9,0x8000c,0x8008c,0x8004c,0x900f9,0x70101,0x80052,0x80012,0x8011a,0x70111,0x80072,0x80032,0x900c5,0x70109,0x80062,0x80022,0x900a5,0x80002,0x80082,0x80042,0x900e5,0x70105,0x8005a,0x8001a,0x90095,0x70115,0x8007a,0x8003a,0x900d5,0x7010d,0x8006a,0x8002a,0x900b5,0x8000a,0x8008a,0x8004a,0x900f5,0x70103,0x80056,0x80016,0x8011e,0x70113,0x80076,0x80036,0x900cd,0x7010b,0x80066,0x80026,0x900ad,0x80006,0x80086,0x80046,0x900ed,0x70107,0x8005e,0x8001e,0x9009d,0x70117,0x8007e,0x8003e,0x900dd,0x7010f,0x8006e,0x8002e,0x900bd,0x8000e,0x8008e,0x8004e,0x900fd,0x70100,0x80051,0x80011,0x80119,0x70110,0x80071,0x80031,0x900c3,0x70108,0x80061,0x80021,0x900a3,0x80001,0x80081,0x80041,0x900e3,0x70104,0x80059,0x80019,0x90093,0x70114,0x80079,0x80039,0x900d3,0x7010c,0x80069,0x80029,0x900b3,0x80009,0x80089,0x80049,0x900f3,0x70102,0x80055,0x80015,0x8011d,0x70112,0x80075,0x80035,0x900cb,0x7010a,0x80065,0x80025,0x900ab,0x80005,0x80085,0x80045,0x900eb,0x70106,0x8005d,0x8001d,0x9009b,0x70116,0x8007d,0x8003d,0x900db,0x7010e,0x8006d,0x8002d,0x900bb,0x8000d,0x8008d,0x8004d,0x900fb,0x70101,0x80053,0x80013,0x8011b,0x70111,0x80073,0x80033,0x900c7,0x70109,0x80063,0x80023,0x900a7,0x80003,0x80083,0x80043,0x900e7,0x70105,0x8005b,0x8001b,0x90097,0x70115,0x8007b,0x8003b,0x900d7,0x7010d,0x8006b,0x8002b,0x900b7,0x8000b,0x8008b,0x8004b,0x900f7,0x70103,0x80057,0x80017,0x8011f,0x70113,0x80077,0x80037,0x900cf,0x7010b,0x80067,0x80027,0x900af,0x80007,0x80087,0x80047,0x900ef,0x70107,0x8005f,0x8001f,0x9009f,0x70117,0x8007f,0x8003f,0x900df,0x7010f,0x8006f,0x8002f,0x900bf,0x8000f,0x8008f,0x8004f,0x900ff]),9];var fixedDistCodeTab=[new Uint32Array([0x50000,0x50010,0x50008,0x50018,0x50004,0x50014,0x5000c,0x5001c,0x50002,0x50012,0x5000a,0x5001a,0x50006,0x50016,0x5000e,0x00000,0x50001,0x50011,0x50009,0x50019,0x50005,0x50015,0x5000d,0x5001d,0x50003,0x50013,0x5000b,0x5001b,0x50007,0x50017,0x5000f,0x00000]),5];function error(e){throw new Error(e);}function constructor(bytes){ //var bytes = stream.getBytes();
	var bytesPos=0;var cmf=bytes[bytesPos++];var flg=bytes[bytesPos++];if(cmf == -1 || flg == -1)error('Invalid header in flate stream');if((cmf & 0x0f) != 0x08)error('Unknown compression method in flate stream');if(((cmf << 8) + flg) % 31 != 0)error('Bad FCHECK in flate stream');if(flg & 0x20)error('FDICT bit set in flate stream');this.bytes = bytes;this.bytesPos = bytesPos;this.codeSize = 0;this.codeBuf = 0;DecodeStream.call(this);}constructor.prototype = Object.create(DecodeStream.prototype);constructor.prototype.getBits = function(bits){var codeSize=this.codeSize;var codeBuf=this.codeBuf;var bytes=this.bytes;var bytesPos=this.bytesPos;var b;while(codeSize < bits) {if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad encoding in flate stream');codeBuf |= b << codeSize;codeSize += 8;}b = codeBuf & (1 << bits) - 1;this.codeBuf = codeBuf >> bits;this.codeSize = codeSize -= bits;this.bytesPos = bytesPos;return b;};constructor.prototype.getCode = function(table){var codes=table[0];var maxLen=table[1];var codeSize=this.codeSize;var codeBuf=this.codeBuf;var bytes=this.bytes;var bytesPos=this.bytesPos;while(codeSize < maxLen) {var b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad encoding in flate stream');codeBuf |= b << codeSize;codeSize += 8;}var code=codes[codeBuf & (1 << maxLen) - 1];var codeLen=code >> 16;var codeVal=code & 0xffff;if(codeSize == 0 || codeSize < codeLen || codeLen == 0)error('Bad encoding in flate stream');this.codeBuf = codeBuf >> codeLen;this.codeSize = codeSize - codeLen;this.bytesPos = bytesPos;return codeVal;};constructor.prototype.generateHuffmanTable = function(lengths){var n=lengths.length; // find max code length
	var maxLen=0;for(var i=0;i < n;++i) {if(lengths[i] > maxLen)maxLen = lengths[i];} // build the table
	var size=1 << maxLen;var codes=new Uint32Array(size);for(var len=1,code=0,skip=2;len <= maxLen;++len,code <<= 1,skip <<= 1) {for(var val=0;val < n;++val) {if(lengths[val] == len){ // bit-reverse the code
	var code2=0;var t=code;for(var i=0;i < len;++i) {code2 = code2 << 1 | t & 1;t >>= 1;} // fill the table entries
	for(var i=code2;i < size;i += skip) codes[i] = len << 16 | val;++code;}}}return [codes,maxLen];};constructor.prototype.readBlock = function(){function repeat(stream,array,len,offset,what){var repeat=stream.getBits(len) + offset;while(repeat-- > 0) array[i++] = what;} // read block header
	var hdr=this.getBits(3);if(hdr & 1)this.eof = true;hdr >>= 1;if(hdr == 0){ // uncompressed block
	var bytes=this.bytes;var bytesPos=this.bytesPos;var b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');var blockLen=b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');blockLen |= b << 8;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');var check=b;if(typeof (b = bytes[bytesPos++]) == 'undefined')error('Bad block header in flate stream');check |= b << 8;if(check != (~blockLen & 0xffff))error('Bad uncompressed block length in flate stream');this.codeBuf = 0;this.codeSize = 0;var bufferLength=this.bufferLength;var buffer=this.ensureBuffer(bufferLength + blockLen);var end=bufferLength + blockLen;this.bufferLength = end;for(var n=bufferLength;n < end;++n) {if(typeof (b = bytes[bytesPos++]) == 'undefined'){this.eof = true;break;}buffer[n] = b;}this.bytesPos = bytesPos;return;}var litCodeTable;var distCodeTable;if(hdr == 1){ // compressed block, fixed codes
	litCodeTable = fixedLitCodeTab;distCodeTable = fixedDistCodeTab;}else if(hdr == 2){ // compressed block, dynamic codes
	var numLitCodes=this.getBits(5) + 257;var numDistCodes=this.getBits(5) + 1;var numCodeLenCodes=this.getBits(4) + 4; // build the code lengths code table
	var codeLenCodeLengths=Array(codeLenCodeMap.length);var i=0;while(i < numCodeLenCodes) codeLenCodeLengths[codeLenCodeMap[i++]] = this.getBits(3);var codeLenCodeTab=this.generateHuffmanTable(codeLenCodeLengths); // build the literal and distance code tables
	var len=0;var i=0;var codes=numLitCodes + numDistCodes;var codeLengths=new Array(codes);while(i < codes) {var code=this.getCode(codeLenCodeTab);if(code == 16){repeat(this,codeLengths,2,3,len);}else if(code == 17){repeat(this,codeLengths,3,3,len = 0);}else if(code == 18){repeat(this,codeLengths,7,11,len = 0);}else {codeLengths[i++] = len = code;}}litCodeTable = this.generateHuffmanTable(codeLengths.slice(0,numLitCodes));distCodeTable = this.generateHuffmanTable(codeLengths.slice(numLitCodes,codes));}else {error('Unknown block type in flate stream');}var buffer=this.buffer;var limit=buffer?buffer.length:0;var pos=this.bufferLength;while(true) {var code1=this.getCode(litCodeTable);if(code1 < 256){if(pos + 1 >= limit){buffer = this.ensureBuffer(pos + 1);limit = buffer.length;}buffer[pos++] = code1;continue;}if(code1 == 256){this.bufferLength = pos;return;}code1 -= 257;code1 = lengthDecode[code1];var code2=code1 >> 16;if(code2 > 0)code2 = this.getBits(code2);var len=(code1 & 0xffff) + code2;code1 = this.getCode(distCodeTable);code1 = distDecode[code1];code2 = code1 >> 16;if(code2 > 0)code2 = this.getBits(code2);var dist=(code1 & 0xffff) + code2;if(pos + len >= limit){buffer = this.ensureBuffer(pos + len);limit = buffer.length;}for(var k=0;k < len;++k,++pos) buffer[pos] = buffer[pos - dist];}};return constructor;})(); /**
	 * JavaScript Polyfill functions for jsPDF
	 * Collected from public resources by
	 * https://github.com/diegocr
	 */(function(global){var b64='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';if(typeof global.btoa === 'undefined'){global.btoa = function(data){ //  discuss at: http://phpjs.org/functions/base64_encode/
	// original by: Tyler Akins (http://rumkin.com)
	// improved by: Bayron Guevara
	// improved by: Thunder.m
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Rafal Kukawski (http://kukawski.pl)
	// bugfixed by: Pellentesque Malesuada
	//   example 1: base64_encode('Kevin van Zonneveld');
	//   returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
	var o1,o2,o3,h1,h2,h3,h4,bits,i=0,ac=0,enc='',tmp_arr=[];if(!data){return data;}do { // pack three octets into four hexets
	o1 = data.charCodeAt(i++);o2 = data.charCodeAt(i++);o3 = data.charCodeAt(i++);bits = o1 << 16 | o2 << 8 | o3;h1 = bits >> 18 & 0x3f;h2 = bits >> 12 & 0x3f;h3 = bits >> 6 & 0x3f;h4 = bits & 0x3f; // use hexets to index into b64, and append result to encoded string
	tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);}while(i < data.length);enc = tmp_arr.join('');var r=data.length % 3;return (r?enc.slice(0,r - 3):enc) + '==='.slice(r || 3);};}if(typeof global.atob === 'undefined'){global.atob = function(data){ //  discuss at: http://phpjs.org/functions/base64_decode/
	// original by: Tyler Akins (http://rumkin.com)
	// improved by: Thunder.m
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	// improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	//    input by: Aman Gupta
	//    input by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: Onno Marsman
	// bugfixed by: Pellentesque Malesuada
	// bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	//   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
	//   returns 1: 'Kevin van Zonneveld'
	var o1,o2,o3,h1,h2,h3,h4,bits,i=0,ac=0,dec='',tmp_arr=[];if(!data){return data;}data += '';do { // unpack four hexets into three octets using index points in b64
	h1 = b64.indexOf(data.charAt(i++));h2 = b64.indexOf(data.charAt(i++));h3 = b64.indexOf(data.charAt(i++));h4 = b64.indexOf(data.charAt(i++));bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;o1 = bits >> 16 & 0xff;o2 = bits >> 8 & 0xff;o3 = bits & 0xff;if(h3 == 64){tmp_arr[ac++] = String.fromCharCode(o1);}else if(h4 == 64){tmp_arr[ac++] = String.fromCharCode(o1,o2);}else {tmp_arr[ac++] = String.fromCharCode(o1,o2,o3);}}while(i < data.length);dec = tmp_arr.join('');return dec;};}if(!Array.prototype.map){Array.prototype.map = function(fun /*, thisArg */){if(this === void 0 || this === null || typeof fun !== "function")throw new TypeError();var t=Object(this),len=t.length >>> 0,res=new Array(len);var thisArg=arguments.length > 1?arguments[1]:void 0;for(var i=0;i < len;i++) { // NOTE: Absolute correctness would demand Object.defineProperty
	//       be used.  But this method is fairly new, and failure is
	//       possible only if Object.prototype or Array.prototype
	//       has a property |i| (very unlikely), so use a less-correct
	//       but more portable alternative.
	if(i in t)res[i] = fun.call(thisArg,t[i],i,t);}return res;};}if(!Array.isArray){Array.isArray = function(arg){return Object.prototype.toString.call(arg) === '[object Array]';};}if(!Array.prototype.forEach){Array.prototype.forEach = function(fun,thisArg){"use strict";if(this === void 0 || this === null || typeof fun !== "function")throw new TypeError();var t=Object(this),len=t.length >>> 0;for(var i=0;i < len;i++) {if(i in t)fun.call(thisArg,t[i],i,t);}};}if(!Object.keys){Object.keys = (function(){'use strict';var hasOwnProperty=Object.prototype.hasOwnProperty,hasDontEnumBug=!({toString:null}).propertyIsEnumerable('toString'),dontEnums=['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor'],dontEnumsLength=dontEnums.length;return function(obj){if(typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)){throw new TypeError();}var result=[],prop,i;for(prop in obj) {if(hasOwnProperty.call(obj,prop)){result.push(prop);}}if(hasDontEnumBug){for(i = 0;i < dontEnumsLength;i++) {if(hasOwnProperty.call(obj,dontEnums[i])){result.push(dontEnums[i]);}}}return result;};})();}if(!String.prototype.trim){String.prototype.trim = function(){return this.replace(/^\s+|\s+$/g,'');};}if(!String.prototype.trimLeft){String.prototype.trimLeft = function(){return this.replace(/^\s+/g,"");};}if(!String.prototype.trimRight){String.prototype.trimRight = function(){return this.replace(/\s+$/g,"");};}})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined);return jsPDF;});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function () {
	  var out$ = typeof exports != 'undefined' && exports || "function" != 'undefined' && {} || this;
	
	  var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp "&#160;">]>';
	
	  function isElement(obj) {
	    return obj instanceof HTMLElement || obj instanceof SVGElement;
	  }
	
	  function requireDomNode(el) {
	    if (!isElement(el)) {
	      throw new Error('an HTMLElement or SVGElement is required; got ' + el);
	    }
	  }
	
	  function isExternal(url) {
	    return url && url.lastIndexOf('http', 0) == 0 && url.lastIndexOf(window.location.host) == -1;
	  }
	
	  function inlineImages(el, callback) {
	    requireDomNode(el);
	
	    var images = el.querySelectorAll('image'),
	        left = images.length,
	        checkDone = function checkDone() {
	      if (left === 0) {
	        callback();
	      }
	    };
	
	    checkDone();
	    for (var i = 0; i < images.length; i++) {
	      (function (image) {
	        var href = image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
	        if (href) {
	          if (isExternal(href.value)) {
	            console.warn("Cannot render embedded images linking to external hosts: " + href.value);
	            return;
	          }
	        }
	        var canvas = document.createElement('canvas');
	        var ctx = canvas.getContext('2d');
	        var img = new Image();
	        img.crossOrigin = "anonymous";
	        href = href || image.getAttribute('href');
	        if (href) {
	          img.src = href;
	          img.onload = function () {
	            canvas.width = img.width;
	            canvas.height = img.height;
	            ctx.drawImage(img, 0, 0);
	            image.setAttributeNS("http://www.w3.org/1999/xlink", "href", canvas.toDataURL('image/png'));
	            left--;
	            checkDone();
	          };
	          img.onerror = function () {
	            console.log("Could not load " + href);
	            left--;
	            checkDone();
	          };
	        } else {
	          left--;
	          checkDone();
	        }
	      })(images[i]);
	    }
	  }
	
	  function styles(el, selectorRemap, modifyStyle) {
	    var css = "";
	    var sheets = document.styleSheets;
	    for (var i = 0; i < sheets.length; i++) {
	      try {
	        var rules = sheets[i].cssRules;
	      } catch (e) {
	        console.warn("Stylesheet could not be loaded: " + sheets[i].href);
	        continue;
	      }
	
	      if (rules != null) {
	        for (var j = 0, match; j < rules.length; j++, match = null) {
	          var rule = rules[j];
	          if (typeof rule.style != "undefined") {
	            var selectorText;
	
	            try {
	              selectorText = rule.selectorText;
	            } catch (err) {
	              console.warn('The following CSS rule has an invalid selector: "' + rule + '"', err);
	            }
	
	            try {
	              if (selectorText) {
	                match = el.querySelector(selectorText);
	              }
	            } catch (err) {
	              console.warn('Invalid CSS selector "' + selectorText + '"', err);
	            }
	
	            if (match) {
	              var selector = selectorRemap ? selectorRemap(rule.selectorText) : rule.selectorText;
	              var cssText = modifyStyle ? modifyStyle(rule.style.cssText) : rule.style.cssText;
	              css += selector + " { " + cssText + " }\n";
	            } else if (rule.cssText.match(/^@font-face/)) {
	              css += rule.cssText + '\n';
	            }
	          }
	        }
	      }
	    }
	    return css;
	  }
	
	  function getDimension(el, clone, dim) {
	    var v = el.viewBox && el.viewBox.baseVal && el.viewBox.baseVal[dim] || clone.getAttribute(dim) !== null && !clone.getAttribute(dim).match(/%$/) && parseInt(clone.getAttribute(dim)) || el.getBoundingClientRect()[dim] || parseInt(clone.style[dim]) || parseInt(window.getComputedStyle(el).getPropertyValue(dim));
	    return typeof v === 'undefined' || v === null || isNaN(parseFloat(v)) ? 0 : v;
	  }
	
	  function reEncode(data) {
	    data = encodeURIComponent(data);
	    data = data.replace(/%([0-9A-F]{2})/g, function (match, p1) {
	      var c = String.fromCharCode('0x' + p1);
	      return c === '%' ? '%25' : c;
	    });
	    return decodeURIComponent(data);
	  }
	
	  out$.prepareSvg = function (el, options, cb) {
	    requireDomNode(el);
	
	    options = options || {};
	    options.scale = options.scale || 1;
	    options.responsive = options.responsive || false;
	    var xmlns = "http://www.w3.org/2000/xmlns/";
	
	    inlineImages(el, function () {
	      var outer = document.createElement("div");
	      var clone = el.cloneNode(true);
	      var width, height;
	      if (el.tagName == 'svg') {
	        width = options.width || getDimension(el, clone, 'width');
	        height = options.height || getDimension(el, clone, 'height');
	      } else if (el.getBBox) {
	        var box = el.getBBox();
	        width = box.x + box.width;
	        height = box.y + box.height;
	        clone.setAttribute('transform', clone.getAttribute('transform').replace(/translate\(.*?\)/, ''));
	
	        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	        svg.appendChild(clone);
	        clone = svg;
	      } else {
	        console.error('Attempted to render non-SVG element', el);
	        return;
	      }
	
	      clone.setAttribute("version", "1.1");
	      if (!clone.getAttribute('xmlns')) {
	        clone.setAttributeNS(xmlns, "xmlns", "http://www.w3.org/2000/svg");
	      }
	      if (!clone.getAttribute('xmlns:xlink')) {
	        clone.setAttributeNS(xmlns, "xmlns:xlink", "http://www.w3.org/1999/xlink");
	      }
	
	      if (options.responsive) {
	        clone.removeAttribute('width');
	        clone.removeAttribute('height');
	        clone.setAttribute('preserveAspectRatio', 'xMinYMin meet');
	      } else {
	        clone.setAttribute("width", width * options.scale);
	        clone.setAttribute("height", height * options.scale);
	      }
	
	      clone.setAttribute("viewBox", [options.left || 0, options.top || 0, width, height].join(" "));
	
	      var fos = clone.querySelectorAll('foreignObject > *');
	      for (var i = 0; i < fos.length; i++) {
	        if (!fos[i].getAttribute('xmlns')) {
	          fos[i].setAttributeNS(xmlns, "xmlns", "http://www.w3.org/1999/xhtml");
	        }
	      }
	
	      outer.appendChild(clone);
	
	      var css = styles(el, options.selectorRemap, options.modifyStyle);
	      var s = document.createElement('style');
	      s.setAttribute('type', 'text/css');
	      s.innerHTML = "<![CDATA[\n" + css + "\n]]>";
	      var defs = document.createElement('defs');
	      defs.appendChild(s);
	      clone.insertBefore(defs, clone.firstChild);
	
	      if (cb) {
	        var outHtml = outer.innerHTML;
	        outHtml = outHtml.replace(/NS\d+:href/gi, 'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');
	        cb(outHtml, width, height);
	      }
	    });
	  };
	
	  out$.svgAsDataUri = function (el, options, cb) {
	    out$.prepareSvg(el, options, function (svg) {
	      var uri = 'data:image/svg+xml;base64,' + window.btoa(reEncode(doctype + svg));
	      if (cb) {
	        cb(uri);
	      }
	    });
	  };
	
	  out$.svgAsPngUri = function (el, options, cb) {
	    requireDomNode(el);
	
	    options = options || {};
	    options.encoderType = options.encoderType || 'image/png';
	    options.encoderOptions = options.encoderOptions || 0.8;
	
	    var convertToPng = function convertToPng(src, w, h) {
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = w;
	      canvas.height = h;
	
	      if (options.canvg) {
	        options.canvg(canvas, src);
	      } else {
	        context.drawImage(src, 0, 0);
	      }
	
	      if (options.backgroundColor) {
	        context.globalCompositeOperation = 'destination-over';
	        context.fillStyle = options.backgroundColor;
	        context.fillRect(0, 0, canvas.width, canvas.height);
	      }
	
	      var png;
	      try {
	        png = canvas.toDataURL(options.encoderType, options.encoderOptions);
	      } catch (e) {
	        if (typeof SecurityError !== 'undefined' && e instanceof SecurityError || e.name == "SecurityError") {
	          console.error("Rendered SVG images cannot be downloaded in this browser.");
	          return;
	        } else {
	          throw e;
	        }
	      }
	      cb(png);
	    };
	
	    if (options.canvg) {
	      out$.prepareSvg(el, options, convertToPng);
	    } else {
	      out$.svgAsDataUri(el, options, function (uri) {
	        var image = new Image();
	
	        image.onload = function () {
	          convertToPng(image, image.width, image.height);
	        };
	
	        image.onerror = function () {
	          console.error('There was an error loading the data URI as an image on the following SVG\n', window.atob(uri.slice(26)), '\n', "Open the following link to see browser's diagnosis\n", uri);
	        };
	
	        image.src = uri;
	      });
	    }
	  };
	
	  out$.download = function (name, uri) {
	    if (navigator.msSaveOrOpenBlob) {
	      navigator.msSaveOrOpenBlob(uriToBlob(uri), name);
	    } else {
	      var saveLink = document.createElement('a');
	      var downloadSupported = ('download' in saveLink);
	      if (downloadSupported) {
	        saveLink.download = name;
	        saveLink.href = uri;
	        saveLink.style.display = 'none';
	        document.body.appendChild(saveLink);
	        saveLink.click();
	        document.body.removeChild(saveLink);
	      } else {
	        window.open(uri, '_temp', 'menubar=no,toolbar=no,status=no');
	      }
	    }
	  };
	
	  function uriToBlob(uri) {
	    var byteString = window.atob(uri.split(',')[1]);
	    var mimeString = uri.split(',')[0].split(':')[1].split(';')[0];
	    var buffer = new ArrayBuffer(byteString.length);
	    var intArray = new Uint8Array(buffer);
	    for (var i = 0; i < byteString.length; i++) {
	      intArray[i] = byteString.charCodeAt(i);
	    }
	    return new Blob([buffer], { type: mimeString });
	  }
	
	  out$.saveSvg = function (el, name, options) {
	    requireDomNode(el);
	
	    options = options || {};
	    out$.svgAsDataUri(el, options, function (uri) {
	      out$.download(name, uri);
	    });
	  };
	
	  out$.saveSvgAsPng = function (el, name, options) {
	    requireDomNode(el);
	
	    options = options || {};
	    out$.svgAsPngUri(el, options, function (uri) {
	      out$.download(name, uri);
	    });
	  };
	
	  // if define is defined create as an AMD module
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return out$;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	})();

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* MDAT Calendar utils
	*
	* Copyright (c) 2015 MIT Hyperstudio
	* Christopher York, 07/2015
	*
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var d3_time = __webpack_require__(40);
	
	function easterForYear(year) {
	  var a = year % 19;
	  var b = Math.floor(year / 100);
	  var c = year % 100;
	  var d = Math.floor(b / 4);
	  var e = b % 4;
	  var f = Math.floor((b + 8) / 25);
	  var g = Math.floor((b - f + 1) / 3);
	  var h = (19 * a + b - d - g + 15) % 30;
	  var i = Math.floor(c / 4);
	  var k = c % 4;
	  var l = (32 + 2 * e + 2 * i - h - k) % 7;
	  var m = Math.floor((a + 11 * h + 22 * l) / 451);
	  var n0 = h + l + 7 * m + 114;
	  var n = Math.floor(n0 / 31) - 1;
	  var p = n0 % 31 + 1;
	  return new Date(year, n, p);
	}
	
	function easter(date) {
	  var d0 = easterForYear(date.getFullYear());
	  return date < d0 ? easterForYear(date.getFullYear() - 1) : d0;
	}
	
	function easterCeiling(date) {
	  var d1 = easterForYear(date.getFullYear());
	  return d1 < date ? easterForYear(date.getFullYear() + 1) : d1;
	}
	
	exports.easterForYear = easterForYear;
	exports.easter = easter;
	exports.easterCeiling = easterCeiling;

/***/ },
/* 91 */
/***/ function(module, exports) {

	/*!
	 * Cross-Browser Split 1.1.1
	 * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
	 * Available under the MIT License
	 * ECMAScript compliant, uniform cross-browser split method
	 */
	
	/**
	 * Splits a string into an array of strings using a regex or string separator. Matches of the
	 * separator are not included in the result array. However, if `separator` is a regex that contains
	 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
	 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
	 * cross-browser.
	 * @param {String} str String to split.
	 * @param {RegExp|String} separator Regex or string to use for separating the string.
	 * @param {Number} [limit] Maximum number of items to include in the result array.
	 * @returns {Array} Array of substrings.
	 * @example
	 *
	 * // Basic use
	 * split('a b c d', ' ');
	 * // -> ['a', 'b', 'c', 'd']
	 *
	 * // With limit
	 * split('a b c d', ' ', 2);
	 * // -> ['a', 'b']
	 *
	 * // Backreferences in result array
	 * split('..word1 word2..', /([a-z]+)(\d+)/i);
	 * // -> ['..', 'word', '1', ' ', 'word', '2', '..']
	 */
	module.exports = (function split(undef) {
	
	  var nativeSplit = String.prototype.split,
	    compliantExecNpcg = /()??/.exec("")[1] === undef,
	    // NPCG: nonparticipating capturing group
	    self;
	
	  self = function(str, separator, limit) {
	    // If `separator` is not a regex, use `nativeSplit`
	    if (Object.prototype.toString.call(separator) !== "[object RegExp]") {
	      return nativeSplit.call(str, separator, limit);
	    }
	    var output = [],
	      flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.extended ? "x" : "") + // Proposed for ES6
	      (separator.sticky ? "y" : ""),
	      // Firefox 3+
	      lastLastIndex = 0,
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      separator = new RegExp(separator.source, flags + "g"),
	      separator2, match, lastIndex, lastLength;
	    str += ""; // Type-convert
	    if (!compliantExecNpcg) {
	      // Doesn't need flags gy, but they don't hurt
	      separator2 = new RegExp("^" + separator.source + "$(?!\\s)", flags);
	    }
	    /* Values for `limit`, per the spec:
	     * If undefined: 4294967295 // Math.pow(2, 32) - 1
	     * If 0, Infinity, or NaN: 0
	     * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
	     * If negative number: 4294967296 - Math.floor(Math.abs(limit))
	     * If other: Type-convert, then use the above rules
	     */
	    limit = limit === undef ? -1 >>> 0 : // Math.pow(2, 32) - 1
	    limit >>> 0; // ToUint32(limit)
	    while (match = separator.exec(str)) {
	      // `separator.lastIndex` is not reliable cross-browser
	      lastIndex = match.index + match[0].length;
	      if (lastIndex > lastLastIndex) {
	        output.push(str.slice(lastLastIndex, match.index));
	        // Fix browsers whose `exec` methods don't consistently return `undefined` for
	        // nonparticipating capturing groups
	        if (!compliantExecNpcg && match.length > 1) {
	          match[0].replace(separator2, function() {
	            for (var i = 1; i < arguments.length - 2; i++) {
	              if (arguments[i] === undef) {
	                match[i] = undef;
	              }
	            }
	          });
	        }
	        if (match.length > 1 && match.index < str.length) {
	          Array.prototype.push.apply(output, match.slice(1));
	        }
	        lastLength = match[0].length;
	        lastLastIndex = lastIndex;
	        if (output.length >= limit) {
	          break;
	        }
	      }
	      if (separator.lastIndex === match.index) {
	        separator.lastIndex++; // Avoid an infinite loop
	      }
	    }
	    if (lastLastIndex === str.length) {
	      if (lastLength || !separator.test("")) {
	        output.push("");
	      }
	    } else {
	      output.push(str.slice(lastLastIndex));
	    }
	    return output.length > limit ? output.slice(0, limit) : output;
	  };
	
	  return self;
	})();


/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = function(obj) {
	    if (typeof obj === 'string') return camelCase(obj);
	    return walk(obj);
	};
	
	function walk (obj) {
	    if (!obj || typeof obj !== 'object') return obj;
	    if (isDate(obj) || isRegex(obj)) return obj;
	    if (isArray(obj)) return map(obj, walk);
	    return reduce(objectKeys(obj), function (acc, key) {
	        var camel = camelCase(key);
	        acc[camel] = walk(obj[key]);
	        return acc;
	    }, {});
	}
	
	function camelCase(str) {
	    return str.replace(/[_.-](\w|$)/g, function (_,x) {
	        return x.toUpperCase();
	    });
	}
	
	var isArray = Array.isArray || function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	};
	
	var isDate = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	var isRegex = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var has = Object.prototype.hasOwnProperty;
	var objectKeys = Object.keys || function (obj) {
	    var keys = [];
	    for (var key in obj) {
	        if (has.call(obj, key)) keys.push(key);
	    }
	    return keys;
	};
	
	function map (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        res.push(f(xs[i], i));
	    }
	    return res;
	}
	
	function reduce (xs, f, acc) {
	    if (xs.reduce) return xs.reduce(f, acc);
	    for (var i = 0; i < xs.length; i++) {
	        acc = f(acc, xs[i], i);
	    }
	    return acc;
	}


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
	// JavaScript specs as packaged in the D3 library (d3js.org). Please see license at http://colorbrewer.org/export/LICENSE.txt
	!function() {
	
	var colorbrewer = {YlGn: {
	3: ["#f7fcb9","#addd8e","#31a354"],
	4: ["#ffffcc","#c2e699","#78c679","#238443"],
	5: ["#ffffcc","#c2e699","#78c679","#31a354","#006837"],
	6: ["#ffffcc","#d9f0a3","#addd8e","#78c679","#31a354","#006837"],
	7: ["#ffffcc","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#005a32"],
	8: ["#ffffe5","#f7fcb9","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#005a32"],
	9: ["#ffffe5","#f7fcb9","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#006837","#004529"]
	},YlGnBu: {
	3: ["#edf8b1","#7fcdbb","#2c7fb8"],
	4: ["#ffffcc","#a1dab4","#41b6c4","#225ea8"],
	5: ["#ffffcc","#a1dab4","#41b6c4","#2c7fb8","#253494"],
	6: ["#ffffcc","#c7e9b4","#7fcdbb","#41b6c4","#2c7fb8","#253494"],
	7: ["#ffffcc","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"],
	8: ["#ffffd9","#edf8b1","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"],
	9: ["#ffffd9","#edf8b1","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#253494","#081d58"]
	},GnBu: {
	3: ["#e0f3db","#a8ddb5","#43a2ca"],
	4: ["#f0f9e8","#bae4bc","#7bccc4","#2b8cbe"],
	5: ["#f0f9e8","#bae4bc","#7bccc4","#43a2ca","#0868ac"],
	6: ["#f0f9e8","#ccebc5","#a8ddb5","#7bccc4","#43a2ca","#0868ac"],
	7: ["#f0f9e8","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#08589e"],
	8: ["#f7fcf0","#e0f3db","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#08589e"],
	9: ["#f7fcf0","#e0f3db","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#0868ac","#084081"]
	},BuGn: {
	3: ["#e5f5f9","#99d8c9","#2ca25f"],
	4: ["#edf8fb","#b2e2e2","#66c2a4","#238b45"],
	5: ["#edf8fb","#b2e2e2","#66c2a4","#2ca25f","#006d2c"],
	6: ["#edf8fb","#ccece6","#99d8c9","#66c2a4","#2ca25f","#006d2c"],
	7: ["#edf8fb","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#005824"],
	8: ["#f7fcfd","#e5f5f9","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#005824"],
	9: ["#f7fcfd","#e5f5f9","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#006d2c","#00441b"]
	},PuBuGn: {
	3: ["#ece2f0","#a6bddb","#1c9099"],
	4: ["#f6eff7","#bdc9e1","#67a9cf","#02818a"],
	5: ["#f6eff7","#bdc9e1","#67a9cf","#1c9099","#016c59"],
	6: ["#f6eff7","#d0d1e6","#a6bddb","#67a9cf","#1c9099","#016c59"],
	7: ["#f6eff7","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016450"],
	8: ["#fff7fb","#ece2f0","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016450"],
	9: ["#fff7fb","#ece2f0","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016c59","#014636"]
	},PuBu: {
	3: ["#ece7f2","#a6bddb","#2b8cbe"],
	4: ["#f1eef6","#bdc9e1","#74a9cf","#0570b0"],
	5: ["#f1eef6","#bdc9e1","#74a9cf","#2b8cbe","#045a8d"],
	6: ["#f1eef6","#d0d1e6","#a6bddb","#74a9cf","#2b8cbe","#045a8d"],
	7: ["#f1eef6","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#034e7b"],
	8: ["#fff7fb","#ece7f2","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#034e7b"],
	9: ["#fff7fb","#ece7f2","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#045a8d","#023858"]
	},BuPu: {
	3: ["#e0ecf4","#9ebcda","#8856a7"],
	4: ["#edf8fb","#b3cde3","#8c96c6","#88419d"],
	5: ["#edf8fb","#b3cde3","#8c96c6","#8856a7","#810f7c"],
	6: ["#edf8fb","#bfd3e6","#9ebcda","#8c96c6","#8856a7","#810f7c"],
	7: ["#edf8fb","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#6e016b"],
	8: ["#f7fcfd","#e0ecf4","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#6e016b"],
	9: ["#f7fcfd","#e0ecf4","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#810f7c","#4d004b"]
	},RdPu: {
	3: ["#fde0dd","#fa9fb5","#c51b8a"],
	4: ["#feebe2","#fbb4b9","#f768a1","#ae017e"],
	5: ["#feebe2","#fbb4b9","#f768a1","#c51b8a","#7a0177"],
	6: ["#feebe2","#fcc5c0","#fa9fb5","#f768a1","#c51b8a","#7a0177"],
	7: ["#feebe2","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177"],
	8: ["#fff7f3","#fde0dd","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177"],
	9: ["#fff7f3","#fde0dd","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177","#49006a"]
	},PuRd: {
	3: ["#e7e1ef","#c994c7","#dd1c77"],
	4: ["#f1eef6","#d7b5d8","#df65b0","#ce1256"],
	5: ["#f1eef6","#d7b5d8","#df65b0","#dd1c77","#980043"],
	6: ["#f1eef6","#d4b9da","#c994c7","#df65b0","#dd1c77","#980043"],
	7: ["#f1eef6","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#91003f"],
	8: ["#f7f4f9","#e7e1ef","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#91003f"],
	9: ["#f7f4f9","#e7e1ef","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#980043","#67001f"]
	},OrRd: {
	3: ["#fee8c8","#fdbb84","#e34a33"],
	4: ["#fef0d9","#fdcc8a","#fc8d59","#d7301f"],
	5: ["#fef0d9","#fdcc8a","#fc8d59","#e34a33","#b30000"],
	6: ["#fef0d9","#fdd49e","#fdbb84","#fc8d59","#e34a33","#b30000"],
	7: ["#fef0d9","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#990000"],
	8: ["#fff7ec","#fee8c8","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#990000"],
	9: ["#fff7ec","#fee8c8","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#b30000","#7f0000"]
	},YlOrRd: {
	3: ["#ffeda0","#feb24c","#f03b20"],
	4: ["#ffffb2","#fecc5c","#fd8d3c","#e31a1c"],
	5: ["#ffffb2","#fecc5c","#fd8d3c","#f03b20","#bd0026"],
	6: ["#ffffb2","#fed976","#feb24c","#fd8d3c","#f03b20","#bd0026"],
	7: ["#ffffb2","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#b10026"],
	8: ["#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#b10026"],
	9: ["#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026"]
	},YlOrBr: {
	3: ["#fff7bc","#fec44f","#d95f0e"],
	4: ["#ffffd4","#fed98e","#fe9929","#cc4c02"],
	5: ["#ffffd4","#fed98e","#fe9929","#d95f0e","#993404"],
	6: ["#ffffd4","#fee391","#fec44f","#fe9929","#d95f0e","#993404"],
	7: ["#ffffd4","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#8c2d04"],
	8: ["#ffffe5","#fff7bc","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#8c2d04"],
	9: ["#ffffe5","#fff7bc","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#993404","#662506"]
	},Purples: {
	3: ["#efedf5","#bcbddc","#756bb1"],
	4: ["#f2f0f7","#cbc9e2","#9e9ac8","#6a51a3"],
	5: ["#f2f0f7","#cbc9e2","#9e9ac8","#756bb1","#54278f"],
	6: ["#f2f0f7","#dadaeb","#bcbddc","#9e9ac8","#756bb1","#54278f"],
	7: ["#f2f0f7","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#4a1486"],
	8: ["#fcfbfd","#efedf5","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#4a1486"],
	9: ["#fcfbfd","#efedf5","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#54278f","#3f007d"]
	},Blues: {
	3: ["#deebf7","#9ecae1","#3182bd"],
	4: ["#eff3ff","#bdd7e7","#6baed6","#2171b5"],
	5: ["#eff3ff","#bdd7e7","#6baed6","#3182bd","#08519c"],
	6: ["#eff3ff","#c6dbef","#9ecae1","#6baed6","#3182bd","#08519c"],
	7: ["#eff3ff","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#084594"],
	8: ["#f7fbff","#deebf7","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#084594"],
	9: ["#f7fbff","#deebf7","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#08519c","#08306b"]
	},Greens: {
	3: ["#e5f5e0","#a1d99b","#31a354"],
	4: ["#edf8e9","#bae4b3","#74c476","#238b45"],
	5: ["#edf8e9","#bae4b3","#74c476","#31a354","#006d2c"],
	6: ["#edf8e9","#c7e9c0","#a1d99b","#74c476","#31a354","#006d2c"],
	7: ["#edf8e9","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#005a32"],
	8: ["#f7fcf5","#e5f5e0","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#005a32"],
	9: ["#f7fcf5","#e5f5e0","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#006d2c","#00441b"]
	},Oranges: {
	3: ["#fee6ce","#fdae6b","#e6550d"],
	4: ["#feedde","#fdbe85","#fd8d3c","#d94701"],
	5: ["#feedde","#fdbe85","#fd8d3c","#e6550d","#a63603"],
	6: ["#feedde","#fdd0a2","#fdae6b","#fd8d3c","#e6550d","#a63603"],
	7: ["#feedde","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#8c2d04"],
	8: ["#fff5eb","#fee6ce","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#8c2d04"],
	9: ["#fff5eb","#fee6ce","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#a63603","#7f2704"]
	},Reds: {
	3: ["#fee0d2","#fc9272","#de2d26"],
	4: ["#fee5d9","#fcae91","#fb6a4a","#cb181d"],
	5: ["#fee5d9","#fcae91","#fb6a4a","#de2d26","#a50f15"],
	6: ["#fee5d9","#fcbba1","#fc9272","#fb6a4a","#de2d26","#a50f15"],
	7: ["#fee5d9","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#99000d"],
	8: ["#fff5f0","#fee0d2","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#99000d"],
	9: ["#fff5f0","#fee0d2","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#a50f15","#67000d"]
	},Greys: {
	3: ["#f0f0f0","#bdbdbd","#636363"],
	4: ["#f7f7f7","#cccccc","#969696","#525252"],
	5: ["#f7f7f7","#cccccc","#969696","#636363","#252525"],
	6: ["#f7f7f7","#d9d9d9","#bdbdbd","#969696","#636363","#252525"],
	7: ["#f7f7f7","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525"],
	8: ["#ffffff","#f0f0f0","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525"],
	9: ["#ffffff","#f0f0f0","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525","#000000"]
	},PuOr: {
	3: ["#f1a340","#f7f7f7","#998ec3"],
	4: ["#e66101","#fdb863","#b2abd2","#5e3c99"],
	5: ["#e66101","#fdb863","#f7f7f7","#b2abd2","#5e3c99"],
	6: ["#b35806","#f1a340","#fee0b6","#d8daeb","#998ec3","#542788"],
	7: ["#b35806","#f1a340","#fee0b6","#f7f7f7","#d8daeb","#998ec3","#542788"],
	8: ["#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788"],
	9: ["#b35806","#e08214","#fdb863","#fee0b6","#f7f7f7","#d8daeb","#b2abd2","#8073ac","#542788"],
	10: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"],
	11: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#f7f7f7","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"]
	},BrBG: {
	3: ["#d8b365","#f5f5f5","#5ab4ac"],
	4: ["#a6611a","#dfc27d","#80cdc1","#018571"],
	5: ["#a6611a","#dfc27d","#f5f5f5","#80cdc1","#018571"],
	6: ["#8c510a","#d8b365","#f6e8c3","#c7eae5","#5ab4ac","#01665e"],
	7: ["#8c510a","#d8b365","#f6e8c3","#f5f5f5","#c7eae5","#5ab4ac","#01665e"],
	8: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e"],
	9: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#f5f5f5","#c7eae5","#80cdc1","#35978f","#01665e"],
	10: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"],
	11: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#f5f5f5","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"]
	},PRGn: {
	3: ["#af8dc3","#f7f7f7","#7fbf7b"],
	4: ["#7b3294","#c2a5cf","#a6dba0","#008837"],
	5: ["#7b3294","#c2a5cf","#f7f7f7","#a6dba0","#008837"],
	6: ["#762a83","#af8dc3","#e7d4e8","#d9f0d3","#7fbf7b","#1b7837"],
	7: ["#762a83","#af8dc3","#e7d4e8","#f7f7f7","#d9f0d3","#7fbf7b","#1b7837"],
	8: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
	9: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#f7f7f7","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
	10: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"],
	11: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#f7f7f7","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"]
	},PiYG: {
	3: ["#e9a3c9","#f7f7f7","#a1d76a"],
	4: ["#d01c8b","#f1b6da","#b8e186","#4dac26"],
	5: ["#d01c8b","#f1b6da","#f7f7f7","#b8e186","#4dac26"],
	6: ["#c51b7d","#e9a3c9","#fde0ef","#e6f5d0","#a1d76a","#4d9221"],
	7: ["#c51b7d","#e9a3c9","#fde0ef","#f7f7f7","#e6f5d0","#a1d76a","#4d9221"],
	8: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
	9: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#f7f7f7","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
	10: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"],
	11: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#f7f7f7","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"]
	},RdBu: {
	3: ["#ef8a62","#f7f7f7","#67a9cf"],
	4: ["#ca0020","#f4a582","#92c5de","#0571b0"],
	5: ["#ca0020","#f4a582","#f7f7f7","#92c5de","#0571b0"],
	6: ["#b2182b","#ef8a62","#fddbc7","#d1e5f0","#67a9cf","#2166ac"],
	7: ["#b2182b","#ef8a62","#fddbc7","#f7f7f7","#d1e5f0","#67a9cf","#2166ac"],
	8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
	9: ["#b2182b","#d6604d","#f4a582","#fddbc7","#f7f7f7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
	10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"],
	11: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#f7f7f7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"]
	},RdGy: {
	3: ["#ef8a62","#ffffff","#999999"],
	4: ["#ca0020","#f4a582","#bababa","#404040"],
	5: ["#ca0020","#f4a582","#ffffff","#bababa","#404040"],
	6: ["#b2182b","#ef8a62","#fddbc7","#e0e0e0","#999999","#4d4d4d"],
	7: ["#b2182b","#ef8a62","#fddbc7","#ffffff","#e0e0e0","#999999","#4d4d4d"],
	8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d"],
	9: ["#b2182b","#d6604d","#f4a582","#fddbc7","#ffffff","#e0e0e0","#bababa","#878787","#4d4d4d"],
	10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"],
	11: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#ffffff","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"]
	},RdYlBu: {
	3: ["#fc8d59","#ffffbf","#91bfdb"],
	4: ["#d7191c","#fdae61","#abd9e9","#2c7bb6"],
	5: ["#d7191c","#fdae61","#ffffbf","#abd9e9","#2c7bb6"],
	6: ["#d73027","#fc8d59","#fee090","#e0f3f8","#91bfdb","#4575b4"],
	7: ["#d73027","#fc8d59","#fee090","#ffffbf","#e0f3f8","#91bfdb","#4575b4"],
	8: ["#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4"],
	9: ["#d73027","#f46d43","#fdae61","#fee090","#ffffbf","#e0f3f8","#abd9e9","#74add1","#4575b4"],
	10: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"],
	11: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#ffffbf","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"]
	},Spectral: {
	3: ["#fc8d59","#ffffbf","#99d594"],
	4: ["#d7191c","#fdae61","#abdda4","#2b83ba"],
	5: ["#d7191c","#fdae61","#ffffbf","#abdda4","#2b83ba"],
	6: ["#d53e4f","#fc8d59","#fee08b","#e6f598","#99d594","#3288bd"],
	7: ["#d53e4f","#fc8d59","#fee08b","#ffffbf","#e6f598","#99d594","#3288bd"],
	8: ["#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd"],
	9: ["#d53e4f","#f46d43","#fdae61","#fee08b","#ffffbf","#e6f598","#abdda4","#66c2a5","#3288bd"],
	10: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"],
	11: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#ffffbf","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"]
	},RdYlGn: {
	3: ["#fc8d59","#ffffbf","#91cf60"],
	4: ["#d7191c","#fdae61","#a6d96a","#1a9641"],
	5: ["#d7191c","#fdae61","#ffffbf","#a6d96a","#1a9641"],
	6: ["#d73027","#fc8d59","#fee08b","#d9ef8b","#91cf60","#1a9850"],
	7: ["#d73027","#fc8d59","#fee08b","#ffffbf","#d9ef8b","#91cf60","#1a9850"],
	8: ["#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
	9: ["#d73027","#f46d43","#fdae61","#fee08b","#ffffbf","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
	10: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"],
	11: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#ffffbf","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"]
	},Accent: {
	3: ["#7fc97f","#beaed4","#fdc086"],
	4: ["#7fc97f","#beaed4","#fdc086","#ffff99"],
	5: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0"],
	6: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f"],
	7: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17"],
	8: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17","#666666"]
	},Dark2: {
	3: ["#1b9e77","#d95f02","#7570b3"],
	4: ["#1b9e77","#d95f02","#7570b3","#e7298a"],
	5: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e"],
	6: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02"],
	7: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d"],
	8: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"]
	},Paired: {
	3: ["#a6cee3","#1f78b4","#b2df8a"],
	4: ["#a6cee3","#1f78b4","#b2df8a","#33a02c"],
	5: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99"],
	6: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c"],
	7: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f"],
	8: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00"],
	9: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6"],
	10: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a"],
	11: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99"],
	12: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928"]
	},Pastel1: {
	3: ["#fbb4ae","#b3cde3","#ccebc5"],
	4: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4"],
	5: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6"],
	6: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc"],
	7: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd"],
	8: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec"],
	9: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec","#f2f2f2"]
	},Pastel2: {
	3: ["#b3e2cd","#fdcdac","#cbd5e8"],
	4: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4"],
	5: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9"],
	6: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae"],
	7: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc"],
	8: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc","#cccccc"]
	},Set1: {
	3: ["#e41a1c","#377eb8","#4daf4a"],
	4: ["#e41a1c","#377eb8","#4daf4a","#984ea3"],
	5: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00"],
	6: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33"],
	7: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628"],
	8: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf"],
	9: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf","#999999"]
	},Set2: {
	3: ["#66c2a5","#fc8d62","#8da0cb"],
	4: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3"],
	5: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854"],
	6: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f"],
	7: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494"],
	8: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494","#b3b3b3"]
	},Set3: {
	3: ["#8dd3c7","#ffffb3","#bebada"],
	4: ["#8dd3c7","#ffffb3","#bebada","#fb8072"],
	5: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3"],
	6: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462"],
	7: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69"],
	8: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5"],
	9: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9"],
	10: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd"],
	11: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5"],
	12: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5","#ffed6f"]
	}};
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (colorbrewer), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === "object" && module.exports) {
	    module.exports = colorbrewer;
	} else {
	    this.colorbrewer = colorbrewer;
	}
	
	}();


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(93);


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "body,html{height:100%}body{font-family:Roboto Regular,Helvetica,Arial,sans-serif}body .tooltip{background-color:#fff;color:#7f7f7f;border:1px solid #0a0a0a}body .tooltip:before{border-top-color:transparent;border-left-color:transparent;border-right-color:transparent;border-bottom-color:#0a0a0a}body .tooltip:after{content:'';display:block;width:0;height:0;border:.75rem inset;border-color:transparent transparent #fff;border-bottom-style:solid;border-top-width:0;bottom:99%;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}::-webkit-scrollbar{-webkit-appearance:none;width:5px;height:5px}::-webkit-scrollbar-thumb{border-radius:4px;background-color:#87c6c5;-webkit-box-shadow:0 0 1px hsla(0,0%,100%,.5)}::-webkit-input-placeholder{font-style:italic;font-size:smaller}::-moz-placeholder{font-style:italic;font-size:smaller}:-ms-input-placeholder{font-style:italic;font-size:smaller}:-moz-placeholder{font-style:italic;font-size:smaller}button{padding:5px 10px;font-size:9pt}.main-container{height:100%;width:100%;max-width:100%!important;display:flex;flex-direction:row;font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}.data-container-pane,.data-display-container{height:100%;width:100%;overflow:hidden;position:relative}.crosstab-view-splitter-container{position:absolute;right:0;top:50%;z-index:99}.crosstab-view-splitter{position:relative;right:0;top:-62px}.crosstab-view-splitter button{width:38px;height:30px;background-color:#cacaca;background-repeat:no-repeat;background-position:center;display:block;margin-bottom:5px}.crosstab-view-splitter button.selected,.crosstab-view-splitter button:hover{background-color:#2888a5}.crosstab-view-splitter .full-table{background-image:url(" + __webpack_require__(122) + ")}.crosstab-view-splitter .full-table:hover,.full-table.selected{background-image:url(" + __webpack_require__(125) + ")}.crosstab-view-splitter .half-tablechart{background-image:url(" + __webpack_require__(123) + ");height:53px}.crosstab-view-splitter .half-tablechart:hover,.half-tablechart.selected{background-image:url(" + __webpack_require__(124) + ")}.crosstab-view-splitter .full-chart{background-image:url(" + __webpack_require__(117) + ")}.crosstab-view-splitter .full-chart:hover,.full-chart.selected{background-image:url(" + __webpack_require__(118) + ")}.clearfix{clear:both}.hidden-container{display:none!important}.visible-container{display:block!important}.visible-flex-container{display:flex!important}.right{float:right}.custom-checkbox{padding-left:20px}.custom-checkbox span{font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}.custom-checkbox input[type=checkbox]+label{cursor:pointer}.custom-checkbox input[type=checkbox]{width:2em;margin:0;padding:0;font-size:1em;opacity:0}.custom-checkbox input[type=checkbox]+label{display:inline-block;margin-left:-1em;line-height:1.2em}.custom-checkbox input[type=checkbox]+label>span.custom-input{display:inline-block;width:.5em;height:.55em;margin:.25em .5em .25em .25em;margin-bottom:7px;border:.0625em solid #cbdae3;background:#fff;vertical-align:bottom;position:absolute;left:-15px;top:2px}.custom-checkbox input[type=checkbox]:checked+label>span.custom-input>span{display:block;width:.33em;height:.33em;margin:.06em;border:none;background:#fff;background-image:-webkit-linear-gradient(#4282a1,#4282a1);background-image:linear-gradient(#4282a1,#4282a1)}ul.axis-selected-dimensions{list-style:none;padding:0;margin-left:0}ul.axis-selected-dimensions li{display:inline-block;margin-right:5px}span.selected-dimension-bullet{background-color:#808284;color:#fff;border-radius:5px;padding:5px 10px;font-size:9pt}span.selected-dimension-bullet label,span.selected-dimension-bullet span{color:#fff}span.selected-dimension-bullet label{font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}span.selected-dimension-bullet.first-axis{background-color:#5a5b5d}span.selected-dimension-bullet.selected{box-shadow:0 0 5px 0 #0587eb}span.selected-dimension-bullet label{cursor:pointer;display:inline-block;margin-right:10px}span.selected-dimension-bullet .fa-close{cursor:pointer}.loading-indicator{position:absolute;z-index:999;width:100%;height:100%}.loading-icon{position:absolute;display:block;top:50%;left:50%;width:2pc;height:2pc;background-image:url(" + __webpack_require__(115) + ")}.show{visibility:visible;display:block}.hide{visibility:hidden;display:none}.pane_selector{float:right;margin:.5em}.pane_selector button{padding:.5em;margin-left:1em;background-color:#eff0f0;color:#000}.pane_selector button.selected,.pane_selector button:hover{background-color:#4382a0;color:#fff}button.secondary{background-color:#eff0f0;color:#000;padding:5px 10px;font-size:9pt}button.secondary:hover{background-color:#2488a5;color:#fff;padding:5px 10px;font-size:9pt}.overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:5000}.modal-message{position:fixed;padding:25px;background-color:#e7e8ea;border:1px solid #000;z-index:10000;top:50%;margin-top:-125px;left:50%;margin-left:-225px;width:450px;height:250px}.modal-message h1{font-size:1pc;letter-spacing:1px;margin-top:20px;margin-bottom:10px;text-transform:uppercase}.modal-message p{font-size:9pt}.modal-message .left{float:left}.modal-message .right{float:right}.modal-message .center{margin:0 auto;width:150px;display:block}.modal-message .secondary{background-color:#c7c8ca}.modal-message .secondary:hover{background-color:#a7a8aa}", ""]);
	
	// exports


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".calendar{font:10px sans-serif;height:100%;width:100%;float:left;margin-right:1em}.calendar .graph{position:relative;height:calc(100% - 130px);overflow-y:scroll;overflow-x:hidden}.calendar .legend{position:relative;margin-left:10px;padding-left:10px;box-sizing:content-box;left:0;right:0;height:70px}.calendar .legend h3{text-align:center;margin-bottom:0}.calendar .legend .block{display:inline-block;border:1px solid #ccc;width:20px;height:20px;vertical-align:middle}.legend .items{float:right}.legend .item{vertical-align:top;display:inline-block}.legend .item span:last-child{padding:0 8px}.calendar canvas,.calendar svg{position:absolute;left:0;top:0;margins:0;padding:0}.calendar .period{cursor:pointer}.foreground .tooltip{font-size:11px}.zoomed .x.axis,.zoomed .y.axis,.zoomed rect{display:none}.x.axis .month{text-transform:capitalize}.calendar-legend{position:absolute;top:0;right:40px;width:115px}", ""]);
	
	// exports


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".carousel{overflow:hidden;white-space:nowrap;width:100%}.carousel .dots{list-style:none;position:relative}.carousel .dots li{float:left}.carousel .dots .active{text-decoration:underline}.carousel .step{position:fixed;z-index:100;top:50%;width:50;height:50;background:#fff;padding:10px;border:1px dashed #fece3c;cursor:pointer}.carousel .step:hover{background:#fece3c}.carousel .step.previous{left:0;border-radius:0 10px 10px 0;border-left:none}.carousel .step.previous:after{content:' < '}.carousel .step.next{right:0;border-radius:10px 0 0 10px;border-right:none}.carousel .step.next:after{content:' > '}.carousel .panes{list-style:none;position:relative;padding:10px;margin:0}.carousel .panes>li{position:relative;float:left}.carousel .panes .pane{overflow:hidden}", ""]);
	
	// exports


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".chart-containter{top:10px;width:100%;text-align:center;position:relative}.crosstab-container.full-table{visibility:hidden;height:0}.crosstab-container.half-table{visibility:visible;height:50%}.crosstab-container.full-chart{visibility:visible;height:100%}.chart-container .loading-icon{top:5em}.chart-container .content-container{width:80%;margin:10px auto}.axis{cursor:pointer}.legend{position:absolute;right:40px;width:115px;top:0}.legend>h6{font-size:9pt;margin-bottom:0;text-transform:uppercase}.legend-labels{cursor:pointer;max-height:150px;box-sizing:border-box;padding:5px;text-align:left;background-color:#f5f5f5;width:100%;overflow-y:auto}.legend-labels>p{margin-bottom:0;font-size:10px;width:100%;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}.legend-labels span{vertical-align:top}.legend-labels>p.highlight{font-weight:700}.legend-labels>p.highlight path{stroke-width:3px}", ""]);
	
	// exports


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".hint{font-size:9pt;font-weight:700}.crosstab-container{width:100%;border-bottom:2px solid #bacad4;position:relative}.crosstab-container.full-table{visibility:visible;height:100%}.crosstab-container.half-table{visibility:visible;height:50%}.crosstab-container.full-chart{visibility:hidden;height:0}.crosstab-container .content-container{width:90%;max-width:75pc;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0}.y-axis-dimensions-container{float:left;width:15%;padding-top:8%;padding-right:5px;overflow:hidden;white-space:nowrap}.y-axis-dimensions-container li{float:right;clear:both}.x-axis-data-container{width:100%;height:100%;overflow:hidden}.x-axis-dimensions-container{height:10%;padding-left:16%;padding-right:16%;overflow:hidden}.crosstab-container .data-table-container{height:85%;overflow-x:hidden;overflow-y:auto;position:relative;font-size:11pt}.data-table-container>div{border:0}.data-table-container table{margin-bottom:0;border:0}.crosstab-container table{table-layout:fixed}.crosstab-container table td,.crosstab-container table th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border:1px solid #cacaca;font-weight:200;line-height:1pc;padding:8px 10px;text-align:center}.crosstab-container table td.selected{background-color:#65a8df;font-weight:500}.crosstab-container table td.partly-selected{background-color:#8dceff}.crosstab-container .cross-cell{color:#cacaca;background-color:#cacaca;background-image:url(" + __webpack_require__(119) + ");background-repeat:no-repeat;background-position:right;cursor:pointer}.crosstab-container .cross-cell span{display:inline-block}.crosstab-container .row-headers-col{float:left;width:15%;max-width:15%;position:relative}.crosstab-container .row-headers-col table{width:100%;max-width:100%}.crosstab-container .data-content{float:left;width:70%;max-width:70%;overflow-x:scroll}.crosstab-container .data-content table{width:100%}.crosstab-container table span{font-weight:inherit;border:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.crosstab-container table tr.heading-row{position:relative}.crosstab-container .sum-col{float:left;width:15%;max-width:15%}.crosstab-container .sum-col,.crosstab-container .sum-row{background-color:#dcdcdc}.crosstab-container .sum-table{background-color:#c5c8c9}.crosstab-container .sum-col table{width:100%;max-width:100%}.crosstab-container .half-column{width:50%;max-width:50%}.pivot{display:inline-block;position:absolute;width:100%;height:100%}.pivot *{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pivot .filler{float:left}.pivot .header.top{overflow:hidden;cursor:row-resize}.pivot .header.top svg{left:50px}.pivot .header.left{float:left;overflow:hidden;cursor:col-resize}.pivot .content{overflow:auto}.pivot svg text{stroke:#000;fill:#000}.pivot .domain{stroke:gray;fill:transparent}.pivot .cell{cursor:pointer}.pivot .cell.focused path,.pivot .cell:hover path{stroke:red}", ""]);
	
	// exports


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".download-container{position:absolute;right:0;top:10px;width:200px;height:150px;z-index:99;border:1px solid transparent;padding:2px;font-size:10pt;display:flex;flex-direction:column;justify-content:space-between}.download-container.closed{width:38px}.download-container.open{border:1px solid gray;background:#fff}.download-container a,.download-container button{display:inline-block;min-height:30px;background-color:#cacaca;background-repeat:no-repeat;background-position:center;margin:2px;color:#fff;font-weight:700}.download-container a{padding:8px}.download-container button.openClose{min-width:38px;align-self:flex-end;background-image:url(" + __webpack_require__(116) + ")}.download-container .format{margin-bottom:10px}.download-container button:hover,.download-container.open a,.download-container.open button{background-color:#2888a5}.download-container .formats,.download-container .message{align-self:center}.download-container.closed .format,.download-container.closed .message{display:none}", ""]);
	
	// exports


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".slide-pannel-container{padding:0!important;position:relative;min-height:100%}.query-container{min-height:100%;background-color:#e7e8ea;padding:0!important;box-sizing:border-box;border-right:8px solid #4382a0;border-top-right-radius:6px;border-bottom-right-radius:6px}.slide-pannel-button{right:-17px!important;top:50%;background-color:#4382a0!important;padding:10px 5px!important;color:#fff!important}.query-show-handle,.slide-pannel-button{position:absolute;border-top-right-radius:6px;border-bottom-right-radius:6px;z-index:999}.query-show-handle{top:0;width:50px;height:100%;background-color:#4382a0;color:#fff;border-right:8px solid #4382a0;text-align:center;white-space:nowrap;cursor:pointer}.query-show-handle div{position:relative;top:50%}.query-show-handle div p{position:absolute;left:-200%;text-transform:uppercase;writing-mode:lr-bt;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.query-pane-content{max-width:450px;position:relative}.query-pane-section{padding:20px 40px;border-bottom:2px solid #bacad4;position:relative}.query-pane-section select{padding:0;height:inherit}.query-pane-section .arrow-indicator{position:absolute;top:50%;right:-15px;z-index:2}.selector .dropdown-list{margin-top:1rem}.selector .custom-checkbox{position:relative;cursor:pointer}.selector .selected-period-filters{margin-top:1rem;margin-bottom:0;list-style:none;padding:0;margin-left:0}.selector .selected-period-filters li{display:inline-block;margin-right:3px}.selector .custom-checkbox .selected-filter{color:#3e94a6}.selector .custom-checkbox .selected-filter .custom-input{background-color:#3e94a6;color:transparent}.selector .custom-checkbox input[type=checkbox]+label>span.custom-input{top:3px;left:-4px;width:.7em;height:.7em}.interchange-axis-button{position:absolute;z-index:9;background-color:#dfdfdc;background-image:url(" + __webpack_require__(120) + ");background-repeat:no-repeat;background-position:center;width:30px;height:30px;bottom:-1pc;right:30px;border:1px solid #2888a5}.interchange-axis-button:hover{background-color:#2888a5;background-image:url(" + __webpack_require__(121) + ")}.query-pane-section .row{margin:0}.query-pane-section .arrow-indicator:after,.query-pane-section .arrow-indicator:before{content:\"\";width:0;height:0;border-color:transparent;position:absolute}.query-pane-section .arrow-indicator:before{border-top:1pc solid transparent;border-left:17px solid #bacad4;border-bottom:17px solid transparent;right:-2px;top:-13px}.query-pane-section .arrow-indicator:after{border-top:15px solid transparent;border-left:15px solid #dadbdb;border-bottom:15px solid transparent;right:1px;top:-9pt}.query-pane-section.interacted{background-color:#dadbdb}.query-pane-section:last-child{border-bottom:none;flex-grow:1}.query-pane-section.header h1{font-size:20px;margin-bottom:5px;text-transform:uppercase}.query-pane-section.header button{background-color:#88c4c6;color:#000;margin-right:3px;margin-left:3px}.query-pane-section.header button:first-of-type{margin-right:3px;margin-left:0}.query-pane-section.header button:last-of-type{margin-left:3px;margin-right:0}.query-pane-section h2{font-size:1pc;margin-bottom:10px;text-transform:uppercase}.query-pane-section h2.axis-title:first-letter{text-transform:lowercase}.aggregate-selector,.axis-selector{position:relative}.time-period-selector>select{width:4.5em;margin:0 .5em;padding:.5rem;border:1px solid #cacaca;border-radius:3px}.time-period-selector>input{display:inline;margin:0 .5em;width:4.5em;height:auto}.time-period-selector>span{line-height:2;vertical-align:middle}button.dropdown-list{width:100%;text-align:left;font-size:11pt;color:#4e5052;background-color:#f1f1f2}button.dropdown-list span.title{max-width:80%;display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-transform:uppercase;font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}button.dropdown-list .fa{color:#3e7f9f}button.dropdown-list.dimension-selector.selected,button.dropdown-list.dimension-selector:hover{background-color:#4382a0;color:#fff}button.dropdown-list.dimension-selector.selected span,button.dropdown-list.dimension-selector:hover span{color:#fff}ul.dropdown-list-content{width:100%;background-color:#f1f1f2;padding:5px 10px;margin:0;list-style:none;z-index:10}ul.dropdown-list-content li{padding-left:0;font-size:10pt}ul.dropdown-list-content li span.title{font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}ul.dropdown-list-content li input[type=radio]+label{cursor:pointer}ul.dropdown-list-content li input[type=radio]{width:2em;margin:0;padding:0;font-size:1em;opacity:0}ul.dropdown-list-content li input[type=radio]+label{display:inline-block;margin-left:-2em;line-height:1.5em}ul.dropdown-list-content li input[type=radio]+label>span.radio{display:inline-block;width:.84em;height:.84em;margin:.25em .5em .25em .25em;border:.0625em solid #cbdae3;border-radius:50%;background:#fff;vertical-align:bottom}ul.dropdown-list-content li input[type=radio]:checked+label>span.radio>span{display:block;width:.5em;height:.5em;margin:.125em;border:none;border-radius:50%;background:#fff;background-image:-webkit-linear-gradient(#4282a1,#4282a1);background-image:linear-gradient(#4282a1,#4282a1)}ul.dropdown-list-content.axis-content{max-height:265px;overflow-y:scroll}ul.dropdown-list-content.dropdown-inline{position:static}.filter-container{position:absolute;flex-direction:column;top:0;left:calc(100% + 8px);z-index:1;bottom:0;background-color:#dadbdb;box-sizing:border-box;border-left:2px solid #bacad4;padding:10px 30px;min-width:200px;max-width:250px}.filter-container input,.filter-container span{font-family:Roboto Regular,Helvetica,Arial,sans-serif;font-weight:400;line-height:1.5}.filter-container>div,.filter-container>ul{margin-top:10px}.filter-container>div>button,.filter-container>div>input{width:100%}.filter-container>div>h4{color:#636363;font-size:13pt;text-transform:uppercase;margin-bottom:0}.filter-container .filter-list{flex-grow:1;list-style:none;padding:0;margin-left:0;overflow:scroll}.filter-container .filter-list li{line-height:14pt;margin-left:20px;margin-bottom:15px;position:relative}.filter-container .filter-list label.selected-filter{color:#3e94a6}.filter-container .filter-list li input[type=checkbox]{position:absolute;left:-17px;top:4px}", ""]);
	
	// exports


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "register-container{width:50%;height:100%;float:left}.register{font:10px sans-serif;height:100%;overflow:hidden}", ""]);
	
	// exports


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:not-allowed}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.foundation-mq{font-family:\"small=0em&medium=40em&large=64em&xlarge=75em&xxlarge=90em\"}html{font-size:100%;box-sizing:border-box}*,:after,:before{box-sizing:inherit}body{padding:0;margin:0;font-family:Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;line-height:1.5;color:#0a0a0a;background:#fefefe;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}img{max-width:100%;height:auto;-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}textarea{height:auto;min-height:50px}select,textarea{border-radius:3px}select{width:100%}#map_canvas embed,#map_canvas img,#map_canvas object,.map_canvas embed,.map_canvas img,.map_canvas object,.mqa-display embed,.mqa-display img,.mqa-display object{max-width:none!important}button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:3px;line-height:1}[data-whatinput=mouse] button{outline:0}.is-visible{display:block!important}.is-hidden{display:none!important}blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}em,i{font-style:italic}b,em,i,strong{line-height:inherit}b,strong{font-weight:700}small{font-size:80%;line-height:inherit}h1,h2,h3,h4,h5,h6{font-family:Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;font-weight:400;font-style:normal;color:inherit;text-rendering:optimizeLegibility;margin-top:0;margin-bottom:.5rem;line-height:1.4}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{color:#cacaca;line-height:0}h1{font-size:1.5rem}h2{font-size:1.25rem}h3{font-size:1.1875rem}h4{font-size:1.125rem}h5{font-size:1.0625rem}h6{font-size:1rem}@media screen and (min-width:40em){h1{font-size:3rem}h2{font-size:2.5rem}h3{font-size:1.9375rem}h4{font-size:1.5625rem}h5{font-size:1.25rem}h6{font-size:1rem}}a{color:#2ba6cb;text-decoration:none;line-height:inherit;cursor:pointer}a img{border:0}hr{max-width:62.5rem;height:0;border-right:0;border-top:0;border-bottom:1px solid #cacaca;border-left:0;margin:1.25rem auto;clear:both}dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}li{font-size:inherit}ul{list-style-type:disc}ol,ul{margin-left:1.25rem}ol ol,ol ul,ul ol,ul ul{margin-left:1.25rem;margin-bottom:0}dl{margin-bottom:1rem}dl dt{margin-bottom:.3rem;font-weight:700}blockquote{margin:0 0 1rem;padding:.5625rem 1.25rem 0 1.1875rem;border-left:1px solid #cacaca}blockquote,blockquote p{line-height:1.6;color:#8a8a8a}cite{display:block;font-size:.8125rem;color:#8a8a8a}cite:before{content:'\\2014    '}abbr{color:#0a0a0a;cursor:help;border-bottom:1px dotted #0a0a0a}code{font-weight:400;border:1px solid #cacaca;padding:.125rem .3125rem .0625rem}code,kbd{font-family:Consolas,Liberation Mono,Courier,monospace;color:#0a0a0a;background-color:#e6e6e6}kbd{padding:.125rem .25rem 0;margin:0;border-radius:3px}.subheader{margin-top:.2rem;margin-bottom:.5rem;font-weight:400;line-height:1.4;color:#8a8a8a}.lead{font-size:125%;line-height:1.6}.stat{font-size:2.5rem;line-height:1}p+.stat{margin-top:-1rem}.no-bullet{margin-left:0;list-style:none}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}@media screen and (min-width:40em){.medium-text-left{text-align:left}.medium-text-right{text-align:right}.medium-text-center{text-align:center}.medium-text-justify{text-align:justify}}@media screen and (min-width:64em){.large-text-left{text-align:left}.large-text-right{text-align:right}.large-text-center{text-align:center}.large-text-justify{text-align:justify}}.show-for-print{display:none!important}@media print{*{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}.show-for-print{display:block!important}.hide-for-print{display:none!important}table.show-for-print{display:table!important}thead.show-for-print{display:table-header-group!important}tbody.show-for-print{display:table-row-group!important}tr.show-for-print{display:table-row!important}td.show-for-print,th.show-for-print{display:table-cell!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}.ir a:after,a[href^='#']:after,a[href^='javascript:']:after{content:''}abbr[title]:after{content:\" (\" attr(title) \")\"}blockquote,pre{border:1px solid #8a8a8a;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}[type=color],[type=date],[type=datetime-local],[type=datetime],[type=email],[type=month],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=time],[type=url],[type=week],textarea{display:block;box-sizing:border-box;width:100%;height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#0a0a0a;background-color:#fefefe;box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);border-radius:3px;transition:box-shadow .5s,border-color .25s ease-in-out;-webkit-appearance:none;-moz-appearance:none}[type=color]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=datetime]:focus,[type=email]:focus,[type=month]:focus,[type=number]:focus,[type=password]:focus,[type=search]:focus,[type=tel]:focus,[type=text]:focus,[type=time]:focus,[type=url]:focus,[type=week]:focus,textarea:focus{border:1px solid #8a8a8a;background-color:#fefefe;outline:0;box-shadow:0 0 5px #cacaca;transition:box-shadow .5s,border-color .25s ease-in-out}textarea{max-width:100%}textarea[rows]{height:auto}input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{color:#cacaca}input::-moz-placeholder,textarea::-moz-placeholder{color:#cacaca}input:-ms-input-placeholder,textarea:-ms-input-placeholder{color:#cacaca}input::placeholder,textarea::placeholder{color:#cacaca}input:disabled,input[readonly],textarea:disabled,textarea[readonly]{background-color:#e6e6e6;cursor:not-allowed}[type=button],[type=submit]{border-radius:3px;-webkit-appearance:none;-moz-appearance:none}input[type=search]{box-sizing:border-box}[type=checkbox],[type=file],[type=radio]{margin:0 0 1rem}[type=checkbox]+label,[type=radio]+label{display:inline-block;margin-left:.5rem;margin-right:1rem;margin-bottom:0;vertical-align:baseline}[type=checkbox]+label[for],[type=radio]+label[for]{cursor:pointer}label>[type=checkbox],label>[type=radio]{margin-right:.5rem}[type=file]{width:100%}label{display:block;margin:0;font-size:.875rem;font-weight:400;line-height:1.8;color:#0a0a0a}label.middle{margin:0 0 1rem;padding:.5625rem 0}.help-text{margin-top:-.5rem;font-size:.8125rem;font-style:italic;color:#0a0a0a}.input-group{display:-ms-flexbox;display:flex;width:100%;margin-bottom:1rem;-ms-flex-align:stretch;align-items:stretch}.input-group>:first-child{border-radius:3px 0 0 3px}.input-group>:last-child>*{border-radius:0 3px 3px 0}.input-group-button,.input-group-field,.input-group-label{margin:0;white-space:nowrap}.input-group-label{text-align:center;padding:0 1rem;background:#e6e6e6;color:#0a0a0a;border:1px solid #cacaca;white-space:nowrap;-ms-flex:0 0 auto;flex:0 0 auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group-label:first-child{border-right:0}.input-group-label:last-child{border-left:0}.input-group-field{border-radius:0;-ms-flex:1 1 0px;flex:1 1 0px;height:auto}.input-group-button{padding-top:0;padding-bottom:0;text-align:center;-ms-flex:0 0 auto;flex:0 0 auto}.input-group-button a,.input-group-button button,.input-group-button input{margin:0}fieldset{border:0;padding:0;margin:0}legend{margin-bottom:.5rem;max-width:100%}.fieldset{border:1px solid #cacaca;padding:1.25rem;margin:1.125rem 0}.fieldset legend{background:#fefefe;padding:0 .1875rem;margin:0;margin-left:-.1875rem}select{height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-size:1rem;font-family:inherit;line-height:normal;color:#0a0a0a;background-color:#fefefe;border-radius:3px;-webkit-appearance:none;-moz-appearance:none;background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>\");background-size:9px 6px;background-position:right -1rem center;background-origin:content-box;background-repeat:no-repeat;padding-right:1.5rem}@media screen and (min-width:0\\0){select{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==\")}}select:disabled{background-color:#e6e6e6;cursor:not-allowed}select::-ms-expand{display:none}select[multiple]{height:auto;background-image:none}.is-invalid-input:not(:focus){background-color:rgba(198,15,19,.1);border-color:#c60f13}.form-error,.is-invalid-label{color:#c60f13}.form-error{display:none;margin-top:-.5rem;margin-bottom:1rem;font-size:.75rem;font-weight:700}.form-error.is-visible{display:block}.float-left{float:left!important}.float-right{float:right!important}.float-center{display:block;margin-left:auto;margin-right:auto}.clearfix:after,.clearfix:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.clearfix:after{clear:both}.hide{display:none!important}.invisible{visibility:hidden}@media screen and (max-width:39.9375em){.hide-for-small-only{display:none!important}}@media screen and (max-width:0em),screen and (min-width:40em){.show-for-small-only{display:none!important}}@media screen and (min-width:40em){.hide-for-medium{display:none!important}}@media screen and (max-width:39.9375em){.show-for-medium{display:none!important}}@media screen and (min-width:40em) and (max-width:63.9375em){.hide-for-medium-only{display:none!important}}@media screen and (max-width:39.9375em),screen and (min-width:64em){.show-for-medium-only{display:none!important}}@media screen and (min-width:64em){.hide-for-large{display:none!important}}@media screen and (max-width:63.9375em){.show-for-large{display:none!important}}@media screen and (min-width:64em) and (max-width:74.9375em){.hide-for-large-only{display:none!important}}@media screen and (max-width:63.9375em),screen and (min-width:75em){.show-for-large-only{display:none!important}}.show-for-sr,.show-on-focus{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}.show-on-focus:active,.show-on-focus:focus{position:static!important;height:auto;width:auto;overflow:visible;clip:auto}.hide-for-portrait,.show-for-landscape{display:block!important}@media screen and (orientation:landscape){.hide-for-portrait,.show-for-landscape{display:block!important}}@media screen and (orientation:portrait){.hide-for-portrait,.show-for-landscape{display:none!important}}.hide-for-landscape,.show-for-portrait{display:none!important}@media screen and (orientation:landscape){.hide-for-landscape,.show-for-portrait{display:none!important}}@media screen and (orientation:portrait){.hide-for-landscape,.show-for-portrait{display:block!important}}.button{display:inline-block;text-align:center;line-height:1;cursor:pointer;-webkit-appearance:none;transition:background-color .25s ease-out,color .25s ease-out;vertical-align:middle;border:1px solid transparent;padding:.85em 1em;margin:0 0 1rem;font-size:.9rem;color:#fefefe}[data-whatinput=mouse] .button{outline:0}.button:focus,.button:hover{background-color:#258dad;color:#fefefe}.button.tiny{font-size:.6rem}.button.small{font-size:.75rem}.button.large{font-size:1.25rem}.button.expanded{display:block;width:100%;margin-left:0;margin-right:0}.button.primary{background-color:#2ba6cb;color:#fefefe}.button.primary:focus,.button.primary:hover{background-color:#2285a2;color:#fefefe}.button.secondary{background-color:#e9e9e9;color:#0a0a0a}.button.secondary:focus,.button.secondary:hover{background-color:#bababa;color:#0a0a0a}.button.alert{background-color:#c60f13;color:#fefefe}.button.alert:focus,.button.alert:hover{background-color:#9e0c0f;color:#fefefe}.button.success{background-color:#5da423;color:#fefefe}.button.success:focus,.button.success:hover{background-color:#4a831c;color:#fefefe}.button.warning{background-color:#ffae00;color:#fefefe}.button.warning:focus,.button.warning:hover{background-color:#cc8b00;color:#fefefe}.button.body-font{background-color:#222;color:#fefefe}.button.body-font:focus,.button.body-font:hover{background-color:#1b1b1b;color:#fefefe}.button.header{background-color:#222;color:#fefefe}.button.header:focus,.button.header:hover{background-color:#1b1b1b;color:#fefefe}.button.hollow{border:1px solid #2ba6cb;color:#2ba6cb}.button.hollow,.button.hollow:focus,.button.hollow:hover{background-color:transparent}.button.hollow:focus,.button.hollow:hover{border-color:#165366;color:#165366}.button.hollow.primary{border:1px solid #2ba6cb;color:#2ba6cb}.button.hollow.primary:focus,.button.hollow.primary:hover{border-color:#165366;color:#165366}.button.hollow.secondary{border:1px solid #e9e9e9;color:#e9e9e9}.button.hollow.secondary:focus,.button.hollow.secondary:hover{border-color:#757575;color:#757575}.button.hollow.alert{border:1px solid #c60f13;color:#c60f13}.button.hollow.alert:focus,.button.hollow.alert:hover{border-color:#63080a;color:#63080a}.button.hollow.success{border:1px solid #5da423;color:#5da423}.button.hollow.success:focus,.button.hollow.success:hover{border-color:#2f5212;color:#2f5212}.button.hollow.warning{border:1px solid #ffae00;color:#ffae00}.button.hollow.warning:focus,.button.hollow.warning:hover{border-color:#805700;color:#805700}.button.hollow.body-font{border:1px solid #222;color:#222}.button.hollow.body-font:focus,.button.hollow.body-font:hover{border-color:#111;color:#111}.button.hollow.header{border:1px solid #222;color:#222}.button.hollow.header:focus,.button.hollow.header:hover{border-color:#111;color:#111}.button.disabled,.button[disabled]{opacity:.25;cursor:not-allowed}.button.disabled:focus,.button.disabled:hover,.button[disabled]:focus,.button[disabled]:hover{background-color:#2ba6cb;color:#fefefe}.button.disabled.primary,.button[disabled].primary{opacity:.25;cursor:not-allowed}.button.disabled.primary:focus,.button.disabled.primary:hover,.button[disabled].primary:focus,.button[disabled].primary:hover{background-color:#2ba6cb;color:#fefefe}.button.disabled.secondary,.button[disabled].secondary{opacity:.25;cursor:not-allowed}.button.disabled.secondary:focus,.button.disabled.secondary:hover,.button[disabled].secondary:focus,.button[disabled].secondary:hover{background-color:#e9e9e9;color:#fefefe}.button.disabled.alert,.button[disabled].alert{opacity:.25;cursor:not-allowed}.button.disabled.alert:focus,.button.disabled.alert:hover,.button[disabled].alert:focus,.button[disabled].alert:hover{background-color:#c60f13;color:#fefefe}.button.disabled.success,.button[disabled].success{opacity:.25;cursor:not-allowed}.button.disabled.success:focus,.button.disabled.success:hover,.button[disabled].success:focus,.button[disabled].success:hover{background-color:#5da423;color:#fefefe}.button.disabled.warning,.button[disabled].warning{opacity:.25;cursor:not-allowed}.button.disabled.warning:focus,.button.disabled.warning:hover,.button[disabled].warning:focus,.button[disabled].warning:hover{background-color:#ffae00;color:#fefefe}.button.disabled.body-font,.button[disabled].body-font{opacity:.25;cursor:not-allowed}.button.disabled.body-font:focus,.button.disabled.body-font:hover,.button[disabled].body-font:focus,.button[disabled].body-font:hover{background-color:#222;color:#fefefe}.button.disabled.header,.button[disabled].header{opacity:.25;cursor:not-allowed}.button.disabled.header:focus,.button.disabled.header:hover,.button[disabled].header:focus,.button[disabled].header:hover{background-color:#222;color:#fefefe}.button.dropdown:after{content:'';display:block;width:0;height:0;border:.4em inset;border-color:#fefefe transparent transparent;border-top-style:solid;border-bottom-width:0;position:relative;top:.4em;float:right;margin-left:1em;display:inline-block}.button.arrow-only:after{margin-left:0;float:none;top:-.1em}.close-button{position:absolute;color:#8a8a8a;right:1rem;top:.5rem;font-size:2em;line-height:1;cursor:pointer}[data-whatinput=mouse] .close-button{outline:0}.close-button:focus,.close-button:hover{color:#0a0a0a}.button-group{margin-bottom:1rem;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-align:stretch;align-items:stretch}.button-group:after,.button-group:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.button-group:after{clear:both}.button-group .button{margin:0;margin-right:1px;margin-bottom:1px;font-size:.9rem;-ms-flex:0 0 auto;flex:0 0 auto}.button-group .button:last-child{margin-right:0}.button-group.tiny .button{font-size:.6rem}.button-group.small .button{font-size:.75rem}.button-group.large .button{font-size:1.25rem}.button-group.expanded .button{-ms-flex:1 1 0px;flex:1 1 0px}.button-group.primary .button{background-color:#2ba6cb;color:#fefefe}.button-group.primary .button:focus,.button-group.primary .button:hover{background-color:#2285a2;color:#fefefe}.button-group.secondary .button{background-color:#e9e9e9;color:#0a0a0a}.button-group.secondary .button:focus,.button-group.secondary .button:hover{background-color:#bababa;color:#0a0a0a}.button-group.alert .button{background-color:#c60f13;color:#fefefe}.button-group.alert .button:focus,.button-group.alert .button:hover{background-color:#9e0c0f;color:#fefefe}.button-group.success .button{background-color:#5da423;color:#fefefe}.button-group.success .button:focus,.button-group.success .button:hover{background-color:#4a831c;color:#fefefe}.button-group.warning .button{background-color:#ffae00;color:#fefefe}.button-group.warning .button:focus,.button-group.warning .button:hover{background-color:#cc8b00;color:#fefefe}.button-group.body-font .button{background-color:#222;color:#fefefe}.button-group.body-font .button:focus,.button-group.body-font .button:hover{background-color:#1b1b1b;color:#fefefe}.button-group.header .button{background-color:#222;color:#fefefe}.button-group.header .button:focus,.button-group.header .button:hover{background-color:#1b1b1b;color:#fefefe}.button-group.stacked,.button-group.stacked-for-medium,.button-group.stacked-for-small{-ms-flex-wrap:wrap;flex-wrap:wrap}.button-group.stacked .button,.button-group.stacked-for-medium .button,.button-group.stacked-for-small .button{-ms-flex:0 0 100%;flex:0 0 100%}.button-group.stacked .button:last-child,.button-group.stacked-for-medium .button:last-child,.button-group.stacked-for-small .button:last-child{margin-bottom:0}@media screen and (min-width:40em){.button-group.stacked-for-small .button{-ms-flex:1 1 0px;flex:1 1 0px;margin-bottom:0}}@media screen and (min-width:64em){.button-group.stacked-for-medium .button{-ms-flex:1 1 0px;flex:1 1 0px;margin-bottom:0}}@media screen and (max-width:39.9375em){.button-group.stacked-for-small.expanded{display:block}.button-group.stacked-for-small.expanded .button{display:block;margin-right:0}}.slider{position:relative;height:.5rem;margin-top:1.25rem;margin-bottom:2.25rem;background-color:#e6e6e6;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:none;touch-action:none}.slider-fill{position:absolute;top:0;left:0;display:inline-block;max-width:100%;height:.5rem;background-color:#cacaca;transition:all .2s ease-in-out}.slider-fill.is-dragging{transition:all 0s linear}.slider-handle{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);position:absolute;left:0;z-index:1;display:inline-block;width:1.4rem;height:1.4rem;background-color:#2ba6cb;transition:all .2s ease-in-out;-ms-touch-action:manipulation;touch-action:manipulation;border-radius:3px}[data-whatinput=mouse] .slider-handle{outline:0}.slider-handle:hover{background-color:#258dad}.slider-handle.is-dragging{transition:all 0s linear}.slider.disabled,.slider[disabled]{opacity:.25;cursor:not-allowed}.slider.vertical{display:inline-block;width:.5rem;height:12.5rem;margin:0 1.25rem;-webkit-transform:scale(1,-1);transform:scale(1,-1)}.slider.vertical .slider-fill{top:0;width:.5rem;max-height:100%}.slider.vertical .slider-handle{position:absolute;top:0;left:50%;width:1.4rem;height:1.4rem;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.switch{height:2rem;margin-bottom:1rem;outline:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fefefe;font-weight:700;font-size:.875rem}.switch-input{opacity:0;position:absolute;margin-bottom:0}.switch-paddle{background:#cacaca;cursor:pointer;display:block;position:relative;width:4rem;height:2rem;transition:all .25s ease-out;border-radius:3px;color:inherit;font-weight:inherit}input+.switch-paddle{margin:0}.switch-paddle:after{background:#fefefe;content:'';display:block;position:absolute;height:1.5rem;left:.25rem;top:.25rem;width:1.5rem;transition:all .25s ease-out;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);border-radius:3px}input:checked~.switch-paddle{background:#2ba6cb}input:checked~.switch-paddle:after{left:2.25rem}[data-whatinput=mouse] input:focus~.switch-paddle{outline:0}.switch-active,.switch-inactive{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.switch-active{left:8%;display:none}input:checked+label>.switch-active{display:block}.switch-inactive{right:15%}input:checked+label>.switch-inactive{display:none}.switch.tiny{height:1.5rem}.switch.tiny .switch-paddle{width:3rem;height:1.5rem;font-size:.625rem}.switch.tiny .switch-paddle:after{width:1rem;height:1rem}.switch.tiny input:checked~.switch-paddle:after{left:1.75rem}.switch.small{height:1.75rem}.switch.small .switch-paddle{width:3.5rem;height:1.75rem;font-size:.75rem}.switch.small .switch-paddle:after{width:1.25rem;height:1.25rem}.switch.small input:checked~.switch-paddle:after{left:2rem}.switch.large{height:2.5rem}.switch.large .switch-paddle{width:5rem;height:2.5rem;font-size:1rem}.switch.large .switch-paddle:after{width:2rem;height:2rem}.switch.large input:checked~.switch-paddle:after{left:2.75rem}.menu{margin:0;list-style-type:none;width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-wrap:nowrap;flex-wrap:nowrap}[data-whatinput=mouse] .menu>li{outline:0}.menu>li>a{display:block;padding:.7rem 1rem;line-height:1}.menu a,.menu button,.menu input{margin-bottom:0}.menu>li>a{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row}.menu>li>a i,.menu>li>a img,.menu>li>a svg{margin-right:.25rem}.menu>li{-ms-flex:0 0 auto;flex:0 0 auto}.menu.vertical{-ms-flex-wrap:wrap;flex-wrap:wrap}.menu.vertical>li{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.menu.vertical>li>a{-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:start;justify-content:flex-start}@media screen and (min-width:40em){.menu.medium-horizontal{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.menu.medium-horizontal>li{-ms-flex:0 0 auto;flex:0 0 auto}.menu.medium-vertical{-ms-flex-wrap:wrap;flex-wrap:wrap}.menu.medium-vertical>li{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.menu.medium-vertical>li>a{-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:start;justify-content:flex-start}}@media screen and (min-width:64em){.menu.large-horizontal{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.menu.large-horizontal>li{-ms-flex:0 0 auto;flex:0 0 auto}.menu.large-vertical{-ms-flex-wrap:wrap;flex-wrap:wrap}.menu.large-vertical>li{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.menu.large-vertical>li>a{-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:start;justify-content:flex-start}}.menu.simple li{line-height:1;display:inline-block;margin-right:1rem}.menu.simple a{padding:0}.menu.align-right{-ms-flex-pack:end;justify-content:flex-end}.menu.expanded>li{-ms-flex:1 1 0px;flex:1 1 0px}.menu.expanded>li:first-child:last-child{width:100%}.menu.icon-top>li>a{-ms-flex-flow:column nowrap;flex-flow:column}.menu.icon-top>li>a i,.menu.icon-top>li>a img,.menu.icon-top>li>a svg{-ms-flex-item-align:stretch;align-self:stretch;text-align:center;margin-bottom:.25rem}.menu.nested{margin-left:1rem}.menu .active>a{color:#fefefe;background:#2ba6cb}.menu-text{font-weight:700;color:inherit;line-height:1;padding-top:0;padding-bottom:0;padding:.7rem 1rem}.menu-centered{text-align:center}.menu-centered>.menu{display:inline-block}.no-js [data-responsive-menu] ul{display:none}.is-drilldown{position:relative;overflow:hidden}.is-drilldown li{display:block!important}.is-drilldown-submenu{position:absolute;top:0;left:100%;z-index:-1;width:100%;background:#fefefe;transition:-webkit-transform .15s linear;transition:transform .15s linear}.is-drilldown-submenu.is-active{z-index:1;display:block;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.is-drilldown-submenu.is-closing{-webkit-transform:translateX(100%);transform:translateX(100%)}.is-drilldown-submenu-parent>a{position:relative}.is-drilldown-submenu-parent>a:after{content:'';display:block;width:0;height:0;border:6px inset;border-color:transparent transparent transparent #2ba6cb;border-left-style:solid;border-right-width:0;position:absolute;top:50%;margin-top:-6px;right:1rem}.js-drilldown-back>a:before{content:'';display:block;width:0;height:0;border:6px inset;border-color:transparent #2ba6cb transparent transparent;border-right-style:solid;border-left-width:0;display:inline-block;vertical-align:middle;margin-right:.75rem}.is-accordion-submenu-parent>a{position:relative}.is-accordion-submenu-parent>a:after{content:'';display:block;width:0;height:0;border:6px inset;border-color:#2ba6cb transparent transparent;border-top-style:solid;border-bottom-width:0;position:absolute;top:50%;margin-top:-4px;right:1rem}.is-accordion-submenu-parent[aria-expanded=true]>a:after{-webkit-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-transform:scaleY(-1);transform:scaleY(-1)}.dropdown.menu>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu>li.is-dropdown-submenu-parent>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:#2ba6cb transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}[data-whatinput=mouse] .dropdown.menu a{outline:0}.no-js .dropdown.menu ul{display:none}.dropdown.menu.vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.vertical>li.opens-left>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent #2ba6cb transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.vertical>li.opens-right>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #2ba6cb;border-left-style:solid;border-right-width:0}@media screen and (min-width:40em){.dropdown.menu.medium-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.medium-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:#2ba6cb transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.medium-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.medium-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.medium-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.medium-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.medium-vertical>li.opens-left>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent #2ba6cb transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.medium-vertical>li.opens-right>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #2ba6cb;border-left-style:solid;border-right-width:0}}@media screen and (min-width:64em){.dropdown.menu.large-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.large-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:#2ba6cb transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.large-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.large-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.large-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.large-vertical>li>a:after{right:14px;margin-top:-3px}.dropdown.menu.large-vertical>li.opens-left>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent #2ba6cb transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.large-vertical>li.opens-right>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #2ba6cb;border-left-style:solid;border-right-width:0}}.dropdown.menu.align-right .is-dropdown-submenu.first-sub{top:100%;left:auto;right:0}.is-dropdown-menu.vertical{width:75pt}.is-dropdown-menu.vertical.align-right{float:right}.is-dropdown-submenu-parent{position:relative}.is-dropdown-submenu-parent a:after{position:absolute;top:50%;right:5px;margin-top:-2px}.is-dropdown-submenu-parent.opens-inner>.is-dropdown-submenu{top:100%;left:auto}.is-dropdown-submenu-parent.opens-left>.is-dropdown-submenu{left:auto;right:100%}.is-dropdown-submenu-parent.opens-right>.is-dropdown-submenu{right:auto;left:100%}.is-dropdown-submenu{display:none;position:absolute;top:0;left:100%;min-width:200px;z-index:1;background:#fefefe;border:1px solid #cacaca}.is-dropdown-submenu .is-dropdown-submenu-parent>a:after{right:14px;margin-top:-3px}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent #2ba6cb transparent transparent;border-right-style:solid;border-left-width:0}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right>a:after{content:'';display:block;width:0;height:0;border:5px inset;border-color:transparent transparent transparent #2ba6cb;border-left-style:solid;border-right-width:0}.is-dropdown-submenu .is-dropdown-submenu{margin-top:-1px}.is-dropdown-submenu>li{width:100%}.is-dropdown-submenu.js-dropdown-active{display:block}.title-bar{background:#0a0a0a;color:#fefefe;padding:.5rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.title-bar .menu-icon{margin-left:.25rem;margin-right:.25rem}.title-bar-left,.title-bar-right{-ms-flex:1 1 0px;flex:1 1 0px}.title-bar-right{text-align:right}.title-bar-title{font-weight:700;vertical-align:middle;display:inline-block}.top-bar-title{margin-right:1rem}.top-bar-left,.top-bar-right,.top-bar-title{-ms-flex:0 0 auto;flex:0 0 auto}.breadcrumbs{list-style:none;margin:0 0 1rem}.breadcrumbs:after,.breadcrumbs:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.breadcrumbs:after{clear:both}.breadcrumbs li{float:left;color:#0a0a0a;font-size:.6875rem;cursor:default;text-transform:uppercase}.breadcrumbs li:not(:last-child):after{color:#cacaca;content:\"/\";margin:0 .75rem;position:relative;top:1px;opacity:1}.breadcrumbs a{color:#2ba6cb}.breadcrumbs a:hover{text-decoration:underline}.breadcrumbs .disabled{color:#cacaca;cursor:not-allowed}.pagination{margin-left:0;margin-bottom:1rem}.pagination:after,.pagination:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.pagination:after{clear:both}.pagination li{font-size:.875rem;margin-right:.0625rem;border-radius:3px;display:none}.pagination li:first-child,.pagination li:last-child{display:inline-block}@media screen and (min-width:40em){.pagination li{display:inline-block}}.pagination a,.pagination button{color:#0a0a0a;display:block;padding:.1875rem .625rem;border-radius:3px}.pagination a:hover,.pagination button:hover{background:#e6e6e6}.pagination .current{padding:.1875rem .625rem;background:#2ba6cb;color:#fefefe;cursor:default}.pagination .disabled{padding:.1875rem .625rem;color:#cacaca;cursor:not-allowed}.pagination .disabled:hover{background:transparent}.pagination .ellipsis:after{content:'\\2026';padding:.1875rem .625rem;color:#0a0a0a}.pagination-previous a:before,.pagination-previous.disabled:before{content:'\\AB';display:inline-block;margin-right:.5rem}.pagination-next a:after,.pagination-next.disabled:after{content:'\\BB';display:inline-block;margin-left:.5rem}.accordion{list-style-type:none;background:#fefefe;margin-left:0}.accordion-item:first-child>:first-child{border-radius:3px 3px 0 0}.accordion-item:last-child>:last-child{border-radius:0 0 3px 3px}.accordion-title{display:block;padding:1.25rem 1rem;line-height:1;font-size:.75rem;color:#2ba6cb;position:relative;border:1px solid #e6e6e6;border-bottom:0}:last-child:not(.is-active)>.accordion-title{border-radius:0 0 3px 3px;border-bottom:1px solid #e6e6e6}.accordion-title:focus,.accordion-title:hover{background-color:#e6e6e6}.accordion-title:before{content:'+';position:absolute;right:1rem;top:50%;margin-top:-.5rem}.is-active>.accordion-title:before{content:'\\2013'}.accordion-content{padding:1rem;display:none;border:1px solid #e6e6e6;border-bottom:0;background-color:#fefefe;color:#0a0a0a}:last-child>.accordion-content:last-child{border-bottom:1px solid #e6e6e6}.dropdown-pane{background-color:#fefefe;border:1px solid #cacaca;border-radius:3px;display:block;font-size:1rem;padding:1rem;position:absolute;visibility:hidden;width:300px;z-index:10}.dropdown-pane.is-open{visibility:visible}.dropdown-pane.tiny{width:75pt}.dropdown-pane.small{width:200px}.dropdown-pane.large{width:25pc}body,html{height:100%}.off-canvas-wrapper{width:100%;overflow-x:hidden;position:relative;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-overflow-scrolling:auto}.off-canvas-wrapper-inner{position:relative;width:100%;min-height:100%;transition:-webkit-transform .5s ease;transition:transform .5s ease}.off-canvas-wrapper-inner:after,.off-canvas-wrapper-inner:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.off-canvas-wrapper-inner:after{clear:both}.off-canvas-content{min-height:100%;background:#fefefe;transition:-webkit-transform .5s ease;transition:transform .5s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;padding-bottom:.1px;box-shadow:0 0 10px hsla(0,0%,4%,.5)}.js-off-canvas-exit{display:none;position:absolute;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.25);cursor:pointer;transition:background .5s ease}.off-canvas{position:absolute;background:#e6e6e6;z-index:-1;max-height:100%;overflow-y:auto;-webkit-transform:translateX(0);transform:translateX(0)}[data-whatinput=mouse] .off-canvas{outline:0}.off-canvas.position-left{left:-250px;top:0;width:250px}.is-open-left{-webkit-transform:translateX(250px);transform:translateX(250px)}.off-canvas.position-right{right:-250px;top:0;width:250px}.is-open-right{-webkit-transform:translateX(-250px);transform:translateX(-250px)}@media screen and (min-width:40em){.position-left.reveal-for-medium{left:0;z-index:auto;position:fixed}.position-left.reveal-for-medium~.off-canvas-content{margin-left:250px}.position-right.reveal-for-medium{right:0;z-index:auto;position:fixed}.position-right.reveal-for-medium~.off-canvas-content{margin-right:250px}}@media screen and (min-width:64em){.position-left.reveal-for-large{left:0;z-index:auto;position:fixed}.position-left.reveal-for-large~.off-canvas-content{margin-left:250px}.position-right.reveal-for-large{right:0;z-index:auto;position:fixed}.position-right.reveal-for-large~.off-canvas-content{margin-right:250px}}.tabs{margin:0;list-style-type:none;background:#fefefe;border:1px solid #e6e6e6}.tabs:after,.tabs:before{content:' ';display:table;-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-order:1;order:1}.tabs:after{clear:both}.tabs.vertical>li{width:auto;float:none;display:block}.tabs.simple>li>a{padding:0}.tabs.simple>li>a:hover{background:transparent}.tabs.primary{background:#2ba6cb}.tabs.primary>li>a{color:#fefefe}.tabs.primary>li>a:focus,.tabs.primary>li>a:hover{background:#299ec1}.tabs-title{float:left}.tabs-title>a{display:block;padding:1.25rem 1.5rem;line-height:1;font-size:.75rem}.tabs-title>a:hover{background:#fefefe}.tabs-title>a:focus,.tabs-title>a[aria-selected=true]{background:#e6e6e6}.tabs-content{background:#fefefe;transition:all .5s ease;border:1px solid #e6e6e6;border-top:0}.tabs-content.vertical{border:1px solid #e6e6e6;border-left:0}.tabs-panel{display:none;padding:1rem}.tabs-panel.is-active{display:block}.callout{margin:0 0 1rem;padding:1rem;border:1px solid hsla(0,0%,4%,.25);border-radius:3px;position:relative;color:#0a0a0a;background-color:#fff}.callout>:first-child{margin-top:0}.callout>:last-child{margin-bottom:0}.callout.primary{background-color:#def2f8}.callout.secondary{background-color:#fcfcfc}.callout.alert{background-color:#fcd6d6}.callout.success{background-color:#e6f7d9}.callout.warning{background-color:#fff3d9}.callout.body-font,.callout.header{background-color:#dedede}.callout.small{padding:.5rem}.callout.large{padding:3rem}.media-object{margin-bottom:1rem;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.media-object img{max-width:none}@media screen and (max-width:39.9375em){.media-object.stack-for-small{-ms-flex-wrap:wrap;flex-wrap:wrap}}@media screen and (max-width:39.9375em){.media-object.stack-for-small .media-object-section{padding:0;padding-bottom:1rem;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.media-object.stack-for-small .media-object-section img{width:100%}}.media-object-section{-ms-flex:0 1 auto;flex:0 1 auto}.media-object-section:first-child{padding-right:1rem}.media-object-section:last-child:not(:nth-child(2)){padding-left:1rem}.media-object-section>:last-child{margin-bottom:0}.media-object-section.main-section{-ms-flex:1 1 0px;flex:1 1 0px}body.is-reveal-open{overflow:hidden}html.is-reveal-open,html.is-reveal-open body{min-height:100%;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.reveal-overlay{display:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:1005;background-color:hsla(0,0%,4%,.45);overflow-y:scroll}.reveal{display:none;z-index:1006;padding:1rem;border:1px solid #cacaca;background-color:#fefefe;border-radius:3px;position:relative;top:75pt;margin-left:auto;margin-right:auto;overflow-y:auto}[data-whatinput=mouse] .reveal{outline:0}@media screen and (min-width:40em){.reveal{min-height:0}}.reveal .column,.reveal .columns{min-width:0}.reveal>:last-child{margin-bottom:0}@media screen and (min-width:40em){.reveal{width:600px;max-width:62.5rem}}@media screen and (min-width:40em){.reveal .reveal{left:auto;right:auto;margin:0 auto}}.reveal.collapse{padding:0}@media screen and (min-width:40em){.reveal.tiny{width:30%;max-width:62.5rem}}@media screen and (min-width:40em){.reveal.small{width:50%;max-width:62.5rem}}@media screen and (min-width:40em){.reveal.large{width:90%;max-width:62.5rem}}.reveal.full{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}@media screen and (max-width:39.9375em){.reveal{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}}.reveal.without-overlay{position:fixed}table{width:100%;margin-bottom:1rem;border-radius:3px}table tbody,table tfoot,table thead{border:1px solid #f1f1f1;background-color:#fefefe}table caption{font-weight:700;padding:.5rem .625rem .625rem}table thead{background:#f8f8f8;color:#0a0a0a}table tfoot{background:#f1f1f1;color:#0a0a0a}table tfoot tr,table thead tr{background:transparent}table tfoot td,table tfoot th,table thead td,table thead th{padding:.5rem .625rem .625rem;font-weight:700;text-align:left}table tbody tr:nth-child(even){background-color:#f1f1f1}table tbody td,table tbody th{padding:.5rem .625rem .625rem}@media screen and (max-width:63.9375em){table.stack tfoot,table.stack thead{display:none}table.stack td,table.stack th,table.stack tr{display:block}table.stack td{border-top:0}}table.scroll{display:block;width:100%;overflow-x:auto}table.hover thead tr:hover{background-color:#f3f3f3}table.hover tfoot tr:hover{background-color:#ececec}table.hover tbody tr:hover{background-color:#f9f9f9}table.hover tbody tr:nth-of-type(even):hover{background-color:#ececec}.table-scroll{overflow-x:auto}.table-scroll table{width:auto}.badge{display:inline-block;padding:.3em;min-width:2.1em;font-size:.6rem;text-align:center;border-radius:50%;background:#2ba6cb;color:#fefefe}.badge.secondary{background:#e9e9e9;color:#0a0a0a}.badge.alert{background:#c60f13;color:#fefefe}.badge.success{background:#5da423;color:#fefefe}.badge.warning{background:#ffae00;color:#fefefe}.badge.body-font,.badge.header{background:#222;color:#fefefe}.label{display:inline-block;padding:.33333rem .5rem;font-size:.8rem;line-height:1;white-space:nowrap;cursor:default;border-radius:3px;background:#2ba6cb;color:#fefefe}.label.secondary{background:#e9e9e9;color:#0a0a0a}.label.alert{background:#c60f13;color:#fefefe}.label.success{background:#5da423;color:#fefefe}.label.warning{background:#ffae00;color:#fefefe}.label.body-font,.label.header{background:#222;color:#fefefe}.progress{background-color:#cacaca;height:1rem;margin-bottom:1rem;border-radius:3px}.progress.primary .progress-meter{background-color:#2ba6cb}.progress.secondary .progress-meter{background-color:#e9e9e9}.progress.alert .progress-meter{background-color:#c60f13}.progress.success .progress-meter{background-color:#5da423}.progress.warning .progress-meter{background-color:#ffae00}.progress.body-font .progress-meter,.progress.header .progress-meter{background-color:#222}.progress-meter{position:relative;display:block;width:0;height:100%;background-color:#2ba6cb;border-radius:3px}.progress-meter-text{top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);position:absolute;margin:0;font-size:.75rem;font-weight:700;color:#fefefe;white-space:nowrap;border-radius:3px}.has-tip{border-bottom:1px dotted #8a8a8a;font-weight:700;position:relative;display:inline-block;cursor:help}.tooltip{background-color:#0a0a0a;color:#fefefe;font-size:80%;padding:.75rem;position:absolute;z-index:10;top:calc(100% + .6495rem);max-width:10rem!important;border-radius:3px}.tooltip:before{border-color:transparent transparent #0a0a0a;border-bottom-style:solid;border-top-width:0;bottom:100%;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.tooltip.top:before,.tooltip:before{content:'';display:block;width:0;height:0;border:.75rem inset}.tooltip.top:before{border-color:#0a0a0a transparent transparent;border-top-style:solid;border-bottom-width:0;top:100%;bottom:auto}.tooltip.left:before{border-color:transparent transparent transparent #0a0a0a;border-left-style:solid;border-right-width:0;left:100%}.tooltip.left:before,.tooltip.right:before{content:'';display:block;width:0;height:0;border:.75rem inset;bottom:auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.tooltip.right:before{border-color:transparent #0a0a0a transparent transparent;border-right-style:solid;border-left-width:0;left:auto;right:100%}.flex-video{position:relative;height:0;padding-bottom:75%;margin-bottom:1rem;overflow:hidden}.flex-video embed,.flex-video iframe,.flex-video object,.flex-video video{position:absolute;top:0;left:0;width:100%;height:100%}.flex-video.widescreen{padding-bottom:56.25%}.flex-video.vimeo{padding-top:0}.orbit,.orbit-container{position:relative}.orbit-container{margin:0;overflow:hidden;list-style:none}.orbit-slide{width:100%;max-height:100%}.orbit-slide.no-motionui.is-active{top:0;left:0}.orbit-figure{margin:0}.orbit-image{margin:0;width:100%;max-width:100%}.orbit-caption{bottom:0;width:100%;margin-bottom:0;background-color:hsla(0,0%,4%,.5)}.orbit-caption,.orbit-next,.orbit-previous{position:absolute;padding:1rem;color:#fefefe}.orbit-next,.orbit-previous{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);z-index:10}[data-whatinput=mouse] .orbit-next,[data-whatinput=mouse] .orbit-previous{outline:0}.orbit-next:active,.orbit-next:focus,.orbit-next:hover,.orbit-previous:active,.orbit-previous:focus,.orbit-previous:hover{background-color:hsla(0,0%,4%,.5)}.orbit-previous{left:0}.orbit-next{left:auto;right:0}.orbit-bullets{position:relative;margin-top:.8rem;margin-bottom:.8rem;text-align:center}[data-whatinput=mouse] .orbit-bullets{outline:0}.orbit-bullets button{width:1.2rem;height:1.2rem;margin:.1rem;background-color:#cacaca;border-radius:50%}.orbit-bullets button.is-active,.orbit-bullets button:hover{background-color:#8a8a8a}.thumbnail{border:4px solid #fefefe;box-shadow:0 0 0 1px hsla(0,0%,4%,.2);display:inline-block;line-height:0;max-width:100%;transition:box-shadow .2s ease-out;border-radius:3px;margin-bottom:1rem}.thumbnail:focus,.thumbnail:hover{box-shadow:0 0 6px 1px rgba(43,166,203,.5)}.sticky-container{position:relative}.sticky{position:absolute;z-index:0;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.sticky.is-stuck{position:fixed;z-index:5}.sticky.is-stuck.is-at-top{top:0}.sticky.is-stuck.is-at-bottom{bottom:0}.sticky.is-anchored{position:absolute;left:auto;right:auto}.sticky.is-anchored.is-at-bottom{bottom:0}.column,.columns{-ms-flex:1 1 0px;flex:1 1 0px;padding-left:.9375rem;padding-right:.9375rem;min-width:initial}.column.row.row,.row.row.columns{float:none;display:block}.row .column.row.row,.row .row.row.columns{padding-left:0;padding-right:0;margin-left:0;margin-right:0}.small-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.small-offset-0{margin-left:0}.small-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.small-offset-1{margin-left:8.33333%}.small-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.small-offset-2{margin-left:16.66667%}.small-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.small-offset-3{margin-left:25%}.small-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.small-offset-4{margin-left:33.33333%}.small-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.small-offset-5{margin-left:41.66667%}.small-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.small-offset-6{margin-left:50%}.small-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.small-offset-7{margin-left:58.33333%}.small-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.small-offset-8{margin-left:66.66667%}.small-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.small-offset-9{margin-left:75%}.small-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.small-offset-10{margin-left:83.33333%}.small-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.small-offset-11{margin-left:91.66667%}.small-up-1{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-1>.column,.small-up-1>.columns{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.small-up-2{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-2>.column,.small-up-2>.columns{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.small-up-3{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-3>.column,.small-up-3>.columns{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.small-up-4{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-4>.column,.small-up-4>.columns{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.small-up-5{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-5>.column,.small-up-5>.columns{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.small-up-6{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-6>.column,.small-up-6>.columns{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.small-up-7{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-7>.column,.small-up-7>.columns{-ms-flex:0 0 14.28571%;flex:0 0 14.28571%;max-width:14.28571%}.small-up-8{-ms-flex-wrap:wrap;flex-wrap:wrap}.small-up-8>.column,.small-up-8>.columns{-ms-flex:0 0 12.5%;flex:0 0 12.5%;max-width:12.5%}.small-collapse>.column,.small-collapse>.columns{padding-left:0;padding-right:0}.small-uncollapse>.column,.small-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}@media screen and (min-width:40em){.medium-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.medium-offset-0{margin-left:0}.medium-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.medium-offset-1{margin-left:8.33333%}.medium-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.medium-offset-2{margin-left:16.66667%}.medium-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.medium-offset-3{margin-left:25%}.medium-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.medium-offset-4{margin-left:33.33333%}.medium-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.medium-offset-5{margin-left:41.66667%}.medium-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.medium-offset-6{margin-left:50%}.medium-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.medium-offset-7{margin-left:58.33333%}.medium-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.medium-offset-8{margin-left:66.66667%}.medium-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.medium-offset-9{margin-left:75%}.medium-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.medium-offset-10{margin-left:83.33333%}.medium-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.medium-offset-11{margin-left:91.66667%}.medium-order-1{-ms-flex-order:1;order:1}.medium-order-2{-ms-flex-order:2;order:2}.medium-order-3{-ms-flex-order:3;order:3}.medium-order-4{-ms-flex-order:4;order:4}.medium-order-5{-ms-flex-order:5;order:5}.medium-order-6{-ms-flex-order:6;order:6}.medium-up-1{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-1>.column,.medium-up-1>.columns{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.medium-up-2{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-2>.column,.medium-up-2>.columns{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.medium-up-3{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-3>.column,.medium-up-3>.columns{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.medium-up-4{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-4>.column,.medium-up-4>.columns{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.medium-up-5{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-5>.column,.medium-up-5>.columns{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.medium-up-6{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-6>.column,.medium-up-6>.columns{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.medium-up-7{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-7>.column,.medium-up-7>.columns{-ms-flex:0 0 14.28571%;flex:0 0 14.28571%;max-width:14.28571%}.medium-up-8{-ms-flex-wrap:wrap;flex-wrap:wrap}.medium-up-8>.column,.medium-up-8>.columns{-ms-flex:0 0 12.5%;flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:40em) and (min-width:40em){.medium-expand{-ms-flex:1 1 0px;flex:1 1 0px}}.row.medium-unstack>.column,.row.medium-unstack>.columns{-ms-flex:0 0 100%;flex:0 0 100%}@media screen and (min-width:40em){.row.medium-unstack>.column,.row.medium-unstack>.columns{-ms-flex:1 1 0px;flex:1 1 0px}}@media screen and (min-width:40em){.medium-collapse>.column,.medium-collapse>.columns{padding-left:0;padding-right:0}.medium-uncollapse>.column,.medium-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}@media screen and (min-width:64em){.large-1{-ms-flex:0 0 8.33333%;flex:0 0 8.33333%;max-width:8.33333%}.large-offset-0{margin-left:0}.large-2{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.large-offset-1{margin-left:8.33333%}.large-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.large-offset-2{margin-left:16.66667%}.large-4{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.large-offset-3{margin-left:25%}.large-5{-ms-flex:0 0 41.66667%;flex:0 0 41.66667%;max-width:41.66667%}.large-offset-4{margin-left:33.33333%}.large-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.large-offset-5{margin-left:41.66667%}.large-7{-ms-flex:0 0 58.33333%;flex:0 0 58.33333%;max-width:58.33333%}.large-offset-6{margin-left:50%}.large-8{-ms-flex:0 0 66.66667%;flex:0 0 66.66667%;max-width:66.66667%}.large-offset-7{margin-left:58.33333%}.large-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.large-offset-8{margin-left:66.66667%}.large-10{-ms-flex:0 0 83.33333%;flex:0 0 83.33333%;max-width:83.33333%}.large-offset-9{margin-left:75%}.large-11{-ms-flex:0 0 91.66667%;flex:0 0 91.66667%;max-width:91.66667%}.large-offset-10{margin-left:83.33333%}.large-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.large-offset-11{margin-left:91.66667%}.large-order-1{-ms-flex-order:1;order:1}.large-order-2{-ms-flex-order:2;order:2}.large-order-3{-ms-flex-order:3;order:3}.large-order-4{-ms-flex-order:4;order:4}.large-order-5{-ms-flex-order:5;order:5}.large-order-6{-ms-flex-order:6;order:6}.large-up-1{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-1>.column,.large-up-1>.columns{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.large-up-2{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-2>.column,.large-up-2>.columns{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.large-up-3{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-3>.column,.large-up-3>.columns{-ms-flex:0 0 33.33333%;flex:0 0 33.33333%;max-width:33.33333%}.large-up-4{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-4>.column,.large-up-4>.columns{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.large-up-5{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-5>.column,.large-up-5>.columns{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.large-up-6{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-6>.column,.large-up-6>.columns{-ms-flex:0 0 16.66667%;flex:0 0 16.66667%;max-width:16.66667%}.large-up-7{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-7>.column,.large-up-7>.columns{-ms-flex:0 0 14.28571%;flex:0 0 14.28571%;max-width:14.28571%}.large-up-8{-ms-flex-wrap:wrap;flex-wrap:wrap}.large-up-8>.column,.large-up-8>.columns{-ms-flex:0 0 12.5%;flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width:64em) and (min-width:64em){.large-expand{-ms-flex:1 1 0px;flex:1 1 0px}}.row.large-unstack>.column,.row.large-unstack>.columns{-ms-flex:0 0 100%;flex:0 0 100%}@media screen and (min-width:64em){.row.large-unstack>.column,.row.large-unstack>.columns{-ms-flex:1 1 0px;flex:1 1 0px}}@media screen and (min-width:64em){.large-collapse>.column,.large-collapse>.columns{padding-left:0;padding-right:0}.large-uncollapse>.column,.large-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}.shrink{-ms-flex:0 0 auto;flex:0 0 auto;max-width:100%}.align-top.columns,.column.align-top{-ms-flex-item-align:start;align-self:flex-start}.align-bottom.columns,.column.align-bottom{-ms-flex-item-align:end;align-self:flex-end}.align-middle.columns,.column.align-middle{-ms-flex-item-align:center;align-self:center}.align-stretch.columns,.column.align-stretch{-ms-flex-item-align:stretch;align-self:stretch}.align-right{-ms-flex-pack:end;justify-content:flex-end}.align-center{-ms-flex-pack:center;justify-content:center}.align-justify{-ms-flex-pack:justify;justify-content:space-between}.align-spaced{-ms-flex-pack:distribute;justify-content:space-around}.align-top{-ms-flex-align:start;align-items:flex-start}.align-self-top{-ms-flex-item-align:start;align-self:flex-start}.align-bottom{-ms-flex-align:end;align-items:flex-end}.align-self-bottom{-ms-flex-item-align:end;align-self:flex-end}.align-middle{-ms-flex-align:center;align-items:center}.align-self-middle{-ms-flex-item-align:center;align-self:center}.align-stretch{-ms-flex-align:stretch;align-items:stretch}.align-self-stretch{-ms-flex-item-align:stretch;align-self:stretch}.small-order-1{-ms-flex-order:1;order:1}.small-order-2{-ms-flex-order:2;order:2}.small-order-3{-ms-flex-order:3;order:3}.small-order-4{-ms-flex-order:4;order:4}.small-order-5{-ms-flex-order:5;order:5}.small-order-6{-ms-flex-order:6;order:6}@media screen and (min-width:40em){.medium-order-1{-ms-flex-order:1;order:1}.medium-order-2{-ms-flex-order:2;order:2}.medium-order-3{-ms-flex-order:3;order:3}.medium-order-4{-ms-flex-order:4;order:4}.medium-order-5{-ms-flex-order:5;order:5}.medium-order-6{-ms-flex-order:6;order:6}}@media screen and (min-width:64em){.large-order-1{-ms-flex-order:1;order:1}.large-order-2{-ms-flex-order:2;order:2}.large-order-3{-ms-flex-order:3;order:3}.large-order-4{-ms-flex-order:4;order:4}.large-order-5{-ms-flex-order:5;order:5}.large-order-6{-ms-flex-order:6;order:6}}.menu-icon{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:1pc}.menu-icon:after{content:'';position:absolute;display:block;width:100%;height:2px;background:#fefefe;top:0;left:0;box-shadow:0 7px 0 #fefefe,0 14px 0 #fefefe}.menu-icon:hover:after{background:#cacaca;box-shadow:0 7px 0 #cacaca,0 14px 0 #cacaca}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:1pc}.menu-icon.dark:after{content:'';position:absolute;display:block;width:100%;height:2px;background:#0a0a0a;top:0;left:0;box-shadow:0 7px 0 #0a0a0a,0 14px 0 #0a0a0a}.menu-icon.dark:hover:after{background:#8a8a8a;box-shadow:0 7px 0 #8a8a8a,0 14px 0 #8a8a8a}.slide-in-down.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateY(-100%);transform:translateY(-100%);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-in-down.mui-enter.mui-enter-active{-webkit-transform:translateY(0);transform:translateY(0)}.slide-in-left.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateX(-100%);transform:translateX(-100%);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-in-left.mui-enter.mui-enter-active{-webkit-transform:translateX(0);transform:translateX(0)}.slide-in-up.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateY(100%);transform:translateY(100%);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-in-up.mui-enter.mui-enter-active{-webkit-transform:translateY(0);transform:translateY(0)}.slide-in-right.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateX(100%);transform:translateX(100%);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-in-right.mui-enter.mui-enter-active{-webkit-transform:translateX(0);transform:translateX(0)}.slide-out-down.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateY(0);transform:translateY(0);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-out-down.mui-leave.mui-leave-active{-webkit-transform:translateY(100%);transform:translateY(100%)}.slide-out-right.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateX(0);transform:translateX(0);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-out-right.mui-leave.mui-leave-active{-webkit-transform:translateX(100%);transform:translateX(100%)}.slide-out-up.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateY(0);transform:translateY(0);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-out-up.mui-leave.mui-leave-active{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.slide-out-left.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:translateX(0);transform:translateX(0);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-backface-visibility:hidden;backface-visibility:hidden}.slide-out-left.mui-leave.mui-leave-active{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.fade-in.mui-enter{transition-duration:.5s;transition-timing-function:linear;opacity:0;transition-property:opacity}.fade-in.mui-enter.mui-enter-active{opacity:1}.fade-out.mui-leave{transition-duration:.5s;transition-timing-function:linear;opacity:1;transition-property:opacity}.fade-out.mui-leave.mui-leave-active{opacity:0}.hinge-in-from-top.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateX(-90deg);transform:perspective(2000px) rotateX(-90deg);-webkit-transform-origin:top;transform-origin:top;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-top.mui-enter.mui-enter-active{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-in-from-right.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateY(-90deg);transform:perspective(2000px) rotateY(-90deg);-webkit-transform-origin:right;transform-origin:right;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-right.mui-enter.mui-enter-active{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-in-from-bottom.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateX(90deg);transform:perspective(2000px) rotateX(90deg);-webkit-transform-origin:bottom;transform-origin:bottom;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-bottom.mui-enter.mui-enter-active{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-in-from-left.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateY(90deg);transform:perspective(2000px) rotateY(90deg);-webkit-transform-origin:left;transform-origin:left;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-left.mui-enter.mui-enter-active{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-in-from-middle-x.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateX(-90deg);transform:perspective(2000px) rotateX(-90deg);-webkit-transform-origin:center;transform-origin:center;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-middle-x.mui-enter.mui-enter-active{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-in-from-middle-y.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotateY(-90deg);transform:perspective(2000px) rotateY(-90deg);-webkit-transform-origin:center;transform-origin:center;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.hinge-in-from-middle-y.mui-enter.mui-enter-active,.hinge-out-from-top.mui-leave{-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);opacity:1}.hinge-out-from-top.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform-origin:top;transform-origin:top;transition-property:-webkit-transform,opacity;transition-property:transform,opacity}.hinge-out-from-top.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateX(-90deg);transform:perspective(2000px) rotateX(-90deg);opacity:0}.hinge-out-from-right.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);-webkit-transform-origin:right;transform-origin:right;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.hinge-out-from-right.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateY(-90deg);transform:perspective(2000px) rotateY(-90deg);opacity:0}.hinge-out-from-bottom.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);-webkit-transform-origin:bottom;transform-origin:bottom;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.hinge-out-from-bottom.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateX(90deg);transform:perspective(2000px) rotateX(90deg);opacity:0}.hinge-out-from-left.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);-webkit-transform-origin:left;transform-origin:left;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.hinge-out-from-left.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateY(90deg);transform:perspective(2000px) rotateY(90deg);opacity:0}.hinge-out-from-middle-x.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);-webkit-transform-origin:center;transform-origin:center;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.hinge-out-from-middle-x.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateX(-90deg);transform:perspective(2000px) rotateX(-90deg);opacity:0}.hinge-out-from-middle-y.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:perspective(2000px) rotate(0deg);transform:perspective(2000px) rotate(0deg);-webkit-transform-origin:center;transform-origin:center;transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.hinge-out-from-middle-y.mui-leave.mui-leave-active{-webkit-transform:perspective(2000px) rotateY(-90deg);transform:perspective(2000px) rotateY(-90deg);opacity:0}.scale-in-up.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:scale(0.5);transform:scale(0.5);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.scale-in-up.mui-enter.mui-enter-active{-webkit-transform:scale(1);transform:scale(1);opacity:1}.scale-in-down.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:scale(1.5);transform:scale(1.5);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.scale-in-down.mui-enter.mui-enter-active,.scale-out-up.mui-leave{-webkit-transform:scale(1);transform:scale(1);opacity:1}.scale-out-up.mui-leave{transition-duration:.5s;transition-timing-function:linear;transition-property:-webkit-transform,opacity;transition-property:transform,opacity}.scale-out-up.mui-leave.mui-leave-active{-webkit-transform:scale(1.5);transform:scale(1.5);opacity:0}.scale-out-down.mui-leave{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:scale(1);transform:scale(1);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:1}.scale-out-down.mui-leave.mui-leave-active{-webkit-transform:scale(0.5);transform:scale(0.5);opacity:0}.spin-in.mui-enter{transition-duration:.5s;transition-timing-function:linear;-webkit-transform:rotate(-0.75turn);transform:rotate(-0.75turn);transition-property:-webkit-transform,opacity;transition-property:transform,opacity;opacity:0}.spin-in.mui-enter.mui-enter-active,.spin-out.mui-leave{-webkit-transform:rotate(0);transform:rotate(0);opacity:1}.spin-out.mui-leave{transition-duration:.5s;transition-timing-function:linear;transition-property:-webkit-transform,opacity;transition-property:transform,opacity}.spin-in-ccw.mui-enter,.spin-out.mui-leave.mui-leave-active{-webkit-transform:rotate(0.75turn);transform:rotate(0.75turn);opacity:0}.spin-in-ccw.mui-enter{transition-duration:.5s;transition-timing-function:linear;transition-property:-webkit-transform,opacity;transition-property:transform,opacity}.spin-in-ccw.mui-enter.mui-enter-active,.spin-out-ccw.mui-leave{-webkit-transform:rotate(0);transform:rotate(0);opacity:1}.spin-out-ccw.mui-leave{transition-duration:.5s;transition-timing-function:linear;transition-property:-webkit-transform,opacity;transition-property:transform,opacity}.spin-out-ccw.mui-leave.mui-leave-active{-webkit-transform:rotate(-0.75turn);transform:rotate(-0.75turn);opacity:0}.slow{transition-duration:.75s!important}.fast{transition-duration:.25s!important}.linear{transition-timing-function:linear!important}.ease{transition-timing-function:ease!important}.ease-in{transition-timing-function:ease-in!important}.ease-out{transition-timing-function:ease-out!important}.ease-in-out{transition-timing-function:ease-in-out!important}.bounce-in{transition-timing-function:cubic-bezier(0.485,0.155,0.24,1.245)!important}.bounce-out{transition-timing-function:cubic-bezier(0.485,0.155,0.515,0.845)!important}.bounce-in-out{transition-timing-function:cubic-bezier(0.76,-0.245,0.24,1.245)!important}.short-delay{transition-delay:.3s!important}.long-delay{transition-delay:.7s!important}.shake{-webkit-animation-name:shake-7;animation-name:shake-7}@-webkit-keyframes shake-7{0%,10%,20%,30%,40%,50%,60%,70%,80%,90%{-webkit-transform:translateX(7%);transform:translateX(7%)}5%,15%,25%,35%,45%,55%,65%,75%,85%,95%{-webkit-transform:translateX(-7%);transform:translateX(-7%)}}@keyframes shake-7{0%,10%,20%,30%,40%,50%,60%,70%,80%,90%{-webkit-transform:translateX(7%);transform:translateX(7%)}5%,15%,25%,35%,45%,55%,65%,75%,85%,95%{-webkit-transform:translateX(-7%);transform:translateX(-7%)}}.spin-cw{-webkit-animation-name:spin-cw-1turn;animation-name:spin-cw-1turn}@-webkit-keyframes spin-cw-1turn{0%{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}to{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes spin-cw-1turn{0%{-webkit-transform:rotate(-1turn);transform:rotate(-1turn)}to{-webkit-transform:rotate(0);transform:rotate(0)}}.spin-ccw{-webkit-animation-name:spin-cw-1turn;animation-name:spin-cw-1turn}@keyframes spin-cw-1turn{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.wiggle{-webkit-animation-name:wiggle-7deg;animation-name:wiggle-7deg}@-webkit-keyframes wiggle-7deg{40%,50%,60%{-webkit-transform:rotate(7deg);transform:rotate(7deg)}35%,45%,55%,65%{-webkit-transform:rotate(-7deg);transform:rotate(-7deg)}0%,30%,70%,to{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes wiggle-7deg{40%,50%,60%{-webkit-transform:rotate(7deg);transform:rotate(7deg)}35%,45%,55%,65%{-webkit-transform:rotate(-7deg);transform:rotate(-7deg)}0%,30%,70%,to{-webkit-transform:rotate(0);transform:rotate(0)}}.shake,.spin-ccw,.spin-cw,.wiggle{-webkit-animation-duration:.5s;animation-duration:.5s}.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.slow{-webkit-animation-duration:.75s!important;animation-duration:.75s!important}.fast{-webkit-animation-duration:.25s!important;animation-duration:.25s!important}.linear{-webkit-animation-timing-function:linear!important;animation-timing-function:linear!important}.ease{-webkit-animation-timing-function:ease!important;animation-timing-function:ease!important}.ease-in{-webkit-animation-timing-function:ease-in!important;animation-timing-function:ease-in!important}.ease-out{-webkit-animation-timing-function:ease-out!important;animation-timing-function:ease-out!important}.ease-in-out{-webkit-animation-timing-function:ease-in-out!important;animation-timing-function:ease-in-out!important}.bounce-in{-webkit-animation-timing-function:cubic-bezier(0.485,0.155,0.24,1.245)!important;animation-timing-function:cubic-bezier(0.485,0.155,0.24,1.245)!important}.bounce-out{-webkit-animation-timing-function:cubic-bezier(0.485,0.155,0.515,0.845)!important;animation-timing-function:cubic-bezier(0.485,0.155,0.515,0.845)!important}.bounce-in-out{-webkit-animation-timing-function:cubic-bezier(0.76,-0.245,0.24,1.245)!important;animation-timing-function:cubic-bezier(0.76,-0.245,0.24,1.245)!important}.short-delay{-webkit-animation-delay:.3s!important;animation-delay:.3s!important}.long-delay{-webkit-animation-delay:.7s!important;animation-delay:.7s!important}", ""]);
	
	// exports


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * cuid.js
	 * Collision-resistant UID generator for browsers and node.
	 * Sequential for fast db lookups and recency sorting.
	 * Safe for element IDs and server-side lookups.
	 *
	 * Extracted from CLCTR
	 *
	 * Copyright (c) Eric Elliott 2012
	 * MIT License
	 */
	
	/*global window, navigator, document, require, process, module */
	(function (app) {
	  'use strict';
	  var namespace = 'cuid',
	    c = 0,
	    blockSize = 4,
	    base = 36,
	    discreteValues = Math.pow(base, blockSize),
	
	    pad = function pad(num, size) {
	      var s = "000000000" + num;
	      return s.substr(s.length-size);
	    },
	
	    randomBlock = function randomBlock() {
	      return pad((Math.random() *
	            discreteValues << 0)
	            .toString(base), blockSize);
	    },
	
	    safeCounter = function () {
	      c = (c < discreteValues) ? c : 0;
	      c++; // this is not subliminal
	      return c - 1;
	    },
	
	    api = function cuid() {
	      // Starting with a lowercase letter makes
	      // it HTML element ID friendly.
	      var letter = 'c', // hard-coded allows for sequential access
	
	        // timestamp
	        // warning: this exposes the exact date and time
	        // that the uid was created.
	        timestamp = (new Date().getTime()).toString(base),
	
	        // Prevent same-machine collisions.
	        counter,
	
	        // A few chars to generate distinct ids for different
	        // clients (so different computers are far less
	        // likely to generate the same id)
	        fingerprint = api.fingerprint(),
	
	        // Grab some more chars from Math.random()
	        random = randomBlock() + randomBlock();
	
	        counter = pad(safeCounter().toString(base), blockSize);
	
	      return  (letter + timestamp + counter + fingerprint + random);
	    };
	
	  api.slug = function slug() {
	    var date = new Date().getTime().toString(36),
	      counter,
	      print = api.fingerprint().slice(0,1) +
	        api.fingerprint().slice(-1),
	      random = randomBlock().slice(-2);
	
	      counter = safeCounter().toString(36).slice(-4);
	
	    return date.slice(-2) +
	      counter + print + random;
	  };
	
	  api.globalCount = function globalCount() {
	    // We want to cache the results of this
	    var cache = (function calc() {
	        var i,
	          count = 0;
	
	        for (i in window) {
	          count++;
	        }
	
	        return count;
	      }());
	
	    api.globalCount = function () { return cache; };
	    return cache;
	  };
	
	  api.fingerprint = function browserPrint() {
	    return pad((navigator.mimeTypes.length +
	      navigator.userAgent.length).toString(36) +
	      api.globalCount().toString(36), 4);
	  };
	
	  // don't change anything from here down.
	  if (app.register) {
	    app.register(namespace, api);
	  } else if (true) {
	    module.exports = api;
	  } else {
	    app[namespace] = api;
	  }
	
	}(this.applitude || this));


/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = createHash
	
	function createHash(elem) {
	    var attributes = elem.attributes
	    var hash = {}
	
	    if (attributes === null || attributes === undefined) {
	        return hash
	    }
	
	    for (var i = 0; i < attributes.length; i++) {
	        var attr = attributes[i]
	
	        if (attr.name.substr(0,5) !== "data-") {
	            continue
	        }
	
	        hash[attr.name.substr(5)] = attr.value
	    }
	
	    return hash
	}


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	var hiddenStore = __webpack_require__(107);
	
	module.exports = createStore;
	
	function createStore() {
	    var key = {};
	
	    return function (obj) {
	        if (typeof obj !== 'object' || obj === null) {
	            throw new Error('Weakmap-shim: Key must be object')
	        }
	
	        var store = obj.valueOf(key);
	        return store && store.identity === key ?
	            store : hiddenStore(obj, key);
	    };
	}


/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = hiddenStore;
	
	function hiddenStore(obj, key) {
	    var store = { identity: key };
	    var valueOf = obj.valueOf;
	
	    Object.defineProperty(obj, "valueOf", {
	        value: function (value) {
	            return value !== key ?
	                valueOf.apply(this, arguments) : store;
	        },
	        writable: true
	    });
	
	    return store;
	}


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var EvStore = __webpack_require__(19)
	
	module.exports = addEvent
	
	function addEvent(target, type, handler) {
	    var events = EvStore(target)
	    var event = events[type]
	
	    if (!event) {
	        events[type] = handler
	    } else if (Array.isArray(event)) {
	        if (event.indexOf(handler) === -1) {
	            event.push(handler)
	        }
	    } else if (event !== handler) {
	        events[type] = [event, handler]
	    }
	}


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var globalDocument = __webpack_require__(14)
	var EvStore = __webpack_require__(19)
	var createStore = __webpack_require__(203)
	
	var addEvent = __webpack_require__(108)
	var removeEvent = __webpack_require__(111)
	var ProxyEvent = __webpack_require__(110)
	
	var HANDLER_STORE = createStore()
	
	module.exports = DOMDelegator
	
	function DOMDelegator(document) {
	    if (!(this instanceof DOMDelegator)) {
	        return new DOMDelegator(document);
	    }
	
	    document = document || globalDocument
	
	    this.target = document.documentElement
	    this.events = {}
	    this.rawEventListeners = {}
	    this.globalListeners = {}
	}
	
	DOMDelegator.prototype.addEventListener = addEvent
	DOMDelegator.prototype.removeEventListener = removeEvent
	
	DOMDelegator.allocateHandle =
	    function allocateHandle(func) {
	        var handle = new Handle()
	
	        HANDLER_STORE(handle).func = func;
	
	        return handle
	    }
	
	DOMDelegator.transformHandle =
	    function transformHandle(handle, broadcast) {
	        var func = HANDLER_STORE(handle).func
	
	        return this.allocateHandle(function (ev) {
	            broadcast(ev, func);
	        })
	    }
	
	DOMDelegator.prototype.addGlobalEventListener =
	    function addGlobalEventListener(eventName, fn) {
	        var listeners = this.globalListeners[eventName] || [];
	        if (listeners.indexOf(fn) === -1) {
	            listeners.push(fn)
	        }
	
	        this.globalListeners[eventName] = listeners;
	    }
	
	DOMDelegator.prototype.removeGlobalEventListener =
	    function removeGlobalEventListener(eventName, fn) {
	        var listeners = this.globalListeners[eventName] || [];
	
	        var index = listeners.indexOf(fn)
	        if (index !== -1) {
	            listeners.splice(index, 1)
	        }
	    }
	
	DOMDelegator.prototype.listenTo = function listenTo(eventName) {
	    if (!(eventName in this.events)) {
	        this.events[eventName] = 0;
	    }
	
	    this.events[eventName]++;
	
	    if (this.events[eventName] !== 1) {
	        return
	    }
	
	    var listener = this.rawEventListeners[eventName]
	    if (!listener) {
	        listener = this.rawEventListeners[eventName] =
	            createHandler(eventName, this)
	    }
	
	    this.target.addEventListener(eventName, listener, true)
	}
	
	DOMDelegator.prototype.unlistenTo = function unlistenTo(eventName) {
	    if (!(eventName in this.events)) {
	        this.events[eventName] = 0;
	    }
	
	    if (this.events[eventName] === 0) {
	        throw new Error("already unlistened to event.");
	    }
	
	    this.events[eventName]--;
	
	    if (this.events[eventName] !== 0) {
	        return
	    }
	
	    var listener = this.rawEventListeners[eventName]
	
	    if (!listener) {
	        throw new Error("dom-delegator#unlistenTo: cannot " +
	            "unlisten to " + eventName)
	    }
	
	    this.target.removeEventListener(eventName, listener, true)
	}
	
	function createHandler(eventName, delegator) {
	    var globalListeners = delegator.globalListeners;
	    var delegatorTarget = delegator.target;
	
	    return handler
	
	    function handler(ev) {
	        var globalHandlers = globalListeners[eventName] || []
	
	        if (globalHandlers.length > 0) {
	            var globalEvent = new ProxyEvent(ev);
	            globalEvent.currentTarget = delegatorTarget;
	            callListeners(globalHandlers, globalEvent)
	        }
	
	        findAndInvokeListeners(ev.target, ev, eventName)
	    }
	}
	
	function findAndInvokeListeners(elem, ev, eventName) {
	    var listener = getListener(elem, eventName)
	
	    if (listener && listener.handlers.length > 0) {
	        var listenerEvent = new ProxyEvent(ev);
	        listenerEvent.currentTarget = listener.currentTarget
	        callListeners(listener.handlers, listenerEvent)
	
	        if (listenerEvent._bubbles) {
	            var nextTarget = listener.currentTarget.parentNode
	            findAndInvokeListeners(nextTarget, ev, eventName)
	        }
	    }
	}
	
	function getListener(target, type) {
	    // terminate recursion if parent is `null`
	    if (target === null || typeof target === "undefined") {
	        return null
	    }
	
	    var events = EvStore(target)
	    // fetch list of handler fns for this event
	    var handler = events[type]
	    var allHandler = events.event
	
	    if (!handler && !allHandler) {
	        return getListener(target.parentNode, type)
	    }
	
	    var handlers = [].concat(handler || [], allHandler || [])
	    return new Listener(target, handlers)
	}
	
	function callListeners(handlers, ev) {
	    handlers.forEach(function (handler) {
	        if (typeof handler === "function") {
	            handler(ev)
	        } else if (typeof handler.handleEvent === "function") {
	            handler.handleEvent(ev)
	        } else if (handler.type === "dom-delegator-handle") {
	            HANDLER_STORE(handler).func(ev)
	        } else {
	            throw new Error("dom-delegator: unknown handler " +
	                "found: " + JSON.stringify(handlers));
	        }
	    })
	}
	
	function Listener(target, handlers) {
	    this.currentTarget = target
	    this.handlers = handlers
	}
	
	function Handle() {
	    this.type = "dom-delegator-handle"
	}


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(137)
	
	var ALL_PROPS = [
	    "altKey", "bubbles", "cancelable", "ctrlKey",
	    "eventPhase", "metaKey", "relatedTarget", "shiftKey",
	    "target", "timeStamp", "type", "view", "which"
	]
	var KEY_PROPS = ["char", "charCode", "key", "keyCode"]
	var MOUSE_PROPS = [
	    "button", "buttons", "clientX", "clientY", "layerX",
	    "layerY", "offsetX", "offsetY", "pageX", "pageY",
	    "screenX", "screenY", "toElement"
	]
	
	var rkeyEvent = /^key|input/
	var rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/
	
	module.exports = ProxyEvent
	
	function ProxyEvent(ev) {
	    if (!(this instanceof ProxyEvent)) {
	        return new ProxyEvent(ev)
	    }
	
	    if (rkeyEvent.test(ev.type)) {
	        return new KeyEvent(ev)
	    } else if (rmouseEvent.test(ev.type)) {
	        return new MouseEvent(ev)
	    }
	
	    for (var i = 0; i < ALL_PROPS.length; i++) {
	        var propKey = ALL_PROPS[i]
	        this[propKey] = ev[propKey]
	    }
	
	    this._rawEvent = ev
	    this._bubbles = false;
	}
	
	ProxyEvent.prototype.preventDefault = function () {
	    this._rawEvent.preventDefault()
	}
	
	ProxyEvent.prototype.startPropagation = function () {
	    this._bubbles = true;
	}
	
	function MouseEvent(ev) {
	    for (var i = 0; i < ALL_PROPS.length; i++) {
	        var propKey = ALL_PROPS[i]
	        this[propKey] = ev[propKey]
	    }
	
	    for (var j = 0; j < MOUSE_PROPS.length; j++) {
	        var mousePropKey = MOUSE_PROPS[j]
	        this[mousePropKey] = ev[mousePropKey]
	    }
	
	    this._rawEvent = ev
	}
	
	inherits(MouseEvent, ProxyEvent)
	
	function KeyEvent(ev) {
	    for (var i = 0; i < ALL_PROPS.length; i++) {
	        var propKey = ALL_PROPS[i]
	        this[propKey] = ev[propKey]
	    }
	
	    for (var j = 0; j < KEY_PROPS.length; j++) {
	        var keyPropKey = KEY_PROPS[j]
	        this[keyPropKey] = ev[keyPropKey]
	    }
	
	    this._rawEvent = ev
	}
	
	inherits(KeyEvent, ProxyEvent)


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var EvStore = __webpack_require__(19)
	
	module.exports = removeEvent
	
	function removeEvent(target, type, handler) {
	    var events = EvStore(target)
	    var event = events[type]
	
	    if (!event) {
	        return
	    } else if (Array.isArray(event)) {
	        var index = event.indexOf(handler)
	        if (index !== -1) {
	            event.splice(index, 1)
	        }
	    } else if (event === handler) {
	        events[type] = null
	    }
	}


/***/ },
/* 112 */
/***/ function(module, exports) {

	var slice = Array.prototype.slice
	
	module.exports = iterativelyWalk
	
	function iterativelyWalk(nodes, cb) {
	    if (!('length' in nodes)) {
	        nodes = [nodes]
	    }
	    
	    nodes = slice.call(nodes)
	
	    while(nodes.length) {
	        var node = nodes.shift(),
	            ret = cb(node)
	
	        if (ret) {
	            return ret
	        }
	
	        if (node.childNodes && node.childNodes.length) {
	            nodes = slice.call(node.childNodes).concat(nodes)
	        }
	    }
	}


/***/ },
/* 113 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/*global window, global*/
	
	var root = typeof window !== 'undefined' ?
	    window : typeof global !== 'undefined' ?
	    global : {};
	
	module.exports = Individual;
	
	function Individual(key, value) {
	    if (key in root) {
	        return root[key];
	    }
	
	    root[key] = value;
	
	    return value;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Individual = __webpack_require__(113);
	
	module.exports = OneVersion;
	
	function OneVersion(moduleName, version, defaultValue) {
	    var key = '__INDIVIDUAL_ONE_VERSION_' + moduleName;
	    var enforceKey = key + '_ENFORCE_SINGLETON';
	
	    var versionValue = Individual(enforceKey, version);
	
	    if (versionValue !== version) {
	        throw new Error('Can only have one copy of ' +
	            moduleName + '.\n' +
	            'You already have version ' + versionValue +
	            ' installed.\n' +
	            'This means you cannot install version ' + version);
	    }
	
	    return Individual(key, defaultValue);
	}


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "871a2c71ef46fb4748b32715d0ff1e3f.gif";

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "94d6ef6e6f978dd644a808c9565957bc.png";

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a59443bc8af1eac976a77832a9648c8a.png";

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3219602c2491f93f07c9dcced6333216.png";

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "54105182047439ae4558d375b8823c4e.png";

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00ffe18609767fb2669cc21b5c6c9087.png";

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1826712c276dfe8f77aea35e79940feb.png";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "ff4b04297e5153041918cad923e6f343.png";

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "eb24b236d17048731476088e48c86dd5.png";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "acfeb68e9e02bb99d69166a55333f362.png";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "da303da5f607226ea5d0e30606a6cd6f.png";

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(169);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(132)();
	// imports
	
	
	// module
	exports.push([module.id, ".fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-fw{width:1.28571429em;text-align:center}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(127) + ");src:url(" + __webpack_require__(126) + "?#iefix&v=4.7.0) format('embedded-opentype'),url(" + __webpack_require__(170) + ") format('woff2'),url(" + __webpack_require__(171) + ") format('woff'),url(" + __webpack_require__(129) + ") format('truetype'),url(" + __webpack_require__(128) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1)\";-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1)\";-webkit-transform:scale(1,-1);transform:scale(1,-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}", ""]);
	
	// exports


/***/ },
/* 132 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 133 */
/***/ function(module, exports) {

	/*jshint maxcomplexity: 10*/
	
	module.exports = FormData
	
	//TODO: Massive spec: http://www.whatwg.org/specs/web-apps/current-work/multipage/association-of-controls-and-forms.html#constructing-form-data-set
	function FormData(elements) {
	    return Object.keys(elements).reduce(function (acc, key) {
	        var elem = elements[key]
	
	        acc[key] = valueOfElement(elem)
	
	        return acc
	    }, {})
	}
	
	function valueOfElement(elem) {
	    if (typeof elem === "function") {
	        return elem()
	    } else if (containsRadio(elem)) {
	        var elems = toList(elem)
	        var checked = elems.filter(function (elem) {
	            return elem.checked
	        })[0] || null
	
	        return checked ? checked.value : null
	    } else if (Array.isArray(elem)) {
	        return elem.map(valueOfElement).filter(filterNull)
	    } else if (elem.tagName === undefined && elem.nodeType === undefined) {
	        return FormData(elem)
	    } else if (elem.tagName === "INPUT" && isChecked(elem)) {
	        if (elem.hasAttribute("value")) {
	            return elem.checked ? elem.value : null
	        } else {
	            return elem.checked
	        }
	    } else if (elem.tagName === "INPUT") {
	        return elem.value
	    } else if (elem.tagName === "TEXTAREA") {
	        return elem.value
	    } else if (elem.tagName === "SELECT") {
	        return elem.value
	    }
	}
	
	function isChecked(elem) {
	    return elem.type === "checkbox" || elem.type === "radio"
	}
	
	function containsRadio(value) {
	    if (value.tagName || value.nodeType) {
	        return false
	    }
	
	    var elems = toList(value)
	
	    return elems.some(function (elem) {
	        return elem.tagName === "INPUT" && elem.type === "radio"
	    })
	}
	
	function toList(value) {
	    if (Array.isArray(value)) {
	        return value
	    }
	
	    return Object.keys(value).map(prop, value)
	}
	
	function prop(x) {
	    return this[x]
	}
	
	function filterNull(val) {
	    return val !== null
	}


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var event = __webpack_require__(45)
	
	module.exports = multiple
	
	function multiple(names) {
	    return names.reduce(function (acc, name) {
	        acc[name] = event()
	        return acc
	    }, {})
	}


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var Event = __webpack_require__(44)
	
	module.exports = Source
	
	function Source(broadcaster) {
	    var tuple = Event()
	
	    broadcaster(tuple.broadcast)
	
	    return tuple.listen
	}


/***/ },
/* 136 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {if (typeof window !== "undefined") {
	    module.exports = window;
	} else if (typeof global !== "undefined") {
	    module.exports = global;
	} else if (typeof self !== "undefined"){
	    module.exports = self;
	} else {
	    module.exports = {};
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 137 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var raf = __webpack_require__(159)
	var TypedError = __webpack_require__(43)
	
	var InvalidUpdateInRender = TypedError({
	    type: "main-loop.invalid.update.in-render",
	    message: "main-loop: Unexpected update occurred in loop.\n" +
	        "We are currently rendering a view, " +
	            "you can't change state right now.\n" +
	        "The diff is: {stringDiff}.\n" +
	        "SUGGESTED FIX: find the state mutation in your view " +
	            "or rendering function and remove it.\n" +
	        "The view should not have any side effects.\n" +
	        "This may also have happened if rendering did not complete due to an error.\n",
	    diff: null,
	    stringDiff: null
	})
	
	module.exports = main
	
	function main(initialState, view, opts) {
	    opts = opts || {}
	
	    var currentState = initialState
	    var create = opts.create
	    var diff = opts.diff
	    var patch = opts.patch
	    var redrawScheduled = false
	
	    var tree = opts.initialTree || view(currentState, 0);
	    var target = opts.target || create(tree, opts)
	    var inRenderingTransaction = false
	
	    currentState = null
	
	    var loop = {
	        state: initialState,
	        target: target,
	        update: update
	    }
	    return loop
	
	    function update(state) {
	        if (inRenderingTransaction) {
	            throw InvalidUpdateInRender({
	                diff: state._diff,
	                stringDiff: JSON.stringify(state._diff)
	            })
	        }
	
	        if (currentState === null && !redrawScheduled) {
	            redrawScheduled = true
	            raf(redraw)
	        }
	
	        currentState = state
	        loop.state = state
	    }
	
	    function redraw(time) {
	        redrawScheduled = false
	        if (currentState === null) {
	            return
	        }
	
	        inRenderingTransaction = true
	        var newTree = view(currentState, time)
	
	        if (opts.createOnly) {
	            inRenderingTransaction = false
	            create(newTree, opts)
	        } else {
	            var patches = diff(tree, newTree, opts)
	            inRenderingTransaction = false
	            target = patch(target, patches, opts)
	        }
	
	        tree = newTree
	        currentState = null
	    }
	}


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var h = __webpack_require__(22);
	var clickEvent = __webpack_require__(141);
	
	var routeAtom = __webpack_require__(48).atom;
	
	module.exports = anchor;
	
	function anchor(props, text) {
	    props['ev-click'] = clickEvent(pushState, {
	        ctrl: false,
	        meta: false,
	        rightClick: false
	    });
	
	    return h('a', props, text);
	
	    function pushState() {
	        routeAtom.set(props.href);
	    }
	}


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var router = __webpack_require__(48);
	var routeView = __webpack_require__(142);
	
	function RouterComponent(channels_map) {
	    return router(channels_map).state;
	}
	
	function Render(state, opts) {
	    return routeView(opts, state);
	}
	
	RouterComponent.go = router.atom.set;
	RouterComponent.anchor = __webpack_require__(139);
	RouterComponent.render = Render;
	
	module.exports = RouterComponent;


/***/ },
/* 141 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = clickEvent;
	
	function clickEvent(handler, opts) {
	    opts = opts || {};
	
	    return function clickHandler(ev) {
	        ev.preventDefault();
	
	        if (!opts.ctrl && ev.ctrlKey) {
	            return;
	        }
	
	        if (!opts.meta && ev.metaKey) {
	            return;
	        }
	
	        if (!opts.rightClick && ev.which === 2) {
	            return;
	        }
	
	        handler();
	    };
	}


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var routeMap = __webpack_require__(53);
	
	module.exports = routeView;
	
	function routeView(defn, args) {
	    if (args.base) {
	        defn = Object.keys(defn)
	            .reduce(function applyBase(acc, str) {
	                acc[args.base + str] = defn[str];
	                return acc;
	            }, {});
	    }
	
	    var match = routeMap(defn);
	
	    var res = match(args.route);
	    if (!res) {
	        throw new Error('router: no match found');
	    }
	
	    res.params.url = res.url;
	    return res.fn(res.params);
	}


/***/ },
/* 143 */
/***/ function(module, exports) {

	module.exports = extend
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var ObservArray = __webpack_require__(51)
	
	var slice = Array.prototype.slice
	
	var ARRAY_METHODS = [
	    "concat", "slice", "every", "filter", "forEach", "indexOf",
	    "join", "lastIndexOf", "map", "reduce", "reduceRight",
	    "some", "toString", "toLocaleString"
	]
	
	var methods = ARRAY_METHODS.map(function (name) {
	    return [name, function () {
	        var res = this._list[name].apply(this._list, arguments)
	
	        if (res && Array.isArray(res)) {
	            res = ObservArray(res)
	        }
	
	        return res
	    }]
	})
	
	module.exports = ArrayMethods
	
	function ArrayMethods(obs) {
	    obs.push = observArrayPush
	    obs.pop = observArrayPop
	    obs.shift = observArrayShift
	    obs.unshift = observArrayUnshift
	    obs.reverse = __webpack_require__(145)
	    obs.sort = __webpack_require__(146)
	
	    methods.forEach(function (tuple) {
	        obs[tuple[0]] = tuple[1]
	    })
	    return obs
	}
	
	
	
	function observArrayPush() {
	    var args = slice.call(arguments)
	    args.unshift(this._list.length, 0)
	    this.splice.apply(this, args)
	
	    return this._list.length
	}
	function observArrayPop() {
	    return this.splice(this._list.length - 1, 1)[0]
	}
	function observArrayShift() {
	    return this.splice(0, 1)[0]
	}
	function observArrayUnshift() {
	    var args = slice.call(arguments)
	    args.unshift(0, 0)
	    this.splice.apply(this, args)
	
	    return this._list.length
	}
	
	
	function notImplemented() {
	    throw new Error("Pull request welcome")
	}


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var applyPatch = __webpack_require__(31)
	var setNonEnumerable = __webpack_require__(15)
	
	module.exports = reverse
	
	function reverse() {
	    var obs = this
	    var changes = fakeDiff(obs._list.slice().reverse())
	    var valueList = obs().slice().reverse()
	
	    var valueChanges = changes.map(applyPatch.bind(obs, valueList))
	
	    setNonEnumerable(valueList, "_diff", valueChanges)
	
	    obs._observSet(valueList)
	    return changes
	}
	
	function fakeDiff(arr) {
	    var _diff
	    var len = arr.length
	
	    if(len % 2) {
	        var midPoint = (len -1) / 2
	        var a = [0, midPoint].concat(arr.slice(0, midPoint))
	        var b = [midPoint +1, midPoint].concat(arr.slice(midPoint +1, len))
	        var _diff = [a, b]
	    } else {
	        _diff = [ [0, len].concat(arr) ]
	    }
	
	    return _diff
	}


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var applyPatch = __webpack_require__(31)
	var setNonEnumerable = __webpack_require__(15)
	
	module.exports = sort
	
	function sort(compare) {
	    var obs = this
	    var list = obs._list.slice()
	
	    var unpacked = unpack(list)
	
	    var sorted = unpacked
	            .map(function(it) { return it.val })
	            .sort(compare)
	
	    var packed = repack(sorted, unpacked)
	
	    //fake diff - for perf
	    //adiff on 10k items === ~3200ms
	    //fake on 10k items === ~110ms
	    var changes = [ [ 0, packed.length ].concat(packed) ]
	
	    var valueChanges = changes.map(applyPatch.bind(obs, sorted))
	
	    setNonEnumerable(sorted, "_diff", valueChanges)
	
	    obs._observSet(sorted)
	    return changes
	}
	
	function unpack(list) {
	    var unpacked = []
	    for(var i = 0; i < list.length; i++) {
	        unpacked.push({
	            val: ("function" == typeof list[i]) ? list[i]() : list[i],
	            obj: list[i]
	        })
	    }
	    return unpacked
	}
	
	function repack(sorted, unpacked) {
	    var packed = []
	
	    while(sorted.length) {
	        var s = sorted.shift()
	        var indx = indexOf(s, unpacked)
	        if(~indx) packed.push(unpacked.splice(indx, 1)[0].obj)
	    }
	
	    return packed
	}
	
	function indexOf(n, h) {
	    for(var i = 0; i < h.length; i++) {
	        if(n === h[i].val) return i
	    }
	    return -1
	}


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var addListener = __webpack_require__(21)
	var setNonEnumerable = __webpack_require__(15);
	
	module.exports = put
	
	// `obs.put` is a mutable implementation of `array[index] = value`
	// that mutates both `list` and the internal `valueList` that
	// is the current value of `obs` itself
	function put(index, value) {
	    var obs = this
	    var valueList = obs().slice()
	
	    var originalLength = valueList.length
	    valueList[index] = typeof value === "function" ? value() : value
	
	    obs._list[index] = value
	
	    // remove past value listener if was observ
	    var removeListener = obs._removeListeners[index]
	    if (removeListener){
	        removeListener()
	    }
	
	    // add listener to value if observ
	    obs._removeListeners[index] = typeof value === "function" ?
	        addListener(obs, value) :
	        null
	
	    // fake splice diff
	    var valueArgs = index < originalLength ? 
	        [index, 1, valueList[index]] :
	        [index, 0, valueList[index]]
	
	    setNonEnumerable(valueList, "_diff", [valueArgs])
	
	    obs._observSet(valueList)
	    return value
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var applyPatch = __webpack_require__(31)
	var setNonEnumerable = __webpack_require__(15)
	var adiff = __webpack_require__(73)
	
	module.exports = set
	
	function set(rawList) {
	    if (!Array.isArray(rawList)) rawList = []
	
	    var obs = this
	    var changes = adiff.diff(obs._list, rawList)
	    var valueList = obs().slice()
	
	    var valueChanges = changes.map(applyPatch.bind(obs, valueList))
	
	    setNonEnumerable(valueList, "_diff", valueChanges)
	
	    obs._observSet(valueList)
	    return changes
	}


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var slice = Array.prototype.slice
	
	var addListener = __webpack_require__(21)
	var setNonEnumerable = __webpack_require__(15);
	
	module.exports = splice
	
	// `obs.splice` is a mutable implementation of `splice()`
	// that mutates both `list` and the internal `valueList` that
	// is the current value of `obs` itself
	function splice(index, amount) {
	    var obs = this
	    var args = slice.call(arguments, 0)
	    var valueList = obs().slice()
	
	    // generate a list of args to mutate the internal
	    // list of only obs
	    var valueArgs = args.map(function (value, index) {
	        if (index === 0 || index === 1) {
	            return value
	        }
	
	        // must unpack observables that we are adding
	        return typeof value === "function" ? value() : value
	    })
	
	    valueList.splice.apply(valueList, valueArgs)
	    // we remove the observs that we remove
	    var removed = obs._list.splice.apply(obs._list, args)
	
	    var extraRemoveListeners = args.slice(2).map(function (observ) {
	        return typeof observ === "function" ?
	            addListener(obs, observ) :
	            null
	    })
	    extraRemoveListeners.unshift(args[0], args[1])
	    var removedListeners = obs._removeListeners.splice
	        .apply(obs._removeListeners, extraRemoveListeners)
	
	    removedListeners.forEach(function (removeObservListener) {
	        if (removeObservListener) {
	            removeObservListener()
	        }
	    })
	
	    setNonEnumerable(valueList, "_diff", [valueArgs])
	
	    obs._observSet(valueList)
	    return removed
	}


/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = transaction
	
	function transaction (func) {
	    var obs = this
	    var rawList = obs._list.slice()
	
	    if (func(rawList) !== false){ // allow cancel
	        return obs.set(rawList)
	    }
	
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var Observ = __webpack_require__(16)
	var extend = __webpack_require__(152)
	
	var NO_TRANSACTION = {}
	
	module.exports = ObservVarhash
	
	function ObservVarhash (hash, createValue) {
	  createValue = createValue || function (obj) { return obj }
	
	  var initialState = {}
	  var currentTransaction = NO_TRANSACTION
	  var nestedTransaction = NO_TRANSACTION
	
	  var obs = Observ(initialState)
	  setNonEnumerable(obs, '_removeListeners', {})
	
	  setNonEnumerable(obs, 'get', get.bind(obs))
	  setNonEnumerable(obs, 'put', put.bind(obs))
	  setNonEnumerable(obs, 'delete', del.bind(obs))
	
	  for (var key in hash) {
	    obs[key] = isFn(hash[key]) ? hash[key] : createValue(hash[key], key)
	
	    if (isFn(obs[key])) {
	      obs._removeListeners[key] = obs[key](watch(obs, key))
	    }
	  }
	
	  var _set = obs.set
	
	  obs.set = function trackDiff (value) {
	    if (currentTransaction === value) {
	      return _set(value)
	    }
	
	    var newState = extend(value)
	    setNonEnumerable(newState, '_diff', value)
	
	    _set(newState)
	  }
	  setNonEnumerable(obs, 'set', obs.set)
	
	  var newState = {}
	  for (key in hash) {
	    var observ = obs[key]
	    checkKey(key)
	    newState[key] = isFn(observ) ? observ() : observ
	  }
	  obs.set(newState)
	
	  obs(function (newState) {
	    if (currentTransaction === newState) {
	      return
	    }
	
	    for (var key in hash) {
	      var observ = hash[key]
	      var newObservValue = newState[key]
	
	      if (isFn(observ) && observ() !== newState[key]) {
	        nestedTransaction = newObservValue
	        observ.set(newState[key])
	        nestedTransaction = NO_TRANSACTION
	      }
	    }
	  })
	
	  function put (key, val) {
	    checkKey(key)
	
	    if (val === undefined) {
	      throw new Error('cannot varhash.put(key, undefined).')
	    }
	
	    var observ = isFn(val) ? val : createValue(val, key)
	    var state = extend(this())
	
	    state[key] = isFn(observ) ? observ() : observ
	
	    if (isFn(this._removeListeners[key])) {
	      this._removeListeners[key]()
	    }
	
	    this._removeListeners[key] = isFn(observ)
	      ? observ(watch(this, key)) : null
	
	    setNonEnumerable(state, '_diff', diff(key, state[key]))
	
	    this[key] = observ
	
	    currentTransaction = state
	    _set(state)
	    currentTransaction = NO_TRANSACTION
	
	    return this
	  }
	
	  function del (key) {
	    var state = extend(this())
	    if (isFn(this._removeListeners[key])) {
	      this._removeListeners[key]()
	    }
	
	    delete this._removeListeners[key]
	    delete state[key]
	    delete this[key]
	
	    setNonEnumerable(state, '_diff', diff(key, undefined))
	    _set(state)
	
	    return this
	  }
	
	  return obs
	
	  // processing
	  function watch (obs, key) {
	    return function (value) {
	      if (nestedTransaction === value) {
	        return
	      }
	
	      var state = extend(obs())
	      state[key] = value
	
	      setNonEnumerable(state, '_diff', diff(key, value))
	
	      currentTransaction = state
	      obs.set(state)
	      currentTransaction = NO_TRANSACTION
	    }
	  }
	}
	
	// access and mutate
	function get (key) {
	  return this[key]
	}
	
	function diff (key, value) {
	  var obj = {}
	  obj[key] = value && value._diff ? value._diff : value
	  return obj
	}
	
	function isFn (obj) {
	  return typeof obj === 'function'
	}
	
	function setNonEnumerable (object, key, value) {
	  Object.defineProperty(object, key, {
	    value: value,
	    writable: true,
	    configurable: true,
	    enumerable: false
	  })
	}
	
	// errors
	var blacklist = {
	  name: 'Clashes with `Function.prototype.name`.',
	  get: 'get is a reserved key of observ-varhash method',
	  put: 'put is a reserved key of observ-varhash method',
	  'delete': 'delete is a reserved key of observ-varhash method',
	  _diff: '_diff is a reserved key of observ-varhash method',
	  _removeListeners: '_removeListeners is a reserved key of observ-varhash'
	}
	
	function checkKey (key) {
	  if (!blacklist[key]) return
	  throw new Error(
	    'cannot create an observ-varhash with key `' + key + '`. ' + blacklist[key]
	  )
	}


/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = extend
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var Observable = __webpack_require__(16)
	
	module.exports = computed
	
	function computed(observables, lambda) {
	    var values = observables.map(function (o) {
	        return o()
	    })
	    var result = Observable(lambda.apply(null, values))
	
	    observables.forEach(function (o, index) {
	        o(function (newValue) {
	            values[index] = newValue
	            result.set(lambda.apply(null, values))
	        })
	    })
	
	    return result
	}


/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = watch
	
	function watch(observable, listener) {
	    var remove = observable(listener)
	    listener(observable())
	    return remove
	}


/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Expose `pathtoRegexp`.
	 */
	
	module.exports = pathtoRegexp;
	
	/**
	 * Normalize the given path string,
	 * returning a regular expression.
	 *
	 * An empty array should be passed,
	 * which will contain the placeholder
	 * key names. For example "/user/:id" will
	 * then contain ["id"].
	 *
	 * @param  {String|RegExp|Array} path
	 * @param  {Array} keys
	 * @param  {Object} options
	 * @return {RegExp}
	 * @api private
	 */
	
	function pathtoRegexp(path, keys, options) {
	  options = options || {};
	  var sensitive = options.sensitive;
	  var strict = options.strict;
	  keys = keys || [];
	
	  if (path instanceof RegExp) return path;
	  if (path instanceof Array) path = '(' + path.join('|') + ')';
	
	  path = path
	    .concat(strict ? '' : '/?')
	    .replace(/\/\(/g, '(?:/')
	    .replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?(\*)?/g, function(_, slash, format, key, capture, optional, star){
	      keys.push({ name: key, optional: !! optional });
	      slash = slash || '';
	      return ''
	        + (optional ? '' : slash)
	        + '(?:'
	        + (optional ? slash : '')
	        + (format || '') + (capture || (format && '([^/.]+?)' || '([^/]+?)')) + ')'
	        + (optional || '')
	        + (star ? '(/*)?' : '');
	    })
	    .replace(/([\/.])/g, '\\$1')
	    .replace(/\*/g, '(.*)');
	
	  return new RegExp('^' + path + '$', sensitive ? '' : 'i');
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.6.3
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/*
	//@ sourceMappingURL=performance-now.map
	*/
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ },
/* 157 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 158 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var now = __webpack_require__(156)
	  , global = typeof window === 'undefined' ? {} : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = global['request' + suffix]
	  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
	  , isNative = true
	
	for(var i = 0; i < vendors.length && !raf; i++) {
	  raf = global[vendors[i] + 'Request' + suffix]
	  caf = global[vendors[i] + 'Cancel' + suffix]
	      || global[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  isNative = false
	
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  if(!isNative) {
	    return raf.call(global, fn)
	  }
	  return raf.call(global, function() {
	    try{
	      fn.apply(this, arguments)
	    } catch(e) {
	      setTimeout(function() { throw e }, 0)
	    }
	  })
	}
	module.exports.cancel = function() {
	  caf.apply(global, arguments)
	}


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(72)))

/***/ },
/* 161 */
/***/ function(module, exports) {

	var nargs = /\{([0-9a-zA-Z]+)\}/g
	var slice = Array.prototype.slice
	
	module.exports = template
	
	function template(string) {
	    var args
	
	    if (arguments.length === 2 && typeof arguments[1] === "object") {
	        args = arguments[1]
	    } else {
	        args = slice.call(arguments, 1)
	    }
	
	    if (!args || !args.hasOwnProperty) {
	        args = {}
	    }
	
	    return string.replace(nargs, function replaceArg(match, i, index) {
	        var result
	
	        if (string[index - 1] === "{" &&
	            string[index + match.length] === "}") {
	            return i
	        } else {
	            result = args.hasOwnProperty(i) ? args[i] : null
	            if (result === null || result === undefined) {
	                return ""
	            }
	
	            return result
	        }
	    })
	}


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./app.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./app.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(96);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./calendar.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./calendar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(97);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./carousel.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./carousel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./crosstab.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./crosstab.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(100);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./download.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./download.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./register.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./register.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(103);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./foundation.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./foundation.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(131);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./node_modules/css-loader/index.js!./../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js", function() {
				var newContent = require("!!./node_modules/css-loader/index.js!./../less-loader/index.js!./font-awesome-styles.loader.js!./font-awesome.config.js");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)(module), (function() { return this; }())))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(172);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(32);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 174 */
/***/ function(module, exports) {

	module.exports = hasKeys
	
	function hasKeys(source) {
	    return source !== null &&
	        (typeof source === "object" ||
	        typeof source === "function")
	}


/***/ },
/* 175 */
/***/ function(module, exports) {

	function Thunk(fn, args, key, eqArgs) {
	    this.fn = fn;
	    this.args = args;
	    this.key = key;
	    this.eqArgs = eqArgs;
	}
	
	Thunk.prototype.type = 'Thunk';
	Thunk.prototype.render = render;
	module.exports = Thunk;
	
	function shouldUpdate(current, previous) {
	    if (!current || !previous || current.fn !== previous.fn) {
	        return true;
	    }
	
	    var cargs = current.args;
	    var pargs = previous.args;
	
	    return !current.eqArgs(cargs, pargs);
	}
	
	function render(previous) {
	    if (shouldUpdate(this, previous)) {
	        return this.fn.apply(null, this.args);
	    } else {
	        return previous.vnode;
	    }
	}


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var Partial = __webpack_require__(177);
	
	module.exports = Partial();


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var shallowEq = __webpack_require__(178);
	var Thunk = __webpack_require__(175);
	
	module.exports = createPartial;
	
	function createPartial(eq) {
	    return function partial(fn) {
	        var args = copyOver(arguments, 1);
	        var firstArg = args[0];
	        var key;
	
	        var eqArgs = eq || shallowEq;
	
	        if (typeof firstArg === 'object' && firstArg !== null) {
	            if ('key' in firstArg) {
	                key = firstArg.key;
	            } else if ('id' in firstArg) {
	                key = firstArg.id;
	            }
	        }
	
	        return new Thunk(fn, args, key, eqArgs);
	    };
	}
	
	function copyOver(list, offset) {
	    var newList = [];
	    for (var i = list.length - 1; i >= offset; i--) {
	        newList[i - offset] = list[i];
	    }
	    return newList;
	}


/***/ },
/* 178 */
/***/ function(module, exports) {

	module.exports = shallowEq;
	
	function shallowEq(currentArgs, previousArgs) {
	    if (currentArgs.length === 0 && previousArgs.length === 0) {
	        return true;
	    }
	
	    if (currentArgs.length !== previousArgs.length) {
	        return false;
	    }
	
	    var len = currentArgs.length;
	
	    for (var i = 0; i < len; i++) {
	        if (currentArgs[i] !== previousArgs[i]) {
	            return false;
	        }
	    }
	
	    return true;
	}


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var createElement = __webpack_require__(34)
	
	module.exports = createElement


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var diff = __webpack_require__(67)
	
	module.exports = diff


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var h = __webpack_require__(22)
	
	module.exports = h


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var diff = __webpack_require__(180)
	var patch = __webpack_require__(183)
	var h = __webpack_require__(181)
	var create = __webpack_require__(179)
	var VNode = __webpack_require__(64)
	var VText = __webpack_require__(66)
	
	module.exports = {
	    diff: diff,
	    patch: patch,
	    h: h,
	    create: create,
	    VNode: VNode,
	    VText: VText
	}


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var patch = __webpack_require__(62)
	
	module.exports = patch


/***/ },
/* 184 */
/***/ function(module, exports) {

	// Maps a virtual DOM tree onto a real DOM tree in an efficient manner.
	// We don't want to read all of the DOM nodes in the tree so we use
	// the in-order tree indexing to eliminate recursion down certain branches.
	// We only recurse into a DOM node if we know that it contains a child of
	// interest.
	
	var noChild = {}
	
	module.exports = domIndex
	
	function domIndex(rootNode, tree, indices, nodes) {
	    if (!indices || indices.length === 0) {
	        return {}
	    } else {
	        indices.sort(ascending)
	        return recurse(rootNode, tree, indices, nodes, 0)
	    }
	}
	
	function recurse(rootNode, tree, indices, nodes, rootIndex) {
	    nodes = nodes || {}
	
	
	    if (rootNode) {
	        if (indexInRange(indices, rootIndex, rootIndex)) {
	            nodes[rootIndex] = rootNode
	        }
	
	        var vChildren = tree.children
	
	        if (vChildren) {
	
	            var childNodes = rootNode.childNodes
	
	            for (var i = 0; i < tree.children.length; i++) {
	                rootIndex += 1
	
	                var vChild = vChildren[i] || noChild
	                var nextIndex = rootIndex + (vChild.count || 0)
	
	                // skip recursion down the tree if there are no nodes down here
	                if (indexInRange(indices, rootIndex, nextIndex)) {
	                    recurse(childNodes[i], vChild, indices, nodes, rootIndex)
	                }
	
	                rootIndex = nextIndex
	            }
	        }
	    }
	
	    return nodes
	}
	
	// Binary search for an index in the interval [left, right]
	function indexInRange(indices, left, right) {
	    if (indices.length === 0) {
	        return false
	    }
	
	    var minIndex = 0
	    var maxIndex = indices.length - 1
	    var currentIndex
	    var currentItem
	
	    while (minIndex <= maxIndex) {
	        currentIndex = ((maxIndex + minIndex) / 2) >> 0
	        currentItem = indices[currentIndex]
	
	        if (minIndex === maxIndex) {
	            return currentItem >= left && currentItem <= right
	        } else if (currentItem < left) {
	            minIndex = currentIndex + 1
	        } else  if (currentItem > right) {
	            maxIndex = currentIndex - 1
	        } else {
	            return true
	        }
	    }
	
	    return false;
	}
	
	function ascending(a, b) {
	    return a > b ? 1 : -1
	}


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var applyProperties = __webpack_require__(61)
	
	var isWidget = __webpack_require__(13)
	var VPatch = __webpack_require__(65)
	
	var updateWidget = __webpack_require__(186)
	
	module.exports = applyPatch
	
	function applyPatch(vpatch, domNode, renderOptions) {
	    var type = vpatch.type
	    var vNode = vpatch.vNode
	    var patch = vpatch.patch
	
	    switch (type) {
	        case VPatch.REMOVE:
	            return removeNode(domNode, vNode)
	        case VPatch.INSERT:
	            return insertNode(domNode, patch, renderOptions)
	        case VPatch.VTEXT:
	            return stringPatch(domNode, vNode, patch, renderOptions)
	        case VPatch.WIDGET:
	            return widgetPatch(domNode, vNode, patch, renderOptions)
	        case VPatch.VNODE:
	            return vNodePatch(domNode, vNode, patch, renderOptions)
	        case VPatch.ORDER:
	            reorderChildren(domNode, patch)
	            return domNode
	        case VPatch.PROPS:
	            applyProperties(domNode, patch, vNode.properties)
	            return domNode
	        case VPatch.THUNK:
	            return replaceRoot(domNode,
	                renderOptions.patch(domNode, patch, renderOptions))
	        default:
	            return domNode
	    }
	}
	
	function removeNode(domNode, vNode) {
	    var parentNode = domNode.parentNode
	
	    if (parentNode) {
	        parentNode.removeChild(domNode)
	    }
	
	    destroyWidget(domNode, vNode);
	
	    return null
	}
	
	function insertNode(parentNode, vNode, renderOptions) {
	    var newNode = renderOptions.render(vNode, renderOptions)
	
	    if (parentNode) {
	        parentNode.appendChild(newNode)
	    }
	
	    return parentNode
	}
	
	function stringPatch(domNode, leftVNode, vText, renderOptions) {
	    var newNode
	
	    if (domNode.nodeType === 3) {
	        domNode.replaceData(0, domNode.length, vText.text)
	        newNode = domNode
	    } else {
	        var parentNode = domNode.parentNode
	        newNode = renderOptions.render(vText, renderOptions)
	
	        if (parentNode && newNode !== domNode) {
	            parentNode.replaceChild(newNode, domNode)
	        }
	    }
	
	    return newNode
	}
	
	function widgetPatch(domNode, leftVNode, widget, renderOptions) {
	    var updating = updateWidget(leftVNode, widget)
	    var newNode
	
	    if (updating) {
	        newNode = widget.update(leftVNode, domNode) || domNode
	    } else {
	        newNode = renderOptions.render(widget, renderOptions)
	    }
	
	    var parentNode = domNode.parentNode
	
	    if (parentNode && newNode !== domNode) {
	        parentNode.replaceChild(newNode, domNode)
	    }
	
	    if (!updating) {
	        destroyWidget(domNode, leftVNode)
	    }
	
	    return newNode
	}
	
	function vNodePatch(domNode, leftVNode, vNode, renderOptions) {
	    var parentNode = domNode.parentNode
	    var newNode = renderOptions.render(vNode, renderOptions)
	
	    if (parentNode && newNode !== domNode) {
	        parentNode.replaceChild(newNode, domNode)
	    }
	
	    return newNode
	}
	
	function destroyWidget(domNode, w) {
	    if (typeof w.destroy === "function" && isWidget(w)) {
	        w.destroy(domNode)
	    }
	}
	
	function reorderChildren(domNode, moves) {
	    var childNodes = domNode.childNodes
	    var keyMap = {}
	    var node
	    var remove
	    var insert
	
	    for (var i = 0; i < moves.removes.length; i++) {
	        remove = moves.removes[i]
	        node = childNodes[remove.from]
	        if (remove.key) {
	            keyMap[remove.key] = node
	        }
	        domNode.removeChild(node)
	    }
	
	    var length = childNodes.length
	    for (var j = 0; j < moves.inserts.length; j++) {
	        insert = moves.inserts[j]
	        node = keyMap[insert.key]
	        // this is the weirdest bug i've ever seen in webkit
	        domNode.insertBefore(node, insert.to >= length++ ? null : childNodes[insert.to])
	    }
	}
	
	function replaceRoot(oldRoot, newRoot) {
	    if (oldRoot && newRoot && oldRoot !== newRoot && oldRoot.parentNode) {
	        oldRoot.parentNode.replaceChild(newRoot, oldRoot)
	    }
	
	    return newRoot;
	}


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var isWidget = __webpack_require__(13)
	
	module.exports = updateWidget
	
	function updateWidget(a, b) {
	    if (isWidget(a) && isWidget(b)) {
	        if ("name" in a && "name" in b) {
	            return a.id === b.id
	        } else {
	            return a.init === b.init
	        }
	    }
	
	    return false
	}


/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = AttributeHook;
	
	function AttributeHook(namespace, value) {
	    if (!(this instanceof AttributeHook)) {
	        return new AttributeHook(namespace, value);
	    }
	
	    this.namespace = namespace;
	    this.value = value;
	}
	
	AttributeHook.prototype.hook = function (node, prop, prev) {
	    if (prev && prev.type === 'AttributeHook' &&
	        prev.value === this.value &&
	        prev.namespace === this.namespace) {
	        return;
	    }
	
	    node.setAttributeNS(this.namespace, prop, this.value);
	};
	
	AttributeHook.prototype.unhook = function (node, prop, next) {
	    if (next && next.type === 'AttributeHook' &&
	        next.namespace === this.namespace) {
	        return;
	    }
	
	    var colonPosition = prop.indexOf(':');
	    var localName = colonPosition > -1 ? prop.substr(colonPosition + 1) : prop;
	    node.removeAttributeNS(this.namespace, localName);
	};
	
	AttributeHook.prototype.type = 'AttributeHook';


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EvStore = __webpack_require__(19);
	
	module.exports = EvHook;
	
	function EvHook(value) {
	    if (!(this instanceof EvHook)) {
	        return new EvHook(value);
	    }
	
	    this.value = value;
	}
	
	EvHook.prototype.hook = function (node, propertyName) {
	    var es = EvStore(node);
	    var propName = propertyName.substr(3);
	
	    es[propName] = this.value;
	};
	
	EvHook.prototype.unhook = function(node, propertyName) {
	    var es = EvStore(node);
	    var propName = propertyName.substr(3);
	
	    es[propName] = undefined;
	};


/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = SoftSetHook;
	
	function SoftSetHook(value) {
	    if (!(this instanceof SoftSetHook)) {
	        return new SoftSetHook(value);
	    }
	
	    this.value = value;
	}
	
	SoftSetHook.prototype.hook = function (node, propertyName) {
	    if (node[propertyName] !== this.value) {
	        node[propertyName] = this.value;
	    }
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var split = __webpack_require__(91);
	
	var classIdSplit = /([\.#]?[a-zA-Z0-9\u007F-\uFFFF_:-]+)/;
	var notClassId = /^\.|#/;
	
	module.exports = parseTag;
	
	function parseTag(tag, props) {
	    if (!tag) {
	        return 'DIV';
	    }
	
	    var noId = !(props.hasOwnProperty('id'));
	
	    var tagParts = split(tag, classIdSplit);
	    var tagName = null;
	
	    if (notClassId.test(tagParts[1])) {
	        tagName = 'DIV';
	    }
	
	    var classes, part, type, i;
	
	    for (i = 0; i < tagParts.length; i++) {
	        part = tagParts[i];
	
	        if (!part) {
	            continue;
	        }
	
	        type = part.charAt(0);
	
	        if (!tagName) {
	            tagName = part;
	        } else if (type === '.') {
	            classes = classes || [];
	            classes.push(part.substring(1, part.length));
	        } else if (type === '#' && noId) {
	            props.id = part.substring(1, part.length);
	        }
	    }
	
	    if (classes) {
	        if (props.className) {
	            classes.push(props.className);
	        }
	
	        props.className = classes.join(' ');
	    }
	
	    return props.namespace ? tagName : tagName.toUpperCase();
	}


/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	var DEFAULT_NAMESPACE = null;
	var EV_NAMESPACE = 'http://www.w3.org/2001/xml-events';
	var XLINK_NAMESPACE = 'http://www.w3.org/1999/xlink';
	var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
	
	// http://www.w3.org/TR/SVGTiny12/attributeTable.html
	// http://www.w3.org/TR/SVG/attindex.html
	var SVG_PROPERTIES = {
	    'about': DEFAULT_NAMESPACE,
	    'accent-height': DEFAULT_NAMESPACE,
	    'accumulate': DEFAULT_NAMESPACE,
	    'additive': DEFAULT_NAMESPACE,
	    'alignment-baseline': DEFAULT_NAMESPACE,
	    'alphabetic': DEFAULT_NAMESPACE,
	    'amplitude': DEFAULT_NAMESPACE,
	    'arabic-form': DEFAULT_NAMESPACE,
	    'ascent': DEFAULT_NAMESPACE,
	    'attributeName': DEFAULT_NAMESPACE,
	    'attributeType': DEFAULT_NAMESPACE,
	    'azimuth': DEFAULT_NAMESPACE,
	    'bandwidth': DEFAULT_NAMESPACE,
	    'baseFrequency': DEFAULT_NAMESPACE,
	    'baseProfile': DEFAULT_NAMESPACE,
	    'baseline-shift': DEFAULT_NAMESPACE,
	    'bbox': DEFAULT_NAMESPACE,
	    'begin': DEFAULT_NAMESPACE,
	    'bias': DEFAULT_NAMESPACE,
	    'by': DEFAULT_NAMESPACE,
	    'calcMode': DEFAULT_NAMESPACE,
	    'cap-height': DEFAULT_NAMESPACE,
	    'class': DEFAULT_NAMESPACE,
	    'clip': DEFAULT_NAMESPACE,
	    'clip-path': DEFAULT_NAMESPACE,
	    'clip-rule': DEFAULT_NAMESPACE,
	    'clipPathUnits': DEFAULT_NAMESPACE,
	    'color': DEFAULT_NAMESPACE,
	    'color-interpolation': DEFAULT_NAMESPACE,
	    'color-interpolation-filters': DEFAULT_NAMESPACE,
	    'color-profile': DEFAULT_NAMESPACE,
	    'color-rendering': DEFAULT_NAMESPACE,
	    'content': DEFAULT_NAMESPACE,
	    'contentScriptType': DEFAULT_NAMESPACE,
	    'contentStyleType': DEFAULT_NAMESPACE,
	    'cursor': DEFAULT_NAMESPACE,
	    'cx': DEFAULT_NAMESPACE,
	    'cy': DEFAULT_NAMESPACE,
	    'd': DEFAULT_NAMESPACE,
	    'datatype': DEFAULT_NAMESPACE,
	    'defaultAction': DEFAULT_NAMESPACE,
	    'descent': DEFAULT_NAMESPACE,
	    'diffuseConstant': DEFAULT_NAMESPACE,
	    'direction': DEFAULT_NAMESPACE,
	    'display': DEFAULT_NAMESPACE,
	    'divisor': DEFAULT_NAMESPACE,
	    'dominant-baseline': DEFAULT_NAMESPACE,
	    'dur': DEFAULT_NAMESPACE,
	    'dx': DEFAULT_NAMESPACE,
	    'dy': DEFAULT_NAMESPACE,
	    'edgeMode': DEFAULT_NAMESPACE,
	    'editable': DEFAULT_NAMESPACE,
	    'elevation': DEFAULT_NAMESPACE,
	    'enable-background': DEFAULT_NAMESPACE,
	    'end': DEFAULT_NAMESPACE,
	    'ev:event': EV_NAMESPACE,
	    'event': DEFAULT_NAMESPACE,
	    'exponent': DEFAULT_NAMESPACE,
	    'externalResourcesRequired': DEFAULT_NAMESPACE,
	    'fill': DEFAULT_NAMESPACE,
	    'fill-opacity': DEFAULT_NAMESPACE,
	    'fill-rule': DEFAULT_NAMESPACE,
	    'filter': DEFAULT_NAMESPACE,
	    'filterRes': DEFAULT_NAMESPACE,
	    'filterUnits': DEFAULT_NAMESPACE,
	    'flood-color': DEFAULT_NAMESPACE,
	    'flood-opacity': DEFAULT_NAMESPACE,
	    'focusHighlight': DEFAULT_NAMESPACE,
	    'focusable': DEFAULT_NAMESPACE,
	    'font-family': DEFAULT_NAMESPACE,
	    'font-size': DEFAULT_NAMESPACE,
	    'font-size-adjust': DEFAULT_NAMESPACE,
	    'font-stretch': DEFAULT_NAMESPACE,
	    'font-style': DEFAULT_NAMESPACE,
	    'font-variant': DEFAULT_NAMESPACE,
	    'font-weight': DEFAULT_NAMESPACE,
	    'format': DEFAULT_NAMESPACE,
	    'from': DEFAULT_NAMESPACE,
	    'fx': DEFAULT_NAMESPACE,
	    'fy': DEFAULT_NAMESPACE,
	    'g1': DEFAULT_NAMESPACE,
	    'g2': DEFAULT_NAMESPACE,
	    'glyph-name': DEFAULT_NAMESPACE,
	    'glyph-orientation-horizontal': DEFAULT_NAMESPACE,
	    'glyph-orientation-vertical': DEFAULT_NAMESPACE,
	    'glyphRef': DEFAULT_NAMESPACE,
	    'gradientTransform': DEFAULT_NAMESPACE,
	    'gradientUnits': DEFAULT_NAMESPACE,
	    'handler': DEFAULT_NAMESPACE,
	    'hanging': DEFAULT_NAMESPACE,
	    'height': DEFAULT_NAMESPACE,
	    'horiz-adv-x': DEFAULT_NAMESPACE,
	    'horiz-origin-x': DEFAULT_NAMESPACE,
	    'horiz-origin-y': DEFAULT_NAMESPACE,
	    'id': DEFAULT_NAMESPACE,
	    'ideographic': DEFAULT_NAMESPACE,
	    'image-rendering': DEFAULT_NAMESPACE,
	    'in': DEFAULT_NAMESPACE,
	    'in2': DEFAULT_NAMESPACE,
	    'initialVisibility': DEFAULT_NAMESPACE,
	    'intercept': DEFAULT_NAMESPACE,
	    'k': DEFAULT_NAMESPACE,
	    'k1': DEFAULT_NAMESPACE,
	    'k2': DEFAULT_NAMESPACE,
	    'k3': DEFAULT_NAMESPACE,
	    'k4': DEFAULT_NAMESPACE,
	    'kernelMatrix': DEFAULT_NAMESPACE,
	    'kernelUnitLength': DEFAULT_NAMESPACE,
	    'kerning': DEFAULT_NAMESPACE,
	    'keyPoints': DEFAULT_NAMESPACE,
	    'keySplines': DEFAULT_NAMESPACE,
	    'keyTimes': DEFAULT_NAMESPACE,
	    'lang': DEFAULT_NAMESPACE,
	    'lengthAdjust': DEFAULT_NAMESPACE,
	    'letter-spacing': DEFAULT_NAMESPACE,
	    'lighting-color': DEFAULT_NAMESPACE,
	    'limitingConeAngle': DEFAULT_NAMESPACE,
	    'local': DEFAULT_NAMESPACE,
	    'marker-end': DEFAULT_NAMESPACE,
	    'marker-mid': DEFAULT_NAMESPACE,
	    'marker-start': DEFAULT_NAMESPACE,
	    'markerHeight': DEFAULT_NAMESPACE,
	    'markerUnits': DEFAULT_NAMESPACE,
	    'markerWidth': DEFAULT_NAMESPACE,
	    'mask': DEFAULT_NAMESPACE,
	    'maskContentUnits': DEFAULT_NAMESPACE,
	    'maskUnits': DEFAULT_NAMESPACE,
	    'mathematical': DEFAULT_NAMESPACE,
	    'max': DEFAULT_NAMESPACE,
	    'media': DEFAULT_NAMESPACE,
	    'mediaCharacterEncoding': DEFAULT_NAMESPACE,
	    'mediaContentEncodings': DEFAULT_NAMESPACE,
	    'mediaSize': DEFAULT_NAMESPACE,
	    'mediaTime': DEFAULT_NAMESPACE,
	    'method': DEFAULT_NAMESPACE,
	    'min': DEFAULT_NAMESPACE,
	    'mode': DEFAULT_NAMESPACE,
	    'name': DEFAULT_NAMESPACE,
	    'nav-down': DEFAULT_NAMESPACE,
	    'nav-down-left': DEFAULT_NAMESPACE,
	    'nav-down-right': DEFAULT_NAMESPACE,
	    'nav-left': DEFAULT_NAMESPACE,
	    'nav-next': DEFAULT_NAMESPACE,
	    'nav-prev': DEFAULT_NAMESPACE,
	    'nav-right': DEFAULT_NAMESPACE,
	    'nav-up': DEFAULT_NAMESPACE,
	    'nav-up-left': DEFAULT_NAMESPACE,
	    'nav-up-right': DEFAULT_NAMESPACE,
	    'numOctaves': DEFAULT_NAMESPACE,
	    'observer': DEFAULT_NAMESPACE,
	    'offset': DEFAULT_NAMESPACE,
	    'opacity': DEFAULT_NAMESPACE,
	    'operator': DEFAULT_NAMESPACE,
	    'order': DEFAULT_NAMESPACE,
	    'orient': DEFAULT_NAMESPACE,
	    'orientation': DEFAULT_NAMESPACE,
	    'origin': DEFAULT_NAMESPACE,
	    'overflow': DEFAULT_NAMESPACE,
	    'overlay': DEFAULT_NAMESPACE,
	    'overline-position': DEFAULT_NAMESPACE,
	    'overline-thickness': DEFAULT_NAMESPACE,
	    'panose-1': DEFAULT_NAMESPACE,
	    'path': DEFAULT_NAMESPACE,
	    'pathLength': DEFAULT_NAMESPACE,
	    'patternContentUnits': DEFAULT_NAMESPACE,
	    'patternTransform': DEFAULT_NAMESPACE,
	    'patternUnits': DEFAULT_NAMESPACE,
	    'phase': DEFAULT_NAMESPACE,
	    'playbackOrder': DEFAULT_NAMESPACE,
	    'pointer-events': DEFAULT_NAMESPACE,
	    'points': DEFAULT_NAMESPACE,
	    'pointsAtX': DEFAULT_NAMESPACE,
	    'pointsAtY': DEFAULT_NAMESPACE,
	    'pointsAtZ': DEFAULT_NAMESPACE,
	    'preserveAlpha': DEFAULT_NAMESPACE,
	    'preserveAspectRatio': DEFAULT_NAMESPACE,
	    'primitiveUnits': DEFAULT_NAMESPACE,
	    'propagate': DEFAULT_NAMESPACE,
	    'property': DEFAULT_NAMESPACE,
	    'r': DEFAULT_NAMESPACE,
	    'radius': DEFAULT_NAMESPACE,
	    'refX': DEFAULT_NAMESPACE,
	    'refY': DEFAULT_NAMESPACE,
	    'rel': DEFAULT_NAMESPACE,
	    'rendering-intent': DEFAULT_NAMESPACE,
	    'repeatCount': DEFAULT_NAMESPACE,
	    'repeatDur': DEFAULT_NAMESPACE,
	    'requiredExtensions': DEFAULT_NAMESPACE,
	    'requiredFeatures': DEFAULT_NAMESPACE,
	    'requiredFonts': DEFAULT_NAMESPACE,
	    'requiredFormats': DEFAULT_NAMESPACE,
	    'resource': DEFAULT_NAMESPACE,
	    'restart': DEFAULT_NAMESPACE,
	    'result': DEFAULT_NAMESPACE,
	    'rev': DEFAULT_NAMESPACE,
	    'role': DEFAULT_NAMESPACE,
	    'rotate': DEFAULT_NAMESPACE,
	    'rx': DEFAULT_NAMESPACE,
	    'ry': DEFAULT_NAMESPACE,
	    'scale': DEFAULT_NAMESPACE,
	    'seed': DEFAULT_NAMESPACE,
	    'shape-rendering': DEFAULT_NAMESPACE,
	    'slope': DEFAULT_NAMESPACE,
	    'snapshotTime': DEFAULT_NAMESPACE,
	    'spacing': DEFAULT_NAMESPACE,
	    'specularConstant': DEFAULT_NAMESPACE,
	    'specularExponent': DEFAULT_NAMESPACE,
	    'spreadMethod': DEFAULT_NAMESPACE,
	    'startOffset': DEFAULT_NAMESPACE,
	    'stdDeviation': DEFAULT_NAMESPACE,
	    'stemh': DEFAULT_NAMESPACE,
	    'stemv': DEFAULT_NAMESPACE,
	    'stitchTiles': DEFAULT_NAMESPACE,
	    'stop-color': DEFAULT_NAMESPACE,
	    'stop-opacity': DEFAULT_NAMESPACE,
	    'strikethrough-position': DEFAULT_NAMESPACE,
	    'strikethrough-thickness': DEFAULT_NAMESPACE,
	    'string': DEFAULT_NAMESPACE,
	    'stroke': DEFAULT_NAMESPACE,
	    'stroke-dasharray': DEFAULT_NAMESPACE,
	    'stroke-dashoffset': DEFAULT_NAMESPACE,
	    'stroke-linecap': DEFAULT_NAMESPACE,
	    'stroke-linejoin': DEFAULT_NAMESPACE,
	    'stroke-miterlimit': DEFAULT_NAMESPACE,
	    'stroke-opacity': DEFAULT_NAMESPACE,
	    'stroke-width': DEFAULT_NAMESPACE,
	    'surfaceScale': DEFAULT_NAMESPACE,
	    'syncBehavior': DEFAULT_NAMESPACE,
	    'syncBehaviorDefault': DEFAULT_NAMESPACE,
	    'syncMaster': DEFAULT_NAMESPACE,
	    'syncTolerance': DEFAULT_NAMESPACE,
	    'syncToleranceDefault': DEFAULT_NAMESPACE,
	    'systemLanguage': DEFAULT_NAMESPACE,
	    'tableValues': DEFAULT_NAMESPACE,
	    'target': DEFAULT_NAMESPACE,
	    'targetX': DEFAULT_NAMESPACE,
	    'targetY': DEFAULT_NAMESPACE,
	    'text-anchor': DEFAULT_NAMESPACE,
	    'text-decoration': DEFAULT_NAMESPACE,
	    'text-rendering': DEFAULT_NAMESPACE,
	    'textLength': DEFAULT_NAMESPACE,
	    'timelineBegin': DEFAULT_NAMESPACE,
	    'title': DEFAULT_NAMESPACE,
	    'to': DEFAULT_NAMESPACE,
	    'transform': DEFAULT_NAMESPACE,
	    'transformBehavior': DEFAULT_NAMESPACE,
	    'type': DEFAULT_NAMESPACE,
	    'typeof': DEFAULT_NAMESPACE,
	    'u1': DEFAULT_NAMESPACE,
	    'u2': DEFAULT_NAMESPACE,
	    'underline-position': DEFAULT_NAMESPACE,
	    'underline-thickness': DEFAULT_NAMESPACE,
	    'unicode': DEFAULT_NAMESPACE,
	    'unicode-bidi': DEFAULT_NAMESPACE,
	    'unicode-range': DEFAULT_NAMESPACE,
	    'units-per-em': DEFAULT_NAMESPACE,
	    'v-alphabetic': DEFAULT_NAMESPACE,
	    'v-hanging': DEFAULT_NAMESPACE,
	    'v-ideographic': DEFAULT_NAMESPACE,
	    'v-mathematical': DEFAULT_NAMESPACE,
	    'values': DEFAULT_NAMESPACE,
	    'version': DEFAULT_NAMESPACE,
	    'vert-adv-y': DEFAULT_NAMESPACE,
	    'vert-origin-x': DEFAULT_NAMESPACE,
	    'vert-origin-y': DEFAULT_NAMESPACE,
	    'viewBox': DEFAULT_NAMESPACE,
	    'viewTarget': DEFAULT_NAMESPACE,
	    'visibility': DEFAULT_NAMESPACE,
	    'width': DEFAULT_NAMESPACE,
	    'widths': DEFAULT_NAMESPACE,
	    'word-spacing': DEFAULT_NAMESPACE,
	    'writing-mode': DEFAULT_NAMESPACE,
	    'x': DEFAULT_NAMESPACE,
	    'x-height': DEFAULT_NAMESPACE,
	    'x1': DEFAULT_NAMESPACE,
	    'x2': DEFAULT_NAMESPACE,
	    'xChannelSelector': DEFAULT_NAMESPACE,
	    'xlink:actuate': XLINK_NAMESPACE,
	    'xlink:arcrole': XLINK_NAMESPACE,
	    'xlink:href': XLINK_NAMESPACE,
	    'xlink:role': XLINK_NAMESPACE,
	    'xlink:show': XLINK_NAMESPACE,
	    'xlink:title': XLINK_NAMESPACE,
	    'xlink:type': XLINK_NAMESPACE,
	    'xml:base': XML_NAMESPACE,
	    'xml:id': XML_NAMESPACE,
	    'xml:lang': XML_NAMESPACE,
	    'xml:space': XML_NAMESPACE,
	    'y': DEFAULT_NAMESPACE,
	    'y1': DEFAULT_NAMESPACE,
	    'y2': DEFAULT_NAMESPACE,
	    'yChannelSelector': DEFAULT_NAMESPACE,
	    'z': DEFAULT_NAMESPACE,
	    'zoomAndPan': DEFAULT_NAMESPACE
	};
	
	module.exports = SVGAttributeNamespace;
	
	function SVGAttributeNamespace(value) {
	  if (SVG_PROPERTIES.hasOwnProperty(value)) {
	    return SVG_PROPERTIES[value];
	  }
	}


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArray = __webpack_require__(27);
	
	var h = __webpack_require__(22);
	
	
	var SVGAttributeNamespace = __webpack_require__(191);
	var attributeHook = __webpack_require__(187);
	
	var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	
	module.exports = svg;
	
	function svg(tagName, properties, children) {
	    if (!children && isChildren(properties)) {
	        children = properties;
	        properties = {};
	    }
	
	    properties = properties || {};
	
	    // set namespace for svg
	    properties.namespace = SVG_NAMESPACE;
	
	    var attributes = properties.attributes || (properties.attributes = {});
	
	    for (var key in properties) {
	        if (!properties.hasOwnProperty(key)) {
	            continue;
	        }
	
	        var namespace = SVGAttributeNamespace(key);
	
	        if (namespace === undefined) { // not a svg attribute
	            continue;
	        }
	
	        var value = properties[key];
	
	        if (typeof value !== 'string' &&
	            typeof value !== 'number' &&
	            typeof value !== 'boolean'
	        ) {
	            continue;
	        }
	
	        if (namespace !== null) { // namespaced attribute
	            properties[key] = attributeHook(namespace, value);
	            continue;
	        }
	
	        attributes[key] = value
	        properties[key] = undefined
	    }
	
	    return h(tagName, properties, children);
	}
	
	function isChildren(x) {
	    return typeof x === 'string' || isArray(x);
	}


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(47)
	var isHook = __webpack_require__(24)
	
	module.exports = diffProps
	
	function diffProps(a, b) {
	    var diff
	
	    for (var aKey in a) {
	        if (!(aKey in b)) {
	            diff = diff || {}
	            diff[aKey] = undefined
	        }
	
	        var aValue = a[aKey]
	        var bValue = b[aKey]
	
	        if (aValue === bValue) {
	            continue
	        } else if (isObject(aValue) && isObject(bValue)) {
	            if (getPrototype(bValue) !== getPrototype(aValue)) {
	                diff = diff || {}
	                diff[aKey] = bValue
	            } else if (isHook(bValue)) {
	                 diff = diff || {}
	                 diff[aKey] = bValue
	            } else {
	                var objectDiff = diffProps(aValue, bValue)
	                if (objectDiff) {
	                    diff = diff || {}
	                    diff[aKey] = objectDiff
	                }
	            }
	        } else {
	            diff = diff || {}
	            diff[aKey] = bValue
	        }
	    }
	
	    for (var bKey in b) {
	        if (!(bKey in a)) {
	            diff = diff || {}
	            diff[bKey] = b[bKey]
	        }
	    }
	
	    return diff
	}
	
	function getPrototype(value) {
	  if (Object.getPrototypeOf) {
	    return Object.getPrototypeOf(value)
	  } else if (value.__proto__) {
	    return value.__proto__
	  } else if (value.constructor) {
	    return value.constructor.prototype
	  }
	}


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var DataSet = __webpack_require__(41)
	
	module.exports = DataSetHook;
	
	function DataSetHook(value) {
	    if (!(this instanceof DataSetHook)) {
	        return new DataSetHook(value);
	    }
	
	    this.value = value;
	}
	
	DataSetHook.prototype.hook = function (node, propertyName) {
	    var ds = DataSet(node)
	    var propName = propertyName.substr(5)
	
	    ds[propName] = this.value;
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var DataSet = __webpack_require__(41)
	
	module.exports = DataSetHook;
	
	function DataSetHook(value) {
	    if (!(this instanceof DataSetHook)) {
	        return new DataSetHook(value);
	    }
	
	    this.value = value;
	}
	
	DataSetHook.prototype.hook = function (node, propertyName) {
	    var ds = DataSet(node)
	    var propName = propertyName.substr(3)
	
	    ds[propName] = this.value;
	};
	
	DataSetHook.prototype.unhook = function(node, propertyName) {
	    var ds = DataSet(node);
	    var propName = propertyName.substr(3);
	
	    ds[propName] = undefined;
	}


/***/ },
/* 196 */
/***/ function(module, exports) {

	module.exports = SoftSetHook;
	
	function SoftSetHook(value) {
	    if (!(this instanceof SoftSetHook)) {
	        return new SoftSetHook(value);
	    }
	
	    this.value = value;
	}
	
	SoftSetHook.prototype.hook = function (node, propertyName) {
	    if (node[propertyName] !== this.value) {
	        node[propertyName] = this.value;
	    }
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var TypedError = __webpack_require__(43)
	
	var VNode = __webpack_require__(200)
	var VText = __webpack_require__(201)
	var isVNode = __webpack_require__(69)
	var isVText = __webpack_require__(199)
	var isWidget = __webpack_require__(70)
	var isHook = __webpack_require__(68)
	var isVThunk = __webpack_require__(198)
	
	var parseTag = __webpack_require__(202)
	var softSetHook = __webpack_require__(196)
	var dataSetHook = __webpack_require__(194)
	var evHook = __webpack_require__(195)
	
	var UnexpectedVirtualElement = TypedError({
	    type: "virtual-hyperscript.unexpected.virtual-element",
	    message: "Unexpected virtual child passed to h().\n" +
	        "Expected a VNode / Vthunk / VWidget / string but:\n" +
	        "got a {foreignObjectStr}.\n" +
	        "The parent vnode is {parentVnodeStr}.\n" +
	        "Suggested fix: change your `h(..., [ ... ])` callsite.",
	    foreignObjectStr: null,
	    parentVnodeStr: null,
	    foreignObject: null,
	    parentVnode: null
	})
	
	module.exports = h
	
	function h(tagName, properties, children) {
	    var childNodes = []
	    var tag, props, key, namespace
	
	    if (!children && isChildren(properties)) {
	        children = properties
	        props = {}
	    }
	
	    props = props || properties || {}
	    tag = parseTag(tagName, props)
	
	    // support keys
	    if ("key" in props) {
	        key = props.key
	        props.key = undefined
	    }
	
	    // support namespace
	    if ("namespace" in props) {
	        namespace = props.namespace
	        props.namespace = undefined
	    }
	
	    // fix cursor bug
	    if (tag === "input" &&
	        "value" in props &&
	        props.value !== undefined &&
	        !isHook(props.value)
	    ) {
	        props.value = softSetHook(props.value)
	    }
	
	    var keys = Object.keys(props)
	    var propName, value
	    for (var j = 0; j < keys.length; j++) {
	        propName = keys[j]
	        value = props[propName]
	        if (isHook(value)) {
	            continue
	        }
	
	        // add data-foo support
	        if (propName.substr(0, 5) === "data-") {
	            props[propName] = dataSetHook(value)
	        }
	
	        // add ev-foo support
	        if (propName.substr(0, 3) === "ev-") {
	            props[propName] = evHook(value)
	        }
	    }
	
	    if (children !== undefined && children !== null) {
	        addChild(children, childNodes, tag, props)
	    }
	
	
	    var node = new VNode(tag, props, childNodes, key, namespace)
	
	    return node
	}
	
	function addChild(c, childNodes, tag, props) {
	    if (typeof c === "string") {
	        childNodes.push(new VText(c))
	    } else if (isChild(c)) {
	        childNodes.push(c)
	    } else if (Array.isArray(c)) {
	        for (var i = 0; i < c.length; i++) {
	            addChild(c[i], childNodes, tag, props)
	        }
	    } else if (c === null || c === undefined) {
	        return
	    } else {
	        throw UnexpectedVirtualElement({
	            foreignObjectStr: JSON.stringify(c),
	            foreignObject: c,
	            parentVnodeStr: JSON.stringify({
	                tagName: tag,
	                properties: props
	            }),
	            parentVnode: {
	                tagName: tag,
	                properties: props
	            }
	        })
	    }
	}
	
	function isChild(x) {
	    return isVNode(x) || isVText(x) || isWidget(x) || isVThunk(x)
	}
	
	function isChildren(x) {
	    return typeof x === "string" || Array.isArray(x) || isChild(x)
	}


/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = isThunk
	
	function isThunk(t) {
	    return t && t.type === "Thunk"
	}


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(26)
	
	module.exports = isVirtualText
	
	function isVirtualText(x) {
	    return x && x.type === "VirtualText" && x.version === version
	}


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(26)
	var isVNode = __webpack_require__(69)
	var isWidget = __webpack_require__(70)
	var isVHook = __webpack_require__(68)
	
	module.exports = VirtualNode
	
	var noProperties = {}
	var noChildren = []
	
	function VirtualNode(tagName, properties, children, key, namespace) {
	    this.tagName = tagName
	    this.properties = properties || noProperties
	    this.children = children || noChildren
	    this.key = key != null ? String(key) : undefined
	    this.namespace = (typeof namespace === "string") ? namespace : null
	
	    var count = (children && children.length) || 0
	    var descendants = 0
	    var hasWidgets = false
	
	    for (var i = 0; i < count; i++) {
	        var child = children[i]
	        if (isVNode(child)) {
	            descendants += child.count || 0
	
	            if (!hasWidgets && child.hasWidgets) {
	                hasWidgets = true
	            }
	        } else if (!hasWidgets && isWidget(child)) {
	            if (typeof child.destroy === "function") {
	                hasWidgets = true
	            }
	        }
	    }
	
	    this.count = count + descendants
	    this.hasWidgets = hasWidgets
	}
	
	VirtualNode.prototype.version = version
	VirtualNode.prototype.type = "VirtualNode"


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(26)
	
	module.exports = VirtualText
	
	function VirtualText(text) {
	    this.text = String(text)
	}
	
	VirtualText.prototype.version = version
	VirtualText.prototype.type = "VirtualText"


/***/ },
/* 202 */
/***/ function(module, exports) {

	var classIdSplit = /([\.#]?[a-zA-Z0-9_:-]+)/
	var notClassId = /^\.|#/
	
	module.exports = parseTag
	
	function parseTag(tag, props) {
	    if (!tag) {
	        return "div"
	    }
	
	    var noId = !("id" in props)
	
	    var tagParts = tag.split(classIdSplit)
	    var tagName = null
	
	    if (notClassId.test(tagParts[1])) {
	        tagName = "div"
	    }
	
	    var classes, part, type, i
	    for (i = 0; i < tagParts.length; i++) {
	        part = tagParts[i]
	
	        if (!part) {
	            continue
	        }
	
	        type = part.charAt(0)
	
	        if (!tagName) {
	            tagName = part
	        } else if (type === ".") {
	            classes = classes || []
	            classes.push(part.substring(1, part.length))
	        } else if (type === "#" && noId) {
	            props.id = part.substring(1, part.length)
	        }
	    }
	
	    if (classes) {
	        if (props.className) {
	            classes.push(props.className)
	        }
	
	        props.className = classes.join(" ")
	    }
	
	    return tagName ? tagName.toLowerCase() : "div"
	}


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var hiddenStore = __webpack_require__(204);
	
	module.exports = createStore;
	
	function createStore() {
	    var key = {};
	
	    return function (obj) {
	        if ((typeof obj !== 'object' || obj === null) &&
	            typeof obj !== 'function'
	        ) {
	            throw new Error('Weakmap-shim: Key must be object')
	        }
	
	        var store = obj.valueOf(key);
	        return store && store.identity === key ?
	            store : hiddenStore(obj, key);
	    };
	}


/***/ },
/* 204 */
/***/ function(module, exports) {

	module.exports = hiddenStore;
	
	function hiddenStore(obj, key) {
	    var store = { identity: key };
	    var valueOf = obj.valueOf;
	
	    Object.defineProperty(obj, "valueOf", {
	        value: function (value) {
	            return value !== key ?
	                valueOf.apply(this, arguments) : store;
	        },
	        writable: true
	    });
	
	    return store;
	}


/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 206 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(160);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 209 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend(target) {
	    for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 211 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bundle.js